export type LanguageCode = 'id' | 'en' | 'zh';

export interface LanguageMeta {
  code: LanguageCode;
  label: string;
  flag: string;
}

export const LANGUAGES: LanguageMeta[] = [
  { code: 'id', label: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
];

type TranslationDict = Record<string, string>;

const id: TranslationDict = {
  // ---- Pembaruan aplikasi ----
  'appUpdate.title': 'Versi baru tersedia',
  'appUpdate.message': 'Lumen telah diperbarui. Muat ulang halaman untuk menggunakan versi terbaru.',
  'appUpdate.reload': 'Muat Ulang Sekarang',

  // ---- Pengaturan (personal + perusahaan) ----
  'settings.title': 'Pengaturan',
  'settings.subtitle': 'Sesuaikan pengalaman Lumen sesuai kebutuhan kerja Anda.',
  'settings.sectionPersonal': 'Preferensi Saya',
  'settings.sectionCompany': 'Pengaturan Perusahaan',
  'settings.docDetection': 'Deteksi Tipe Dokumen Otomatis',
  'settings.docDetectionDesc':
    'Sistem membaca setiap dokumen yang diunggah dan mengisi tipenya untuk Anda. Matikan jika Anda lebih suka memilih tipe dokumen sendiri.',
  'settings.docDetectionNote':
    'Berlaku pada langkah unggah dokumen PIB. Tebakan dari nama berkas tetap berjalan meski deteksi dimatikan.',
  'settings.docDetectionLockedNote':
    'Pengaturan ini dikunci oleh admin perusahaan Anda. Hubungi admin jika Anda memerlukan perubahan.',
  'settings.lockedByCompany': 'Dikunci perusahaan',
  'settings.professionalMode': 'Profesional Mode',
  'settings.professionalModeDesc':
    'Aktifkan untuk menyembunyikan Stamp Duty, Mini Games, dan Trivia Game pada alur pemrosesan.',
  'settings.professionalModeNote':
    'Perubahan mode akan memuat ulang halaman agar antarmuka mengikuti preferensi terbaru Anda.',
  'settings.companyDocDetection': 'Default deteksi untuk seluruh perusahaan',
  'settings.companyDocDetectionDesc': 'Posisi awal deteksi otomatis bagi anggota yang belum pernah mengatur sendiri.',
  'settings.companyLock': 'Kunci pilihan ini',
  'settings.companyLockDesc':
    'Anggota tidak dapat mengubah deteksi otomatis selama dikunci. Pilihan mereka tersimpan dan kembali berlaku setelah kunci dibuka.',
  'settings.companyNote': 'Hanya admin perusahaan yang melihat bagian ini.',
  'settings.saveFailed': 'Gagal menyimpan',
  'settings.saveFailedMsg': 'Pengaturan perusahaan belum tersimpan. Silakan coba lagi.',
  // Language switcher
  'language.switcher': 'Bahasa',
  'language.indonesia': 'Bahasa Indonesia',
  'language.english': 'English',
  'language.chinese': '中文',

  // Sidebar menus
  'menu.mgmtDashboard': 'Dashboard Manajemen',
  'menu.manifest': 'Manifest',
  'menu.dashboard': 'Dasbor',
  'menu.buatAju': 'Buat Aju',
  'menu.draft': 'Draft',
  'menu.docManifes': 'Dok Manifes',
  'menu.theGuardian': 'The Guardian',
  'menu.radar': 'Radar',
  'menu.kepabeanan': 'Kepabeanan',
  'menu.docPabean': 'Dok Pabean',
  'menu.monitoringBlokir': 'Monitoring Blokir',
  'menu.respon': 'Respon',
  'menu.databaseBarang': 'Database Barang',
  'menu.ppftz': 'PPFTZ',
  'menu.kuotaImporEkspor': 'Kuota Impor / Ekspor',
  'menu.shipmentQuota': 'Kuota Pengiriman',
  'menu.hargaReferensi': 'Harga Referensi',
  'menu.cukai': 'Cukai',
  'menu.tutorial': 'Tutorial',
  'menu.suratJalan': 'Surat Jalan',
  'menu.dokumenCk': 'Dokumen CK',
  'menu.billOfMaterial': 'Bill of Material',
  'menu.inventori': 'Inventori',
  'menu.riskSelfCheck': 'Pemeriksaan Mandiri Risiko',
  'menu.customerApproval': 'Persetujuan Pelanggan',
  'menu.approvalRequests': 'Permintaan Persetujuan',
  'menu.emailGroups': 'Grup Email',
  'menu.reviewers': 'Peninjau',
  'menu.rolesPermissions': 'Role & Permission',
  'menu.creditTopup': 'Topup Kredit',
  'menu.langganan': 'Langganan',
  'menu.berita': 'Berita',
  'menu.antaraNews': 'Antara News',
  'menu.cnnIndonesia': 'CNN Indonesia',
  'menu.cnbcIndonesia': 'CNBC Indonesia',
  'menu.republikaNews': 'Republika News',
  'menu.kumparanNews': 'Kumparan News',
  'menu.voaNews': 'VOA News',
  'menu.layananLainnya': 'Layanan Lainnya',
  'menu.stampDuty': 'Stamp',
  'menu.miniGames': 'Mini Games',
  'menu.fileCompress': 'Kompres File',
  'menu.splitPdf': 'Pisah PDF',
  'menu.pengaturan': 'Pengaturan',
  'menu.master': 'Master',
  'menu.ceisaUser': 'Pengguna Ceisa',
  'menu.user': 'Pengguna',
  'menu.seaCarriers': 'Perusahaan Pelayaran',
  'menu.email': 'Email',
  'menu.customerEmailForwarding': 'Penerusan Email Pelanggan',
  'menu.statement': 'Pernyataan',
  'menu.manifestReminder': 'Pengingat Manifest',
  'menu.revokeAccess': 'Cabut Akses',
  'menu.exportBank': 'Export Bank',
  'menu.riwayatPembaruan': 'Riwayat Pembaruan',

  // Sidebar badges
  'badge.new': 'Baru',
  'badge.bod': 'BOD',
  'badge.mulai': 'Mulai',
  'badge.aiReady': 'AI Siap',

  // Sidebar footer / search
  'sidebar.manageAccount': 'Kelola akun',
  'sidebar.impersonate': 'Jadikan Pengguna',
  'sidebar.impersonating': 'Meniru Pengguna',
  'sidebar.changeTheme': 'Ganti Tema',
  'sidebar.theme': 'Tema',
  'theme.apex': 'APEX',
  'theme.apexNight': 'APEX Night',
  'theme.horizon': 'Horizon',
  'theme.horizonNight': 'Horizon Night',
  'theme.horizonDawn': 'Horizon Dawn',
  'theme.horizonDusk': 'Horizon Dusk',
  'theme.horizonMist': 'Horizon Mist',
  'sidebar.logout': 'Keluar',
  'sidebar.loggingOut': 'Keluar...',
  'sidebar.collapse': 'Ciutkan sidebar',
  'sidebar.expand': 'Perluas sidebar',
  'sidebar.quickSearch': 'Cari cepat...',
  'sidebar.noMatches': 'Tidak ada hasil',

  // Login
  'auth.welcome': 'Selamat datang! Masuk untuk mengakses akun Anda',
  'auth.email': 'Alamat email',
  'auth.emailPlaceholder': 'contoh@mail.com',
  'auth.password': 'Kata sandi',
  'auth.passwordPlaceholder': 'Kata sandi Anda',
  'auth.signIn': 'Masuk',
  'auth.or': 'atau',
  'auth.cubeLogin': 'Masuk dengan Akun CUBEforall',
  'auth.reviewerLogin': 'Masuk sebagai Reviewer',
  'auth.cubeErrorTitle': 'Login CUBEforall gagal',

  // Login showcase (right panel of the login page)
  'auth.showcase.headline': 'Dokumen pabean selesai dalam hitungan menit, bukan jam.',
  'auth.showcase.ariaLabel': 'Fitur Lumen',
  'auth.showcase.play': 'Putar',
  'auth.showcase.pause': 'Jeda',
  'auth.showcase.segBrand': 'Intro',
  'auth.showcase.segExtract': 'Ekstraksi AI',
  'auth.showcase.segHs': 'HS & Lartas',
  'auth.showcase.segCeisa': 'CEISA',
  'auth.showcase.segRadar': 'Radar',
  'auth.showcase.segUpload': 'Upload',
  'auth.showcase.extractTitle': 'Ekstraksi AI',
  'auth.showcase.extractDesc': 'Invoice dan packing list dibaca, setiap nilai diberi skor keyakinan.',
  'auth.showcase.tabBarang': 'Barang',
  'auth.showcase.itemsDetected': '{n} item terdeteksi',
  'auth.showcase.reading': 'Membaca dokumen',
  'auth.showcase.draftReady': 'Draft PIB siap ditinjau',
  'auth.showcase.verified': 'Verified',
  'auth.showcase.sampleData': 'Data contoh',
  'auth.showcase.tipVerified': 'Verified',
  'auth.showcase.tipCheck': 'Check',
  'auth.showcase.tipAutoVerified': 'Terverifikasi otomatis dari sumber',
  'auth.showcase.tipClickReview': 'Klik untuk meninjau terhadap sumber',
  'auth.showcase.tipHsConfidence': 'Keyakinan ekstraksi HS code',
  'auth.showcase.hsTitle': 'Validasi HS code dan Lartas',
  'auth.showcase.hsDesc': 'HS code dicek ke INSW, status Lartas dan tarif dihitung otomatis.',
  'auth.showcase.hsCode': 'Kode',
  'auth.showcase.hsNormalized': 'Kode normalisasi',
  'auth.showcase.hsUraian': 'Uraian (ID)',
  'auth.showcase.hsInswYear': 'Tahun INSW',
  'auth.showcase.no': 'Tidak',
  'auth.showcase.tipNoLartas': 'Tidak memerlukan izin Lartas',
  'auth.showcase.tipBm': 'Bea Masuk, tarif MFN',
  'auth.showcase.tipPpn': 'Pajak Pertambahan Nilai',
  'auth.showcase.tipPph': 'PPh Pasal 22 impor, dengan API',
  'auth.showcase.tipPostel': 'Perlu sertifikat Postel',
  'auth.showcase.ceisaTitle': 'Submit ke CEISA 4.0',
  'auth.showcase.ceisaDesc': 'Satu klik kirim, riwayat status mengalir kembali ke Lumen.',
  'auth.showcase.sent': 'Terkirim',
  'auth.showcase.tipDraft': 'Draft tersimpan di Lumen',
  'auth.showcase.tipSubmitted': 'Dikirim ke CEISA 4.0',
  'auth.showcase.tipUmum': 'Diterima, penjaluran berjalan',
  'auth.showcase.tipSppb': 'Surat Persetujuan Pengeluaran Barang',
  'auth.showcase.radarTitle': 'Radar manifest',
  'auth.showcase.radarDesc': 'Manifest masuk dan keluar dipantau sebelum kapal tiba.',
  'auth.showcase.vessel': 'Kapal',
  'auth.showcase.remaining': 'Sisa',
  'auth.showcase.uploadTitle': 'Upload hingga 50 dokumen',
  'auth.showcase.uploadDesc': 'Jenis dokumen dikenali otomatis dan dikelompokkan.',
  'auth.showcase.dropHint': 'Tarik dan lepas dokumen',
  'auth.showcase.typesDetected': '{n} jenis dokumen terdeteksi',

  // Doc Pabean page
  'docpabean.errorLoad': 'Gagal memuat data Dokumen Pabean.',
  'docpabean.retry': 'Coba lagi',
  'docpabean.allStatus': 'Semua Status',
  'docpabean.sortPlaceholder': 'Urutkan',
  'docpabean.filterStatus': 'Filter Status',
  'docpabean.filterBranch': 'Filter Cabang',
  'docpabean.branchMine': 'Cabang Saya',
  'docpabean.branchAll': 'Semua Cabang',
  'docpabean.sortNewest': 'Urutkan: Terbaru',
  'docpabean.sortAjuAsc': 'Nomor Aju (A-Z)',
  'docpabean.sortAjuDesc': 'Nomor Aju (Z-A)',
  'docpabean.sortShipperAsc': 'Nama Shipper (A-Z)',
  'docpabean.sortShipperDesc': 'Nama Shipper (Z-A)',
  'docpabean.sortDateOldest': 'Tanggal Daftar (Terlama)',
  'docpabean.sortDateNewest': 'Tanggal Daftar (Terbaru)',
  'docpabean.sortItemLeast': 'Total Item (Tersedikit)',
  'docpabean.sortItemMost': 'Total Item (Terbanyak)',
  'docpabean.downloadUsage': 'Unduh Laporan Penggunaan',
  'docpabean.downloadReport': 'Unduh Laporan',
  'docpabean.startDate': 'Tanggal Mulai',
  'docpabean.endDate': 'Tanggal Akhir',
  'docpabean.selectStartDate': 'Pilih tanggal mulai',
  'docpabean.selectEndDate': 'Pilih tanggal akhir',
  'docpabean.docType': 'Jenis Dokumen',
  'docpabean.all': 'Semua',
  'docpabean.cancel': 'Batal',
  'docpabean.download': 'Unduh',
  'docpabean.errSelectDates': 'Pilih tanggal mulai dan tanggal akhir',
  'docpabean.successDownloaded': 'Laporan penggunaan berhasil diunduh',
  'docpabean.errDownload': 'Gagal mengunduh laporan penggunaan',
  'docpabean.errorTitle': 'Error',

  // Doc Pabean credits banner
  'docpabean.remainingCredits': 'Sisa kredit',
  'docpabean.errLoadBalance': 'Gagal memuat saldo',
  'docpabean.viewSubscription': 'Lihat langganan',

  // Doc Pabean download modal
  'docpabean.downloadModalTitle': 'Unduh Laporan',
  'docpabean.loadingOptions': 'Memuat opsi...',
  'docpabean.filterHint':
    'Filter riwayat ekspor berdasarkan nama perusahaan dan/atau rentang tanggal. Nama drafter bersifat opsional.',
  'docpabean.drafterName': 'Nama Drafter (opsional)',
  'docpabean.drafterPlaceholder': 'Cari dan pilih drafter...',
  'docpabean.noDrafters': 'Tidak ada drafter ditemukan',
  'docpabean.companyName': 'Nama Perusahaan',
  'docpabean.companyPlaceholder': 'Cari dan pilih perusahaan...',
  'docpabean.noCompanies': 'Tidak ada perusahaan ditemukan',
  'docpabean.errSelectCompanyDates': 'Pilih perusahaan dan/atau rentang tanggal (nama drafter opsional)',
  'docpabean.errDateRequiredCompany': 'Tanggal mulai dan akhir wajib diisi untuk {company} (DD-MM-YYYY)',
  'docpabean.errEndBeforeStart': 'Tanggal akhir harus sama atau setelah tanggal mulai',
  'docpabean.successReportDownloaded': 'Laporan berhasil diunduh',
  'docpabean.errReportDownload': 'Gagal mengunduh laporan',

  // Doc Pabean table
  'docpabean.colNomorAju': 'Nomor Aju',
  'docpabean.colShipper': 'Nama Shipper',
  'docpabean.colBuyer': 'Nama Buyer',
  'docpabean.colDate': 'Tanggal Daftar',
  'docpabean.colRespon': 'Respon',
  'docpabean.colStatus': 'Status',
  'docpabean.colType': 'Type',
  'docpabean.colJenisKategori': 'Jenis | Kategori Ekspor',
  'docpabean.colDrafter': 'Drafter',
  'docpabean.colTotalItem': 'Total Item',
  'docpabean.colApproval': 'Approval',
  'docpabean.colActions': 'Actions',
  'docpabean.filterShipmentType': 'Jenis Pengiriman',
  'docpabean.filterNamaPerusahaan': 'Nama Perusahaan',
  'docpabean.filterDrafter': 'Nama Drafter',
  'docpabean.filterMotType': 'Tipe MOT',
  'docpabean.motSea': 'Angkutan laut',
  'docpabean.motAir': 'Angkutan udara',
  'docpabean.filterCountry': 'Negara Shipper/Konsinyi',
  'docpabean.statusHistory': 'Riwayat Status',
  'docpabean.latest': 'Terbaru',
  'docpabean.respon': 'Respon',
  'docpabean.tooltipVerified': 'Lengkap: Invoice + BL/AWB',
  'docpabean.tooltipView': 'Lihat',
  'docpabean.tooltipViewEdit': 'Lihat / Edit',
  'docpabean.tooltipEdit': 'Edit',
  'docpabean.tooltipCopy': 'Salin',
  'docpabean.tooltipUpload': 'Unggah Berkas',
  'docpabean.tooltipSyncRespon': 'Sinkron Respon',
  'docpabean.tooltipDelete': 'Hapus',
  'docpabean.tooltipPreviewPdf': 'Pratinjau PDF',
  'docpabean.tooltipPreviewPdfNoAju': 'Nomor AJU belum tersedia',
  'docpabean.pdfPreview.title': 'Pratinjau {doc}',
  'docpabean.pdfPreview.kindFinal': 'Final (NOPEN)',
  'docpabean.pdfPreview.kindDraft': 'Draft CEISA',
  'docpabean.pdfPreview.fallbackTitle': 'Dokumen final belum bisa diambil',
  'docpabean.pdfPreview.fallbackBody':
    'Dokumen ini sudah mendapat NPE/SPPB, tetapi formulir final gagal diambil dari CEISA. Yang ditampilkan adalah draft CEISA.',
  'docpabean.pdfPreview.loading': 'Mengambil dokumen dari CEISA…',
  'docpabean.pdfPreview.loadingHint':
    'Jika dokumen belum pernah dibuat, CEISA perlu waktu untuk menyiapkannya — bisa sampai sekitar satu menit saat CEISA sedang lambat.',
  'docpabean.pdfPreview.docGeneric': 'Dokumen',
  'docpabean.pdfPreview.refreshDraft': 'Perbarui Draft',
  'docpabean.pdfPreview.download': 'Unduh',
  'docpabean.pdfPreview.openNewTab': 'Buka di Tab Baru',
  'docpabean.pdfPreview.errorTitle': 'Dokumen tidak dapat ditampilkan',
  'docpabean.pdfPreview.errorGeneric': 'Gagal mengambil dokumen. Silakan coba lagi.',
  'docpabean.pdfPreview.errorBilling': 'Langganan belum dibayar / kredit tidak cukup — preview tidak dapat dibuka.',
  'docpabean.pdfPreview.retry': 'Coba Lagi',
  'docpabean.deleteConfirm':
    'Hapus dokumen {nomor} dari daftar? Dokumen yang sudah terkirim ke CEISA tidak terpengaruh.',
  'docpabean.deleteCancel': 'Batal',
  'docpabean.deleteFiledWarning':
    'Dokumen ini sudah terdaftar di CEISA. Menghapus hanya menyembunyikannya dari Lumen — dokumen tetap ada di CEISA.',
  'docpabean.showDeleted': 'Tampilkan yang dihapus',
  'docpabean.deletedBadge': 'Dihapus',
  'docpabean.tooltipRestore': 'Pulihkan',
  'docpabean.restoreConfirm': 'Pulihkan dokumen {nomor} ke daftar?',
  'docpabean.restore': 'Pulihkan',
  'docpabean.delete': 'Hapus',
  'docpabean.loadingData': 'Memuat data...',
  'docpabean.emptyFilter': 'Tidak ada dokumen untuk filter saat ini.',
  'docpabean.page': 'Hal',
  'docpabean.company': 'Perusahaan',
  'docpabean.proses': 'Proses',
  'docpabean.totalItemLabel': 'Total Item',
  'docpabean.country': 'Negara',
  'docpabean.export': 'Ekspor',
  'docpabean.import': 'Impor',
  'docpabean.justNow': 'baru saja',
  'docpabean.ago': 'yang lalu',
  'docpabean.approved': 'Disetujui',
  'docpabean.waiting': 'Menunggu',
  'docpabean.needRevision': 'Perlu Revisi',
  'docpabean.rejected': 'Ditolak',
  'docpabean.cancelled': 'Dibatalkan',
  'docpabean.scheduled': 'Dijadwalkan',
  // Submit gate: Incoterm FOB/FCA declared with Freight 0 (issue #234)
  'docpabean.freightZero.title': 'Freight 0 — Periksa Komponen Biaya',
  'docpabean.freightZero.body':
    'Incoterm {incoterm} mengharuskan Freight diisi sebagai komponen biaya terpisah, karena biaya angkut tidak termasuk dalam harga invoice. Freight saat ini masih 0, sehingga nilai pabean yang dilaporkan bisa salah.',
  'docpabean.freightZero.hint':
    'Isi Biaya Transportasi (Freight) pada Informasi Komponen Biaya, lalu simpan. Setelah Freight lebih besar dari 0, dokumen dapat dikirim ke CEISA.',
  'docpabean.freightZero.cta': 'Buka Komponen Biaya',
  'docpabean.freightZero.cancel': 'Batal',
  // Upload freight screenshot → extract value + currency (issue #235)
  'docpabean.freightUpload.dropTitle': 'Unggah screenshot atau PDF freight',
  'docpabean.freightUpload.dropHint':
    'Tarik dan lepas gambar atau PDF dari email atau WhatsApp ke sini, klik untuk memilih file, atau tempel dengan {paste}',
  'docpabean.freightUpload.ofUploaded': 'Dokumen Ocean Freight (OF) sudah diunggah',
  'docpabean.freightUpload.ofUploadedFiles': 'Nilai freight sudah dibaca dari {files} saat PIB dibuat.',
  'docpabean.freightUpload.ofUploadedHint': 'Nilai freight sudah dibaca dari dokumen tersebut saat PIB dibuat.',
  'docpabean.freightUpload.ofUploadedOverride':
    'Unggah screenshot atau PDF di bawah ini hanya jika nilai freight perlu diganti.',
  'docpabean.freightUpload.reading': 'Membaca file...',
  'docpabean.freightUpload.readingHint': 'Biasanya hanya perlu beberapa detik',
  'docpabean.freightUpload.detected': 'Freight terdeteksi: {currency} {amount}',
  'docpabean.freightUpload.detectedSub': 'Dibaca otomatis dari file ({pct}% yakin, {method})',
  'docpabean.freightUpload.detectedSubNoPct': 'Dibaca otomatis dari file ({method})',
  'docpabean.freightUpload.mismatchInline':
    'Freight terdeteksi: {currency} {amount}, berbeda dari mata uang transaksi ({txn})',
  'docpabean.freightUpload.use': 'Gunakan nilai ini',
  'docpabean.freightUpload.useAs': 'Gunakan sebagai {currency}',
  'docpabean.freightUpload.review': 'Tinjau konversi',
  'docpabean.freightUpload.retry': 'Coba lagi',
  'docpabean.freightUpload.dismiss': 'Tutup',
  'docpabean.freightUpload.lowConfidence': 'Keyakinan rendah ({pct}%). Periksa nilai ini sebelum digunakan.',
  'docpabean.freightUpload.notFound': 'Freight tidak terbaca dari file ini',
  'docpabean.freightUpload.notFoundHint':
    'Coba file lain yang memuat nilai freight, atau isi manual pada Informasi Komponen Biaya.',
  'docpabean.freightUpload.currencyUnknown':
    'Nilai {amount} terbaca, tetapi mata uangnya tidak dapat dipastikan dari gambar.',
  'docpabean.freightUpload.invalidType': 'File harus berupa gambar (JPEG/PNG/WebP) atau PDF.',
  'docpabean.freightUpload.tooLarge': 'Ukuran file maksimal 10 MB.',
  'docpabean.freightUpload.failed': 'Gagal membaca file: {message}',
  'docpabean.freightUpload.applyFailed': 'Gagal menyimpan freight: {message}',
  'docpabean.freightUpload.applied': 'Freight {currency} {amount} tersimpan ke Informasi Komponen Biaya',
  'docpabean.freightUpload.appliedInline': 'Freight {value} digunakan',
  'docpabean.freightUpload.appliedHintField': 'Tersimpan ke Informasi Komponen Biaya',
  'docpabean.freightUpload.appliedFrom.converted': 'Dari {currency} {amount}, dikonversi ke {txn} dengan kurs NDPBM',
  'docpabean.freightUpload.appliedFrom.original':
    'Angka {amount} dimasukkan apa adanya sebagai {txn} (terbaca sebagai {currency})',
  'docpabean.freightUpload.appliedFrom.assumed':
    'Angka {amount} dianggap sebagai {txn}; mata uang tidak terbaca dari file',
  'docpabean.freightUpload.appliedHintRow': 'Terisi di baris ini. Klik Simpan untuk menyimpan.',
  'docpabean.freightUpload.method.ocr': 'OCR',
  'docpabean.freightUpload.method.gemini': 'AI',
  'docpabean.freightUpload.method.pdf-text': 'teks PDF',
  'docpabean.freightUpload.method.pdf-ocr': 'OCR halaman PDF',
  'docpabean.freightUpload.mismatch.title': 'Mata uang freight berbeda',
  'docpabean.freightUpload.mismatch.body':
    'Freight terdeteksi dalam {detected} ({detected} {detectedAmount}). Transaksi ini berdenominasi {txn}. Kami akan mengonversi {detected} → {txn} menjadi ±{converted} {txn} menggunakan kurs NDPBM. Gunakan hasil konversi ini?',
  'docpabean.freightUpload.mismatch.bodyNoRate':
    'Freight terdeteksi dalam {detected} ({detected} {detectedAmount}), sedangkan transaksi ini berdenominasi {txn}.',
  'docpabean.freightUpload.mismatch.rate':
    'Kurs NDPBM {detected}: 1 {detected} = Rp {ndpbmSrc}\nKurs NDPBM {txn}: 1 {txn} = Rp {ndpbmTxn}\nHasil: 1 {detected} ≈ {rate} {txn}',
  'docpabean.freightUpload.mismatch.noRate':
    'Kurs NDPBM untuk konversi tidak tersedia saat ini, sehingga hasil konversi tidak dapat dihitung. Anda dapat memakai nilai asli atau mengisi manual.',
  'docpabean.freightUpload.mismatch.valutaHint':
    'Jika invoice memang dalam {detected}, ubah Valuta pada kartu Harga terlebih dahulu, lalu unggah ulang gambarnya.',
  'docpabean.freightUpload.mismatch.useConverted': 'Gunakan hasil konversi',
  'docpabean.freightUpload.mismatch.useOriginal': 'Masukkan {amount} sebagai {txn}',
  'docpabean.freightUpload.mismatch.cancel': 'Batal',

  // Status / Respon history modal
  'statushistory.title': 'Riwayat Status',
  'statushistory.loading': 'Memuat...',
  'statushistory.document': 'Dokumen',
  'statushistory.by': 'oleh',
  'statushistory.totalItems': 'Total Item',
  'statushistory.item': 'item',
  'statushistory.items': 'items',
  'statushistory.country': 'Negara',
  'statushistory.file': 'File',
  'statushistory.totalTime': 'Total Waktu',
  'statushistory.noData': 'Tidak ada data tersedia',
  'statushistory.viewResponHistory': 'Lihat Riwayat Respon',
  'statushistory.errFetch': 'Gagal memuat riwayat status',
  'statushistory.errGeneric': 'Kesalahan memuat riwayat status',

  // Buat Aju page
  'buataju.import': 'Import',
  'buataju.importDesc': 'Buat dokumen pabean untuk impor barang ke Indonesia.',
  'buataju.export': 'Export',
  'buataju.exportDesc': 'Buat dokumen pabean untuk ekspor barang dari Indonesia.',
  'buataju.bc33Desc':
    'Pemberitahuan Ekspor Barang Melalui atau Dari PLB — untuk ekspor melalui/dari Pusat Logistik Berikat.',
  'buataju.ppftzDesc': 'Buat dokumen FTZ (511) dari Invoice, Packing List, dan B/L dengan AI, atau isi manual.',
  'buataju.bc16Desc': 'Pemasukan barang impor ke Pusat Logistik Berikat (PLB).',
  'buataju.bc23Desc': 'Pemasukan barang impor ke TPB dari kawasan pabean atau TPS.',
  'buataju.bc25Desc': 'Pengeluaran barang impor dari TPB ke TLDDP untuk impor dipakai.',
  'buataju.bc261Desc': 'Pengeluaran sementara barang dari TPB ke TLDDP dengan jaminan.',
  'buataju.bc262Desc': 'Pemasukan kembali barang eks pengeluaran sementara ke TPB.',
  'buataju.bc27Desc': 'Pemindahan barang antar TPB, ke KEK, atau ke kawasan bebas.',
  'buataju.bc28Desc': 'Pengeluaran barang dari PLB untuk impor dipakai atau sementara.',
  'buataju.bc40Desc': 'Pemasukan barang asal TLDDP ke Tempat Penimbunan Berikat.',
  'buataju.bc41Desc': 'Pengeluaran barang asal TLDDP dari TPB kembali ke TLDDP.',
  'buataju.bcp3betDesc': 'Dokumen pemberitahuan untuk kegiatan pameran berikat (P3BET).',
  'buataju.popular': 'Populer',
  'buataju.limitedAccess': 'Akses Terbatas',
  'buataju.comingSoon': 'Segera Hadir',
  'buataju.new': 'Baru',
  'buataju.locked': 'Terkunci',
  'buataju.start': 'Mulai',
  'buataju.badge': 'Proses Dokumen Pabean dengan Mudah',
  'buataju.title': 'Pilih Jenis Dokumen',
  'buataju.subtitle':
    'Mulai perjalanan Anda dengan memilih jenis dokumen pabean yang sesuai dengan kebutuhan bisnis Anda.',
  'buataju.typesAvailable': 'jenis tersedia',
  'buataju.tpb': 'TPB',
  'buataju.tpbDesc': 'Tempat Penimbunan Berikat',
  'buataju.codeImport': 'Import',
  'buataju.codeExport': 'Export',
  'buataju.codeEkspor': 'Ekspor',
  'buataju.codePpftz': 'PPFTZ',
  'buataju.codeTpb': 'TPB',

  // Doc Pabean Upload page
  'upload.back': 'Kembali',
  'upload.title': 'Upload Dokumen',
  'upload.subtitle': 'Upload dan kelompokkan dokumen pabean Anda.',
  'upload.backToWizard': 'Kembali ke alur wizard 3 langkah',
  'upload.useWizard': 'Pakai Wizard',
  'upload.documents': 'Dokumen',
  'upload.processing': 'Memproses...',
  'upload.grouped': 'Telah dikelompokkan',
  'upload.readyToProcess': 'Siap diproses',
  'upload.successCount': '{n} berhasil',
  'upload.failedCount': '{n} gagal',
  'upload.reset': 'Reset',
  'upload.continueReview': 'Lanjut ke Review',
  'upload.uploadDocs': 'Upload {n} Dokumen',
  'upload.processDocs': 'Process Dokumen',
  'upload.uploading': 'Uploading... {p}%',
  'upload.groupingDocs': 'Mengelompokkan dokumen berdasarkan jenis...',
  'upload.resultsTitle': 'Hasil Upload Dokumen',
  'upload.total': 'Total',
  'upload.success': 'Berhasil',
  'upload.failed': 'Gagal',
  'upload.caution': 'Perhatian',
  'upload.cautionMsg':
    'Beberapa dokumen gagal diupload. Anda dapat mencoba kembali atau melanjutkan dengan dokumen yang berhasil.',
  'upload.successDocs': 'Dokumen Berhasil ({n})',
  'upload.failedDocs': 'Dokumen Gagal ({n})',
  'upload.docType': 'Jenis: {type}',
  'upload.noDocType': 'Tanpa jenis dokumen',
  'upload.errorLabel': 'Error: {msg}',
  'upload.reUpload': 'Upload Ulang',
  'upload.continue': 'Lanjutkan',
  'upload.errRequiredTransport': 'Wajib ada dokumen BL, AWB, MBL, atau MAWB',
  'upload.errCeisaCombine': 'Excel CEISA tidak bisa digabung',
  'upload.errCeisaCombineMsg': 'File Excel CEISA harus diupload sendiri, tidak boleh digabung dengan dokumen lain.',
  'upload.errNoFile': 'Tidak ada file',
  'upload.errNoFileMsg': 'Silakan tambahkan file terlebih dahulu',
  'upload.errNoType': 'Jenis dokumen belum dipilih',
  'upload.errNoTypeMsg': '{n} file belum memiliki jenis dokumen',
  'upload.errEmptyFile': 'ukuran 0 byte (file kosong)',
  'upload.errInvalidPdf': 'bukan PDF valid (header "{magic}", size {size} byte)',
  'upload.errInvalidFile': 'File tidak valid',
  'upload.successUploaded': 'Upload Berhasil',
  'upload.successUploadedMsg': 'Semua dokumen berhasil diupload.',
  'upload.doneUploading': 'Upload Selesai',
  'upload.partialMsg': '{success} dari {total} dokumen berhasil diupload.',
  'upload.errCeisaProcess':
    'Gagal memproses Excel CEISA: {msg}. File telah tersimpan, silakan lanjutkan di halaman draft.',
  'upload.errUpload': 'Terjadi kesalahan saat mengupload dokumen: {msg}',
  'upload.errUploadFile': 'Gagal mengupload file.',
  'upload.errNoBatch': 'Batch UUID tidak ditemukan. Silakan upload dokumen terlebih dahulu.',
  'upload.uploadGagal': 'Upload gagal: Server tidak mengembalikan data yang valid',
  'upload.ceisaFileNotFound': 'File EXCEL CEISA tidak ditemukan',
  'upload.emptyHeader': 'File yang akan diupload ({n})',
  'upload.searchPlaceholder': 'Cari file...',
  'upload.selectDocType': 'Pilih jenis dokumen',
  'upload.alreadySelected': 'sudah dipilih',
  'upload.noMatch': 'Tidak ada file cocok dengan "{q}"',
  'upload.noFiles': 'Belum ada file yang diupload',
  'upload.dragDrop': 'Drag & drop atau',
  'upload.clickBrowse': 'klik untuk browse',
  'upload.dropPdf': 'Drop file PDF disini',
  'upload.dropPdfExcel': 'Drop file PDF/Excel disini',
  'upload.dropPdfExcelImg': 'Drop file PDF/Excel/foto (JPG/PNG) disini',
  'upload.maxFiles': 'Maks. {n} file',
  'upload.enlarge': 'Perbesar',
  'upload.shrink': 'Perkecil',
  'upload.fmtNotMatch': 'Format tidak sesuai',
  'upload.fmtPdfOnly': 'Hanya file PDF yang diperbolehkan',
  'upload.fmtPdfExcel': 'Hanya file PDF dan Excel yang diperbolehkan',
  'upload.fmtPdfExcelImg': 'Hanya file PDF, Excel, dan foto (JPG/PNG) yang diperbolehkan',
  'upload.tooMany': 'Terlalu banyak file',
  'upload.tooManyMsg': 'Maksimal {n} file dapat diupload',
  'upload.cantSelect': 'Tidak dapat memilih',
  'upload.masterOnlyOne': 'Hanya 1 {name} yang diperbolehkan',
  'upload.fileCount': '{n} file',
  'upload.groupedHeader': 'Dokumen telah dikelompokkan',
  'upload.dragReorder': 'Drag untuk ubah urutan',
  'upload.splitTitle': 'Pisah PDF menjadi beberapa dokumen',
  'upload.splitHint': 'Pilih file PDF untuk menandai segmen, atau klik "Pisah otomatis" agar dibaca otomatis.',
  'upload.notPdf': 'File ini bukan PDF',
  'upload.pages': '{n} hal',
  'upload.activeSeg': 'Aktif: Seg {n}',
  'upload.pageOf': 'Halaman {cur} / {total}',
  'pdf.zoomIn': 'Perbesar (Ctrl + scroll)',
  'pdf.zoomOut': 'Perkecil (Ctrl + scroll)',
  'pdf.zoomReset': 'Reset zoom',
  'upload.smartSplit': 'Pisah otomatis',
  'upload.smartSplitHint': 'Pisah otomatis — baca isi PDF dan pisahkan per dokumen',
  'upload.smartSplitWorking': 'Membaca dokumen',
  'upload.smartSplitNeedsPages': 'Perlu minimal 2 halaman',
  'upload.smartSplitResult': '{n} dokumen ditemukan · {method}',
  'upload.smartSplitViaAi': 'dibaca AI',
  'upload.smartSplitViaText': 'dari teks PDF',
  'upload.smartSplitSingle': 'Hanya satu dokumen di file ini — tidak ada yang perlu dipisah.',
  'upload.smartSplitFailed': 'Deteksi gagal',
  'upload.smartSplitFailedMsg': 'Tidak dapat membaca dokumen. Tandai segmen secara manual.',
  'upload.smartSplitAll': 'Deteksi semua',
  'upload.smartSplitAllHint': 'Baca semua PDF sekaligus — jenis dokumen dan batas halaman',
  'upload.smartSplitAllProgress': 'Membaca {done}/{total}',
  'upload.aiDetectQueued': 'Menunggu',
  'upload.aiDetectFailed': 'Deteksi gagal — coba lagi',
  'upload.mismatchDetected': 'Isi file terbaca sebagai {type} ({pct}%), bukan {declared}',
  'upload.mismatchUse': 'Gunakan {type}',
  'upload.mismatchIgnore': 'Abaikan',
  'upload.siblingHint': 'Terbaca {type} — mungkin lebih tepat',
  'upload.bundleDetected': 'Berisi {n} dokumen ({types}) — pisahkan dulu',
  'upload.bundleOpen': 'Buka pemisah',
  'upload.issuesTitle': 'Periksa jenis dokumen',
  'upload.issuesIntro': 'Isi {n} file tidak sesuai dengan jenis yang dipilih. Lanjutkan apa adanya?',
  'upload.issuesDeclared': 'dipilih',
  'upload.issuesDetected': 'terbaca',
  'upload.issuesBundle': 'berisi {types} — belum dipisah',
  'upload.issuesContinue': 'Lanjutkan',
  'upload.issuesReview': 'Periksa lagi',
  'upload.waitDetection': 'Membaca dokumen {done}/{total} — tunggu sampai selesai',
  'upload.waitDetectionHint': 'Tombol aktif setelah semua dokumen selesai dibaca',
  'upload.needsType': 'pilih jenis',
  'upload.lowConfidence': 'perlu dicek · {pct}%',
  'upload.confidence': 'yakin {pct}%',
  'upload.loadingPreview': 'Memuat pratinjau...',
  'upload.previewFailed': 'Pratinjau tidak dapat ditampilkan',
  'upload.previewFailedMsg': 'File tetap dapat dipisah otomatis dan diunggah.',
  'upload.addSegment': 'Tambah Segment',
  'upload.segmentHint': 'Klik tombol di atas, lalu pilih halaman pada thumbnail.',
  'upload.selectPages': 'Pilih halaman pada thumbnail...',
  'upload.noPages': 'Belum ada halaman',
  'upload.pagesLabel': 'Hal: {pages}',
  'upload.docTypePlaceholder': 'Jenis dokumen',
  'upload.removeOriginal': 'Hapus file asli',
  'upload.extractSegments': 'Ekstrak {n} Segment',
  'upload.activateSegmentFirst': 'Klik segment di bawah untuk mengaktifkannya terlebih dahulu',
  'upload.pageFreed': 'Halaman {page} dilepas dari Segmen {seg}',
  'upload.pageFreedClickAgain':
    'Halaman {page} dilepas dari Segmen {seg}. Klik lagi untuk memindahkannya ke segmen aktif.',
  'upload.fileLimitReached': 'Batas file tercapai',
  'upload.fileLimitReachedMsg': 'Tidak dapat menambah segment: akan melebihi batas {n} file',
  'upload.segMinPages': 'Setiap segmen harus memiliki minimal 1 halaman',
  'upload.segNeedType': 'Semua segmen harus memiliki jenis dokumen',
  'upload.exceedLimit': 'Melebihi batas {n} file (saat ini {cur}, akan menambah {add})',
  'upload.validationFailed': 'Validasi gagal',
  'upload.extractSuccess': '{n} file dibuat dari "{name}"',
  'upload.extractFailed': 'Gagal memecah PDF',

  // Smart document detection
  'upload.detecting': 'Mendeteksi...',
  'upload.detected': 'Terdeteksi',
  'upload.detectedMulti': '{n} jenis dokumen terdeteksi',
  'upload.detectedSingle': 'Terdeteksi: {type}',
  'upload.detectFailed': 'Gagal mendeteksi',
  'upload.splitSuggestion': 'Pisahkan dokumen',
  'upload.unclassifiedPages': '{n} halaman tidak teridentifikasi',

  // Document type options (select/dropdown labels)
  'doctype.PL': '(PL) Packing List',
  'doctype.I': '(I) Invoice',
  'doctype.BL': '(BL) Bill of Lading',
  'doctype.MBL': '(MBL) Master Bill of Lading',
  'doctype.SI': '(SI) Shipping Instruction',
  'doctype.BR': '(BR) Booking Receipt',
  'doctype.COO': '(COO) Certificate of Origin',
  'doctype.ECOO': '(E-COO) Electronic Certificate of Origin',
  'doctype.AWB': '(AWB) Air Waybill',
  'doctype.MAWB': '(MAWB) Master Air Waybill',
  'doctype.LS': '(LS) Laporan Surveyor',
  'doctype.POSTEL': '(POSTEL) Postel',
  'doctype.PI': '(PI) Persetujuan Import',
  'doctype.AKL': '(AKL) Nomor Pendaftaran Alat Kesehatan/Depkes',
  'doctype.SKI': '(SKI) SURAT PERSETUJUAN MUAT BPOM',
  'doctype.SKB': '(SKBPPN) SKB PPN Impor',
  'doctype.SKBPPH': '(SKBPPH) SKB PPh Pasal 22 Impor',
  'doctype.SKBPP23': '(SKBPP23) SKB PPh Final PP 23',
  'doctype.SNI': '(SNI) SNI',
  'doctype.VLEGAL': '(VLEGAL) V-LEGAL',
  'doctype.CITES': '(CITES) CITES',
  'doctype.HC': '(HC) Health Certificate',
  'doctype.HALAL': '(HALAL) Sertifikat Halal',
  'doctype.SKEPTPB': '(SKEPTPB) SKEP-TPB',
  'doctype.PE': '(PE) Persetujuan Ekspor',
  'doctype.SKEM': '(SKEM) SKEM',
  'doctype.SNISPBDEPDAG': '(SNISPBDEPDAG) SNISPBDEPDAG',
  'doctype.PP': '(PP) Pengecualian Perijinan RB3 / Registrasi B3 / KLH',
  'doctype.EXC-JRE': '(CIPL - JRE) CIPL - JRE',
  'doctype.EXC-ARJUNA': '(CIPL - ARJUNA) CIPL - ARJUNA',
  'doctype.EXC-OBOR': '(CIPL - OBOR) CIPL - OBOR',
  'doctype.EXC-BENING': '(CIPL - BENING) CIPL - BENING',
  'doctype.EXC-NADA': '(CIPL - NADA) CIPL - NADA',
  'doctype.EXC-MINEBEA': '(CIPL - MINEBEA) CIPL - MINEBEA',
  'doctype.EXC-WIDE-SUCCESS': '(CIPL - WIDE SUCCESS) CIPL - WIDE SUCCESS',
  'doctype.EXC-NICESO': '(CIPL - NICESO) CIPL - NICESO',
  'doctype.EXC-CEISA': '(EXCEL CEISA) Excel CEISA',
  'doctype.SKEP': '(SKEP) SKEP',
  'doctype.980': '(980) Deklarasi Impor',
  'doctype.OF': '(OF) Ocean Freight / Biaya Angkut',

  // HeaderForm
  'headerform.labelPelabuhan': 'Pelabuhan',
  'headerform.labelKantorPabean': 'Kantor Pabean',
  'headerform.labelPIB': 'PIB',
  'headerform.labelJenisImpor': 'Jenis Impor',
  'headerform.labelCaraBayar': 'Cara Bayar',
  'headerform.placeholderPelabuhan': 'Pilih pelabuhan',
  'headerform.placeholderKantorPabean': 'Pilih kantor pabean',
  'headerform.placeholderPIB': 'Pilih jenis PIB',
  'headerform.placeholderJenisImpor': 'Pilih jenis impor',
  'headerform.placeholderCaraBayar': 'Pilih cara bayar',
  'headerform.pibOpt1': '1 - BIASA',
  'headerform.pibOpt2': '2 - BERKALA',
  'headerform.imporOpt1': '1 - UNTUK DIPAKAI',
  'headerform.imporOpt2': '2 - SEMENTARA',
  'headerform.imporOpt5': '5 - RUSH HANDLING',
  'headerform.imporOpt9': '9 - GABUNGAN 1 DAN 2',
  'headerform.bayarOpt1': '1 - BIASA/TUNAI',
  'headerform.bayarOpt2': '2 - BERKALA',
  'headerform.bayarOpt10': '10 - PEMBAYARAN KEMUDIAN (OPEN ACCOUNT) SECARA BERTAHAP',
  'headerform.bayarOpt11': '11 - PEMBAYARAN KEMUDIAN (OPEN ACCOUNT) SECARA TUNAI',
  'headerform.bayarOpt12': '12 - DILAKUKAN DI DN DENGAN PEMBAYARAN UANG TUNAI',
  'headerform.bayarOpt13': '13 - DILAKUKAN DI DN DENGAN PEMBAYARAN MELALUI TELEGRAPH TRANSFER (T/T)',
  'headerform.bayarOpt14': '14 - DILAKUKAN TANPA PEMBAYARAN',
  'headerform.bayarOpt15': '15 - PEMBAYARAN DIMUKA (ADVANCE PAYMENT)',
  'headerform.bayarOpt16': '16 - SIGHT LETTER OF CREDIT',
  'headerform.bayarOpt17': '17 - INKASO (COLLECTION DRAFT)',

  // DokumenForm
  'dokumenform.col.seri': 'Seri',
  'dokumenform.col.jenis': 'Jenis',
  'dokumenform.col.ecooStatus': 'eCOO Status',
  'dokumenform.col.nomor': 'Nomor',
  'dokumenform.col.tanggal': 'Tanggal',
  'dokumenform.col.fasilitas': 'Fasilitas',
  'dokumenform.col.kodeIjin': 'Kode Ijin',
  'dokumenform.col.attached': 'Terlampir',
  'dokumenform.col.state': 'Status',
  'dokumenform.col.aksi': 'Aksi',

  'dokumenform.action.attachToBarang': 'Lampirkan ke Barang',
  'dokumenform.action.edit': 'Edit',
  'dokumenform.action.copy': 'Salin',
  'dokumenform.action.uploadReplace': 'Unggah / Ganti File',
  'dokumenform.action.uploadReplaceAria': 'Unggah atau ganti file',
  'dokumenform.action.delete': 'Hapus',
  'dokumenform.action.deleteLastBlocked': 'Dokumen terakhir tidak dapat dihapus — CEISA memerlukan minimal 2 dokumen',
  'dokumenform.action.undo': 'Urungkan',
  'dokumenform.deleted.title': 'Dokumen yang dihapus',
  'dokumenform.deleted.hint':
    'Dokumen ini tidak akan muncul di tab Dokumen dan tidak dikirim ke CEISA. Pulihkan bila terhapus tidak sengaja.',
  'dokumenform.deleted.restore': 'Pulihkan',

  'dokumenform.modal.attachTitle': 'Lampirkan Dokumen ke Barang',
  'dokumenform.modal.replaceTitle': 'Ganti pilihan saat ini?',
  'dokumenform.modal.uploadPdfTitle': 'Unggah PDF Dokumen',

  'dokumenform.label.quickSelect': 'Pilih Cepat (Input Rentang)',
  'dokumenform.label.filterHsCode': 'Filter berdasarkan Kode HS',
  'dokumenform.label.bulkSeriIjin': 'Bulk No. Urut di Izin',
  'dokumenform.label.filePdf': 'File PDF',
  'dokumenform.label.tipeDokumen': 'Tipe Dokumen',

  'dokumenform.placeholder.rangeExample': 'Contoh: 1-2,3,5-8,10 (gunakan nomor item, bukan indeks)',
  'dokumenform.placeholder.filterHsCode': 'Ketik kode HS untuk filter (mis. 9403)',
  'dokumenform.placeholder.value': 'Nilai',
  'dokumenform.placeholder.pilihFilePdf': 'Pilih file PDF',
  'dokumenform.placeholder.url': 'https://... (House-BL / AWB / dokumen pendukung)',

  'dokumenform.button.batal': 'Batal',
  'dokumenform.button.simpan': 'Simpan',
  'dokumenform.button.menyimpan': 'Menyimpan...',
  'dokumenform.button.tambahDokumen': 'Tambah dokumen',
  'dokumenform.button.uploadPdf': 'Unggah PDF',
  'dokumenform.button.upload': 'Unggah',
  'dokumenform.button.applyToSelected': 'Terapkan ke Terpilih ({n})',
  'dokumenform.button.clearSelection': 'Bersihkan pilihan',
  'dokumenform.button.replaceSelection': 'Ganti pilihan',
  'dokumenform.button.autoMatch': 'Auto-match',
  'dokumenform.button.autoMatchEcoo': 'Auto-match dari E-COO',
  'dokumenform.button.validateEcoo': 'Validasi eCOO',
  'dokumenform.button.autoSort': 'Urutkan Otomatis',
  'dokumenform.total': 'Total: {n}',

  'dokumenform.notify.success': 'Berhasil',
  'dokumenform.notify.successTitle': 'Sukses',
  'dokumenform.notify.errorTitle': 'Error',
  'dokumenform.notify.failed': 'Gagal',
  'dokumenform.notify.cannotUpload': 'Belum bisa upload',
  'dokumenform.notify.saveRowFirst': 'Simpan baris dokumen terlebih dahulu sebelum mengganti file.',
  'dokumenform.notify.formatNotSupported': 'Format tidak didukung',
  'dokumenform.notify.onlyPdfExcel': 'Hanya file PDF atau Excel (.xlsx/.xls/.csv) yang diperbolehkan.',
  'dokumenform.notify.uploaded': '{name} terupload',
  'dokumenform.notify.uploadFailed': 'Gagal mengupload file',
  'dokumenform.notify.urlSaveFailed': 'Gagal menyimpan URL Dokumen',
  'dokumenform.notify.documentAdded': 'Dokumen berhasil ditambahkan',
  'dokumenform.notify.documentUpdated': 'Dokumen berhasil diperbarui',
  'dokumenform.notify.documentAddFailed': 'Gagal menyimpan dokumen baru',
  'dokumenform.notify.documentEditFailed': 'Gagal menyimpan dokumen yang diedit',
  'dokumenform.notify.documentCopied': 'Dokumen berhasil disalin',
  'dokumenform.notify.documentCopyFailed': 'Gagal menyimpan dokumen yang disalin',
  'dokumenform.notify.documentDeleted': 'Dokumen berhasil dihapus',
  'dokumenform.notify.documentDeleteFailed': 'Gagal menyimpan perubahan setelah menghapus dokumen',
  'dokumenform.notify.cannotDeleteLastDocument':
    'Minimal satu dokumen harus tersisa. CEISA memerlukan minimal 2 dokumen untuk pengiriman.',
  'dokumenform.notify.documentRestored': 'Dokumen berhasil dipulihkan',
  'dokumenform.notify.documentRestoreFailed': 'Gagal memulihkan dokumen',
  'dokumenform.notify.stateChangedTo': 'Status dokumen diubah menjadi {state}',
  'dokumenform.notify.stateUpdateFailed': 'Gagal memperbarui status dokumen',
  'dokumenform.notify.autoMatch': 'Auto-match',
  'dokumenform.notify.noAutoMatch':
    'Tidak ditemukan kecocokan yang yakin untuk dokumen ini. Silakan pilih barang secara manual.',
  'dokumenform.notify.processIdNotFound': 'Process ID tidak ditemukan',
  'dokumenform.notify.serialNotFound': 'Nomor seri dokumen tidak ditemukan',
  'dokumenform.notify.attachedToBarang': 'Dokumen terlampir ke {count} barang',
  'dokumenform.notify.attachedPartial':
    'Dokumen terlampir ke {count} dari {requested} barang. {dropped} barang ditolak karena sudah terlampir di dokumen lain dengan kode yang sama.',
  'dokumenform.notify.attachFailed': 'Gagal menyimpan lampiran barang',
  'dokumenform.notify.pleaseSelectPdf': 'Silakan pilih file PDF terlebih dahulu',
  'dokumenform.notify.pdfExtracted': 'Dokumen berhasil diekstrak dari PDF',
  'dokumenform.notify.pdfExtractedWithEntitas': 'Dokumen berhasil diekstrak dari PDF, Tab Entitas ikut diperbarui',
  'dokumenform.notify.pdfUploadError': 'Terjadi kesalahan saat upload PDF',
  'dokumenform.notify.orderUpdated': 'Urutan dokumen berhasil diperbarui',
  'dokumenform.notify.orderSaveFailed': 'Gagal menyimpan urutan dokumen',
  'dokumenform.notify.orderAlreadySorted': 'Urutan dokumen sudah sesuai',
  'dokumenform.notify.validationFailed': 'Validasi Gagal',
  'dokumenform.notify.npwpRequired': 'NPWP Importir harus diisi untuk validasi eCOO',
  'dokumenform.notify.npwpInvalid': 'NPWP Importir tidak valid',
  'dokumenform.notify.noDocsToValidate': 'Tidak ada dokumen untuk divalidasi',
  'dokumenform.notify.ecooInvalid': 'Dokumen eCOO tidak valid',
  'dokumenform.notify.ajuRequired': 'Nomor AJU (BL Number) harus diisi untuk validasi eCOO',
  'dokumenform.notify.validationSuccess': 'Validasi Berhasil',
  'dokumenform.notify.ecooValidated': 'eCOO berhasil divalidasi',
  'dokumenform.notify.ecooValidationFailed': 'Validasi eCOO gagal',
  'dokumenform.notify.ecooError': 'Terjadi kesalahan saat validasi eCOO',

  'dokumenform.barang.selectPrompt': 'Pilih barang mana yang dokumen ini akan dilampirkan:',
  'dokumenform.barang.findingEcoo': 'Mencari barang yang disarankan dari item baris E-COO…',
  'dokumenform.barang.finding': 'Mencari barang yang disarankan untuk dokumen ini…',
  'dokumenform.barang.autoMatchShipment':
    'Kiriman ini hanya satu barang, jadi dokumen ini mencakupnya. Periksa sebelum menyimpan.',
  'dokumenform.barang.noAutoMatchEcoo':
    'Tidak ada kecocokan yang yakin dengan baris E-COO ini. Pilih barang secara manual.',
  'dokumenform.barang.noAutoMatch': 'Tidak ada kecocokan yang yakin untuk dokumen ini. Pilih barang secara manual.',
  'dokumenform.barang.colSeriBarang': 'Seri Barang',
  'dokumenform.barang.colHsCode': 'Kode HS',
  'dokumenform.barang.colNamaBarang': 'Nama Barang',
  'dokumenform.barang.colNoUrut': 'No. Urut di Izin',
  'dokumenform.barang.noItemsMatch': 'Tidak ada item yang cocok dengan kode HS "{hs}"',
  'dokumenform.barang.noBarang': 'Tidak ada barang yang tersedia. Silakan tambahkan barang terlebih dahulu.',
  'dokumenform.barang.loading': 'Memuat barang...',
  'dokumenform.barang.showingCount': 'Menampilkan {count} dari {total} item',
  'dokumenform.barang.filterDescription': 'Filter barang berdasarkan kode HS',
  'dokumenform.barang.replacePrompt':
    'Auto-match akan mengganti {count} barang yang dipilih saat ini dengan set yang disarankan untuk dokumen ini. Tidak ada yang disimpan sampai Anda mengklik Simpan.',
  'dokumenform.barang.rangeDescription':
    'Masukkan nomor item barang dipisahkan koma. Gunakan tanda hubung untuk rentang (mis. 1-5 berarti item 1,2,3,4,5)',
  'dokumenform.barang.unamed': 'TANPA NAMA',
  'dokumenform.barang.suggestedCoverage': 'Disarankan · {label}',
  'dokumenform.barang.suggestedConfidence': 'Disarankan · {confidence} · {percent}%',
  'dokumenform.barang.ecooItem': 'Item E-COO: {desc}',
  'dokumenform.popover.autoMatch': 'Auto-match',
  'dokumenform.popover.loading': 'Loading…',
  'dokumenform.popover.noAutoMatchData': 'No auto-match data — attached manually',
  'dokumenform.popover.seri': 'Seri {n}',
  'dokumenform.popover.wholeShipment': 'whole shipment',
  'dokumenform.popover.sameHsCode': 'kode HS sama ·',
  'dokumenform.popover.andMore': '…and {n} more',
  'dokumenform.popover.moreMatch': '{n} more barang match this document but are not attached',
  'dokumenform.file.downloadAria': 'Download {name}',
  'dokumenform.file.replaceTooltip': 'Ganti file',
  'dokumenform.file.uploadTooltip': 'Upload file',
  'dokumenform.file.replaceAria': 'Replace file',
  'dokumenform.file.uploadAria': 'Upload file',
  'dokumenform.file.uploading': 'Uploading…',
  'dokumenform.file.replaceUploading': 'Mengganti file…',
  'dokumenform.file.noUrlInResponse': 'Response tidak mengandung URL file yang baru',
  'dokumenform.barang.statusSuggested': '{count} dari {total} barang dicentang otomatis. Periksa sebelum menyimpan.',
  'dokumenform.barang.legend':
    'Badge hijau: cocok dengan baris sertifikat. Badge kuning: kecocokan lebih lemah. Tanpa badge: tidak dicocokkan, centang manual jika sertifikat mencakupnya.',
  'dokumenform.barang.legendWithCount':
    'Badge hijau: cocok dengan baris sertifikat. Badge kuning: jumlah baris sertifikat sama dengan jumlah barang, jadi sisanya kemungkinan tercakup. Periksa sebelum menyimpan.',
  'dokumenform.barang.claimedNote':
    '{count} barang sudah terlampir di sertifikat lain dan tidak bisa dicentang di sini. Lepaskan di sana dulu jika ingin memindahkannya.',
  'dokumenform.barang.showUnmatched': 'Lihat {count} barang yang tidak dicocokkan',
  'dokumenform.barang.hideUnmatched': 'Sembunyikan {count} barang yang tidak dicocokkan',
  'dokumenform.barang.suggestedHigh': 'Disarankan {percent}%',
  'dokumenform.barang.suggestedMedium': 'Mungkin cocok {percent}%',
  'dokumenform.barang.suggestedCount': 'Disarankan, jumlah sama',
  'dokumenform.barang.countTooltip':
    'Sertifikat ini punya {n} baris, sama dengan jumlah barang. Barang ini tidak cocok berdasarkan teks, tetapi kemungkinan tercakup.',
  'dokumenform.barang.suggestedHsCode': 'Disarankan, kode HS sama',
  'dokumenform.barang.hsCodeTooltip': 'Kode HS sama dengan yang tercantum di dokumen: {hs}',
  'dokumenform.barang.claimedBadge': 'Sudah di seri {seri}',
  'dokumenform.barang.claimedTooltip':
    'Barang ini sudah terlampir di dokumen seri {seri} dengan kode yang sama. Lepaskan di sana dulu untuk memindahkannya ke sini.',
  'dokumenform.button.selectAll': 'Pilih semua ({n})',
  'dokumenform.button.deselectAll': 'Kosongkan',
  'dokumenform.button.simpanCount': 'Simpan ({n} barang)',
  'dokumenform.barang.more': '+{n} more',
  'dokumenform.confidence.overall': 'Kepercayaan Keseluruhan',
  'dokumenform.confidence.documentNumber': 'Kepercayaan Nomor Dokumen',
  'dokumenform.confidence.documentDate': 'Kepercayaan Tanggal Dokumen',

  // <i18n-anchor-dokumenform>
  // <i18n-anchor-entitasform>
  'entitasform.entitas': 'Entitas',
  'entitasform.nibWajibDiisi': 'NIB wajib diisi',
  'entitasform.errNibImportirWajib': 'NIB Importir wajib diisi',
  'entitasform.errNamaImportirWajib': 'Nama Importir wajib diisi',
  'entitasform.errJenisApiImportirWajib': 'Jenis API Importir wajib diisi',
  'entitasform.errJenisIdentitasWajib': 'Jenis Identitas wajib diisi',
  'entitasform.errNpwpImportirWajib': 'NPWP Importir wajib diisi',
  'entitasform.errAlamatImportirWajib': 'Alamat Importir wajib diisi',
  'entitasform.errStatusImportirWajib': 'Status Importir wajib diisi',
  'entitasform.errFieldWajibDiisi': 'Field ini wajib diisi',
  'entitasform.successTitle': 'Success',
  'entitasform.successMessage': 'Entity data loaded successfully!',
  'entitasform.titlePemilikBarang': 'Pemilik Barang',
  'entitasform.titlePemusatan': 'Pemusatan',
  'entitasform.titlePengirim': 'Pengirim',
  'entitasform.titlePenjual': 'Penjual',
  'entitasform.titlePpjk': 'PPJK',
  'entitasform.actionSalinImportir': 'Salin Importir',
  'entitasform.actionSalinDataPengirim': 'Salin Data Pengirim',
  'entitasform.importir': 'Importir',
  'entitasform.fieldJenis': 'Jenis',
  'entitasform.fieldNpwp': 'NPWP {title}',
  'entitasform.fieldNama': 'Nama {title}',
  'entitasform.fieldNegara': 'Negara {title}',
  'entitasform.fieldAlamat': 'Alamat {title}',
  'entitasform.fieldStatus': 'Status',
  'entitasform.fieldApiNib': 'API/NIB',
  'entitasform.fieldNib': 'NIB',
  'entitasform.fieldAfiliasi': 'Afiliasi',
  'entitasform.syncDariJarvis': 'Sync dari Lumen',
  'entitasform.syncPerluDiperiksa': 'Berbeda dari dokumen terakhir — ambil data dari Lumen',
  'entitasform.pilihDataDariJarvis': 'Pilih Data {title} dari Lumen',
  'entitasform.syncGagal': 'Sync Gagal',
  'entitasform.tidakAdaDataJarvis': 'Tidak ada data untuk NPWP ini di Lumen.',
  'entitasform.gagalSyncJarvis': 'Gagal sync data dari Lumen.',
  'entitasform.npwpBelumLengkap': 'NPWP belum lengkap',
  'entitasform.npwpHarus16Digit': 'NPWP harus 16 digit untuk sync dari Lumen.',
  'entitasform.diterapkan': 'Diterapkan',
  'entitasform.pilihDariRiwayat': 'Pilih dari riwayat dokumen',
  'entitasform.dataConsigneeSumber': 'Data Consignee',
  'entitasform.bukaDiConsignee': 'Buka di Data Consignee',
  'entitasform.bukaConsignee': 'Buka Data Consignee',
  'entitasform.riwayatDokumenCount': 'Riwayat dokumen ({count})',
  'entitasform.diperbaruiTanggal': 'Diperbarui {date}',
  'entitasform.belumAdaDiConsignee':
    'Importir ini belum ada di Master › Data Consignee. Setelah dokumen berhasil dikirim ke CEISA, data importir akan disimpan otomatis sebagai sumber utama.',
  'entitasform.belumAdaDiConsigneeSingkat':
    'Belum ada di Data Consignee. Tersimpan otomatis setelah dokumen berhasil dikirim ke CEISA.',
  'entitasform.dataMasterTidakBisaDitandai': 'Data Consignee dikelola di menu Master, bukan ditandai salah di sini.',
  'entitasform.riwayatTidakDapatDimuat': 'Riwayat dokumen tidak dapat dimuat',
  'entitasform.dibukaDiTabBaru': 'Dibuka di tab baru: Master › Data Consignee',
  'entitasform.dataConsigneeSeksi': 'DATA CONSIGNEE',
  'entitasform.consigneeTerpakai': 'Data consignee diterapkan ke Importir.',
  'entitasform.simpanKeConsignee': 'Simpan ke Data Consignee',
  'entitasform.simpanKeConsigneeHint': 'Simpan importir ini agar terisi otomatis di dokumen berikutnya.',
  'entitasform.tersimpanKeConsignee': 'Tersimpan ke Data Consignee',
  'entitasform.tersimpanKeConsigneeMsg': 'Importir ini akan terisi otomatis dari NPWP-nya mulai sekarang.',
  'entitasform.consigneeSudahAda': 'NPWP ini sudah ada di Data Consignee.',
  'entitasform.gagalSimpanConsignee': 'Gagal menyimpan ke Data Consignee.',
  'entitasform.dataDiterapkanSection': 'Data Lumen diterapkan ke section.',
  'entitasform.dataDiterapkanImportir': 'Data Lumen diterapkan ke Importir.',
  'entitasform.gagalMenyimpanEntitas': 'Gagal menyimpan Entitas',
  'entitasform.dataHistoricalBelumTersimpan': 'Data historical sudah diterapkan, tetapi belum tersimpan.',
  'entitasform.disinkronDariRiwayat': 'Disinkron dari riwayat dokumen',
  'entitasform.dataDariDokumenSebelumnya':
    'Data ini diambil dari dokumen sebelumnya. Periksa & sesuaikan sebelum dikirim.',
  'entitasform.optMita': 'MITA',
  'entitasform.optAeo': 'AEO',
  'entitasform.optLainnya': 'LAINNYA',
  'entitasform.optApiU': 'API U',
  'entitasform.optApiP': 'API P',
  'entitasform.optPaspor': '2 - PASPOR',
  'entitasform.optKtp': '3 - KTP',
  'entitasform.optLainnyaIdentitas': '4 - LAINNYA',
  'entitasform.optNpwp15': '5 - NPWP 15 DIGIT',
  'entitasform.optNpwp16': '6 - NPWP 16 DIGIT',
  'entitasform.optAfl': 'AFL - Affiliated Company',
  'entitasform.optCtr': 'CTR - Financial/legally controlled',
  'entitasform.optFam': 'FAM - Family member',
  'entitasform.optTah': 'TAH - Tidak berhubungan',
  // <i18n-anchor-kemasanform>
  'kemasanform.seri': 'Seri',
  'kemasanform.jumlah': 'Jumlah',
  'kemasanform.jenis': 'Jenis',
  'kemasanform.merek': 'Merek',
  'kemasanform.aksi': 'Aksi',
  'kemasanform.nomor': 'Nomor',
  'kemasanform.ukuran': 'Ukuran',
  'kemasanform.tipe': 'Tipe',
  'kemasanform.kemasan': 'Kemasan',
  'kemasanform.petiKemas': 'Peti Kemas',
  'kemasanform.tambahKemasan': 'Tambah Kemasan',
  'kemasanform.tambahPetiKemas': 'Tambah Peti Kemas',
  'kemasanform.totalPetiKemas': 'Total: {n}',
  'kemasanform.edit': 'Edit',
  'kemasanform.copy': 'Copy',
  'kemasanform.delete': 'Delete',
  'kemasanform.required': 'This field is required!',
  'kemasanform.jenisOptionEmpty': '4 - EMPTY',
  'kemasanform.jenisOptionLcl': '7 - LCL',
  'kemasanform.jenisOptionFcl': '8 - FCL',
  'kemasanform.tipeOptionGeneralDry': '1 - GENERAL / DRY CARGO',
  'kemasanform.tipeOptionTunnel': '2 - TUNNEL TYPE',
  'kemasanform.tipeOptionOpenTop': '3 - OPEN TOP STEEL',
  'kemasanform.tipeOptionFlatRack': '4 - FLAT RACK',
  'kemasanform.tipeOptionReefer': '5 - REEFER/REFRIGERATE',
  'kemasanform.tipeOptionBarge': '6 - BARGE CONTAINER',
  'kemasanform.tipeOptionBulk': '7 - BULK CONTAINER',
  'kemasanform.tipeOptionIsotank': '8 - ISOTANK',
  'kemasanform.tipeOptionLain': '99 - LAIN-LAIN',
  // PengangkutForm
  'pengangkutform.smartSync': 'Smart Sync dengan BC 1.1',
  'pengangkutform.syncing': 'Menyinkronkan...',
  'pengangkutform.kodeTutupPu': 'Kode Tutup PU',
  'pengangkutform.nomorBc11': 'Nomor BC 1.1',
  'pengangkutform.tanggalTutupPu': 'Tanggal Tutup PU',
  'pengangkutform.nomorPos': 'Nomor Pos',
  'pengangkutform.nomorSubpos': 'Nomor Subpos',
  'pengangkutform.nomorSubsubpos': 'Nomor Subsubpos',
  'pengangkutform.pengangkutan': 'Pengangkutan',
  'pengangkutform.caraPengangkutan': 'Cara Pengangkutan',
  'pengangkutform.namaSaranaPengangkut': 'Nama Sarana Pengangkut',
  'pengangkutform.nomorVoyFlightNoPol': 'Nomor Voy/Flight/No. Pol',
  'pengangkutform.bendera': 'Bendera',
  'pengangkutform.perkiraanTanggalTiba': 'Perkiraan Tanggal Tiba',
  'pengangkutform.cariBendera': 'Cari Bendera',
  'pengangkutform.pelabuhanTempatPenimbunan': 'Pelabuhan & Tempat Penimbunan',
  'pengangkutform.pelabuhanMuat': 'Pelabuhan Muat',
  'pengangkutform.pelabuhanTransit': 'Pelabuhan Transit',
  'pengangkutform.pelabuhanTujuan': 'Pelabuhan Tujuan',
  'pengangkutform.tempatPenimbunan': 'Tempat penimbunan',
  'pengangkutform.noticeOfArrival': 'Notice of Arrival',
  'pengangkutform.loadingData': 'Memuat data...',
  'pengangkutform.useThisValue': 'Gunakan nilai ini',
  'pengangkutform.uploading': 'Mengunggah...',
  'pengangkutform.maxFileSize': 'Ukuran file maksimum: 2MB',
  'pengangkutform.extractedInfo': '✓ Informasi yang Diekstrak',
  'pengangkutform.warehouse': 'Gudang:',
  'pengangkutform.invoiceNumber': 'Nomor Invoice:',
  'pengangkutform.shipper': 'Pengirim:',
  'pengangkutform.consignee': 'Penerima:',
  'pengangkutform.flagNameFromApi': 'Nama bendera dari API',
  'pengangkutform.portOfLoadingFromApi': 'Pelabuhan muat dari API',
  'pengangkutform.notifError': 'Error',
  'pengangkutform.notifSuccess': 'Sukses',
  'pengangkutform.notifWarning': 'Peringatan',
  'pengangkutform.notifFileTooLarge': 'File Terlalu Besar',
  'pengangkutform.notifUploadSuccessful': 'Upload Berhasil',
  'pengangkutform.notifPdfExtractionComplete': 'Ekstraksi PDF Selesai',
  'pengangkutform.notifUploadFailed': 'Upload Gagal',
  'pengangkutform.notifDocumentNotFound': 'Dokumen Tidak Ditemukan',
  'pengangkutform.notifIncompleteDocument': 'Dokumen Tidak Lengkap',
  'pengangkutform.notifNoData': 'Tidak Ada Data',
  'pengangkutform.notifApiError': 'API Error',
  'pengangkutform.msgEnterVesselNameFirst': 'Silakan masukkan nama kapal terlebih dahulu',
  'pengangkutform.msgFlagFound': 'Bendera ditemukan: {flag}',
  'pengangkutform.msgNoFlagInfo': 'Tidak ada informasi bendera untuk kapal ini',
  'pengangkutform.msgNoAirlineFlagInfo': 'Maskapai tidak dikenali, pilih bendera secara manual',
  'pengangkutform.msgEnterAirlineFirst': 'Silakan masukkan nama maskapai atau nomor penerbangan terlebih dahulu',
  'pengangkutform.msgFailedFetchFlag': 'Gagal mengambil informasi bendera kapal',
  'pengangkutform.msgFileTooLarge': 'Ukuran file harus kurang dari 2MB',
  'pengangkutform.msgBatchUuidNotFound': 'Batch UUID tidak ditemukan di URL',
  'pengangkutform.msgUploadSuccessful': 'File NOA "{name}" berhasil diunggah',
  'pengangkutform.msgPdfExtractionComplete': 'Data Notice of Arrival berhasil diekstrak',
  'pengangkutform.msgUploadFailed': 'Gagal mengunggah file NOA',
  'pengangkutform.msgNoBlDocument': 'Dokumen B/L (705) tidak ditemukan. Silakan tambahkan dokumen B/L terlebih dahulu.',
  'pengangkutform.msgBlIncomplete': 'Dokumen B/L harus memiliki nomor dan tanggal.',
  'pengangkutform.msgPopulatedFields': '{n} field berhasil diisi dari Manifest BC 1.1',
  'pengangkutform.msgNoManifestData': 'Tidak ada data dalam respons Manifest BC 1.1',
  'pengangkutform.msgFailedRetrieveManifest': 'Gagal mengambil data manifest',
  'pengangkutform.msgFailedCallManifest': 'Gagal memanggil API Manifest BC 1.1. Silakan coba lagi.',
  'pengangkutform.caraOpt1': '1 - LAUT',
  'pengangkutform.caraOpt2': '2 - KERETA API',
  'pengangkutform.caraOpt3': '3 - DARAT',
  'pengangkutform.caraOpt4': '4 - UDARA',
  'pengangkutform.caraOpt5': '5 - POS',
  'pengangkutform.caraOpt6': '6 - MULTIMODA',
  'pengangkutform.caraOpt7': '7 - INSTALASI / PIPA',
  'pengangkutform.caraOpt8': '8 - PERAIRAN',
  'pengangkutform.caraOpt9': '9 - LAINNYA',
  // <i18n-anchor-pengangkutform>
  // <i18n-anchor-transaksiform>
  'transaksiform.titleHarga': 'Harga',
  'transaksiform.warningPastikanValuta': 'Harap pastikan valuta sudah benar',
  'transaksiform.labelValuta': 'Valuta',
  'transaksiform.placeholderPilihValuta': 'Pilih Valuta',
  'transaksiform.labelNdpbm': 'NDPBM',
  'transaksiform.placeholderNdpbm': 'NDPBM',
  'transaksiform.labelJenisTransaksi': 'Jenis Transaksi',
  'transaksiform.placeholderJenisTransaksi': 'Pilih Jenis Transaksi',
  'transaksiform.labelIncoterm': 'Incoterm',
  'transaksiform.placeholderIncoterm': 'Pilih Incoterm',
  'transaksiform.labelHargaBarang': 'Harga Barang',
  'transaksiform.placeholderHargaBarang': 'Harga Barang',
  'transaksiform.labelNilaiPabeanRupiah': 'Nilai Pabean dalam Rupiah',
  'transaksiform.placeholderNilaiPabeanRupiah': 'Nilai Pabean dalam Rupiah',
  'transaksiform.informasiKomponenBiaya': 'Informasi Komponen Biaya',
  'transaksiform.titleHargaLainnya': 'Harga Lainnya',
  'transaksiform.biayaPenambahan': 'Biaya penambahan',
  'transaksiform.biayaPengurang': 'Biaya pengurang',
  'transaksiform.freight': 'Freight',
  'transaksiform.labelAsuransi': 'Asuransi',
  'transaksiform.placeholderAsuransi': 'Asuransi',
  'transaksiform.nilaiAsuransi': 'Nilai Asuransi',
  'transaksiform.labelVoluntaryDeclaration': 'Voluntary declaration',
  'transaksiform.placeholderVoluntaryDeclaration': 'Voluntary declaration',
  'transaksiform.titleBerat': 'Berat',
  'transaksiform.labelBeratKotor': 'Berat Kotor (KGM)',
  'transaksiform.placeholderBeratKotor': 'Berat Kotor (KGM)',
  'transaksiform.labelBeratBersih': 'Berat Bersih (KGM)',
  'transaksiform.placeholderBeratBersih': 'Berat Bersih (KGM)',
  'transaksiform.helperNettoDihitung':
    'Dihitung dari total netto barang. Gunakan "Samakan ke berat kotor" untuk menyesuaikan, atau isi netto per barang di tab Barang. Tab Transaksi tetap kuning sampai nilai > 0.',
  'transaksiform.buttonSamakanKeBeratKotor': 'Samakan ke berat kotor',
  'transaksiform.tooltipSamakanKeBeratKotor':
    'Sesuaikan netto barang pertama agar total berat bersih sama dengan berat kotor',
  'transaksiform.disabledSamakanBrutoKosong': 'Isi berat kotor terlebih dahulu',
  'transaksiform.disabledSamakanTidakAdaBarang': 'Tidak ada barang untuk disamakan',
  'transaksiform.modalSamakanTitle': 'Samakan berat bersih ke berat kotor',
  'transaksiform.modalSamakanBeratKotor': 'Berat kotor',
  'transaksiform.modalSamakanTotalNetto': 'Total berat bersih saat ini',
  'transaksiform.modalSamakanItem': 'Barang yang diubah',
  'transaksiform.modalSamakanNettoLama': 'Netto lama',
  'transaksiform.modalSamakanNettoBaru': 'Netto baru',
  'transaksiform.modalSamakanConfirm': 'Samakan',
  'transaksiform.modalSamakanCancel': 'Batal',
  'transaksiform.hintNettoTidakSamaBruto':
    'Berat bersih berbeda dari berat kotor. Gunakan tombol di atas untuk menyamakan.',
  'transaksiform.errSamakanFirstNegatif':
    'Netto barang lain sudah melebihi berat kotor. Kurangi netto di tab Barang terlebih dahulu.',
  'transaksiform.errSamakanTidakAdaBarang': 'Tidak ada barang untuk disamakan',
  'transaksiform.errSamakanBrutoKosong': 'Berat kotor harus lebih dari 0',
  // Tab-bar ring tooltips.
  'docpabean.tabs.mandatoryFilled': '{filled} / {total} kolom wajib terisi.',
  // Tab-bar warning ring: Transaksi and Barang totals disagree.
  'docpabean.tabs.hargaMismatchTooltip':
    'Total harga tidak sama: tab Barang {barang} {valuta} ({seri} seri), tab Transaksi {harga} {valuta}. Selisih {selisih} {valuta}. Buka tab Transaksi untuk menyamakan.',
  // Harga Barang (Transaksi) vs Σ Total Nilai (Barang). Placeholders are filled
  // by utils/hargaBarangCheck.ts — keep {harga}/{barang}/{selisih}/{valuta}/{seri}.
  'transaksiform.hintHargaTidakSamaBarang':
    'Total nilai di tab Barang ({barang} {valuta} dari {seri} seri) tidak sama dengan Harga Barang di sini ({harga} {valuta}). Selisih {selisih} {valuta}.',
  'transaksiform.buttonSamakanHargaBarang': 'Samakan dengan total tab Barang',
  'transaksiform.modalSamakanHargaTitle': 'Samakan Harga Barang dengan total Barang',
  'transaksiform.modalSamakanHargaSekarang': 'Harga Barang sekarang',
  'transaksiform.modalSamakanHargaTotalBarang': 'Total nilai tab Barang ({seri} seri)',
  'transaksiform.modalSamakanHargaSelisih': 'Selisih',
  'transaksiform.modalSamakanHargaPenjelasan':
    'Harga Barang akan diisi dengan total nilai dari tab Barang. Rincian per barang tidak diubah.',
  'transaksiform.modalSamakanHargaCatatanBiaya':
    'Catatan: Freight {freight} {valuta} dan Asuransi {asuransi} {valuta} diisi terpisah. Pastikan total di tab Barang belum termasuk keduanya, agar nilai pabean tidak dihitung dua kali.',
  'transaksiform.hargaSamakanApplied': 'Harga Barang diisi {amount} {valuta} dari total tab Barang',
  'transaksiform.errHargaSamakanGagal': 'Gagal menyamakan Harga Barang. Coba lagi.',
  'transaksiform.errNettoHarusLebihDari0': 'Berat Bersih harus lebih dari 0 — isi netto per barang di tab Barang',
  'transaksiform.errNettoLebihDariBruto': 'Berat Bersih tidak boleh lebih besar dari Berat Kotor',
  'transaksiform.warningTitle': 'Warning',
  'transaksiform.errNdpbmRetrieve': 'Could not retrieve NDPBM value. Please enter manually.',
  'transaksiform.errorTitle': 'Error',
  'transaksiform.errNdpbmFetch': 'Error when fetching NDPBM',
  'transaksiform.confGrossWeight': 'Gross weight confidence',
  'transaksiform.confCurrency': 'Currency confidence',
  'transaksiform.confIncoterm': 'Incoterm confidence',
  'transaksiform.confHargaBarang': 'Harga barang confidence',
  'transaksiform.confFreight': 'Freight confidence',
  'transaksiform.confInsurance': 'Insurance value confidence',
  'transaksiform.confNdpbm': 'Exchange rate confidence',
  'transaksiform.confCif': 'CIF value confidence',
  'transaksiform.confNetto': 'Net weight confidence',
  // BarangForm — daftar barang (goods table)
  'barangform.notifError': 'Error',
  'barangform.notifSuccess': 'Berhasil',
  'barangform.notifInfo': 'Info',
  'barangform.minOneBarang': 'Minimal satu barang harus ditambahkan untuk melanjutkan',
  'barangform.seriUraianKosong': 'Seri barang [{seri}] ditemukan Uraian masih kosong',
  'barangform.seriSatuanKosong': 'Seri barang [{seri}] ditemukan Satuan masih kosong',
  'barangform.seriKodeSatuanKosong': 'Seri barang [{seri}] ditemukan Kode Satuan masih kosong',
  'barangform.seriNegaraKosong': 'Seri barang [{seri}] ditemukan Negara masih kosong',
  'barangform.seriHsKosong': 'Seri Barang [{seri}] ditemukan HS Code masih kosong',
  'barangform.seriHs8Digit': 'Seri Barang [{seri}] HS Code harus 8 digit',
  'barangform.gagalMenghapusDokumen': 'Gagal menghapus dokumen',
  'barangform.noItemsSelected': 'No items selected',
  'barangform.updatedCount': '{count} item berhasil diperbarui',
  'barangform.bulkEditFailed': 'Bulk edit failed',
  'barangform.seriBarangRequired': 'Seri Barang wajib diisi',
  'barangform.dataBerhasilDiperbarui': 'Data barang berhasil diperbarui',
  'barangform.gagalMemperbaruiData': 'Gagal memperbarui data barang',
  'barangform.fetchHsDetailsFailed': 'Failed to fetch HS code details',
  'barangform.fetchHsDetailsError': 'Error fetching HS code details',
  'barangform.itemBerhasilDihapus': 'Item berhasil dihapus',
  'barangform.gagalMenghapusItem': 'Gagal menghapus item',
  'barangform.tidakAdaItemDipilih': 'Tidak ada item yang dipilih',
  'barangform.itemBerhasilDihapusCount': '{count} item berhasil dihapus',
  'barangform.itemBerhasilDisalin': 'Item berhasil disalin',
  'barangform.gagalMenyalinItem': 'Gagal menyalin item',
  'barangform.loadItemEditFailed': 'Failed to load item for editing',
  'barangform.processIdNotFound': 'Process ID not found',
  'barangform.downloadSuccess': 'Download success!',
  'barangform.downloadFailed': 'Download failed!',
  'barangform.pilihFilePdf': 'Silakan pilih file PDF terlebih dahulu',
  'barangform.processIdTidakDitemukan': 'Process ID tidak ditemukan',
  'barangform.invoiceUploadSuccess': 'Invoice berhasil diupload dan sedang diproses',
  'barangform.uploadInvoiceError': 'Terjadi kesalahan saat upload invoice',
  'barangform.noItemsToCheck': 'No items to check',
  'barangform.noDuplicateDescriptions': 'No duplicate descriptions found',
  'barangform.foundDuplicates': 'Ditemukan {count} item dengan deskripsi duplikat',
  'barangform.tidakAdaBarangSync': 'Tidak ada barang untuk di-sync',
  'barangform.tidakAdaHsValid': 'Tidak ada HS Code yang valid untuk di-sync',
  'barangform.syncProsesDimulai': 'Proses sync {count} HS Code telah dimulai. Silakan tunggu hingga selesai.',
  'barangform.gagalMemulaiSync': 'Gagal memulai sync: {msg}',
  'barangform.tidakAdaHsCodeSync': 'Tidak ada HS Code untuk di-sync',
  'barangform.hsCodeSyncCount': '{count} HS Code berhasil di-sync',
  'barangform.hsCodeSyncErrorSuffix': ', {count} error',
  'barangform.gagalSyncTarifInsw': 'Gagal sync tarif dengan INSW',
  'barangform.processIdTidakTersedia': 'Process ID tidak tersedia. Silakan muat ulang halaman.',
  'barangform.processIdTidakTersediaSingkat': 'Process ID tidak tersedia',
  'barangform.noItemsToSync': 'No items to sync',
  'barangform.gagalSimpanSebelumSync': 'Failed to save barang data before sync',
  'barangform.smartSyncSukses': 'Smart Sync completed successfully',
  'barangform.smartSyncGagal': 'Smart Sync failed',
  'barangform.noValidHsSync': 'No valid HS codes found to sync',
  'barangform.lartasStatusUpdated': 'Status LARTAS diperbarui untuk {count} item',
  'barangform.lartasAlreadyUpToDate': 'LARTAS status is already up to date',
  'barangform.gagalAmbilLartas': 'Failed to retrieve LARTAS data',
  'barangform.gagalSyncLartas': 'Failed to sync LARTAS data',
  'barangform.itemDariDatabaseSukses': 'Item berhasil ditambahkan dari database!',
  'barangform.gagalItemDatabase': 'Gagal menambahkan item dari database',
  'barangform.cifBerhasil': 'Biaya proporsional berhasil dihitung',
  'barangform.gagalHitungCif': 'Gagal menghitung biaya proporsional',
  'barangform.fobBerhasil': 'Harga FOB berhasil diterapkan',
  'barangform.gagalTerapkanFob': 'Gagal menerapkan harga FOB',
  'barangform.itemUpdatedApplied':
    'Item updated and changes applied to {count} items with same HS code or empty HS code',
  'barangform.itemUpdatedNoApply': 'Item updated. No other items had matching or empty HS codes to apply changes to.',
  'barangform.gagalSimpanServer': 'Failed to save changes to server. Please try again.',
  'barangform.itemAddedSukses': 'Item added successfully',
  'barangform.gagalSimpanItemBaru': 'Failed to save new item to server. Please try again.',
  'barangform.syncedTooltip': 'Data diambil dari dokumen sebelumnya',
  'barangform.syncedFromAjuLabel': 'Synced from Aju {aju}',
  'barangform.syncedFromDraftLabel': 'Synced from Draft {id}',
  'barangform.cekTarifInsw': 'Mengecek tarif dengan INSW...',
  'barangform.inswCocok': 'INSW tarif cocok ({kind}: {value}%)',
  'barangform.inswBerbeda': 'INSW tarif berbeda — INSW {kind}: {value}%',
  'barangform.memuatDetailHs': 'Memuat detail HS...',
  'barangform.lihatDetailHs': 'Lihat detail HS',
  'barangform.hsPick': 'Pilih HS code dari dokumen pengangkutan',
  'barangform.hsPickFailed': 'Gagal menyimpan HS code yang dipilih',
  'barangform.lartas': 'Lartas',
  'barangform.non': 'Non',
  'barangform.unnamedItem': 'Unnamed Item',
  'barangform.justNow': 'just now',
  'barangform.hoursAgo': '{count} jam yang lalu',
  'barangform.oneDayAgo': '1 hari yang lalu',
  'barangform.daysAgo': '{count} hari yang lalu',
  'barangform.hsCodeKosong': 'HS code kosong',
  'barangform.tidakAdaHsCodeDicari': 'Tidak ada HS code untuk dicari.',
  'barangform.prefTarif': '{pref} {year}: {nilai} vs BM {bm}%',
  'barangform.prefNoTarif': '{pref} — tidak ada tarif untuk {year}',
  'barangform.skbPphBadge': 'PPh BEBAS',
  'barangform.skbPphApplied': 'SKB PPh terhubung — PPh dibebaskan (fasilitas 5), tarif {tarif}% tetap tercatat.',
  'barangform.skbPphAppliedNoDoc':
    'PPh dibebaskan (fasilitas 5) tanpa dokumen SKB PPh terhubung — pastikan SKB ada di Tab Dokumen sebelum submit.',
  'barangform.skbPphPending':
    'SKB PPh terhubung, fasilitas bebas PPh belum diterapkan pada barang ini — buka tab Pungutan atau jalankan Sync Tarif HS.',
  'barangform.skbPpnBadge': 'PPN BEBAS',
  'barangform.skbPpnApplied':
    'SKB PPN terhubung — PPN dibebaskan (fasilitas 5), tarif {tarif}% tetap tercatat, PPN dibayar 0.',
  'barangform.skbPpnAppliedNoDoc':
    'PPN dibebaskan (fasilitas 5) tanpa dokumen SKB PPN terhubung — pastikan SKB ada di Tab Dokumen sebelum submit.',
  'barangform.skbPpnPending':
    'SKB PPN terhubung, fasilitas bebas PPN belum diterapkan pada barang ini — buka tab Pungutan atau jalankan Sync Tarif HS.',
  'barangform.editLabel': 'Edit',
  'barangform.copyLabel': 'Copy',
  'barangform.deleteLabel': 'Delete',
  'barangform.colSeri': 'Seri',
  'barangform.colGroup': 'Group',
  'barangform.colHs': 'HS',
  'barangform.colLartas': 'Lartas',
  'barangform.lartasUnverified': 'PERLU CEK',
  'barangform.colUraian': 'Uraian',
  'barangform.colTotalNilai': 'Total Nilai',
  'barangform.colNw': 'NW',
  'barangform.colSatuan': 'Satuan',
  'barangform.colKemasan': 'Kemasan',
  'barangform.kemasanMismatchDetail':
    '{count} baris Barang memakai kemasan {codes}, sedangkan tab Kemasan & Peti Kemas menyatakan {target}.',
  'barangform.kemasanMismatchApply': 'Samakan semua ke {target}',
  'barangform.kemasanMismatchApplying': 'Menyamakan...',
  'barangform.kemasanMismatchDismiss': 'Abaikan',
  'barangform.kemasanMismatchNoCode': 'tanpa kode',
  'barangform.kemasanMismatchDone': '{count} baris Barang diubah ke kemasan {target}.',
  'barangform.kemasanMismatchFailed': 'Gagal menyamakan kemasan Barang.',

  // Kode HS pendek (6 digit) pada tab Barang — lihat utils/hsSuggestions.ts.
  'barangform.hsShortSummary':
    '{codes} kode HS masih kurang dari 8 digit pada {rows} baris. CEISA hanya menerima kode 8 digit.',
  'barangform.hsShortRows': '{count} baris (seri {seri})',
  'barangform.hsShortPick': 'Pilih kode 8 digit ({count} pilihan)',
  'barangform.hsShortModalTitle': 'Pilih kode HS 8 digit untuk {heading}',
  'barangform.hsShortModalIntro':
    'Buku tarif (BTKI) mencatat kode berikut di bawah {heading}. Kode yang Anda pilih akan dipakai untuk {count} baris sekaligus (seri {seri}).',
  'barangform.hsShortCatchAll': 'Lain-lain',
  'barangform.hsShortInactive': 'Tidak aktif',
  'barangform.hsShortInactiveSome':
    'Tidak aktif = tidak ada di sinkronisasi INSW terakhir, bukan berarti tidak bisa dipakai.',
  'barangform.hsShortInactiveAll':
    'Semua kode di bawah pos ini tidak aktif di sinkronisasi INSW terakhir — data BTKI kami (2022) mungkin tertinggal. Periksa dulu sebelum dipakai.',
  'barangform.hsShortUserEdited': '{count} baris pernah diubah manual (seri {seri}) dan akan ikut ditimpa.',
  'barangform.hsShortCancel': 'Batal',
  'barangform.hsShortConfirm': 'Terapkan ke {count} baris',
  'barangform.hsShortDone': '{count} baris diubah dari {heading} menjadi {code}.',
  'barangform.hsShortDoneSkipped':
    '{count} baris diubah menjadi {code}. {skipped} baris dilewati karena sudah berubah.',
  'barangform.hsShortFailed': 'Gagal menerapkan rekomendasi kode HS.',
  'barangform.colDok': 'Dok',
  'barangform.colPpn': 'PPN',
  'barangform.colPph': 'PPH',
  'barangform.colBm': 'BM',
  'barangform.colAction': 'Action',
  'barangform.colJenisDokumen': 'Jenis Dokumen',
  'barangform.colKode': 'Kode',
  'barangform.colNomorDokumen': 'Nomor Dokumen',
  'barangform.colTanggal': 'Tanggal',
  'barangform.colKodeFasilitas': 'Kode Fasilitas',
  'barangform.colNamaFasilitas': 'Nama Fasilitas',
  'barangform.colKodeIjin': 'Kode Ijin',
  'barangform.hapusBarangTitle': 'Hapus Barang',
  'barangform.tindakanTidakBisaDibatalkan': 'Tindakan ini tidak dapat dibatalkan',
  'barangform.konfirmasiHapusBarang': 'Anda yakin ingin menghapus barang berikut?',
  'barangform.konfirmasiHapusMany': 'Anda yakin ingin menghapus {count} barang yang dipilih?',
  'barangform.labelSeri': 'Seri:',
  'barangform.labelUraian': 'Uraian:',
  'barangform.labelHsCode': 'HS Code:',
  'barangform.cancel': 'Batal',
  'barangform.deleting': 'Menghapus...',
  'barangform.delete': 'Hapus',
  'barangform.hapusCountTitle': 'Hapus {count} Barang',
  'barangform.hapusCountItem': 'Hapus {count} Item',
  'barangform.labelJumlahItem': 'Jumlah Item:',
  'barangform.jumlahItemCount': '{count} item',
  'barangform.labelSeriBarang': 'Seri Barang:',
  'barangform.lagiSuffix': ', ... (+{count} lagi)',
  'barangform.hsCodeDetailsTitle': 'HS Code Details',
  'barangform.tabBasicInfo': 'Basic Info',
  'barangform.tabTariffRates': 'Tariff Rates',
  'barangform.tabPreferentialCount': 'Preferential Tariffs ({count})',
  'barangform.labelCode': 'Code:',
  'barangform.labelNormalizedCode': 'Normalized Code:',
  'barangform.labelIdDescription': 'ID Description:',
  'barangform.labelEnDescription': 'EN Description:',
  'barangform.labelInswYear': 'INSW Year:',
  'barangform.labelLartas': 'LARTAS:',
  'barangform.yes': 'YES',
  'barangform.no': 'NO',
  'barangform.labelPpnBm': 'PPN BM',
  'barangform.na': 'N/A',
  'barangform.placeholderSearchPrefTariffs': 'Search preferential tariffs...',
  'barangform.labelIssueDate': 'Issue Date:',
  'barangform.labelEffective': 'Effective:',
  'barangform.nowSuffix': ' (now)',
  'barangform.labelHistoricalRates': 'Historical Rates:',
  'barangform.loadingHsDetails': 'Loading HS code details...',
  'barangform.dokumenTerlampir': 'Dokumen Terlampir',
  'barangform.seriInfoLine': 'Seri {seri}: {uraian}',
  'barangform.dokumenFallback': 'Dokumen {kode}',
  'barangform.deleteAttachmentAria': 'Delete attachment',
  'barangform.tidakAdaDokumenTerlampir': 'Tidak ada dokumen yang terlampir pada barang ini',
  'barangform.memuatDataBarang': 'Memuat data barang...',
  'barangform.menyalinDataBarang': 'Menyalin data barang...',
  'barangform.tambahBarang': 'Tambah Barang',
  'barangform.editBarang': 'Edit Barang',
  'barangform.editMassalCount': 'Edit Massal {count} Item',
  'barangform.bulkEditHint':
    'Pilih field yang ingin diubah untuk semua item yang dipilih. Biarkan kosong untuk mempertahankan nilai yang ada.',
  'barangform.hsCodeField': 'HS Code',
  'barangform.placeholderPilihHs': 'Pilih HS Code baru untuk item yang dipilih...',
  'barangform.nonLartasLabel': 'NON-LARTAS',
  'barangform.kodeSatuanField': 'Kode Satuan',
  'barangform.placeholderPilihSatuan': 'Pilih Kode Satuan baru untuk item yang dipilih...',
  'barangform.kodeKemasanField': 'Kode Kemasan',
  'barangform.placeholderPilihKemasan': 'Pilih Kode Kemasan baru untuk item yang dipilih...',
  'barangform.kodeNegaraField': 'Kode Negara',
  'barangform.placeholderPilihNegara': 'Pilih Kode Negara baru untuk item yang dipilih...',
  'barangform.tarifPungutan': 'Tarif (Pungutan)',
  'barangform.aturTarifHint': 'Atur tarif PPN, PPH, dan BM untuk item yang dipilih',
  'barangform.labelPpnPct': 'PPN (%)',
  'barangform.labelPphPct': 'PPH (%)',
  'barangform.labelBmPct': 'BM (%)',
  'barangform.fasilitasPpnField': 'Fasilitas PPN',
  'barangform.fasilitasPphField': 'Fasilitas PPH',
  'barangform.fasilitasBmField': 'Fasilitas BM',
  'barangform.placeholderPilihFasilitas': 'Pilih fasilitas...',
  'barangform.fasByr': '1 - BYR - DIBAYAR',
  'barangform.fasDtp': '2 - DITANGGUNG PEMERINTAH',
  'barangform.fasBbs': '5 - BBS - DIBEBASKAN',
  'barangform.fasTidakDipungut': '6 - TIDAK DIPUNGUT',
  'barangform.fasDilunasi': '7 - SUDAH DILUNASI',
  'barangform.fasDitunda': '9 - DITUNDA',
  'barangform.terapkanPerubahan': 'Terapkan Perubahan',
  'barangform.resyncTarifTitle': 'Re-Sync Tarif Database',
  'barangform.tersisa': 'tersisa',
  'barangform.syncingTarif': 'Sedang Mensinkronkan Tarif...',
  'barangform.resyncDescription':
    'Sistem sedang mengunduh dan memperbarui data tarif dari database INSW untuk HS Code yang ada di tabel barang Anda.',
  'barangform.harapTunggu': 'Harap tunggu hingga proses selesai. Jangan menutup halaman ini.',
  'barangform.syncSelesai': 'Sync Selesai!',
  'barangform.resyncSelesaiDesc':
    'Data tarif telah berhasil diperbarui. Silakan klik Smart Sync untuk menerapkan tarif terbaru ke tabel barang.',
  'barangform.selesai': 'Selesai',
  'barangform.loadingBarangData': 'Loading barang data...',
  'barangform.totalCount': 'Total: {count}',
  'barangform.labelHsCodes': 'HS Codes:',
  'barangform.filteredCount': 'Filtered: {count}',
  'barangform.duplicatesCount': 'Duplicates: {count}',
  'barangform.withDocumentsCount': 'With Documents: {count}',
  'barangform.lartasCount': 'Lartas: {count}',
  'barangform.nonLartasCount': 'Non-Lartas: {count}',
  'barangform.selectedCount': 'Dipilih: {count}',
  'barangform.editMassal': 'Edit Massal',
  'barangform.editBtn': 'Edit',
  'barangform.hapusMassal': 'Hapus Massal',
  'barangform.batalPilih': 'Batal Pilih',
  'barangform.duplikat': 'Duplikat',
  'barangform.duplikatMassal': 'Duplikat Massal',
  'barangform.duplikatTitle': 'Duplikat Barang',
  'barangform.duplikatSelected': '{count} baris dipilih',
  'barangform.duplikatCopiesLabel': 'Salinan per baris',
  'barangform.duplikatCopiesHint':
    'Setiap baris terpilih disalin sebanyak ini dan ditambahkan di akhir daftar (maks {max}).',
  'barangform.duplikatCopiesInvalid': 'Isi angka 1 – {max}',
  'barangform.duplikatAdded': '+{count} baris baru',
  'barangform.duplikatTotal': 'Total: {from} → {to} barang',
  'barangform.duplikatWillAdd': 'Akan menambah:',
  'barangform.duplikatTotalsNote':
    'Total di Header/Transaksi tidak diubah otomatis. Sesuaikan qty/nilai tiap baris setelahnya.',
  'barangform.duplikatConfirm': 'Duplikat {count}',
  'barangform.duplikatBerhasil': '{count} baris berhasil diduplikasi (seri {first}–{last})',
  'barangform.duplikatGagal': 'Gagal menduplikasi barang',
  'barangform.pilihHalamanIni': '{count} baris di halaman ini dipilih.',
  'barangform.pilihSemuaN': 'Pilih semua {count} barang',
  'barangform.semuaDipilih': 'Semua {count} barang dipilih.',
  'barangform.placeholderCari': 'Cari berdasarkan uraian atau HS code...',
  'barangform.filterOptions': 'Filter Options',
  'barangform.filterHasDocument': 'Barang yang ada Dokumennya',
  'barangform.lartasStatus': 'Lartas Status',
  'barangform.filterLartas': 'Barang Lartas',
  'barangform.filterNonLartas': 'Barang Non-Lartas',
  'barangform.showingCount': 'Menampilkan {count} item',
  'barangform.sortBySeri': 'Urutkan Berdasarkan Seri Barang',
  'barangform.sortByHs': 'Urutkan Berdasarkan HS Code',
  'barangform.sortedBySeriMsg': 'Barang diurutkan berdasarkan Seri Barang',
  'barangform.sortedByHsMsg': 'Barang diurutkan berdasarkan HS Code',
  'barangform.legendBarang': 'Barang',
  'barangform.bulkUpdate': 'Bulk Update',
  'barangform.uploadInvoice': 'Upload Invoice',
  'barangform.legendTarif': 'Tarif',
  'barangform.smartSync': 'Smart Sync',
  'barangform.detailTarif': 'Detail Tarif',
  'barangform.hitungHargaProporsional': 'Hitung Harga Proporsional',
  'barangform.kembalikanHargaSemula': 'Kembalikan Ke Harga Semula',
  'barangform.labelFileInvoice': 'File Invoice (PDF)',
  'barangform.placeholderPilihFilePdf': 'Pilih file PDF',
  'barangform.uploadExtract': 'Upload & Extract',
  'barangform.goTo': 'Go to',
  'barangform.go': 'Go',
  // <i18n-anchor-barangform>
  // PungutanForm
  'pungutanform.title': 'Pungutan',
  'pungutanform.generate': 'Generate Pungutan',
  'pungutanform.total': 'Total Pungutan:',
  'pungutanform.colJenisPungutan': 'Jenis Pungutan',
  'pungutanform.colFasilitas': 'Fasilitas',
  'pungutanform.colNilaiPungutan': 'Nilai Pungutan (IDR)',
  'pungutanform.fasilitas.dibayar': 'Dibayar',
  'pungutanform.fasilitas.ditanggung': 'Ditanggung Pemerintah',
  'pungutanform.fasilitas.ditunda': 'Ditunda',
  'pungutanform.fasilitas.tidakDipungut': 'Tidak Dipungut',
  'pungutanform.fasilitas.dibebaskan': 'Dibebaskan',
  'pungutanform.notif.errorTitle': 'Error',
  'pungutanform.notif.noProcessId': 'Process ID tidak tersedia untuk hitung pungutan',
  'pungutanform.notif.successTitle': 'Success',
  'pungutanform.notif.generated': 'pungutan berhasil di-generate',
  'pungutanform.notif.calculated': 'pungutan dihitung dari barang & tarif',
  'pungutanform.notif.infoTitle': 'Info',
  'pungutanform.notif.noData': 'Tidak ada data pungutan',
  'pungutanform.notif.failTitle': 'Gagal',
  'pungutanform.notif.failGenerate': 'Gagal generate pungutan',
  // Pre-AJU local calculation readiness (issue #237)
  'pungutanform.readiness.ready': 'Siap dihitung',
  'pungutanform.readiness.estimate': 'Perkiraan',
  'pungutanform.readiness.partial': 'Sebagian belum terhitung',
  'pungutanform.readiness.blocked': 'Belum bisa dihitung',
  'pungutanform.readiness.detail.ready':
    'Dihitung lokal dari tarif dan kurs pada draft. Nilai final mengikuti CEISA setelah AJU dikirim.',
  'pungutanform.readiness.detail.estimate':
    'Dihitung lokal dengan CIF perkiraan (freight & asuransi dibagi proporsional). Nilai final mengikuti CEISA setelah AJU dikirim.',
  'pungutanform.readiness.detail.blocked': 'Pungutan belum bisa dihitung untuk draft ini.',
  'pungutanform.readiness.detail.partialSuffix': '{count} barang belum ikut terhitung.',
  'pungutanform.readiness.reason.barangKosong': 'Draft belum memiliki data barang.',
  'pungutanform.readiness.reason.tarifBelumSinkron':
    'Tarif HS belum tersinkron, jadi tidak ada tarif BM/PPN/PPh yang bisa dipakai.',
  'pungutanform.readiness.reason.kursBelumAda':
    'Kurs (NDPBM) belum diisi di tab Transaksi, jadi nilai barang belum bisa dikonversi ke rupiah.',
  'pungutanform.readiness.reason.nilaiBarangKosong': 'Nilai barang masih 0, tidak ada dasar perhitungan.',
  'pungutanform.readiness.valuta': 'Valuta',
  'pungutanform.readiness.ndpbm': 'NDPBM',
  'pungutanform.readiness.ndpbmFromCeisa': 'kurs CEISA — belum tersimpan di tab Transaksi',
  'pungutanform.readiness.tarifSource': 'Sumber tarif',
  'pungutanform.readiness.source.saved': 'tarif tersimpan',
  'pungutanform.readiness.source.hsTariffs': 'tarif HS',
  'pungutanform.readiness.source.mixed': 'campuran',
  'pungutanform.readiness.source.none': '-',
  'pungutanform.readiness.missingCodes': 'Kode HS tanpa tarif',
  'pungutanform.readiness.andMore': '(+{count} lainnya)',
  'pungutanform.readiness.syncTarif': 'Sync Tarif HS',
  'pungutanform.readiness.syncDone': 'Sinkronisasi tarif HS selesai',
  'pungutanform.readiness.syncFailed': 'Gagal sinkronisasi tarif HS',
  'pungutanform.readiness.unsavedTarif':
    'Tarif {count} barang dihitung dari tarif HS & fasilitas dokumen, belum tersimpan di barang — disimpan otomatis saat sinkronisasi (perlu akses Master CEISA).',
  'pungutanform.readiness.ambiguousPreferential':
    'Tarif preferensi (BM fasilitas) barang seri {seri} tidak diterapkan otomatis karena data preferensi bertentangan — BM memakai tarif umum (MFN); cek fasilitas BM secara manual.',
  'pungutanform.readiness.pphExempt':
    'PPh {count} barang (seri {seri}) dibebaskan karena SKB PPh / SKB PP 23 terhubung — tercantum sebagai baris PPH fasilitas 5 (Dibebaskan).',
  'pungutanform.readiness.ppnExempt':
    'PPN {count} barang (seri {seri}) dibebaskan karena SKB PPN terhubung — tercantum sebagai baris PPN fasilitas 5 (Dibebaskan).',

  // PernyataanForm
  'pernyataanform.title': 'Pernyataan',
  'pernyataanform.titleSync': 'Sync Pernyataan',
  'pernyataanform.syncing': 'Syncing...',
  'pernyataanform.declarationHeader': 'Dengan ini saya menyatakan:',
  'pernyataanform.statement1':
    'bertanggung jawab atas kebenaran hal-hal yang diberitahukan dalam dokumen ini dan keabsahan dokumen pelengkap pabean yang menjadi dasar pembuatan dokumen ini; dan',
  'pernyataanform.statement2':
    'apabila dalam jangka waktu paling lambat 1 (satu) hari setelah tanggal pemberitahuan kesiapan barang, saya tidak hadir untuk menyaksikan pemeriksaan fisik, maka saya menuasakan penyaksian kepada pengusaha TPS dengan resiko dan biaya menjadi tanggung jawab saya.',
  'pernyataanform.signerInfo': 'Informasi Penandatangan',
  'pernyataanform.nama': 'Nama',
  'pernyataanform.tanggal': 'Tanggal',
  'pernyataanform.placeholderTanggal': 'tanggal',
  'pernyataanform.tempat': 'Tempat',
  'pernyataanform.jabatan': 'Jabatan',
  'pernyataanform.errorNamaTtd': 'Nama TTD wajib diisi',
  'pernyataanform.errorTanggalTtd': 'Tanggal TTD wajib diisi',
  'pernyataanform.errorKotaTtd': 'Kota TTD wajib diisi',
  'pernyataanform.errorJabatanTtd': 'Jabatan TTD wajib diisi',
  'pernyataanform.notifySuccessTitle': 'Success',
  'pernyataanform.notifySuccessMessage': 'Pernyataan data synced successfully',
  'pernyataanform.notifyErrorTitle': 'Error',
  'pernyataanform.notifyErrorSyncMessage': 'Failed to sync pernyataan data',
  'pernyataanform.notifyErrorGeneralMessage': 'Error syncing pernyataan data',
  'pernyataanform.notifyNoStatementTitle': 'Pernyataan belum diatur',
  'pernyataanform.notifyNoStatementMessage':
    'Belum ada Pernyataan untuk PPJK Anda. Isi di Master → Pernyataan, lalu sinkronkan lagi.',

  // Subscription: free trial
  'subscription.trial.badge.active': 'Uji Coba Gratis',
  'subscription.trial.badge.ended': 'Uji Coba Berakhir',
  'subscription.trial.free': 'Gratis',
  'subscription.trial.endsOn': 'Uji Coba Berakhir',
  'subscription.trial.cost': 'Biaya',
  'subscription.trial.running.title': 'Uji coba gratis sedang berjalan',
  'subscription.trial.running.daysLeft': 'Sisa {n} hari.',
  'subscription.trial.running.endsToday': 'Uji coba berakhir hari ini.',
  'subscription.trial.running.body': 'Setelah berakhir, pengajuan baru akan terblokir sampai Anda berlangganan.',
  'subscription.trial.running.cta': 'Lihat paket berlangganan',
  'subscription.trial.header.daysLeft': 'Uji coba: {n} hari lagi',
  'subscription.trial.header.endsToday': 'Uji coba: hari terakhir',
  'subscription.trial.header.ended': 'Uji coba berakhir',
  'subscription.trial.strip.soon': 'Uji coba gratis berakhir dalam {n} hari.',
  'subscription.trial.strip.today': 'Uji coba gratis berakhir hari ini.',
  'subscription.trial.strip.ended': 'Uji coba gratis telah berakhir.',
  'subscription.trial.strip.soonDetail': 'Setelah itu pengajuan baru terblokir sampai Anda berlangganan.',
  'subscription.trial.strip.endedDetail': 'Pengajuan baru terblokir sampai Anda berlangganan.',
  'subscription.trial.contactSales': 'Hubungi Sales',
  'subscription.trial.contactSales.message':
    'Halo Sales Lumen, masa uji coba gratis perusahaan kami akan segera berakhir. Saya ingin berlangganan paket Lumen.',
  'subscription.trial.ended.title': 'Masa uji coba gratis telah berakhir',
  'subscription.trial.ended.body':
    'Akun Anda diblokir untuk pengajuan baru{since}. Tidak ada tagihan yang harus dibayar. Pilih paket berlangganan untuk melanjutkan layanan. Sisa kredit uji coba tidak dibawa ke paket berbayar.',
  'subscription.trial.ended.since': ' sejak {date}',
  'subscription.trial.ended.cta': 'Pilih paket berlangganan',
  'subscription.trial.picker.title': 'Lanjutkan dengan paket berbayar',
  'subscription.trial.picker.subtitleRunning':
    'Uji coba Anda masih berjalan. Berlangganan sekarang agar layanan tidak terputus saat masa uji coba berakhir. Sisa kredit uji coba tidak dibawa ke paket berbayar.',
  'subscription.trial.picker.subtitleEnded':
    'Masa uji coba telah berakhir dan akun Anda terblokir. Pilih paket di bawah untuk mengaktifkan kembali layanan.',
  'subscription.invoice.trialBadge': 'Uji Coba Gratis',
  'subscription.invoice.free': 'Gratis',
  // Subscription page + billing components
  'subscription.page.title': 'Langganan',
  'subscription.page.subtitle': 'Kelola paket langganan dan tagihan bulanan Anda',
  'subscription.page.loadingSubscription': 'Memuat data langganan...',
  'subscription.page.loadingPlans': 'Memuat paket langganan...',
  'subscription.common.error': 'Terjadi kesalahan',
  'subscription.card.title': 'Langganan',
  'subscription.card.currentPeriod': 'Periode Berjalan',
  'subscription.card.nextBilling': 'Tagihan Berikutnya',
  'subscription.card.pricePerMonth': 'Harga per Bulan',
  'subscription.card.quotaTitle': 'Kuota Kredit Bulanan',
  'subscription.card.col.product': 'Produk',
  'subscription.card.col.quotaPerPeriod': 'Kuota per Periode',
  'subscription.card.col.used': 'Terpakai',
  'subscription.card.col.balance': 'Saldo Saat Ini',
  'subscription.card.credits': 'kredit',
  'subscription.card.usedOf': '{used}/{quota} terpakai',
  'subscription.card.balanceError': 'Gagal memuat saldo kredit',
  'subscription.card.override': 'Khusus',
  'subscription.card.noQuota': 'Tidak ada kuota kredit pada paket ini',
  'subscription.status.active': 'Aktif',
  'subscription.status.pending': 'Menunggu Pembayaran',
  'subscription.status.unpaid': 'Belum Dibayar',
  'subscription.status.cancelled': 'Dibatalkan',
  'subscription.cancel.button': 'Batalkan Langganan',
  'subscription.cancel.confirm.title': 'Batalkan langganan?',
  'subscription.cancel.confirm.body':
    'Anda tetap dapat menggunakan kredit hingga {date}. Kartu Anda tidak akan ditagih lagi setelah langganan berakhir.',
  'subscription.cancel.confirm.titleImmediate': 'Batalkan langganan sekarang?',
  'subscription.cancel.confirm.bodyImmediate':
    'Langganan ini belum aktif karena tagihan pertama belum dibayar, jadi akan langsung dibatalkan. Tagihan yang menunggu pembayaran ikut dibatalkan, tidak ada penagihan, dan tidak ada kredit yang diberikan. Anda dapat berlangganan lagi kapan saja.',
  'subscription.cancel.toast.periodEnd.title': 'Berhasil',
  'subscription.cancel.toast.periodEnd.body':
    'Langganan tidak akan diperpanjang. Kredit tetap dapat digunakan hingga akhir periode.',
  'subscription.cancel.toast.immediate.title': 'Langganan dibatalkan',
  'subscription.cancel.toast.immediate.body': 'Tagihan yang menunggu pembayaran dibatalkan. Anda tidak ditagih.',
  'subscription.cancel.toast.error.title': 'Error',
  'subscription.cancel.toast.error.body': 'Gagal membatalkan langganan. Silakan coba lagi.',
  'subscription.cancel.confirm.back': 'Kembali',
  'subscription.cancel.confirm.confirm': 'Ya, batalkan',
  'subscription.cancel.endsOn': 'Berakhir {date}',
  'subscription.cancel.cancelling.title': 'Berhenti diperpanjang otomatis',
  'subscription.cancel.cancelling.body':
    'Langganan tetap aktif hingga {date}. Kartu tidak akan ditagih lagi. Berlangganan kembali kapan saja.',
  'subscription.cancel.cancelling.cta': 'Lihat paket',
  'subscription.cancel.picker.title': 'Berlangganan kembali',
  'subscription.cancel.picker.subtitle': 'Pilih paket untuk melanjutkan layanan.',
  'subscription.alert.unpaid.title': 'Akun diblokir - segera lakukan pembayaran',
  'subscription.alert.unpaid.body':
    'Langganan Anda belum dibayar{since}. Akun Anda diblokir sampai tagihan dilunasi. Silakan bayar tagihan tertunda di bagian Tagihan di bawah.',
  'subscription.alert.unpaid.since': ' sejak {date}',
  'subscription.alert.pending.title': 'Menunggu pembayaran',
  'subscription.alert.pending.body':
    'Langganan Anda akan aktif setelah tagihan pertama dibayar. Silakan selesaikan pembayaran di bagian Tagihan di bawah.',
  'subscription.picker.title': 'Pilih Paket Langganan',
  'subscription.picker.subtitle': 'Anda belum memiliki langganan. Pilih paket di bawah untuk mulai berlangganan.',
  'subscription.picker.empty': 'Tidak ada paket langganan tersedia saat ini.',
  'subscription.picker.perMonth': '/ bulan',
  'subscription.picker.periodDays': 'Periode {n} hari',
  'subscription.picker.accountPrice': 'Harga khusus akun Anda',
  'subscription.picker.includedCredits': 'Kredit Termasuk:',
  'subscription.picker.creditLine': '{n} kredit {product}',
  'subscription.picker.product': 'Produk #{id}',
  'subscription.picker.subscribe': 'Berlangganan',
  'subscription.invoices.title': 'Tagihan',
  'subscription.invoices.col.type': 'Tipe',
  'subscription.invoices.col.period': 'Periode',
  'subscription.invoices.col.amount': 'Jumlah',
  'subscription.invoices.col.status': 'Status',
  'subscription.invoices.col.action': 'Aksi',
  'subscription.invoices.type.initial': 'Tagihan Awal',
  'subscription.invoices.type.renewal': 'Perpanjangan',
  'subscription.invoices.status.pending': 'Menunggu Pembayaran',
  'subscription.invoices.status.paid': 'Lunas',
  'subscription.invoices.status.cancelled': 'Dibatalkan',
  'subscription.invoices.paidOn': 'Dibayar {date}',
  'subscription.invoices.priorAttempt': 'Terdapat instruksi pembayaran sebelumnya',
  'subscription.invoices.continuePayment': 'Lanjutkan Pembayaran',
  'subscription.invoices.pay': 'Bayar',
  'subscription.invoices.download': 'Unduh',
  'subscription.invoices.downloadError': 'Gagal mengunduh invoice. Silakan coba lagi.',
  'subscription.invoices.empty': 'Belum ada tagihan.',
  'subscription.banner.unpaid.title': 'Langganan Belum Dibayar',
  'subscription.banner.unpaid.body': 'Langganan Anda belum dibayar, akun diblokir untuk pengajuan baru.',
  'subscription.banner.unpaid.cta': 'Bayar Sekarang',
  'subscription.banner.trial.title': 'Masa Uji Coba Berakhir',
  'subscription.banner.trial.body': 'Masa uji coba gratis Anda telah berakhir, akun diblokir untuk pengajuan baru.',
  'subscription.banner.trial.cta': 'Pilih Paket',
  'subscription.banner.pending.title': 'Tagihan Menunggu Pembayaran',
  'subscription.banner.pending.body': 'Tagihan perpanjangan langganan menunggu pembayaran.',
  'subscription.banner.pending.cta': 'Bayar Perpanjangan',
  // Subscription payment modal
  'subscription.pay.title': 'Pembayaran Tagihan #{id}',
  'subscription.pay.subtotal': 'Subtotal',
  'subscription.pay.fee': 'Biaya layanan pembayaran',
  'subscription.pay.feeNotice': 'Biaya layanan pembayaran ditambahkan di atas subtotal dan dapat berbeda tiap metode.',
  'subscription.pay.total': 'Total Pembayaran:',
  'subscription.pay.method': 'Metode Pembayaran',
  'subscription.pay.method.va': 'Virtual Account',
  'subscription.pay.method.qris': 'QRIS',
  'subscription.pay.method.card': 'Kartu Kredit',
  'subscription.pay.method.unknown': 'Tidak diketahui',
  'subscription.pay.prior.title': 'Instruksi pembayaran sebelumnya tersedia',
  'subscription.pay.prior.body':
    'Anda sudah memulai pembayaran dengan metode {method}{bank}. Anda dapat menampilkan kembali instruksi tersebut atau membuat pembayaran baru dengan metode lain.',
  'subscription.pay.prior.cta': 'Tampilkan Instruksi Sebelumnya',
  'subscription.pay.selectBank': 'Pilih Bank',
  'subscription.pay.continue': 'Lanjut ke Pembayaran',
  'subscription.pay.va.transferTo': 'Transfer ke nomor Virtual Account di bawah ini:',
  'subscription.pay.va.note': 'Setelah transfer, pembayaran akan diproses secara otomatis dalam 1-5 menit.',
  'subscription.pay.copy': 'Salin',
  'subscription.pay.copied.title': 'Berhasil',
  'subscription.pay.copied.body': 'Disalin ke clipboard',
  'subscription.pay.qris.title': 'Scan QRIS',
  'subscription.pay.qris.body': 'Scan kode QR di bawah ini dengan aplikasi e-wallet Anda:',
  'subscription.pay.qris.unavailable': 'Gambar QR tidak tersedia',
  'subscription.pay.card.title': 'Pembayaran Kartu Kredit',
  'subscription.pay.card.open': 'Buka Halaman Pembayaran',
  'subscription.pay.card.unavailable': 'Link pembayaran tidak tersedia',
  'subscription.pay.waiting': 'Menunggu Pembayaran',
  'subscription.pay.polling': 'Status diperiksa otomatis setiap 5 detik',
  'subscription.pay.changeMethod': 'Ganti Metode Pembayaran',
  'subscription.pay.checkStatus': 'Periksa Status',
  'subscription.pay.success.title': 'Pembayaran Berhasil',
  'subscription.pay.success.body': 'Tagihan langganan Anda telah dibayar. Terima kasih!',
  'subscription.pay.success.notification': 'Tagihan langganan Anda telah dibayar.',
  'subscription.pay.close': 'Tutup',

  // Dashboard header notification bell (incoming CEISA email responses)
  'notifications.bell.title': 'Notifikasi',
  'notifications.bell.aria': 'Notifikasi respon email',
  'notifications.bell.markAllRead': 'Tandai semua terbaca',
  'notifications.bell.empty': 'Belum ada respon email masuk',
  'notifications.bell.emptyHint': 'Respon CEISA yang masuk akan muncul di sini',
  'notifications.bell.loading': 'Memuat notifikasi...',
  'notifications.bell.error': 'Gagal memuat notifikasi',
  'notifications.bell.retry': 'Coba lagi',
  'notifications.bell.unreadCount': 'belum dibaca',
  'notifications.bell.new': 'Baru',
  'notifications.bell.ajuNumber': 'Nomor AJU',
  'notifications.bell.filterAll': 'Semua',
  'notifications.bell.filterUnread': 'Belum dibaca',
  'notifications.bell.emptyUnread': 'Semua sudah terbaca',
  'notifications.bell.emptyUnreadHint': 'Tidak ada respon yang menunggu dibuka',
  'notifications.bell.urgent': 'Urgent',
  'notifications.bell.download': 'Unduh',
  'notifications.bell.downloading': 'Mengunduh',
  'notifications.bell.downloaded': 'berhasil diunduh',
  'notifications.bell.downloadFailed': 'Gagal mengunduh',
  'notifications.bell.sinceLastResponse': 'sejak respon terakhir',
  'notifications.bell.lastResponseAt': 'Respon terakhir',
  // Entity history check — the badge on each Entitas card and the suggestions
  // it offers. Plain words on purpose: never "AI" or "ekstraksi", always the
  // document and its date.
  'entitycheck.cocok': 'Cocok',
  'entitycheck.perluDiperiksa': 'Perlu diperiksa',
  'entitycheck.tidakDicek': 'Tidak dicek',
  'entitycheck.dariAkun': 'Dari akun Anda',
  'entitycheck.samaDenganDokumen': 'Sama dengan dokumen',
  'entitycheck.bedaDariDokumen': 'Berbeda dari dokumen',
  'entitycheck.cocokDariNama': 'cocok dari nama',
  'entitycheck.dokumen': 'Dokumen',
  'entitycheck.dokumenSebelumnya': 'Dokumen sebelumnya',
  'entitycheck.pakaiIni': 'Pakai ini',
  'entitycheck.biarkanSaja': 'Biarkan saja',
  'entitycheck.belumAda': 'Belum ada di sini',
  'entitycheck.tambahkan': 'Tambahkan',

  // ---- Info Kode HS (detail komoditas INSW) ----
  // Judul dan label memakai istilah yang sama dengan portal INSW supaya orang
  // yang terbiasa dengan portal itu mengenali panelnya tanpa menerjemahkan.
  'hsCodeInfo.title': 'Informasi Kode HS',
  'hsCodeInfo.kodeHs': 'Kode HS',
  'hsCodeInfo.tabTarif': 'Informasi Tarif',
  'hsCodeInfo.tabPreferensi': 'Tarif Preferensi',
  'hsCodeInfo.tabRegulasiImpor': 'Regulasi Impor',
  'hsCodeInfo.tabRegulasiEkspor': 'Regulasi Ekspor',
  'hsCodeInfo.lartasBorder': 'Regulasi Impor (Lartas Border)',
  'hsCodeInfo.tataNiagaPostBorder': 'Regulasi Impor (Tata Niaga Post Border)',
  'hsCodeInfo.regulasiImporUmum': 'Regulasi Impor (Umum)',
  'hsCodeInfo.lartasEkspor': 'Regulasi Ekspor (Lartas Ekspor)',
  'hsCodeInfo.kolNamaIzin': 'Nama Izin',
  'hsCodeInfo.kolKodeIzin': 'Kode Izin',
  'hsCodeInfo.kolDeskripsi': 'Deskripsi',
  'hsCodeInfo.kolDasarHukum': 'Dasar Hukum',
  'hsCodeInfo.kolMasaBerlaku': 'Masa Berlaku',
  'hsCodeInfo.kolKeterangan': 'Keterangan',
  'hsCodeInfo.kolDokumenPabean': 'Dokumen Pabean',
  'hsCodeInfo.kolUraianBarang': 'Uraian Barang',
  'hsCodeInfo.instansi': 'Instansi',
  'hsCodeInfo.sekarang': 'Sekarang',
  'hsCodeInfo.berlaku': 'Berlaku',
  'hsCodeInfo.terbaru': 'Terbaru',
  'hsCodeInfo.legacy': 'Lama',
  'hsCodeInfo.mfnTerbaru': 'Most Favored Nation (Terbaru)',
  'hsCodeInfo.mfn': 'Most Favored Nation',
  'hsCodeInfo.preferensiTerbaru': 'Tarif Preferensi (Terbaru)',
  'hsCodeInfo.preferensi': 'Tarif Preferensi',
  'hsCodeInfo.tarifPerTahun': 'Tarif per Tahun',
  'hsCodeInfo.lanjutan': 'Tarif berlanjut untuk tahun berikutnya',
  'hsCodeInfo.sda': 'SDA (Sumber Daya Alam)',
  'hsCodeInfo.tidakDiaturLartasBorder': 'Atas HS dimaksud tidak diatur dalam Lartas Border',
  'hsCodeInfo.tidakDiaturPostBorder': 'Atas HS dimaksud tidak diatur dalam Tata Niaga Post Border',
  'hsCodeInfo.tidakDiaturImporUmum': 'Atas HS dimaksud tidak diatur dalam Regulasi Impor Umum',
  'hsCodeInfo.tidakDiaturLartasEkspor': 'Atas HS dimaksud tidak diatur dalam Lartas Ekspor',
  // Dipakai saat INSW belum pernah menjawab untuk kode ini: kosong berarti "belum tahu",
  // bukan "tidak diatur".
  'hsCodeInfo.regulasiBelumTersedia': 'Data regulasi belum tersedia untuk kode ini',
  'hsCodeInfo.tidakAdaTarif': 'Data tarif MFN tidak tersedia',
  'hsCodeInfo.tidakAdaPreferensi': 'Tidak ada skema tarif preferensi untuk kode ini',
  'hsCodeInfo.tidakAdaData': 'Tidak ada data untuk kode HS ini',
  'hsCodeInfo.tidakDitemukan': 'Data untuk kode HS ini tidak ditemukan',
  'hsCodeInfo.kolNamaTarif': 'Nama Tarif',
  'hsCodeInfo.kolTarif': 'Tarif',
  'hsCodeInfo.kolRegulasi': 'Regulasi',
  'hsCodeInfo.tabUmum': 'Uraian Barang',
  'hsCodeInfo.tabLainnya': 'Informasi Lainnya',
  'hsCodeInfo.lartasYa': 'Lartas',
  'hsCodeInfo.lartasTidak': 'Non-Lartas',
  'hsCodeInfo.kodeNormal': 'Kode Ternormalisasi',
  'hsCodeInfo.uraianId': 'Uraian (ID)',
  'hsCodeInfo.uraianEn': 'Uraian (EN)',
  'hsCodeInfo.tahunInsw': 'Tahun INSW',
  'hsCodeInfo.kodeSatuan': 'Kode Satuan',
  'hsCodeInfo.spesifikasi': 'Spesifikasi Barang',
  'hsCodeInfo.cariPreferensi': 'Cari skema atau nomor PMK',
  'hsCodeInfo.dibandingMfn': 'Dibandingkan BM MFN {rate}',
  'hsCodeInfo.hematBm': 'Hemat {n}% BM',
  'hsCodeInfo.tidakLebihMurah': 'Tidak lebih murah dari MFN',
  'hsCodeInfo.preferensiTidakCocok': 'Tidak ada skema preferensi yang cocok dengan "{query}"',
  'hsCodeInfo.berlakuSeterusnya': 'Berlaku seterusnya',
  'hsCodeInfo.kedaluwarsa': 'Kedaluwarsa',
  'hsCodeInfo.belumBerlaku': 'Belum berlaku',
  'hsCodeInfo.bahasa': 'Bahasa',
  'hsCodeInfo.english': 'English',
  'hsCodeInfo.satuanBarang': 'Satuan Barang',
  'hsCodeInfo.kolKodeSatuan': 'Kode Satuan',
  'hsCodeInfo.kolUraianSatuan': 'Uraian Satuan',
  'hsCodeInfo.kolJenis': 'Jenis',
  'hsCodeInfo.gagalMuat': 'Gagal memuat detail kode HS',

  // ---- Master: Data Consignee ----
  'menu.dataConsignee': 'Data Consignee',
  'consignee.title': 'Data Consignee',
  'consignee.subtitle': 'Daftar importir yang Anda urus. Isi sekali, dipakai berulang di dokumen Anda.',
  'consignee.privacyTitle': 'Hanya untuk PPJK Anda',
  'consignee.tabOwn': 'PPJK Saya',
  'consignee.tabGlobal': 'Semua PPJK',
  'consignee.colPpjk': 'PPJK',
  'consignee.globalNoticeTitle': 'Tampilan internal, hanya baca',
  'consignee.globalNotice':
    'Daftar consignee dari semua PPJK, hanya terlihat oleh super admin. Untuk menambah atau mengubah consignee, masuk sebagai PPJK pemiliknya.',
  'consignee.globalSearchPlaceholder': 'Cari consignee, NPWP, atau PPJK',
  'consignee.privacyBody':
    'Daftar ini tersimpan khusus untuk {company} (NPWP {npwp}). Tidak dibagikan ke PPJK lain, tidak dipakai untuk melatih apa pun, dan hanya dipakai untuk mengisi dokumen Anda.',
  'consignee.yourPpjk': 'PPJK Anda',
  'consignee.noPpjkTitle': 'NPWP PPJK belum ada',
  'consignee.noPpjkMsg': 'Akun Anda belum terhubung ke PPJK. Hubungi administrator Anda.',
  'consignee.loadFailedTitle': 'Gagal memuat',
  'consignee.loadFailedMsg': 'Daftar consignee belum bisa dimuat. Coba lagi beberapa saat.',
  'consignee.searchPlaceholder': 'Cari nama atau NPWP',
  'consignee.total': '{n} consignee',
  'consignee.template': 'Template',
  'consignee.exportCurrent': 'Unduh data saat ini',
  'consignee.uploadExcel': 'Unggah Excel',
  'consignee.uploadIntro':
    'Unduh template, isi di Excel, lalu unggah kembali. Anda akan melihat apa yang akan berubah sebelum data disimpan.',
  'consignee.add': 'Tambah',
  'consignee.addTitle': 'Tambah Consignee',
  'consignee.editTitle': 'Ubah Consignee',
  'consignee.emptyTitle': 'Belum ada consignee',
  'consignee.emptyHint': 'Tambah satu per satu, atau unggah sekaligus dari Excel.',
  'consignee.colNama': 'Nama Consignee',
  'consignee.colNpwp': 'NPWP',
  'consignee.colAlamat': 'Alamat',
  'consignee.colNib': 'NIB',
  'consignee.colJenisApi': 'Jenis API',
  'consignee.colStatus': 'Status',
  'consignee.colSumber': 'Sumber',
  'consignee.colDiperbarui': 'Diperbarui',
  'consignee.colAksi': 'Aksi',
  'consignee.sourceExcel': 'Excel',
  'consignee.sourceManual': 'Manual',
  'consignee.sourceCeisa': 'CEISA',
  'consignee.edit': 'Ubah',
  'consignee.delete': 'Hapus',
  'consignee.cancel': 'Batal',
  'consignee.save': 'Simpan',
  'consignee.create': 'Tambah',
  'consignee.unknown': 'Tidak diketahui',
  'consignee.npwpHint': '15 atau 16 digit. Titik dan strip boleh diketik, akan dirapikan otomatis.',
  'consignee.npwpStoredAs': 'Akan disimpan sebagai {npwp}',
  'consignee.npwpInvalid': 'NPWP harus 15 atau 16 digit',
  'consignee.nibInvalid': 'NIB harus 13 digit angka',
  'consignee.formInvalidTitle': 'Periksa isian',
  'consignee.formInvalidMsg': 'Nama dan NPWP wajib diisi dengan benar.',
  'consignee.savedTitle': 'Tersimpan',
  'consignee.createdMsg': 'Consignee ditambahkan.',
  'consignee.updatedMsg': 'Consignee diperbarui.',
  'consignee.existsMsg': 'NPWP ini sudah ada di daftar Anda. Ubah data yang ada, bukan menambah baru.',
  'consignee.saveFailedTitle': 'Gagal menyimpan',
  'consignee.saveFailedMsg': 'Consignee belum tersimpan. Coba lagi.',
  'consignee.deleteTitle': 'Hapus Consignee',
  'consignee.deleteConfirm': 'Hapus {nama} dari daftar Anda? Data ini tidak akan muncul lagi di dokumen baru.',
  'consignee.deletedTitle': 'Dihapus',
  'consignee.deletedMsg': 'Consignee dihapus dari daftar.',
  'consignee.deleteFailedMsg': 'Consignee belum terhapus. Coba lagi.',
  'consignee.downloadFailedTitle': 'Gagal mengunduh',
  'consignee.downloadFailedMsg': 'File belum bisa diunduh. Coba lagi beberapa saat.',
  'consigneeImport.dropTitle': 'Tarik file Excel ke sini',
  'consigneeImport.dropHint': 'Satu file .xlsx, maksimal 5.000 baris',
  'consigneeImport.chooseFile': 'Pilih file',
  'consigneeImport.onlyXlsx': 'Gunakan satu file Excel (.xlsx) dari template.',
  'consigneeImport.reading': 'Membaca {file}',
  'consigneeImport.previewFailed': 'File belum bisa dibaca',
  'consigneeImport.previewStale': 'Data Consignee berubah, pratinjau mungkin tidak sesuai',
  'consigneeImport.reloadPreview': 'Muat ulang pratinjau',
  'consigneeImport.chooseOther': 'Pilih file lain',
  'consigneeImport.rowsSeen': '{n} baris',
  'consigneeImport.rowLabel': 'Baris {n}',
  'consigneeImport.actionNew': 'baru',
  'consigneeImport.actionUpdated': 'diperbarui',
  'consigneeImport.actionUnchanged': 'tidak berubah',
  'consigneeImport.actionRejected': 'dilewati',
  'consigneeImport.neverDeletes':
    'Unggahan tidak pernah menghapus data. Baris yang tidak ada di file dibiarkan apa adanya; sel kosong tidak menimpa nilai yang sudah ada.',
  'consigneeImport.importN': 'Impor {n} baris',
  'consigneeImport.importedTitle': 'Impor selesai',
  'consigneeImport.importedMsg': '{new} baru, {updated} diperbarui.',
  'consigneeImport.resultLine': '{new} baru, {updated} diperbarui, {unchanged} tidak berubah.',
  'consigneeImport.rejectedTitle': 'Baris yang dilewati',
  'consigneeImport.failedTitle': 'Impor gagal',
  'consigneeImport.failedMsg': 'Data belum tersimpan. Coba lagi.',
  'consigneeImport.uploadAnother': 'Unggah file lain',
  'menu.dataEksportir': 'Data Eksportir',
  'eksportir.title': 'Data Eksportir',
  'eksportir.subtitle': 'Daftar eksportir yang Anda urus. Isi sekali, dipakai berulang di dokumen PEB Anda.',
  'eksportir.privacyTitle': 'Hanya untuk PPJK Anda',
  'eksportir.tabOwn': 'PPJK Saya',
  'eksportir.tabGlobal': 'Semua PPJK',
  'eksportir.colPpjk': 'PPJK',
  'eksportir.globalNoticeTitle': 'Tampilan internal, hanya baca',
  'eksportir.globalNotice':
    'Daftar eksportir dari semua PPJK, hanya terlihat oleh super admin. Untuk menambah atau mengubah eksportir, masuk sebagai PPJK pemiliknya.',
  'eksportir.globalSearchPlaceholder': 'Cari eksportir, nomor identitas, atau PPJK',
  'eksportir.privacyBody':
    'Daftar ini tersimpan khusus untuk {company} (NPWP {npwp}). Tidak dibagikan ke PPJK lain, tidak dipakai untuk melatih apa pun, dan hanya dipakai untuk mengisi dokumen Anda.',
  'eksportir.yourPpjk': 'PPJK Anda',
  'eksportir.noPpjkTitle': 'NPWP PPJK belum ada',
  'eksportir.noPpjkMsg': 'Akun Anda belum terhubung ke PPJK. Hubungi administrator Anda.',
  'eksportir.loadFailedTitle': 'Gagal memuat',
  'eksportir.loadFailedMsg': 'Daftar eksportir belum bisa dimuat. Coba lagi beberapa saat.',
  'eksportir.searchPlaceholder': 'Cari nama atau nomor identitas',
  'eksportir.total': '{n} eksportir',
  'eksportir.template': 'Template',
  'eksportir.exportCurrent': 'Unduh data saat ini',
  'eksportir.uploadExcel': 'Unggah Excel',
  'eksportir.uploadIntro':
    'Unduh template, isi di Excel, lalu unggah kembali. Anda akan melihat apa yang akan berubah sebelum data disimpan.',
  'eksportir.add': 'Tambah',
  'eksportir.addTitle': 'Tambah Eksportir',
  'eksportir.editTitle': 'Ubah Eksportir',
  'eksportir.emptyTitle': 'Belum ada eksportir',
  'eksportir.emptyHint': 'Tambah satu per satu, atau unggah sekaligus dari Excel.',
  'eksportir.colNama': 'Nama Eksportir',
  'eksportir.colIdentitas': 'Identitas',
  'eksportir.colJenisIdentitas': 'Jenis Identitas',
  'eksportir.colNomorIdentitas': 'Nomor Identitas',
  'eksportir.colAlamat': 'Alamat',
  'eksportir.colStatus': 'Status',
  'eksportir.colSumber': 'Sumber',
  'eksportir.colDiperbarui': 'Diperbarui',
  'eksportir.colAksi': 'Aksi',
  'eksportir.sourceExcel': 'Excel',
  'eksportir.sourceManual': 'Manual',
  'eksportir.sourceCeisa': 'CEISA',
  'eksportir.edit': 'Ubah',
  'eksportir.delete': 'Hapus',
  'eksportir.cancel': 'Batal',
  'eksportir.save': 'Simpan',
  'eksportir.create': 'Tambah',
  'eksportir.unknown': 'Tidak diketahui',
  'eksportir.namaPlaceholder': 'PT. CONTOH',
  'eksportir.npwpHint': '15 atau 16 digit. Titik dan strip boleh diketik, akan dirapikan otomatis.',
  'eksportir.identitasHint': 'Hanya angka. Karakter lain dibuang otomatis.',
  'eksportir.identitasStoredAs': 'Akan disimpan sebagai {nomor}',
  'eksportir.npwpInvalid': 'NPWP harus 15 atau 16 digit',
  'eksportir.ktpInvalid': 'KTP harus 16 digit angka',
  'eksportir.identitasEmpty': 'Nomor identitas harus berisi angka',
  'eksportir.identitasTooLong': 'Nomor identitas maksimal 50 digit',
  'eksportir.formInvalidTitle': 'Periksa isian',
  'eksportir.formInvalidMsg': 'Nama dan nomor identitas wajib diisi dengan benar.',
  'eksportir.savedTitle': 'Tersimpan',
  'eksportir.createdMsg': 'Eksportir ditambahkan.',
  'eksportir.updatedMsg': 'Eksportir diperbarui.',
  'eksportir.existsMsg': 'Identitas ini sudah ada di daftar Anda. Ubah data yang ada, bukan menambah baru.',
  'eksportir.saveFailedTitle': 'Gagal menyimpan',
  'eksportir.saveFailedMsg': 'Eksportir belum tersimpan. Coba lagi.',
  'eksportir.deleteTitle': 'Hapus Eksportir',
  'eksportir.deleteConfirm': 'Hapus {nama} dari daftar Anda? Data ini tidak akan muncul lagi di dokumen baru.',
  'eksportir.deletedTitle': 'Dihapus',
  'eksportir.deletedMsg': 'Eksportir dihapus dari daftar.',
  'eksportir.deleteFailedMsg': 'Eksportir belum terhapus. Coba lagi.',
  'eksportir.downloadFailedTitle': 'Gagal mengunduh',
  'eksportir.downloadFailedMsg': 'File belum bisa diunduh. Coba lagi beberapa saat.',
  'eksportir.jenis.2': 'PASPOR',
  'eksportir.jenis.3': 'KTP',
  'eksportir.jenis.4': 'LAINNYA',
  'eksportir.jenis.5': 'NPWP 15 DIGIT',
  'eksportir.jenis.6': 'NPWP 16 DIGIT',
  'eksportir.jenis.npwp': 'NPWP',
  'eksportir.status.1': 'KOPERASI',
  'eksportir.status.2': 'PMDN (MIGAS)',
  'eksportir.status.3': 'PMDN (NON MIGAS)',
  'eksportir.status.4': 'PMA (MIGAS)',
  'eksportir.status.5': 'PMA (NON MIGAS)',
  'eksportir.status.6': 'BUMN',
  'eksportir.status.7': 'BUMD',
  'eksportir.status.8': 'SWASTA',
  'eksportir.status.9': 'JOINT VENTURE',
  'eksportir.status.10': 'LAINNYA',
  'eksportirImport.dropTitle': 'Tarik file Excel ke sini',
  'eksportirImport.dropHint': 'Satu file .xlsx, maksimal 5.000 baris',
  'eksportirImport.chooseFile': 'Pilih file',
  'eksportirImport.onlyXlsx': 'Gunakan satu file Excel (.xlsx) dari template.',
  'eksportirImport.reading': 'Membaca {file}',
  'eksportirImport.previewFailed': 'File belum bisa dibaca',
  'eksportirImport.previewStale': 'Data Eksportir berubah, pratinjau mungkin tidak sesuai',
  'eksportirImport.reloadPreview': 'Muat ulang pratinjau',
  'eksportirImport.chooseOther': 'Pilih file lain',
  'eksportirImport.rowsSeen': '{n} baris',
  'eksportirImport.rowLabel': 'Baris {n}',
  'eksportirImport.actionNew': 'baru',
  'eksportirImport.actionUpdated': 'diperbarui',
  'eksportirImport.actionUnchanged': 'tidak berubah',
  'eksportirImport.actionRejected': 'dilewati',
  'eksportirImport.neverDeletes':
    'Unggahan tidak pernah menghapus data. Baris yang tidak ada di file dibiarkan apa adanya; sel kosong tidak menimpa nilai yang sudah ada.',
  'eksportirImport.importN': 'Impor {n} baris',
  'eksportirImport.importedTitle': 'Impor selesai',
  'eksportirImport.importedMsg': '{new} baru, {updated} diperbarui.',
  'eksportirImport.resultLine': '{new} baru, {updated} diperbarui, {unchanged} tidak berubah.',
  'eksportirImport.rejectedTitle': 'Baris yang dilewati',
  'eksportirImport.failedTitle': 'Impor gagal',
  'eksportirImport.failedMsg': 'Data belum tersimpan. Coba lagi.',
  'eksportirImport.uploadAnother': 'Unggah file lain',
  'eksportirCard.dataEksportir': 'Data Eksportir',
  'eksportirCard.dibukaDiTabBaru': 'Dibuka di tab baru: Master › Data Eksportir',
  'eksportirCard.belumAda':
    'Belum ada di Data Eksportir. Tersimpan otomatis setelah dokumen berhasil dikirim ke CEISA.',
  'eksportirCard.buka': 'Buka Data Eksportir',
  'eksportirCard.simpan': 'Simpan ke Data Eksportir',
  'eksportirCard.simpanHint': 'Simpan eksportir ini agar terisi otomatis di dokumen berikutnya.',
  'eksportirCard.tersimpan': 'Tersimpan ke Data Eksportir',
  'eksportirCard.tersimpanMsg': 'Eksportir ini akan terisi otomatis dari nomor identitasnya mulai sekarang.',
  'eksportirCard.sudahAda': 'Identitas ini sudah ada di Data Eksportir.',
  'eksportirCard.gagalSimpan': 'Gagal menyimpan ke Data Eksportir.',
  'eksportirCard.diterapkanTitle': 'Diterapkan',
  'eksportirCard.diterapkanMsg': 'Data Eksportir diterapkan ke Eksportir.',
  'statement.updatedBy': 'Diperbarui oleh {email} pada {date}',
  'statement.utama': 'Utama',
  'statement.tabOwn': 'PPJK Saya',
  'statement.tabGlobal': 'Semua PPJK',
  'statement.staleSessionTitle': 'PPJK akun Anda sudah berubah',
  'statement.staleSessionMsg':
    'Browser ini masih menyimpan PPJK lama ({stored}). Akun Anda sekarang terhubung ke {current}, dan itulah yang ditampilkan di sini dan dipakai draft Anda. Keluar lalu masuk lagi agar bagian lain aplikasi ikut menyesuaikan.',
  'statement.jadikanUtama': 'Jadikan utama',
  'statement.jadikanUtamaBerhasil': '{name} sekarang menjadi Pernyataan utama untuk draft baru.',
  'statement.jadikanUtamaGagal': 'Gagal menjadikan utama',
  'statement.nonaktifkanUtamaJudul': 'Nonaktifkan Pernyataan utama?',
  'statement.nonaktifkanUtamaPesan':
    'Pernyataan aktif lain yang paling awal dibuat akan otomatis menjadi utama untuk draft baru.',
  'statement.nonaktifkanUtamaTanpaPengganti':
    'Tidak ada Pernyataan aktif lain. Draft baru tidak akan terisi Pernyataan secara otomatis.',
  'statement.nonaktifkan': 'Nonaktifkan',
  'statement.batal': 'Batal',
  'statement.konflikJudul': 'Pernyataan baru saja diperbarui oleh rekan Anda',
  'statement.konflikDiperbaruiOleh': 'Diperbarui oleh {email} pada {date}',
  'statement.konflikDiperbaruiPada': 'Diperbarui pada {date}',
  'statement.kolomTempat': 'Tempat',
  'statement.kolomNama': 'Nama',
  'statement.kolomJabatan': 'Jabatan',
  'statement.konflikMuatUlang': 'Muat ulang',
  'statement.konflikTimpa': 'Timpa',
  'statement.konflikGagalMemuat': 'Data terbaru belum bisa dimuat.',
  'statement.konflikMuatUlangDaftar': 'Muat ulang daftar',
  'pernyataanform.pilihPernyataan': 'Pilih Pernyataan',
  'pernyataanform.pilihPernyataanPlaceholder': 'Pilih dari Master › Pernyataan',
  'pernyataanform.diubahManual': 'Nilai saat ini diubah manual',
  'settings.sectionTampilan': 'Tampilan',
  'settings.theme': 'Tema',
  'settings.themeDesc': 'Warna tampilan aplikasi. Berlaku untuk akun Anda saja.',
  'settings.language': 'Bahasa',
  'settings.languageDesc': 'Bahasa menu dan teks aplikasi.',
  'settings.textSize': 'Ukuran teks',
  'settings.textSizeDesc': 'Perbesar teks dan tombol di seluruh aplikasi.',
  'settings.textSizeNormal': 'Normal',
  'settings.textSizeLarge': 'Besar',
  'settings.textSizeLarger': 'Lebih besar',
  'settings.textSizePreview': 'Contoh: Nomor Aju 000020-001234-20260915-000041, Importir PT. CEMANI TOKA, Status SPPB.',
  'settings.textSizeNote':
    'Perubahan langsung terlihat. Beberapa tabel yang padat akan terasa lebih rapat pada ukuran terbesar.',

  // ---- Riwayat perubahan draf (drawer "Audit Logs" di halaman edit) ----
  'docpabean.audit.title': 'Riwayat Perubahan',
  'docpabean.audit.refresh': 'Muat ulang',
  'docpabean.audit.count': '{n} perubahan',
  'docpabean.audit.loadMore': 'Muat lebih banyak ({n} lagi)',
  'docpabean.audit.unavailable': 'Riwayat belum tersedia untuk draf ini.',
  'docpabean.audit.subtitle.batch': 'Batch {uuid}',
  'docpabean.audit.subtitle.none': 'Draf belum tersimpan',
  'docpabean.audit.systemActor': 'Sistem',
  'docpabean.audit.rowCount': '{n} baris',
  'docpabean.audit.empty': '(kosong)',
  'docpabean.audit.yes': 'Ya',
  'docpabean.audit.no': 'Tidak',
  'docpabean.audit.addedEntity': 'Ditambahkan: {entity}',
  'docpabean.audit.removedEntity': 'Dihapus: {entity}',
  'docpabean.audit.showMoreFields': 'Lihat {n} lainnya',
  'docpabean.audit.hideMoreFields': 'Sembunyikan',
  'docpabean.audit.showMoreValue': 'selengkapnya',
  'docpabean.audit.showLessValue': 'lebih sedikit',
  'docpabean.audit.filter.tab.all': 'Semua',
  'docpabean.audit.filteredEmpty': 'Tidak ada perubahan pada tab ini.',
  'docpabean.audit.empty.title': 'Belum ada riwayat',
  'docpabean.audit.empty.body': 'Perubahan pada draf ini akan tampil di sini.',
  'docpabean.audit.error.title': 'Gagal memuat riwayat',
  'docpabean.audit.error.body': 'Riwayat tidak dapat dimuat. Coba lagi sebentar lagi.',
  'docpabean.audit.error.retry': 'Coba lagi',
  'docpabean.audit.notFound.title': 'Riwayat tidak ditemukan',
  'docpabean.audit.notFound.body': 'Draf ini tidak tersedia untuk akun Anda.',
  'docpabean.audit.forbidden.title': 'Akun belum terhubung PPJK',
  'docpabean.audit.forbidden.body': 'Akun Anda belum terhubung ke PPJK, sehingga riwayat draf tidak dapat ditampilkan.',
  'docpabean.audit.day.today': 'Hari ini',
  'docpabean.audit.day.yesterday': 'Kemarin',
  'docpabean.audit.day.unknown': 'Tanggal tidak diketahui',
  'docpabean.audit.time.justNow': 'Baru saja',
  'docpabean.audit.time.minutesAgo': '{n} menit lalu',
  'docpabean.audit.time.hoursAgo': '{n} jam lalu',
  'docpabean.audit.time.daysAgo': '{n} hari lalu',
  'docpabean.audit.time.monthsAgo': '{n} bulan lalu',
  'docpabean.audit.time.yearsAgo': '{n} tahun lalu',
  'docpabean.audit.time.unknown': 'Waktu tidak diketahui',
  // Ekstraksi AI tampil sebagai tiga tonggak saja: tanpa jumlah, tanpa nama
  // field, tanpa nilai.
  'docpabean.audit.milestone.extractionStarted': 'Ekstraksi AI dimulai oleh {name}',
  'docpabean.audit.milestone.extractionStartedAnon': 'Ekstraksi AI dimulai',
  'docpabean.audit.milestone.extractionCompleted': 'Ekstraksi AI selesai',
  'docpabean.audit.milestone.extractionFailed': 'Ekstraksi AI gagal',
  'docpabean.audit.milestone.submitDraft': '{name} mengirim draf',
  'docpabean.audit.milestone.submitFinal': '{name} mengirim dokumen final',
  'docpabean.audit.milestone.draftDeleted': '{name} menghapus draf',
  'docpabean.audit.milestone.documentFileUploaded': '{name} mengunggah berkas {file}',
  'docpabean.audit.milestone.documentFileUploadedAnon': 'Berkas {file} diunggah',
  'docpabean.audit.import.full': 'Excel · Full',
  'docpabean.audit.import.barangOnly': 'Excel · Barang Only',
  'docpabean.audit.import.allTabs': 'Semua tab',
  'docpabean.audit.import.otherTab': 'Tanpa tab',
  'docpabean.audit.import.added': '{n} ditambah',
  'docpabean.audit.import.changed': '{n} diubah',
  'docpabean.audit.import.removed': '{n} dihapus',
  'docpabean.audit.import.fields': '{n} field',
  'docpabean.audit.import.noChanges': 'Tidak ada perubahan',
  'docpabean.audit.import.goodsReplaced': 'Daftar barang diganti sesuai isi file',
  'docpabean.audit.import.showPerTab': 'Lihat perubahan per tab',
  'docpabean.audit.import.hidePerTab': 'Sembunyikan perubahan per tab',
  'docpabean.audit.import.truncated': 'Menampilkan 300 baris pertama',
  'docpabean.audit.action.UPDATE': 'Diubah',
  'docpabean.audit.action.CREATE': 'Ditambahkan',
  'docpabean.audit.action.DELETE': 'Dihapus',
  'docpabean.audit.action.HISTORICAL_SYNC': 'Disalin dari riwayat',
  'docpabean.audit.action.AI_APPLIED': 'Diisi AI',
  'docpabean.audit.action.EXTRACTION_REQUESTED': 'Ekstraksi AI dimulai',
  'docpabean.audit.action.EXTRACTION_COMPLETED': 'Ekstraksi AI selesai',
  'docpabean.audit.action.EXTRACTION_FAILED': 'Ekstraksi AI gagal',
  'docpabean.audit.action.SUBMIT_DRAFT': 'Draf dikirim',
  'docpabean.audit.action.SUBMIT_FINAL': 'Dokumen final dikirim',
  'docpabean.audit.action.DRAFT_DELETED': 'Draf dihapus',
  'docpabean.audit.action.BULK_SUMMARY': 'Perubahan massal',
  'docpabean.audit.action.EXCEL_IMPORT': 'Unggah Excel',
  'docpabean.audit.entity.header': 'Header',
  'docpabean.audit.entity.entity': 'Entitas',
  'docpabean.audit.entity.document': 'Dokumen',
  'docpabean.audit.entity.carrier': 'Pengangkut',
  'docpabean.audit.entity.peti_kemas': 'Peti kemas',
  'docpabean.audit.entity.kemasan': 'Kemasan',
  'docpabean.audit.entity.transaksi': 'Transaksi',
  'docpabean.audit.entity.barang': 'Barang',
  'docpabean.audit.entity.statement': 'Pernyataan',
  'docpabean.audit.entity.process': 'Proses',
  'docpabean.audit.entity.barang_vd': 'Jenis transaksi',
  'docpabean.audit.field.barang_vd.kodeJenisVd': 'Jenis transaksi',
  'docpabean.audit.field.barang_vd.nilaiBarangVd': 'Nilai VD',
  // A customs term, not UI copy: the CEISA form prints these words, so they are
  // the same in every language block rather than translated out of the document.
  'docpabean.audit.value.kondisiBarang1': 'Barang Baru',
  'docpabean.audit.value.kondisiBarang2': 'Bukan Barang Baru',
  'docpabean.audit.value.jenisApi01': 'API U',
  'docpabean.audit.value.jenisApi02': 'API P',
  'docpabean.audit.tab.header': 'Header',
  'docpabean.audit.tab.entitas': 'Entitas',
  'docpabean.audit.tab.dokumen': 'Dokumen',
  'docpabean.audit.tab.pengangkut': 'Pengangkut',
  'docpabean.audit.tab.kemasan': 'Kemasan & Peti Kemas',
  'docpabean.audit.tab.transaksi': 'Transaksi',
  'docpabean.audit.tab.barang': 'Barang',
  'docpabean.audit.tab.pungutan': 'Pungutan',
  'docpabean.audit.tab.pernyataan': 'Pernyataan',

  // ---- Komponen UI Lumen (src/components/lumen: label tombol dan aksesibilitas) ----
  // ---- Lumen shell: top bar ----
  'lumen.topbar.openMenu': 'Buka menu navigasi',
  'lumen.topbar.switchToLight': 'Ganti ke mode terang',
  'lumen.topbar.switchToDark': 'Ganti ke mode gelap',
  'lumen.topbar.account': 'Akun',
  'lumen.topbar.impersonateDescription': 'Cari pengguna lalu masuk sebagai dia. Halaman dimuat ulang setelahnya.',
  'lumen.close': 'Tutup',
  'lumen.pagination.label': 'Navigasi halaman',
  'lumen.pagination.previous': 'Sebelumnya',
  'lumen.pagination.next': 'Berikutnya',
  'lumen.pagination.previousPage': 'Ke halaman sebelumnya',
  'lumen.pagination.nextPage': 'Ke halaman berikutnya',
  'lumen.pagination.morePages': 'Halaman lainnya',

  // ---- Lumen table system (src/components/data-table) ----
  // The first six replace the old SharedDataTable / mantine-datatable copy.
  'lumen.table.pageSize': 'Baris per halaman',
  'lumen.table.range': '{from} - {to} / {total}',
  'lumen.table.loading': 'Memuat data...',
  'lumen.table.noRecords': 'Tidak ada data',
  'lumen.table.emptyTitle': 'Belum ada data',
  'lumen.table.emptyDescription': 'Saat ini tidak ada data untuk ditampilkan.',
  'lumen.table.pageLink': 'Halaman {n}',
  'lumen.table.selected': '{n} dipilih',
  'lumen.table.clearSelection': 'Batalkan pilihan',
  'lumen.table.selectAll': 'Pilih semua baris di halaman ini',
  'lumen.table.selectRow': 'Pilih baris',
  'lumen.table.selectRowNamed': 'Pilih {name}',
  'lumen.table.search': 'Cari',
  'lumen.table.columns': 'Kolom',
  'lumen.table.resetColumns': 'Kembalikan kolom',
  'lumen.table.filter': 'Filter',
  'lumen.table.hideFilter': 'Sembunyikan filter',
  'lumen.table.resetFilters': 'Reset',
  'lumen.table.activeFilters': 'Filter aktif',
  'lumen.table.removeFilter': 'Hapus filter {label}',
  'lumen.table.clearFilters': 'Hapus semua filter',

  // ---- Lumen common copy (shared parts cleanup) ----
  // Words more than one list page uses. Each value is the value of the page key it replaces, in this
  // language (those were the old pages' literals, verbatim in every language): `cancel` / `save` are the
  // master pages' "Cancel" / "Save", `batal` / `simpan` the approval pages' "Batal" / "Simpan".
  'lumen.common.actions': 'Actions',
  'lumen.common.active': 'Active',
  'lumen.common.inactive': 'Inactive',
  'lumen.common.status': 'Status',
  'lumen.common.edit': 'Edit',
  'lumen.common.deactivate': 'Deactivate',
  'lumen.common.viewDetails': 'View Details',
  'lumen.common.create': 'Create',
  'lumen.common.save': 'Save',
  'lumen.common.cancel': 'Cancel',
  'lumen.common.simpan': 'Simpan',
  'lumen.common.batal': 'Batal',
  'lumen.common.update': 'Update',
  'lumen.common.success': 'Success',
  'lumen.common.error': 'Error',
  'lumen.common.requiredFields': 'Please fill in all required fields',
  'lumen.common.total': 'Total: {n} records',
  'lumen.common.name': 'Name',
  'lumen.common.email': 'Email',
  'lumen.common.emailPlaceholder': 'email@example.com',
  'lumen.common.username': 'Username',
  'lumen.common.password': 'Password',
  'lumen.common.editEmail': 'Edit Email',
  'lumen.common.motType': 'MOT Type',
  'lumen.common.ppjk': 'PPJK: {n}',
  'lumen.common.ppjkNpwp': 'PPJK NPWP',
  'lumen.common.ppjkRequiredTitle': 'PPJK NPWP Required',
  'lumen.common.ppjkRequiredBody': 'No PPJK NPWP found for your account. Please contact your administrator.',

  // ---- Lumen chart parts (dashboards PR 5) ----
  // Labels the chart parts in src/components/charts add, translated (like lumen.table.*).
  'lumen.chart.updating': 'Memperbarui…',

  // ---- Lumen /dashboard (dashboards PR 5) ----
  // The old page's literal text, verbatim in every language (copy unchanged). {error}, {n}, {v} and {pct} are
  // filled with formatTemplate.
  'lumen.dashboard.title': 'Operational Dashboard',
  'lumen.dashboard.subtitle': 'Overview aktivitas, performa, dan tren operasional',
  'lumen.dashboard.selectPpjk': 'Select PPJK',
  'lumen.dashboard.ppjkNotFound': 'PPJK tidak ditemukan',
  'lumen.dashboard.pickStartDate': 'Pick start date',
  'lumen.dashboard.pickEndDate': 'Pick end date',
  'lumen.dashboard.loading': 'Loading dashboard...',
  'lumen.dashboard.error': 'Error: {error}',
  'lumen.dashboard.graphView': 'Graph View',
  'lumen.dashboard.userStats': 'User Stats',
  'lumen.dashboard.loadingCharts': 'Loading charts...',
  'lumen.dashboard.loadingStats': 'Loading stats...',
  'lumen.dashboard.usageTrend': 'Usage Trend',
  'lumen.dashboard.usageTrendDescription': 'Daily AJU submissions over time',
  'lumen.dashboard.loadingGraph': 'Loading graph data...',
  'lumen.dashboard.noGraphData': 'No graph data available for the selected date range.',
  'lumen.dashboard.ajuCount': '{n} AJU',
  'lumen.dashboard.totalAju': 'Total AJU',
  'lumen.dashboard.dailyAverage': 'Daily Average',
  'lumen.dashboard.peakDay': 'Peak Day',
  'lumen.dashboard.loadingUserStats': 'Loading user stats...',
  'lumen.dashboard.noUserStats': 'No user statistics available for the selected date range.',
  'lumen.dashboard.totalUsers': 'Total Users',
  'lumen.dashboard.avgPerUser': 'Avg per User',
  'lumen.dashboard.topPerformance': 'Top Performance',
  'lumen.dashboard.userPerformance': 'User Performance',
  'lumen.dashboard.topN': 'Top {n}',
  'lumen.dashboard.distribution': 'Distribution',
  'lumen.dashboard.others': 'Others',
  'lumen.dashboard.ajuShare': '{v} AJU ({pct}%)',
  'lumen.dashboard.topPerformers': 'Top Performers',
  'lumen.dashboard.rank': '#{n}',

  // ---- Lumen master/email ----
  // The old page's literal English, verbatim in every language (copy unchanged).
  'lumen.masterEmail.searchPlaceholder': 'Search by email...',
  'lumen.masterEmail.add': 'Add Email',
  'lumen.masterEmail.emailType': 'Email Type',
  'lumen.masterEmail.branch': 'Branch',
  'lumen.masterEmail.emailPlaceholder': 'user@example.com',
  'lumen.masterEmail.updated': 'Email updated successfully',
  'lumen.masterEmail.updateFailed': 'Failed to update email',
  'lumen.masterEmail.created': 'Email created successfully',
  'lumen.masterEmail.createFailed': 'Failed to create email',
  'lumen.masterEmail.emailRequired': 'Please fill in the email field',
  'lumen.masterEmail.deactivated': 'Email deactivated successfully',
  'lumen.masterEmail.deactivateFailed': 'Failed to deactivate email',

  // ---- Lumen auth ----
  // Sign-in, MFA dialogs and the reviewer sign-in (src/app/(auth), src/components/auth-frame, mfa-dialogs).
  // Most values are the old pages' literal copy, moved verbatim and identical in every language (copy
  // unchanged); translating them is a copy change. New labels: showPassword, hidePassword, loginFailed,
  // otpLabel, setup.steps, setup.qrLabel.
  'lumen.auth.showPassword': 'Tampilkan kata sandi',
  'lumen.auth.hidePassword': 'Sembunyikan kata sandi',
  'lumen.auth.loginFailed': 'Login gagal',
  'lumen.auth.otpLabel': 'Kode verifikasi 6 digit',
  'lumen.auth.cubeLogoAlt': 'CUBEforall by CCN',
  'lumen.auth.version': 'Version 1.0.0 (build 484)',
  'lumen.auth.copyright': '© 2022 - 2026. All rights reserved.',
  'lumen.auth.toast.loginSuccessful': 'Login Successful',
  'lumen.auth.toast.cubeSignedIn': 'Signed in with your CUBEforall account',
  'lumen.auth.toast.cubeError': 'CUBE SSO Error',
  'lumen.auth.toast.mfaSetup': 'MFA Setup',
  'lumen.auth.toast.mfaSetupPending': 'Please complete your pending MFA setup or contact support',
  'lumen.auth.toast.error': 'Error',
  'lumen.auth.toast.mfaSetupFailed': 'Failed to setup MFA. Please try logging in again.',
  'lumen.auth.toast.mfaStatusFailed': 'Failed to check MFA status. Redirecting to app.',
  'lumen.auth.toast.success': 'Success!',
  'lumen.auth.toast.mfaActivated': 'MFA successfully activated',
  'lumen.auth.toast.mfaNotActive': 'MFA not active yet, please try again',
  'lumen.auth.toast.setupCodeIncorrect': 'Verification code is incorrect, please try again',
  'lumen.auth.toast.mfaVerified': 'MFA verification successful',
  'lumen.auth.toast.mfaCodeInvalid': 'Invalid verification code. Please try again.',
  'lumen.auth.toast.deviceAdded': 'Device Added Successfully',
  'lumen.auth.toast.deviceAddedMessage':
    'The new device has been added and verified. Your team member can now use it to login.',
  'lumen.auth.verify.title': 'Two-Factor Authentication',
  'lumen.auth.verify.description': 'Please enter the 6-digit verification code from your authenticator app',
  'lumen.auth.verify.verifying': 'Verifying code...',
  'lumen.auth.verify.help':
    'Open your authenticator app (e.g., Google Authenticator, Authy) to view your verification code',
  'lumen.auth.verify.back': 'Kembali ke Login',
  'lumen.auth.setup.title': 'Setup Autentikasi Multi-Faktor (MFA)',
  'lumen.auth.setup.steps': 'Langkah penyiapan MFA',
  'lumen.auth.setup.step1': 'Scan QR Code',
  'lumen.auth.setup.step1Desc': 'Gunakan Google Authenticator',
  'lumen.auth.setup.step2': 'Backup Codes',
  'lumen.auth.setup.step2Desc': 'Simpan kode darurat',
  'lumen.auth.setup.step3': 'Verifikasi',
  'lumen.auth.setup.step3Desc': 'Masukkan 6 digit kode',
  'lumen.auth.setup.scanHint': 'Buka aplikasi {app} di smartphone Anda dan scan QR code di bawah ini.',
  'lumen.auth.setup.qrLabel': 'Kode QR MFA',
  'lumen.auth.setup.manualEntry': 'Atau masukkan kode manual',
  'lumen.auth.setup.copy': 'Salin kode',
  'lumen.auth.setup.copied': 'Tersalin!',
  'lumen.auth.setup.toBackup': 'Lanjut ke Backup Codes',
  'lumen.auth.setup.important': 'PENTING:',
  'lumen.auth.setup.backupWarning':
    'Simpan kode backup ini di tempat yang aman. Anda akan membutuhkannya jika kehilangan akses ke perangkat autentikasi.',
  'lumen.auth.setup.yourCodes': 'Kode Backup Anda:',
  'lumen.auth.setup.download': 'Download Backup Codes',
  'lumen.auth.setup.downloaded': 'Backup Codes Telah Didownload',
  'lumen.auth.setup.back': 'Kembali',
  'lumen.auth.setup.toVerify': 'Lanjut ke Verifikasi',
  'lumen.auth.setup.verifyHint': 'Masukkan 6 digit kode yang muncul di aplikasi Google Authenticator Anda.',
  'lumen.auth.setup.verifySubmit': 'Verifikasi & Aktifkan MFA',
  'lumen.auth.addDevice.title': 'Tambahkan Device Baru',
  'lumen.auth.addDevice.description': 'Add a new device for team members to access this account',
  'lumen.auth.addDevice.hint':
    'After adding the device, the team member will scan the QR code with their authenticator app',
  'lumen.auth.addDevice.deviceName': 'Device Name',
  'lumen.auth.addDevice.deviceNamePlaceholder': "e.g., Friend's iPhone",
  'lumen.auth.addDevice.userName': 'User Name',
  'lumen.auth.addDevice.userNamePlaceholder': 'e.g., Jane Smith',
  'lumen.auth.addDevice.generate': 'Generate QR Code',
  'lumen.auth.addDevice.cancel': 'Cancel',
  'lumen.auth.reviewer.title': 'Reviewer Portal',
  'lumen.auth.reviewer.subtitle': 'Login to review and approve AJU documents',
  'lumen.auth.reviewer.email': 'Email address',
  'lumen.auth.reviewer.emailPlaceholder': 'reviewer@company.com',
  'lumen.auth.reviewer.password': 'Password',
  'lumen.auth.reviewer.passwordPlaceholder': 'Your password',
  'lumen.auth.reviewer.signIn': 'Sign in',
  'lumen.auth.reviewer.footer': 'Lumen Reviewer Portal',
  'lumen.auth.reviewer.caption': 'Review and approve customs documents securely',
  'lumen.breadcrumb.label': 'Jejak navigasi',
  'lumen.breadcrumb.more': 'Lainnya',
  // ---- Lumen P4 pages: customer approval (4 pages), riwayat-pembaruan, stamp-duty ----
  // The old pages' literal text, verbatim in every language (copy unchanged). Generic words are lumen.common.*
  // (Active, Name, Actions, …); words two of these pages share live under the first one.
  // customer-approval (Status, Actions are lumen.common.*)
  'lumen.customerApproval.title': 'Approval Requests',
  'lumen.customerApproval.description': 'Kelola dan pantau permintaan approval dari customer',
  'lumen.customerApproval.refresh': 'Refresh',
  'lumen.customerApproval.statTotal': 'Total Requests',
  'lumen.customerApproval.statWaiting': 'Waiting',
  'lumen.customerApproval.statusApproved': 'Approved',
  'lumen.customerApproval.statusRejected': 'Rejected',
  'lumen.customerApproval.statusWaiting': 'Waiting for Review',
  'lumen.customerApproval.statusNeedRevision': 'Need Revision',
  'lumen.customerApproval.statusInvalidated': 'Invalidated',
  'lumen.customerApproval.statusScheduled': 'Scheduled',
  'lumen.customerApproval.searchPlaceholder': 'Search by AJU no., requester...',
  'lumen.customerApproval.count': '{n} requests',
  'lumen.customerApproval.colAju': 'AJU No.',
  'lumen.customerApproval.colVersion': 'Ver',
  'lumen.customerApproval.notes': 'Notes',
  'lumen.customerApproval.colRequested': 'Requested',
  'lumen.customerApproval.colReviewed': 'Reviewed',
  'lumen.customerApproval.scheduledAt': 'Dijadwalkan: {date}',
  'lumen.customerApproval.justNow': 'just now',
  'lumen.customerApproval.minutesAgo': '{m}m ago',
  'lumen.customerApproval.hoursMinutesAgo': '{h}h {m}m ago',
  'lumen.customerApproval.hoursAgo': '{h}h ago',
  'lumen.customerApproval.daysHoursAgo': '{d}d {h}h ago',
  'lumen.customerApproval.daysAgo': '{d}d ago',
  'lumen.customerApproval.resendEmail': 'Resend Email',
  'lumen.customerApproval.cancelScheduled': 'Cancel Scheduled',
  'lumen.customerApproval.empty': 'No approval requests found',
  'lumen.customerApproval.detailsTitle': 'Approval Request Details',
  'lumen.customerApproval.requestInfo': 'Request Information',
  'lumen.customerApproval.requestedBy': 'Requested by:',
  'lumen.customerApproval.requestedOn': 'Requested: {date}',
  'lumen.customerApproval.reviewedOn': 'Reviewed: {date}',
  'lumen.customerApproval.revisionChecklist': 'Revision Checklist',
  'lumen.customerApproval.completed': '{checked}/{total} completed',
  'lumen.customerApproval.recipients': 'Recipients ({n})',
  'lumen.customerApproval.sent': 'Sent',
  'lumen.customerApproval.failed': 'Failed',
  'lumen.customerApproval.pending': 'Pending',
  'lumen.customerApproval.close': 'Close',
  'lumen.customerApproval.editDraft': 'Edit Draft',
  // customer-approval/reviewers (Batal, Simpan, Update and the email placeholder are lumen.common.*)
  'lumen.approvalReviewers.title': 'Reviewer Accounts',
  'lumen.approvalReviewers.description': 'Kelola akun reviewer untuk approval AJU draft.',
  'lumen.approvalReviewers.add': 'Tambah Reviewer',
  'lumen.approvalReviewers.editTitle': 'Edit Reviewer',
  'lumen.approvalReviewers.namePlaceholder': 'Full name',
  'lumen.approvalReviewers.passwordOptional': 'Password (optional)',
  'lumen.approvalReviewers.passwordPlaceholder': 'Min. 6 characters',
  'lumen.approvalReviewers.passwordKeepPlaceholder': 'Leave empty to keep current',
  // customer-approval/email-groups (Edit Email is lumen.common.editEmail)
  'lumen.approvalEmailGroups.title': 'Email Groups',
  'lumen.approvalEmailGroups.description': 'Kelola grup email untuk pengiriman approval AJU draft.',
  'lumen.approvalEmailGroups.addGroup': 'Tambah Group',
  'lumen.approvalEmailGroups.editGroup': 'Edit Group',
  'lumen.approvalEmailGroups.importir': 'Importir',
  'lumen.approvalEmailGroups.loading': 'Loading...',
  'lumen.approvalEmailGroups.filterPlaceholder': 'Pilih importir untuk filter grup',
  'lumen.approvalEmailGroups.importirPlaceholder': 'Pilih importir',
  'lumen.approvalEmailGroups.colDescription': 'Description',
  'lumen.approvalEmailGroups.emailCount': 'Jumlah Email',
  'lumen.approvalEmailGroups.addEmailRow': 'Tambah email',
  'lumen.approvalEmailGroups.groupNamePlaceholder': 'Group name',
  'lumen.approvalEmailGroups.groupDescriptionPlaceholder': 'Group description',
  'lumen.approvalEmailGroups.groupDetail': 'Group Detail',
  'lumen.approvalEmailGroups.addEmail': 'Tambah Email',
  'lumen.approvalEmailGroups.recipientNamePlaceholder': 'Recipient name',
  // customer-approval/roles, role-form-modal, user-assignment-drawer
  'lumen.customRoles.title': 'Roles & Permissions',
  'lumen.customRoles.description':
    'Buat role khusus, pilih menu yang boleh diakses beserta levelnya, lalu tugaskan user.',
  'lumen.customRoles.add': 'Tambah Role',
  'lumen.customRoles.fallback':
    'Akun Anda masih memakai role lama. Semua akses tetap berjalan seperti sebelumnya sampai admin menugaskan custom role.',
  'lumen.customRoles.showInactive': 'Tampilkan role nonaktif',
  'lumen.customRoles.colName': 'Nama Role',
  'lumen.customRoles.colCode': 'Kode',
  'lumen.customRoles.colDescription': 'Deskripsi',
  'lumen.customRoles.colUser': 'User',
  'lumen.customRoles.colMenus': 'Akses Menu',
  'lumen.customRoles.system': 'System',
  'lumen.customRoles.systemHint': 'Role bawaan sistem hasil migrasi role lama. Tidak dapat diubah.',
  'lumen.customRoles.menusNone': 'Tidak ada',
  'lumen.customRoles.menusFull': '{n} menu · penuh',
  'lumen.customRoles.menusRead': '{n} menu · lihat saja',
  'lumen.customRoles.menusMixed': '{n} menu · {full} penuh',
  'lumen.customRoles.editLocked': 'Role sistem tidak dapat diubah',
  'lumen.customRoles.duplicate': 'Duplikat',
  'lumen.customRoles.assignUser': 'Assign user',
  'lumen.customRoles.deactivate': 'Nonaktifkan',
  'lumen.customRoles.deleteLocked': 'Role sistem tidak dapat dihapus',
  'lumen.customRoles.deactivateTitle': 'Nonaktifkan Role',
  'lumen.customRoles.deactivateConfirm':
    'Role {name} akan dinonaktifkan. User yang masih aktif harus dipindahkan terlebih dahulu.',
  'lumen.customRoles.editTitle': 'Edit Role',
  'lumen.customRoles.duplicateTitle': 'Duplikat Role',
  'lumen.customRoles.tabGeneral': 'Informasi Umum',
  'lumen.customRoles.namePlaceholder': 'mis. Document Approver',
  'lumen.customRoles.codeLabel': 'Kode Role',
  'lumen.customRoles.codeHint': 'Format slug, dipakai di kode program. Dibuat otomatis dari nama.',
  'lumen.customRoles.codePlaceholder': 'document_approver',
  'lumen.customRoles.descriptionPlaceholder': 'Menjelaskan tanggung jawab role ini',
  'lumen.customRoles.active': 'Role aktif',
  'lumen.customRoles.menusEmpty': 'Katalog menu belum tersedia.',
  'lumen.customRoles.menusHint':
    'Menu yang dipilih menentukan halaman {and} data yang bisa diakses user dengan role ini. Menu yang tidak dipilih tidak akan tampil di sidebar dan datanya juga tidak bisa dibuka.',
  'lumen.customRoles.menusHintAnd': 'dan',
  'lumen.customRoles.levelRead': 'Lihat saja',
  'lumen.customRoles.levelFull': 'Penuh',
  'lumen.customRoles.levelReadHint':
    'User bisa membuka dan mengunduh, tidak bisa membuat, mengubah, mengirim, atau menghapus.',
  'lumen.customRoles.levelFullHint': 'User bisa melakukan semua aksi di menu ini.',
  'lumen.customRoles.assignTitle': 'Assign User — {name}',
  'lumen.customRoles.assignTitlePlain': 'Assign User',
  'lumen.customRoles.subjectReviewer': 'Reviewer',
  'lumen.customRoles.searchPlaceholder': 'Cari nama atau email',
  'lumen.customRoles.moving': '{n} user akan dipindahkan dari role lain ke role ini.',
  'lumen.customRoles.noUser': 'Tidak ada user yang cocok.',
  'lumen.customRoles.noReviewer': 'Tidak ada reviewer yang cocok.',
  'lumen.customRoles.inactive': 'Nonaktif',
  'lumen.customRoles.selected': '{n} dipilih',

  // ---- Lumen /management-dashboard (dashboards PR 5) ----
  // The old page's literal text, verbatim in every language (copy unchanged). {n}, {name}, {pct}, {rate},
  // {currency}, {at} and {filename} are filled with formatTemplate. dateRange is new (the preset select's
  // accessible name), translated. The toasts' "Error" title is lumen.common.error.
  'lumen.managementDashboard.title': 'Executive Dashboard',
  'lumen.managementDashboard.subtitle': 'Real-time business intelligence',
  'lumen.managementDashboard.rangeThisMonth': 'This Month',
  'lumen.managementDashboard.rangeLastMonth': 'Last Month',
  'lumen.managementDashboard.rangeLast3Months': 'Last 3 Months',
  'lumen.managementDashboard.rangeThisQuarter': 'This Quarter',
  'lumen.managementDashboard.rangeLastQuarter': 'Last Quarter',
  'lumen.managementDashboard.rangeThisYear': 'This Year',
  'lumen.managementDashboard.rangeLastYear': 'Last Year',
  'lumen.managementDashboard.rangeLast7Days': 'Last 7 Days',
  'lumen.managementDashboard.rangeLast30Days': 'Last 30 Days',
  'lumen.managementDashboard.rangeLast90Days': 'Last 90 Days',
  'lumen.managementDashboard.refresh': 'Refresh',
  'lumen.managementDashboard.downloadReport': 'Download Report',
  'lumen.managementDashboard.downloading': 'Downloading...',
  'lumen.managementDashboard.loading': 'Loading Executive Dashboard...',
  'lumen.managementDashboard.loadFailed': 'Failed to load dashboard',
  'lumen.managementDashboard.retry': 'Retry',
  'lumen.managementDashboard.totalProcesses': 'Total Processes',
  'lumen.managementDashboard.successfulCount': '{n} successful',
  'lumen.managementDashboard.nilaiPabean': 'Nilai Pabean',
  'lumen.managementDashboard.totalCustomsValue': 'Total customs value',
  'lumen.managementDashboard.activePpjks': 'Active PPJKs',
  'lumen.managementDashboard.processingAgents': 'Processing agents',
  'lumen.managementDashboard.monthlyTrends': 'Monthly Trends',
  'lumen.managementDashboard.monthlyTrendsDescription': 'Process volume over time',
  'lumen.managementDashboard.timeSeries': 'Time Series',
  'lumen.managementDashboard.noTrendData': 'No trend data available',
  'lumen.managementDashboard.unknown': 'Unknown',
  'lumen.managementDashboard.notAvailable': 'N/A',
  'lumen.managementDashboard.shipmentDistribution': 'Shipment Distribution',
  'lumen.managementDashboard.byShipmentType': 'By shipment type',
  'lumen.managementDashboard.distribution': 'Distribution',
  'lumen.managementDashboard.noShipmentData': 'No shipment data available',
  'lumen.managementDashboard.slicePercent': '{name}: {pct}%',
  'lumen.managementDashboard.ppjkPerformance': 'PPJK Performance',
  'lumen.managementDashboard.agentMetrics': 'Agent metrics',
  'lumen.managementDashboard.performance': 'Performance',
  'lumen.managementDashboard.successRate': '{rate}% Success',
  'lumen.managementDashboard.processes': 'Processes',
  'lumen.managementDashboard.successful': 'Successful',
  'lumen.managementDashboard.noPpjkData': 'No PPJK data available',
  'lumen.managementDashboard.currencyBreakdown': 'Currency Breakdown',
  'lumen.managementDashboard.transactionCurrencies': 'Transaction currencies',
  'lumen.managementDashboard.finance': 'Finance',
  'lumen.managementDashboard.transactions': 'Transactions',
  'lumen.managementDashboard.currencyLeads': '{currency} leads with {n} transactions',
  'lumen.managementDashboard.currencyUnavailable': 'Currency performance information unavailable',
  'lumen.managementDashboard.totalTransactions': 'Total transactions: {n}',
  'lumen.managementDashboard.noCurrencyData': 'No currency data available',
  'lumen.managementDashboard.topImportOrigins': 'Top Import Origins',
  'lumen.managementDashboard.byTotalProcesses': 'By total processes',
  'lumen.managementDashboard.imports': 'Imports',
  'lumen.managementDashboard.topExportDestinations': 'Top Export Destinations',
  'lumen.managementDashboard.exports': 'Exports',
  'lumen.managementDashboard.topImportHsCodes': 'Top Import HS Codes',
  'lumen.managementDashboard.byFrequency': 'By frequency',
  'lumen.managementDashboard.import': 'Import',
  'lumen.managementDashboard.frequency': 'Frequency',
  'lumen.managementDashboard.noImportHsData': 'No import HS code data available',
  'lumen.managementDashboard.topExportHsCodes': 'Top Export HS Codes',
  'lumen.managementDashboard.export': 'Export',
  'lumen.managementDashboard.noExportHsData': 'No export HS code data available',
  'lumen.managementDashboard.topImporters': 'Top Importers',
  'lumen.managementDashboard.topImportersDescription': 'Importer performance by total processes and goods',
  'lumen.managementDashboard.importAnalysis': 'Import Analysis',
  'lumen.managementDashboard.totalGoods': 'Total Goods',
  'lumen.managementDashboard.topExporters': 'Top Exporters',
  'lumen.managementDashboard.topExportersDescription': 'Exporter performance by total processes and goods',
  'lumen.managementDashboard.exportAnalysis': 'Export Analysis',
  'lumen.managementDashboard.financialSummary': 'Financial Summary',
  'lumen.managementDashboard.financialSummaryDescription': 'Value breakdown and exchange rates',
  'lumen.managementDashboard.hargaBarang': 'Harga Barang',
  'lumen.managementDashboard.totalFreight': 'Total Freight',
  'lumen.managementDashboard.biayaPenambah': 'Biaya Penambah',
  'lumen.managementDashboard.avgExchangeRate': 'Avg Exchange Rate',
  'lumen.managementDashboard.avgHargaPerProcess': 'Avg Harga per Process',
  'lumen.managementDashboard.avgPabeanPerProcess': 'Avg Nilai Pabean per Process',
  'lumen.managementDashboard.currencyDetails': 'Currency Details',
  'lumen.managementDashboard.currencyDetailsDescription': 'Exchange rates and transaction volumes',
  'lumen.managementDashboard.details': 'Details',
  'lumen.managementDashboard.currency': 'Currency',
  'lumen.managementDashboard.avgRate': 'Avg Rate',
  'lumen.managementDashboard.minRate': 'Min Rate',
  'lumen.managementDashboard.maxRate': 'Max Rate',
  'lumen.managementDashboard.generatedAt': 'Generated: {at}',
  'lumen.managementDashboard.version': 'Lumen Executive Dashboard v2.0',
  'lumen.managementDashboard.downloadSuccessTitle': 'Berhasil',
  'lumen.managementDashboard.downloadSuccess': 'Report {filename} terunduh.',
  'lumen.managementDashboard.downloadFailed': 'Gagal mengunduh report.',
  'lumen.managementDashboard.dateRange': 'Rentang tanggal',
  // stamp-duty (Active is lumen.common.active)
  'lumen.stampDuty.title': 'Stamp Duty Generator',
  'lumen.stampDuty.description': 'Upload your PDF document to add official stamp duty marks',
  'lumen.stampDuty.uploadDocument': 'Upload Document',
  'lumen.stampDuty.dropHere': 'Drop your PDF file here',
  'lumen.stampDuty.orBrowse': 'or click to browse from your computer',
  'lumen.stampDuty.pdfOnly': 'PDF files only',
  'lumen.stampDuty.maxSize': 'Max 10MB',
  'lumen.stampDuty.supportedFormat': 'Supported Format',
  'lumen.stampDuty.pdfDocuments': 'PDF Documents',
  'lumen.stampDuty.processing': 'Processing',
  'lumen.stampDuty.automaticStamping': 'Automatic Stamping',
  'lumen.stampDuty.documentPreview': 'Document Preview',
  'lumen.stampDuty.sizeKb': '{n} KB',
  'lumen.stampDuty.uploadNew': 'Upload New File',
  'lumen.command.title': 'Palet perintah',
  'lumen.command.description': 'Cari perintah untuk dijalankan…',
  'lumen.toast.region': 'Notifikasi',

  // ---- Lumen respon (Kepabeanan › Respon) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.respon.searchPlaceholder': 'Cari berdasarkan nomor pengajuan, nama perusahaan, atau nama respon...',
  'lumen.respon.total': 'Total: {n} AJU',
  'lumen.respon.nomorAju': 'Nomor Pengajuan',
  'lumen.respon.namaPerusahaan': 'Nama Perusahaan',
  'lumen.respon.namaRespon': 'Nama Respon',
  'lumen.respon.count': '{n} respon',
  'lumen.respon.range': '{from} - {to} / {total} AJU',
  'lumen.respon.download': 'Download {label}',
  'lumen.respon.error': 'Error',
  'lumen.respon.success': 'Success',
  'lumen.respon.fetchFailed': 'Failed to fetch response data',
  'lumen.respon.fetchDataFailed': 'Failed to fetch data',
  'lumen.respon.fetchingTitle': 'Mengambil {label} dari CEISA…',
  'lumen.respon.fetchingBody': 'Dokumen belum ada di arsip; CEISA bisa memakan waktu hingga 30 detik.',
  'lumen.respon.downloaded': '{label} berhasil diunduh',
  'lumen.respon.downloadFailed': 'Gagal mengunduh {label}',

  // ---- Lumen database-barang (Kepabeanan › Database Barang) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.databaseBarang.searchPlaceholder': 'Cari kode barang, uraian, HS code...',
  'lumen.databaseBarang.ajuNo': 'Aju No',
  'lumen.databaseBarang.companyName': 'Company Name',
  'lumen.databaseBarang.total': 'Total: {n} records',
  'lumen.databaseBarang.downloadExcel': 'Download Excel',
  'lumen.databaseBarang.kodeNegaraAsal': 'Kode Negara Asal',
  'lumen.databaseBarang.merk': 'Merk',
  'lumen.databaseBarang.uraian': 'Uraian',
  'lumen.databaseBarang.hsCode': 'HS Code',
  'lumen.databaseBarang.kodeBarang': 'Kode Barang',
  'lumen.databaseBarang.uom': 'UOM',
  'lumen.databaseBarang.unitPrice': 'Unit Price',
  'lumen.databaseBarang.currency': 'Currency',
  'lumen.databaseBarang.range': '{from} - {to} / {total}',
  'lumen.databaseBarang.error': 'Error',
  'lumen.databaseBarang.success': 'Success',
  'lumen.databaseBarang.fetchDataFailed': 'Failed to fetch data',
  'lumen.databaseBarang.fetchFailed': 'Failed to fetch database barang data',
  'lumen.databaseBarang.downloaded': 'Database barang downloaded',
  'lumen.databaseBarang.downloadFailed': 'Failed to download database barang',

  // ---- Lumen manifest-dashboard (Manifest › Dashboard) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.manifestDashboard.title': 'Manifest Dashboard',
  'lumen.manifestDashboard.subtitle': 'Real-time overview of your manifest operations',
  'lumen.manifestDashboard.startDate': 'Start date',
  'lumen.manifestDashboard.endDate': 'End date',
  'lumen.manifestDashboard.downloadReport': 'Download Excel Report',
  'lumen.manifestDashboard.downloading': 'Downloading...',
  'lumen.manifestDashboard.loading': 'Loading dashboard...',
  'lumen.manifestDashboard.noData': 'No data available',
  'lumen.manifestDashboard.totalManifests': 'Total Manifests',
  'lumen.manifestDashboard.totalHouseBls': 'Total House BLs',
  'lumen.manifestDashboard.critical': 'Critical',
  'lumen.manifestDashboard.pending': 'Pending',
  'lumen.manifestDashboard.submittedToday': 'Submitted Today',
  'lumen.manifestDashboard.attentionRequired': 'Attention Required',
  'lumen.manifestDashboard.needAttention': '{pct}% of manifests need attention',
  'lumen.manifestDashboard.criticalCount': '{n} Critical',
  'lumen.manifestDashboard.mediumCount': '{n} Medium',
  'lumen.manifestDashboard.normalCount': '{n} Normal',
  'lumen.manifestDashboard.statusDistribution': 'Status Distribution',
  'lumen.manifestDashboard.draft': 'Draft',
  'lumen.manifestDashboard.sent': 'Sent',
  'lumen.manifestDashboard.ready': 'Ready',
  'lumen.manifestDashboard.deleted': 'Deleted',
  'lumen.manifestDashboard.sharePct': '({pct}%)',
  'lumen.manifestDashboard.companyPerformance': 'Company Performance',
  'lumen.manifestDashboard.submitted': 'Submitted',
  'lumen.manifestDashboard.manifestCount': '{n} manifests',
  'lumen.manifestDashboard.criticalManifests': 'Critical Manifests',
  'lumen.manifestDashboard.noCriticalManifests': 'No critical manifests',
  'lumen.manifestDashboard.daysUntil': '{n}d',
  'lumen.manifestDashboard.upcomingEvents': 'Upcoming Events',
  'lumen.manifestDashboard.noUpcomingEvents': 'No upcoming events',
  'lumen.manifestDashboard.typeInwardSea': 'Inward Laut',
  'lumen.manifestDashboard.typeInwardAir': 'Inward Udara',
  'lumen.manifestDashboard.typeOutwardSea': 'Outward Laut',
  'lumen.manifestDashboard.typeOutwardAir': 'Outward Udara',
  'lumen.manifestDashboard.toastSuccess': 'Berhasil',
  'lumen.manifestDashboard.reportDownloaded': 'Report {filename} terunduh.',
  'lumen.manifestDashboard.downloadFailed': 'Gagal mengunduh report.',
  'lumen.manifestDashboard.demoModeTitle': 'Demo Mode',
  'lumen.manifestDashboard.demoModeBody': 'Backend endpoint not available. Showing demo data.',
  'lumen.manifestDashboard.fetchFailed': 'Failed to fetch dashboard data: {message}',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 S): the submit dialog (ModalSubmit) and the incomplete-manifest
  // report (IncompleteManifestModal), their toasts. The old text verbatim in every language; {label}, {bl}, {name},
  // {address}, {message} and {n} are filled with formatTemplate. Nomor AJU and Cek Lengkap (with its three toasts) are
  // the shell block's; Batal, Simpan, Success and Error are lumen.common.*.
  'lumen.manifestEngine.submit.title': 'Manifest',
  'lumen.manifestEngine.submit.ajuPlaceholder': 'Masukkan Nomor AJU',
  'lumen.manifestEngine.submit.refresh': 'Refresh Nomor AJU',
  'lumen.manifestEngine.submit.ajuUpdated': 'Nomor AJU berhasil diperbarui',
  'lumen.manifestEngine.submit.ajuLoadFailed': 'Gagal memuat nomor AJU terbaru',
  'lumen.manifestEngine.submit.ajuEmpty': 'Nomor AJU tidak boleh kosong',
  'lumen.manifestEngine.submit.belumTitle': 'Belum Lengkap',
  'lumen.manifestEngine.submit.belumFallback': 'Data belum lengkap',
  'lumen.manifestEngine.submit.noProcessId': 'Manifest ID tidak ditemukan',
  'lumen.manifestEngine.submit.referenceLabel': 'Reference ID',
  'lumen.manifestEngine.submit.referenceRequiredTitle': '{label} wajib diisi',
  'lumen.manifestEngine.submit.referenceRequiredBody': 'Isi {label} di tab Header sebelum manifest dikirim',
  'lumen.manifestEngine.submit.noBlTitle': 'Manifest belum memiliki {bl}',
  'lumen.manifestEngine.submit.noBlBody': 'Tambahkan minimal satu {bl} sebelum submit ke CEISA',
  'lumen.manifestEngine.submit.companyMissing': 'Data perusahaan tidak tersedia. Name: {name}, Address: {address}',
  'lumen.manifestEngine.submit.companyEmpty': 'empty',
  'lumen.manifestEngine.submit.submitted': 'Manifest berhasil disubmit ke CEISA',
  'lumen.manifestEngine.submit.submitFailed': 'Gagal submit manifest',
  'lumen.manifestEngine.submit.submitFailedWith': 'Gagal submit manifest: {message}',
  'lumen.manifestEngine.submit.tutup': 'Tutup',
  'lumen.manifestEngine.submit.ok': 'OK',
  'lumen.manifestEngine.submit.incompleteTitle': 'Data Belum Lengkap',
  'lumen.manifestEngine.submit.incompleteBody':
    'Manifest belum bisa didorong ke CEISA. Lengkapi {n} kolom wajib berikut terlebih dahulu.',

  // ---- Lumen manifest/draft (revamp PR 6a, unit F6) ----
  // The old page's literal text, verbatim in every language (copy unchanged). Status, Actions, Edit, Error,
  // Success and Cancel are lumen.common.*.
  'lumen.manifestDraft.title': 'Draft Manifest',
  'lumen.manifestDraft.subtitle': 'Kelola draft manifest yang belum disubmit',
  'lumen.manifestDraft.searchPlaceholder': 'Cari berdasarkan nama perusahaan...',
  'lumen.manifestDraft.search': 'Search',
  'lumen.manifestDraft.deleteSelected': 'Delete ({n})',
  'lumen.manifestDraft.colType': 'Type',
  'lumen.manifestDraft.colCompany': 'Nama Perusahaan',
  'lumen.manifestDraft.colVessel': 'Sarana Pengangkut',
  'lumen.manifestDraft.colVoyage': 'Voyage',
  'lumen.manifestDraft.colDeparture': 'Tgl Berangkat',
  'lumen.manifestDraft.colArrival': 'Tgl Tiba',
  'lumen.manifestDraft.modeLaut': 'Laut',
  'lumen.manifestDraft.modeUdara': 'Udara',
  'lumen.manifestDraft.modeDarat': 'Darat',
  'lumen.manifestDraft.imo': ' | IMO: {imo}',
  'lumen.manifestDraft.view': 'View',
  'lumen.manifestDraft.demoCannotView': 'Demo users cannot view',
  'lumen.manifestDraft.demoCannotEdit': 'Demo users cannot edit',
  'lumen.manifestDraft.fetchFailed': 'Failed to fetch drafts: {message}',
  'lumen.manifestDraft.noSelectionTitle': 'No Selection',
  'lumen.manifestDraft.noSelectionBody': 'Please select at least one record to delete',
  'lumen.manifestDraft.deleted': 'Successfully deleted {n} record(s)',
  'lumen.manifestDraft.deleteFailed': 'Failed to delete records: {message}',
  'lumen.manifestDraft.confirmTitle': 'Confirm Delete',
  'lumen.manifestDraft.confirmBody': 'Are you sure you want to delete {n} record(s)? This action cannot be undone.',
  'lumen.manifestDraft.delete': 'Delete',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 B1): the BL list (table, toolbar, bulk edit, sync, print chrome,
  // NOA) and the PEB / BL susulan upload. The old text verbatim in every language (copy unchanged); {n}, {message}, {ok},
  // {fail}, {mapped}, {direction}, {doc}, {checked}, {total}, {label} and {name} are filled with formatTemplate. New labels the
  // new parts need (bl.selectAllRows, bl.reorderHint, susulan.removeFile) are Indonesian like the page. The print documents
  // and the CEISA code labels stay as constants (i1 §11 settled 2).
  'lumen.manifestEngine.bl.titleBl': 'Data BL',
  'lumen.manifestEngine.bl.titleAwb': 'Data AWB',
  'lumen.manifestEngine.bl.bulkEdit': 'Bulk Edit ({n} dipilih)',
  'lumen.manifestEngine.bl.uploadNoa': 'Upload NOA',
  'lumen.manifestEngine.bl.susulanOutBl': 'Upload PEB / BL Susulan',
  'lumen.manifestEngine.bl.susulanOutAwb': 'Upload PEB / AWB Susulan',
  'lumen.manifestEngine.bl.susulanInBl': 'Upload BL Susulan',
  'lumen.manifestEngine.bl.susulanInAwb': 'Upload AWB Susulan',
  'lumen.manifestEngine.bl.printAllBl': 'Cetak Semua BL',
  'lumen.manifestEngine.bl.printAllAwb': 'Cetak Semua AWB',
  'lumen.manifestEngine.bl.syncMasterBl': 'Sync with Master BL',
  'lumen.manifestEngine.bl.syncMasterAwb': 'Sync with Master AWB',
  'lumen.manifestEngine.bl.syncAllPorts': 'Sync All Ports',
  'lumen.manifestEngine.bl.addBl': 'Tambah Data BL',
  'lumen.manifestEngine.bl.addAwb': 'Tambah Data AWB',
  'lumen.manifestEngine.bl.colNo': 'No',
  'lumen.manifestEngine.bl.colNoPos': 'No Pos',
  'lumen.manifestEngine.bl.colPorts': 'Kode Pelabuhan',
  'lumen.manifestEngine.bl.portAsal': 'Asal:',
  'lumen.manifestEngine.bl.portBongkar': 'Bongkar:',
  'lumen.manifestEngine.bl.portTransit': 'Transit:',
  'lumen.manifestEngine.bl.portAkhir': 'Akhir:',
  'lumen.manifestEngine.bl.colMasterBl': 'Master BL',
  'lumen.manifestEngine.bl.colMasterAwb': 'Master AWB',
  'lumen.manifestEngine.bl.colHostBl': 'Host BL',
  'lumen.manifestEngine.bl.colHostAwb': 'Host AWB',
  'lumen.manifestEngine.bl.colPeb': 'No. PEB / PPKEK',
  'lumen.manifestEngine.bl.colShipper': 'Shipper',
  'lumen.manifestEngine.bl.colConsignee': 'Consignee',
  'lumen.manifestEngine.bl.colFileName': 'File Name',
  'lumen.manifestEngine.bl.colActions': 'Aksi',
  'lumen.manifestEngine.bl.actionEdit': 'Edit',
  'lumen.manifestEngine.bl.actionCopy': 'Copy',
  'lumen.manifestEngine.bl.actionPrint': 'Print',
  'lumen.manifestEngine.bl.actionDelete': 'Delete',
  'lumen.manifestEngine.bl.selectAllRows': 'Pilih semua baris',
  'lumen.manifestEngine.bl.reorderHint': 'Seret untuk mengubah urutan',
  'lumen.manifestEngine.bl.copyUnsaved': 'Tidak dapat menyalin BL yang belum disimpan',
  'lumen.manifestEngine.bl.copyingTitle': 'Copying...',
  'lumen.manifestEngine.bl.copying': 'Menyalin BL...',
  'lumen.manifestEngine.bl.copied': 'BL berhasil disalin',
  'lumen.manifestEngine.bl.copyFailed': 'Gagal menyalin BL',
  'lumen.manifestEngine.bl.copyFailedWith': 'Gagal menyalin BL: {message}',
  'lumen.manifestEngine.bl.deleted': 'BL berhasil dihapus',
  'lumen.manifestEngine.bl.deletingTitle': 'Deleting...',
  'lumen.manifestEngine.bl.deleting': 'Menghapus BL...',
  'lumen.manifestEngine.bl.deleteFailed': 'Gagal menghapus BL',
  'lumen.manifestEngine.bl.deleteFailedWith': 'Gagal menghapus BL: {message}',
  'lumen.manifestEngine.bl.processingTitle': 'Processing...',
  'lumen.manifestEngine.bl.partialTitle': 'Partial Success',
  'lumen.manifestEngine.bl.partial': 'Berhasil: {ok} BL, Gagal: {fail} BL',
  'lumen.manifestEngine.bl.infoTitle': 'Info',
  'lumen.manifestEngine.bl.noBls': 'Tidak ada BL untuk disinkronkan',
  'lumen.manifestEngine.bl.noMasterData': 'Tidak ada data Master BL atau Vessel untuk disinkronkan',
  'lumen.manifestEngine.bl.syncingMaster': 'Menyinkronkan {n} BL dengan Master BL...',
  'lumen.manifestEngine.bl.syncedMaster': 'Berhasil menyinkronkan {n} BL dengan Master BL',
  'lumen.manifestEngine.bl.syncFailed': 'Sinkronisasi gagal',
  'lumen.manifestEngine.bl.noPortData': 'Tidak ada data pelabuhan untuk disinkronkan',
  'lumen.manifestEngine.bl.lookingUpPorts': 'Mencari kode pelabuhan untuk {n} pelabuhan...',
  'lumen.manifestEngine.bl.portsAllCorrect': 'Semua pelabuhan sudah menggunakan kode yang benar',
  'lumen.manifestEngine.bl.updatingPorts': 'Memperbarui {n} BL dengan kode pelabuhan...',
  'lumen.manifestEngine.bl.portsMapped': '{mapped} pelabuhan berhasil dimapping, {ok} BL diperbarui',
  'lumen.manifestEngine.bl.portsFailedWith': 'Sinkronisasi pelabuhan gagal: {message}',
  'lumen.manifestEngine.bl.noneSelected': 'Tidak ada BL yang dipilih',
  'lumen.manifestEngine.bl.bulkUpdating': 'Memperbarui {n} BL...',
  'lumen.manifestEngine.bl.bulkUpdated': 'Berhasil memperbarui {n} BL',
  'lumen.manifestEngine.bl.bulkFailed': 'Bulk edit gagal',
  'lumen.manifestEngine.bl.reordering': 'Menyimpan urutan BL...',
  'lumen.manifestEngine.bl.reordered': 'Urutan BL berhasil diubah dan disimpan',
  'lumen.manifestEngine.bl.reorderFailed': 'Gagal menyimpan urutan BL',
  'lumen.manifestEngine.bl.bulkTitle': 'Bulk Edit BL',
  'lumen.manifestEngine.bl.bulkIntro': 'Isi field yang ingin diupdate. Field yang kosong tidak akan diubah.',
  'lumen.manifestEngine.bl.bulkMasterBlPlaceholder': 'Master BL (opsional)',
  'lumen.manifestEngine.bl.bulkDate': 'Tanggal Master BL',
  'lumen.manifestEngine.bl.bulkDatePlaceholder': 'Tanggal Master BL (opsional)',
  'lumen.manifestEngine.bl.bulkVessel': 'Vessel Name',
  'lumen.manifestEngine.bl.bulkVesselPlaceholder': 'Vessel Name (opsional)',
  'lumen.manifestEngine.bl.pelabuhanAsal': 'Pelabuhan Asal',
  'lumen.manifestEngine.bl.pelabuhanBongkar': 'Pelabuhan Bongkar',
  'lumen.manifestEngine.bl.pelabuhanTransit': 'Pelabuhan Transit',
  'lumen.manifestEngine.bl.pelabuhanAkhir': 'Pelabuhan Akhir',
  'lumen.manifestEngine.bl.pelabuhanAsalPlaceholder': 'Pilih Pelabuhan Asal (opsional)',
  'lumen.manifestEngine.bl.pelabuhanBongkarPlaceholder': 'Pilih Pelabuhan Bongkar (opsional)',
  'lumen.manifestEngine.bl.pelabuhanTransitPlaceholder': 'Pilih Pelabuhan Transit (opsional)',
  'lumen.manifestEngine.bl.pelabuhanAkhirPlaceholder': 'Pilih Pelabuhan Akhir (opsional)',
  'lumen.manifestEngine.bl.bulkApply': 'Terapkan ke {n} BL',
  'lumen.manifestEngine.bl.syncPortsText':
    'Proses ini akan mencari kode pelabuhan untuk semua nama pelabuhan di {n} BL, lalu memperbarui semua BL dengan kode pelabuhan yang ditemukan.',
  'lumen.manifestEngine.bl.syncPortsFound': '{n} pelabuhan unik ditemukan:',
  'lumen.manifestEngine.bl.lanjutkan': 'Lanjutkan',
  'lumen.manifestEngine.bl.printTitle': 'Print Preview - {direction} Manifest BC 1.1',
  'lumen.manifestEngine.bl.printAllTitle': 'Print Preview - {direction} Manifest BC 1.1 ({n} {doc})',
  'lumen.manifestEngine.bl.tutup': 'Tutup',
  'lumen.manifestEngine.bl.printManifest': 'Print Manifest',
  'lumen.manifestEngine.bl.printAll': 'Print Semua Manifest ({n})',
  'lumen.manifestEngine.bl.showChecklist': 'Show Checklist',
  'lumen.manifestEngine.bl.hideChecklist': 'Hide Checklist',
  'lumen.manifestEngine.bl.checkedCount': '{checked}/{total} checked',
  'lumen.manifestEngine.bl.checkAll': 'Check All',
  'lumen.manifestEngine.bl.uncheckAll': 'Uncheck All',
  'lumen.manifestEngine.bl.noaBusy': 'Memproses NOA...',
  'lumen.manifestEngine.bl.noaBusyHint': 'Mohon tunggu, jangan tutup halaman.',
  'lumen.manifestEngine.bl.noaNoProcess': 'Manifest belum tersedia. Simpan header dulu sebelum upload NOA.',
  'lumen.manifestEngine.bl.noaNoBatch': 'Batch UUID tidak ditemukan.',
  'lumen.manifestEngine.bl.noaNoFileUrl': 'Upload response tidak mengandung file_url.',
  'lumen.manifestEngine.bl.noaDone': 'Ekstraksi NOA selesai. Memuat ulang data...',
  'lumen.manifestEngine.bl.noaFailed': 'Upload NOA gagal.',
  'lumen.manifestEngine.bl.noaNotFound': 'Manifest tidak ditemukan.',
  'lumen.manifestEngine.bl.noaNoContainer': 'NOA tidak punya container yang bisa dipakai, atau BL/PEB belum diupload.',
  'lumen.manifestEngine.susulan.descInAwb': 'Upload file AWB tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.descInBl': 'Upload file BL tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.descOutAwb': 'Upload file PEB atau AWB tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.descOutBl': 'Upload file PEB atau BL tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.dropInAwb': 'Drag & drop file AWB',
  'lumen.manifestEngine.susulan.dropInBl': 'Drag & drop file BL',
  'lumen.manifestEngine.susulan.dropOutAwb': 'Drag & drop file PEB / AWB',
  'lumen.manifestEngine.susulan.dropOutBl': 'Drag & drop file PEB / BL',
  'lumen.manifestEngine.susulan.dropActive': 'Drop file PDF disini',
  'lumen.manifestEngine.susulan.browseOr': 'atau',
  'lumen.manifestEngine.susulan.browseLink': 'klik untuk browse',
  'lumen.manifestEngine.susulan.pdfOnly': 'PDF Only',
  'lumen.manifestEngine.susulan.maxFiles': 'Maks. 20 file',
  'lumen.manifestEngine.susulan.docType': 'Tipe Dokumen',
  'lumen.manifestEngine.susulan.docTypeHint':
    'Pilih tipe dokumen yang akan diupload. File yang di-drop akan otomatis menggunakan tipe ini.',
  'lumen.manifestEngine.susulan.listTitle': 'File yang akan diupload ({n})',
  'lumen.manifestEngine.susulan.uploadFailed': 'Gagal mengupload',
  'lumen.manifestEngine.susulan.uploading': 'Uploading...',
  'lumen.manifestEngine.susulan.uploaded': 'Uploaded',
  'lumen.manifestEngine.susulan.removeFile': 'Hapus {name}',
  'lumen.manifestEngine.susulan.proceed': 'Proceed',
  'lumen.manifestEngine.susulan.processing': 'Processing...',
  'lumen.manifestEngine.susulan.badFormatTitle': 'Format tidak sesuai',
  'lumen.manifestEngine.susulan.badFormat': 'Hanya file PDF yang diperbolehkan',
  'lumen.manifestEngine.susulan.tooManyTitle': 'Terlalu banyak file',
  'lumen.manifestEngine.susulan.tooMany': 'Maksimal 20 file dapat diupload',
  'lumen.manifestEngine.susulan.addedTitle': 'File ditambahkan',
  'lumen.manifestEngine.susulan.added': '{n} file berhasil ditambahkan',
  'lumen.manifestEngine.susulan.noFilesTitle': 'Tidak ada file',
  'lumen.manifestEngine.susulan.noFiles': 'Silakan tambahkan file terlebih dahulu',
  'lumen.manifestEngine.susulan.noneUploaded': 'Tidak ada file yang berhasil diupload',
  'lumen.manifestEngine.susulan.done': 'Berhasil menambahkan {n} {label} susulan',
  'lumen.manifestEngine.susulan.failed': 'Gagal menambahkan dokumen susulan',
  'lumen.manifestEngine.susulan.failedWith': 'Gagal menambahkan dokumen susulan: {message}',

  // ---- Lumen harga-referensi (Kuota Impor / Ekspor › Harga Referensi) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.hargaReferensi.title': 'Harga Referensi',
  'lumen.hargaReferensi.description': 'Search and view preferential tariff reference prices by HS Code',
  'lumen.hargaReferensi.searchPlaceholder': 'Enter HS Code (min. 6 digits)...',
  'lumen.hargaReferensi.hsCode': 'HS Code',
  'lumen.hargaReferensi.period': 'Period',
  'lumen.hargaReferensi.month': 'Month',
  'lumen.hargaReferensi.year': 'Year',
  'lumen.hargaReferensi.referencePrice': 'Reference Price',
  'lumen.hargaReferensi.currency': 'Currency',
  'lumen.hargaReferensi.uom': 'UOM',
  'lumen.hargaReferensi.notAvailable': 'N/A',
  'lumen.hargaReferensi.noRecordsFor': 'No reference prices found for HS Code: {hsCode}',
  'lumen.hargaReferensi.noRecords': 'No reference prices available',
  'lumen.hargaReferensi.error': 'Error',
  'lumen.hargaReferensi.fetchFailed': 'Failed to fetch tariffs',

  // ---- Lumen shipment-quota (Kuota Impor / Ekspor › Kuota Pengiriman, + create) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.shipmentQuota.title': 'Shipment Quota Management',
  'lumen.shipmentQuota.create': 'Create Quota',
  'lumen.shipmentQuota.searchPlaceholder': 'Search by HS Code...',
  'lumen.shipmentQuota.empty': 'No shipment quotas yet',
  'lumen.shipmentQuota.createFirst': 'Create Your First Quota',
  'lumen.shipmentQuota.status': 'Status',
  'lumen.shipmentQuota.hsCode': 'HS Code',
  'lumen.shipmentQuota.shipmentType': 'Shipment Type',
  'lumen.shipmentQuota.totalQuota': 'Total Quota',
  'lumen.shipmentQuota.quotaLeft': 'Quota Left',
  'lumen.shipmentQuota.usage': 'Usage %',
  'lumen.shipmentQuota.expiredDate': 'Expired Date',
  'lumen.shipmentQuota.createdAt': 'Created At',
  'lumen.shipmentQuota.expired': 'Expired',
  'lumen.shipmentQuota.depleted': 'Depleted',
  'lumen.shipmentQuota.low': 'Low',
  'lumen.shipmentQuota.active': 'Active',
  'lumen.shipmentQuota.error': 'Error',
  'lumen.shipmentQuota.success': 'Success',
  'lumen.shipmentQuota.fetchFailed': 'Failed to fetch quotas',
  'lumen.shipmentQuota.createTitle': 'Create Shipment Quota',
  'lumen.shipmentQuota.createDescription': 'Fill in the details below to create a new shipment quota',
  'lumen.shipmentQuota.ppjkNpwp': 'PPJK NPWP',
  'lumen.shipmentQuota.ppjkLoading': 'Loading PPJK NPWP...',
  'lumen.shipmentQuota.ppjkPlaceholder': 'PPJK NPWP from your account',
  'lumen.shipmentQuota.hsPlaceholder': 'Search HS Code...',
  'lumen.shipmentQuota.lartas': 'LARTAS',
  'lumen.shipmentQuota.nonLartas': 'NON-LARTAS',
  'lumen.shipmentQuota.uom': 'Unit of Measure (UOM)',
  'lumen.shipmentQuota.uomPlaceholder': 'Select UOM...',
  'lumen.shipmentQuota.typePlaceholder': 'Select shipment type',
  'lumen.shipmentQuota.import': 'Import',
  'lumen.shipmentQuota.export': 'Export',
  'lumen.shipmentQuota.quota': 'Quota',
  'lumen.shipmentQuota.quotaPlaceholder': 'Enter quota amount',
  'lumen.shipmentQuota.expiredPlaceholder': 'Select expiration date and time',
  'lumen.shipmentQuota.cancel': 'Cancel',
  'lumen.shipmentQuota.required': 'Please fill in all required fields',
  'lumen.shipmentQuota.created': 'Shipment quota created successfully!',
  'lumen.shipmentQuota.createFailed': 'Failed to create shipment quota',
  // New labels for the Lumen date-time field (translated).
  'lumen.shipmentQuota.time': 'Jam',
  'lumen.shipmentQuota.done': 'Selesai',

  // ---- Lumen ssm/data (SSM › Data, + SSMForm) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.ssmData.pageTitle': 'SSM Data Management',
  'lumen.ssmData.totalItems': 'Total Items',
  'lumen.ssmData.activeItems': 'Active Items',
  'lumen.ssmData.inactiveItems': 'Inactive Items',
  'lumen.ssmData.lastUpdated': 'Last Updated',
  'lumen.ssmData.today': 'Today',
  'lumen.ssmData.sectionTitle': 'SSM Data',
  'lumen.ssmData.sectionDescription': 'Manage system configuration and master data',
  'lumen.ssmData.refresh': 'Refresh',
  'lumen.ssmData.addNew': 'Add New Item',
  'lumen.ssmData.searchPlaceholder': 'Search by code, name, or description...',
  'lumen.ssmData.code': 'Code',
  'lumen.ssmData.name': 'Name',
  'lumen.ssmData.description': 'Description',
  'lumen.ssmData.status': 'Status',
  'lumen.ssmData.actions': 'Actions',
  'lumen.ssmData.active': 'Active',
  'lumen.ssmData.inactive': 'Inactive',
  'lumen.ssmData.viewDetails': 'View Details',
  'lumen.ssmData.edit': 'Edit',
  'lumen.ssmData.delete': 'Delete',
  'lumen.ssmData.noData': 'No data found',
  'lumen.ssmData.showing': 'Showing {n} of {total} items',
  'lumen.ssmData.step.pemberitahuan': 'Pemberitahuan',
  'lumen.ssmData.step.transportasi': 'Transportasi',
  'lumen.ssmData.step.dokumen': 'Dokumen',
  'lumen.ssmData.step.komoditi': 'Komoditi',
  'lumen.ssmData.step.layanan': 'Layanan',
  'lumen.ssmData.formMeta': 'No Pengajuan : | Jenis API : 02',
  'lumen.ssmData.formTitle': 'Data Pemberitahuan',
  'lumen.ssmData.tabUtama': 'Data Utama',
  'lumen.ssmData.tabEntitas': 'Data Entitas',
  'lumen.ssmData.tabPungutan': 'Data Pungutan',
  'lumen.ssmData.nomerPengajuan': 'Nomer Pengajuan',
  'lumen.ssmData.tanggalPengajuan': 'Tanggal Pengajuan',
  'lumen.ssmData.nomorPendaftaran': 'Nomor Pendaftaran',
  'lumen.ssmData.tanggalPendaftaran': 'Tanggal Pendaftaran',
  'lumen.ssmData.kantorPabean': 'Kantor Pabean',
  'lumen.ssmData.skepFasilitas': 'SKEP Fasilitas',
  'lumen.ssmData.jenisPib': 'Jenis PIB',
  'lumen.ssmData.jenisImpor': 'Jenis Impor',
  'lumen.ssmData.caraPembayaran': 'Cara Pembayaran',
  'lumen.ssmData.transaksi': 'Transaksi',
  'lumen.ssmData.kodePembayaran': 'Kode Pembayaran',
  'lumen.ssmData.previous': 'Sebelumnya',
  'lumen.ssmData.next': 'Selanjutnya',
  'lumen.ssmData.opt.kantorPabean.kpu_tanjung_priok': 'KPU TANJUNG PRIOK',
  'lumen.ssmData.opt.kantorPabean.kpu_soekarno_hatta': 'KPU SOEKARNO HATTA',
  'lumen.ssmData.opt.kantorPabean.kpu_juanda': 'KPU JUANDA',
  'lumen.ssmData.opt.skepFasilitas.asean_china_fta': 'PREFERENSI TARIF IMPORTASI ASEAN-CHINA FTA',
  'lumen.ssmData.opt.skepFasilitas.asean_korea_fta': 'PREFERENSI TARIF IMPORTASI ASEAN-KOREA FTA',
  'lumen.ssmData.opt.skepFasilitas.asean_india_fta': 'PREFERENSI TARIF IMPORTASI ASEAN-INDIA FTA',
  'lumen.ssmData.opt.jenisPib.biasa': 'Biasa',
  'lumen.ssmData.opt.jenisPib.khusus': 'Khusus',
  'lumen.ssmData.opt.jenisPib.sementara': 'Sementara',
  'lumen.ssmData.opt.jenisImpor.untuk_dipakai': 'UNTUK DIPAKAI',
  'lumen.ssmData.opt.jenisImpor.sementara': 'SEMENTARA',
  'lumen.ssmData.opt.jenisImpor.angkutan': 'ANGKUTAN',
  'lumen.ssmData.opt.caraPembayaran.biasa_tunai': 'BIASA/TUNAI',
  'lumen.ssmData.opt.caraPembayaran.kredit': 'KREDIT',
  'lumen.ssmData.opt.caraPembayaran.transfer': 'TRANSFER',
  'lumen.ssmData.opt.transaksi.perdagangan': 'Transaksi Perdagangan Atau Cara Pemi',
  'lumen.ssmData.opt.transaksi.non_perdagangan': 'Non Perdagangan',

  'lumen.shell.menu': 'Menu',
  'lumen.shell.menuDescription': 'Navigasi utama aplikasi',
  // ---- Lumen shell: sidebar ----
  'lumen.sidebar.navLabel': 'Menu utama',
  'lumen.sidebar.locked': 'Modul belum aktif',
  // ---- Lumen shell: reviewer area and feature lock ----
  // The old screens showed this copy as literals, one language for everyone; kept verbatim (copy decision).
  'lumen.reviewer.dashboard': 'Dashboard',
  'lumen.reviewer.role': 'Reviewer',
  'lumen.reviewer.logout': 'Logout',
  // ---- Lumen master B (revamp PR 4): customer-email-forwarding, sea-carriers, revoke-access, consignee ----
  // The old pages' literal copy is kept verbatim in every language; labels new components need are translated.
  'lumen.customerEmailForwarding.title': 'CEISA Customer Email Forwarding',
  'lumen.customerEmailForwarding.description': 'Kelola mapping importir dan penerima email forwarding CEISA.',
  'lumen.customerEmailForwarding.addMapping': 'Tambah Mapping',
  'lumen.customerEmailForwarding.editMappingTitle': 'Edit Mapping',
  'lumen.customerEmailForwarding.failed': 'Gagal',
  'lumen.customerEmailForwarding.importirLoadFailed': 'Daftar importir tidak dapat dimuat.',
  'lumen.customerEmailForwarding.loadFailedTitle': 'Data tidak dapat dimuat',
  'lumen.customerEmailForwarding.tenantImportirLoadFailed': 'Daftar importir tenant tidak dapat dimuat.',
  'lumen.customerEmailForwarding.filterImportir': 'Filter importir',
  'lumen.customerEmailForwarding.loadingImportir': 'Memuat importir...',
  'lumen.customerEmailForwarding.importirPlaceholder': 'Cari nama atau NPWP importir',
  'lumen.customerEmailForwarding.searchMapping': 'Cari mapping',
  'lumen.customerEmailForwarding.searchPlaceholder': 'Nama atau NPWP importir',
  'lumen.customerEmailForwarding.importir': 'Importir',
  'lumen.customerEmailForwarding.recipients': 'Penerima',
  'lumen.customerEmailForwarding.status': 'Status',
  'lumen.customerEmailForwarding.active': 'Aktif',
  'lumen.customerEmailForwarding.inactive': 'Nonaktif',
  'lumen.customerEmailForwarding.actions': 'Aksi',
  'lumen.customerEmailForwarding.manageRecipients': 'Kelola penerima',
  'lumen.customerEmailForwarding.editMapping': 'Edit mapping',
  'lumen.customerEmailForwarding.deactivateMapping': 'Nonaktifkan mapping',
  'lumen.customerEmailForwarding.activateMapping': 'Aktifkan mapping',
  'lumen.customerEmailForwarding.importirRequired': 'Importir wajib dipilih.',
  'lumen.customerEmailForwarding.importirUnavailable': 'Importir tidak tersedia untuk tenant ini.',
  'lumen.customerEmailForwarding.cancel': 'Batal',
  'lumen.customerEmailForwarding.save': 'Simpan',
  'lumen.customerEmailForwarding.recipientsTitle': 'Penerima Email',
  'lumen.customerEmailForwarding.showInactive': 'Tampilkan penerima nonaktif',
  'lumen.customerEmailForwarding.inactiveLoadFailed': 'Penerima nonaktif tidak dapat dimuat.',
  'lumen.customerEmailForwarding.name': 'Nama',
  'lumen.customerEmailForwarding.email': 'Email',
  'lumen.customerEmailForwarding.emailPlaceholder': 'nama@perusahaan.com',
  'lumen.customerEmailForwarding.editRecipient': 'Edit Penerima',
  'lumen.customerEmailForwarding.addRecipient': 'Tambah Penerima',
  'lumen.customerEmailForwarding.nameRequired': 'Nama penerima wajib diisi.',
  'lumen.customerEmailForwarding.emailInvalid': 'Masukkan alamat email yang valid.',
  'lumen.customerEmailForwarding.activateRecipient': 'Aktifkan penerima',
  'lumen.customerEmailForwarding.deactivateRecipient': 'Nonaktifkan penerima',
  'lumen.customerEmailForwarding.noImportir': 'Importir tidak ditemukan',
  'lumen.customerEmailForwarding.clearImportir': 'Hapus filter importir',
  'lumen.seaCarriers.title': 'Sea Carriers',
  'lumen.seaCarriers.description': 'Upload a CSV or TXT file containing sea carrier data.',
  'lumen.seaCarriers.dropTitle': 'Click or drag & drop to upload',
  'lumen.seaCarriers.accepted': 'Accepted formats: .csv, .txt',
  'lumen.seaCarriers.size': '{n} KB',
  'lumen.seaCarriers.submit': 'Submit',
  'lumen.seaCarriers.invalidTitle': 'Invalid file type',
  'lumen.seaCarriers.invalidMsg': 'Only .csv or .txt files are accepted.',
  'lumen.seaCarriers.successTitle': 'Upload successful',
  'lumen.seaCarriers.successMsg': 'Sea carriers file has been uploaded successfully.',
  'lumen.seaCarriers.failedTitle': 'Upload failed',
  'lumen.seaCarriers.failedMsg': 'An error occurred while uploading the file.',
  'lumen.seaCarriers.removeFile': 'Hapus file',
  'lumen.revokeAccess.title': 'Revoke Access by PPJK NPWP',
  'lumen.revokeAccess.description':
    "Block or unblock a PPJK's CEISA access. Blocking revokes all active tokens immediately.",
  'lumen.revokeAccess.warning': 'This action affects all app users tied to the given PPJK NPWP. Use with care.',
  'lumen.revokeAccess.npwp': 'PPJK NPWP',
  'lumen.revokeAccess.placeholder': 'e.g. 0029326105001000',
  'lumen.revokeAccess.unblock': 'Unblock',
  'lumen.revokeAccess.block': 'Block / Revoke Access',
  'lumen.revokeAccess.validationTitle': 'Validation Error',
  'lumen.revokeAccess.npwpRequired': 'PPJK NPWP is required',
  'lumen.revokeAccess.success': 'Success',
  'lumen.revokeAccess.blocked': 'PPJK blocked successfully',
  'lumen.revokeAccess.unblocked': 'PPJK unblocked successfully',
  'lumen.revokeAccess.error': 'Error',
  'lumen.revokeAccess.requestFailed': 'Request failed',
  'lumen.revokeAccess.resultNpwp': 'NPWP:',
  'lumen.revokeAccess.resultState': 'State:',
  'lumen.revokeAccess.stateBlocked': 'BLOCKED',
  'lumen.revokeAccess.stateUnblocked': 'UNBLOCKED',
  'lumen.revokeAccess.appUsersAffected': 'App Users Affected:',
  'lumen.revokeAccess.ceisaUsersHit': 'CEISA Users Hit:',
  'lumen.revokeAccess.ceisaAccountsHit': 'CEISA Accounts Hit:',
  'lumen.revokeAccess.tokensRevoked': 'Tokens Revoked:',
  'lumen.revokeAccess.appUserIds': 'App User IDs:',

  // ---- Lumen manifest/guardian/radar (revamp PR 5, unit R) ----
  // The old page's literal text, verbatim in every language (copy unchanged). New, the same in every language:
  // dotLabel (each radar dot's accessible name, only placeholders and separators) and the table view's title and
  // column headers (tableTitle, col*), in English like the detail card's labels. The rail toggle is lumen.table.*.
  'lumen.manifestRadar.title': 'Orbital Radar',
  'lumen.manifestRadar.ppjk': 'PPJK {npwp}',
  'lumen.manifestRadar.ppjkAll': 'all',
  'lumen.manifestRadar.refresh': 'Refresh',
  'lumen.manifestRadar.windowHours': 'Window (h)',
  'lumen.manifestRadar.pastHours': 'Past (h)',
  'lumen.manifestRadar.critHours': 'Critical ≤ (h)',
  'lumen.manifestRadar.warnHours': 'Warning ≤ (h)',
  'lumen.manifestRadar.direction': 'Direction',
  'lumen.manifestRadar.both': 'Both',
  'lumen.manifestRadar.inward': 'Inward',
  'lumen.manifestRadar.outward': 'Outward',
  'lumen.manifestRadar.status': 'Status (CSV)',
  'lumen.manifestRadar.statusPlaceholder': 'DRAFT,SENT',
  'lumen.manifestRadar.apply': 'Apply',
  'lumen.manifestRadar.counts': 'Counts',
  'lumen.manifestRadar.critical': 'Critical',
  'lumen.manifestRadar.warning': 'Warning',
  'lumen.manifestRadar.normal': 'Normal',
  'lumen.manifestRadar.overdue': 'Overdue',
  'lumen.manifestRadar.done': 'Done',
  'lumen.manifestRadar.active': 'Active',
  'lumen.manifestRadar.loading': 'Memuat radar...',
  'lumen.manifestRadar.toastError': 'Gagal',
  'lumen.manifestRadar.loadFailed': 'Gagal memuat timeline radar',
  'lumen.manifestRadar.eyebrow': 'Manifest · Orbital Radar',
  'lumen.manifestRadar.headline': '{critical} critical · {warning} warning',
  'lumen.manifestRadar.tRange': 'T-RANGE: {h}h',
  'lumen.manifestRadar.scan': 'SCAN: {time} WIB',
  'lumen.manifestRadar.ringHours': '{h}h',
  'lumen.manifestRadar.axisInward': '↑ INWARD · ETA',
  'lumen.manifestRadar.axisOutward': '↓ OUTWARD · ETD',
  'lumen.manifestRadar.sevCritical': 'CRITICAL',
  'lumen.manifestRadar.sevWarning': 'WARNING',
  'lumen.manifestRadar.sevNormal': 'NORMAL',
  'lumen.manifestRadar.legendInward': '▲ INWARD',
  'lumen.manifestRadar.legendOutward': '▼ OUTWARD',
  'lumen.manifestRadar.manifestId': 'Manifest #{id}',
  'lumen.manifestRadar.bl': 'BL · {bl}',
  'lumen.manifestRadar.eta': 'ETA',
  'lumen.manifestRadar.etd': 'ETD',
  'lumen.manifestRadar.detailStatus': 'Status',
  'lumen.manifestRadar.dotLabel': '{severity} · {countdown} · {aju} · {direction}',
  'lumen.manifestRadar.tableTitle': 'Manifests',
  'lumen.manifestRadar.colAjuBl': 'AJU / BL',
  'lumen.manifestRadar.colSeverity': 'Severity',
  'lumen.manifestRadar.colCountdown': 'Countdown',
  'lumen.manifestRadar.colVesselVoyage': 'Vessel / Voyage',
  'lumen.manifestRadar.colRoute': 'Route',
  'lumen.manifestRadar.colEvent': 'ETA/ETD',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 C): the Container section (table, Host BL filter, the
  // Tambah / Edit / Attach dialogs, their toasts). The old text verbatim in every language (copy unchanged, mixed English
  // and Indonesian as before); {filtered}, {total}, {plural}, {size}, {n}, {ok}, {fail}, {host} and {message} are filled
  // with formatTemplate. The code lists (Ukuran, Jenis, Type) stay as constants (i1 §11 settled 2). Error, Success and
  // Cancel reuse lumen.common.*.
  'lumen.manifestEngine.container.title': 'All Containers from BLs',
  'lumen.manifestEngine.container.showing': 'Showing: {filtered} of {total} container{plural}',
  'lumen.manifestEngine.container.add': 'Tambah Container',
  'lumen.manifestEngine.container.filterPlaceholder': 'Filter by Host BL',
  'lumen.manifestEngine.container.allHostBls': 'All Host BLs',
  'lumen.manifestEngine.container.noResults': 'No results found.',
  'lumen.manifestEngine.container.clearFilter': 'Clear selection',
  'lumen.manifestEngine.container.colNoPos': 'No Pos',
  'lumen.manifestEngine.container.colMasterBl': 'Master BL',
  'lumen.manifestEngine.container.colHostBl': 'Host BL',
  'lumen.manifestEngine.container.colNomor': 'Nomor Container',
  'lumen.manifestEngine.container.colUkuran': 'Ukuran',
  'lumen.manifestEngine.container.colJenis': 'Jenis',
  'lumen.manifestEngine.container.colType': 'Type',
  'lumen.manifestEngine.container.colAksi': 'Aksi',
  'lumen.manifestEngine.container.feet': '{size} FEET',
  'lumen.manifestEngine.container.edit': 'Edit Container',
  'lumen.manifestEngine.container.attach': 'Attach to BL',
  'lumen.manifestEngine.container.delete': 'Delete Container',
  'lumen.manifestEngine.container.info': 'Info',
  'lumen.manifestEngine.container.deletingTitle': 'Deleting...',
  'lumen.manifestEngine.container.partialTitle': 'Partial Success',
  'lumen.manifestEngine.container.idNotFound': 'Container ID not found',
  'lumen.manifestEngine.container.deleting': 'Menghapus container...',
  'lumen.manifestEngine.container.deleted': 'Container berhasil dihapus',
  'lumen.manifestEngine.container.deleteFailed': 'Failed to delete container',
  'lumen.manifestEngine.container.deleteFailedWith': 'Failed to delete container: {message}',
  'lumen.manifestEngine.container.numberRequired': 'Container number is required',
  'lumen.manifestEngine.container.pickBl': 'Please select at least 1 BL to attach this container',
  'lumen.manifestEngine.container.pickSize': 'Please select Ukuran Container',
  'lumen.manifestEngine.container.added': 'Container added successfully to {n} BL(s)',
  'lumen.manifestEngine.container.addFailed': 'Failed to add container',
  'lumen.manifestEngine.container.addFailedWith': 'Failed to add container: {message}',
  'lumen.manifestEngine.container.noEditing': 'No container selected for editing',
  'lumen.manifestEngine.container.numberEmpty': 'Container number cannot be empty',
  'lumen.manifestEngine.container.noChanges': 'No changes made to container',
  'lumen.manifestEngine.container.blNotFound': 'BL not found',
  'lumen.manifestEngine.container.notInBl': 'Container not found in BL',
  'lumen.manifestEngine.container.updated': 'Container number updated successfully',
  'lumen.manifestEngine.container.updateFailed': 'Failed to update container',
  'lumen.manifestEngine.container.updateFailedWith': 'Failed to update container: {message}',
  'lumen.manifestEngine.container.noSelected': 'No container selected',
  'lumen.manifestEngine.container.noChangesToSave': 'No changes to save',
  'lumen.manifestEngine.container.attached': 'Container attached/detached successfully ({n} BL(s) updated)',
  'lumen.manifestEngine.container.partial': 'Success: {ok} BL(s), Failed: {fail} BL(s)',
  'lumen.manifestEngine.container.attachFailedWith': 'Failed to attach container: {message}',
  'lumen.manifestEngine.container.attachTitle': 'Attach Container to BLs',
  'lumen.manifestEngine.container.containerInfo': 'Container Information',
  'lumen.manifestEngine.container.infoNomor': 'Nomor:',
  'lumen.manifestEngine.container.infoUkuran': 'Ukuran:',
  'lumen.manifestEngine.container.infoJenis': 'Jenis:',
  'lumen.manifestEngine.container.infoType': 'Type:',
  'lumen.manifestEngine.container.pickAttach': 'Select BLs to attach this container (can select multiple):',
  'lumen.manifestEngine.container.pickAddBefore': 'Select BLs to attach this container',
  'lumen.manifestEngine.container.pickAddAfter': '(must select at least 1):',
  'lumen.manifestEngine.container.selectAll': 'Pilih Semua',
  'lumen.manifestEngine.container.hostBlLine': 'Host BL: {host}',
  'lumen.manifestEngine.container.saveAttach': 'Save ({n} BL{plural} selected)',
  'lumen.manifestEngine.container.editTitle': 'Edit Container',
  'lumen.manifestEngine.container.blInfo': 'BL Information',
  'lumen.manifestEngine.container.hostBl': 'Host BL:',
  'lumen.manifestEngine.container.saveChanges': 'Save Changes',
  'lumen.manifestEngine.container.addTitle': 'Tambah Container',
  'lumen.manifestEngine.container.addSubmit': 'Add Container ({n} BL{plural} selected)',
  'lumen.manifestEngine.container.nomorContainer': 'Nomor Container',
  'lumen.manifestEngine.container.ukuranContainer': 'Ukuran Container',
  'lumen.manifestEngine.container.jenisContainer': 'Jenis Container',
  'lumen.manifestEngine.container.typeContainer': 'Type Container',
  'lumen.manifestEngine.container.nomorSegel': 'Nomor Segel',
  'lumen.manifestEngine.container.nomorPolisi': 'Nomor Polisi',
  'lumen.manifestEngine.container.driver': 'Driver',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 C): the Barang section (table, Combine / Slice views,
  // Edit Barang, its toasts). The old text verbatim in every language; {filtered}, {total} and {message} are filled with
  // formatTemplate. The filter's texts and the Info title are the Container block's.
  'lumen.manifestEngine.barang.title': 'All Barang from BLs',
  'lumen.manifestEngine.barang.combine': 'Combine Goods',
  'lumen.manifestEngine.barang.uncombine': 'Uncombine Goods',
  'lumen.manifestEngine.barang.slice': 'Slice HS Codes (4 Digits)',
  'lumen.manifestEngine.barang.unslice': 'Unslice HS Codes',
  'lumen.manifestEngine.barang.showing': 'Showing: {filtered} of {total} barang',
  'lumen.manifestEngine.barang.colNoPos': 'No Pos',
  'lumen.manifestEngine.barang.colNoPeb': 'No. PEB',
  'lumen.manifestEngine.barang.colNoAwb': 'No. AWB',
  'lumen.manifestEngine.barang.colMasterAwb': 'Master AWB',
  'lumen.manifestEngine.barang.colHostAwb': 'Host AWB',
  'lumen.manifestEngine.barang.colNoBl': 'No. BL',
  'lumen.manifestEngine.barang.colMasterBl': 'Master BL',
  'lumen.manifestEngine.barang.colHostBl': 'Host BL',
  'lumen.manifestEngine.barang.colKodeHs': 'Kode HS',
  'lumen.manifestEngine.barang.colUraianHs': 'Uraian HS',
  'lumen.manifestEngine.barang.colAksi': 'Aksi',
  'lumen.manifestEngine.barang.edit': 'Edit Barang',
  'lumen.manifestEngine.barang.editTitle': 'Edit Barang',
  'lumen.manifestEngine.barang.barangInfo': 'Barang Information',
  'lumen.manifestEngine.barang.blLine': 'BL:',
  'lumen.manifestEngine.barang.kodeHs': 'Kode HS',
  'lumen.manifestEngine.barang.kodeHsPlaceholder': 'Enter Kode HS',
  'lumen.manifestEngine.barang.previous': 'Previous:',
  'lumen.manifestEngine.barang.uraianHs': 'Uraian HS',
  'lumen.manifestEngine.barang.uraianHsPlaceholder': 'Enter Uraian HS',
  'lumen.manifestEngine.barang.saveChanges': 'Save Changes',
  'lumen.manifestEngine.barang.noBarang': 'No barang selected for editing',
  'lumen.manifestEngine.barang.kodeEmpty': 'Kode HS cannot be empty',
  'lumen.manifestEngine.barang.uraianEmpty': 'Uraian HS cannot be empty',
  'lumen.manifestEngine.barang.noChanges': 'No changes made to barang',
  'lumen.manifestEngine.barang.blNotFound': 'BL not found',
  'lumen.manifestEngine.barang.notInBl': 'Barang not found in BL',
  'lumen.manifestEngine.barang.updated': 'Barang updated successfully',
  'lumen.manifestEngine.barang.updateFailed': 'Failed to update barang',
  'lumen.manifestEngine.barang.updateFailedWith': 'Failed to update barang: {message}',

  // ---- Lumen manifest/product + manifest/product/upload (revamp PR 6a, unit P) ----
  // Both pages' literal text, verbatim in every language (copy unchanged). Toast titles "Error" are lumen.common.error;
  // the upload kit keeps its upload.* keys and the Excel hook its own toasts.
  'lumen.manifestProduct.pill': 'Kelola Manifest dengan Mudah dan Cepat',
  'lumen.manifestProduct.titleCategory': 'Pilih Jalur Manifest',
  'lumen.manifestProduct.titleDirection': 'Pilih Arah Manifest',
  'lumen.manifestProduct.subtitleCategory': 'Mulai proses manifest dengan memilih jalur pengiriman terlebih dahulu',
  'lumen.manifestProduct.subtitleDirection': 'Tentukan arah manifest untuk melanjutkan proses',
  'lumen.manifestProduct.pickedLabel': 'Jalur terpilih:',
  'lumen.manifestProduct.udara': 'Udara',
  'lumen.manifestProduct.laut': 'Laut',
  'lumen.manifestProduct.changeCategory': 'Ganti Jalur',
  'lumen.manifestProduct.categoryUdaraTitle': 'Manifest - Udara',
  'lumen.manifestProduct.categoryUdaraDesc': 'Pilih jalur udara untuk proses manifest',
  'lumen.manifestProduct.categoryLautTitle': 'Manifest - Laut',
  'lumen.manifestProduct.categoryLautDesc': 'Pilih jalur laut untuk proses manifest',
  'lumen.manifestProduct.pickCategory': 'Pilih Jalur',
  'lumen.manifestProduct.pick': 'Pilih',
  'lumen.manifestProduct.start': 'Mulai',
  'lumen.manifestProduct.inwardUdaraTitle': 'Inward Manifest - Udara',
  'lumen.manifestProduct.inwardUdaraDesc': 'Manifest untuk barang masuk melalui jalur udara',
  'lumen.manifestProduct.outwardUdaraTitle': 'Outward Manifest - Udara',
  'lumen.manifestProduct.outwardUdaraDesc': 'Manifest untuk barang keluar melalui jalur udara',
  'lumen.manifestProduct.inwardLautTitle': 'Inward Manifest - Laut',
  'lumen.manifestProduct.inwardLautDesc': 'Manifest untuk barang masuk melalui jalur laut',
  'lumen.manifestProduct.outwardLautTitle': 'Outward Manifest - Laut',
  'lumen.manifestProduct.outwardLautDesc': 'Manifest untuk barang keluar melalui jalur laut',
  'lumen.manifestProduct.popular': 'Popular',
  'lumen.manifestProduct.methodTitle': 'Pilih Metode Input',
  'lumen.manifestProduct.methodBody': 'Pilih metode yang ingin Anda gunakan untuk mengisi {title}',
  'lumen.manifestProduct.aiTitle': 'AI Assistant',
  'lumen.manifestProduct.aiDesc': 'Biarkan AI membantu mengisi form dengan cepat dan akurat',
  'lumen.manifestProduct.manualTitle': 'Manual Input',
  'lumen.manifestProduct.manualDesc': 'Isi form secara manual dengan kontrol penuh',
  'lumen.manifestProduct.back': 'Kembali',
  'lumen.manifestProduct.uploadTitle': 'Upload Dokumen Manifest {direction} {mode}',
  'lumen.manifestProduct.uploadTitleMode': '- {mode}',
  'lumen.manifestProduct.inward': 'Inward',
  'lumen.manifestProduct.outward': 'Outward',
  'lumen.manifestProduct.tabPdf': 'Upload PDF',
  'lumen.manifestProduct.tabExcel': 'Upload Excel',
  'lumen.manifestProduct.docsReady': '{n} dokumen siap diupload',
  'lumen.manifestProduct.docsGrouped': '{n} dokumen telah dikelompokkan',
  'lumen.manifestProduct.succeeded': '{n} berhasil',
  'lumen.manifestProduct.failed': '{n} gagal',
  'lumen.manifestProduct.reset': 'Reset',
  'lumen.manifestProduct.uploading': 'Uploading... {p}%',
  'lumen.manifestProduct.processing': 'Processing...',
  'lumen.manifestProduct.toReview': 'Lanjut ke Review',
  'lumen.manifestProduct.uploadN': 'Upload {n} Dokumen',
  'lumen.manifestProduct.process': 'Process',
  'lumen.manifestProduct.grouping': 'Mengelompokkan dokumen berdasarkan jenis...',
  'lumen.manifestProduct.fileFailed': 'Gagal mengupload file. Silakan coba lagi.',
  'lumen.manifestProduct.noFileTitle': 'Tidak ada file',
  'lumen.manifestProduct.noFileBody': 'Silakan tambahkan file terlebih dahulu',
  'lumen.manifestProduct.noTypeTitle': 'Jenis dokumen belum dipilih',
  'lumen.manifestProduct.noTypeBody': '{n} file belum memiliki jenis dokumen',
  'lumen.manifestProduct.extractFailed': 'Gagal memulai ekstraksi manifest',
  'lumen.manifestProduct.uploadDoneTitle': 'Upload Selesai',
  'lumen.manifestProduct.uploadDoneBody': '{s} dari {t} dokumen berhasil diupload.',
  'lumen.manifestProduct.uploadError': 'Terjadi kesalahan saat mengupload dokumen: {message}',
  'lumen.manifestProduct.noBatch': 'Batch UUID tidak ditemukan. Silakan upload dokumen terlebih dahulu.',
  'lumen.manifestProduct.excelTitle': 'Upload Draft Manifest via Excel',
  'lumen.manifestProduct.excelSubtitle':
    'Upload 1 file Excel (.xls atau .xlsx) untuk membuat draft manifest secara langsung.',
  'lumen.manifestProduct.excelDrop': 'Tarik & lepas file Excel di sini',
  'lumen.manifestProduct.excelHint': 'Maksimal 1 file dengan format .xls atau .xlsx',
  'lumen.manifestProduct.excelPick': 'Pilih File Excel',
  'lumen.manifestProduct.excelRemove': 'Hapus File',
  'lumen.manifestProduct.excelRejected': 'Gunakan 1 file Excel (.xls atau .xlsx) untuk melanjutkan upload.',
  'lumen.manifestProduct.excelNoFile': 'Silakan pilih 1 file Excel terlebih dahulu.',
  'lumen.manifestProduct.excelUploading': 'Mengunggah file...',
  'lumen.manifestProduct.excelProcessing': 'Memproses manifest...',
  'lumen.manifestProduct.excelReady': '1 file Excel siap diproses',
  'lumen.manifestProduct.excelNone': 'Belum ada file Excel yang dipilih',
  'lumen.manifestProduct.excelNote': 'File Excel akan diproses dengan flow terpisah dari upload PDF.',
  'lumen.manifestProduct.excelContinue': 'Lanjutkan Upload Excel',
  'lumen.manifestProduct.excelBatchMissing': 'Batch UUID tidak ditemukan dari response upload.',
  'lumen.manifestProduct.excelUrlMissing': 'URL file hasil upload tidak ditemukan.',
  'lumen.manifestProduct.excelFailed': 'Upload Excel gagal diproses.',
  'lumen.manifestProduct.extractTitle': 'Mengekstraksi Manifest',
  'lumen.manifestProduct.extractDoneTitle': 'Ekstraksi Selesai!',
  'lumen.manifestProduct.extractBody': 'AI sedang membaca dan mengekstrak data dari dokumen Anda',
  'lumen.manifestProduct.extractDoneBody': 'Semua dokumen berhasil diekstraksi',
  'lumen.manifestProduct.startedAt': 'Mulai',
  'lumen.manifestProduct.duration': 'Durasi',
  'lumen.manifestProduct.statDone': 'Selesai',
  'lumen.manifestProduct.statRunning': 'Proses',
  'lumen.manifestProduct.statFailed': 'Gagal',
  'lumen.manifestProduct.statTotal': 'Total',
  'lumen.manifestProduct.viewResults': 'Lihat Hasil Ekstraksi',

  // ---- Lumen manifest form engine (revamp PR 6b): the page shell and the Header pilot (wave 1 F) ----
  // The old page's literal text, verbatim in every language (copy unchanged); {message}, {status}, {when}, {label},
  // {list} and {imo} are filled with formatTemplate, and **…** marks the bold words of a dialog line. New labels the
  // new parts need (sections, sectionDone/Todo, summary*, completeness, security, header.time/timeDone) are Indonesian
  // like the page. Wave 2 adds its own blocks (masterBl, bl, blEditor, container, barang, submit, susulan).
  'lumen.manifestEngine.shell.back': 'Back',
  'lumen.manifestEngine.shell.inward': 'Inward',
  'lumen.manifestEngine.shell.outward': 'Outward',
  'lumen.manifestEngine.shell.air': 'Air',
  'lumen.manifestEngine.shell.sea': 'Sea',
  'lumen.manifestEngine.shell.lihatDiCeisa': 'Lihat di Ceisa',
  'lumen.manifestEngine.shell.hapusAju': 'Hapus Aju Di Ceisa',
  'lumen.manifestEngine.shell.cekLengkap': 'Cek Lengkap',
  'lumen.manifestEngine.shell.submitDraft': 'Submit Draft',
  'lumen.manifestEngine.shell.prosesPenerimaan': 'Proses Penerimaan',
  'lumen.manifestEngine.shell.header': 'Header',
  'lumen.manifestEngine.shell.masterBl': 'Master BL',
  'lumen.manifestEngine.shell.masterAwb': 'Master AWB',
  'lumen.manifestEngine.shell.bl': 'BL',
  'lumen.manifestEngine.shell.awb': 'AWB',
  'lumen.manifestEngine.shell.container': 'Container',
  'lumen.manifestEngine.shell.barang': 'Barang',
  'lumen.manifestEngine.shell.previous': 'Sebelumnya',
  'lumen.manifestEngine.shell.next': 'Selanjutnya',
  'lumen.manifestEngine.shell.secureTitle': 'Secure & Private',
  'lumen.manifestEngine.shell.secureBody': 'Protected by enterprise-grade security',
  'lumen.manifestEngine.shell.ownershipTitle': 'Data Ownership',
  'lumen.manifestEngine.shell.ownershipBody': 'Your data belongs to you, always',
  'lumen.manifestEngine.shell.bankTitle': 'Bank-Level Security',
  'lumen.manifestEngine.shell.bankBody': 'Military-grade protection for your business',
  'lumen.manifestEngine.shell.loading': 'Loading document data',
  'lumen.manifestEngine.shell.loadingBody': 'This may take a moment as we process your document.',
  'lumen.manifestEngine.shell.savingTitle': 'Saving...',
  'lumen.manifestEngine.shell.savingHeader': 'Menyimpan header data...',
  'lumen.manifestEngine.shell.headerSaved': 'Header data berhasil disimpan',
  'lumen.manifestEngine.shell.headerSaveFailed': 'Gagal menyimpan header data. Silakan coba lagi.',
  'lumen.manifestEngine.shell.loadFailed': 'Gagal memuat data manifest',
  'lumen.manifestEngine.shell.loadFailedWith': 'Gagal memuat data manifest: {message}',
  'lumen.manifestEngine.shell.ajuNotFound': 'Nomor AJU tidak ditemukan',
  'lumen.manifestEngine.shell.prosesOk': 'Proses kirim berhasil',
  'lumen.manifestEngine.shell.prosesFailed': 'Proses kirim gagal',
  'lumen.manifestEngine.shell.prosesError': 'Gagal proses kirim: {message}',
  'lumen.manifestEngine.shell.cekOk': 'Cek lengkap berhasil',
  'lumen.manifestEngine.shell.cekFailed': 'Cek lengkap gagal',
  'lumen.manifestEngine.shell.cekError': 'Gagal cek lengkap: {message}',
  'lumen.manifestEngine.shell.berhasil': 'Berhasil',
  'lumen.manifestEngine.shell.hapusOk': 'AJU berhasil dihapus dari CEISA. Memuat ulang data...',
  'lumen.manifestEngine.shell.hapusFailed': 'Gagal hapus AJU di CEISA',
  'lumen.manifestEngine.shell.hapusError': 'Gagal hapus AJU: {message}',
  'lumen.manifestEngine.shell.lengkapTitle': 'Data Lengkap!',
  'lumen.manifestEngine.shell.lengkapBody': 'Semua data manifest telah lengkap dan siap diproses',
  'lumen.manifestEngine.shell.lengkapStatus': 'Status: {status}',
  'lumen.manifestEngine.shell.mengerti': 'Mengerti',
  'lumen.manifestEngine.shell.hapusTitle': 'Konfirmasi Hapus AJU',
  'lumen.manifestEngine.shell.hapusBody':
    'Apakah Anda yakin ingin **menghapus AJU** ini dari CEISA? Tindakan ini tidak dapat dibatalkan.',
  'lumen.manifestEngine.shell.nomorAju': 'Nomor AJU',
  'lumen.manifestEngine.shell.yaHapus': 'Ya, Hapus',
  'lumen.manifestEngine.shell.prosesTitle': 'Konfirmasi Proses Penerimaan',
  'lumen.manifestEngine.shell.prosesBody':
    'Apakah Anda yakin ingin **mengirim (proses penerimaan)** manifest ini ke CEISA?',
  'lumen.manifestEngine.shell.yaProses': 'Ya, Proses Penerimaan',
  'lumen.manifestEngine.shell.sections': 'Bagian manifest',
  'lumen.manifestEngine.shell.sectionDone': 'lengkap',
  'lumen.manifestEngine.shell.sectionTodo': 'belum lengkap',
  'lumen.manifestEngine.shell.summary': 'Ringkasan',
  'lumen.manifestEngine.shell.summaryDirection': 'Arah',
  'lumen.manifestEngine.shell.summaryKantor': 'Kantor',
  'lumen.manifestEngine.shell.completeness': 'Kelengkapan',
  'lumen.manifestEngine.shell.security': 'Keamanan',
  'lumen.manifestEngine.shell.reminderLoading': 'Reminder...',
  'lumen.manifestEngine.shell.reminderOff': 'Reminder belum aktif',
  'lumen.manifestEngine.shell.reminderArmed': 'Reminder armed · {when}',
  'lumen.manifestEngine.shell.reminderCancelLabel': 'Cancel reminder',
  'lumen.manifestEngine.shell.reminderCancelTitle': 'Batalkan Reminder?',
  'lumen.manifestEngine.shell.reminderCancelBody':
    'Reminder yang sedang aktif akan dibatalkan. Tindakan ini tidak otomatis menghapus rule — rule tetap berjalan untuk manifest lain.',
  'lumen.manifestEngine.shell.reminderClose': 'Tutup',
  'lumen.manifestEngine.shell.reminderConfirm': 'Ya, Batalkan',
  'lumen.manifestEngine.shell.reminderCancelled': 'Reminder dibatalkan.',
  'lumen.manifestEngine.shell.reminderCancelFailed': 'Gagal membatalkan reminder',
  'lumen.manifestEngine.shell.reminderLoadFailed': 'Gagal memuat reminder',
  'lumen.manifestEngine.shell.gagal': 'Gagal',
  'lumen.manifestEngine.header.kantor': 'Pilih kantor pabean',
  'lumen.manifestEngine.header.required': 'Field ini wajib diisi',
  'lumen.manifestEngine.header.vessel': 'Nama Sarana Pengangkut',
  'lumen.manifestEngine.header.imo': 'Nomor IMO / Registrasi',
  'lumen.manifestEngine.header.updateImo': 'Update Nomor IMO',
  'lumen.manifestEngine.header.new': 'New',
  'lumen.manifestEngine.header.voyage': 'Nomor Voyage',
  'lumen.manifestEngine.header.tanggalBerangkat': 'Tanggal Berangkat',
  'lumen.manifestEngine.header.tanggalTiba': 'Tanggal Tiba',
  'lumen.manifestEngine.header.reference': 'Reference ID',
  'lumen.manifestEngine.header.referenceOptional': '{label} (opsional)',
  'lumen.manifestEngine.header.referenceRequired': '{label} wajib diisi',
  'lumen.manifestEngine.header.referenceHintSource': 'Pilih dari daftar job perusahaan Anda, atau ketik manual',
  'lumen.manifestEngine.header.referenceHintFree': 'ID internal dari sistem Anda, mis. nomor PO/Job',
  'lumen.manifestEngine.header.referenceUnavailable':
    'Daftar job sedang tidak tersedia — silakan ketik nomornya manual.',
  'lumen.manifestEngine.header.duplicateWithAju': 'Reference ID ini sudah dipakai di AJU {list}',
  'lumen.manifestEngine.header.duplicateOther': 'Reference ID ini sudah dipakai di manifest lain',
  'lumen.manifestEngine.header.reusedTitle': 'Reference ID sudah dipakai',
  'lumen.manifestEngine.header.reusedWithAju': 'Reference ID ini juga dipakai di AJU {list}. Data tetap tersimpan.',
  'lumen.manifestEngine.header.reusedOther': 'Reference ID ini juga dipakai di manifest lain. Data tetap tersimpan.',
  'lumen.manifestEngine.header.imoNeedVessel': 'Masukkan nama sarana pengangkut terlebih dahulu',
  'lumen.manifestEngine.header.imoFound': 'Nomor IMO {imo} berhasil ditemukan',
  'lumen.manifestEngine.header.imoNotFoundTitle': 'Tidak ditemukan',
  'lumen.manifestEngine.header.imoNotFound': 'Nomor IMO tidak ditemukan untuk kapal ini',
  'lumen.manifestEngine.header.imoFailed': 'Gagal mencari nomor IMO',
  'lumen.manifestEngine.header.saveFailed': 'Gagal menyimpan header data',
  'lumen.manifestEngine.header.lookupLoading': 'Loading...',
  'lumen.manifestEngine.header.lookupEmpty': 'Tidak dapat menemukan',
  'lumen.manifestEngine.header.lookupFailed': 'Error when get {label}',
  'lumen.manifestEngine.header.time': 'Jam',
  'lumen.manifestEngine.header.timeDone': 'OK',
  // ---- end Lumen manifest/guardian/radar ----

  'lumen.consignee.namaPlaceholder': 'PT. CONTOH',
  // ---- end Lumen master B ----
  'lumen.featureLock.title': 'Fitur Belum Aktif',
  'lumen.featureLock.moduleInactive': 'Modul {module} belum aktif untuk perusahaan Anda.',
  'lumen.featureLock.thisModuleInactive': 'Modul ini belum aktif untuk perusahaan Anda.',
  'lumen.featureLock.contactAdmin': 'Silakan hubungi Admin Lumen untuk mengaktifkan fitur ini dan membahas pembayaran.',
  'lumen.featureLock.contactSales': 'Hubungi Customer Service',
  'lumen.featureLock.understood': 'Mengerti',
  // ---- Lumen master pages (P1): user, ceisa-user, export-bank, manifest-reminder, statement ----
  // The old pages' literal English, verbatim in every language (copy unchanged). Generic words are
  // lumen.common.* (Active, Cancel, Save, …); words two of these pages share live under the first one.
  // master/user
  'lumen.masterUser.searchPlaceholder': 'Search by name, email, ceisa user...',
  'lumen.masterUser.add': 'Add User',
  'lumen.masterUser.editTitle': 'Edit User',
  'lumen.masterUser.ceisaUser': 'Ceisa User',
  'lumen.masterUser.ceisaUserPlaceholder': 'Cari Ceisa User...',
  'lumen.masterUser.updated': 'User updated successfully',
  'lumen.masterUser.updateFailed': 'Failed to update user',
  'lumen.masterUser.created': 'User created successfully',
  'lumen.masterUser.createFailed': 'Failed to create user',
  // master/ceisa-user (also uses lumen.masterUser.add, updated, created and their failures)
  'lumen.masterCeisaUser.searchPlaceholder': 'Search by username, name, NPWP, company code...',
  'lumen.masterCeisaUser.editTitle': 'Edit Ceisa User',
  'lumen.masterCeisaUser.addTitle': 'Add Ceisa User',
  'lumen.masterCeisaUser.npwp': 'NPWP',
  'lumen.masterCeisaUser.npwpHint': 'Minimum 12 digits',
  'lumen.masterCeisaUser.companyCode': 'Company Code',
  'lumen.masterCeisaUser.address': 'Address',
  'lumen.masterCeisaUser.apiKey': 'API Key',
  'lumen.masterCeisaUser.apiKeyHint': 'CEISA beacukai-api-key',
  'lumen.masterCeisaUser.apiKeyEditHint': 'CEISA beacukai-api-key. Leave empty to clear.',
  'lumen.masterCeisaUser.applicationId': 'Application ID',
  'lumen.masterCeisaUser.lastSixDigitPrefix': 'Last Six Digit Prefix',
  'lumen.masterCeisaUser.npwpTooShort': 'NPWP must be at least 12 characters',
  'lumen.masterCeisaUser.deactivateTitle': 'Deactivate User',
  'lumen.masterCeisaUser.warning': 'Warning',
  'lumen.masterCeisaUser.deactivateConfirm':
    'Are you sure you want to deactivate user {username}? This action will set the user status to inactive.',
  'lumen.masterCeisaUser.deactivated': 'User deactivated successfully',
  'lumen.masterCeisaUser.deactivateFailed': 'Failed to deactivate user',
  // master/export-bank (the old page's own heading and line; Name is lumen.common.name)
  'lumen.masterExportBank.title': 'Export Bank',
  'lumen.masterExportBank.description': 'Manage the bank devisa catalogue used in export transaction forms.',
  'lumen.masterExportBank.searchPlaceholder': 'Search by code or name...',
  'lumen.masterExportBank.add': 'Add Export Bank',
  'lumen.masterExportBank.editTitle': 'Edit Export Bank',
  'lumen.masterExportBank.deleteTitle': 'Delete Export Bank',
  'lumen.masterExportBank.code': 'Code',
  'lumen.masterExportBank.codePlaceholder': 'e.g. BNI',
  'lumen.masterExportBank.namePlaceholder': 'Bank Name',
  'lumen.masterExportBank.activate': 'Activate',
  'lumen.masterExportBank.delete': 'Delete',
  'lumen.masterExportBank.required': 'Code and Name are required',
  'lumen.masterExportBank.created': 'Export bank created successfully',
  'lumen.masterExportBank.createFailed': 'Failed to create export bank',
  'lumen.masterExportBank.updated': 'Export bank updated successfully',
  'lumen.masterExportBank.updateFailed': 'Failed to update export bank',
  'lumen.masterExportBank.deactivated': 'Export bank deactivated',
  'lumen.masterExportBank.activated': 'Export bank activated',
  'lumen.masterExportBank.deleted': 'Export bank deleted successfully',
  'lumen.masterExportBank.deleteFailed': 'Failed to delete export bank',
  'lumen.masterExportBank.deleteConfirm':
    'Are you sure you want to delete bank {code} - {name}? This action cannot be undone.',
  // master/manifest-reminder (PPJK NPWP, MOT Type and the PPJK-required alert are lumen.common.*)
  'lumen.masterManifestReminder.searchPlaceholder': 'Search by email, direction, MOT...',
  'lumen.masterManifestReminder.add': 'Add Reminder',
  'lumen.masterManifestReminder.addTitle': 'Add Manifest Reminder',
  'lumen.masterManifestReminder.editTitle': 'Edit Manifest Reminder',
  'lumen.masterManifestReminder.direction': 'Direction',
  'lumen.masterManifestReminder.mot': 'MOT',
  'lumen.masterManifestReminder.refDate': 'Ref Date',
  'lumen.masterManifestReminder.offset': 'Offset',
  'lumen.masterManifestReminder.emails': 'Emails',
  'lumen.masterManifestReminder.referenceDate': 'Reference Date',
  'lumen.masterManifestReminder.offsetUnit': 'Offset Unit',
  'lumen.masterManifestReminder.offsetValue': 'Offset Value',
  'lumen.masterManifestReminder.emailsHint': 'Comma-separated email addresses',
  'lumen.masterManifestReminder.emailsPlaceholder': 'user@example.com,admin@example.com',
  'lumen.masterManifestReminder.emailsRequired': 'Please fill in the emails field',
  'lumen.masterManifestReminder.updated': 'Reminder config updated successfully',
  'lumen.masterManifestReminder.updateFailed': 'Failed to update reminder config',
  'lumen.masterManifestReminder.created': 'Reminder config created successfully',
  'lumen.masterManifestReminder.createFailed': 'Failed to create reminder config',
  'lumen.masterManifestReminder.deactivated': 'Reminder config deactivated successfully',
  'lumen.masterManifestReminder.deactivateFailed': 'Failed to deactivate reminder config',
  // ---- Lumen manifest/guardian (revamp PR 5, unit G) ----
  // The old page's literal text, verbatim in every language (copy unchanged). Active, Inactive, Edit, Create, Save,
  // Batal and PPJK NPWP are lumen.common.*.
  'lumen.manifestGuardian.title': 'The Guardian',
  'lumen.manifestGuardian.subtitle': 'Manifest reminder rules untuk PPJK {npwp}',
  'lumen.manifestGuardian.none': '—',
  'lumen.manifestGuardian.createRule': 'Create Rule',
  'lumen.manifestGuardian.colNo': '#',
  'lumen.manifestGuardian.manifestType': 'Manifest Type',
  'lumen.manifestGuardian.offset': 'Offset',
  'lumen.manifestGuardian.snooze': 'Snooze',
  'lumen.manifestGuardian.maxFires': 'Max Fires',
  'lumen.manifestGuardian.recipients': 'Recipients',
  'lumen.manifestGuardian.actions': 'Aksi',
  'lumen.manifestGuardian.offsetBefore': '{offset} sebelum',
  'lumen.manifestGuardian.snoozeEvery': 'setiap {snooze}',
  'lumen.manifestGuardian.unlimited': 'Unlimited',
  'lumen.manifestGuardian.delete': 'Delete',
  'lumen.manifestGuardian.loading': 'Memuat...',
  'lumen.manifestGuardian.noPpjk': 'PPJK NPWP tidak tersedia. Pastikan login.',
  'lumen.manifestGuardian.empty': 'Belum ada rule. Klik "Create Rule" untuk menambahkan.',
  'lumen.manifestGuardian.typeInwardAir': 'Inward Air',
  'lumen.manifestGuardian.typeInwardOcean': 'Inward Ocean',
  'lumen.manifestGuardian.typeOutwardAir': 'Outward Air',
  'lumen.manifestGuardian.typeOutwardOcean': 'Outward Ocean',
  'lumen.manifestGuardian.createTitle': 'Create Reminder Rule',
  'lumen.manifestGuardian.editTitle': 'Edit Reminder Rule',
  'lumen.manifestGuardian.typeLocked': 'Manifest type tidak bisa diubah — buat rule baru jika ingin tipe lain.',
  'lumen.manifestGuardian.offsetLabel': 'Offset (menit sebelum ETA/ETD)',
  'lumen.manifestGuardian.snoozeLabel': 'Snooze (menit)',
  'lumen.manifestGuardian.maxFireLabel': 'Max Fire Count (0 = unlimited)',
  'lumen.manifestGuardian.recipientsLabel': 'Recipients (comma-separated)',
  'lumen.manifestGuardian.recipientsPlaceholder': 'ops@dextercargo.com,manager@dextercargo.com',
  'lumen.manifestGuardian.deleteTitle': 'Hapus Rule?',
  'lumen.manifestGuardian.deleteBody':
    'Rule akan dihapus permanen. Reminder yang sedang berjalan untuk rule ini juga dibatalkan oleh backend pada fire berikutnya.',
  'lumen.manifestGuardian.deleteConfirm': 'Hapus',
  'lumen.manifestGuardian.toastSuccess': 'Berhasil',
  'lumen.manifestGuardian.toastError': 'Gagal',
  'lumen.manifestGuardian.toastWarning': 'Perhatian',
  'lumen.manifestGuardian.noPpjkWarning': 'PPJK NPWP belum tersedia. Pastikan login dengan PPJK terkait.',
  'lumen.manifestGuardian.recipientsRequired': 'Recipients wajib diisi.',
  'lumen.manifestGuardian.emailInvalid': 'Email tidak valid: {email}',
  'lumen.manifestGuardian.offsetPositive': 'Offset Minutes harus > 0.',
  'lumen.manifestGuardian.snoozePositive': 'Snooze Minutes harus > 0.',
  'lumen.manifestGuardian.maxFireNegative': 'Max Fire Count tidak boleh negatif (0 = unlimited).',
  'lumen.manifestGuardian.created': 'Rule berhasil dibuat.',
  'lumen.manifestGuardian.updated': 'Rule berhasil diperbarui.',
  'lumen.manifestGuardian.deleted': 'Rule berhasil dihapus.',
  'lumen.manifestGuardian.loadFailed': 'Gagal memuat daftar rule',
  'lumen.manifestGuardian.saveFailed': 'Gagal menyimpan rule',
  'lumen.manifestGuardian.deleteFailed': 'Gagal menghapus rule',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 M): the Master BL / AWB section ----
  // The old section's literal text, verbatim in every language (copy unchanged); {count}, {failed} and {message} are
  // filled with formatTemplate. Kelompok Pos option labels stay constants in master-bl.logic.ts (CEISA code names).
  'lumen.manifestEngine.masterBl.titleBl': 'Data Master BL',
  'lumen.manifestEngine.masterBl.titleAwb': 'Data Master AWB',
  'lumen.manifestEngine.masterBl.uploadBl': 'Upload Master BL',
  'lumen.manifestEngine.masterBl.uploadAwb': 'Upload Master AWB',
  'lumen.manifestEngine.masterBl.addBl': 'Tambah Master BL',
  'lumen.manifestEngine.masterBl.addAwb': 'Tambah Master AWB',
  'lumen.manifestEngine.masterBl.editBl': 'Edit Master BL',
  'lumen.manifestEngine.masterBl.editAwb': 'Edit Master AWB',
  'lumen.manifestEngine.masterBl.colKelompok': 'Kel. Pos',
  'lumen.manifestEngine.masterBl.colNomor': 'No Master',
  'lumen.manifestEngine.masterBl.colTanggal': 'Tgl. Master',
  'lumen.manifestEngine.masterBl.colJumlah': 'Jml Pos',
  'lumen.manifestEngine.masterBl.colAksi': 'Aksi',
  'lumen.manifestEngine.masterBl.attach': 'Attach to BL',
  'lumen.manifestEngine.masterBl.copy': 'Copy',
  'lumen.manifestEngine.masterBl.delete': 'Delete',
  'lumen.manifestEngine.masterBl.kelompokPos': 'Kelompok Pos',
  'lumen.manifestEngine.masterBl.nomorMaster': 'Nomor Master',
  'lumen.manifestEngine.masterBl.tanggalMaster': 'Tanggal Master',
  'lumen.manifestEngine.masterBl.required': 'Field ini wajib diisi',
  'lumen.manifestEngine.masterBl.noResults': 'No results found.',
  'lumen.manifestEngine.masterBl.matchedBl': '{count} Host BL ditemukan dengan nomor Master BL ini',
  'lumen.manifestEngine.masterBl.matchedAwb': '{count} Host AWB ditemukan dengan nomor Master AWB ini',
  'lumen.manifestEngine.masterBl.validationTitle': 'Validation Error',
  'lumen.manifestEngine.masterBl.validationBody': 'Silakan lengkapi semua field yang wajib diisi',
  'lumen.manifestEngine.masterBl.processingBl': 'Memproses Master BL...',
  'lumen.manifestEngine.masterBl.processingAwb': 'Memproses Master AWB...',
  'lumen.manifestEngine.masterBl.processingHint': 'Mohon tunggu, jangan tutup halaman.',
  'lumen.manifestEngine.masterBl.needHeader': 'Manifest belum tersedia. Simpan header dulu sebelum upload Master BL.',
  'lumen.manifestEngine.masterBl.noBatch': 'Batch UUID tidak ditemukan.',
  'lumen.manifestEngine.masterBl.badUpload': 'Upload response tidak mengandung file_url / file_id.',
  'lumen.manifestEngine.masterBl.extracted': 'Ekstraksi Master BL selesai. Memuat ulang data...',
  'lumen.manifestEngine.masterBl.uploadFailed': 'Gagal upload Master BL.',
  'lumen.manifestEngine.masterBl.blsUpdated': '{count} BL berhasil diperbarui',
  'lumen.manifestEngine.masterBl.warningTitle': 'Warning',
  'lumen.manifestEngine.masterBl.blsFailed': '{failed} dari {count} BL gagal diperbarui',
  'lumen.manifestEngine.masterBl.noProcess': 'Lumen Process ID tidak ditemukan',
  'lumen.manifestEngine.masterBl.duplicateTitle': 'Duplikat',
  'lumen.manifestEngine.masterBl.duplicateBody': 'Master BL dengan nomor ini sudah ada',
  'lumen.manifestEngine.masterBl.saving': 'Menyimpan Master BL...',
  'lumen.manifestEngine.masterBl.added': 'Master BL berhasil ditambahkan',
  'lumen.manifestEngine.masterBl.updated': 'Master BL berhasil diperbarui',
  'lumen.manifestEngine.masterBl.saveFailed': 'Gagal menyimpan Master BL',
  'lumen.manifestEngine.masterBl.saveFailedWith': 'Gagal menyimpan Master BL: {message}',
  'lumen.manifestEngine.masterBl.copyUnsaved': 'Tidak dapat menyalin Master BL yang belum disimpan',
  'lumen.manifestEngine.masterBl.copyingTitle': 'Copying...',
  'lumen.manifestEngine.masterBl.copying': 'Menyalin Master BL...',
  'lumen.manifestEngine.masterBl.copied': 'Master BL berhasil disalin',
  'lumen.manifestEngine.masterBl.copyFailed': 'Gagal menyalin Master BL',
  'lumen.manifestEngine.masterBl.copyFailedWith': 'Gagal menyalin Master BL: {message}',
  'lumen.manifestEngine.masterBl.deletingTitle': 'Deleting...',
  'lumen.manifestEngine.masterBl.deleting': 'Menghapus Master BL...',
  'lumen.manifestEngine.masterBl.deleted': 'Master BL berhasil dihapus',
  'lumen.manifestEngine.masterBl.deleteFailed': 'Gagal menghapus Master BL',
  'lumen.manifestEngine.masterBl.deleteFailedWith': 'Gagal menghapus Master BL: {message}',
  'lumen.manifestEngine.masterBl.applyNone': 'Silakan pilih minimal satu BL untuk menerapkan data Master BL.',
  'lumen.manifestEngine.masterBl.masterNotFound': 'Master BL tidak ditemukan',
  'lumen.manifestEngine.masterBl.applied': 'Master BL data diterapkan ke {count} BL dan diperbarui di latar belakang.',
  'lumen.manifestEngine.masterBl.applyTitleBl': 'Terapkan Master BL ke BL',
  'lumen.manifestEngine.masterBl.applyTitleAwb': 'Terapkan Master AWB ke AWB',
  'lumen.manifestEngine.masterBl.applyIntroBl': 'Data Master BL berikut akan diterapkan ke BL:',
  'lumen.manifestEngine.masterBl.applyIntroAwb': 'Data Master AWB berikut akan diterapkan ke AWB:',
  'lumen.manifestEngine.masterBl.applyKelompok': 'Kelompok Pos:',
  'lumen.manifestEngine.masterBl.applyNomor': 'Nomor Master:',
  'lumen.manifestEngine.masterBl.applyTanggal': 'Tanggal Master:',
  'lumen.manifestEngine.masterBl.pickBls': 'Pilih BL yang akan diterapkan:',
  'lumen.manifestEngine.masterBl.selectAll': 'Pilih Semua',
  'lumen.manifestEngine.masterBl.noBls': 'Tidak ada BL yang tersedia. Silakan buat BL terlebih dahulu di tab BL.',
  'lumen.manifestEngine.masterBl.houseBl': 'House BL:',
  'lumen.manifestEngine.masterBl.selected': '{count} BL dipilih',
  'lumen.manifestEngine.masterBl.lanjutkan': 'Lanjutkan',

  // /manifest/doc-pabean "Doc Manifes" (revamp PR 6a, unit D): the page, its dialogs, Cargo Tracking and
  // the upload dialog. Copied word for word, the same text in id, zh and en. The ID/JA column labels stay in
  // the page's own dictionary (doc-manifes-dict.ts).
  'lumen.manifestDocPabean.loadFailed': 'Gagal memuat data Manifest Doc Pabean.',
  'lumen.manifestDocPabean.retry': 'Coba lagi',
  'lumen.manifestDocPabean.langId': 'ID',
  'lumen.manifestDocPabean.langJa': 'JA',
  'lumen.manifestDocPabean.actDownload': 'Download',
  'lumen.manifestDocPabean.actView': 'View',
  'lumen.manifestDocPabean.actCopy': 'Copy',
  'lumen.manifestDocPabean.actUpload': 'Upload Dokumen',
  'lumen.manifestDocPabean.actRekon': 'Update ke REKON',
  'lumen.manifestDocPabean.actDelete': 'Delete',
  'lumen.manifestDocPabean.demoCannotCopy': 'Demo users cannot copy',
  'lumen.manifestDocPabean.demoCannotEdit': 'Demo users cannot edit',
  'lumen.manifestDocPabean.demoCannotUpload': 'Demo users cannot upload',
  'lumen.manifestDocPabean.demoCannotRekon': 'Demo users cannot update to REKON',
  'lumen.manifestDocPabean.demoCannotDelete': 'Demo users cannot delete',
  'lumen.manifestDocPabean.imo': ' | IMO: {imo}',
  'lumen.manifestDocPabean.copied': 'Manifest berhasil disalin',
  'lumen.manifestDocPabean.copyFailed': 'Gagal menyalin manifest',
  'lumen.manifestDocPabean.copyFailedWith': 'Gagal menyalin manifest: {message}',
  'lumen.manifestDocPabean.deleted': 'Manifest berhasil dihapus',
  'lumen.manifestDocPabean.deleteFailed': 'Gagal menghapus manifest',
  'lumen.manifestDocPabean.deleteFailedWith': 'Gagal menghapus manifest: {message}',
  'lumen.manifestDocPabean.rekonDone': 'Status berhasil diubah ke REKON',
  'lumen.manifestDocPabean.rekonFailed': 'Gagal mengubah status',
  'lumen.manifestDocPabean.rekonFailedWith': 'Gagal mengubah status: {message}',
  'lumen.manifestDocPabean.statusFailed': 'Gagal mengambil data status manifest',
  'lumen.manifestDocPabean.statusFailedWith': 'Gagal mengambil data status: {message}',
  'lumen.manifestDocPabean.pdfFailedWith': 'Gagal mengunduh PDF: {message}',
  'lumen.manifestDocPabean.deleteTitle': 'Konfirmasi Hapus',
  'lumen.manifestDocPabean.deleteBody': 'Apakah Anda yakin ingin menghapus manifest ini?',
  'lumen.manifestDocPabean.detailCompany': 'Nama Perusahaan',
  'lumen.manifestDocPabean.detailVoyage': 'Voyage',
  'lumen.manifestDocPabean.detailAju': 'Nomor AJU',
  'lumen.manifestDocPabean.detailVessel': 'Vessel',
  'lumen.manifestDocPabean.delete': 'Hapus',
  'lumen.manifestDocPabean.rekonTitle': 'Konfirmasi Update Status',
  'lumen.manifestDocPabean.rekonBody': 'Apakah Anda yakin ingin mengubah status manifest ini ke {status}?',
  'lumen.manifestDocPabean.downloadTitle': 'Download Dokumen',
  'lumen.manifestDocPabean.responCount': 'Respon ({n})',
  'lumen.manifestDocPabean.responRekon': 'Rekon',
  'lumen.manifestDocPabean.responPenerimaan': 'Penerimaan',
  'lumen.manifestDocPabean.responPerbaikan': 'Perbaikan',
  'lumen.manifestDocPabean.close': 'Tutup',
  'lumen.manifestDocPabean.trackingTitle': 'Cargo Tracking',
  'lumen.manifestDocPabean.trackingLoading': 'Loading cargo tracking...',
  'lumen.manifestDocPabean.trackingEmpty': 'No cargo tracking data available',
  'lumen.manifestDocPabean.trackingFailed': 'Failed to fetch cargo tracking data',
  'lumen.manifestDocPabean.trackingContainers': 'Container',
  'lumen.manifestDocPabean.trackingContainer': 'Container {n}',
  'lumen.manifestDocPabean.trackingEta': 'ETA {date}',
  'lumen.manifestDocPabean.trackingEvents': 'Events',
  'lumen.manifestDocPabean.trackingActual': 'Actual',
  'lumen.manifestDocPabean.trackingEstimated': 'Estimated',
  'lumen.manifestDocPabean.uploadType': 'Tipe Dokumen',
  'lumen.manifestDocPabean.typeRevisi': 'Revisi',
  'lumen.manifestDocPabean.typePenerimaan': 'Penerimaan',
  'lumen.manifestDocPabean.typeSync': 'Sync',
  'lumen.manifestDocPabean.hintRevisi': '* Revisi: Hanya 1 file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.hintSync': '* Sync: Hanya 1 file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.hintPenerimaan': '* Penerimaan: Bisa multiple files (PDF atau Excel)',
  'lumen.manifestDocPabean.labelExcel': 'Upload File Excel (1 file)',
  'lumen.manifestDocPabean.labelMulti': 'Upload File (PDF atau Excel, bisa multiple)',
  'lumen.manifestDocPabean.labelAny': 'Upload File (PDF atau Excel)',
  'lumen.manifestDocPabean.placeholderExcel': 'Pilih 1 file Excel...',
  'lumen.manifestDocPabean.placeholderMulti': 'Pilih file (bisa lebih dari satu)...',
  'lumen.manifestDocPabean.fileLine': '{i}. {name} ({size} KB)',
  'lumen.manifestDocPabean.fileTotal': 'Total: {n} file(s)',
  'lumen.manifestDocPabean.upload': 'Upload',
  'lumen.manifestDocPabean.errNoType': 'Pilih tipe dokumen terlebih dahulu',
  'lumen.manifestDocPabean.errNoFile': 'Pilih file terlebih dahulu',
  'lumen.manifestDocPabean.errRevisiOne': 'Revisi hanya bisa upload 1 file Excel',
  'lumen.manifestDocPabean.errRevisiExcel': 'Revisi hanya menerima file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.errSyncOne': 'Sync hanya bisa upload 1 file Excel',
  'lumen.manifestDocPabean.errSyncExcel': 'Sync hanya menerima file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.errNotPdfExcel': 'File {name} bukan PDF atau Excel',
  'lumen.manifestDocPabean.uploadedAll': '{n} file berhasil diupload',
  'lumen.manifestDocPabean.partialTitle': 'Partial Success',
  'lumen.manifestDocPabean.uploadedPartial': '{ok} file berhasil, {fail} file gagal',
  'lumen.manifestDocPabean.uploadedNone': 'Semua file gagal diupload',
  'lumen.manifestDocPabean.uploadFailedWith': 'Gagal upload file: {message}',
  'lumen.draft.colShipmentType': 'Jenis Pengiriman',
  'lumen.draft.colCustomer': 'Nama Customer',
  'lumen.draft.colImportir': 'Nama Importir',
  'lumen.draft.colLatestUpdate': 'Pembaruan Terakhir',
  'lumen.draft.colMot': 'MOT',
  'lumen.draft.colKantor': 'Kantor Pabean',
  'lumen.draft.colActions': 'Aksi',
  'lumen.draft.edit': 'Ubah',
  'lumen.draft.selected': '{n} item dipilih',
  'lumen.draft.deleteSelected': 'Hapus yang dipilih',
  'lumen.draft.filterShipment': 'Jenis Pengiriman',
  'lumen.draft.filterCustomer': 'Nama Customer',
  'lumen.draft.filterImportir': 'Nama Importir',
  'lumen.draft.filterMot': 'Cara Pengangkutan',
  'lumen.docPabean.logoNoWebsite': 'Belum ada website',
  'lumen.docPabean.logoWrong': 'Logo ini salah',
  'lumen.docPabean.logoMissing': 'Perusahaan ini punya logo',
  'lumen.docPabean.logoWebsitePlaceholder': 'Website yang benar, mis. mahle.com',
  'lumen.docPabean.logoSendWebsite': 'Kirim website',
  'lumen.docPabean.logoReviewNote': 'Laporan ditinjau dulu sebelum diterapkan.',
  'lumen.docPabean.logoOf': 'Logo {name}',
  'lumen.docPabean.uploadTitle': 'Unggah Berkas',
  'lumen.docPabean.uploadRefresh': 'Refresh',
  'lumen.docPabean.uploadColSeri': 'Seri',
  'lumen.docPabean.uploadColJenis': 'Jenis',
  'lumen.docPabean.uploadColNo': 'No. Dokumen',
  'lumen.docPabean.uploadColFile': 'File',
  'lumen.docPabean.uploadColAksi': 'Aksi',
  'lumen.docPabean.uploadLoading': 'Memuat dokumen...',
  'lumen.docPabean.uploadEmpty': 'Belum ada dokumen pada batch ini.',
  'lumen.docPabean.uploadNoFile': 'Belum ada file',
  'lumen.docPabean.uploadReplace': 'Ganti file',
  'lumen.docPabean.uploadUpload': 'Unggah file',
  'lumen.docPabean.uploadClose': 'Tutup',
  'lumen.docPabean.uploadDone': '{name} terupload',
  'lumen.docPabean.uploadFailed': 'Gagal mengupload file',
  'lumen.docPabean.uploadListFailed': 'Gagal memuat daftar dokumen',
  'lumen.docPabean.uploadBadFormatTitle': 'Format tidak didukung',
  'lumen.docPabean.uploadBadFormat': 'Hanya file PDF atau Excel (.xlsx/.xls/.csv) yang diperbolehkan.',
  'lumen.docPabean.blokirLoadFailed': 'Gagal memuat data Monitoring Blokir.',
  'lumen.uploadKit.loadingText': 'Memuat...',
  'lumen.uploadKit.emptyText': 'Tidak ditemukan',
  'lumen.uploadKit.loadErrorText': 'Gagal memuat',
  'lumen.pdfPageThumbnail.pageLabel': 'Page {page}',
  'lumen.docReview.loading': 'Loading...',
  'lumen.docReview.errorTitle': 'Error',
  'lumen.docReview.title': 'Review Dokumen',
  'lumen.docReview.noDocsFound': 'No Documents Found',
  'lumen.docReview.noDocsDesc': 'No documents were found for this batch. Please go back and try again.',
  'lumen.docReview.goBack': 'Go Back',
  'lumen.docReview.back': 'Back',
  'lumen.docReview.documents': 'Dokumen',
  'lumen.docReview.pages': 'halaman',
  'lumen.docReview.selectedPages': 'Halaman terpilih:',
  'lumen.docReview.noSelection': 'Belum ada halaman terpilih',
  'lumen.docReview.loadingPdfPreview': 'Loading PDF preview...',
  'lumen.docReview.openInNewTab': 'Buka di tab baru',
  'lumen.docReview.openPdfInNewTab': 'Open PDF in new tab',
  'lumen.docReview.documentSelection': 'Document Selection',
  'lumen.docReview.documentsByCategory': 'Documents by Category',
  'lumen.docReview.excelUnavailable': 'Excel - Preview unavailable',
  'lumen.docReview.includedInSubmission': 'Included in submission',
  'lumen.docReview.pagesAllSelected': 'pages selected',
  'lumen.docReview.extractedBy': 'Extracted by',
  'lumen.docReview.processing': 'Processing...',
  'lumen.docReview.preparingDocs': 'Preparing your documents...',
  'lumen.docReview.fetchingDocs': 'Fetching document data...',
  'lumen.docReview.waitProcessing': 'Please wait while we process your request. This may take a few moments.',
  'lumen.docReview.donNavigateAway': 'Please do not close this page or navigate away.',
  'lumen.docReview.dataLossWarning': 'Closing this page may result in data loss',
  'lumen.docReview.successTitle': 'Berhasil',
  'lumen.docReview.selectionSaved': 'Pilihan halaman berhasil disimpan',
  'lumen.docReview.submitError': 'Failed to submit selection. Please try again.',
  'lumen.docReview.fetchError': 'Failed to fetch files. Please try again.',
  'lumen.docReview.viewerError': 'Gagal memuat pratinjau PDF. Coba unduh file atau refresh halaman.',
  'lumen.docReview.noPdfPreview': 'No PDF documents available for preview',
  'lumen.docReview.processingModalTitle': 'Processing Documents',
  'lumen.docReview.processingCompleteTitle': 'Processing Complete',
  'lumen.docReview.processingSuccessDesc': 'Your documents have been processed successfully!',
  'lumen.docReview.submitSelection': 'Submit Selection',
  'lumen.docReview.documentPlaceholder': 'Dokumen {id}',
  'lumen.docReview.allExcelNote':
    'All uploaded files are Excel documents. They will be included in the submission but cannot be previewed here.',
  'lumen.docReview.categoryHeading': '{category} ({count})',

  // PR 7b B6a: the export upload wizard
  'lumen.exportWizard.title': 'Upload Dokumen Ekspor',
  'lumen.exportWizard.subtitle': 'BC 3.0 · Alur 3 langkah',
  'lumen.exportWizard.oldMode': 'Mode Lama (PDF / Excel)',
  'lumen.exportWizard.oldModeTitle': 'Pakai Mode Lama: Upload PDF / Excel langsung tanpa wizard',
  'lumen.exportWizard.step1': 'Pelabuhan Muat',
  'lumen.exportWizard.step1Desc': 'Pilih kode pelabuhan',
  'lumen.exportWizard.step2': 'Eksportir',
  'lumen.exportWizard.step2Desc': 'Pilih perusahaan eksportir',
  'lumen.exportWizard.step3': 'Dokumen',
  'lumen.exportWizard.step3Desc': 'Upload file PDF',
  'lumen.exportWizard.back': 'Kembali',
  'lumen.exportWizard.next': 'Lanjutkan',
  'lumen.exportWizard.upload': 'Upload Dokumen',
  'lumen.exportWizard.uploading': 'Mengunggah...',
  'lumen.exportWizard.scaffolding': 'Menyiapkan draft...',
  'lumen.exportWizard.readingDocs': 'Membaca dokumen %s/%s...',
  'lumen.exportWizard.uploadDisabled': 'Tombol aktif setelah semua dokumen selesai dibaca',
  'lumen.exportWizard.portLabel': 'Pelabuhan Muat',
  'lumen.exportWizard.portPlaceholder': 'Cari pelabuhan (kode atau nama)',
  'lumen.exportWizard.portTitle': 'Kode Pelabuhan Muat',
  'lumen.exportWizard.portDesc':
    'Pilih pelabuhan tempat barang akan dimuat untuk ekspor. Anda dapat mencari berdasarkan kode atau nama pelabuhan.',
  'lumen.exportWizard.whyImportant': 'Mengapa ini penting?',
  'lumen.exportWizard.whyDesc':
    'Kode pelabuhan muat akan digunakan untuk mengisi data header PEB secara otomatis pada langkah berikutnya.',
  'lumen.exportWizard.required': 'Field ini wajib diisi',
  'lumen.exportWizard.exporterTitle': 'Pilih Eksportir',
  'lumen.exportWizard.exporterDesc': 'Pilih perusahaan eksportir yang akan digunakan untuk dokumen ini.',
  'lumen.exportWizard.exporterPlaceholder': 'Cari nama, NPWP, penerima, atau pembeli',
  'lumen.exportWizard.results': 'Menampilkan %s-%s dari %s',
  'lumen.exportWizard.noData': 'Tidak ada data',
  'lumen.exportWizard.or': 'ATAU',
  'lumen.exportWizard.excelUpload': 'Upload File Excel CEISA',
  'lumen.exportWizard.excelUploadDesc': 'Klik atau seret file Excel (.xlsx, .xls) ke area ini',
  'lumen.exportWizard.change': 'Ubah',
  'lumen.exportWizard.loading': 'Loading...',
  'lumen.exportWizard.step1PelabuhanMuat': 'Pelabuhan Muat',
  'lumen.exportWizard.step1PelabuhanMuatDesc': 'Pilih kode pelabuhan',
  'lumen.exportWizard.excelFormatError': 'Format tidak didukung',
  'lumen.exportWizard.excelFormatErrorDesc': 'Hanya file Excel (.xls, .xlsx) yang diterima.',
  'lumen.exportWizard.excelSearchPlaceholder': 'Cari nama, NPWP, penerima, atau pembeli',
  'lumen.exportWizard.resultsCount': 'Menampilkan {from}-{to} dari {total}',
  'lumen.exportWizard.failedLoad': 'Gagal memuat data',
  'lumen.exportWizard.retry': 'Coba Lagi',
  'lumen.exportWizard.emptyState': 'Tidak ada eksportir ditemukan',
  'lumen.exportWizard.emptyStateDesc': 'Coba ubah kata kunci pencarian atau periksa kembali data Anda.',
  'lumen.exportWizard.previous': 'Sebelumnya',
  'lumen.exportWizard.paginationNext': 'Selanjutnya',
  'lumen.exportWizard.uploadExcelDatabase': 'Upload Excel Database',
  'lumen.exportWizard.uploadExcelDatabaseDesc': 'Upload file Excel CEISA untuk memproses data ekspor secara langsung.',
  'lumen.exportWizard.emptyStateClick': 'Klik untuk pilih file Excel CEISA',
  'lumen.exportWizard.emptyStateFormat': 'Format: .xls, .xlsx',
  'lumen.exportWizard.uploadingProcessing': 'Mengupload dan memproses...',
  'lumen.exportWizard.uploadingProcessingDesc': 'Mohon tunggu, sedang memproses file Excel CEISA',
  'lumen.exportWizard.step3Title': 'Upload Dokumen',
  'lumen.exportWizard.step3Subtitle': 'Unggah file PDF untuk masing-masing jenis dokumen yang diperlukan.',
  'lumen.exportWizard.selectUnspecified': 'Belum dipilih',
  'lumen.exportWizard.summaryTitle': 'Ringkasan Upload',
  'lumen.exportWizard.summaryDesc':
    'Periksa jenis dokumen untuk setiap file sebelum upload. Ubah di daftar di atas jika ada yang salah.',
  'lumen.exportWizard.noInvoiceTitle': 'Belum ada file Invoice',
  'lumen.exportWizard.noInvoiceBefore': 'Salah satu file harus bertipe ',
  'lumen.exportWizard.noInvoiceStrong': 'Invoice (I)',
  'lumen.exportWizard.noInvoiceAfter':
    ' atau format Excel CEISA. Tanpa Invoice, Python tidak akan mengekstrak data barang dan tab Barang akan kosong. Ubah jenis dokumen salah satu file di daftar di atas.',
  'lumen.exportWizard.dupTypeTitle': 'Duplikat jenis dokumen',
  'lumen.exportWizard.dupTypeBefore': 'Beberapa file memiliki jenis dokumen yang sama: ',
  'lumen.exportWizard.dupTypeStrong':
    ', Pastikan ini memang disengaja — biasanya setiap jenis dokumen hanya diunggah satu kali.',
  'lumen.exportWizard.dataFilledTitle': 'Data eksportir & pelabuhan sudah terisi',
  'lumen.exportWizard.dataFilledDesc':
    'Setelah upload selesai, halaman review hanya akan meminta Anda memverifikasi halaman-halaman yang berisi data barang. Informasi eksportir dan pelabuhan akan otomatis terisi dari pilihan Anda di langkah sebelumnya.',
  'lumen.exportWizard.uploadSuccessTitle': 'Upload Berhasil',
  'lumen.exportWizard.uploadSuccessMsg': 'File Excel CEISA berhasil diupload dan diproses.',
  'lumen.exportWizard.uploadFailedTitle': 'Upload gagal',
  'lumen.exportWizard.scaffoldFailedTitle': 'Gagal scaffold',
  'lumen.exportWizard.uploadDoneTitle': 'Berhasil',
  'lumen.exportWizard.uploadDoneMsg': 'Dokumen berhasil diunggah. Mengarahkan ke halaman review.',
  'lumen.exportWizard.confirmDiscard':
    'Berkas sudah terunggah ke draft ini. Kembali akan membuang progres upload. Lanjutkan?',
  'lumen.exportWizard.stepBadge': 'Langkah {step} dari {total}',
  'lumen.exportWizard.stepPageInfo': 'Halaman {page} dari {totalPages}',

  // PR 6b B2: the BL editor (Sheet, sections, inner HS / Container / Dokumen lists). Old text verbatim,
  // the same in id, zh and en; sections, selectAll and selectRow are new labels for the new parts.
  'lumen.manifestEngine.blEditor.titleAddBl': 'Tambah Data BL',
  'lumen.manifestEngine.blEditor.titleAddAwb': 'Tambah Data AWB',
  'lumen.manifestEngine.blEditor.titleEditBl': 'Edit Data BL',
  'lumen.manifestEngine.blEditor.titleEditAwb': 'Edit Data AWB',
  'lumen.manifestEngine.blEditor.sections': 'Bagian BL',
  'lumen.manifestEngine.blEditor.batal': 'Batal',
  'lumen.manifestEngine.blEditor.simpan': 'Simpan',
  'lumen.manifestEngine.blEditor.required': 'Field ini wajib diisi',
  'lumen.manifestEngine.blEditor.successTitle': 'Success',
  'lumen.manifestEngine.blEditor.errorTitle': 'Error',
  'lumen.manifestEngine.blEditor.warningTitle': 'Warning',
  'lumen.manifestEngine.blEditor.validationTitle': 'Validation Error',
  'lumen.manifestEngine.blEditor.validationMessage': 'Please fill in all required fields',
  'lumen.manifestEngine.blEditor.updated': 'BL data has been updated successfully',
  'lumen.manifestEngine.blEditor.added': 'BL data has been added successfully',
  'lumen.manifestEngine.blEditor.saveFailed': 'Failed to save BL: {message}',
  'lumen.manifestEngine.blEditor.noResults': 'No results found.',
  'lumen.manifestEngine.blEditor.lookupLoading': 'Loading...',
  'lumen.manifestEngine.blEditor.lookupEmpty': 'Tidak dapat menemukan',
  'lumen.manifestEngine.blEditor.lookupFailed': 'Error when get {label}',
  'lumen.manifestEngine.blEditor.kelompokPosTitle': 'Kelompok Pos & Nomor Pos',
  'lumen.manifestEngine.blEditor.kelompokPos': 'Kelompok Pos',
  'lumen.manifestEngine.blEditor.nomorPos': 'Nomor Pos',
  'lumen.manifestEngine.blEditor.masterHostBl': 'Master BL & Host BL',
  'lumen.manifestEngine.blEditor.masterHostAwb': 'Master AWB & Host AWB',
  'lumen.manifestEngine.blEditor.masterBl': 'Master BL',
  'lumen.manifestEngine.blEditor.masterAwb': 'Master AWB',
  'lumen.manifestEngine.blEditor.tanggalMasterBl': 'Tanggal Master BL',
  'lumen.manifestEngine.blEditor.tanggalMasterAwb': 'Tanggal Master AWB',
  'lumen.manifestEngine.blEditor.hostBl': 'Host BL',
  'lumen.manifestEngine.blEditor.hostAwb': 'Host AWB',
  'lumen.manifestEngine.blEditor.tanggalHostBl': 'Tanggal Host BL',
  'lumen.manifestEngine.blEditor.tanggalHostAwb': 'Tanggal Host AWB',
  'lumen.manifestEngine.blEditor.flagBl': 'Flag BL',
  'lumen.manifestEngine.blEditor.konsolidasi': 'Konsolidasi',
  'lumen.manifestEngine.blEditor.parsial': 'Parsial',
  'lumen.manifestEngine.blEditor.partOf': 'Part Of',
  'lumen.manifestEngine.blEditor.pelabuhan': 'Pelabuhan',
  'lumen.manifestEngine.blEditor.pelabuhanAsal': 'Pelabuhan Asal',
  'lumen.manifestEngine.blEditor.pelabuhanBongkar': 'Pelabuhan Bongkar',
  'lumen.manifestEngine.blEditor.pelabuhanTransit': 'Pelabuhan Transit',
  'lumen.manifestEngine.blEditor.pelabuhanAkhir': 'Pelabuhan Akhir',
  'lumen.manifestEngine.blEditor.pilihPelabuhanAsal': 'Pilih Pelabuhan Asal',
  'lumen.manifestEngine.blEditor.pilihPelabuhanBongkar': 'Pilih Pelabuhan Bongkar',
  'lumen.manifestEngine.blEditor.pilihPelabuhanTransit': 'Pilih Pelabuhan Transit',
  'lumen.manifestEngine.blEditor.pilihPelabuhanAkhir': 'Pilih Pelabuhan Akhir',
  'lumen.manifestEngine.blEditor.motherVessel': 'Mother Vessel',
  'lumen.manifestEngine.blEditor.vesselName': 'Vessel Name',
  'lumen.manifestEngine.blEditor.copyFromHeader': 'Copy dari Header',
  'lumen.manifestEngine.blEditor.vesselCopied': 'Mother vessel copied from header',
  'lumen.manifestEngine.blEditor.vesselMissing': 'Header vessel or voyage data not found',
  'lumen.manifestEngine.blEditor.kemasan': 'Kemasan',
  'lumen.manifestEngine.blEditor.berat': 'Berat',
  'lumen.manifestEngine.blEditor.dimensi': 'Dimensi',
  'lumen.manifestEngine.blEditor.unitKg': 'kg',
  'lumen.manifestEngine.blEditor.unitM3': 'm3',
  'lumen.manifestEngine.blEditor.numberPlaceholder': '0',
  'lumen.manifestEngine.blEditor.marking': 'Marking',
  'lumen.manifestEngine.blEditor.markingPlaceholder': 'marking',
  'lumen.manifestEngine.blEditor.jenisKemasan': 'Jenis Kemasan',
  'lumen.manifestEngine.blEditor.pilihJenisKemasan': 'Pilih Jenis Kemasan',
  'lumen.manifestEngine.blEditor.totalKemasan': 'Total Kemasan',
  'lumen.manifestEngine.blEditor.jumlahKemasanTerangkut': 'Jumlah Kemasan Terangkut',
  'lumen.manifestEngine.blEditor.shipper': 'Shipper',
  'lumen.manifestEngine.blEditor.jenisIdentitas': 'Jenis Identitas',
  'lumen.manifestEngine.blEditor.npwpShipper': 'NPWP Shipper / Pengirim',
  'lumen.manifestEngine.blEditor.namaShipper': 'Nama Shipper / Pengirim',
  'lumen.manifestEngine.blEditor.alamatShipper': 'Alamat Shipper / Pengirim',
  'lumen.manifestEngine.blEditor.consignee': 'Consignee',
  'lumen.manifestEngine.blEditor.normalizeNpwp': 'Normalize NPWP',
  'lumen.manifestEngine.blEditor.npwpNormalizedTitle': 'NPWP Normalized',
  'lumen.manifestEngine.blEditor.npwpNormalized': 'NPWP diubah dari "{raw}" menjadi "{normalized}"',
  'lumen.manifestEngine.blEditor.npwpCleanTitle': 'NPWP sudah bersih',
  'lumen.manifestEngine.blEditor.npwpClean': 'Tidak ada simbol yang perlu dihapus.',
  'lumen.manifestEngine.blEditor.npwpConsignee': 'NPWP Consignee / Penerima',
  'lumen.manifestEngine.blEditor.namaConsignee': 'Nama Consignee / Penerima',
  'lumen.manifestEngine.blEditor.alamatConsignee': 'Alamat Consignee / Penerima',
  'lumen.manifestEngine.blEditor.notify': 'Notify',
  'lumen.manifestEngine.blEditor.salinConsignee': 'Salin Data Consignee',
  'lumen.manifestEngine.blEditor.consigneeCopied': 'Data Consignee telah disalin ke Notify',
  'lumen.manifestEngine.blEditor.npwpNotify': 'NPWP Notify',
  'lumen.manifestEngine.blEditor.namaNotify': 'Nama Notify',
  'lumen.manifestEngine.blEditor.alamatNotify': 'Alamat Notify',
  'lumen.manifestEngine.blEditor.dataHsCount': 'Data HS ({n})',
  'lumen.manifestEngine.blEditor.dataHs': 'Data HS',
  'lumen.manifestEngine.blEditor.hapusSelected': 'Hapus ({n} dipilih)',
  'lumen.manifestEngine.blEditor.combine': 'Combine Goods',
  'lumen.manifestEngine.blEditor.uncombine': 'Uncombine Goods',
  'lumen.manifestEngine.blEditor.slice': 'Slice HS Codes (4 Digits)',
  'lumen.manifestEngine.blEditor.addHs': 'TAMBAH DATA HS BARU',
  'lumen.manifestEngine.blEditor.colHs': 'HS',
  'lumen.manifestEngine.blEditor.colUraian': 'Uraian',
  'lumen.manifestEngine.blEditor.colAksi': 'Aksi',
  'lumen.manifestEngine.blEditor.edit': 'Edit',
  'lumen.manifestEngine.blEditor.copy': 'Copy',
  'lumen.manifestEngine.blEditor.delete': 'Delete',
  'lumen.manifestEngine.blEditor.selectAll': 'Pilih semua',
  'lumen.manifestEngine.blEditor.selectRow': 'Pilih baris {n}',
  'lumen.manifestEngine.blEditor.noSelection': 'Tidak ada item yang dipilih',
  'lumen.manifestEngine.blEditor.deletedCount': '{n} item berhasil dihapus',
  'lumen.manifestEngine.blEditor.slicedTitle': 'HS Codes Sliced',
  'lumen.manifestEngine.blEditor.sliced': 'All HS codes longer than 4 digits have been trimmed to 4 digits.',
  'lumen.manifestEngine.blEditor.hsDialogAdd': 'Tambah Data HS',
  'lumen.manifestEngine.blEditor.hsDialogEdit': 'Edit Data HS',
  'lumen.manifestEngine.blEditor.kodeHs': 'Kode HS',
  'lumen.manifestEngine.blEditor.uraianHs': 'Uraian HS',
  'lumen.manifestEngine.blEditor.cancel': 'Cancel',
  'lumen.manifestEngine.blEditor.ok': 'OK',
  'lumen.manifestEngine.blEditor.dataContainerCount': 'Data Container ({n})',
  'lumen.manifestEngine.blEditor.dataContainer': 'Data Container',
  'lumen.manifestEngine.blEditor.addContainer': 'TAMBAH CONTAINER BARU',
  'lumen.manifestEngine.blEditor.nomorContainer': 'Nomor Container',
  'lumen.manifestEngine.blEditor.tipeContainer': 'Tipe Container',
  'lumen.manifestEngine.blEditor.ukuranContainer': 'Ukuran Container',
  'lumen.manifestEngine.blEditor.jenisContainer': 'Jenis Container',
  'lumen.manifestEngine.blEditor.nomorSegel': 'Nomor Segel',
  'lumen.manifestEngine.blEditor.isPartOf': 'Is Part Of',
  'lumen.manifestEngine.blEditor.yes': 'Yes',
  'lumen.manifestEngine.blEditor.containerDialogAdd': 'Tambah Peti Kemas',
  'lumen.manifestEngine.blEditor.containerDialogEdit': 'Edit Peti Kemas',
  'lumen.manifestEngine.blEditor.type': 'Type',
  'lumen.manifestEngine.blEditor.nomorPolisi': 'Nomor Polisi',
  'lumen.manifestEngine.blEditor.driver': 'Driver',
  'lumen.manifestEngine.blEditor.ukuranPlaceholder': 'Ukuran',
  'lumen.manifestEngine.blEditor.jenisPlaceholder': 'Jenis',
  'lumen.manifestEngine.blEditor.segelPlaceholder': 'Segel',
  'lumen.manifestEngine.blEditor.tipePlaceholder': 'Tipe',
  'lumen.manifestEngine.blEditor.platNomorPlaceholder': 'Plat Nomor',
  'lumen.manifestEngine.blEditor.dataDokumenCount': 'Data Dokumen ({n})',
  'lumen.manifestEngine.blEditor.dataDokumen': 'Data Dokumen',
  'lumen.manifestEngine.blEditor.addDokumen': 'TAMBAH DOKUMEN BARU',
  'lumen.manifestEngine.blEditor.jenisDokumen': 'Jenis Dokumen',
  'lumen.manifestEngine.blEditor.nomorDok': 'Nomor Dok',
  'lumen.manifestEngine.blEditor.tanggalDokumen': 'Tanggal Dokumen',
  'lumen.manifestEngine.blEditor.kodeKantor': 'Kode Kantor',
  'lumen.manifestEngine.blEditor.kodeDokumenAsal': 'Kode Dokumen Asal',
  'lumen.manifestEngine.blEditor.pilihKodeDokumen': 'Pilih Kode Dokumen',
  'lumen.manifestEngine.blEditor.nomorDokumenAsal': 'Nomor Dokumen Asal',
  'lumen.manifestEngine.blEditor.nomorDokumenPlaceholder': '000000',
  'lumen.manifestEngine.blEditor.tanggalPlaceholder': '2025-10-19',
  'lumen.manifestEngine.blEditor.pilihKodeKantor': 'Pilih Kode Kantor',
  // ---- end Lumen manifest/guardian ----
  // master/statement (the Utama, scope, conflict and confirm copy stays in statement.*)
  'lumen.masterStatement.searchPlaceholder': 'Search by name, place, position...',
  'lumen.masterStatement.add': 'Add Config',
  'lumen.masterStatement.addTitle': 'Add Statement Config',
  'lumen.masterStatement.editTitle': 'Edit Statement Config',
  'lumen.masterStatement.position': 'Position',
  'lumen.masterStatement.place': 'Place',
  'lumen.masterStatement.positionPlaceholder': 'e.g. Manager',
  'lumen.masterStatement.placePlaceholder': 'e.g. Jakarta',
  'lumen.masterStatement.updated': 'Statement config updated successfully',
  'lumen.masterStatement.updateFailed': 'Failed to update statement config',
  'lumen.masterStatement.created': 'Statement config created successfully',
  'lumen.masterStatement.createFailed': 'Failed to create statement config',
  'lumen.masterStatement.deactivated': 'Statement config deactivated successfully',
  'lumen.masterStatement.deactivateFailed': 'Failed to deactivate statement config',
  // lumen.pibEngine (revamp PR 7c)
  'lumen.pibEngine.lookup.loading': 'Loading...',
  'lumen.pibEngine.lookup.empty': 'Tidak dapat menemukan',
  'lumen.pibEngine.lookup.failed': 'Error when get {label}',
  'lumen.pibEngine.lookup.clear': 'Hapus',
  'lumen.pibEngine.select.empty': 'No results found.',
  'lumen.pibEngine.select.clear': 'Hapus pilihan',
  'lumen.pibEngine.s1.draftTitle': 'Draft PIB',
  'lumen.pibEngine.s1.draftSubtitulo': 'Pratinjau lokal, belum dikirim ke CEISA',
  'lumen.pibEngine.s1.printPdf': 'Cetak / Simpan PDF',
  'lumen.pibEngine.s1.backToDraft': 'Kembali ke Draft',
  'lumen.pibEngine.s1.loadingDraft': 'Menyiapkan draft PIB...',
  'lumen.pibEngine.eb1.errorPickHsFirst': 'Pilih HS Code terlebih dahulu',
  'lumen.pibEngine.eb1.hsSpekMarked': 'HS Code ditandai sebagai Barang Spek Khusus',
  'lumen.pibEngine.eb1.hsSpekUnmarked': 'HS Code dihapus dari Barang Spek Khusus',
  'lumen.pibEngine.eb1.hsSpekToggleFailed': 'Gagal mengubah status Barang Spek Khusus',
  'lumen.pibEngine.eb1.processIdMissing': 'Process ID tidak tersedia. Silakan muat ulang halaman.',
  'lumen.pibEngine.eb1.hsDetailsFetchFailed': 'Failed to fetch HS Code details',
  'lumen.pibEngine.eb1.hsDetailsFetchError': 'Error fetching HS Code details',
  'lumen.pibEngine.eb2.navInformasiDasar': 'Informasi Dasar',
  'lumen.pibEngine.eb2.navDokumenTransaksi': 'Dokumen & Transaksi',
  'lumen.pibEngine.eb2.navSpesifikasiKhusus': 'Spesifikasi Khusus',
  'lumen.pibEngine.eb2.navPungutan': 'Pungutan',
  'lumen.pibEngine.eb2.sectionInformasiDasar': 'Informasi Dasar',
  'lumen.pibEngine.eb2.sectionDetailHarga': 'Detail & Harga',
  'lumen.pibEngine.eb2.sectionPungutan': 'Pungutan',
  'lumen.pibEngine.eb2.sectionDokumen': 'Dokumen',
  'lumen.pibEngine.eb2.sectionJenisTransaksi': 'Jenis Transaksi',
  'lumen.pibEngine.eb2.sectionSpesifikasiKhusus': 'Spesifikasi Khusus',
  'lumen.pibEngine.eb2.tambahBiaya': 'Tambah Biaya',
  'lumen.pibEngine.eb2.btnBatal': 'Batal',
  'lumen.pibEngine.eb2.btnMenyimpan': 'Menyimpan...',
  'lumen.pibEngine.eb2.btnTambahBarang': 'Tambah Barang',
  'lumen.pibEngine.eb2.btnSimpan': 'Simpan',
  'lumen.pibEngine.eb2.btnHsSpekKhusus': 'HS Spek Khusus',
  'lumen.pibEngine.eb2.btnTandaiHsSpekKhusus': 'Tandai HS sebagai Spek Khusus',
  'lumen.pibEngine.eb2.btnYaTerapkan': 'Ya, Terapkan',
  'lumen.pibEngine.eb2.modalKonfirmasiTitle': 'Konfirmasi Terapkan ke Semua Item',
  'lumen.pibEngine.eb2.modalKonfirmasiDesc':
    'Anda akan menerapkan <strong>HS Code</strong>, <strong>Kode Satuan</strong>, <strong>Kode Kemasan</strong>, <strong>Negara Asal</strong>, dan <strong>Tarif (PPN, PPH, BM)</strong> dari item ini ke <strong>SEMUA item lainnya</strong> dalam daftar.',
  'lumen.pibEngine.eb2.modalKonfirmasiWarning':
    'Tindakan ini akan mengganti data yang sudah ada pada semua item. Apakah Anda yakin ingin melanjutkan?',
  'lumen.pibEngine.eb2.modalMenyimpan': 'Menyimpan data barang...',
  'lumen.pibEngine.eb2.errorTitle': 'Error',
  'lumen.pibEngine.eb2.errHsCodeRequired': 'HS Code harus diisi',
  'lumen.pibEngine.eb2.errUraianRequired': 'Uraian barang harus diisi',
  'lumen.pibEngine.eb2.errSatuanRequired': 'Satuan harus diisi dan lebih dari 0',
  'lumen.pibEngine.eb2.errKodeSatuanRequired': 'Kode satuan harus diisi',
  'lumen.pibEngine.ebfix.successTitle': 'Berhasil',
  'lumen.pibEngine.s2.kolomBelumLengkap': 'Terdapat kolom yang belum lengkap',
  'lumen.pibEngine.s2.hargaMismatch': 'Total harga tidak sama',
  'lumen.pibEngine.s2.hargaMismatchDetail':
    'Tab Barang {totalBarang} {valuta} ({totalItems} seri) vs tab Transaksi {hargaBarang} {valuta} — selisih {selisih} {valuta}.',
  'lumen.pibEngine.s2.hargaMismatchHint':
    'Tidak memblokir submit. Periksa Harga Barang di tab Transaksi atau nilai per barang di tab Barang.',
  'lumen.pibEngine.s2.oneWarning': '1 PERINGATAN',
  'lumen.pibEngine.s2.go': 'Go',
  'lumen.pibEngine.s2.view': 'View',
  'lumen.pibEngine.s2.hide': 'Hide',
  'lumen.pibEngine.s2.show': 'Show',
  'lumen.pibEngine.s2.fieldRequired': '{field} wajib diisi',
  'lumen.pibEngine.s2.nibRequired': 'NIB Importir wajib diisi',
  'lumen.pibEngine.s2.namaRequired': 'Nama {entity} wajib diisi',
  'lumen.pibEngine.s2.alamatRequired': 'Alamat {entity} wajib diisi',
  'lumen.pibEngine.s2.identitasRequired': 'Jenis Identitas {entity} wajib diisi',
  'lumen.pibEngine.s2.npwpRequired': 'NPWP {entity} wajib diisi',
  'lumen.pibEngine.s2.statusRequired': 'Status Importir wajib diisi',
  'lumen.pibEngine.s2.apiRequired': 'Jenis API Importir wajib diisi',
  'lumen.pibEngine.s2.afiliasiRequired': 'Afiliasi Pemilik Barang wajib dipilih',
  'lumen.pibEngine.s2.ndpbmRequired': 'NDPBM wajib diisi dan lebih besar dari 0',
  'lumen.pibEngine.s2.hargaBarangRequired': 'Harga Barang wajib diisi dan lebih besar dari 0',
  'lumen.pibEngine.s2.brutoRequired': 'Berat Kotor wajib diisi dan lebih besar dari 0',
  'lumen.pibEngine.s2.nettoRequired': 'Berat Bersih harus lebih dari 0 — isi netto per barang di tab Barang',
  'lumen.pibEngine.s2.loadingAju': 'Memuat AJU…',
  'lumen.pibEngine.s2.refreshAju': 'Ambil nomor AJU terbaru',
  'lumen.pibEngine.s2.saveAju': 'Simpan AJU',
  'lumen.pibEngine.s2.cancel': 'Batal',
  'lumen.pibEngine.s2.editAju': 'Ubah nomor AJU',
  'lumen.pibEngine.s2.submitDraft': 'Submit Draft',
  'lumen.pibEngine.s2.ajuPlaceholder': '000000-000000-00000000-000000',
  'lumen.pibEngine.s2.refreshAjuAria': 'Refresh nomor AJU',
  'lumen.pibEngine.s2.cancelEditAria': 'Batal edit AJU',
  'lumen.pibEngine.s3.ajuModalTitle': 'Nomor AJU - Deklarasi Impor',
  'lumen.pibEngine.s3.nomorAjuDihasilkan': 'Nomor AJU yang Dihasilkan',
  'lumen.pibEngine.s3.berhasilDisalin': 'Nomor AJU berhasil disalin ke clipboard!',
  'lumen.pibEngine.s3.nomorAjuTerbaru': 'Nomor AJU Terbaru',
  'lumen.pibEngine.s3.statusSelesai': 'Selesai',
  'lumen.pibEngine.s3.statusTerkirim': 'Terkirim',
  'lumen.pibEngine.s3.statusDraft': 'Draft',
  'lumen.pibEngine.s3.batal': 'Batal',
  'lumen.pibEngine.s3.simpan': 'Simpan',
  'lumen.pibEngine.s3.kirimApproval': 'Kirim Approval',
  'lumen.pibEngine.s3.pilihEmailGroup': 'Pilih email group untuk mengirim approval request ke reviewer.',
  'lumen.pibEngine.s3.buatGroupBaru': 'Buat Group Baru',
  'lumen.pibEngine.s3.namaGroup': 'Nama Group',
  'lumen.pibEngine.s3.namaGroupPlaceholder': 'Nama group',
  'lumen.pibEngine.s3.deskripsiOpsional': 'Deskripsi (opsional)',
  'lumen.pibEngine.s3.deskripsiGroupPlaceholder': 'Deskripsi group',
  'lumen.pibEngine.s3.pilihEmailGroupPlaceholder': 'Pilih email group',
  'lumen.pibEngine.s3.loading': 'Loading...',
  'lumen.pibEngine.s3.kirimSekarang': 'Kirim Sekarang',
  'lumen.pibEngine.s3.jadwalkan': 'Jadwalkan',
  'lumen.pibEngine.s3.pilihTanggalWaktu': 'Pilih tanggal dan waktu',
  'lumen.pibEngine.s3.waktuPengiriman': 'Waktu Pengiriman',
  'lumen.pibEngine.s3.selesai': 'Selesai',
  'lumen.pibEngine.s3.emailAkanDikirim': 'Email yang akan dikirim',
  'lumen.pibEngine.s3.tidakAdaEmailAktif': 'Tidak ada email aktif di group ini.',
  'lumen.pibEngine.s3.nama': 'Nama',
  'lumen.pibEngine.s3.email': 'Email',
  'lumen.pibEngine.s3.tambah': 'Tambah',
  'lumen.pibEngine.s3.tambahEmail': 'Tambah Email',
  'lumen.pibEngine.s3.jadwalkanApproval': 'Jadwalkan Approval',
  'lumen.pibEngine.s3.kirimApprovalBtn': 'Kirim Approval',
  'lumen.pibEngine.s14.basicInfoTitle': 'Informasi Dasar',
  'lumen.pibEngine.s14.seriLabel': 'Seri',
  'lumen.pibEngine.s14.seriPlaceholder': 'Seri',
  'lumen.pibEngine.s14.satuanLabel': 'Satuan',
  'lumen.pibEngine.s14.satuanPlaceholder': 'Satuan',
  'lumen.pibEngine.s14.kodeSatuanLabel': 'Kode Satuan',
  'lumen.pibEngine.s14.kodeSatuanPlaceholder': 'Kode satuan',
  'lumen.pibEngine.s14.kemasanLabel': 'Kemasan',
  'lumen.pibEngine.s14.kemasanPlaceholder': 'Kemasan',
  'lumen.pibEngine.s14.kodeKemasanLabel': 'Kode Kemasan',
  'lumen.pibEngine.s14.kodeKemasanPlaceholder': 'Kode Kemasan',
  'lumen.pibEngine.s14.hsCodeLabel': 'HS Code',
  'lumen.pibEngine.s14.hsCodePlaceholder': 'HS Code',
  'lumen.pibEngine.s14.hsCodeAria': 'HS Code',
  'lumen.pibEngine.s14.viewHsCodeDetails': 'View HS Code Details',
  'lumen.pibEngine.s14.lartasBadge': 'LARTAS',
  'lumen.pibEngine.s14.pernyataanLartasLabel': 'Pernyataan Lartas',
  'lumen.pibEngine.s14.ya': 'Ya',
  'lumen.pibEngine.s14.tidak': 'Tidak',
  'lumen.pibEngine.s14.uraianLabel': 'Uraian',
  'lumen.pibEngine.s14.sesuaiHs': 'Sesuai HS',
  'lumen.pibEngine.s14.uraianPlaceholder': 'Uraian barang',
  'lumen.pibEngine.s14.tanpaMerek': 'TANPA MEREK',
  'lumen.pibEngine.s14.merekLabel': 'Merk',
  'lumen.pibEngine.s14.merekPlaceholder': 'Merk',
  'lumen.pibEngine.s14.tanpaTipe': 'TANPA TIPE',
  'lumen.pibEngine.s14.tipeLabel': 'Tipe',
  'lumen.pibEngine.s14.tipePlaceholder': 'Tipe',
  'lumen.pibEngine.s14.ukuranLabel': 'Ukuran',
  'lumen.pibEngine.s14.ukuranPlaceholder': '0.00',
  'lumen.pibEngine.s14.spesifikasiLainLabel': 'Spesifikasi Lain',
  'lumen.pibEngine.s14.spesifikasiLainPlaceholder': 'Spesifikasi Lain',
  'lumen.pibEngine.s14.kodeBarangLabel': 'Kode Barang',
  'lumen.pibEngine.s14.kodeBarangPlaceholder': 'Kode Barang',
  'lumen.pibEngine.s14.beratBersihLabel': 'Berat Bersih (kg)',
  'lumen.pibEngine.s14.nettoPlaceholder': '0.00',
  'lumen.pibEngine.s14.kondisiBaru': 'BARANG BARU',
  'lumen.pibEngine.s14.kondisiBukanBaru': 'BUKAN BARANG BARU',
  'lumen.pibEngine.s14.kondisiBarangLabel': 'Kondisi Barang',
  'lumen.pibEngine.s14.kondisiBarangPlaceholder': 'Kondisi Barang',
  'lumen.pibEngine.s14.volumeLabel': 'Volume (m³)',
  'lumen.pibEngine.s14.volumePlaceholder': '0.0000',
  'lumen.pibEngine.s14.negaraAsalLabel': 'Negara Asal',
  'lumen.pibEngine.s14.negaraAsalPlaceholder': 'Negara Asal',
  'lumen.pibEngine.s15.docCount': 'Dokumen',
  'lumen.pibEngine.s15.tambah': 'Tambah',
  'lumen.pibEngine.s15.seri': 'Seri',
  'lumen.pibEngine.s15.jenis': 'Jenis',
  'lumen.pibEngine.s15.nomor': 'Nomor',
  'lumen.pibEngine.s15.tanggal': 'Tanggal',
  'lumen.pibEngine.s15.fasilitas': 'Fasilitas',
  'lumen.pibEngine.s15.izin': 'Izin',
  'lumen.pibEngine.s15.aksi': 'Aksi',
  'lumen.pibEngine.s15.edit': 'Edit',
  'lumen.pibEngine.s15.editAria': 'Edit',
  'lumen.pibEngine.s15.delete': 'Hapus',
  'lumen.pibEngine.s15.deleteAria': 'Hapus',
  'lumen.pibEngine.s15.emptyState': 'Belum ada dokumen. Klik "Tambah" untuk menambahkan.',
  'lumen.pibEngine.s15.attachModalTitle': 'Attach Documents to Barang',
  'lumen.pibEngine.s15.attachDescription': 'Select which documents should be attached to this barang item:',
  'lumen.pibEngine.s15.noDocsAvailable': 'No documents available. Please add documents first in the Documents tab.',
  'lumen.pibEngine.s15.failSaveDocTitle': 'Gagal menyimpan dokumen barang',
  'lumen.pibEngine.s15.failSaveDocMessage': 'Perubahan dokumen belum tersimpan. Silakan coba lagi.',
  'lumen.pibEngine.s8.syncDariJarvis': 'Sync dari Lumen',
  'lumen.pibEngine.s8.syncPerluDiperiksa': 'Berbeda dari dokumen terakhir — ambil data dari Lumen',
  'lumen.pibEngine.s8.pilihDataDariLumen': 'Pilih Data dari Lumen',
  'lumen.pibEngine.s8.dataTandaDiSalahkan': 'Data ditandai salah',
  'lumen.pibEngine.s8.dataTidakAkanDitampilkan': 'Data ini tidak akan ditampilkan lagi pada pencarian berikutnya.',
  'lumen.pibEngine.s8.gagalMenandaiData': 'Gagal menandai data',
  'lumen.pibEngine.s8.terjadiKesalahan': 'Terjadi kesalahan saat memperbarui data.',
  'lumen.pibEngine.s8.tandaiDataSalah': 'Tandai Data Salah',
  'lumen.pibEngine.s8.yaTandaiSalah': 'Ya, Tandai Salah',
  'lumen.pibEngine.s8.tidak': 'Tidak',
  'lumen.pibEngine.s8.batal': 'Batal',
  'lumen.pibEngine.s8.apply': 'Apply',
  'lumen.pibEngine.s8.tidakAdaDataUntukDipilih': 'Tidak ada data untuk dipilih.',
  'lumen.pibEngine.s8.bukaConsignee': 'Buka Data Consignee',
  'lumen.pibEngine.s8.riwayatDokumenCount': 'Riwayat dokumen ({count})',
  'lumen.pibEngine.s8.diperbaruiTanggal': 'Diperbarui {date}',
  'lumen.pibEngine.s8.bukaDiConsignee': 'Buka di Data Consignee',
  'lumen.pibEngine.s8.riwayatTidakDapatDimuat': 'Riwayat dokumen tidak dapat dimuat',
  'lumen.pibEngine.s8.tandaiSebagaiSalah':
    'Tandai “{name}” sebagai data salah? Data ini akan disembunyikan dari pencarian berikutnya.',
  'lumen.pibEngine.s8.dataMasterTidakBisaDitandai':
    'Data Consignee dikelola di menu Master, bukan ditandai salah di sini.',
  'lumen.pibEngine.s16.amountCif': 'Amount (CIF)',
  'lumen.pibEngine.s16.typeHere': 'Type here...',
  'lumen.pibEngine.s16.fob': 'FOB',
  'lumen.pibEngine.s16.hargaSatuan': 'Harga Satuan',
  'lumen.pibEngine.s16.biayaTambahanDiskon': 'Biaya Tambahan - Diskon',
  'lumen.pibEngine.s16.freight': 'Freight',
  'lumen.pibEngine.s16.biayaAsuransi': 'Biaya Asuransi',
  'lumen.pibEngine.s16.cifRupiah': 'CIF - Rupiah (Calculated)',
  'lumen.pibEngine.s16.freeOfChargeItem': 'Free of Charge Item',
  'lumen.pibEngine.s16.metodePenentuanNilai': 'Metode Penentuan Nilai Pabean',
  'lumen.pibEngine.s16.pilihMetode': 'Pilih Metode',
  'lumen.pibEngine.s16.alasan': 'Alasan',
  'lumen.pibEngine.s16.pilihAlasan': 'Pilih Alasan',
  'lumen.pibEngine.s16.statementPerbedaanHarga': 'Statement Perbedaan Harga',
  'lumen.pibEngine.s16.ada': 'Ada',
  'lumen.pibEngine.s16.tidakAda': 'Tidak Ada',
  'lumen.pibEngine.s16.transaksiCount': 'Transaksi: {count}',
  'lumen.pibEngine.s16.tambah': 'Tambah',
  'lumen.pibEngine.s16.aksi': 'Aksi',
  'lumen.pibEngine.s16.jenisTransaksi': 'Jenis Transaksi',
  'lumen.pibEngine.s16.nilaiVD': 'Nilai VD',
  'lumen.pibEngine.s16.belumAdaTransaksi': 'Belum ada jenis transaksi yang ditambahkan',
  'lumen.pibEngine.s16.tambahJenisTransaksi': 'Tambah Jenis Transaksi',
  'lumen.pibEngine.s16.ubahJenisTransaksi': 'Ubah Jenis Transaksi',
  'lumen.pibEngine.s16.jenisNilai': 'Jenis Nilai',
  'lumen.pibEngine.s16.pilihJenisNilai': 'Pilih Jenis Nilai',
  'lumen.pibEngine.s16.voluntaryDeclaration': 'Voluntary Declaration',
  'lumen.pibEngine.s16.wajibDiisi': 'Wajib diisi untuk jenis transaksi ini',
  'lumen.pibEngine.s16.opsional': 'Opsional untuk jenis transaksi ini',
  'lumen.pibEngine.s16.batal': 'Batal',
  'lumen.pibEngine.s16.simpan': 'Simpan',
  'lumen.pibEngine.s16.errorPilihJenisTransaksi': 'Jenis transaksi harus dipilih',
  'lumen.pibEngine.s16.errorVoluntaryDeclaration': 'Voluntary Declaration wajib diisi untuk jenis transaksi ini',
  'lumen.pibEngine.s16.errorDuplicate': 'Jenis transaksi sudah ada dalam daftar',
  'lumen.pibEngine.s16.edit': 'Edit',
  'lumen.pibEngine.s16.hapus': 'Hapus',
  'lumen.pibEngine.s16.editAriaLabel': 'Edit jenis transaksi',
  'lumen.pibEngine.s16.hapusAriaLabel': 'Hapus jenis transaksi',
  'lumen.pibEngine.s4.titleTransfer': 'Ringkasan Transfer ke CEISA',
  'lumen.pibEngine.s4.titleSubmit': 'Ringkasan Submit Draft',
  'lumen.pibEngine.s4.hargaMismatchTitle': 'Total harga tidak sama',
  'lumen.pibEngine.s4.barangTab': 'Tab Barang ({n} seri)',
  'lumen.pibEngine.s4.transaksiTab': 'Tab Transaksi',
  'lumen.pibEngine.s4.selisih': 'Selisih',
  'lumen.pibEngine.s4.hargaMismatchMessage':
    'Periksa dulu Harga Barang di tab Transaksi dan nilai per barang di tab Barang.',
  'lumen.pibEngine.s4.hargaAck': 'Saya sudah cek selisihnya dan tetap ingin submit',
  'lumen.pibEngine.s4.duplicateTitle': 'Barang terlampir di dua dokumen sejenis',
  'lumen.pibEngine.s4.duplicateMessage':
    'Satu barang hanya boleh membawa satu dokumen per kode. CEISA akan menolak pengajuan ini. Buka tab Dokumen, lalu lepaskan barang di bawah ini dari salah satu dokumennya.',
  'lumen.pibEngine.s4.duplicateAck': 'Saya sudah cek dan tetap ingin submit',
  'lumen.pibEngine.s4.kantorPelTitle': 'Kantor & Pelabuhan',
  'lumen.pibEngine.s4.kantor': 'Kantor',
  'lumen.pibEngine.s4.pelTujuan': 'Pel. Tujuan',
  'lumen.pibEngine.s4.importirTitle': 'Importir',
  'lumen.pibEngine.s4.nama': 'Nama',
  'lumen.pibEngine.s4.npwp': 'NPWP',
  'lumen.pibEngine.s4.apiNib': 'API / NIB',
  'lumen.pibEngine.s4.alamat': 'Alamat',
  'lumen.pibEngine.s4.pengirimTitle': 'Pengirim',
  'lumen.pibEngine.s4.penjualTitle': 'Penjual',
  'lumen.pibEngine.s4.negara': 'Negara',
  'lumen.pibEngine.s4.pengangkutTitle': 'Pengangkut',
  'lumen.pibEngine.s4.sarana': 'Sarana',
  'lumen.pibEngine.s4.voyFlight': 'Voy/Flight',
  'lumen.pibEngine.s4.bendera': 'Bendera',
  'lumen.pibEngine.s4.pelMuat': 'Pel. Muat',
  'lumen.pibEngine.s4.kemasanLabel': 'Kemasan',
  'lumen.pibEngine.s4.kontainerLabel': 'Kontainer',
  'lumen.pibEngine.s4.dokumenLabel': 'Dokumen',
  'lumen.pibEngine.s4.barangLabel': 'Barang',
  'lumen.pibEngine.s4.unit': 'unit',
  'lumen.pibEngine.s4.dokumenUnit': 'dokumen',
  'lumen.pibEngine.s4.seri': 'seri',
  'lumen.pibEngine.s4.transaksiTitle': 'Transaksi',
  'lumen.pibEngine.s4.jenisTransaksi': 'Jenis Transaksi',
  'lumen.pibEngine.s4.incoterm': 'Incoterm',
  'lumen.pibEngine.s4.totalCif': 'Total CIF',
  'lumen.pibEngine.s4.valuta': 'Valuta',
  'lumen.pibEngine.s4.ndpbm': 'NDPBM',
  'lumen.pibEngine.s4.beratKotor': 'Berat Kotor',
  'lumen.pibEngine.s4.beratBersih': 'Berat Bersih',
  'lumen.pibEngine.s4.lartasTitle': 'Lartas',
  'lumen.pibEngine.s4.lartasY': 'Ya (Y)',
  'lumen.pibEngine.s4.lartasT': 'Tidak (T)',
  'lumen.pibEngine.s4.lartasN': 'Tidak Ada (N)',
  'lumen.pibEngine.s4.loadingBarang': 'Memuat data barang...',
  'lumen.pibEngine.s4.back': 'Kembali',
  'lumen.pibEngine.s4.transferConfirm': 'Ya, Transfer ke CEISA',
  'lumen.pibEngine.s4.submitConfirm': 'Submit ke CEISA',
  'lumen.pibEngine.s4.tooltipDuplicate': 'Perbaiki dulu barang yang terlampir di dua dokumen sejenis',
  'lumen.pibEngine.s4.tooltipHarga': 'Centang dulu konfirmasi selisih harga di atas',
  'lumen.pibEngine.s4.editAria': 'Edit {n} item(s)',
  'lumen.pibEngine.s5.errorWorker': 'PDF worker communication failed. Please refresh the page and try again.',
  'lumen.pibEngine.s5.errorNetwork': 'Unable to load PDF due to network restrictions. Please contact support.',
  'lumen.pibEngine.s5.errorLoad': 'Failed to load PDF. Please try again later.',
  'lumen.pibEngine.s5.labelInvoice': 'Invoice',
  'lumen.pibEngine.s5.labelPackingList': 'Packing List',
  'lumen.pibEngine.s5.labelBillOfLading': 'Bill of Lading',
  'lumen.pibEngine.s5.labelAirWaybill': 'Air Waybill',
  'lumen.pibEngine.s5.labelCertOrigin': 'Certificate of Origin',
  'lumen.pibEngine.s5.labelImportCert': 'Import Certificate',
  'lumen.pibEngine.s5.excelPreviewNotAvailable': 'Excel File Preview Not Available',
  'lumen.pibEngine.s5.excelCannotDisplay': 'Excel files (.xlsx, .xls, .csv) cannot be displayed in the PDF viewer.',
  'lumen.pibEngine.s5.downloadExcel': 'Download Excel File',
  'lumen.pibEngine.s5.fallingBackIframe': 'Falling back to iframe viewer...',
  'lumen.pibEngine.s5.loadingPdf': 'Loading PDF...',
  'lumen.pibEngine.s5.loadingPage': 'Loading page {page}...',
  'lumen.pibEngine.s5.pageIndicator': 'Page {page} of {total}',
  'lumen.pibEngine.s5.zoomOutAria': 'Zoom out',
  'lumen.pibEngine.s5.zoomOutTitle': 'Zoom Out (Ctrl + -)',
  'lumen.pibEngine.s5.zoomInAria': 'Zoom in',
  'lumen.pibEngine.s5.zoomInTitle': 'Zoom In (Ctrl + +)',
  'lumen.pibEngine.s5.resetZoomAria': 'Reset zoom',
  'lumen.pibEngine.s5.resetZoomTitle': 'Reset Zoom (Ctrl + 0)',
  'lumen.pibEngine.s5.zoomLevelTitle': 'Zoom level (Ctrl +/- to zoom, Ctrl 0 to reset)',
  'lumen.pibEngine.s5.prevPdfAria': 'Previous PDF',
  'lumen.pibEngine.s5.prevPdfTitle': 'Previous PDF',
  'lumen.pibEngine.s5.nextPdfAria': 'Next PDF',
  'lumen.pibEngine.s5.nextPdfTitle': 'Next PDF',
  'lumen.pibEngine.s5.downloadPdfAria': 'Download PDF',
  'lumen.pibEngine.s5.downloadPdfTitle': 'Download PDF',
  'lumen.pibEngine.s5.hidePdfAria': 'Hide PDF',
  'lumen.pibEngine.s5.hidePdfTitle': 'Hide PDF',
  'lumen.pibEngine.s17.beaMasuk': 'Bea Masuk (BM)',
  'lumen.pibEngine.s17.ppn': 'PPN',
  'lumen.pibEngine.s17.pph': 'PPH',
  'lumen.pibEngine.s17.kodeJenis': 'Kode Jenis',
  'lumen.pibEngine.s17.tarif': 'Tarif (%)',
  'lumen.pibEngine.s17.tarifPlaceholder': '0',
  'lumen.pibEngine.s17.ppnPlaceholder': '11',
  'lumen.pibEngine.s17.pphPlaceholder': '2.5',
  'lumen.pibEngine.s17.jenisTarif': 'Jenis Tarif',
  'lumen.pibEngine.s17.fasilitas': 'Fasilitas',
  'lumen.pibEngine.s17.pilih': 'Pilih',
  'lumen.pibEngine.s17.advalorum': 'Advalorum',
  'lumen.pibEngine.s17.spesifik': 'Spesifik',
  'lumen.pibEngine.s17.tambahBiaya': 'Tambah Biaya',
  'lumen.pibEngine.s17.biayaTambahan': 'Biaya Tambahan',
  'lumen.pibEngine.s17.hapus': 'Hapus',
  'lumen.pibEngine.s17.kategoriSpesifikasi': 'Kategori Spesifikasi',
  'lumen.pibEngine.s17.otomotif': 'OTOMOTIF',
  'lumen.pibEngine.s17.others': 'OTHERS',
  'lumen.pibEngine.s17.cbuLabel': 'CBU',
  'lumen.pibEngine.s17.pilihCbu': 'Pilih CBU',
  'lumen.pibEngine.s17.noncbu': 'NONCBU',
  'lumen.pibEngine.s17.cbu': 'CBU',
  'lumen.pibEngine.s17.jenisKendaraan': 'JENIS KENDARAAN',
  'lumen.pibEngine.s17.jenisKendaraanPlaceholder': 'Jenis Kendaraan',
  'lumen.pibEngine.s17.merk': 'MERK',
  'lumen.pibEngine.s17.merkPlaceholder': 'Merk',
  'lumen.pibEngine.s17.tipe': 'TIPE',
  'lumen.pibEngine.s17.tipePlaceholder': 'Tipe',
  'lumen.pibEngine.s17.tahunPembuatan': 'TAHUN PEMBUATAN',
  'lumen.pibEngine.s17.tahunPembuatanPlaceholder': 'Tahun Pembuatan',
  'lumen.pibEngine.s17.nomorRangka': 'NOMOR RANGKA',
  'lumen.pibEngine.s17.nomorRangkaPlaceholder': 'Nomor Rangka',
  'lumen.pibEngine.s17.nomorMesin': 'NOMOR MESIN',
  'lumen.pibEngine.s17.nomorMesinPlaceholder': 'Nomor Mesin',
  'lumen.pibEngine.s17.silinder': 'SILINDER',
  'lumen.pibEngine.s17.silinderPlaceholder': 'Silinder',
  'lumen.pibEngine.s17.daya': 'DAYA',
  'lumen.pibEngine.s17.dayaPlaceholder': 'Daya',
  'lumen.pibEngine.s17.modelLabel': 'MODEL',
  'lumen.pibEngine.s17.modelPlaceholder': 'Model',
  'lumen.pibEngine.s17.nomorCasiLabel': 'NOMOR CASI',
  'lumen.pibEngine.s17.nomorCasiPlaceholder': 'NOMOR CASI Kosong',
  'lumen.pibEngine.s17.mutuLabel': 'MUTU',
  'lumen.pibEngine.s17.pilihMutu': 'Pilih Mutu',
  'lumen.pibEngine.s17.mutuPangan': 'MUTU PANGAN',
  'lumen.pibEngine.s17.mutuFarmasi': 'MUTU FARMASI',
  'lumen.pibEngine.s17.mutuPakanTernak': 'MUTU PAKAN TERNAK',
  'lumen.pibEngine.s17.mutuLainnya': 'MUTU LAINNYA',
  'lumen.pibEngine.s9.verified': 'Verified',
  'lumen.pibEngine.s9.check': 'Check',
  'lumen.pibEngine.s9.review': 'Review',
  'lumen.pibEngine.s9.clickReviewSource': 'Click to review against source',
  'lumen.pibEngine.s9.autoVerified': 'Auto-verified from source',
  'lumen.pibEngine.s9.needsManualReview': 'Needs manual review',
  'lumen.pibEngine.s9.suggestVerify': 'Suggest verifying this value',
  'lumen.pibEngine.s6.kalibrasiTitle': 'Kalibrasi Draft PIB (Internal)',
  'lumen.pibEngine.s6.checklistTitle': 'Checklist: Draft PDF vs Final PDF',
  'lumen.pibEngine.s6.loadingData': 'Mengambil data perbandingan untuk {nomorAju}...',
  'lumen.pibEngine.s6.failedTitle': 'Gagal mengambil data',
  'lumen.pibEngine.s6.nomorAjuLabel': 'Nomor Aju',
  'lumen.pibEngine.s6.statusLabel': 'Status:',
  'lumen.pibEngine.s6.printSave': 'Print / Save as PDF',
  'lumen.pibEngine.s6.totalFields': 'Total Fields',
  'lumen.pibEngine.s6.matches': 'Matches',
  'lumen.pibEngine.s6.mismatches': 'Mismatches',
  'lumen.pibEngine.s6.missingInDraft': 'Missing in Draft',
  'lumen.pibEngine.s6.missingInFinal': 'Missing in Final',
  'lumen.pibEngine.s6.goodsAdded': 'Goods Added',
  'lumen.pibEngine.s6.goodsRemoved': 'Goods Removed',
  'lumen.pibEngine.s6.goodsModified': 'Goods Modified',
  'lumen.pibEngine.s6.goodsUnchanged': 'Goods Unchanged',
  'lumen.pibEngine.s6.draftPdf': 'DRAFT PDF',
  'lumen.pibEngine.s6.finalPdf': 'FINAL PDF',
  'lumen.pibEngine.s6.pages': 'pages',
  'lumen.pibEngine.s6.localTab': 'Lokal vs CEISA',
  'lumen.pibEngine.s6.headerTab': 'Header Fields',
  'lumen.pibEngine.s6.goodsTab': 'Goods',
  'lumen.pibEngine.s6.localAlert':
    'Kalibrasi internal: nilai draft PIB lokal (dari form) dibandingkan dengan draft PIB yang diterbitkan CEISA untuk AJU ini. Baris yang tidak cocok menandakan template atau pemetaan nilai lokal yang perlu diselaraskan.',
  'lumen.pibEngine.s6.emptyInLocal': 'Kosong di Lokal',
  'lumen.pibEngine.s6.emptyInCeisa': 'Kosong di CEISA',
  'lumen.pibEngine.s6.field': 'Field',
  'lumen.pibEngine.s6.draftLokal': 'Draft Lokal',
  'lumen.pibEngine.s6.draftCeisa': 'Draft CEISA',
  'lumen.pibEngine.s6.status': 'Status',
  'lumen.pibEngine.s6.draftValue': 'Draft Value',
  'lumen.pibEngine.s6.finalValue': 'Final Value',
  'lumen.pibEngine.s6.noHeader': 'Tidak ada data header',
  'lumen.pibEngine.s6.noGoods': 'Tidak ada data barang.',
  'lumen.pibEngine.s6.addedText': 'Added: ',
  'lumen.pibEngine.s6.removedText': 'Removed: ',
  'lumen.pibEngine.s6.modifiedText': 'Modified: ',
  'lumen.pibEngine.s6.unchangedText': 'Unchanged: ',
  'lumen.pibEngine.s6.barang': 'barang',
  'lumen.pibEngine.s6.comparisonFailed': 'Comparison failed',
  'lumen.pibEngine.s6.unknownError': 'Unknown error',
  'lumen.pibEngine.p2.loadingValidation': 'Memuat dan memvalidasi data formulir...',
  'lumen.pibEngine.p3.initErrorTitle': 'Error',
  'lumen.pibEngine.p3.initErrorMessage': 'Failed to initialize form',
  'lumen.pibEngine.p3.npwpErrorTitle': 'Validasi Entitas Gagal',
  'lumen.pibEngine.p3.npwpErrorMessage': 'NPWP PPJK tidak valid. Silakan isi NPWP PPJK terlebih dahulu.',
  'lumen.pibEngine.p3.processIdNotFoundTitle': 'Error',
  'lumen.pibEngine.p3.processIdNotFoundMessage': 'Process ID not found',
  'lumen.pibEngine.p3.downloadSuccessTitle': 'Success',
  'lumen.pibEngine.p3.downloadSuccessMessage': 'Download success!',
  'lumen.pibEngine.p3.downloadFailedTitle': 'Error',
  'lumen.pibEngine.p3.downloadFailedMessage': 'Download failed!',
  'lumen.pibEngine.p3.downloadBarangSuccessTitle': 'Success',
  'lumen.pibEngine.p3.downloadBarangSuccessMessage': 'Download barang excel berhasil!',
  'lumen.pibEngine.p3.downloadBarangFailedTitle': 'Error',
  'lumen.pibEngine.p3.downloadBarangFailedMessage': 'Download barang excel gagal!',
  'lumen.pibEngine.p3.uploadBarangSuccessTitle': 'Success',
  'lumen.pibEngine.p3.uploadBarangSuccessMessage': 'Upload barang excel berhasil! Refreshing...',
  'lumen.pibEngine.p3.uploadBarangFailedTitle': 'Error',
  'lumen.pibEngine.p3.uploadBarangFailedMessage': 'Upload barang excel gagal!',
  'lumen.pibEngine.p3.uploadSuccessTitle': 'Success',
  'lumen.pibEngine.p3.uploadSuccessMessage': 'Upload success! Refreshing form data...',
  'lumen.pibEngine.p3.uploadFailedTitle': 'Error',
  'lumen.pibEngine.p3.uploadFailedMessage': 'Upload failed!',
  'lumen.pibEngine.p3.ajuCancelledMsg': '❌ AJU cancelled by cancel button',
  'lumen.pibEngine.p4.noAjuTitle': 'Error',
  'lumen.pibEngine.p4.noAjuMessage': 'Nomor AJU belum tersedia. Silakan Submit DRAFT ke CEISA terlebih dahulu.',
  'lumen.pibEngine.p4.noProcessIdTitle': 'Error',
  'lumen.pibEngine.p4.noProcessIdMessage': 'Process ID tidak tersedia untuk hitung pungutan',
  'lumen.pibEngine.p4.noDataPungutanTitle': 'Info',
  'lumen.pibEngine.p4.noDataPungutanMessage': 'Tidak ada data pungutan',
  'lumen.pibEngine.p4.gagalTitle': 'Gagal',
  'lumen.pibEngine.p4.syncDoneTitle': 'Success',
  'lumen.pibEngine.p4.syncDefaultMessage': 'Sinkronisasi tarif HS selesai',
  'lumen.pibEngine.p4.canNotTransferTitle': 'Belum bisa Transfer',
  'lumen.pibEngine.p4.validationFailedTitle': 'Validasi Gagal',
  'lumen.pibEngine.p4.validationFailedMessage': 'Terdapat {n} pesan error. Perbaiki terlebih dahulu sebelum transfer.',
  'lumen.pibEngine.p4.transferSuccessTitle': 'Transfer Berhasil',
  'lumen.pibEngine.p4.transferSuccessMessage': 'Dokumen berhasil ditransfer ke CEISA',
  'lumen.pibEngine.p4.transferFailedTitle': 'Transfer Gagal',
  'lumen.pibEngine.p4.noDataStatusTitle': 'Info',
  'lumen.pibEngine.p4.noDataStatusMessage': 'Tidak ada data status',
  'lumen.pibEngine.p4.noFormDataTitle': 'Error',
  'lumen.pibEngine.p4.noFormDataMessage': 'Data form tidak tersedia',
  'lumen.pibEngine.p4.gateSuccessTitle': 'Berhasil',
  'lumen.pibEngine.p4.successMessage': 'Berhasil',
  'lumen.pibEngine.p4.gagalGeneratePungutanMessage': 'Gagal generate pungutan',
  'lumen.pibEngine.p4.gagalSinkronisasiHsMessage': 'Gagal sinkronisasi tarif HS',
  'lumen.pibEngine.p4.gagalMengambilStatusMessage': 'Gagal mengambil status',
  'lumen.pibEngine.p4.gagalCetakFormulirMessage': 'Gagal cetak formulir',
  'lumen.pibEngine.p4.gagalShort': 'Gagal',
  'lumen.pibEngine.p5.gateAjuTitle': 'Error',
  'lumen.pibEngine.p5.gateAjuMsg': 'Nomor AJU belum tersedia',
  'lumen.pibEngine.p5.nomorPolisiMsg': 'Nomor Polisi wajib diisi',
  'lumen.pibEngine.p5.gateKontainerMsg': 'Nomor Kontainer wajib diisi',
  'lumen.pibEngine.p5.gateSuccessTitle': 'Berhasil',
  'lumen.pibEngine.p5.gateSuccessMsg': 'Berhasil',
  'lumen.pibEngine.p5.gateFailTitle': 'Gagal',
  'lumen.pibEngine.p5.gateFailMsg': 'Gagal',
  'lumen.pibEngine.p5.submitBlockedTitle': 'Belum bisa Submit',
  'lumen.pibEngine.p5.validationTitle': 'Validation Error',
  'lumen.pibEngine.p5.validationMsg': 'Berat Bersih tidak boleh lebih besar dari Berat Kotor',
  'lumen.pibEngine.p5.entitySaveFailTitle': 'Gagal menyimpan Entitas',
  'lumen.pibEngine.p5.entitySaveFailMsg': 'Data hasil sync belum tersimpan. Submit ke CEISA dibatalkan.',
  'lumen.pibEngine.p5.draftSuccessTitle': 'Success',
  'lumen.pibEngine.p5.draftSuccessMsg': 'Draft berhasil diupdate ke CEISA',
  'lumen.pibEngine.p5.draftFailTitle': 'Error',
  'lumen.pibEngine.p5.draftFailMsg': 'Gagal mengupdate draft ke CEISA',
  'lumen.pibEngine.p5.loadingTitle': 'Loading document data',
  'lumen.pibEngine.p5.loadingDesc': 'This may take a moment as we process your document.',
  'lumen.pibEngine.p6.loadingTitle': 'Loading document data',
  'lumen.pibEngine.p6.loadingSub': 'This may take a moment as we process your document.',
  'lumen.pibEngine.p6.back': 'Back',
  'lumen.pibEngine.p6.auditLogs': 'Audit Logs',
  'lumen.pibEngine.p6.excelFull': 'Excel (Full)',
  'lumen.pibEngine.p6.downloadExcelFull': 'Download Excel (Full)',
  'lumen.pibEngine.p6.uploadExcelFull': 'Upload Excel (Full)',
  'lumen.pibEngine.p6.excelBarang': 'Excel (Barang Only)',
  'lumen.pibEngine.p6.downloadExcelBarang': 'Download Excel (Barang Only)',
  'lumen.pibEngine.p6.uploadExcelBarang': 'Upload Excel (Barang Only)',
  'lumen.pibEngine.p6.historical': 'Historical',
  'lumen.pibEngine.p6.syncHistorical': 'Sync with Historical Data',
  'lumen.pibEngine.p6.draftPib': 'Draft PIB',
  'lumen.pibEngine.p6.aksi': 'Aksi',
  'lumen.pibEngine.p6.generatePungutan': 'Generate Pungutan',
  'lumen.pibEngine.p6.validasi': 'Validasi',
  'lumen.pibEngine.p6.approval': 'Approval',
  'lumen.pibEngine.p6.kirimApproval': 'Kirim Approval',
  'lumen.pibEngine.p6.cetak': 'Cetak',
  'lumen.pibEngine.p6.cetakFormulirDraft': 'Cetak Formulir Draft CEISA',
  'lumen.pibEngine.p6.draftPibPreview': 'Draft PIB (Preview Lokal)',
  'lumen.pibEngine.p6.internal': 'Internal',
  'lumen.pibEngine.p6.kalibrasi': 'Kalibrasi Draft PIB (Internal)',
  'lumen.pibEngine.p6.ceisaPortal': 'CEISA Portal',
  'lumen.pibEngine.p6.lihatCeisa': 'Lihat di Ceisa',
  'lumen.pibEngine.p6.submit': 'Submit',
  'lumen.pibEngine.p6.transferBilling': 'Transfer (Billing)',
  'lumen.pibEngine.p6.revisi': 'Revisi',
  'lumen.pibEngine.p6.revisionChecklist': 'Revision Checklist',
  'lumen.pibEngine.p6.completed': 'completed',
  'lumen.pibEngine.p6.selesaikanChecklist': 'Selesaikan semua checklist sebelum submit',
  'lumen.pibEngine.p6.sebelumnya': 'Sebelumnya',
  'lumen.pibEngine.p6.lihatPdf': 'Lihat PDF',
  'lumen.pibEngine.p6.tutupPdf': 'Tutup PDF',
  'lumen.pibEngine.p6.editItem': 'Edit Item',
  'lumen.pibEngine.p6.selanjutnya': 'Selanjutnya',
  'lumen.pibEngine.p6.perhatianProporsional': 'Perhatian: Biaya Proporsional Terdeteksi',
  'lumen.pibEngine.p6.lumenMendeteksi': 'Lumen mendeteksi adanya',
  'lumen.pibEngine.p6.biayaPenambah': 'Biaya Penambah',
  'lumen.pibEngine.p6.biayaPengurang': 'Biaya Pengurang',
  'lumen.pibEngine.p6.harapLakukan': 'Harap lakukan langkah berikut di CEISA terlebih dahulu:',
  'lumen.pibEngine.p6.setelahDua': 'Setelah kedua langkah di atas selesai, Anda dapat melakukan ',
  'lumen.pibEngine.p6.melewatiLumen': 'melalui Lumen.',
  'lumen.pibEngine.p6.sayaMengerti': 'Saya Mengerti',
  'lumen.pibEngine.p6b.freight': 'Freight',
  'lumen.pibEngine.p6b.atau': 'atau',
  'lumen.pibEngine.p6b.asuransi': 'Asuransi',
  'lumen.pibEngine.p6b.padaDokumenIni': 'pada dokumen ini.',
  'lumen.pibEngine.p6b.klik': 'Klik',
  'lumen.pibEngine.p6b.hitungProporsionalAsuransi': 'Hitung Proporsional Asuransi dan Freight',
  'lumen.pibEngine.p6b.hitungProporsionalBiaya': 'Hitung Proporsional Biaya Penambah dan Pengurang',
  'lumen.pibEngine.p6b.dan': 'dan',
  'lumen.pibEngine.p6b.generatePungutan': 'Generate Pungutan',
  'lumen.pibEngine.p6b.cetakDraftPib': 'Cetak Draft PIB',
  'lumen.pibEngine.p7.kemasanGateIn': 'Kemasan Gate In',
  'lumen.pibEngine.p7.kemasanGateOut': 'Kemasan Gate Out',
  'lumen.pibEngine.p7.kontainerGateIn': 'Kontainer Gate In',
  'lumen.pibEngine.p7.nomorPolisiLabel': 'Nomor Polisi',
  'lumen.pibEngine.p7.nomorPolisiPlaceholder': 'Contoh: B 1234 ABC',
  'lumen.pibEngine.p7.nomorSegelLabel': 'Nomor Segel',
  'lumen.pibEngine.p7.nomorSegelPlaceholder': 'Nomor segel',
  'lumen.pibEngine.p7.nomorKontainerLabel': 'Nomor Kontainer *',
  'lumen.pibEngine.p7.nomorKontainerPlaceholder': 'Contoh: ABCU1234567',
  'lumen.pibEngine.p7.waktuGateLabel': 'Waktu Gate *',
  'lumen.pibEngine.p7.kirim': 'Kirim',
  'lumen.pibEngine.p7.konfirmasiTitle': 'Konfirmasi',
  'lumen.pibEngine.p7.transferBilling': 'Transfer (Billing)',
  'lumen.pibEngine.p7.revisi': 'Revisi',
  'lumen.pibEngine.p7.transferWarning':
    'Anda akan melakukan Transfer (Billing). Dokumen akan disubmit secara final ke CEISA untuk mendapatkan billing. Pastikan semua data sudah benar.',
  'lumen.pibEngine.p7.revisiWarning':
    'Anda akan melakukan Revisi dokumen. Data yang sudah disubmit sebelumnya akan diperbarui di CEISA.',
  'lumen.pibEngine.p7.batal': 'Batal',
  'lumen.pibEngine.p7.lanjutkan': 'Ya, Lanjutkan',
  'lumen.pibEngine.p7.konfirmasiTransfer': 'Konfirmasi Transfer',
  'lumen.pibEngine.p7.konfirmasiTransferDesc':
    'Dokumen akan dikirim secara final ke CEISA. Pastikan semua data sudah benar sebelum melanjutkan.',
  'lumen.pibEngine.p7.yaTransfer': 'Ya, Transfer ke CEISA',
  'lumen.pibEngine.p7.dokumenBelumLengkap': 'Dokumen Wajib Belum Lengkap',
  'lumen.pibEngine.p7.submitKombinasi': 'Submit ke CEISA membutuhkan minimal kombinasi:',
  'lumen.pibEngine.p7.invoiceBl': 'INVOICE + BL (atau AWB)',
  'lumen.pibEngine.p7.belumTersedia': 'Belum tersedia',
  'lumen.pibEngine.p7.tambahkanDokumen': 'Tambahkan dokumen yang kurang pada tab Dokumen, lalu coba submit kembali.',
  'lumen.pibEngine.p7.mengerti': 'Mengerti',
  'lumen.pibEngine.p7.dokumenBermasalah': 'Dokumen Bermasalah',
  'lumen.pibEngine.p7.submitDedup':
    'Submit dibatalkan karena daftar dokumen akan di-dedup oleh backend (berdasarkan jenis + nomor dokumen). Perbaiki dulu di tab Dokumen.',
  'lumen.pibEngine.p7.barisKosong': 'Baris kosong (Seri)',
  'lumen.pibEngine.p7.lengkapiJenisNomor': 'Lengkapi Jenis dan Nomor Dokumen, atau hapus baris.',
  'lumen.pibEngine.p7.duplikat': 'Duplikat (Jenis · Nomor)',
  'lumen.pibEngine.p7.hapusBarisKembar': 'Hapus baris kembar atau ubah salah satu nomornya.',
  'lumen.pibEngine.p7.statusCEISA': 'Status CEISA',
  'lumen.pibEngine.p7.kode': 'Kode',
  'lumen.pibEngine.p7.waktu': 'Waktu',
  'lumen.pibEngine.p7.nomorDaftar': 'No. Daftar',
  'lumen.pibEngine.p7.responCEISA': 'Respon CEISA',
  'lumen.pibEngine.p7.pesan': 'Pesan',
  'lumen.pibEngine.p7.tutup': 'Tutup',
  'lumen.pibEngine.p7.hasilPungutan': 'Hasil Generate Pungutan',
  'lumen.pibEngine.p7.totalPungutan': 'Total Pungutan',
  'lumen.pibEngine.p7.submittingCEISA': 'Submitting to CEISA',
  'lumen.pibEngine.p7.processingDocument': 'Processing your document...',
  'lumen.pibEngine.p7.progress': 'Progress',
  'lumen.pibEngine.p7.submissionComplete': 'Submission Complete',
  'lumen.pibEngine.p7.submittedSuccessfully': 'Document submitted to CEISA successfully',
  'lumen.pibEngine.p7.submissionFailed': 'Submission Failed',
  'lumen.pibEngine.p7.close': 'Close',
  'lumen.pibEngine.s10.lihatDatabase': 'Lihat Database',
  'lumen.pibEngine.s10.loadingItems': 'Loading items...',
  'lumen.pibEngine.s10.searchPlaceholder': 'Search by description, HS code, brand... (press Enter to search)',
  'lumen.pibEngine.s10.originLabel': 'Origin: {name} ({code})',
  'lumen.pibEngine.s10.ajuLabel': 'Aju: {ajuNo}',
  'lumen.pibEngine.tr1.successTitle': 'Berhasil',
  'lumen.pibEngine.s21.welcome': "Hi! I'm your AI assistant 👋",
  'lumen.pibEngine.s21.welcomeHint': 'Select a context above and ask me anything!',
  'lumen.pibEngine.s21.placeholder': 'Type a message...',
  'lumen.pibEngine.s21.thinking': 'AI is thinking...',
  'lumen.pibEngine.s21.pChecking': '🔍 Sedang memeriksa semua tab... Mohon tunggu sebentar...',
  'lumen.pibEngine.s21.pVerified': 'Verifikasi Lengkap Semua Tab',
  'lumen.pibEngine.s21.pStatus': 'Status Pengecekan vs PDF',
  'lumen.pibEngine.s21.pResult': 'Hasil: 9/9 tab terverifikasi ✅',
  'lumen.pibEngine.s21.pMatch': 'Semua data sudah sesuai dengan PDF',
  'lumen.pibEngine.s21.aiAssistant': 'AI Assistant',
  'lumen.pibEngine.s21.online': 'Online',
  'lumen.pibEngine.s21.error': "Sorry, I'm having trouble responding right now. Please try again later.",
  'lumen.pibEngine.s21.contextLabel': '📍 {label}',
  'lumen.pibEngine.s11.tambahKemasan': 'Tambah Kemasan',
  'lumen.pibEngine.s11.tambahPetiKemas': 'Tambah Peti Kemas',
  'lumen.pibEngine.s11.seri': 'Seri',
  'lumen.pibEngine.s11.jumlah': 'Jumlah',
  'lumen.pibEngine.s11.jenis': 'Jenis',
  'lumen.pibEngine.s11.merek': 'Merek',
  'lumen.pibEngine.s11.merk': 'Merk',
  'lumen.pibEngine.s11.nomor': 'Nomor',
  'lumen.pibEngine.s11.ukuran': 'Ukuran',
  'lumen.pibEngine.s11.tipe': 'Tipe',
  'lumen.pibEngine.kb1.modalTitle': 'Informasi Komponen Biaya',
  'lumen.pibEngine.kb1.keterangan': 'Keterangan',
  'lumen.pibEngine.kb1.nilaiPasti': 'Nilai Pasti',
  'lumen.pibEngine.kb1.nilaiPerkiraan': 'Nilai Perkiraan (VD)',
  'lumen.pibEngine.kb1.hanyaSebenarnya': 'Harga yang sebenarnya atau yang seharusnya dibayar',
  'lumen.pibEngine.kb1.hargaInvoice': '1. Harga yang tercantum dalam Invoice',
  'lumen.pibEngine.kb1.pembayaranTdkLangsung':
    '2. Pembayaran tidak langsung (contoh pengurangan piutang pembeli/importir, nota kredit, dll)',
  'lumen.pibEngine.kb1.jumlahHarga': 'A. Jumlah Harga yang sebenarnya atau seharusnya dibayar (1+2)',
  'lumen.pibEngine.kb1.biayaPengurang': 'B. Biaya Pengurang (Diskon) yang {highlight} ke dalam invoice',
  'lumen.pibEngine.kb1.jumlahA_DikurangiB': 'C. Jumlah A Dikurangi B',
  'lumen.pibEngine.kb1.penambahBelumTermasuk': 'Biaya-biaya yang di tambahkan yang {highlight} ke dalam harga invoice',
  'lumen.pibEngine.kb1.komisiPenjualan': '1. Komisi penjualan dan jasa perantara',
  'lumen.pibEngine.kb1.biayaPengemasan': '2. Biaya pengemasan',
  'lumen.pibEngine.kb1.biayaPengepakan': '3. Biaya pengepakan',
  'lumen.pibEngine.kb1.nilaiBantuan': '4. Nilai bantuan (assist)',
  'lumen.pibEngine.kb1.assistDesc':
    '"Nilai bantuan (assist) adalah nilai barang dan jasa yang disediakan secara langsung atau tidak langsung oleh pembeli tanpa dipungut biaya atau dengan biaya yang dikurangi, untuk digunakan dalam produksi atau penjualan barang impor."',
  'lumen.pibEngine.kb1.royalti': '5. Royalti dan biaya lisensi',
  'lumen.pibEngine.kb1.royaltiDesc':
    'Royalti adalah pembayaran atas hak cipta, paten dan sejenisnya, sedangkan lisensi adalah pembayaran atas hak penggunaan suatu teknologi atau merek.',
  'lumen.pibEngine.kb1.proceeds': '6. Proceeds',
  'lumen.pibEngine.kb1.proceedsDesc':
    'Proceeds merupakan bagian hasil dari penjualan kembali, pelepasan atau penggunaan barang impor yang wajib disetor kepada penjual.',
  'lumen.pibEngine.kb1.biayaTransport': '7. Biaya Transportasi / Freight',
  'lumen.pibEngine.kb1.transportDesc':
    'Biaya transportasi / freight adalah biaya pengangkutan barang dari pelabuhan muat sampai ke pelabuhan bongkar yang belum termasuk dalam harga invoice.',
  'lumen.pibEngine.kb1.biayaPemuatan':
    '8. Biaya pemuatan, pembongkaran dan penanganan yang belum termasuk ke dalam biaya transportasi',
  'lumen.pibEngine.kb1.asuransi': '9. Asuransi / Insurance',
  'lumen.pibEngine.kb1.asuransiDesc':
    'Pilih jenis asuransi (Dalam Negeri atau Luar Negeri), kemudian isikan nilai asuransi yang belum termasuk dalam harga invoice.',
  'lumen.pibEngine.kb1.garansi': '10. Garansi',
  'lumen.pibEngine.kb1.jumlahPenambah': 'D. Jumlah Biaya Penambah (jumlah 1 s.d 10)',
  'lumen.pibEngine.kb1.jumlahC_DitambahD': 'E. Jumlah C ditambah D',
  'lumen.pibEngine.kb1.tidakPerluDitambahkan':
    'Biaya-biaya yang tidak perlu ditambahkan namun {highlight} ke dalam harga invoice',
  'lumen.pibEngine.kb1.kegiatanPembeli':
    '1. Biaya yang terjadi dari kegiatan yang dilakukan oleh Pembeli untuk kepentingan sendiri',
  'lumen.pibEngine.kb1.pengimporan': '2. Biaya yang terjadi setelah pengimporan barang',
  'lumen.pibEngine.kb1.pajakInternal': '3. Biaya pajak internal di negera pengekspor',
  'lumen.pibEngine.kb1.bunga': '4. Bunga',
  'lumen.pibEngine.kb1.deviden': '5. Deviden',
  'lumen.pibEngine.kb1.jumlahTidakDitambahkan': 'F. Jumlah Biaya yang Tidak Ditambahkan ( jumlah 1 s.d 5 )',
  'lumen.pibEngine.kb1.jumlahE_DikurangiF': 'G. Jumlah E dikurangi F',
  'lumen.pibEngine.kb1.hapus': 'Hapus',
  'lumen.pibEngine.kb1.simpan': 'Simpan',
  'lumen.pibEngine.kb1.menyimpan': 'Menyimpan...',
  'lumen.pibEngine.kb1.apakahYakin': 'Apakah anda yakin?',
  'lumen.pibEngine.kb1.andAkanMenghapusAnda': 'Anda akan menghapus data ini!',
  'lumen.pibEngine.kb1.tidak': 'Tidak',
  'lumen.pibEngine.kb1.ya': 'Ya',
  'lumen.pibEngine.kb1.error': 'Error',
  'lumen.pibEngine.kb1.lumenProcessIdNotFound': 'Lumen Process ID not found',
  'lumen.pibEngine.kb1.saveSuccess': 'Komponen biaya berhasil disimpan',
  'lumen.pibEngine.kb1.successTitle': 'Success',
  'lumen.pibEngine.kb1.saveError': 'Gagal menyimpan komponen biaya',
  'lumen.pibEngine.kb1.deleteSuccess': 'Data komponen biaya berhasil dihapus',
  'lumen.pibEngine.kb1.deleteError': 'Gagal menghapus komponen biaya',
  'lumen.pibEngine.kb1.notApplicable': '0.00',
  'lumen.pibEngine.kb1.tidakTermasuk': 'tidak termasuk',
  'lumen.pibEngine.kb1.belumTermasuk': 'belum termasuk',
  'lumen.pibEngine.kb1.sudahTermasuk': 'sudah termasuk',
  'lumen.pibEngine.kb2.incoterm': 'Incoterm',
  'lumen.pibEngine.kb2.dalamNegeri': 'DALAM NEGERI',
  'lumen.pibEngine.kb2.luarNegeri': 'LUAR NEGERI',
  'lumen.pibEngine.sh1.successTitle': 'Berhasil',
  'lumen.pibEngine.sh1.syncSuccess': 'Data berhasil disinkronkan. {matched} dari {total} barang berhasil dicocokkan.',
  'lumen.pibEngine.sh1.syncFailed': 'Gagal menyinkronkan data historis',
  'lumen.pibEngine.sh1.sourcesFailed': 'Gagal memuat sumber data historis',
  'lumen.pibEngine.sh1.previewFailed': 'Gagal memuat preview data',
  'lumen.pibEngine.sh1.forceApplied': 'Seri {seri} diterapkan dari kandidat terdekat.',
  'lumen.pibEngine.sh1.forceApplyUnavailable': 'Fitur force-apply belum tersedia di backend.',
  'lumen.pibEngine.sh1.forceApplyFailed': 'Gagal menerapkan kandidat.',
  'lumen.pibEngine.sh1.labelSaved': 'Label "{label}" berhasil disimpan',
  'lumen.pibEngine.sh1.labelRemoved': 'Label berhasil dihapus',
  'lumen.pibEngine.sh1.labelSaveFailed': 'Gagal menyimpan label',
  'lumen.pibEngine.sh1.stepSources': 'Pilih Sumber Data Historis',
  'lumen.pibEngine.sh1.stepPreview': 'Preview Data Historis',
  'lumen.pibEngine.sh1.stepResult': 'Hasil Sinkronisasi',
  'lumen.pibEngine.sh1.processIdLine': 'Process ID: {id} — {name}',
  'lumen.pibEngine.sh1.matchedSummary': '{matched} dari {total} barang dicocokkan',
  'lumen.pibEngine.sh2.aboutTitle': 'Tentang fitur ini',
  'lumen.pibEngine.sh2.aboutBodyExport':
    'Mengambil data dari dokumen ekspor sebelumnya dengan NPWP eksportir yang sama untuk melengkapi dokumen yang sedang dibuat.',
  'lumen.pibEngine.sh2.aboutBodyImport':
    'Mengambil data dari dokumen impor sebelumnya dengan NPWP importir yang sama untuk melengkapi dokumen yang sedang dibuat.',
  'lumen.pibEngine.sh2.updatedTitle': 'Yang diperbarui',
  'lumen.pibEngine.sh2.updatedBody': 'Entitas, Barang (HS, uraian, satuan, kemasan, negara asal), Kemasan, Transaksi',
  'lumen.pibEngine.sh2.unchangedTitle': 'Yang tidak berubah',
  'lumen.pibEngine.sh2.unchangedBody': 'Jumlah, berat, harga, freight, asuransi, dan data kuantitas lainnya',
  'lumen.pibEngine.sh2.loadingSources': 'Memuat sumber data...',
  'lumen.pibEngine.sh2.loadFailed': 'Gagal memuat',
  'lumen.pibEngine.sh2.retry': 'Coba lagi',
  'lumen.pibEngine.sh2.noHistory': 'Tidak ada data historis yang ditemukan untuk importir ini.',
  'lumen.pibEngine.sh2.summaryExport':
    '{sources} sumber dari {groups} pembeli — pilih salah satu untuk melihat preview',
  'lumen.pibEngine.sh2.summaryImport':
    '{sources} sumber dari {groups} pengirim — pilih salah satu untuk melihat preview',
  'lumen.pibEngine.sh2.buyer': 'Buyer',
  'lumen.pibEngine.sh2.shipper': 'Shipper',
  'lumen.pibEngine.sh2.barangCount': '{count} barang',
  'lumen.pibEngine.sh2.uniqueUraian': '{count} uraian unik',
  'lumen.pibEngine.sh2.npwpLine': 'NPWP: {npwp}',
  'lumen.pibEngine.sh2.labelPlaceholder': 'Ketik label...',
  'lumen.pibEngine.sh2.addLabel': 'Tambah label',
  'lumen.pibEngine.sh2.editLabel': 'Edit label',
  'lumen.pibEngine.sh2.mergedSources': '{count} sumber digabung',
  'lumen.pibEngine.sh2.previewButton': 'Lihat Preview',
  'lumen.pibEngine.sh2.loadingPreview': 'Memuat preview data...',
  'lumen.pibEngine.sh2.back': 'Kembali',
  'lumen.pibEngine.sh2.applySync': 'Terapkan Sinkronisasi',
  'lumen.pibEngine.sh2.exporter': 'Eksportir',
  'lumen.pibEngine.sh2.importer': 'Importir',
  'lumen.pibEngine.sh2.recipient': 'Penerima',
  'lumen.pibEngine.sh2.sender': 'Pengirim',
  'lumen.pibEngine.sh2.carrier': 'Pengangkut',
  'lumen.pibEngine.sh2.name': 'Nama',
  'lumen.pibEngine.sh2.npwp': 'NPWP',
  'lumen.pibEngine.sh2.address': 'Alamat',
  'lumen.pibEngine.sh2.country': 'Negara',
  'lumen.pibEngine.sh2.vessel': 'Sarana',
  'lumen.pibEngine.sh2.voyage': 'Voy/Flight',
  'lumen.pibEngine.sh2.flag': 'Bendera',
  'lumen.pibEngine.sh2.loadPort': 'Pel. Muat',
  'lumen.pibEngine.sh2.statDocuments': 'Dokumen',
  'lumen.pibEngine.sh2.statDocumentsUnit': 'dokumen',
  'lumen.pibEngine.sh2.statGoods': 'Barang',
  'lumen.pibEngine.sh2.statGoodsUnit': 'seri',
  'lumen.pibEngine.sh2.statTransaction': 'Transaksi',
  'lumen.pibEngine.sh2.barangTitle': 'Barang ({count} item)',
  'lumen.pibEngine.sh2.barangTitleLimited': 'Barang (Maks. 10 dari {count} item)',
  'lumen.pibEngine.sh2.colSeri': 'Seri',
  'lumen.pibEngine.sh2.colHsCode': 'Kode HS',
  'lumen.pibEngine.sh2.colUraian': 'Uraian',
  'lumen.pibEngine.sh2.colCountry': 'Negara',
  'lumen.pibEngine.sh2.moreItems': '... dan {count} barang lainnya',
  'lumen.pibEngine.sh2.syncedBanner': 'Synced {matched} of {total} barang',
  'lumen.pibEngine.sh2.fromSource': 'Dari {name}',
  'lumen.pibEngine.sh2.ajuInfo': '(Aju {aju})',
  'lumen.pibEngine.sh2.ajuInfoMore': '(Aju {aju}, +{count} lainnya)',
  'lumen.pibEngine.sh2.tabMatched': 'Matched',
  'lumen.pibEngine.sh2.tabNotMerged': 'Not Merged',
  'lumen.pibEngine.sh2.noneMatched': 'Tidak ada barang yang berhasil di-merge.',
  'lumen.pibEngine.sh2.allMerged': 'Semua barang berhasil di-merge.',
  'lumen.pibEngine.sh2.sourceAju': 'Source Aju',
  'lumen.pibEngine.sh2.sourceSeri': 'Source Seri',
  'lumen.pibEngine.sh2.sourceUraian': 'Source Uraian',
  'lumen.pibEngine.sh2.matchTier': 'Match Tier',
  'lumen.pibEngine.sh2.colUraianCurrent': 'Uraian (current)',
  'lumen.pibEngine.sh2.colScore': 'Score',
  'lumen.pibEngine.sh2.colReason': 'Reason',
  'lumen.pibEngine.sh2.colClosest': 'Closest Candidate',
  'lumen.pibEngine.sh2.colAction': 'Aksi',
  'lumen.pibEngine.sh2.candidateLine': 'Aju {aju} · Seri {seri}',
  'lumen.pibEngine.sh2.useCandidate': 'Use this candidate',
  'lumen.pibEngine.sh2.editManually': 'Edit manually',
  'lumen.pibEngine.sh2.closeModalTitle': 'Tutup modal',
  'lumen.pibEngine.sh2.editManuallyHint': 'Edit barang Seri {seri} secara manual dari tabel utama.',
  'lumen.pibEngine.sh2.pickDifferent': 'Pick different source',
  'lumen.pibEngine.sh2.close': 'Tutup',
  'lumen.pibEngine.ji1.statusOk': 'read off a document',
  'lumen.pibEngine.ji1.statusMasterOk': 'resolved from master data',
  'lumen.pibEngine.ji1.statusDefault': 'template constant',
  'lumen.pibEngine.ji1.statusShape': "outside the control's options",
  'lumen.pibEngine.ji1.statusMaster': 'waiting on master data',
  'lumen.pibEngine.ji1.statusCalc': 'CEISA calculates it',
  'lumen.pibEngine.ji1.statusUser': 'a person only',
  'lumen.pibEngine.ji1.copied': 'Copied',
  'lumen.pibEngine.ji1.copy': 'Copy',
  'lumen.pibEngine.ji1.sectionJsonAria': 'Section JSON',
  'lumen.pibEngine.ji1.saveToGroundTruth': 'Save to ground truth',
  'lumen.pibEngine.ji1.cancel': 'Cancel',
  'lumen.pibEngine.ji1.emptySectionHint': 'Leave it empty to record that the document has no such section.',
  'lumen.pibEngine.ji1.reviewedBy': 'Reviewed by {who}',
  'lumen.pibEngine.ji1.someone': 'someone',
  'lumen.pibEngine.ji1.reviewedAt': 'Reviewed {when}',
  'lumen.pibEngine.ji1.notYetReviewed': 'Not yet reviewed',
  'lumen.pibEngine.ji1.outputFromForm': 'Output from the form (synced {count}×, last {when})',
  'lumen.pibEngine.ji1.outputDrafted': 'Output as the pipeline drafted it',
  'lumen.pibEngine.ji1.sectionsEditedOne': '{count} section edited',
  'lumen.pibEngine.ji1.sectionsEditedMany': '{count} sections edited',
  'lumen.pibEngine.ji1.noSectionsEdited': 'no sections edited',
  'lumen.pibEngine.ji1.rerunSinceSeeded': 're-run since seeded',
  'lumen.pibEngine.ji1.rerunSinceSeededTip':
    "The batch was run through the pipeline again after this review started. The pipeline's row is the new run; this ground truth still holds what was reviewed.",
  'lumen.pibEngine.ji1.resyncFromForm': 'Resync from form',
  'lumen.pibEngine.ji1.resyncTip':
    "Read the form's rows back into the reviewed output now. Every save on the form already does this.",
  'lumen.pibEngine.ji1.withdrawReview': 'Withdraw review',
  'lumen.pibEngine.ji1.markAsReviewed': 'Mark as reviewed',
  'lumen.pibEngine.ji1.groundTruthIntroBefore':
    'The nine tab payloads as reviewed -- the same shape the pipeline writes to',
  'lumen.pibEngine.ji1.groundTruthIntroAfter':
    ', joined. The sections half is on the Documents view, where each one can be edited.',
  'lumen.pibEngine.ji1.rowsCount': '{count} rows',
  'lumen.pibEngine.ji1.keysCount': '{count} keys',
  'lumen.pibEngine.ji1.empty': 'empty',
  'lumen.pibEngine.ji1.sectionEdits': 'Section edits',
  'lumen.pibEngine.ji1.recordedCount': '{count} recorded',
  'lumen.pibEngine.ji1.moreCharacters': '… {count} more characters',
  'lumen.pibEngine.ji1.noSections':
    'This run stored no sections. Runs from before the inspector existed did not keep them — re-run the batch to see them.',
  'lumen.pibEngine.ji1.noSectionList': 'no section list',
  'lumen.pibEngine.ji1.sharedFile': 'shared file',
  'lumen.pibEngine.ji1.sharedFileTip':
    "Another document wrote to the same file; these sections may be the other document's.",
  'lumen.pibEngine.ji1.fileOverwritten': 'file overwritten',
  'lumen.pibEngine.ji1.fileOverwrittenTip':
    'The extraction file on this pod disagrees with what the tabs were actually fed, so another run of a document with this name overwrote it. Sections marked “another run’s file” below are not this run’s; everything a tab was given still is.',
  'lumen.pibEngine.ji1.requiredEmpty': '{count} required empty',
  'lumen.pibEngine.ji1.sectionsFound': '{found}/{total} sections',
  'lumen.pibEngine.ji1.readBackFailed':
    'The extraction file could not be read back for this document, so only the sections a tab was actually fed are shown. The rest are empty here, not in the run.',
  'lumen.pibEngine.ji1.edited': 'edited',
  'lumen.pibEngine.ji1.reviewedEditBy': "Reviewed edit by {who} {when}. The pipeline's own answer is shown below it.",
  'lumen.pibEngine.ji1.offSchema': 'off-schema',
  'lumen.pibEngine.ji1.offSchemaTip': "The model answered with a section this document type's schema does not name.",
  'lumen.pibEngine.ji1.required': 'required',
  'lumen.pibEngine.ji1.multiRegion': 'multi-region',
  'lumen.pibEngine.ji1.anotherRunsFile': 'another run’s file',
  'lumen.pibEngine.ji1.anotherRunsFileTip':
    "Read back off the pod's extraction file, which another run has since overwritten. No tab was given this section, so the run itself kept no other copy.",
  'lumen.pibEngine.ji1.sentToATab': 'sent to a tab',
  'lumen.pibEngine.ji1.sentToATabTip': 'This is the copy a tab was actually fed.',
  'lumen.pibEngine.ji1.editAgain': 'Edit again',
  'lumen.pibEngine.ji1.editForGroundTruth': 'Edit for ground truth',
  'lumen.pibEngine.ji1.resetToPipelines': 'Reset to the pipeline’s',
  'lumen.pibEngine.ji1.reviewerRecordedNone': 'The reviewer recorded no such section on this document.',
  'lumen.pibEngine.ji1.nothingExtracted': 'Nothing was extracted under this heading.',
  'lumen.pibEngine.ji1.pipelinesOwnAnswer': 'The pipeline’s own answer',
  'lumen.pibEngine.ji1.whatTheReaderSaw': 'What the reader saw',
  'lumen.pibEngine.ji1.charactersCount': '{count} characters',
  'lumen.pibEngine.ji1.pagesCount': '{count} pages',
  'lumen.pibEngine.ji1.truncated': 'truncated',
  'lumen.pibEngine.ji1.noPerFieldView':
    'No per-field view for this tab. It is stored by the PIB overlay, which this run did not keep.',
  'lumen.pibEngine.ji1.value': 'Value',
  'lumen.pibEngine.ji1.ruleThePromptStates': 'The rule the prompt states',
  'lumen.pibEngine.ji1.whereItComesFrom': 'Where it comes from',
  'lumen.pibEngine.ji1.sentToTheModel': 'sent to the model',
  'lumen.pibEngine.ji1.notInTheSlice': 'not in the slice',
  'lumen.pibEngine.ji1.neverGivenSection':
    'No document of this type carried this section, so the tab was never given it.',
  'lumen.pibEngine.ji1.nothingSpeaksToInput':
    "Nothing in the documents speaks to this input — it is a constant, a calculation, or a person's to fill.",
  'lumen.pibEngine.ji2.noTabCalls':
    'This run stored no tab calls. Runs from before the inspector existed did not keep them.',
  'lumen.pibEngine.ji2.tabsAria': 'Tab calls',
  'lumen.pibEngine.ji2.nothingStoredTab': 'Nothing was stored for this tab.',
  'lumen.pibEngine.ji2.askedModel': 'asked the model',
  'lumen.pibEngine.ji2.assembledRules': 'assembled from rules',
  'lumen.pibEngine.ji2.callOne': '{count} call',
  'lumen.pibEngine.ji2.callMany': '{count} calls',
  'lumen.pibEngine.ji2.documentOne': '{count} document',
  'lumen.pibEngine.ji2.documentMany': '{count} documents',
  'lumen.pibEngine.ji2.sharePct': '{pct}% of the extractions',
  'lumen.pibEngine.ji2.shareTip': 'How much of everything extracted this tab was actually sent',
  'lumen.pibEngine.ji2.promptNotVerified': 'prompt not verified',
  'lumen.pibEngine.ji2.promptNotVerifiedTip':
    "The prompts are rebuilt from the stored slice and did not match the number of calls the run recorded. The slice and the answer are still the run's own.",
  'lumen.pibEngine.ji2.inputTitle': 'Input — the slice this tab was fed',
  'lumen.pibEngine.ji2.inputSubtitle': '{shown} of {total} characters',
  'lumen.pibEngine.ji2.sectionsCount': '{count} sections',
  'lumen.pibEngine.ji2.notSentToTab': 'Not sent to this tab: {list}',
  'lumen.pibEngine.ji2.heldBackDoc':
    'Held back as redundant: {list} — the map does give this tab these, and a primary in this pile already answers the same field.',
  'lumen.pibEngine.ji2.noDocMapped': 'No document was mapped to this tab, so no call went out.',
  'lumen.pibEngine.ji2.notGivenAtAll': 'Not given to this tab at all: {list}',
  'lumen.pibEngine.ji2.heldBackAbsent':
    'Held back as redundant: {list} — everything the map gives this tab of these is a table a primary in this pile already answers.',
  'lumen.pibEngine.ji2.promptTitle': 'Prompt — exactly what the model was sent',
  'lumen.pibEngine.ji2.systemInstruction': 'System instruction',
  'lumen.pibEngine.ji2.callOfTotal': 'Call {n} of {total}',
  'lumen.pibEngine.ji2.promptWord': 'Prompt',
  'lumen.pibEngine.ji2.noPromptKept':
    'No prompt was kept for this tab — either no call went out, or the capture shed them to stay inside its size cap.',
  'lumen.pibEngine.ji2.outputTitle': 'Output — what the model answered',
  'lumen.pibEngine.ji2.emptyWord': 'empty',
  'lumen.pibEngine.ji2.payloadTitle': 'Payload — what went onto the form',
  'lumen.pibEngine.ji2.payloadSubtitle': 'after the rules and the master-data lookups',
  'lumen.pibEngine.ji2.fieldsTitle': 'Fields — one row per input on this tab',
  'lumen.pibEngine.ji2.pendingTitle': 'Pending — what this tab could not answer',
  'lumen.pibEngine.ji2.choicesTitle': 'Choices — where the documents printed more than one right answer',
  'lumen.pibEngine.ji2.noModelCalls':
    'This run kept no model calls. Runs from before the ledger was stored with the draft did not keep them — re-run the batch to see them.',
  'lumen.pibEngine.ji2.hostTip': "The server that answered — OpenRouter's provider, or google",
  'lumen.pibEngine.ji2.slowestRetried': 'slowest {stage}: {seconds} · {attempts} attempts',
  'lumen.pibEngine.ji2.slowestBadge': 'slowest {stage}: {seconds}',
  'lumen.pibEngine.ji2.slowestTip':
    'Slowest {stage} call: {subject}, {seconds} on {host}, {attempts}, {tokens} answer tokens',
  'lumen.pibEngine.ji2.attemptOne': '{count} attempt',
  'lumen.pibEngine.ji2.attemptMany': '{count} attempts',
  'lumen.pibEngine.ji2.inOrder': 'In order',
  'lumen.pibEngine.ji2.slowestFirst': 'Slowest first',
  'lumen.pibEngine.ji2.callsNote':
    'Seconds include the waits between attempts. More than one attempt means the call was refused first — a rate limit or a full provider — and a slow call with one attempt was a slow host or a long answer.',
  'lumen.pibEngine.ji2.colStage': 'Stage',
  'lumen.pibEngine.ji2.colSubject': 'Subject',
  'lumen.pibEngine.ji2.colModel': 'Model',
  'lumen.pibEngine.ji2.colHost': 'Host',
  'lumen.pibEngine.ji2.colSeconds': 'Seconds',
  'lumen.pibEngine.ji2.colAttempts': 'Attempts',
  'lumen.pibEngine.ji2.colIn': 'In',
  'lumen.pibEngine.ji2.colOut': 'Out',
  'lumen.pibEngine.ji2.colCost': 'Cost',
  'lumen.pibEngine.ji2.colFinish': 'Finish',
  'lumen.pibEngine.ji2.rowCandidateMissed': 'row {seri} ({code}): {reason}',
  'lumen.pibEngine.ji2.rowCandidateTaken': 'row {seri} ({code}) is on line {line}',
  'lumen.pibEngine.ji2.notShippedDetail': 'no goods row prints anything close to this code',
  'lumen.pibEngine.ji2.noCodeDetail': 'the line prints no article code to check the goods rows against',
  'lumen.pibEngine.ji2.pendingDash': 'pending —',
  'lumen.pibEngine.ji2.noAttachRecord':
    "This run kept no attach record. Either nothing it read attaches to goods lines — no certificate, permit or surveyor's report — or it ran before the record was stored, and re-running the batch will show it.",
  'lumen.pibEngine.ji2.filterPlaceholder': 'Filter by seri barang, code or naming',
  'lumen.pibEngine.ji2.allLines': 'All lines',
  'lumen.pibEngine.ji2.unmatchedOnly': 'Unmatched lines only',
  'lumen.pibEngine.ji2.likelyMissedOnly': 'Likely missed only',
  'lumen.pibEngine.ji2.attachNote':
    "Each goods line a document printed, beside the barang rows it was attached to and the test that settled it. The article code goes first across the whole document; then an equal amount, the naming, the line number. A line with no row stayed pending, and says whether it rightly did: correct when no goods row prints a close code, or when the rows that do are on lines of their own; likely missed when a row with a close code — a leading zero, a code inside a longer one, a code the document cut off — was left free. Replayed from the run's own documents, not read again.",
  'lumen.pibEngine.ji2.replayMismatch':
    'Replaying the join did not make exactly the links this run stored, so a reason below may not be the one that decided it.',
  'lumen.pibEngine.ji2.dokumenSerials': ' · Dokumen #{list}',
  'lumen.pibEngine.ji2.rowsLines': '{rows} rows · {lines} lines',
  'lumen.pibEngine.ji2.unmatchedCount': '{count} unmatched',
  'lumen.pibEngine.ji2.likelyMissedCount': '{count} likely missed',
  'lumen.pibEngine.ji2.attachedNothing': 'Attached nothing: {reason}',
  'lumen.pibEngine.ji2.colLine': 'Line',
  'lumen.pibEngine.ji2.colCode': 'Code',
  'lumen.pibEngine.ji2.colNaming': "Document's naming",
  'lumen.pibEngine.ji2.colQty': 'Qty',
  'lumen.pibEngine.ji2.colSeri': 'Seri',
  'lumen.pibEngine.ji2.colBarang': 'Barang',
  'lumen.pibEngine.ji2.colSettledBy': 'Settled by',
  'lumen.pibEngine.ji2.colWhatHeld': 'What held',
  'lumen.pibEngine.ji2.noLineMatches': 'No line matches this filter.',
  'lumen.pibEngine.ji2.panelTitle': 'Lumen 2.0 — what the pipeline read',
  'lumen.pibEngine.ji2.documentsCount': '{count} documents',
  'lumen.pibEngine.ji2.fetching': 'Fetching what the run read — this is the size of the extractions.',
  'lumen.pibEngine.ji2.fetchFailed':
    'The draft could not be fetched. It may have been run before the inspector existed, or the service may be unreachable.',
  'lumen.pibEngine.ji2.viewsAria': 'Inspector views',
  'lumen.pibEngine.ji2.viewDocuments': 'Documents ({count})',
  'lumen.pibEngine.ji2.viewTabs': 'Tabs ({count})',
  'lumen.pibEngine.ji2.viewCalls': 'Model calls ({count})',
  'lumen.pibEngine.ji2.viewAttach': 'Attach ({count})',
  'lumen.pibEngine.ji2.viewTruth': 'Ground truth',
  'lumen.pibEngine.mtb.seriIzinTitle': 'Seri Izin',
  'lumen.pibEngine.mtb.seriIzinSubtitle': 'No. urut barang di dalam satu dokumen izin',
  'lumen.pibEngine.mtb.dokumenIzin': 'Dokumen Izin',
  'lumen.pibEngine.mtb.noDocumentPlaceholder': 'Belum ada dokumen pada draft ini',
  'lumen.pibEngine.mtb.documentPlaceholder': 'Pilih dokumen izin...',
  'lumen.pibEngine.mtb.documentHint':
    'Seri izin menempel pada pasangan barang & dokumen, jadi dokumen tujuan wajib dipilih. Barang yang belum terhubung ke dokumen ini akan otomatis dilampirkan.',
  'lumen.pibEngine.mtb.fillMethod': 'Cara Pengisian',
  'lumen.pibEngine.mtb.serialList': 'Daftar Seri Barang & Seri Izin',
  'lumen.pibEngine.mtb.serialHintA': 'Satu pasang per baris —',
  'lumen.pibEngine.mtb.serialHintCode': 'seri barang : seri izin',
  'lumen.pibEngine.mtb.serialHintB':
    '. Bisa ditempel langsung dari Excel; pemisah koma, titik dua, sama dengan, spasi, atau tab.',
  'lumen.pibEngine.mtb.startFrom': 'Mulai Dari',
  'lumen.pibEngine.mtb.serialValue': 'Nilai Seri Izin',
  'lumen.pibEngine.mtb.startHint': 'Nomor berjalan naik satu per satu mengikuti urutan seri barang.',
  'lumen.pibEngine.mtb.sameValueHint': 'Nomor yang sama diterapkan ke seluruh seri barang di baris ini.',
  'lumen.pibEngine.mtb.previewLabel': 'Pratinjau Penomoran',
  'lumen.pibEngine.mtb.barang': 'barang',
  'lumen.pibEngine.mtb.notYet': 'belum ada',
  'lumen.pibEngine.mtb.pasteHint': 'Tempel daftar pasangan seri barang dan seri izin di atas.',
  'lumen.pibEngine.mtb.fillHint': 'Isi Seri Barang dan nomor awal untuk melihat hasil penomoran.',
  'lumen.pibEngine.mtb.others': 'lainnya',
  'lumen.pibEngine.mtb.outsideRange':
    'seri barang di luar rentang "Seri Barang" baris ini — tetap diterapkan, tetapi lewati bila tidak disengaja.',
  'lumen.pibEngine.hcc.title': 'HS Code Tariff Data',
  'lumen.pibEngine.hcc.hsCodes': 'HS Codes',
  'lumen.pibEngine.hcc.items': 'Items',
  'lumen.pibEngine.hcc.loading': 'Loading tariff data...',
  'lumen.pibEngine.hcc.noData': 'Tidak ada data untuk ditampilkan',
  'lumen.pibEngine.hcc.group': 'Group',
  'lumen.pibEngine.hcc.hsCode': 'HS Code',
  'lumen.pibEngine.hcc.dokumen': 'Dokumen',
  'lumen.pibEngine.hcc.ppn': 'PPN (%)',
  'lumen.pibEngine.hcc.pph': 'PPH (%)',
  'lumen.pibEngine.hcc.bm': 'BM (%)',
  'lumen.pibEngine.hcc.count': 'Jumlah Item',
  'lumen.pibEngine.hcc.seriBarang': 'Seri Barang',
  'lumen.pibEngine.hcc.lartas': 'Lartas',
  'lumen.pibEngine.hcc.sync': 'Sync',
  'lumen.pibEngine.s19.modul': 'Modul: {modul}',
  'lumen.pibEngine.s19.na': 'N/A',
  'lumen.pibEngine.s19.wajibLaporDheSda': 'Wajib Lapor DHE-SDA',
  'lumen.pibEngine.s19.tidak': 'Tidak',
  'lumen.pibEngine.s19.note': 'NOTE',
  'lumen.pibEngine.s12.selectDocumentError': 'Please select a document',
  'lumen.pibEngine.s12.dokumenFasilitasLartas': 'Dokumen Fasilitas / Lartas',
  'lumen.pibEngine.s12.dokumen': 'Dokumen',
  'lumen.pibEngine.s12.pilihDokumen': 'Pilih Dokumen',
  'lumen.pibEngine.s12.izin': 'Izin',
  'lumen.pibEngine.s12.masukkanIzin': 'Masukkan izin',
  'lumen.pibEngine.s12.dokumenLampiran': 'Dokumen Lampiran',
  'lumen.pibEngine.s12.modalIsOpen': 'Modal is open: {open}',
  'lumen.pibEngine.s12.seri': 'Seri',
  'lumen.pibEngine.s12.jenisDokumen': 'Jenis Dokumen',
  'lumen.pibEngine.s12.pilihJenisDokumen': 'Pilih Jenis Dokumen',
  'lumen.pibEngine.s12.nomor': 'Nomor',
  'lumen.pibEngine.s12.tanggal': 'Tanggal',
  'lumen.pibEngine.s12.pilihTanggal': 'Pilih Tanggal ',
  'lumen.pibEngine.s12.kodeIjin': 'Kode Ijin',
  'lumen.pibEngine.s12.pilihKodeIjin': 'Pilih Kode Ijin',
  'lumen.pibEngine.s12.tidakDitemukan': 'Tidak ditemukan',
  'lumen.pibEngine.s12.fasilitasDokumen': 'Fasilitas Dokumen',
  'lumen.pibEngine.s12.pilihFasilitasDokumen': 'Pilih Fasilitas Dokumen',
  'lumen.pibEngine.s12.statusDokumen': 'Status Dokumen',
  'lumen.pibEngine.s12.cancel': 'Cancel',
  'lumen.pibEngine.rv1.draftPibTitle': 'Draft PIB',
  'lumen.pibEngine.rv2.syncInfoTitle': 'Info',
  'lumen.pibEngine.rv2.revisionProgressAria': 'Progress revision checklist',
  'lumen.pibEngine.mtd.row': 'Baris',
  'lumen.pibEngine.mtd.removeRow': 'Hapus baris',
  'lumen.pibEngine.mtd.identityTitle': 'Identitas Barang',
  'lumen.pibEngine.mtd.identitySubtitle': 'Baris tujuan dan klasifikasi HS',
  'lumen.pibEngine.mtd.seriBarang': 'Seri Barang',
  'lumen.pibEngine.mtd.seriBarangHint': 'Nomor baris yang diperbarui. Pakai koma atau strip — contoh',
  'lumen.pibEngine.mtd.hsCode': 'HS Code',
  'lumen.pibEngine.mtd.hsCodeHint': 'Kode klasifikasi Harmonized System barang.',
  'lumen.pibEngine.mtd.hsCodePlaceholder': 'Pilih HS Code…',
  'lumen.pibEngine.mtd.uraian': 'Uraian',
  'lumen.pibEngine.mtd.uraianHint': 'Deskripsi lengkap barang sesuai dokumen (invoice / packing list).',
  'lumen.pibEngine.mtd.uraianPlaceholder': 'mis. Telepon pintar layar 6,7 inci, 256GB',
  'lumen.pibEngine.mtd.kodeBarang': 'Kode Barang',
  'lumen.pibEngine.mtd.kodeBarangPlaceholder': 'SKU / kode internal (opsional)',
  'lumen.pibEngine.mtd.merkTitle': 'Merek & Spesifikasi',
  'lumen.pibEngine.mtd.merkSubtitle': 'Tandai "tanpa" bila barang tidak bermerek / bertipe',
  'lumen.pibEngine.mtd.merek': 'Merek',
  'lumen.pibEngine.mtd.noBrand': 'Tanpa merek',
  'lumen.pibEngine.mtd.brandPlaceholder': 'Nama merek',
  'lumen.pibEngine.mtd.noBrandFlag': 'TANPA MEREK',
  'lumen.pibEngine.mtd.tipe': 'Tipe',
  'lumen.pibEngine.mtd.noType': 'Tanpa tipe',
  'lumen.pibEngine.mtd.typePlaceholder': 'Nama tipe',
  'lumen.pibEngine.mtd.noTypeFlag': 'TANPA TIPE',
  'lumen.pibEngine.mtd.ukuran': 'Ukuran',
  'lumen.pibEngine.mtd.ukuranHint': 'Ukuran / dimensi bila relevan.',
  'lumen.pibEngine.mtd.ukuranPlaceholder': 'mis. XL / 42',
  'lumen.pibEngine.mtd.originTitle': 'Asal, Satuan & Kemasan',
  'lumen.pibEngine.mtd.originSubtitle': 'Data logistik dan berat barang',
  'lumen.pibEngine.mtd.negaraAsal': 'Negara Asal',
  'lumen.pibEngine.mtd.negaraAsalHint': 'Negara tempat barang diproduksi.',
  'lumen.pibEngine.mtd.countryPlaceholder': 'Pilih negara…',
  'lumen.pibEngine.mtd.kodeSatuan': 'Kode Satuan',
  'lumen.pibEngine.mtd.kodeSatuanHint': 'Satuan kuantitas barang.',
  'lumen.pibEngine.mtd.unitPlaceholder': 'Pilih satuan…',
  'lumen.pibEngine.mtd.kodeKemasan': 'Kode Kemasan',
  'lumen.pibEngine.mtd.kodeKemasanHint': 'Jenis kemasan pengiriman.',
  'lumen.pibEngine.mtd.packagingPlaceholder': 'Pilih kemasan…',
  'lumen.pibEngine.mtd.nettLabel': 'Berat Bersih / Nett Weight (KGM)',
  'lumen.pibEngine.mtd.nettHint': 'Berat bersih per unit dalam kilogram.',
  'lumen.pibEngine.mtd.taxTitle': 'Pajak & Fasilitas',
  'lumen.pibEngine.mtd.taxSubtitle': 'Tarif dan fasilitas kepabeanan barang',
  'lumen.pibEngine.mtd.fasBM': 'Fasilitas BM',
  'lumen.pibEngine.mtd.taxNameBM': 'Bea Masuk',
  'lumen.pibEngine.mtd.fasPPN': 'Fasilitas PPN',
  'lumen.pibEngine.mtd.taxNamePPN': 'Pajak Pertambahan Nilai',
  'lumen.pibEngine.mtd.fasPPh': 'Fasilitas PPh',
  'lumen.pibEngine.mtd.taxNamePPh': 'Pajak Penghasilan',
  'lumen.pibEngine.mtd.facilityPlaceholder': 'Pilih fasilitas...',
  'lumen.pibEngine.mtd.pastedList': 'daftar tempel',
  'lumen.pibEngine.mtd.notSet': 'belum ditentukan',
  'lumen.pibEngine.mtd.noHsSelected': 'Belum ada HS Code dipilih',
  'lumen.pibEngine.mtd.noDescription': 'Belum ada uraian barang.',
  'lumen.pibEngine.mtd.none': 'Tanpa',
  'lumen.pibEngine.mtd.dialogEyebrow': 'Detail Barang Impor',
  'lumen.pibEngine.mtd.dialogTitle': 'Atur Merek, Tipe, Ukuran & HS Barang',
  'lumen.pibEngine.mtd.dialogIntro':
    'Isi hanya field yang ingin diperbarui — sisanya dibiarkan kosong tidak akan mengubah data baris terpilih.',
  'lumen.pibEngine.mtd.close': 'Tutup',
  'lumen.pibEngine.mtd.summaryTitle': 'Ringkasan Baris',
  'lumen.pibEngine.mtd.summaryIntro': 'Pratinjau langsung data yang akan disimpan.',
  'lumen.pibEngine.mtd.requiredFields': 'Field wajib',
  'lumen.pibEngine.mtd.appliedToSeri': 'Diterapkan ke seri:',
  'lumen.pibEngine.mtd.summaryNegara': 'Negara asal',
  'lumen.pibEngine.mtd.summarySatuan': 'Satuan',
  'lumen.pibEngine.mtd.summaryKemasan': 'Kemasan',
  'lumen.pibEngine.mtd.summaryNett': 'Berat bersih',
  'lumen.pibEngine.mtd.summaryTax': 'Pajak',
  'lumen.pibEngine.mtd.summarySeriIzin': 'Seri Izin',
  'lumen.pibEngine.mtd.numbered': 'barang dinomori',
  'lumen.pibEngine.mtd.noPermitDoc': 'Belum ada dokumen izin dipilih — seri izin tidak diubah.',
  'lumen.pibEngine.mtd.footerA': 'Perubahan diterapkan pada seri',
  'lumen.pibEngine.mtd.footerB': 'Seri izin ditulis ke',
  'lumen.pibEngine.mtd.footerC': 'untuk',
  'lumen.pibEngine.mtd.footerD': 'barang.',
  'lumen.pibEngine.mtd.cancel': 'Batal',
  'lumen.pibEngine.mtd.addRow': 'Tambah Baris',
  'lumen.pibEngine.mtd.apply': 'Terapkan',
  'lumen.pibEngine.rv5.rowN': 'Baris {n}',
  'lumen.pibEngine.rv5.numberedN': '{n} barang dinomori',
  'lumen.pibEngine.rv5.statusMatch': 'Match',
  'lumen.pibEngine.rv5.statusMismatch': 'Mismatch',
  'lumen.pibEngine.rv5.mandatory': 'mandatory',
  'lumen.pibEngine.rv5.fetchError': 'Gagal mengambil data perbandingan',
  'lumen.pibEngine.rv5.dupSeri': 'Seri',
  'lumen.pibEngine.rv5.dupDokumen': 'dokumen',
  'lumen.pibEngine.rv5.dupSeriDok': 'seri',
  'lumen.pibEngine.rv5.jenisN': '{n} jenis',
  'lumen.pibEngine.rv5.kgN': '{n} kg',
  // lumen.otherDocs (revamp PR 8a)
  'lumen.otherDocs.ck1.statusDraft': 'Draft',
  'lumen.otherDocs.ck1.statusFinal': 'Final',
  'lumen.otherDocs.ck1.statusCkGenerated': 'CK Dibuat',
  'lumen.otherDocs.ck1.statusCancelled': 'Dibatalkan',
  'lumen.otherDocs.ck1.statusGenerated': 'Draft CK',
  'lumen.otherDocs.ck1.statusSubmitted': 'Terkirim',
  'lumen.otherDocs.ck1.statusAccepted': 'Diterima',
  'lumen.otherDocs.ck1.statusRejected': 'Ditolak',
  'lumen.otherDocs.ck1.statusError': 'Gagal',
  'lumen.otherDocs.ck1.docCk1Desc': 'Pemesanan Pita Cukai',
  'lumen.otherDocs.ck1.docCk4Desc': 'Laporan Produksi BKC',
  'lumen.otherDocs.ck1.docCk5Desc': 'Mutasi Barang Kena Cukai',
  'lumen.otherDocs.ck1.itemBahanBaku': 'Bahan Baku',
  'lumen.otherDocs.ck1.itemBarangJadi': 'Barang Jadi',
  'lumen.otherDocs.ck1.itemPitaCukai': 'Pita Cukai',
  'lumen.otherDocs.ck1.addItem': 'Tambah Barang',
  'lumen.otherDocs.ck1.allStatus': 'Semua status',
  'lumen.otherDocs.ck1.caraKredit': 'Kredit',
  'lumen.otherDocs.ck1.caraTunai': 'Tunai',
  'lumen.otherDocs.ck1.cellRows': '{n} baris',
  'lumen.otherDocs.ck1.colAksi': 'Aksi',
  'lumen.otherDocs.ck1.colAngkutan': 'Angkutan',
  'lumen.otherDocs.ck1.colBarang': 'Barang',
  'lumen.otherDocs.ck1.colPengirimPenerima': 'Pengirim → Penerima',
  'lumen.otherDocs.ck1.colStatus': 'Status',
  'lumen.otherDocs.ck1.colSuratJalan': 'Surat Jalan',
  'lumen.otherDocs.ck1.createButton': 'Buat Surat Jalan',
  'lumen.otherDocs.ck1.delBodyAfter': '? Dokumen CK yang sudah dibuat tidak ikut terhapus.',
  'lumen.otherDocs.ck1.delBodyBefore': 'Yakin ingin menghapus',
  'lumen.otherDocs.ck1.deleteItemAria': 'Hapus barang #{n}',
  'lumen.otherDocs.ck1.delTitle': 'Hapus Surat Jalan',
  'lumen.otherDocs.ck1.emptyDesc': 'Buat surat jalan pertama Anda, lalu terbitkan CK-1 / CK-4 / CK-5 darinya.',
  'lumen.otherDocs.ck1.emptyTitle': 'Belum ada surat jalan',
  'lumen.otherDocs.ck1.existingDocs': 'DOKUMEN YANG SUDAH DIBUAT DARI SURAT JALAN INI',
  'lumen.otherDocs.ck1.fAlamatPenerima': 'Alamat Penerima',
  'lumen.otherDocs.ck1.fAlamatPengirim': 'Alamat Pengirim',
  'lumen.otherDocs.ck1.fHje': 'HJE / kemasan',
  'lumen.otherDocs.ck1.fIsiPerKemasan': 'Isi per Kemasan',
  'lumen.otherDocs.ck1.fJenisBkc': 'Jenis BKC',
  'lumen.otherDocs.ck1.fJenisKemasan': 'Jenis Kemasan',
  'lumen.otherDocs.ck1.fJenisKemasanPlaceholder': 'Bungkus / Karton',
  'lumen.otherDocs.ck1.fJumlah': 'Jumlah',
  'lumen.otherDocs.ck1.fJumlahKemasan': 'Jumlah Kemasan',
  'lumen.otherDocs.ck1.fKadarAlkohol': 'Kadar Alkohol %',
  'lumen.otherDocs.ck1.fKeterangan': 'Keterangan',
  'lumen.otherDocs.ck1.fKodeBarang': 'Kode Barang',
  'lumen.otherDocs.ck1.fKodeKantorAsal': 'Kode Kantor Asal (KPPBC)',
  'lumen.otherDocs.ck1.fKodeKantorTujuan': 'Kode Kantor Tujuan',
  'lumen.otherDocs.ck1.fMerk': 'Merk',
  'lumen.otherDocs.ck1.fModa': 'Moda',
  'lumen.otherDocs.ck1.fNamaPenerima': 'Nama Penerima',
  'lumen.otherDocs.ck1.fNamaPengangkut': 'Nama Pengangkut',
  'lumen.otherDocs.ck1.fNamaPengirim': 'Nama Pengirim',
  'lumen.otherDocs.ck1.fNomorPolisi': 'Nomor Polisi',
  'lumen.otherDocs.ck1.fNomorSuratJalan': 'Nomor Surat Jalan',
  'lumen.otherDocs.ck1.fNppbkcPenerima': 'NPPBKC Penerima',
  'lumen.otherDocs.ck1.fNppbkcPengirim': 'NPPBKC Pengirim',
  'lumen.otherDocs.ck1.fNpwpPenerima': 'NPWP Penerima',
  'lumen.otherDocs.ck1.fNpwpPengirim': 'NPWP Pengirim',
  'lumen.otherDocs.ck1.formTitleCreate': 'Buat Surat Jalan',
  'lumen.otherDocs.ck1.formTitleEdit': 'Edit Surat Jalan — {nomor}',
  'lumen.otherDocs.ck1.fPengemudi': 'Pengemudi',
  'lumen.otherDocs.ck1.fPerkiraanTiba': 'Perkiraan Tiba',
  'lumen.otherDocs.ck1.fromSuratJalan': 'Dari surat jalan',
  'lumen.otherDocs.ck1.fSatuan': 'Satuan',
  'lumen.otherDocs.ck1.fStatus': 'Status',
  'lumen.otherDocs.ck1.fTanggal': 'Tanggal',
  'lumen.otherDocs.ck1.fTarifCukai': 'Tarif Cukai / satuan',
  'lumen.otherDocs.ck1.fTglBerangkat': 'Tgl Berangkat',
  'lumen.otherDocs.ck1.fUraianBarang': 'Uraian Barang',
  'lumen.otherDocs.ck1.gCaraBayar': 'Cara Bayar',
  'lumen.otherDocs.ck1.genAlertBody':
    'Data pengirim, penerima, transportasi, dan {n} barang akan diisi otomatis dari surat jalan ini. Draft masih dapat diedit sebelum dikirim ke Bea Cukai.',
  'lumen.otherDocs.ck1.genSubmit': 'Buat Draft {docType}',
  'lumen.otherDocs.ck1.genTitle': 'Buat {docType} dari {nomor}',
  'lumen.otherDocs.ck1.gKodeKantor': 'Kode Kantor (KPPBC)',
  'lumen.otherDocs.ck1.gNppbkc': 'NPPBKC',
  'lumen.otherDocs.ck1.gPeriodeAkhir': 'Periode Akhir Produksi',
  'lumen.otherDocs.ck1.gPeriodeAwal': 'Periode Awal Produksi',
  'lumen.otherDocs.ck1.gStatusPelunasan': 'Status Pelunasan Cukai',
  'lumen.otherDocs.ck1.gTujuanPengiriman': 'Tujuan Pengiriman',
  'lumen.otherDocs.ck1.itemHeader': 'BARANG #{n}',
  'lumen.otherDocs.ck1.menuCk1': 'CK-1 · Pemesanan Pita Cukai',
  'lumen.otherDocs.ck1.menuCk4': 'CK-4 · Laporan Produksi',
  'lumen.otherDocs.ck1.menuCk5': 'CK-5 · Mutasi BKC',
  'lumen.otherDocs.ck1.menuCkLabel': 'Buat dokumen dari surat jalan',
  'lumen.otherDocs.ck1.menuDelete': 'Hapus',
  'lumen.otherDocs.ck1.menuEdit': 'Edit',
  'lumen.otherDocs.ck1.pilih': 'Pilih',
  'lumen.otherDocs.ck1.rowMenu': 'Aksi lainnya',
  'lumen.otherDocs.ck1.saveCreate': 'Simpan Surat Jalan',
  'lumen.otherDocs.ck1.saveEdit': 'Simpan Perubahan',
  'lumen.otherDocs.ck1.searchPlaceholder': 'Cari nomor, pengirim, penerima, nopol...',
  'lumen.otherDocs.ck1.secBarang': 'Barang Kena Cukai',
  'lumen.otherDocs.ck1.secPenerima': 'Penerima',
  'lumen.otherDocs.ck1.secPengangkutan': 'Pengangkutan',
  'lumen.otherDocs.ck1.secPengirim': 'Pengirim (Pabrik / Gudang)',
  'lumen.otherDocs.ck1.sjCreatedMsg': 'Surat jalan dibuat.',
  'lumen.otherDocs.ck1.sjDeletedMsg': 'Surat jalan dihapus.',
  'lumen.otherDocs.ck1.sjDeletedTitle': 'Dihapus',
  'lumen.otherDocs.ck1.sjDeleteFailedTitle': 'Gagal menghapus',
  'lumen.otherDocs.ck1.sjGeneratedMsg': 'Draft {desc} berhasil dibuat dari {nomor}.',
  'lumen.otherDocs.ck1.sjGeneratedTitle': '{docType} dibuat',
  'lumen.otherDocs.ck1.sjGenerateFailedTitle': 'Gagal membuat CK',
  'lumen.otherDocs.ck1.sjIncompleteMsg': 'Nomor surat jalan, NPWP & nama pengirim, dan nama penerima wajib diisi.',
  'lumen.otherDocs.ck1.sjIncompleteTitle': 'Data belum lengkap',
  'lumen.otherDocs.ck1.sjNoItemsMsg': 'Minimal satu barang dengan uraian dan jumlah harus diisi.',
  'lumen.otherDocs.ck1.sjNoItemsTitle': 'Barang kosong',
  'lumen.otherDocs.ck1.sjPostStockFailedTitle': 'Gagal posting stok',
  'lumen.otherDocs.ck1.sjSavedTitle': 'Tersimpan',
  'lumen.otherDocs.ck1.sjSaveFailedTitle': 'Gagal menyimpan',
  'lumen.otherDocs.ck1.sjSkippedInfo': '({n} baris dilewati — belum terhubung ke item stok)',
  'lumen.otherDocs.ck1.sjStockPostedMsg': '{n} mutasi stok tercatat untuk {nomor}{skipped}.',
  'lumen.otherDocs.ck1.sjStockPostedTitle': 'Stok keluar dibukukan',
  'lumen.otherDocs.ck1.sjUpdatedMsg': 'Surat jalan diperbarui.',
  'lumen.otherDocs.ck1.statGenerated': 'CK Sudah Dibuat',
  'lumen.otherDocs.ck1.statTotal': 'Total Surat Jalan',
  'lumen.otherDocs.ck1.subtitle': 'Dokumen sumber cukai — dari surat jalan Anda dapat membuat CK-1, CK-4, dan CK-5',
  'lumen.otherDocs.ck1.tipCreateCk': 'Buat dokumen CK',
  'lumen.otherDocs.ck1.tipPostStock': 'Posting stok keluar',
  'lumen.otherDocs.ck1.title': 'Surat Jalan',
  'lumen.otherDocs.ck3.title': 'Bill of Material',
  'lumen.otherDocs.ck3.subtitle': 'Resep produksi per produk BKC — dipakai CK-4 untuk menghitung pemakaian bahan baku',
  'lumen.otherDocs.ck3.createBom': 'Buat BOM',
  'lumen.otherDocs.ck3.searchPlaceholder': 'Cari kode produk, nama, merk...',
  'lumen.otherDocs.ck3.colProduk': 'Produk',
  'lumen.otherDocs.ck3.colJenisBkc': 'Jenis BKC',
  'lumen.otherDocs.ck3.colOutput': 'Output per Batch',
  'lumen.otherDocs.ck3.colKomposisi': 'Komposisi Bahan',
  'lumen.otherDocs.ck3.colItemHasil': 'Item Stok Hasil',
  'lumen.otherDocs.ck3.colAksi': 'Aksi',
  'lumen.otherDocs.ck3.merkPrefix': 'Merk ',
  'lumen.otherDocs.ck3.notLinked': 'Belum ditautkan',
  'lumen.otherDocs.ck3.notLinkedHint': 'Tautkan item barang jadi agar posting stok produksi CK-4 bisa berjalan',
  'lumen.otherDocs.ck3.edit': 'Edit',
  'lumen.otherDocs.ck3.hapus': 'Hapus',
  'lumen.otherDocs.ck3.emptyTitle': 'Belum ada BOM',
  'lumen.otherDocs.ck3.emptyBody':
    'Definisikan resep produksi agar CK-4 bisa menghitung pemakaian bahan baku otomatis.',
  'lumen.otherDocs.ck3.createTitle': 'Buat Bill of Material',
  'lumen.otherDocs.ck3.editTitlePrefix': 'Edit BOM — ',
  'lumen.otherDocs.ck3.kodeProduk': 'Kode Produk',
  'lumen.otherDocs.ck3.namaProduk': 'Nama Produk',
  'lumen.otherDocs.ck3.merk': 'Merk',
  'lumen.otherDocs.ck3.jenisBkc': 'Jenis BKC',
  'lumen.otherDocs.ck3.jumlahOutput': 'Jumlah Output per Batch',
  'lumen.otherDocs.ck3.satuanOutput': 'Satuan Output',
  'lumen.otherDocs.ck3.outputItem': 'Item Stok Barang Jadi (hasil produksi)',
  'lumen.otherDocs.ck3.outputItemHint': 'Wajib untuk posting stok produksi dari CK-4: barang jadi masuk ke item ini',
  'lumen.otherDocs.ck3.outputItemPlaceholder': 'Pilih item barang jadi',
  'lumen.otherDocs.ck3.outputItemNone': 'Belum ada item BARANG_JADI di inventori',
  'lumen.otherDocs.ck3.clearSelection': 'Hapus pilihan',
  'lumen.otherDocs.ck3.compositionHeading': 'Komposisi Bahan Baku (per {n} {satuan})',
  'lumen.otherDocs.ck3.kodeBahan': 'Kode Bahan',
  'lumen.otherDocs.ck3.namaBahan': 'Nama Bahan',
  'lumen.otherDocs.ck3.jumlah': 'Jumlah',
  'lumen.otherDocs.ck3.satuan': 'Satuan',
  'lumen.otherDocs.ck3.itemStok': 'Item Stok',
  'lumen.otherDocs.ck3.itemStokPlaceholder': 'Link bahan baku',
  'lumen.otherDocs.ck3.deleteRowAria': 'Hapus baris bahan',
  'lumen.otherDocs.ck3.addIngredient': 'Tambah Bahan',
  'lumen.otherDocs.ck3.keterangan': 'Keterangan',
  'lumen.otherDocs.ck3.saveChanges': 'Simpan Perubahan',
  'lumen.otherDocs.ck3.saveBom': 'Simpan BOM',
  'lumen.otherDocs.ck3.deleteTitle': 'Hapus BOM',
  'lumen.otherDocs.ck3.deleteConfirmPre': 'Yakin ingin menghapus BOM ',
  'lumen.otherDocs.ck3.deleteConfirmPost': '?',
  'lumen.otherDocs.ck3.incompleteTitle': 'Data belum lengkap',
  'lumen.otherDocs.ck3.incompleteMessage': 'Kode produk, nama produk, dan jumlah output wajib diisi.',
  'lumen.otherDocs.ck3.emptyCompositionTitle': 'Komposisi kosong',
  'lumen.otherDocs.ck3.emptyCompositionMessage': 'Minimal satu bahan dengan nama dan jumlah harus diisi.',
  'lumen.otherDocs.ck3.savedTitle': 'Tersimpan',
  'lumen.otherDocs.ck3.updated': 'BOM diperbarui.',
  'lumen.otherDocs.ck3.created': 'BOM dibuat.',
  'lumen.otherDocs.ck3.saveFailed': 'Gagal menyimpan',
  'lumen.otherDocs.ck3.deletedTitle': 'Dihapus',
  'lumen.otherDocs.ck3.deleted': 'BOM dihapus.',
  'lumen.otherDocs.ck3.deleteFailed': 'Gagal menghapus',
  'lumen.otherDocs.ck3.pageTitle': 'Risk Self-Check',
  'lumen.otherDocs.ck3.pageSubtitle':
    'Indikator risiko cukai versi perusahaan — cermin dari pengawasan SPT-BKC Bea Cukai, agar temuan terlihat sebelum diperiksa',
  'lumen.otherDocs.ck3.periodeAwal': 'Periode awal',
  'lumen.otherDocs.ck3.periodeAkhir': 'Periode akhir',
  'lumen.otherDocs.ck3.until': 's/d',
  'lumen.otherDocs.ck3.recalculate': 'Hitung Ulang',
  'lumen.otherDocs.ck3.calculating': 'Menghitung indikator risiko...',
  'lumen.otherDocs.ck3.loadFailed': 'Gagal memuat self-check',
  'lumen.otherDocs.ck3.riskScore': 'Skor Risiko 0 – 1',
  'lumen.otherDocs.ck3.scoreHint': 'Skor dihitung dari indikator yang sama dengan yang dipantau Bea Cukai (SPT-BKC)',
  'lumen.otherDocs.ck3.bucketSangatRendah': 'Sangat Rendah',
  'lumen.otherDocs.ck3.bucketRendah': 'Rendah',
  'lumen.otherDocs.ck3.bucketSedang': 'Sedang',
  'lumen.otherDocs.ck3.bucketTinggi': 'Tinggi',
  'lumen.otherDocs.ck3.bucketSangatTinggi': 'Sangat Tinggi',
  'lumen.otherDocs.ck3.statusOk': 'Aman',
  'lumen.otherDocs.ck3.statusWarning': 'Perhatian',
  'lumen.otherDocs.ck3.statusCritical': 'Kritis',
  'lumen.otherDocs.ck3.weight': 'bobot {n}%',
  'lumen.otherDocs.ck3.periodSummary': 'Ringkasan Periode',
  'lumen.otherDocs.ck3.periodRange': '{awal} s/d {akhir}',
  'lumen.otherDocs.ck3.criticalIndicators': 'Indikator kritis',
  'lumen.otherDocs.ck3.needAttention': 'Perlu perhatian',
  'lumen.otherDocs.ck3.safe': 'Aman',
  'lumen.otherDocs.ck3.calculatedOn': 'Dihitung {date} dari data CK-1, CK-4, CK-5, BOM, dan kartu stok Anda.',
  'lumen.otherDocs.ck2.actCreate': 'Dibuat',
  'lumen.otherDocs.ck2.actEdit': 'Diubah',
  'lumen.otherDocs.ck2.actSubmit': 'Dikirim',
  'lumen.otherDocs.ck2.actStatusPull': 'Tarik Status',
  'lumen.otherDocs.ck2.actDelete': 'Dihapus',
  'lumen.otherDocs.ck2.allStatus': 'Semua status',
  'lumen.otherDocs.ck2.angkutFmt': '{moda} · {nopol}',
  'lumen.otherDocs.ck2.arrowFmt': '{asal} → {tujuan}',
  'lumen.otherDocs.ck2.btnHistory': 'Riwayat',
  'lumen.otherDocs.ck2.btnPull': 'Tarik Status',
  'lumen.otherDocs.ck2.btnSend': 'Kirim ke Bea Cukai',
  'lumen.otherDocs.ck2.byUser': '· oleh User #{id}',
  'lumen.otherDocs.ck2.colAksi': 'Aksi',
  'lumen.otherDocs.ck2.colDikirim': 'Dikirim',
  'lumen.otherDocs.ck2.colDokumen': 'Dokumen',
  'lumen.otherDocs.ck2.colNomorAju': 'Nomor Aju',
  'lumen.otherDocs.ck2.colNppbkc': 'NPPBKC / Kantor',
  'lumen.otherDocs.ck2.colStatus': 'Status',
  'lumen.otherDocs.ck2.copyAria': 'Salin Nomor Aju',
  'lumen.otherDocs.ck2.delAju': '({nomorAju})',
  'lumen.otherDocs.ck2.delBodyBefore': 'Yakin ingin menghapus draft',
  'lumen.otherDocs.ck2.delBodyEnd': '?',
  'lumen.otherDocs.ck2.delConfirm': 'Hapus',
  'lumen.otherDocs.ck2.delTitle': 'Hapus Dokumen',
  'lumen.otherDocs.ck2.emptyDesc': 'Buka menu Surat Jalan lalu pilih "Buat dokumen CK" pada salah satu surat jalan.',
  'lumen.otherDocs.ck2.emptyTitle': 'Belum ada dokumen cukai',
  'lumen.otherDocs.ck2.historyDesc':
    'Jejak audit setiap perubahan status dokumen (siapa, kapan, dari → ke). Tidak dapat diubah.',
  'lumen.otherDocs.ck2.historyEmpty': 'Belum ada riwayat untuk dokumen ini.',
  'lumen.otherDocs.ck2.historyTitle': 'Riwayat {docType}',
  'lumen.otherDocs.ck2.historyTitleFallback': 'Riwayat',
  'lumen.otherDocs.ck2.kirimSekarang': 'Kirim Sekarang',
  'lumen.otherDocs.ck2.lblAngkutan': 'Angkutan',
  'lumen.otherDocs.ck2.lblBerangkatTiba': 'Berangkat / Tiba',
  'lumen.otherDocs.ck2.lblCaraBayar': 'Cara Bayar',
  'lumen.otherDocs.ck2.lblDikirim': 'Dikirim',
  'lumen.otherDocs.ck2.lblIdHeader': 'ID Header',
  'lumen.otherDocs.ck2.lblJenisBkc': 'Jenis BKC',
  'lumen.otherDocs.ck2.lblKantor': 'Kode Kantor',
  'lumen.otherDocs.ck2.lblKantorAsalTujuan': 'Kantor Asal → Tujuan',
  'lumen.otherDocs.ck2.lblKodeDok': 'Kode Dokumen H2H',
  'lumen.otherDocs.ck2.lblMode': 'Mode Kirim',
  'lumen.otherDocs.ck2.lblNomorAju': 'Nomor Aju',
  'lumen.otherDocs.ck2.lblNomorPemesanan': 'Nomor Pemesanan',
  'lumen.otherDocs.ck2.lblNppbkc': 'NPPBKC',
  'lumen.otherDocs.ck2.lblNpwp': 'NPWP Pemohon',
  'lumen.otherDocs.ck2.lblPenerima': 'Penerima',
  'lumen.otherDocs.ck2.lblPengirim': 'Pengirim',
  'lumen.otherDocs.ck2.lblPengusaha': 'Pengusaha',
  'lumen.otherDocs.ck2.lblPeriode': 'Periode',
  'lumen.otherDocs.ck2.lblPerusahaan': 'Perusahaan',
  'lumen.otherDocs.ck2.lblStatusPelunasan': 'Status Pelunasan',
  'lumen.otherDocs.ck2.lblSuratJalan': 'Surat Jalan',
  'lumen.otherDocs.ck2.lblTanggal': 'Tanggal',
  'lumen.otherDocs.ck2.lblTotalKemasan': 'Total Kemasan',
  'lumen.otherDocs.ck2.lblTujuanKirim': 'Tujuan Pengiriman',
  'lumen.otherDocs.ck2.loading': 'Memuat...',
  'lumen.otherDocs.ck2.modeDraft': 'Draft di CEISA',
  'lumen.otherDocs.ck2.modeFinal': 'Final',
  'lumen.otherDocs.ck2.noAju': 'Belum ada — dibuat saat kirim',
  'lumen.otherDocs.ck2.noAjuYet': 'Dibuat saat kirim',
  'lumen.otherDocs.ck2.optAccepted': 'Diterima',
  'lumen.otherDocs.ck2.optDraftCk': 'Draft CK',
  'lumen.otherDocs.ck2.optError': 'Gagal',
  'lumen.otherDocs.ck2.optRejected': 'Ditolak',
  'lumen.otherDocs.ck2.optSubmitted': 'Terkirim',
  'lumen.otherDocs.ck2.partyFmt': '{nama} ({nppbkc})',
  'lumen.otherDocs.ck2.periodeRange': '{awal} s/d {akhir}',
  'lumen.otherDocs.ck2.postSkipped': '({n} baris dilewati — cek link BOM & item stok)',
  'lumen.otherDocs.ck2.respon': 'Respon Bea Cukai: {msg}',
  'lumen.otherDocs.ck2.searchPlaceholder': 'Cari nomor aju, NPPBKC, NPWP...',
  'lumen.otherDocs.ck2.slashFmt': '{berangkat} / {tiba}',
  'lumen.otherDocs.ck2.statDraft': 'Draft',
  'lumen.otherDocs.ck2.statProblem': 'Ditolak / Gagal',
  'lumen.otherDocs.ck2.statSubmitted': 'Terkirim',
  'lumen.otherDocs.ck2.statTotal': 'Total Dokumen',
  'lumen.otherDocs.ck2.submitBody':
    'Dokumen akan dikirim melalui gateway H2H CEISA. Nomor Aju dibuat otomatis jika belum ada.',
  'lumen.otherDocs.ck2.submitTitle': 'Kirim {docType} ke Bea Cukai',
  'lumen.otherDocs.ck2.subtitle':
    'Kelola dan kirim CK-1 (pita cukai), CK-4 (produksi), dan CK-5 (mutasi BKC) ke Bea Cukai',
  'lumen.otherDocs.ck2.switchFinal': 'Kirim final (isFinal) — tanpa ini dokumen tersimpan sebagai draft di CEISA',
  'lumen.otherDocs.ck2.tabAll': 'Semua',
  'lumen.otherDocs.ck2.tabCk1': 'CK-1 · Pita Cukai',
  'lumen.otherDocs.ck2.tabCk4': 'CK-4 · Produksi',
  'lumen.otherDocs.ck2.tabCk5': 'CK-5 · Mutasi',
  'lumen.otherDocs.ck2.thHje': 'HJE',
  'lumen.otherDocs.ck2.thIsiKemasan': 'Isi/Kemasan',
  'lumen.otherDocs.ck2.thJenisBkc': 'Jenis BKC',
  'lumen.otherDocs.ck2.thJmlKemasan': 'Jml Kemasan',
  'lumen.otherDocs.ck2.thJmlProduksi': 'Jml Produksi',
  'lumen.otherDocs.ck2.thJumlah': 'Jumlah',
  'lumen.otherDocs.ck2.thKemasan': 'Kemasan',
  'lumen.otherDocs.ck2.thKeping': 'Keping',
  'lumen.otherDocs.ck2.thLembar': 'Lembar',
  'lumen.otherDocs.ck2.thMerk': 'Merk',
  'lumen.otherDocs.ck2.thNilaiCukai': 'Nilai Cukai',
  'lumen.otherDocs.ck2.thPpn': 'PPN',
  'lumen.otherDocs.ck2.thSeriPita': 'Seri Pita',
  'lumen.otherDocs.ck2.thTarif': 'Tarif',
  'lumen.otherDocs.ck2.thTglProduksi': 'Tgl Produksi',
  'lumen.otherDocs.ck2.thUraian': 'Uraian',
  'lumen.otherDocs.ck2.tipDelete': 'Hapus draft',
  'lumen.otherDocs.ck2.tipDetail': 'Lihat detail',
  'lumen.otherDocs.ck2.tipHistory': 'Riwayat perubahan',
  'lumen.otherDocs.ck2.tipPostStock': 'Posting stok produksi (barang jadi masuk, bahan baku keluar)',
  'lumen.otherDocs.ck2.tipPullStatus': 'Tarik status dari Bea Cukai',
  'lumen.otherDocs.ck2.tipSend': 'Kirim ke Bea Cukai',
  'lumen.otherDocs.ck2.title': 'Dokumen Cukai',
  'lumen.otherDocs.ck2.toastDeleted': 'Dihapus',
  'lumen.otherDocs.ck2.toastDeletedMsg': 'Dokumen dihapus.',
  'lumen.otherDocs.ck2.toastDeleteFail': 'Gagal menghapus',
  'lumen.otherDocs.ck2.toastLoadDocFail': 'Gagal memuat dokumen',
  'lumen.otherDocs.ck2.toastLoadHistoryFail': 'Gagal memuat riwayat',
  'lumen.otherDocs.ck2.toastPosted': 'Stok produksi dibukukan',
  'lumen.otherDocs.ck2.toastPostedMsg': '{n} mutasi (barang jadi masuk + bahan baku keluar){skipped}.',
  'lumen.otherDocs.ck2.toastPostFail': 'Gagal posting stok',
  'lumen.otherDocs.ck2.toastSent': 'Terkirim',
  'lumen.otherDocs.ck2.toastSentMsg': '{docType} terkirim ke Bea Cukai. Nomor Aju: {nomorAju}',
  'lumen.otherDocs.ck2.toastStatusDone': 'Status diperbarui',
  'lumen.otherDocs.ck2.toastStatusDoneMsg': 'Status {docType} ({nomorAju}) ditarik dari Bea Cukai.',
  'lumen.otherDocs.ck2.toastStatusFail': 'Gagal menarik status',
  'lumen.otherDocs.ck2.toastSubmitFail': 'Pengiriman gagal',
  'lumen.otherDocs.ck2.totBatang': 'Total Batang',
  'lumen.otherDocs.ck2.totBayar': 'Total Bayar',
  'lumen.otherDocs.ck2.totCukai': 'Total Cukai',
  'lumen.otherDocs.ck2.totGram': 'Total Gram',
  'lumen.otherDocs.ck2.totLiter': 'Total Liter',
  'lumen.otherDocs.ck2.totNilaiCukai': 'Total Nilai Cukai',
  'lumen.otherDocs.ck2.totPpn': 'Total PPN (9,9%)',
  'lumen.otherDocs.ck4.alertStokAwalPost':
    'setelah item dibuat — bukan diinput langsung — agar kartu stok tetap konsisten.',
  'lumen.otherDocs.ck4.alertStokAwalPre': 'Stok awal dibukukan lewat tombol',
  'lumen.otherDocs.ck4.alertStokKeluar': 'Stok keluar ditolak otomatis jika melebihi saldo yang tersedia.',
  'lumen.otherDocs.ck4.allTypes': 'Semua tipe',
  'lumen.otherDocs.ck4.btnBukukan': 'Bukukan',
  'lumen.otherDocs.ck4.btnBukukanPenyesuaian': 'Bukukan Penyesuaian',
  'lumen.otherDocs.ck4.btnHapus': 'Hapus',
  'lumen.otherDocs.ck4.btnItemBaru': 'Item Baru',
  'lumen.otherDocs.ck4.btnSimpanItem': 'Simpan Item',
  'lumen.otherDocs.ck4.btnSimpanPerubahan': 'Simpan Perubahan',
  'lumen.otherDocs.ck4.btnStockOpname': 'Stock Opname',
  'lumen.otherDocs.ck4.btnStokKeluar': 'Stok Keluar',
  'lumen.otherDocs.ck4.btnStokMasuk': 'Stok Masuk',
  'lumen.otherDocs.ck4.btnStokMenipis': 'Stok Menipis',
  'lumen.otherDocs.ck4.btnTambahBaris': 'Tambah Baris',
  'lumen.otherDocs.ck4.colAksi': 'Aksi',
  'lumen.otherDocs.ck4.colArah': 'Arah',
  'lumen.otherDocs.ck4.colItem': 'Item',
  'lumen.otherDocs.ck4.colJenisMutasi': 'Jenis Mutasi',
  'lumen.otherDocs.ck4.colJumlah': 'Jumlah',
  'lumen.otherDocs.ck4.colLokasi': 'Lokasi',
  'lumen.otherDocs.ck4.colMinStok': 'Min. Stok',
  'lumen.otherDocs.ck4.colReferensi': 'Referensi',
  'lumen.otherDocs.ck4.colSaldoAkhir': 'Saldo Akhir',
  'lumen.otherDocs.ck4.colStokSaatIni': 'Stok Saat Ini',
  'lumen.otherDocs.ck4.colTanggal': 'Tanggal',
  'lumen.otherDocs.ck4.colTipe': 'Tipe',
  'lumen.otherDocs.ck4.delBodyPost': '? Riwayat mutasinya tetap tersimpan.',
  'lumen.otherDocs.ck4.delBodyPre': 'Yakin ingin menghapus item',
  'lumen.otherDocs.ck4.deleteRowAria': 'Hapus baris',
  'lumen.otherDocs.ck4.dirKeluar': 'Keluar',
  'lumen.otherDocs.ck4.dirMasuk': 'Masuk',
  'lumen.otherDocs.ck4.emptyItemsDesc': 'Buat item bahan baku / barang jadi, lalu bukukan stok masuk pertama Anda.',
  'lumen.otherDocs.ck4.emptyItemsTitle': 'Belum ada item inventori',
  'lumen.otherDocs.ck4.emptyMovementsTitle': 'Belum ada mutasi stok',
  'lumen.otherDocs.ck4.hintPerluPengadaan': 'Perlu pengadaan',
  'lumen.otherDocs.ck4.hintSemuaAman': 'Semua aman',
  'lumen.otherDocs.ck4.hintStokTercatat': 'Stok tercatat saat ini:',
  'lumen.otherDocs.ck4.itemOptionFmt': '{kode} — {nama} (stok: {qty} {satuan})',
  'lumen.otherDocs.ck4.lblBarisItem': 'Baris Item',
  'lumen.otherDocs.ck4.lblHasilHitung': 'Hasil Hitung Fisik',
  'lumen.otherDocs.ck4.lblItem': 'Item',
  'lumen.otherDocs.ck4.lblJenisMutasi': 'Jenis Mutasi',
  'lumen.otherDocs.ck4.lblJumlah': 'Jumlah',
  'lumen.otherDocs.ck4.lblKeterangan': 'Keterangan',
  'lumen.otherDocs.ck4.lblKodeItem': 'Kode Item',
  'lumen.otherDocs.ck4.lblLokasi': 'Lokasi Gudang',
  'lumen.otherDocs.ck4.lblMerk': 'Merk (barang jadi)',
  'lumen.otherDocs.ck4.lblNamaItem': 'Nama Item',
  'lumen.otherDocs.ck4.lblReferensi': 'Referensi (No. PO / dokumen)',
  'lumen.otherDocs.ck4.lblSatuan': 'Satuan',
  'lumen.otherDocs.ck4.lblStokMinimum': 'Stok Minimum (alert)',
  'lumen.otherDocs.ck4.lblTanggal': 'Tanggal',
  'lumen.otherDocs.ck4.lblTipeItem': 'Tipe Item',
  'lumen.otherDocs.ck4.merkFmt': 'Merk {merk}',
  'lumen.otherDocs.ck4.mvHasilProduksi': 'Hasil Produksi',
  'lumen.otherDocs.ck4.mvOpnameMinus': 'Opname (−)',
  'lumen.otherDocs.ck4.mvOpnamePlus': 'Opname (+)',
  'lumen.otherDocs.ck4.mvPemakaianProduksi': 'Pemakaian Produksi',
  'lumen.otherDocs.ck4.mvPenerimaan': 'Penerimaan',
  'lumen.otherDocs.ck4.mvPengiriman': 'Pengiriman',
  'lumen.otherDocs.ck4.mvReturMasuk': 'Retur Masuk',
  'lumen.otherDocs.ck4.optHasilProduksi': 'Hasil produksi',
  'lumen.otherDocs.ck4.optPemakaianProduksi': 'Pemakaian produksi',
  'lumen.otherDocs.ck4.optPenerimaan': 'Penerimaan (pembelian)',
  'lumen.otherDocs.ck4.optPengiriman': 'Pengiriman',
  'lumen.otherDocs.ck4.optReturMasuk': 'Retur masuk',
  'lumen.otherDocs.ck4.phAlasan': 'Alasan penyesuaian',
  'lumen.otherDocs.ck4.phPilihItem': 'Pilih item',
  'lumen.otherDocs.ck4.satuanPlaceholder': 'Kg / Batang / Liter / Lembar',
  'lumen.otherDocs.ck4.searchPlaceholder': 'Cari kode, nama, merk...',
  'lumen.otherDocs.ck4.statKeluarHariIni': 'Mutasi Keluar Hari Ini',
  'lumen.otherDocs.ck4.statMasukHariIni': 'Mutasi Masuk Hari Ini',
  'lumen.otherDocs.ck4.statSaldoSaatIni': 'Saldo Saat Ini',
  'lumen.otherDocs.ck4.statStokMenipis': 'Stok Menipis',
  'lumen.otherDocs.ck4.statTotalItem': 'Total Item',
  'lumen.otherDocs.ck4.statTotalKeluar': 'Total Keluar',
  'lumen.otherDocs.ck4.statTotalMasuk': 'Total Masuk',
  'lumen.otherDocs.ck4.subtitle':
    'Kartu stok bahan baku, barang jadi, dan pita cukai — mutasi tercatat otomatis dari surat jalan & CK-4',
  'lumen.otherDocs.ck4.tabItemStok': 'Item & Stok',
  'lumen.otherDocs.ck4.tabRiwayat': 'Riwayat Mutasi',
  'lumen.otherDocs.ck4.tAdjustFailed': 'Gagal penyesuaian',
  'lumen.otherDocs.ck4.tAdjustPosted': 'Penyesuaian dibukukan',
  'lumen.otherDocs.ck4.tCardFailed': 'Gagal memuat kartu stok',
  'lumen.otherDocs.ck4.tDeletedTitle': 'Dihapus',
  'lumen.otherDocs.ck4.tDeleteFailed': 'Gagal menghapus',
  'lumen.otherDocs.ck4.tEmptyLinesMsg': 'Pilih item dan isi jumlah minimal satu baris.',
  'lumen.otherDocs.ck4.tEmptyLinesTitle': 'Baris kosong',
  'lumen.otherDocs.ck4.thJenis': 'Jenis',
  'lumen.otherDocs.ck4.thKeluar': 'Keluar',
  'lumen.otherDocs.ck4.thMasuk': 'Masuk',
  'lumen.otherDocs.ck4.thSaldo': 'Saldo',
  'lumen.otherDocs.ck4.tIncompleteMsg': 'Kode, nama, dan satuan item wajib diisi.',
  'lumen.otherDocs.ck4.tIncompleteTitle': 'Data belum lengkap',
  'lumen.otherDocs.ck4.tipEdit': 'Edit',
  'lumen.otherDocs.ck4.tipHapus': 'Hapus',
  'lumen.otherDocs.ck4.tipKartuStok': 'Kartu stok',
  'lumen.otherDocs.ck4.tipLowStock': 'Di bawah stok minimum ({min})',
  'lumen.otherDocs.ck4.tipStokKeluar': 'Stok keluar',
  'lumen.otherDocs.ck4.tipStokMasuk': 'Stok masuk',
  'lumen.otherDocs.ck4.tItemCreated': 'Item dibuat.',
  'lumen.otherDocs.ck4.tItemDeleted': 'Item dihapus.',
  'lumen.otherDocs.ck4.tItemUpdated': 'Item diperbarui.',
  'lumen.otherDocs.ck4.title': 'Inventori BKC',
  'lumen.otherDocs.ck4.titleBukukanKeluar': 'Bukukan Stok Keluar',
  'lumen.otherDocs.ck4.titleBukukanMasuk': 'Bukukan Stok Masuk',
  'lumen.otherDocs.ck4.titleEditItem': 'Edit Item — {kode}',
  'lumen.otherDocs.ck4.titleHapusItem': 'Hapus Item',
  'lumen.otherDocs.ck4.titleKartuStok': 'Kartu Stok — {kode} ({nama})',
  'lumen.otherDocs.ck4.titleMemuatKartu': 'Memuat kartu stok...',
  'lumen.otherDocs.ck4.titleNewItem': 'Item Inventori Baru',
  'lumen.otherDocs.ck4.titleOpname': 'Stock Opname (Penyesuaian)',
  'lumen.otherDocs.ck4.tNewBalance': 'Saldo baru: {saldo}.',
  'lumen.otherDocs.ck4.tPickItemMsg': 'Item wajib dipilih.',
  'lumen.otherDocs.ck4.tPickItemTitle': 'Pilih item',
  'lumen.otherDocs.ck4.tPostedCount': '{n} mutasi tercatat.',
  'lumen.otherDocs.ck4.tPostedIn': 'Stok masuk dibukukan',
  'lumen.otherDocs.ck4.tPostedOut': 'Stok keluar dibukukan',
  'lumen.otherDocs.ck4.tPostFailed': 'Gagal membukukan',
  'lumen.otherDocs.ck4.tSavedTitle': 'Tersimpan',
  'lumen.otherDocs.ck4.tSaveFailed': 'Gagal menyimpan',
  'lumen.otherDocs.ck4.typeBahanBaku': 'Bahan Baku',
  'lumen.otherDocs.ck4.typeBarangJadi': 'Barang Jadi (BKC)',
  'lumen.otherDocs.ck4.typePitaCukai': 'Pita Cukai',
  'lumen.otherDocs.rp1.home': 'Home',
  'lumen.otherDocs.rp1.report': 'Report',
  'lumen.otherDocs.rp1.title20': 'BC 2.0 Report',
  'lumen.otherDocs.rp1.title30': 'BC 3.0 Report',
  'lumen.otherDocs.rp1.title57': 'BC 5.7 Report',
  'lumen.otherDocs.rp1.filterByNpwp': 'Filter by NPWP Customer',
  'lumen.otherDocs.rp1.npwpCustomer': 'NPWP Customer',
  'lumen.otherDocs.rp1.npwpCustomerPlaceholder': 'Enter NPWP Customer',
  'lumen.otherDocs.rp1.npwp': 'NPWP',
  'lumen.otherDocs.rp1.npwpPlaceholder': 'Enter NPWP',
  'lumen.otherDocs.rp1.startDate': 'Start Date',
  'lumen.otherDocs.rp1.startDatePlaceholder': 'Select start date',
  'lumen.otherDocs.rp1.endDate': 'End Date',
  'lumen.otherDocs.rp1.endDatePlaceholder': 'Select end date',
  'lumen.otherDocs.rp1.generateReport': 'Generate Report',
  'lumen.otherDocs.rp1.errorTitle': 'Error',
  'lumen.otherDocs.rp1.successTitle': 'Success',
  'lumen.otherDocs.rp1.generateFailed': 'Failed to generate report',
  'lumen.otherDocs.rp1.generated': 'Report generated successfully',
  'lumen.otherDocs.rp1.connectFailed': 'Failed to connect to server',
  'lumen.otherDocs.pz1.processIdMissing': 'Parameter processId tidak ditemukan. Buat dokumen FTZ secara manual.',
  'lumen.otherDocs.pz1.buatManual': 'Buat Manual',
  'lumen.otherDocs.pz1.errorTitle': 'Gagal membuat draft PPFTZ',
  'lumen.otherDocs.pz1.cobaLagi': 'Coba lagi',
  'lumen.otherDocs.pz1.keDaftar': 'Ke Daftar PPFTZ',
  'lumen.otherDocs.pz1.menyusunTitle': 'Menyusun draft PPFTZ dari hasil ekstraksi…',
  'lumen.otherDocs.pz1.menyusunBody': 'Data Invoice / Packing List / B/L sedang dipetakan ke dokumen FTZ 511',
  'lumen.otherDocs.pz1.createFailed': 'Gagal membuat draft PPFTZ dari hasil ekstraksi',
  'lumen.otherDocs.pz1.terhapus': 'Terhapus',
  'lumen.otherDocs.pz1.draftDihapus': 'Draft PPFTZ berhasil dihapus',
  'lumen.otherDocs.pz1.gagalMenghapus': 'Gagal menghapus',
  'lumen.otherDocs.pz1.gagalMenghapusDraft': 'Gagal menghapus draft PPFTZ',
  'lumen.otherDocs.pz1.colNomorAju': 'Nomor AJU',
  'lumen.otherDocs.pz1.colFamily': 'Family',
  'lumen.otherDocs.pz1.colKodeDokumen': 'Kode Dokumen',
  'lumen.otherDocs.pz1.colArah': 'Arah',
  'lumen.otherDocs.pz1.colStatus': 'Status',
  'lumen.otherDocs.pz1.colKodeKantor': 'Kode Kantor',
  'lumen.otherDocs.pz1.colDiperbarui': 'Diperbarui',
  'lumen.otherDocs.pz1.colAksi': 'Aksi',
  'lumen.otherDocs.pz1.buka': 'Buka',
  'lumen.otherDocs.pz1.hapusDraft': 'Hapus draft',
  'lumen.otherDocs.pz1.hapus': 'Hapus',
  'lumen.otherDocs.pz1.title': 'PPFTZ / Dokumen FTZ',
  'lumen.otherDocs.pz1.subtitle': 'Draft dan pengiriman Host-to-Host dokumen CEISA FTZ (511–531)',
  'lumen.otherDocs.pz1.buatDokumen': 'Buat Dokumen FTZ',
  'lumen.otherDocs.pz1.phFamily': 'Family',
  'lumen.otherDocs.pz1.phKodeDokumen': 'Kode Dokumen',
  'lumen.otherDocs.pz1.phStatus': 'Status',
  'lumen.otherDocs.pz1.loadFailed': 'Gagal memuat daftar dokumen PPFTZ',
  'lumen.otherDocs.pz1.belumAda': 'Belum ada dokumen PPFTZ',
  'lumen.otherDocs.pz1.confirmHapus': 'Hapus draft PPFTZ {nomor}?',
  'lumen.otherDocs.pz2.tidakAdaPilihan': 'Tidak ada pilihan',
  'lumen.otherDocs.pz2.nomorAjuInvalid':
    'Nomor AJU harus kosong atau tepat {length} digit angka (saat ini {count} karakter)',
  'lumen.otherDocs.pz2.kodeKantorWajib': 'Kode Kantor wajib diisi',
  'lumen.otherDocs.pz2.validasiGagal': 'Validasi gagal',
  'lumen.otherDocs.pz2.periksaHeader': 'Periksa kembali field header yang ditandai',
  'lumen.otherDocs.pz2.tersimpan': 'Tersimpan',
  'lumen.otherDocs.pz2.headerTersimpan': 'Header berhasil disimpan',
  'lumen.otherDocs.pz2.header': 'Header',
  'lumen.otherDocs.pz2.simpanHeader': 'Simpan Header',
  'lumen.otherDocs.pz2.belumDisimpan': 'Ada perubahan header yang belum disimpan.',
  'lumen.otherDocs.pz2.pilihKantorDulu': 'Pilih atau isi kode kantor terlebih dahulu agar saran nomor AJU akurat',
  'lumen.otherDocs.pz2.gagalSarankan':
    'Gagal menyarankan nomor AJU. Pastikan akun CEISA tenant sudah tertaut, atau isi nomor AJU manual.',
  'lumen.otherDocs.pz2.familyTidakCocok': 'Family dan kode dokumen tidak cocok',
  'lumen.otherDocs.pz2.familyTidakCocokDesc':
    'Family {family} tidak sesuai dengan kode dokumen {kodeDokumen}. Kembali ke langkah Dokumen dan pilih ulang.',
  'lumen.otherDocs.pz2.ajuTidakValid': 'Nomor AJU tidak valid',
  'lumen.otherDocs.pz2.ajuTidakValidDesc':
    'Nomor AJU harus kosong (server akan menyarankan) atau tepat {length} digit angka (saat ini {count} karakter)',
  'lumen.otherDocs.pz2.draftDibuat': 'Draft dibuat',
  'lumen.otherDocs.pz2.draftDibuatDesc': 'Draft PPFTZ {nomorAju} berhasil dibuat',
  'lumen.otherDocs.pz2.gagalMembuatDraft': 'Gagal membuat draft',
  'lumen.otherDocs.pz2.gagalMembuatDraftFallback': 'Gagal membuat draft PPFTZ',
  'lumen.otherDocs.pz2.gagalMemuatKatalog': 'Gagal memuat katalog dokumen PPFTZ',
  'lumen.otherDocs.pz2.cobaLagi': 'Coba lagi',
  'lumen.otherDocs.pz2.stepFamily': 'Family',
  'lumen.otherDocs.pz2.stepFamilyHint': 'Jenis kawasan',
  'lumen.otherDocs.pz2.stepDokumen': 'Dokumen',
  'lumen.otherDocs.pz2.stepDokumenHint': 'Kode dokumen',
  'lumen.otherDocs.pz2.stepKantor': 'Kantor',
  'lumen.otherDocs.pz2.stepKantorHint': 'Kode kantor pabean',
  'lumen.otherDocs.pz2.stepNomorAju': 'Nomor AJU',
  'lumen.otherDocs.pz2.stepNomorAjuHint': 'Konfirmasi & buat',
  'lumen.otherDocs.pz2.pilihJenisKawasan': 'Pilih jenis kawasan',
  'lumen.otherDocs.pz2.familyMenentukan': 'Setiap family menentukan jenis dokumen yang tersedia.',
  'lumen.otherDocs.pz2.countDokumen': '{count} Dokumen',
  'lumen.otherDocs.pz2.pilihKodeDokumen': 'Pilih kode dokumen',
  'lumen.otherDocs.pz2.kodeMenentukan': 'Kode menentukan arah dan jenis kegiatan pabean.',
  'lumen.otherDocs.pz2.tidakAdaDokumen': 'Tidak ada dokumen untuk family ini.',
  'lumen.otherDocs.pz2.pilihKantorPabean': 'Pilih kantor pabean',
  'lumen.otherDocs.pz2.kantorPemrosesan': 'Kantor pemrosesan dokumen sesuai lokasi kegiatan.',
  'lumen.otherDocs.pz2.daftarKantorKosong':
    'Daftar kantor referensi tidak tersedia — masukkan kode kantor secara manual di bawah.',
  'lumen.otherDocs.pz2.kodeKantorLain': 'Kode kantor lain',
  'lumen.otherDocs.pz2.masukkanManual': 'Masukkan kode kantor pabean secara manual',
  'lumen.otherDocs.pz2.kodeKantor': 'Kode Kantor',
  'lumen.otherDocs.pz2.kodeKantorPlaceholder': 'mis. 020400',
  'lumen.otherDocs.pz2.ringkasan': 'Ringkasan',
  'lumen.otherDocs.pz2.ajuHint':
    '{length} digit dari server (posisi 7–12 = kode perusahaan CEISA). Boleh diubah atau dikosongkan — backend akan menyarankan saat submit jika kosong.',
  'lumen.otherDocs.pz2.saranGagal': 'Saran nomor AJU gagal',
  'lumen.otherDocs.pz2.ajuDiperbarui': 'Nomor AJU diperbarui',
  'lumen.otherDocs.pz2.saranDimuat': 'Saran dari server berhasil dimuat',
  'lumen.otherDocs.pz2.cobaSaranLagi': 'Coba saran lagi',
  'lumen.otherDocs.pz2.ajuEksternalPlaceholder': 'Isi nomor AJU eksternal, atau biarkan kosong',
  'lumen.otherDocs.pz2.draftDapatDiedit': 'Draft dapat diedit sebelum dikirim ke sistem CEISA.',
  'lumen.otherDocs.pz2.buatDokumenFtz': 'Buat Dokumen FTZ',
  'lumen.otherDocs.pz2.ikutiLangkah': 'Ikuti 4 langkah untuk membuat dokumen pabean kawasan bebas.',
  'lumen.otherDocs.pz2.kembaliKeDaftar': 'Kembali ke daftar',
  'lumen.otherDocs.pz2.langkahDari': 'Langkah {step} dari 4',
  'lumen.otherDocs.pz2.kembali': 'Kembali',
  'lumen.otherDocs.pz2.buatDraft': 'Buat Draft',
  'lumen.otherDocs.pz2.sarankanAju': 'Sarankan AJU',
  'lumen.otherDocs.pz2.lanjut': 'Lanjut',
  'lumen.otherDocs.pz3.gagalMemuatPayload': 'Gagal memuat payload CEISA',
  'lumen.otherDocs.pz3.previewPayloadCeisa': 'Preview Payload CEISA',
  'lumen.otherDocs.pz3.memuat': 'Memuat...',
  'lumen.otherDocs.pz3.gagalMemuatRiwayat': 'Gagal memuat riwayat status',
  'lumen.otherDocs.pz3.riwayatStatus': 'Riwayat Status',
  'lumen.otherDocs.pz3.belumAdaRiwayat': 'Belum ada riwayat',
  'lumen.otherDocs.pz3.waktu': 'Waktu',
  'lumen.otherDocs.pz3.aksi': 'Aksi',
  'lumen.otherDocs.pz3.status': 'Status',
  'lumen.otherDocs.pz3.keterangan': 'Keterangan',
  'lumen.otherDocs.pz3.selengkapnya': 'Selengkapnya',
  'lumen.otherDocs.pz3.sembunyikan': 'Sembunyikan',
  'lumen.otherDocs.pz3.wajibDiisi': '{label} wajib diisi',
  'lumen.otherDocs.pz3.harusArrayJson': '{label} harus berupa array JSON yang valid',
  'lumen.otherDocs.pz3.tersimpan': 'Tersimpan',
  'lumen.otherDocs.pz3.dataBerhasilDisimpan': 'Data {label} berhasil disimpan',
  'lumen.otherDocs.pz3.tambahLabel': 'Tambah {label}',
  'lumen.otherDocs.pz3.simpanLabel': 'Simpan {label}',
  'lumen.otherDocs.pz3.ubahLabel': 'Ubah {label}',
  'lumen.otherDocs.pz3.adaPerubahan': 'Ada perubahan {label} yang belum disimpan.',
  'lumen.otherDocs.pz3.belumAdaData': 'Belum ada data {label}',
  'lumen.otherDocs.pz3.tambah': 'Tambah',
  'lumen.otherDocs.pz3.ubahBaris': 'Ubah baris',
  'lumen.otherDocs.pz3.hapusBaris': 'Hapus baris',
  'lumen.otherDocs.pz3.tidakAdaYangDiisi': 'Tidak ada yang diisi',
  'lumen.otherDocs.pz3.semuaBarangSudahTarif': 'Semua barang sudah memiliki tarif BM',
  'lumen.otherDocs.pz3.tarifTidakDitemukan': 'Tarif tidak ditemukan',
  'lumen.otherDocs.pz3.tarifHsTidakDitemukan': 'Tarif HS tidak ditemukan untuk barang seri {seri}',
  'lumen.otherDocs.pz3.tarifBmTerisi': 'Tarif BM terisi',
  'lumen.otherDocs.pz3.barangDiisiTarifBm': '{filled} barang diisi tarif BM dari master HS',
  'lumen.otherDocs.pz3.seriTidakDitemukan': '; seri {seri} tidak ditemukan',
  'lumen.otherDocs.pz3.gagalMengisiTarif': 'Gagal mengisi tarif',
  'lumen.otherDocs.pz3.gagalMengambilTarif': 'Gagal mengambil tarif dari master HS',
  'lumen.otherDocs.pz3.nilaiPabean': 'Nilai Pabean',
  'lumen.otherDocs.pz3.totalBm': 'Total BM',
  'lumen.otherDocs.pz3.nilaiImpor': 'Nilai Impor',
  'lumen.otherDocs.pz3.estimasiPpn': 'Estimasi PPN {rate}%',
  'lumen.otherDocs.pz3.estimasiPph': 'Estimasi PPh {rate}%',
  'lumen.otherDocs.pz3.pungutan': 'Pungutan',
  'lumen.otherDocs.pz3.isiTarifBm': 'Isi Tarif BM dari Master HS',
  'lumen.otherDocs.pz3.dokumen513Wajib':
    'Dokumen 513 wajib mendeklarasikan tarif BM per barang. Barang seri {seri} belum memiliki tarif.',
  'lumen.otherDocs.pz3.seri': 'Seri',
  'lumen.otherDocs.pz3.posTarif': 'Pos Tarif',
  'lumen.otherDocs.pz3.uraian': 'Uraian',
  'lumen.otherDocs.pz3.bm': 'BM',
  'lumen.otherDocs.pz3.statusTarif': 'Status Tarif',
  'lumen.otherDocs.pz3.belumAdaBarang': 'Belum ada barang',
  'lumen.otherDocs.pz3.ada': 'Ada',
  'lumen.otherDocs.pz3.belum': 'Belum',
  'lumen.otherDocs.pz3.ppnPphEstimasi':
    'PPN dan PPh bersifat estimasi ({ppn}% dan {pph}% importir ber-API) dan ditagihkan melalui billing setelah dokumen diterima CEISA. Nilai bayar BM dapat disesuaikan per barang melalui tab Barang.',
  'lumen.otherDocs.pz3.tarifBmBarangTarif': 'Tarif BM (barangTarif)',
  'lumen.otherDocs.pz3.nilaiPabeanLabel': 'Nilai pabean: {nilai}',
  'lumen.otherDocs.pz3.belumAdaTarif':
    'Belum ada tarif. Untuk dokumen 513 (keluar ke TLDDP), setiap barang wajib memiliki tarif BM.',
  'lumen.otherDocs.pz3.jenisTarif': 'Jenis Tarif',
  'lumen.otherDocs.pz3.tarif': 'Tarif',
  'lumen.otherDocs.pz3.tarifFasilitas': 'Tarif Fasilitas',
  'lumen.otherDocs.pz3.kodeFasilitas': 'Kode Fasilitas',
  'lumen.otherDocs.pz3.jumlahSatuan': 'Jumlah Satuan',
  'lumen.otherDocs.pz3.satuan': 'Satuan',
  'lumen.otherDocs.pz3.nilaiBayarBm': 'Nilai Bayar (BM)',
  'lumen.otherDocs.pz3.hapusTarif': 'Hapus tarif',
  'lumen.otherDocs.pz3.gagalMenyimpanHeader': 'Gagal menyimpan header',
  'lumen.otherDocs.pz3.gagalMenyimpanHeaderPpftz': 'Gagal menyimpan header PPFTZ',
  'lumen.otherDocs.pz3.gagalMenyimpanSection': 'Gagal menyimpan {section}',
  'lumen.otherDocs.pz3.gagalMenyimpanDataSection': 'Gagal menyimpan data {section}',
  'lumen.otherDocs.pz3.cekCeisaStatus': 'Cek CEISA: {status}',
  'lumen.otherDocs.pz3.lihatPanelPesan': 'Lihat panel pesan untuk detail',
  'lumen.otherDocs.pz3.gagalCekDokumen': 'Gagal melakukan cek dokumen ke CEISA',
  'lumen.otherDocs.pz3.skemaCeisaTidakValid': 'Skema CEISA tidak valid',
  'lumen.otherDocs.pz3.cekCeisaGagal': 'Cek CEISA gagal',
  'lumen.otherDocs.pz3.kirimCeisaStatus': 'Kirim CEISA: {status}',
  'lumen.otherDocs.pz3.idHeaderValue': 'idHeader: {idHeader}',
  'lumen.otherDocs.pz3.dokumenDikirim': 'Dokumen dikirim ke CEISA',
  'lumen.otherDocs.pz3.draftTerkirim': 'Draft CEISA terkirim — formulir draft dapat dicetak setelah status diperbarui',
  'lumen.otherDocs.pz3.kirimCeisaGagal': 'Kirim CEISA gagal',
  'lumen.otherDocs.pz3.gagalMengirimDokumen': 'Gagal mengirim dokumen ke CEISA',
  'lumen.otherDocs.pz3.gagalMemuatFormulir': 'Gagal memuat formulir {type}',
  'lumen.otherDocs.pz3.formulirBelumTersedia': 'Formulir belum tersedia di CEISA untuk dokumen ini',
  'lumen.otherDocs.pz3.statusCeisa': 'Status CEISA',
  'lumen.otherDocs.pz3.nomorAjuStatus': '{nomorAju}: {status}',
  'lumen.otherDocs.pz3.idHeaderParen': '(idHeader {idHeader})',
  'lumen.otherDocs.pz3.gagalMemuatStatus': 'Gagal memuat status',
  'lumen.otherDocs.pz3.gagalMemuatStatusCeisa': 'Gagal memuat status dari CEISA',
  'lumen.otherDocs.pz3.gagalMemuatDokumen': 'Gagal memuat dokumen PPFTZ',
  'lumen.otherDocs.pz3.cobaLagi': 'Coba lagi',
  'lumen.otherDocs.pz3.kembaliKeDaftar': 'Kembali ke daftar',
  'lumen.otherDocs.pz3.draftId': 'Draft #{id}',
  'lumen.otherDocs.pz3.dokumenFtz': 'Dokumen FTZ',
  'lumen.otherDocs.pz3.idHeaderBullet': '• idHeader: {idHeader}',
  'lumen.otherDocs.pz3.cekCeisa': 'Cek CEISA',
  'lumen.otherDocs.pz3.kirim': 'Kirim',
  'lumen.otherDocs.pz3.refreshStatus': 'Refresh Status',
  'lumen.otherDocs.pz3.cetakDraft': 'Cetak Draft',
  'lumen.otherDocs.pz3.cetakFormulir': 'Cetak Formulir',
  'lumen.otherDocs.pz3.previewPayload': 'Preview Payload',
  'lumen.otherDocs.pz3.history': 'History',
  'lumen.otherDocs.pz3.dokumenBerstatus': 'Dokumen berstatus {status} dan tidak dapat diubah lagi.',
  'lumen.otherDocs.pz3.pesanCeisaTerakhir': 'Pesan CEISA terakhir',
  'lumen.otherDocs.pz3.header': 'Header',
  'lumen.otherDocs.pz3.perubahanBelumDisimpan': 'Perubahan belum disimpan',
  'lumen.otherDocs.pz3.adaPerubahanTab':
    'Ada perubahan yang belum disimpan pada tab ini. Pindah tab akan membuang perubahan tersebut. Lanjutkan?',
  'lumen.otherDocs.pz3.lanjutkan': 'Lanjutkan',
  'lumen.otherDocs.pz3.kirimKeCeisa': 'Kirim ke CEISA',
  'lumen.otherDocs.pz3.cekTerakhirBerstatus':
    'Cek terakhir berstatus {status}. Perbaiki dokumen terlebih dahulu, atau kirim jika Anda yakin.',
  'lumen.otherDocs.pz3.dokumen513WajibKirim':
    'Dokumen 513 wajib mendeklarasikan tarif BM per barang. Barang seri {seri} belum memiliki tarif — lengkapi melalui tab Pungutan atau Barang sebelum mengirim.',
  'lumen.otherDocs.pz3.pengajuanFinal': 'Pengajuan final',
  'lumen.otherDocs.pz3.nonaktifkanDraft': 'Nonaktifkan untuk mengirim sebagai draft CEISA terlebih dahulu',
  'lumen.otherDocs.pz3.revisiAtasAju': 'Revisi atas aju yang sudah dikirim',
  'lumen.otherDocs.pz3.centangHanyaKoreksi': 'Centang hanya untuk koreksi dokumen yang telah diajukan sebelumnya',
  'lumen.otherDocs.pz3.setiapPengiriman':
    'Setiap pengiriman memakai 1 kredit CEISA submission. Kredit dikembalikan otomatis jika CEISA menolak.',
  'lumen.otherDocs.pz3.kirimSekarang': 'Kirim Sekarang',
  'lumen.otherDocs.pz3.kirimFinal': 'Kirim Final',
  'lumen.otherDocs.pz3.kirimDraft': 'Kirim Draft',
  'lumen.otherDocs.ck5.title': 'Panduan Modul Cukai',
  'lumen.otherDocs.ck5.subtitle':
    'Dari surat jalan sampai lapor Bea Cukai — pahami tiap menu dalam beberapa menit. Baru pertama kali? Ikuti dari atas ke bawah.',
  'lumen.otherDocs.ck5.learnProgress': 'Kemajuan belajar',
  'lumen.otherDocs.ck5.railCount': '{current}/{total} bagian',
  'lumen.otherDocs.ck5.secAlur': 'Alur lengkap',
  'lumen.otherDocs.ck5.secInventori': 'Inventori',
  'lumen.otherDocs.ck5.secBom': 'Bill of Material',
  'lumen.otherDocs.ck5.secSuratJalan': 'Surat Jalan',
  'lumen.otherDocs.ck5.secDokumen': 'Dokumen CK',
  'lumen.otherDocs.ck5.secStok': 'Posting Stok',
  'lumen.otherDocs.ck5.secRisk': 'Risk Self-Check',
  'lumen.otherDocs.ck5.secMulai': 'Mulai dari sini',
  'lumen.otherDocs.ck5.flowInventori': 'Inventori',
  'lumen.otherDocs.ck5.flowBom': 'BOM',
  'lumen.otherDocs.ck5.flowStokMasuk': 'Stok Masuk',
  'lumen.otherDocs.ck5.flowSuratJalan': 'Surat Jalan',
  'lumen.otherDocs.ck5.flowDokumenCk': 'Dokumen CK',
  'lumen.otherDocs.ck5.flowSubmit': 'Submit',
  'lumen.otherDocs.ck5.flowPostingStok': 'Posting Stok',
  'lumen.otherDocs.ck5.flowRiskCheck': 'Risk Check',
  'lumen.otherDocs.ck5.flowTitle': 'Alur lengkap: satu perjalanan, delapan langkah',
  'lumen.otherDocs.ck5.scrollHint': 'Gulir untuk memulai',
  'lumen.otherDocs.ck5.menuLabel': 'Menu {n}',
  'lumen.otherDocs.ck5.whenToUse': 'Kapan dipakai',
  'lumen.otherDocs.ck5.stepsHeading': 'Langkah-langkah',
  'lumen.otherDocs.ck5.tipLabel': 'Tip:',
  'lumen.otherDocs.ck5.openMenu': 'Buka {name}',
  'lumen.otherDocs.ck5.s1Title': 'Daftarkan item Inventori',
  'lumen.otherDocs.ck5.s1Desc':
    'Buat item bahan baku, barang jadi (BKC), dan pita cukai. Ini jadi kartu stok yang dibaca semua fitur otomatis.',
  'lumen.otherDocs.ck5.s2Title': 'Susun BOM (resep produksi)',
  'lumen.otherDocs.ck5.s2Desc':
    'Buat resep per produk: barang jadi butuh bahan baku apa dan berapa. Tautkan output & komponen ke inventori.',
  'lumen.otherDocs.ck5.s3Title': 'Catat stok masuk bahan baku',
  'lumen.otherDocs.ck5.s3Desc':
    'Rekam penerimaan bahan baku sebagai stok masuk agar gudang punya saldo awal yang benar.',
  'lumen.otherDocs.ck5.s4Title': 'Buat Surat Jalan',
  'lumen.otherDocs.ck5.s4Desc':
    'Isi pengirim, penerima, pengangkutan, dan daftar barang. Inilah dokumen sumber semua dokumen CK.',
  'lumen.otherDocs.ck5.s5Title': 'Generate dokumen CK',
  'lumen.otherDocs.ck5.s5Desc':
    'Dari surat jalan, terbitkan CK-5 (mutasi), CK-4 (produksi), atau CK-1 (pemesanan pita).',
  'lumen.otherDocs.ck5.s6Title': 'Edit lalu Submit ke Bea Cukai',
  'lumen.otherDocs.ck5.s6Desc': 'Periksa dan lengkapi dokumen, kirim host-to-host, pantau status hingga ACCEPTED.',
  'lumen.otherDocs.ck5.s7Title': 'Posting stok',
  'lumen.otherDocs.ck5.s7Desc':
    'Surat jalan final mengeluarkan barang jadi; CK-4 menambah produksi & memotong bahan baku sesuai BOM.',
  'lumen.otherDocs.ck5.s8Title': 'Pantau Risk Self-Check',
  'lumen.otherDocs.ck5.s8Desc': 'Telaah 7 indikator dan perbaiki red flag lebih dulu sebelum Bea Cukai menemukannya.',
  'lumen.otherDocs.ck5.mInvTitle': 'Inventori — kartu stok',
  'lumen.otherDocs.ck5.mInvApa':
    'Kumpulan kartu stok Anda dalam tiga tipe: bahan baku (kuning), barang jadi/BKC (hijau), dan pita cukai (ungu). Di sini Anda mencatat stok masuk, stok keluar, dan stock opname — plus peringatan saat stok menipis.',
  'lumen.otherDocs.ck5.mInvKapan':
    'Paling awal, sebelum BOM dan surat jalan. Catat stok masuk tiap menerima bahan baku/pita, dan opname saat menyesuaikan saldo fisik.',
  'lumen.otherDocs.ck5.mInvL1': 'Klik "Tambah Item", pilih tipe (BAHAN_BAKU / BARANG_JADI / PITA_CUKAI).',
  'lumen.otherDocs.ck5.mInvL2': 'Isi nama, satuan, dan batas stok minimum untuk memicu peringatan.',
  'lumen.otherDocs.ck5.mInvL3': 'Catat "Stok Masuk" saat menerima bahan baku atau pita cukai.',
  'lumen.otherDocs.ck5.mInvL4': 'Biarkan surat jalan & CK-4 memposting mutasi otomatis.',
  'lumen.otherDocs.ck5.mInvL5': 'Lakukan "Stock Opname" bila saldo sistem beda dari hitungan fisik.',
  'lumen.otherDocs.ck5.mInvTip':
    'Setiap item yang tidak tertaut ke dokumen memutus rekonsiliasi otomatis. Kartu stok yang sinkron adalah fondasi skor risiko yang sehat.',
  'lumen.otherDocs.ck5.mBomTitle': 'Bill of Material — resep produksi',
  'lumen.otherDocs.ck5.mBomApa':
    'Resep produksi Anda: untuk tiap produk/merk, BOM mendaftar bahan baku apa saja dan berapa takarannya. Karena tertaut ke inventori, CK-4 dapat "meledakkan" resep ini untuk otomatis mengurangi stok bahan baku sesuai jumlah produksi.',
  'lumen.otherDocs.ck5.mBomKapan':
    'Sekali di awal untuk tiap produk, diperbarui bila komposisi berubah. Harus ada sebelum CK-4 bisa menghitung pemakaian bahan otomatis.',
  'lumen.otherDocs.ck5.mBomL1': 'Klik "Buat BOM", pilih produk/merk barang jadi sebagai output.',
  'lumen.otherDocs.ck5.mBomL2': 'Tautkan output ke item inventori bertipe BARANG_JADI.',
  'lumen.otherDocs.ck5.mBomL3': 'Tambahkan komponen bahan baku + jumlah pemakaian per unit.',
  'lumen.otherDocs.ck5.mBomL4': 'Tautkan setiap komponen ke item inventori BAHAN_BAKU.',
  'lumen.otherDocs.ck5.mBomL5': 'Simpan — kini CK-4 memakainya untuk konsumsi bahan otomatis.',
  'lumen.otherDocs.ck5.mBomTip':
    'Akurasi takaran BOM penting: bila meleset, indikator "Pemakaian Bahan vs BOM" di Risk Self-Check menunjukkan varian besar yang terbaca sebagai kebocoran bahan.',
  'lumen.otherDocs.ck5.mSjTitle': 'Surat Jalan — dokumen sumber',
  'lumen.otherDocs.ck5.mSjApa':
    'Dokumen pengantar pengiriman internal Anda, sekaligus TITIK AWAL seluruh modul. Catat pengirim, penerima, pengangkutan, dan daftar barang kena cukai. Datanya nanti mengalir otomatis ke dokumen CK.',
  'lumen.otherDocs.ck5.mSjKapan':
    'Setiap kali ada barang yang akan bergerak atau dilaporkan — selalu langkah pertama dalam satu transaksi.',
  'lumen.otherDocs.ck5.mSjL1': 'Klik "Buat Surat Jalan", isi pengirim & penerima beserta NPPBKC.',
  'lumen.otherDocs.ck5.mSjL2': 'Lengkapi pengangkutan: moda transportasi dan nomor polisi.',
  'lumen.otherDocs.ck5.mSjL3': 'Tambahkan barang: jenis BKC (EA/MMEA/HT), merk, kemasan, jumlah, satuan.',
  'lumen.otherDocs.ck5.mSjL4': 'Tautkan tiap barang ke item inventori agar posting stok otomatis.',
  'lumen.otherDocs.ck5.mSjL5': 'Simpan sebagai DRAFT atau tandai FINAL, lalu klik "Generate" untuk membuat CK.',
  'lumen.otherDocs.ck5.mSjTip':
    'Tautkan tiap baris barang ke item inventori sejak awal. Baris tak tertaut menurunkan skor "Kesiapan Data" dan membuat posting stok tidak otomatis.',
  'lumen.otherDocs.ck5.mDokTitle': 'Dokumen CK — CK-1, CK-4, CK-5',
  'lumen.otherDocs.ck5.mDokApa':
    'Mengelola tiga dokumen cukai resmi yang diterbitkan dari surat jalan, dikirim ke Bea Cukai host-to-host, lalu dipantau statusnya. CK-1 = pemesanan pita cukai (ungu). CK-4 = laporan produksi selesai (oranye). CK-5 = pemberitahuan mutasi BKC (sian).',
  'lumen.otherDocs.ck5.mDokKapan':
    'CK-5 saat memindahkan BKC antar-lokasi. CK-4 saat melaporkan hasil produksi. CK-1 saat memesan pita cukai.',
  'lumen.otherDocs.ck5.mDokL1': 'Dari surat jalan, pilih "Generate" dan tentukan jenis (CK-1/CK-4/CK-5).',
  'lumen.otherDocs.ck5.mDokL2': 'Data pengirim, penerima, dan barang tersalin otomatis — periksa kembali.',
  'lumen.otherDocs.ck5.mDokL3': 'Lengkapi kolom khusus: HJE & tarif (CK-1), status pelunasan (CK-5), dsb.',
  'lumen.otherDocs.ck5.mDokL4': 'Simpan sebagai GENERATED, lalu "Submit ke Bea Cukai".',
  'lumen.otherDocs.ck5.mDokL5': 'Pantau status: SUBMITTED → ACCEPTED atau REJECTED.',
  'lumen.otherDocs.ck5.mDokL6': 'Jika REJECTED, perbaiki sesuai catatan penolakan lalu submit ulang.',
  'lumen.otherDocs.ck5.mDokTip':
    'Sebelum submit, pastikan HJE & tarif cukai benar. Untuk CK-1: satu lembar berisi keping sesuai seri (I:120, II:56, III:150), dan PPN pita HT 9,9%.',
  'lumen.otherDocs.ck5.mRiskTitle': 'Risk Self-Check — dashboard kepatuhan',
  'lumen.otherDocs.ck5.mRiskApa':
    'Dashboard yang meniru indikator risiko SPT-BKC milik DJBC. Sistem menghitung skor risiko 0–1 dari data Anda sendiri, dikelompokkan ke 5 kategori, dijabarkan lewat 7 indikator yang bisa dijelaskan. Tujuannya: Anda melihat red flag lebih dulu, sebelum Bea Cukai melihatnya.',
  'lumen.otherDocs.ck5.mRiskKapan':
    'Rutin — terutama menjelang pelaporan periodik dan setelah banyak transaksi produksi/mutasi/pemesanan pita.',
  'lumen.otherDocs.ck5.mRiskL1': 'Buka Risk Self-Check dan pilih periode evaluasi.',
  'lumen.otherDocs.ck5.mRiskL2': 'Perhatikan skor risiko total dan kategorinya.',
  'lumen.otherDocs.ck5.mRiskL3': 'Telaah tiap indikator, buka rincian baris WARNING/CRITICAL.',
  'lumen.otherDocs.ck5.mRiskL4': 'Baca rekomendasi pada indikator bermasalah.',
  'lumen.otherDocs.ck5.mRiskL5': 'Perbaiki akar masalah di menu terkait, lalu muat ulang.',
  'lumen.otherDocs.ck5.mRiskTip':
    'Skor tinggi bukan vonis, tapi peringatan dini. Prioritaskan indikator CRITICAL, mulai dari "Kesiapan Data": banyak masalah lain membaik begitu semua tautan inventori lengkap.',
  'lumen.otherDocs.ck5.chipBahanBaku': 'Bahan Baku',
  'lumen.otherDocs.ck5.chipBarangJadi': 'Barang Jadi',
  'lumen.otherDocs.ck5.chipPitaCukai': 'Pita Cukai',
  'lumen.otherDocs.ck5.invName1': 'Tembakau Rajang',
  'lumen.otherDocs.ck5.invQty1': '450 kg',
  'lumen.otherDocs.ck5.invName2': 'SKM Merk A',
  'lumen.otherDocs.ck5.invQty2': '12.000 btg',
  'lumen.otherDocs.ck5.invName3': 'Pita Seri II',
  'lumen.otherDocs.ck5.invQty3': '80 lbr',
  'lumen.otherDocs.ck5.lowStockWarn': '⚠ 1 item di bawah stok minimum',
  'lumen.otherDocs.ck5.bomMockTitle': 'SKM Merk A · per 1.000 btg',
  'lumen.otherDocs.ck5.bomIng1': 'Tembakau rajang',
  'lumen.otherDocs.ck5.bomQty1': '0,9 kg',
  'lumen.otherDocs.ck5.bomIng2': 'Cengkeh',
  'lumen.otherDocs.ck5.bomQty2': '0,3 kg',
  'lumen.otherDocs.ck5.bomIng3': 'Kertas sigaret',
  'lumen.otherDocs.ck5.bomQty3': '1.000 lbr',
  'lumen.otherDocs.ck5.bomMockNote': 'CK-4 memotong stok bahan otomatis',
  'lumen.otherDocs.ck5.docDesc1': 'Pemesanan Pita Cukai',
  'lumen.otherDocs.ck5.docDesc2': 'Laporan Produksi',
  'lumen.otherDocs.ck5.docDesc3': 'Mutasi BKC',
  'lumen.otherDocs.ck5.statusCycle': 'Status siklus:',
  'lumen.otherDocs.ck5.statusDraft': 'Draft CK',
  'lumen.otherDocs.ck5.statusSent': 'Terkirim',
  'lumen.otherDocs.ck5.statusAccepted': 'Diterima',
  'lumen.otherDocs.ck5.fanTitle': '1 Surat Jalan',
  'lumen.otherDocs.ck5.fanSub': 'SJ/2026/00123 · 3 barang',
  'lumen.otherDocs.ck5.fanPita': 'Pita cukai',
  'lumen.otherDocs.ck5.fanProduksi': 'Produksi',
  'lumen.otherDocs.ck5.fanMutasi': 'Mutasi',
  'lumen.otherDocs.ck5.fanNote': 'Data tersalin otomatis — Anda tinggal melengkapi',
  'lumen.otherDocs.ck5.riskSliderHint': 'Geser untuk merasakan skala risiko 0–1',
  'lumen.otherDocs.ck5.riskSliderAria': 'Skor risiko',
  'lumen.otherDocs.ck5.katSangatRendah': 'Sangat Rendah',
  'lumen.otherDocs.ck5.katRendah': 'Rendah',
  'lumen.otherDocs.ck5.katSedang': 'Sedang',
  'lumen.otherDocs.ck5.katTinggi': 'Tinggi',
  'lumen.otherDocs.ck5.katSangatTinggi': 'Sangat Tinggi',
  'lumen.otherDocs.ck5.postingBadge': 'Otomatis',
  'lumen.otherDocs.ck5.postingTitle': 'Posting Stok — dokumen ↔ kartu stok selalu sinkron',
  'lumen.otherDocs.ck5.postingSj': 'Surat Jalan final',
  'lumen.otherDocs.ck5.postingSjBody':
    'Mengeluarkan <b>barang jadi</b> dari gudang (stok keluar) sesuai barang yang dikirim.',
  'lumen.otherDocs.ck5.postingCk4': 'CK-4 diproses',
  'lumen.otherDocs.ck5.postingCk4Body':
    'Menambah <b>barang jadi</b> hasil produksi & memotong <b>bahan baku</b> sesuai BOM (BOM di-explode).',
  'lumen.otherDocs.ck5.postingNote':
    'Anda tetap mencatat manual untuk <b>stok masuk bahan baku/pita</b> dan <b>stock opname</b>. Sisanya berjalan sendiri.',
  'lumen.otherDocs.ck5.startHere': 'Mulai dari sini',
  'lumen.otherDocs.ck5.reset': 'Ulangi',
  'lumen.otherDocs.ck5.checklistHint': 'Centang tiap langkah selagi Anda mengerjakannya — tersimpan di browser ini.',
  'lumen.otherDocs.ck5.allDone': 'Selesai! Anda sudah paham seluruh alur modul Cukai. 🎉',
  'lumen.otherDocs.ck5.openMenuTip': 'Buka menu',
  'lumen.otherDocs.ck5.glossaryTitle': 'Istilah penting',
  'lumen.otherDocs.ck5.glossarySearch': 'Cari istilah…',
  'lumen.otherDocs.ck5.glossaryEmpty': 'Tidak ada istilah cocok.',
  'lumen.otherDocs.ck5.gBkcTerm': 'BKC',
  'lumen.otherDocs.ck5.gBkcDef':
    'Barang Kena Cukai. Ada tiga jenis: EA (Etil Alkohol), MMEA (Minuman Beralkohol), dan HT (Hasil Tembakau).',
  'lumen.otherDocs.ck5.gNppbkcTerm': 'NPPBKC',
  'lumen.otherDocs.ck5.gNppbkcDef':
    'Nomor Pokok Pengusaha Barang Kena Cukai — izin/identitas resmi pengusaha BKC dari Bea Cukai.',
  'lumen.otherDocs.ck5.gCk1Term': 'CK-1',
  'lumen.otherDocs.ck5.gCk1Def': 'Dokumen pemesanan pita cukai (keping pita yang dilekatkan pada BKC). Berwarna ungu.',
  'lumen.otherDocs.ck5.gCk4Term': 'CK-4',
  'lumen.otherDocs.ck5.gCk4Def':
    'Laporan bahwa produksi BKC selesai dibuat. Menambah stok barang jadi & memotong bahan baku sesuai BOM. Berwarna oranye.',
  'lumen.otherDocs.ck5.gCk5Term': 'CK-5',
  'lumen.otherDocs.ck5.gCk5Def':
    'Pemberitahuan mutasi (perpindahan) BKC antar-lokasi, menyimpan status pelunasan. Berwarna sian.',
  'lumen.otherDocs.ck5.gPitaTerm': 'Pita Cukai',
  'lumen.otherDocs.ck5.gPitaDef':
    'Tanda pelunasan cukai berupa pita pada kemasan BKC. Dipesan lewat CK-1; keping per lembar berbeda tiap seri (I:120, II:56, III:150).',
  'lumen.otherDocs.ck5.gHjeTerm': 'HJE',
  'lumen.otherDocs.ck5.gHjeDef': 'Harga Jual Eceran per kemasan — dasar perhitungan cukai.',
  'lumen.otherDocs.ck5.gTarifTerm': 'Tarif Cukai',
  'lumen.otherDocs.ck5.gTarifDef':
    'Besaran cukai per satuan (batang/gram/liter), dikalikan jumlah untuk menghitung nilai cukai.',
  'lumen.otherDocs.ck5.gStokTerm': 'Kartu Stok',
  'lumen.otherDocs.ck5.gStokDef':
    'Catatan mutasi persediaan per item: stok masuk, keluar, dan penyesuaian. Buku persediaan wajib pengusaha BKC.',
  'lumen.otherDocs.ck5.gMutasiTerm': 'Mutasi',
  'lumen.otherDocs.ck5.gMutasiDef':
    'Perpindahan/pergerakan BKC atau perubahan saldo stok. Dalam dokumen dilaporkan lewat CK-5.',
  'lumen.otherDocs.ck5.gPelunasanTerm': 'Pelunasan',
  'lumen.otherDocs.ck5.gPelunasanDef':
    'Status pembayaran cukai: Belum Dilunasi, Sudah Dilunasi, Tidak Dipungut, atau Dibebaskan. Melekat pada CK-5.',
  'lumen.otherDocs.ck5.gBomTerm': 'BOM',
  'lumen.otherDocs.ck5.gBomDef':
    'Bill of Material — resep produksi: bahan baku dan takaran untuk membuat satu barang jadi. Tertaut ke inventori.',
  'lumen.otherDocs.ck5.gOpnameTerm': 'Stock Opname',
  'lumen.otherDocs.ck5.gOpnameDef':
    'Penyesuaian saldo stok agar sesuai hitungan fisik gudang — menghasilkan mutasi tambah/kurang.',
  'lumen.otherDocs.ck5.gH2hTerm': 'Host-to-Host',
  'lumen.otherDocs.ck5.gH2hDef':
    'Pengiriman dokumen langsung dari sistem Anda ke Bea Cukai tanpa input ulang; status balasan ditarik otomatis.',
  'lumen.otherDocs.ck5.faqTitle': 'Pertanyaan yang sering diajukan',
  'lumen.otherDocs.ck5.faq1Q': 'Saya benar-benar baru. Dari mana harus mulai?',
  'lumen.otherDocs.ck5.faq1A':
    'Ikuti urutan "Mulai dari sini": Inventori → BOM → stok masuk → Surat Jalan → generate CK → submit → posting stok → Risk Self-Check. Urutan ini membuat otomatisasi berjalan mulus.',
  'lumen.otherDocs.ck5.faq2Q': 'Apa bedanya CK-1, CK-4, dan CK-5?',
  'lumen.otherDocs.ck5.faq2A':
    'CK-1 memesan pita cukai (ungu). CK-4 melaporkan produksi selesai (oranye). CK-5 memberitahukan mutasi BKC beserta pelunasan (sian). Ketiganya diterbitkan dari surat jalan lalu disubmit ke Bea Cukai.',
  'lumen.otherDocs.ck5.faq3Q': 'Kenapa Surat Jalan dibuat lebih dulu?',
  'lumen.otherDocs.ck5.faq3A':
    'Surat Jalan adalah dokumen sumber. Data pengirim, penerima, pengangkutan, dan barang diisi sekali, lalu tersalin otomatis saat men-generate CK — hemat waktu dan konsisten.',
  'lumen.otherDocs.ck5.faq4Q': 'Apakah stok berubah sendiri?',
  'lumen.otherDocs.ck5.faq4A':
    'Sebagian besar otomatis: surat jalan final mengeluarkan barang jadi, CK-4 menambah produksi & memotong bahan baku sesuai BOM. Anda tetap mencatat manual stok masuk bahan baku/pita dan stock opname.',
  'lumen.otherDocs.ck5.faq5Q': 'Skor risiko saya tinggi, apa artinya?',
  'lumen.otherDocs.ck5.faq5A':
    'Peringatan dini, bukan sanksi. Telaah indikator CRITICAL dulu, baca rekomendasinya. Umumnya mulai dari "Kesiapan Data" (lengkapi tautan inventori), lunasi CK-5, dan pastikan CK-4/surat jalan sudah diposting.',
  'lumen.otherDocs.fxp.dateRangeMax3Months': 'Date range cannot exceed 3 months',
  'lumen.otherDocs.fxp.submitSentenceFinal':
    'Dokumen <b>{title}</b> ({kode}) akan dikirim ke CEISA sebagai pengajuan final.',
  'lumen.otherDocs.fxp.submitSentenceDraft':
    'Dokumen <b>{title}</b> ({kode}) akan dikirim ke CEISA sebagai draft (dapat dicetak dan dilihat di portal CEISA).',
  // lumen.exportEngine (revamp PR 8c)
  'lumen.exportEngine.g1.scaffoldPill': 'Terisi otomatis',
  'lumen.exportEngine.g1.scaffoldPillTooltip':
    'Nilai ini terisi otomatis dari eksportir / pelabuhan yang Anda pilih saat upload.',
  'lumen.exportEngine.g1.cardRecommendedTooltip':
    'Barang mirip dengan draft ini — {matchCount} dari {matchTotal} pos tarif cocok',
  'lumen.exportEngine.g1.cardSelectedAria': 'Terpilih',
  'lumen.exportEngine.g1.cardNpwpNik': 'NPWP/NIK:',
  'lumen.exportEngine.g1.cardNoAddress': 'Alamat tidak tersedia',
  'lumen.exportEngine.g1.cardPenerima': 'Penerima:',
  'lumen.exportEngine.g1.cardPembeli': 'Pembeli:',
  'lumen.exportEngine.g1.cardPelMuat': 'Pel. muat ekspor:',
  'lumen.exportEngine.pg1.secureTitle': 'Secure & Private',
  'lumen.exportEngine.pg1.secureMessage': 'Protected by enterprise-grade security',
  'lumen.exportEngine.pg1.ownershipTitle': 'Data Ownership',
  'lumen.exportEngine.pg1.ownershipMessage': 'Your data belongs to you, always',
  'lumen.exportEngine.pg1.bankTitle': 'Bank-Level Security',
  'lumen.exportEngine.pg1.bankMessage': 'Military-grade protection for your business',
  'lumen.exportEngine.pg2.loading': 'Loading...',
  'lumen.exportEngine.pg4.saveFailedTitle': 'Gagal Menyimpan',
  'lumen.exportEngine.pg4.saveBarangFailed': 'Gagal menyimpan data barang',
  'lumen.exportEngine.pg4.saveTabFailed': 'Gagal menyimpan tab {tab}',
  'lumen.exportEngine.pg4.ajuMissing': 'Nomor AJU belum tersedia',
  'lumen.exportEngine.pg4.failedTitle': 'Gagal',
  'lumen.exportEngine.pg4.printFormFailed': 'Gagal cetak formulir',
  'lumen.exportEngine.pg4.ppjkNpwpMissing': 'PPJK NPWP tidak ditemukan. Pastikan data PPJK sudah diisi dengan benar.',
  'lumen.exportEngine.pg5.formDataMissing': 'Form data not available. Please fill out the form first.',
  'lumen.exportEngine.pg5.submitSuccess': 'Export document berhasil disubmit ke CEISA.',
  'lumen.exportEngine.pg5.submitFailed': 'Gagal submit export document',
  'lumen.exportEngine.pg6.loadingPage': 'Memuat halaman',
  'lumen.exportEngine.pg6.back': 'Back',
  'lumen.exportEngine.pg6.auditLogs': 'Audit Logs',
  'lumen.exportEngine.pg6.lihatDiCeisa': 'Lihat di Ceisa',
  'lumen.exportEngine.pg6.syncHistoricalData': 'Sync with Historical Data',
  'lumen.exportEngine.pg6.aksi': 'Aksi',
  'lumen.exportEngine.pg6.cetak': 'Cetak',
  'lumen.exportEngine.pg6.loadingEllipsis': 'Loading...',
  'lumen.exportEngine.pg6.cetakDraftPeb': 'Cetak Draft PEB',
  'lumen.exportEngine.pg6.submit': 'Submit',
  'lumen.exportEngine.pg6.transferNpe': 'Transfer (NPE)',
  'lumen.exportEngine.pg6.revisi': 'Revisi',
  'lumen.exportEngine.pg6.submitKeCeisa': 'Submit ke Ceisa',
  'lumen.exportEngine.pg6.sebelumnya': 'Sebelumnya',
  'lumen.exportEngine.pg6.selanjutnya': 'Selanjutnya',
  'lumen.exportEngine.pg6.konfirmasi': 'Konfirmasi {type}',
  'lumen.exportEngine.pg6.transferWarning':
    'Anda akan melakukan Transfer (NPE). Dokumen akan disubmit secara final ke CEISA dan tidak dapat diubah kembali setelah mendapatkan NPE.',
  'lumen.exportEngine.pg6.revisiWarning':
    'Anda akan melakukan Revisi dokumen. Data yang sudah disubmit sebelumnya akan diperbarui di CEISA.',
  'lumen.exportEngine.pg6.yaLanjutkan': 'Ya, Lanjutkan',
  'lumen.exportEngine.pg6.submissionProgress': 'Progres pengiriman',
  'lumen.exportEngine.pg6.submittingToCeisa': 'Submitting to CEISA...',
  'lumen.exportEngine.pg6.submissionFailed': 'Submission Failed',
  'lumen.exportEngine.pg6.close': 'Close',
  'lumen.exportEngine.pk1.originLoadingPortRequired': 'Pelabuhan Muat Asal harus dipilih',
  'lumen.exportEngine.pk1.exportLoadingPortRequired': 'Pelabuhan Muat Ekspor harus dipilih',
  'lumen.exportEngine.pk1.destinationPortRequired': 'Pelabuhan Tujuan harus dipilih',
  'lumen.exportEngine.pk1.exportDestinationCountryRequired': 'Negara Tujuan Ekspor harus dipilih',
  'lumen.exportEngine.pk1.estimatedExportDateRequired': 'Perkiraan Tanggal Ekspor harus diisi',
  'lumen.exportEngine.pk1.inspectionLocationRequired': 'Lokasi Pemeriksaan harus diisi',
  'lumen.exportEngine.pk1.inspectionOfficeRequired': 'Kantor Pemeriksaan harus dipilih',
  'lumen.exportEngine.pk1.inspectionDateRequired': 'Tanggal Pemeriksaan harus diisi',
  'lumen.exportEngine.pk1.wajibDiisi': 'Wajib diisi',
  'lumen.exportEngine.pk2.seri': 'Seri',
  'lumen.exportEngine.pk2.namaSarkut': 'Nama Sarkut',
  'lumen.exportEngine.pk2.nomorPengangkut': 'Nomor Pengangkut',
  'lumen.exportEngine.pk2.caraPengangkutan': 'Cara Pengangkutan',
  'lumen.exportEngine.pk2.bendera': 'Bendera',
  'lumen.exportEngine.pk2.aksi': 'Aksi',
  'lumen.exportEngine.pk2.edit': 'Edit',
  'lumen.exportEngine.pk2.delete': 'Delete',
  'lumen.exportEngine.pk2.saranaAngkut': 'Sarana Angkut',
  'lumen.exportEngine.pk2.tambah': 'Tambah',
  'lumen.exportEngine.pk2.pelabuhanMuatAsal': 'Pelabuhan muat asal',
  'lumen.exportEngine.pk2.pilihPelabuhanMuatAsal': 'Pilih pelabuhan muat asal',
  'lumen.exportEngine.pk2.pelabuhanMuatEkspor': 'Pelabuhan muat Ekspor',
  'lumen.exportEngine.pk2.pilihPelabuhanMuatEkspor': 'Pilih pelabuhan muat ekspor',
  'lumen.exportEngine.pk2.tempatPenimbunan': 'Tempat penimbunan',
  'lumen.exportEngine.pk2.pilihTempatPenimbunan': 'Pilih tempat penimbunan',
  'lumen.exportEngine.pk2.pilihKantorMuatDulu': 'Mohon pilih kantor pabean muat asal terlebih dahulu',
  'lumen.exportEngine.pk2.tanggalPerkiraanEkspor': 'Tanggal perkiraan ekspor',
  'lumen.exportEngine.pk2.jenisPengangkutan': 'Jenis Pengangkutan',
  'lumen.exportEngine.pk2.pilihJenisPengangkutan': 'Pilih jenis pengangkutan',
  'lumen.exportEngine.pk2.pelabuhanTujuan': 'Pelabuhan tujuan',
  'lumen.exportEngine.pk2.pilihPelabuhanTujuan': 'Pilih pelabuhan tujuan',
  'lumen.exportEngine.pk2.negaraTujuanEkspor': 'Negara tujuan ekspor',
  'lumen.exportEngine.pk2.pilihNegaraTujuanEkspor': 'Pilih negara tujuan ekspor',
  'lumen.exportEngine.pk2.pemeriksaan': 'Pemeriksaan',
  'lumen.exportEngine.pk2.lokasiPemeriksaan': 'Lokasi Pemeriksaan',
  'lumen.exportEngine.pk2.pilihLokasiPemeriksaan': 'Pilih lokasi pemeriksaan',
  'lumen.exportEngine.pk2.kantorPabeanPemeriksaan': 'Kantor Pabean Pemeriksaan',
  'lumen.exportEngine.pk2.pilihKantorPabeanPemeriksaan': 'Pilih kantor pabean pemeriksaan',
  'lumen.exportEngine.pk2.tanggalPeriksa': 'Tanggal periksa',
  'lumen.exportEngine.pk3.tambahPetiKemas': 'Tambah Peti Kemas',
  'lumen.exportEngine.pk3.seri': 'Seri',
  'lumen.exportEngine.pk3.nomor': 'Nomor',
  'lumen.exportEngine.pk3.ukuran': 'Ukuran',
  'lumen.exportEngine.pk3.jenis': 'Jenis',
  'lumen.exportEngine.pk3.tipe': 'Tipe',
  'lumen.exportEngine.pk3.tambahKemasan': 'Tambah Kemasan',
  'lumen.exportEngine.pk3.jumlah': 'Jumlah',
  'lumen.exportEngine.pk3.merek': 'Merek',
  'lumen.exportEngine.pk3.namaRequired': 'Nama sarana angkut is required',
  'lumen.exportEngine.pk3.caraRequired': 'Cara pengangkutan is required',
  'lumen.exportEngine.pk3.voyRequired': 'Nomor Voy/Flight/NoPol is required',
  'lumen.exportEngine.pk3.benderaRequired': 'Bendera is required',
  'lumen.exportEngine.pk3.masukkanNamaDulu': 'Masukkan nama sarana angkut terlebih dahulu',
  'lumen.exportEngine.pk3.hanyaLaut': 'Pencarian bendera hanya tersedia untuk angkutan laut',
  'lumen.exportEngine.pk3.kodeNegaraGagal':
    'Bendera "{flagName}" ditemukan, namun kode negara tidak dapat diambil. Silakan pilih bendera secara manual.',
  'lumen.exportEngine.pk3.benderaTidakDitemukan': 'Bendera tidak ditemukan untuk kapal ini',
  'lumen.exportEngine.pk3.gagalCari': 'Gagal mencari bendera kapal. Silakan pilih bendera secara manual.',
  'lumen.exportEngine.pk3.editSaranaAngkut': 'Edit Sarana Angkut',
  'lumen.exportEngine.pk3.tambahSaranaAngkut': 'Tambah Sarana Angkut',
  'lumen.exportEngine.pk3.namaSaranaAngkut': 'Nama Sarana Angkut',
  'lumen.exportEngine.pk3.namaPlaceholder': 'Masukkan nama sarana angkut',
  'lumen.exportEngine.pk3.cariBendera': 'Cari Bendera',
  'lumen.exportEngine.pk3.caraPengangkutan': 'Cara Pengangkutan',
  'lumen.exportEngine.pk3.caraPlaceholder': 'Pilih cara pengangkutan',
  'lumen.exportEngine.pk3.voyLabel': 'Nomor Voy / Flight / No Pol',
  'lumen.exportEngine.pk3.voyPlaceholder': 'Masukkan nomor voy/flight/no pol',
  'lumen.exportEngine.pk3.bendera': 'Bendera',
  'lumen.exportEngine.pk3.benderaPlaceholder': 'Pilih bendera',
  'lumen.exportEngine.pk4.seri': 'Seri',
  'lumen.exportEngine.pk4.jumlah': 'Jumlah',
  'lumen.exportEngine.pk4.jenis': 'Jenis',
  'lumen.exportEngine.pk4.merek': 'Merek',
  'lumen.exportEngine.pk4.nomor': 'Nomor',
  'lumen.exportEngine.pk4.ukuran': 'Ukuran',
  'lumen.exportEngine.pk4.tipe': 'Tipe',
  'lumen.exportEngine.pk4.aksi': 'Aksi',
  'lumen.exportEngine.pk4.edit': 'Edit',
  'lumen.exportEngine.pk4.copy': 'Copy',
  'lumen.exportEngine.pk4.delete': 'Delete',
  'lumen.exportEngine.pk4.kemasan': 'Kemasan',
  'lumen.exportEngine.pk4.petiKemas': 'Peti Kemas',
  'lumen.exportEngine.pk4.tambahKemasan': 'Tambah Kemasan',
  'lumen.exportEngine.pk4.tambahPetiKemas': 'Tambah Peti Kemas',
  'lumen.exportEngine.pk4.konfirmasiHapus': 'Konfirmasi Hapus',
  'lumen.exportEngine.pk4.hapusKemasanBody': 'Apakah Anda yakin akan menghapus kemasan ini?',
  'lumen.exportEngine.pk4.hapusPetiKemasBody': 'Apakah Anda yakin akan menghapus peti kemas ini?',
  'lumen.exportEngine.pk4.hapus': 'Hapus',
  'lumen.exportEngine.pk5.transaksi': 'Transaksi',
  'lumen.exportEngine.pk5.valuta': 'Valuta',
  'lumen.exportEngine.pk5.pilihValuta': 'Pilih Valuta',
  'lumen.exportEngine.pk5.ndpbm': 'NDPBM',
  'lumen.exportEngine.pk5.caraPenyerahan': 'Cara penyerahan',
  'lumen.exportEngine.pk5.pilihCaraPenyerahan': 'Pilih cara penyerahan',
  'lumen.exportEngine.pk5.nilaiEksporFob': 'Nilai Ekspor (Incoterm FOB)',
  'lumen.exportEngine.pk5.freight': 'Freight',
  'lumen.exportEngine.pk5.nilaiAsuransi': 'Nilai Asuransi',
  'lumen.exportEngine.pk5.asuransi': 'Asuransi',
  'lumen.exportEngine.pk5.jenisAsuransi': 'Jenis asuransi',
  'lumen.exportEngine.pk5.dalamNegeri': 'DALAM NEGERI',
  'lumen.exportEngine.pk5.luarNegeri': 'LUAR NEGERI',
  'lumen.exportEngine.pk5.ratesHint':
    'Freight dan Nilai Asuransi standar DJBC; isian manual tidak ditimpa kecuali dihitung ulang.',
  'lumen.exportEngine.pk5.hitungFreightAsuransi': 'Hitung Freight & Asuransi',
  'lumen.exportEngine.pk5.beratKotor': 'Berat kotor (KGM)',
  'lumen.exportEngine.pk5.beratBersih': 'Berat bersih (KGM)',
  'lumen.exportEngine.pk5.nilaiMaklon': 'Nilai Maklon',
  'lumen.exportEngine.pk5.nilaiBeaKeluar': 'Nilai Bea Keluar',
  'lumen.exportEngine.pk5.infoBeaKeluar': 'Info Bea Keluar',
  'lumen.exportEngine.pk5.infoBeaKeluarText':
    'Nilai Bea Keluar dihitung otomatis berdasarkan tarif BK yang berlaku untuk HS code barang ekspor (Permenkeu BK terbaru). Diisi dalam Rupiah.',
  'lumen.exportEngine.pk5.hitungBeaKeluar': 'Hitung Bea Keluar',
  'lumen.exportEngine.pk5.nilaiPph22': 'Nilai PPh Pasal 22 Ekspor',
  'lumen.exportEngine.pk5.infoPph22': 'Info PPh 22',
  'lumen.exportEngine.pk5.infoPph22Text':
    'Centang bila ekspor dikenai PPh Pasal 22 (mis. ekspor batu bara, mineral logam, sawit kelapa). Nilai dihitung dari Nilai Ekspor × tarif PPh 22 sesuai PMK terbaru, dalam Rupiah.',
  'lumen.exportEngine.pk5.nilaiPungutanSawit': 'Nilai Pungutan Sawit',
  'lumen.exportEngine.pk5.infoPungutanSawit': 'Info Pungutan Sawit',
  'lumen.exportEngine.pk5.infoPungutanSawitText':
    'Pungutan ekspor CPO/produk sawit yang dikenakan BPDPKS. Isi nilai dalam Rupiah sesuai tarif yang berlaku.',
  'lumen.exportEngine.pk5.previewUnavailable': 'Preview Bea Keluar tidak tersedia',
  'lumen.exportEngine.pk5.responseUnavailable': 'Response Bea Keluar tidak tersedia',
  'lumen.exportEngine.pk5.persistFailedFallback': 'Persist failed',
  'lumen.exportEngine.pk5.calcFailedTitle': 'Gagal Menghitung',
  'lumen.exportEngine.pk5.calcFailedFallback': 'Gagal menghitung Bea Keluar',
  'lumen.exportEngine.pk5.warningTitle': 'Warning',
  'lumen.exportEngine.pk5.savedRefreshFailed': 'Bea Keluar tersimpan, tetapi data terbaru gagal dimuat otomatis.',
  'lumen.exportEngine.pk5.successTitle': 'Success',
  'lumen.exportEngine.pk5.savedAmount': 'Bea keluar {amount} disimpan',
  'lumen.exportEngine.pk5.persistFailedTitle': 'Persist Failed',
  'lumen.exportEngine.pk6.bankDevisa': 'Bank Devisa',
  'lumen.exportEngine.pk6.tambah': 'Tambah',
  'lumen.exportEngine.pk6.seri': 'Seri',
  'lumen.exportEngine.pk6.kodeBank': 'Kode Bank',
  'lumen.exportEngine.pk6.namaBank': 'Nama Bank',
  'lumen.exportEngine.pk6.aksi': 'Aksi',
  'lumen.exportEngine.pk6.delete': 'Delete',
  'lumen.exportEngine.pk6.konfirmasiHapus': 'Konfirmasi Hapus',
  'lumen.exportEngine.pk6.hapusBankBody': 'Apakah Anda yakin akan menghapus bank devisa ini?',
  'lumen.exportEngine.pk6.hapus': 'Hapus',
  'lumen.exportEngine.pk6.previewBeaKeluar': 'Preview Bea Keluar',
  'lumen.exportEngine.pk6.totalBeaKeluar': 'Total Bea Keluar',
  'lumen.exportEngine.pk6.totalSummary': 'USD {usd} · NDPBM {ndpbm} · Periode {periode}',
  'lumen.exportEngine.pk6.peringatan': 'Peringatan',
  'lumen.exportEngine.pk6.warningWithSeri': '{code} · Seri {seri}: {message}',
  'lumen.exportEngine.pk6.warningNoSeri': '{code}: {message}',
  'lumen.exportEngine.pk6.periksaDataPendukung': 'Periksa data pendukung Bea Keluar.',
  'lumen.exportEngine.pk6.posTarif': 'Pos Tarif',
  'lumen.exportEngine.pk6.uraian': 'Uraian',
  'lumen.exportEngine.pk6.netto': 'Netto',
  'lumen.exportEngine.pk6.hpe': 'HPE',
  'lumen.exportEngine.pk6.tarifBk': 'Tarif BK',
  'lumen.exportEngine.pk6.bkUsd': 'BK USD',
  'lumen.exportEngine.pk6.bkIdr': 'BK IDR',
  'lumen.exportEngine.pk6.status': 'Status',
  'lumen.exportEngine.pk6.tidakAdaBaris': 'Tidak ada baris perhitungan.',
  'lumen.exportEngine.pk6.nettoMt': '{n} MT',
  'lumen.exportEngine.pk6.nettoKg': '{n} KG',
  'lumen.exportEngine.pk6.usdAmount': 'USD {amount}',
  'lumen.exportEngine.pk6.staleHpe': 'Stale HPE',
  'lumen.exportEngine.pk6.hpeMonthUsed': 'HPE month used: {month}',
  'lumen.exportEngine.pk6.bracketInfo': '{kelompok} · HR {min}-{max}',
  'lumen.exportEngine.pk6.terapkan': 'Terapkan',
  'lumen.exportEngine.pk6.tambahBankDevisa': 'Tambah Bank Devisa',
  'lumen.exportEngine.pk6.pilihBank': 'Pilih Bank',
  'lumen.exportEngine.br1.hsFetchFailed': 'Failed to fetch HS code details',
  'lumen.exportEngine.br1.hsFetchError': 'Error fetching HS code details',
  'lumen.exportEngine.br1.excelDownloaded': 'Excel berhasil diunduh',
  'lumen.exportEngine.br1.excelDownloadFailed': 'Gagal mengunduh Excel',
  'lumen.exportEngine.br1.uploadExcelTitle': 'Upload Excel',
  'lumen.exportEngine.br1.uploadingExcel': 'Mengunggah file Excel dan menyegarkan data barang...',
  'lumen.exportEngine.br1.processIdMissing': 'Process ID tidak ditemukan',
  'lumen.exportEngine.br1.uploadFailed': 'Upload gagal',
  'lumen.exportEngine.br1.uploadRefreshing': 'Upload berhasil, memuat data terbaru...',
  'lumen.exportEngine.br1.uploadDone': 'Upload Excel berhasil dan data barang sudah diperbarui',
  'lumen.exportEngine.br1.uploadRefreshFailed':
    'Upload berhasil, namun gagal memperbarui tampilan secara otomatis. Silakan refresh halaman.',
  'lumen.exportEngine.br1.uploadExcelFailed': 'Gagal mengupload Excel',
  'lumen.exportEngine.br2.seri': 'Seri',
  'lumen.exportEngine.br2.hs': 'HS',
  'lumen.exportEngine.br2.lartas': 'Lartas',
  'lumen.exportEngine.br2.uraian': 'Uraian',
  'lumen.exportEngine.br2.satuan': 'Satuan',
  'lumen.exportEngine.br2.kemasan': 'Kemasan',
  'lumen.exportEngine.br2.fob': 'FOB',
  'lumen.exportEngine.br2.nw': 'NW',
  'lumen.exportEngine.br2.aksi': 'Aksi',
  'lumen.exportEngine.br2.yes': 'Yes',
  'lumen.exportEngine.br2.no': 'No',
  'lumen.exportEngine.br2.kg': 'kg',
  'lumen.exportEngine.br2.copy': 'Copy',
  'lumen.exportEngine.br2.delete': 'Delete',
  'lumen.exportEngine.br3.itemCopyNotFound': 'Item tidak ditemukan untuk disalin',
  'lumen.exportEngine.br3.itemDeleteNotFound': 'Item tidak ditemukan untuk dihapus',
  'lumen.exportEngine.br3.bulkDeleted': '{count} barang berhasil dihapus',
  'lumen.exportEngine.br3.bulkDeleteFailed': 'Gagal menghapus barang',
  'lumen.exportEngine.br3.itemUpdated': 'Item berhasil diperbarui',
  'lumen.exportEngine.br3.itemAdded': 'Item berhasil ditambahkan',
  'lumen.exportEngine.br3.processIdMissing': 'Process ID tidak ditemukan',
  'lumen.exportEngine.br3.smartSyncTitle': 'Smart Sync',
  'lumen.exportEngine.br3.smartSyncStep1': 'Step 1/3: Saving current data...',
  'lumen.exportEngine.br3.smartSyncStep2': 'Step 2/3: Syncing data with CEISA...',
  'lumen.exportEngine.br3.smartSyncStep3': 'Step 3/3: Retrieving synced data...',
  'lumen.exportEngine.br3.smartSyncDone': 'Smart Sync completed! Synced {count} items.',
  'lumen.exportEngine.br3.smartSyncRetrieveFailed': 'Failed to retrieve synced data',
  'lumen.exportEngine.br3.smartSyncFailed': 'Smart Sync gagal',
  'lumen.exportEngine.br4.downloading': 'Downloading...',
  'lumen.exportEngine.br4.downloadExcel': 'Download Excel',
  'lumen.exportEngine.br4.uploading': 'Uploading...',
  'lumen.exportEngine.br4.uploadExcel': 'Upload Excel',
  'lumen.exportEngine.br4.hsCodeDetails': 'HS Code Details',
  'lumen.exportEngine.br4.basicInfo': 'Basic Info',
  'lumen.exportEngine.br4.tariffRates': 'Tariff Rates',
  'lumen.exportEngine.br4.preferentialTariffs': 'Preferential Tariffs ({count})',
  'lumen.exportEngine.br4.code': 'Code:',
  'lumen.exportEngine.br4.normalizedCode': 'Normalized Code:',
  'lumen.exportEngine.br4.idDescription': 'ID Description:',
  'lumen.exportEngine.br4.enDescription': 'EN Description:',
  'lumen.exportEngine.br4.inswYear': 'INSW Year:',
  'lumen.exportEngine.br4.lartas': 'LARTAS:',
  'lumen.exportEngine.br4.yes': 'YES',
  'lumen.exportEngine.br4.no': 'NO',
  'lumen.exportEngine.br4.issueDate': 'Issue Date:',
  'lumen.exportEngine.br4.effective': 'Effective:',
  'lumen.exportEngine.br4.historicalRates': 'Historical Rates:',
  'lumen.exportEngine.br4.loadingHsCode': 'Loading HS code details...',
  'lumen.exportEngine.br5.total': 'Total: {count}',
  'lumen.exportEngine.br5.filtered': 'Filtered: {count}',
  'lumen.exportEngine.br5.smartSync': 'Smart Sync',
  'lumen.exportEngine.br5.syncing': 'Syncing...',
  'lumen.exportEngine.br5.tambahBarang': 'Tambah Barang',
  'lumen.exportEngine.br5.searchPlaceholder': 'Cari berdasarkan uraian atau HS code...',
  'lumen.exportEngine.br5.clearSearch': 'Hapus pencarian',
  'lumen.exportEngine.br5.tableAria': 'Daftar barang',
  'lumen.exportEngine.br6.nilaiEksporFob': 'Nilai Ekspor (Nilai FOB)',
  'lumen.exportEngine.br6.infoNilaiEksporAria': 'Info Nilai Ekspor',
  'lumen.exportEngine.br6.nilaiEksporInfo':
    'Diisi dengan nilai ekspor per barang yang tertera dalam invoice sesuai dengan Incoterm FOB dan dalam valuta sesuai pengisian pada kolom Valuta. Dalam hal menggunakan Incoterm selain FOB, nilai ekspor yang dicantumkan adalah sebesar nilai FOB. Dalam hal ekspor jasa maklon, maka kolom Nilai Ekspor diisikan dengan ketentuan sebagai berikut: Kolom Nilai Ekspor diisikan dengan menggunakan nilai barang jadi yang diekspor (setelah dilakukan pengerjaan). Dalam hal nilai barang jadi yang diekspor tidak diketahui, maka kolom Nilai Ekspor menggunakan nilai impor barang atau bahan baku yang dilakukan pengerjaan ditambah dengan nilai jasa maklon. Contoh Pengisian lihat Hal. 34 Lampiran I Perdirjen No. PER-22/BC/2024.',
  'lumen.exportEngine.br6.nilaiEksporPerSatuan': 'Nilai Ekspor per satuan barang',
  'lumen.exportEngine.br6.incoterm': 'Incoterm',
  'lumen.exportEngine.br6.beratBersih': 'Berat Bersih (kg)',
  'lumen.exportEngine.br6.mataUang': 'Mata Uang',
  'lumen.exportEngine.br6.totalNilaiFob': 'Total Nilai FOB ({currency})',
  'lumen.exportEngine.br6.totalQuantity': 'Total Quantity',
  'lumen.exportEngine.br6.informasiDasar': 'Informasi Dasar',
  'lumen.exportEngine.br6.detailHarga': 'Detail & Harga',
  'lumen.exportEngine.br6.dokumenFasilitasLartas': 'Dokumen Fasilitas/Lartas',
  'lumen.exportEngine.br6.entitasBarang': 'Entitas Barang',
  'lumen.exportEngine.br6.tambahBarang': 'Tambah Barang',
  'lumen.exportEngine.br6.simpanPerubahan': 'Simpan Perubahan',
  'lumen.exportEngine.br6.gagalMenambahkanBarang': 'Gagal Menambahkan Barang',
  'lumen.exportEngine.br6.lengkapiFieldWajib': 'Mohon lengkapi field wajib berikut: {fields}',
  'lumen.exportEngine.br7.seri': 'Seri',
  'lumen.exportEngine.br7.jumlahSatuan': 'Jumlah Satuan',
  'lumen.exportEngine.br7.jumlahSatuanPlaceholder': 'Jumlah satuan',
  'lumen.exportEngine.br7.kodeSatuan': 'Kode Satuan',
  'lumen.exportEngine.br7.kodeSatuanPlaceholder': 'Kode satuan',
  'lumen.exportEngine.br7.jumlahKemasan': 'Jumlah Kemasan',
  'lumen.exportEngine.br7.jumlahKemasanPlaceholder': 'Jumlah kemasan',
  'lumen.exportEngine.br7.kodeKemasan': 'Kode Kemasan',
  'lumen.exportEngine.br7.hsCode': 'HS Code',
  'lumen.exportEngine.br7.lartas': 'LARTAS',
  'lumen.exportEngine.br7.nonLartas': 'NON-LARTAS',
  'lumen.exportEngine.br7.uraian': 'Uraian',
  'lumen.exportEngine.br7.uraianPlaceholder': 'Uraian barang',
  'lumen.exportEngine.br7.sesuaiHs': 'Sesuai HS',
  'lumen.exportEngine.br7.kode': 'Kode',
  'lumen.exportEngine.br7.kodeProdukPlaceholder': 'Kode produk',
  'lumen.exportEngine.br7.merk': 'Merk',
  'lumen.exportEngine.br7.tipe': 'Tipe',
  'lumen.exportEngine.br7.ukuran': 'Ukuran',
  'lumen.exportEngine.br7.kodeJenisEkspor': 'Kode Jenis Ekspor',
  'lumen.exportEngine.br7.negaraAsal': 'Negara Asal Barang',
  'lumen.exportEngine.br7.negaraAsalPlaceholder': 'Negara asal',
  'lumen.exportEngine.br7.daerahAsal': 'Daerah Asal Barang',
  'lumen.exportEngine.br7.daerahAsalPlaceholder': 'Daerah asal',
  'lumen.exportEngine.br8.dokumenCount': 'Dokumen: {count}',
  'lumen.exportEngine.br8.pemilikCount': 'Pemilik: {count}',
  'lumen.exportEngine.br8.pilihDokumen': 'Pilih dokumen...',
  'lumen.exportEngine.br8.pilihPemilik': 'Pilih pemilik barang...',
  'lumen.exportEngine.br8.tambah': 'Tambah',
  'lumen.exportEngine.br8.tidakAdaDokumen': 'Tidak ada dokumen tersedia',
  'lumen.exportEngine.br8.tidakAdaPemilik': 'Tidak ada pemilik tersedia',
  'lumen.exportEngine.br8.seri': 'Seri',
  'lumen.exportEngine.br8.jenis': 'Jenis',
  'lumen.exportEngine.br8.nomor': 'Nomor',
  'lumen.exportEngine.br8.tanggal': 'Tanggal',
  'lumen.exportEngine.br8.fasilitas': 'Fasilitas',
  'lumen.exportEngine.br8.izin': 'Izin',
  'lumen.exportEngine.br8.aksi': 'Aksi',
  'lumen.exportEngine.br8.nama': 'Nama',
  'lumen.exportEngine.br8.identitas': 'Identitas',
  'lumen.exportEngine.br8.alamat': 'Alamat',
  'lumen.exportEngine.br8.hapus': 'Hapus',
  'lumen.exportEngine.br8.belumAdaDokumenDiTab': 'Belum ada dokumen di tab Dokumen. Tambahkan dokumen terlebih dahulu.',
  'lumen.exportEngine.br8.belumAdaDokumenDipilih': 'Belum ada dokumen dipilih. Pilih dokumen dari dropdown di atas.',
  'lumen.exportEngine.br8.belumAdaPemilikDiTab': 'Belum ada pemilik di tab Entitas. Tambahkan pemilik terlebih dahulu.',
  'lumen.exportEngine.br8.belumAdaPemilikDipilih': 'Belum ada pemilik dipilih. Pilih pemilik dari dropdown di atas.',
  'lumen.exportEngine.br8.infoPemilik': 'Entitas pemilik diambil dari daftar Pemilik Barang di tab Entitas',
  'lumen.exportEngine.he2.pelabuhanLabel': 'Pelabuhan Muat Ekspor',
  'lumen.exportEngine.he2.pelabuhanPlaceholder': 'Pilih Pelabuhan Muat Ekspor',
  'lumen.exportEngine.he2.kantorAsalLabel': 'Kantor Pabean Muat Asal',
  'lumen.exportEngine.he2.kantorAsalPlaceholder': 'Pilih Kantor Pabean Muat Asal',
  'lumen.exportEngine.he2.jenisEksporLabel': 'Jenis Ekspor',
  'lumen.exportEngine.he2.jenisEksporPlaceholder': 'Pilih Jenis Ekspor',
  'lumen.exportEngine.he2.kantorEksporLabel': 'Kantor Pabean Muat Ekspor',
  'lumen.exportEngine.he2.kantorEksporPlaceholder': 'Pilih Kantor Pabean Muat Ekspor',
  'lumen.exportEngine.he2.kategoriEksporLabel': 'Kategori Ekspor',
  'lumen.exportEngine.he2.kategoriEksporPlaceholder': 'Pilih Kategori Ekspor',
  'lumen.exportEngine.he2.caraDagangLabel': 'Cara Dagang',
  'lumen.exportEngine.he2.caraDagangPlaceholder': 'Pilih Cara Dagang',
  'lumen.exportEngine.he2.caraBayarLabel': 'Cara Bayar',
  'lumen.exportEngine.he2.caraBayarPlaceholder': 'Pilih Cara Bayar',
  'lumen.exportEngine.he2.ketBayar': 'Keterangan Pembayaran',
  'lumen.exportEngine.he2.komoditiLabel': 'Komoditi',
  'lumen.exportEngine.he2.komoditiPlaceholder': 'Pilih Komoditi',
  'lumen.exportEngine.he2.curahLabel': 'Curah',
  'lumen.exportEngine.he2.curahPlaceholder': 'Pilih Curah',
  'lumen.exportEngine.he2.barangKirimanLabel': 'Ekspor Barang Kiriman',
  'lumen.exportEngine.he2.barangKirimanPlaceholder': 'Pilih Ekspor Barang Kiriman',
  'lumen.exportEngine.he2.pkbTitle': 'Pemberitahuan Konsolidasi Barang (PKB)',
  'lumen.exportEngine.he2.pkbSubtitle':
    'Jenis ekspor 4, 5 atau 6 — lengkapi dokumen PKB, atau simpan & gunakan template untuk mempercepat pengisian berulang.',
  'lumen.exportEngine.he2.manageTemplate': 'Manage Template',
  'lumen.exportEngine.he2.isiPkb': 'Isi PKB',
  'lumen.exportEngine.he3.title': 'PKB',
  'lumen.exportEngine.he3.permintaanPemeriksaan': 'Permintaan Pemeriksaan',
  'lumen.exportEngine.he3.pelaksanaanStuffing': 'Pelaksanaan Stuffing',
  'lumen.exportEngine.he3.tanggal': 'Tanggal',
  'lumen.exportEngine.he3.dateFormat': 'DD-MM-YYYY',
  'lumen.exportEngine.he3.alamat': 'Alamat',
  'lumen.exportEngine.he3.telepon': 'Telepon',
  'lumen.exportEngine.he3.contactPerson': 'Contact Person',
  'lumen.exportEngine.he3.jenisBarang': 'Jenis Barang',
  'lumen.exportEngine.he3.pilihJenisBarang': 'Pilih Jenis Barang',
  'lumen.exportEngine.he3.tempatSimpan': 'Tempat Simpan',
  'lumen.exportEngine.he3.pilihTempatSimpan': 'Pilih Tempat Simpan',
  'lumen.exportEngine.he3.petiKemas': 'Peti Kemas',
  'lumen.exportEngine.he3.feet20': '20 Feet',
  'lumen.exportEngine.he3.feet40': '40 Feet',
  'lumen.exportEngine.he3.caraStuffing': 'Cara Stuffing',
  'lumen.exportEngine.he3.pilihCaraStuffing': 'Pilih Cara Stuffing',
  'lumen.exportEngine.he3.halPartOf': 'Hal Part Of',
  'lumen.exportEngine.he3.pilihHalPartOf': 'Pilih Hal Part Of',
  'lumen.exportEngine.he3.tempat': 'Tempat',
  'lumen.exportEngine.he3.hapus': 'Hapus',
  'lumen.exportEngine.he4.manageTitle': 'Manage PKB Templates',
  'lumen.exportEngine.he4.ppjkNpwp': 'PPJK NPWP:',
  'lumen.exportEngine.he4.addTemplate': 'Add Template',
  'lumen.exportEngine.he4.colTemplateName': 'Template Name',
  'lumen.exportEngine.he4.colCaraStuffing': 'Cara Stuffing',
  'lumen.exportEngine.he4.colPeti': '20ft / 40ft',
  'lumen.exportEngine.he4.colTempatStuffing': 'Tempat Stuffing',
  'lumen.exportEngine.he4.colStatus': 'Status',
  'lumen.exportEngine.he4.colActions': 'Actions',
  'lumen.exportEngine.he4.noNpwp': 'PPJK NPWP tidak tersedia. Isi data PPJK di Entitas terlebih dahulu.',
  'lumen.exportEngine.he4.loading': 'Loading templates...',
  'lumen.exportEngine.he4.noTemplates': 'No templates found',
  'lumen.exportEngine.he4.inactive': 'Inactive',
  'lumen.exportEngine.he4.active': 'Active',
  'lumen.exportEngine.he4.applyTemplate': 'Pakai template ini',
  'lumen.exportEngine.he4.edit': 'Edit',
  'lumen.exportEngine.he4.delete': 'Delete',
  'lumen.exportEngine.he4.deleteTitle': 'Delete Template',
  'lumen.exportEngine.he4.deleteConfirmPrefix': 'Are you sure you want to delete',
  'lumen.exportEngine.he4.thisTemplate': 'this template',
  'lumen.exportEngine.he4.deleteConfirmSuffix': '? This action cannot be undone.',
  'lumen.exportEngine.he4.cancel': 'Cancel',
  'lumen.exportEngine.he4.editTitle': 'Edit PKB Template',
  'lumen.exportEngine.he4.addTitle': 'Add PKB Template',
  'lumen.exportEngine.he4.templateName': 'Template Name',
  'lumen.exportEngine.he4.templateNamePlaceholder': 'e.g. LCL Priok default',
  'lumen.exportEngine.he4.activeSwitch': 'Active',
  'lumen.exportEngine.he4.metaNote':
    '. Templates store reusable PKB values. Tanggal permintaan & tanggal stuffing are per-transaction — fill them on the PKB form.',
  'lumen.exportEngine.he4.permintaanPemeriksaan': 'Permintaan Pemeriksaan',
  'lumen.exportEngine.he4.alamat': 'Alamat',
  'lumen.exportEngine.he4.telepon': 'Telepon',
  'lumen.exportEngine.he4.contactPerson': 'Contact Person',
  'lumen.exportEngine.he4.jenisBarang': 'Jenis Barang',
  'lumen.exportEngine.he4.pilihJenisBarang': 'Pilih Jenis Barang',
  'lumen.exportEngine.he4.tempatSimpan': 'Tempat Simpan',
  'lumen.exportEngine.he4.pilihTempatSimpan': 'Pilih Tempat Simpan',
  'lumen.exportEngine.he4.petiKemas': 'Peti Kemas',
  'lumen.exportEngine.he4.feet20': '20 Feet',
  'lumen.exportEngine.he4.feet40': '40 Feet',
  'lumen.exportEngine.he4.caraStuffing': 'Cara Stuffing',
  'lumen.exportEngine.he4.pilihCaraStuffing': 'Pilih Cara Stuffing',
  'lumen.exportEngine.he4.halPartOf': 'Hal Part Of',
  'lumen.exportEngine.he4.pilihHalPartOf': 'Pilih Hal Part Of',
  'lumen.exportEngine.he4.pelaksanaanStuffing': 'Pelaksanaan Stuffing',
  'lumen.exportEngine.he4.tempat': 'Tempat',
  'lumen.exportEngine.he4.saving': 'Menyimpan...',
  'lumen.exportEngine.he4.tambah': 'Tambah',
  'lumen.exportEngine.dk1.fileFallback': 'File',
  'lumen.exportEngine.dk1.downloadAria': 'Download {label}',
  'lumen.exportEngine.dk1.uploadBlockedTitle': 'Belum bisa upload',
  'lumen.exportEngine.dk1.uploadBlockedMessage': 'Simpan baris dokumen terlebih dahulu sebelum mengupload file.',
  'lumen.exportEngine.dk1.formatTitle': 'Format tidak didukung',
  'lumen.exportEngine.dk1.formatMessage': 'Hanya file PDF atau Excel (.xlsx/.xls/.csv) yang diperbolehkan.',
  'lumen.exportEngine.dk1.noUrl': 'Response tidak mengandung URL file yang baru',
  'lumen.exportEngine.dk1.successTitle': 'Berhasil',
  'lumen.exportEngine.dk1.uploaded': '{name} terupload',
  'lumen.exportEngine.dk1.uploadFailed': 'Gagal mengupload file',
  'lumen.exportEngine.dk1.failedTitle': 'Gagal',
  'lumen.exportEngine.dk2.colSeri': 'Seri',
  'lumen.exportEngine.dk2.colJenis': 'Jenis',
  'lumen.exportEngine.dk2.colEcooStatus': 'eCOO Status',
  'lumen.exportEngine.dk2.colNomor': 'Nomor',
  'lumen.exportEngine.dk2.colTanggal': 'Tanggal',
  'lumen.exportEngine.dk2.colFasilitas': 'Fasilitas',
  'lumen.exportEngine.dk2.colIjin': 'Ijin',
  'lumen.exportEngine.dk2.colFile': 'File',
  'lumen.exportEngine.dk2.colAttached': 'Attached',
  'lumen.exportEngine.dk2.colAksi': 'Aksi',
  'lumen.exportEngine.dk2.attachTitle': 'Lampirkan Dokumen ke Barang',
  'lumen.exportEngine.dk2.edit': 'Edit',
  'lumen.exportEngine.dk2.copy': 'Copy',
  'lumen.exportEngine.dk2.uploadAria': 'Upload or replace file',
  'lumen.exportEngine.dk2.uploadReplace': 'Upload / Ganti File',
  'lumen.exportEngine.dk2.uploadFile': 'Upload File',
  'lumen.exportEngine.dk2.delete': 'Delete',
  'lumen.exportEngine.dk2.attachIntro': 'Pilih item barang mana yang harus dokumen ini dilampirkan:',
  'lumen.exportEngine.dk2.selectAllAria': 'Pilih semua barang',
  'lumen.exportEngine.dk2.selectRowAria': 'Pilih barang {n}',
  'lumen.exportEngine.dk2.seriBarang': 'Seri Barang',
  'lumen.exportEngine.dk2.hsCode': 'HS Code',
  'lumen.exportEngine.dk2.namaBarang': 'Nama Barang',
  'lumen.exportEngine.dk2.unnamed': 'UNNAMED',
  'lumen.exportEngine.dk2.noBarang': 'Belum ada item barang. Silakan tambahkan item barang terlebih dahulu.',
  'lumen.exportEngine.dk2.deleteTitle': 'Konfirmasi Hapus',
  'lumen.exportEngine.dk2.deleteBody': 'Apakah Anda yakin akan menghapus dokumen ini?',
  'lumen.exportEngine.dk2.hapus': 'Hapus',
  'lumen.exportEngine.dk2.tambahDokumen': 'Tambah dokumen',
  'lumen.exportEngine.dk2.tableAria': 'Document',
  'lumen.exportEngine.dk3.tambahDokumen': 'Tambah Dokumen',
  'lumen.exportEngine.dk3.seriDokumen': 'Seri Dokumen',
  'lumen.exportEngine.dk3.seriDokumenPlaceholder': 'Seri dokumen',
  'lumen.exportEngine.dk3.jenisDokumen': 'Jenis Dokumen',
  'lumen.exportEngine.dk3.jenisDokumenPlaceholder': 'Pilih jenis dokumen',
  'lumen.exportEngine.dk3.nomorDokumen': 'Nomor Dokumen',
  'lumen.exportEngine.dk3.nomorDokumenPlaceholder': 'Masukkan nomor dokumen',
  'lumen.exportEngine.dk3.tanggalDokumen': 'Tanggal Dokumen',
  'lumen.exportEngine.dk3.fasilitas': 'Fasilitas',
  'lumen.exportEngine.dk3.fasilitasPlaceholder': 'Pilih fasilitas',
  'lumen.exportEngine.dk3.ijin': 'Ijin',
  'lumen.exportEngine.dk3.ijinPlaceholder': 'Masukkan kode ijin',
  'lumen.exportEngine.dk3.batal': 'Batal',
  'lumen.exportEngine.dk3.simpan': 'Simpan',
  'lumen.exportEngine.dk3.notSetTitle': 'Pernyataan belum diatur',
  'lumen.exportEngine.dk3.notSetMessage':
    'Belum ada Pernyataan untuk PPJK Anda. Isi di Master → Pernyataan, lalu sinkronkan lagi.',
  'lumen.exportEngine.dk3.successTitle': 'Berhasil',
  'lumen.exportEngine.dk3.syncSuccess': 'Data pernyataan berhasil disinkronisasi',
  'lumen.exportEngine.dk3.syncFailed': 'Gagal melakukan sinkronisasi data pernyataan',
  'lumen.exportEngine.dk3.title': 'Pernyataan',
  'lumen.exportEngine.dk3.syncing': 'Syncing...',
  'lumen.exportEngine.dk3.syncButton': 'Sync Pernyataan',
  'lumen.exportEngine.dk3.legalHeading': 'Dengan ini saya menyatakan:',
  'lumen.exportEngine.dk3.legal1':
    'Bertanggung jawab atas kebenaran hal-hal yang diberitahukan dalam dokumen ini dan keabsahan dokumen pelengkap pabean yang menjadi dasar pembuatan dokumen ini; dan',
  'lumen.exportEngine.dk3.legal2':
    'Apabila dalam jangka waktu paling lambat 1 (satu) hari setelah tanggal pemberitahuan kesiapan barang, saya tidak hadir untuk menyaksikan pemeriksaan fisik, maka saya menuasakan penyaksian kepada pengusaha TPS dengan resiko dan biaya menjadi tanggung jawab saya.',
  'lumen.exportEngine.dk3.signerHeading': 'Informasi Penandatangan',
  'lumen.exportEngine.dk3.nama': 'Nama',
  'lumen.exportEngine.dk3.tanggal': 'Tanggal',
  'lumen.exportEngine.dk3.tempat': 'Tempat',
  'lumen.exportEngine.dk3.jabatan': 'Jabatan',
  'lumen.exportEngine.en1.npwpKosongTitle': 'NPWP kosong',
  'lumen.exportEngine.en1.npwpKosongMsg': 'Masukkan NPWP eksportir terlebih dahulu.',
  'lumen.exportEngine.en1.npwpBelumLengkapTitle': 'NPWP belum lengkap',
  'lumen.exportEngine.en1.npwpBelumLengkapMsg': 'NPWP harus {count} digit untuk jenis identitas yang dipilih.',
  'lumen.exportEngine.en1.ditarikDariLumen': 'Data eksportir berhasil ditarik dari Lumen.',
  'lumen.exportEngine.en1.ditarikDariProfil': 'Data eksportir berhasil ditarik dari profil perusahaan.',
  'lumen.exportEngine.en1.tidakDitemukanTitle': 'Tidak ditemukan',
  'lumen.exportEngine.en1.tidakDitemukanMsg': 'Tidak ada data untuk NPWP ini.',
  'lumen.exportEngine.en1.gagalTitle': 'Gagal',
  'lumen.exportEngine.en1.gagalMsg': 'Gagal menarik data NPWP. Coba lagi.',
  'lumen.exportEngine.en1.nomorIdentitas': 'Nomor Identitas',
  'lumen.exportEngine.en1.alamat': 'Alamat',
  'lumen.exportEngine.en1.hapus': 'Delete',
  'lumen.exportEngine.en2.eksportir': 'Eksportir',
  'lumen.exportEngine.en2.penerima': 'Penerima',
  'lumen.exportEngine.en2.pembeli': 'Pembeli',
  'lumen.exportEngine.en2.jenis': 'Jenis',
  'lumen.exportEngine.en2.jenisPlaceholder': 'Pilih jenis nomor identitas',
  'lumen.exportEngine.en2.npwpEksportir': 'NPWP Eksportir',
  'lumen.exportEngine.en2.nomorIdentitasPlaceholder': 'Masukkan nomor identitas',
  'lumen.exportEngine.en2.tarikNpwp': 'Tarik data NPWP',
  'lumen.exportEngine.en2.status': 'Status',
  'lumen.exportEngine.en2.namaEksportir': 'Nama Eksportir',
  'lumen.exportEngine.en2.namaEksportirPlaceholder': 'Masukkan nama eksportir',
  'lumen.exportEngine.en2.alamatEksportir': 'Alamat Eksportir',
  'lumen.exportEngine.en2.alamatEksportirPlaceholder': 'Alamat eksportir',
  'lumen.exportEngine.en2.namaPenerima': 'Nama Penerima',
  'lumen.exportEngine.en2.namaPenerimaPlaceholder': 'Masukkan nama penerima',
  'lumen.exportEngine.en2.alamatPenerima': 'Alamat Penerima',
  'lumen.exportEngine.en2.alamatPenerimaPlaceholder': 'Alamat penerima',
  'lumen.exportEngine.en2.negaraPenerima': 'Negara Penerima',
  'lumen.exportEngine.en2.negaraPenerimaPlaceholder': 'Pilih negara penerima',
  'lumen.exportEngine.en2.salinPenerima': 'Salin Penerima',
  'lumen.exportEngine.en2.namaPembeli': 'Nama Pembeli',
  'lumen.exportEngine.en2.namaPembeliPlaceholder': 'Masukkan nama pembeli',
  'lumen.exportEngine.en2.alamatPembeli': 'Alamat Pembeli',
  'lumen.exportEngine.en2.alamatPembeliPlaceholder': 'Alamat pembeli',
  'lumen.exportEngine.en2.negaraPembeli': 'Negara Pembeli',
  'lumen.exportEngine.en2.negaraPembeliPlaceholder': 'Pilih negara pembeli',
  'lumen.exportEngine.en3.ppjk': 'PPJK',
  'lumen.exportEngine.en3.jenisPlaceholder': 'Jenis',
  'lumen.exportEngine.en3.nomorIdentitasPpjk': 'Nomor Identitas PPJK',
  'lumen.exportEngine.en3.nomorIdentitasPpjkPlaceholder': 'Nomor identitas PPJK akan diisi otomatis',
  'lumen.exportEngine.en3.namaPpjk': 'Nama PPJK',
  'lumen.exportEngine.en3.namaPpjkPlaceholder': 'Nama PPJK akan diisi otomatis',
  'lumen.exportEngine.en3.alamatPpjk': 'Alamat PPJK',
  'lumen.exportEngine.en3.alamatPpjkPlaceholder': 'Alamat PPJK akan diisi otomatis',
  'lumen.exportEngine.en3.konsolidasi': 'Pihak Yang Melakukan Konsolidasi',
  'lumen.exportEngine.en3.manageWarehouse': 'Manage Warehouse',
  'lumen.exportEngine.en3.lokasiKonsolidasi': 'Lokasi Konsolidasi',
  'lumen.exportEngine.en3.lokasiBelumTersedia':
    'PPJK Identity Number belum tersedia. Silakan tunggu atau refresh halaman.',
  'lumen.exportEngine.en3.lokasiPlaceholder': 'Pilih warehouse dari daftar...',
  'lumen.exportEngine.en3.kategori': 'Kategori',
  'lumen.exportEngine.en3.kategoriPlaceholder': 'Pilih Kode Kategori',
  'lumen.exportEngine.en3.nomorIdentitasPlaceholder': 'Masukkan Nomor identitas',
  'lumen.exportEngine.en3.nitku': 'NITKU',
  'lumen.exportEngine.en3.nitkuPlaceholder': 'Masukkan NITKU',
  'lumen.exportEngine.en3.namaPlaceholder': 'Masukkan Nama',
  'lumen.exportEngine.en3.alamatKonsolidasi': 'Alamat Konsolidasi',
  'lumen.exportEngine.en3.alamatKonsolidasiPlaceholder': 'Masukkan Alamat Konsolidasi',
  'lumen.exportEngine.en3.total': 'Total: {n}',
  'lumen.exportEngine.en3.salinEksportir': 'Salin Eksportir',
  'lumen.exportEngine.en3.pemilikBarang': 'Pemilik Barang',
  'lumen.exportEngine.en4.npwpDigitAlert': 'NPWP harus {expectedLength} digit untuk jenis identitas yang dipilih',
  'lumen.exportEngine.en4.requiredAlert': 'Mohon lengkapi semua field yang wajib diisi',
  'lumen.exportEngine.en4.title': 'Tambah Pemilik Barang - Eksportir',
  'lumen.exportEngine.en4.jenisIdentitas': 'Jenis Identitas',
  'lumen.exportEngine.en4.jenisIdentitasPlaceholder': 'Pilih jenis identitas',
  'lumen.exportEngine.en4.nomorIdentitas': 'Nomor Identitas',
  'lumen.exportEngine.en4.nomorIdentitasPlaceholder': 'Masukkan nomor identitas',
  'lumen.exportEngine.en4.syncCompanyProfile': 'Sync Company Profile',
  'lumen.exportEngine.en4.namaPemilik': 'Nama Pemilik',
  'lumen.exportEngine.en4.namaPemilikPlaceholder': 'Masukkan nama pemilik',
  'lumen.exportEngine.en4.alamatPemilik': 'Alamat Pemilik',
  'lumen.exportEngine.en4.alamatPemilikPlaceholder': 'Masukkan alamat pemilik',
  'lumen.exportEngine.en4.entitasBarang': 'Entitas Barang',
  'lumen.exportEngine.en4.entitasBarangHint': 'Pilih barang yang dimiliki oleh pemilik ini',
  'lumen.exportEngine.en4.tambah': 'Tambah',
  'lumen.exportEngine.en4.seriBarang': 'Seri Barang',
  'lumen.exportEngine.en4.hsCode': 'HS Code',
  'lumen.exportEngine.en4.uraian': 'Uraian',
  'lumen.exportEngine.en4.aksi': 'Aksi',
  'lumen.exportEngine.en4.emptyTitle': 'Belum ada barang yang dipilih',
  'lumen.exportEngine.en4.emptyHint': 'Klik tombol Tambah untuk memilih barang',
  'lumen.exportEngine.en4.tambahEntitasBarang': 'Tambah Entitas Barang',
  'lumen.exportEngine.en4.pilih': 'Pilih',
  'lumen.exportEngine.en5.manageTitle': 'Manage Consolidation Warehouses',
  'lumen.exportEngine.en5.ppjkNpwpCaption': 'PPJK NPWP: {npwp}',
  'lumen.exportEngine.en5.addWarehouse': 'Add Warehouse',
  'lumen.exportEngine.en5.location': 'Location',
  'lumen.exportEngine.en5.warehouseName': 'Warehouse Name',
  'lumen.exportEngine.en5.nitku': 'NITKU',
  'lumen.exportEngine.en5.loading': 'Loading warehouses...',
  'lumen.exportEngine.en5.empty': 'No warehouses found',
  'lumen.exportEngine.en5.delete': 'Delete',
  'lumen.exportEngine.en5.deleteTitle': 'Delete Warehouse',
  'lumen.exportEngine.en5.deleteBodyBefore': 'Are you sure you want to delete',
  'lumen.exportEngine.en5.deleteBodyAfter': '? This action cannot be undone.',
  'lumen.exportEngine.en5.addTitle': 'Add New Warehouse',
  'lumen.exportEngine.en5.editTitle': 'Edit Warehouse',
  'lumen.exportEngine.en5.consoleLocation': 'Console Location',
  'lumen.exportEngine.en5.consoleLocationPlaceholder': 'Enter location',
  'lumen.exportEngine.en5.category': 'Category',
  'lumen.exportEngine.en5.categoryPlaceholder': 'Select category',
  'lumen.exportEngine.en5.identityType': 'Identity Type',
  'lumen.exportEngine.en5.identityTypePlaceholder': 'Select identity type',
  'lumen.exportEngine.en5.identityNumber': 'Identity Number',
  'lumen.exportEngine.en5.identityNumberPlaceholder': 'Enter identity number',
  'lumen.exportEngine.en5.nitkuPlaceholder': 'Enter NITKU',
  'lumen.exportEngine.en5.warehouseNamePlaceholder': 'Enter warehouse name',
  'lumen.exportEngine.en5.warehouseAddress': 'Warehouse Address',
  'lumen.exportEngine.en5.warehouseAddressPlaceholder': 'Enter warehouse address',
  'lumen.exportEngine.en5.updateWarehouse': 'Update Warehouse',
  'lumen.exportEngine.en5.saveWarehouse': 'Save Warehouse',
  'lumen.exportEngine.pt1.tabHeader': 'Header',
  'lumen.exportEngine.pt1.tabEntitas': 'Entitas',
  'lumen.exportEngine.pt1.tabDokumen': 'Dokumen',
  'lumen.exportEngine.pt1.tabPengangkut': 'Pengangkut',
  'lumen.exportEngine.pt1.tabKemasan': 'Kemasan & Peti Kemas',
  'lumen.exportEngine.pt1.tabTransaksi': 'Transaksi',
  'lumen.exportEngine.pt1.tabBarang': 'Barang',
  'lumen.exportEngine.pt1.tabPernyataan': 'Pernyataan',
  'lumen.exportEngine.pt1.entityEksportir': 'Eksportir',
  'lumen.exportEngine.pt1.entityPenerima': 'Penerima Barang',
  'lumen.exportEngine.pt1.entityPembeli': 'Pembeli',
  'lumen.exportEngine.pt1.entityPpjk': 'PPJK',
  'lumen.exportEngine.pt1.entityKonsolidasi': 'Konsolidasi',
  'lumen.exportEngine.pt1.labelJenisIdentitas': 'Jenis Identitas',
  'lumen.exportEngine.pt1.labelNpwp': 'NPWP',
  'lumen.exportEngine.pt1.labelNama': 'Nama',
  'lumen.exportEngine.pt1.labelAlamat': 'Alamat',
  'lumen.exportEngine.pt1.labelStatus': 'Status',
  'lumen.exportEngine.pt1.labelNegara': 'Negara',
  'lumen.exportEngine.pt1.fieldRequired': '{label} wajib diisi',
  'lumen.exportEngine.pt1.exportirName': 'Nama Eksportir wajib diisi',
  'lumen.exportEngine.pt1.exportirAddress': 'Alamat Eksportir wajib diisi',
  'lumen.exportEngine.pt1.exportirIdentityType': 'Jenis Identitas Eksportir wajib diisi',
  'lumen.exportEngine.pt1.exportirStatus': 'Status Eksportir wajib diisi',
  'lumen.exportEngine.pt1.recipientName': 'Nama Penerima wajib diisi',
  'lumen.exportEngine.pt1.recipientAddress': 'Alamat Penerima wajib diisi',
  'lumen.exportEngine.pt1.recipientCountry': 'Negara Penerima wajib diisi',
  'lumen.exportEngine.pt1.buyerName': 'Nama Pembeli wajib diisi',
  'lumen.exportEngine.pt1.buyerAddress': 'Alamat Pembeli wajib diisi',
  'lumen.exportEngine.pt1.buyerCountry': 'Negara Pembeli wajib diisi',
  'lumen.exportEngine.pt1.ppjkName': 'Nama PPJK wajib diisi',
  'lumen.exportEngine.pt1.ppjkAddress': 'Alamat PPJK wajib diisi',
  'lumen.exportEngine.pt1.ppjkIdentityType': 'Jenis Identitas PPJK wajib diisi',
  'lumen.exportEngine.pt1.ppjkIdentityNumber': 'NPWP PPJK wajib diisi',
  'lumen.exportEngine.pt1.entityHeadingOne': '{name} ({count} field)',
  'lumen.exportEngine.pt1.entityHeadingMany': '{name} ({count} fields)',
  'lumen.exportEngine.pt1.kolomBelumLengkap': 'Terdapat kolom yang belum lengkap',
  'lumen.exportEngine.pt1.hide': 'Hide',
  'lumen.exportEngine.pt1.show': 'Show',
  'lumen.exportEngine.pt1.go': 'Go',
  'lumen.exportEngine.pt1.view': 'View',
  'lumen.exportEngine.pt2.statusSelesai': 'Selesai',
  'lumen.exportEngine.pt2.statusTerkirim': 'Terkirim',
  'lumen.exportEngine.pt2.statusDraft': 'Draft',
  'lumen.exportEngine.pt2.npwpUnavailable': 'PPJK NPWP tidak tersedia',
  'lumen.exportEngine.pt2.ajuCreated': 'Nomor AJU berhasil dibuat',
  'lumen.exportEngine.pt2.ajuCreateFailed': 'Gagal membuat Nomor AJU',
  'lumen.exportEngine.pt2.ajuCopied': 'Nomor AJU berhasil disalin ke clipboard',
  'lumen.exportEngine.pt2.ajuCopyFailed': 'Gagal menyalin Nomor AJU',
  'lumen.exportEngine.pt2.ajuEmpty': 'Nomor AJU tidak boleh kosong',
  'lumen.exportEngine.pt2.ajuMinLength': 'Nomor AJU harus memiliki minimal 20 karakter',
  'lumen.exportEngine.pt2.title': '📋 Nomor AJU - Deklarasi Ekspor',
  'lumen.exportEngine.pt2.loading': 'Memuat...',
  'lumen.exportEngine.pt2.nomorAju': 'Nomor AJU',
  'lumen.exportEngine.pt2.copyAria': 'Salin ke clipboard',
  'lumen.exportEngine.pt2.nomorAjuTerbaru': 'Nomor AJU Terbaru',
  'lumen.exportEngine.pt2.save': 'Save',
  'lumen.exportEngine.pt2.areaHeader': 'Header',
  'lumen.exportEngine.pt2.areaEntitas': 'Entitas',
  'lumen.exportEngine.pt2.areaPengangkut': 'Pengangkut',
  'lumen.exportEngine.pt2.areaTransaksi': 'Transaksi',
  'lumen.exportEngine.pt2.areaKemasan': 'Kemasan & Peti Kemas',
  'lumen.exportEngine.pt2.rangeEmpty': '0 dari 0',
  'lumen.exportEngine.pt2.range': '{from}-{to} dari {total}',
  'lumen.exportEngine.pt2.appliedTitle': 'Data eksportir diterapkan',
  'lumen.exportEngine.pt2.appliedAreas': 'Tab yang diperbarui: {areas}.',
  'lumen.exportEngine.pt2.draftUpdated': 'Draft diperbarui.',
  'lumen.exportEngine.pt2.applyFailed': 'Gagal menerapkan data eksportir',
  'lumen.exportEngine.pt2.failedTitle': 'Gagal',
  'lumen.exportEngine.pt2.dataEksportir': 'Data Eksportir',
  'lumen.exportEngine.pt2.dataEksportirHint':
    'Ambil dari database untuk mengisi Header, Entitas, dan Pengangkut secara otomatis.',
  'lumen.exportEngine.pt2.pilihDariDatabase': 'Pilih dari Database',
  'lumen.exportEngine.pt2.pilihEksportir': 'Pilih Eksportir',
  'lumen.exportEngine.pt2.pilihPerusahaan': 'Pilih perusahaan eksportir yang akan digunakan untuk dokumen ini.',
  'lumen.exportEngine.pt2.searchPlaceholder': 'Cari nama, NPWP, penerima, atau pembeli',
  'lumen.exportEngine.pt2.showing': 'Menampilkan {range}',
  'lumen.exportEngine.pt2.loadFailed': 'Gagal memuat daftar eksportir. Coba muat ulang halaman.',
  'lumen.exportEngine.pt2.noResults': 'Tidak ada eksportir ditemukan',
  'lumen.exportEngine.pt2.sebelumnya': 'Sebelumnya',
  'lumen.exportEngine.pt2.selanjutnya': 'Selanjutnya',
  'lumen.exportEngine.pt2.halaman': 'Halaman',
  'lumen.exportEngine.pt2.dari': 'dari',
  'lumen.exportEngine.pt2.dataBerikutAkan': 'Data berikut akan',
  'lumen.exportEngine.pt2.ditimpa': 'ditimpa',
  'lumen.exportEngine.pt2.overwriteNote1':
    'Pada Header hanya data tetap eksportir yang ditimpa (jenis & kategori ekspor, cara dagang, cara bayar, fasilitas, kantor pabean, pelabuhan muat). Nomor aju, jumlah kontainer, dan data stuffing tetap. Tab',
  'lumen.exportEngine.pt2.dan': 'dan',
  'lumen.exportEngine.pt2.overwriteNote2':
    'hanya diisi pada bagian yang masih kosong — data hasil ekstraksi dokumen tidak akan hilang.',
  'lumen.exportEngine.pt2.terapkan': 'Terapkan',
  'lumen.exportEngine.pt2.pilihKartu': 'Pilih salah satu kartu eksportir di atas untuk melanjutkan.',
  'lumen.exportEngine.fx1.fieldWajibDiisi': 'Field ini wajib diisi',
  'lumen.exportEngine.fx2.labelWithCurrency': '{label} - {currency}',
  // lumen.bc23Engine (revamp PR 8b)
  'lumen.bc23Engine.br1.titleError': 'Error',
  'lumen.bc23Engine.br1.titleSuccess': 'Success',
  'lumen.bc23Engine.br1.gagalHapusDokumen': 'Gagal menghapus dokumen',
  'lumen.bc23Engine.br1.noItemsSelected': 'No items selected',
  'lumen.bc23Engine.br1.updatedOne': 'Successfully updated {count} item',
  'lumen.bc23Engine.br1.updatedMany': 'Successfully updated {count} items',
  'lumen.bc23Engine.br1.bulkEditFailed': 'Bulk edit failed',
  'lumen.bc23Engine.br1.fetchHsFailed': 'Failed to fetch HS code details',
  'lumen.bc23Engine.br1.fetchHsError': 'Error fetching HS code details',
  'lumen.bc23Engine.br2.colJSatuan': 'J. Satuan',
  'lumen.bc23Engine.br2.colTotalDokumen': 'Total Dokumen',
  'lumen.bc23Engine.br2.selectAllAria': 'Select all items',
  'lumen.bc23Engine.br2.selectRowAria': 'Select item',
  'lumen.bc23Engine.br2.lihatDokumenAria': 'View documents',
  'lumen.bc23Engine.br4.noItemsToSync': 'No items to sync',
  'lumen.bc23Engine.br4.processIdMissing': 'Process ID tidak tersedia. Silakan muat ulang halaman.',
  'lumen.bc23Engine.br4.tariffsUpdated': 'Tariffs updated for {count} items',
  'lumen.bc23Engine.br4.titleInfo': 'Info',
  'lumen.bc23Engine.br4.noTariffYet': 'No tariff data available yet. Tariffs will be calculated on submit.',
  'lumen.bc23Engine.br4.saveBeforeSyncFailed': 'Failed to save barang data before sync',
  'lumen.bc23Engine.br4.refreshTariffFailed': 'Failed to refresh tariff data. Please reload page if needed.',
  'lumen.bc23Engine.br4.syncFailed': 'Failed to sync tariff and LARTAS data',
  'lumen.bc23Engine.br5.itemUpdatedApplied':
    'Item updated and changes applied to {count} items with same HS code or empty HS code',
  'lumen.bc23Engine.br5.itemUpdatedNoMatch':
    'Item updated. No other items had matching or empty HS codes to apply changes to.',
  'lumen.bc23Engine.br5.saveChangesFailed': 'Failed to save changes to server. Please try again.',
  'lumen.bc23Engine.br5.itemAdded': 'Item added successfully',
  'lumen.bc23Engine.br5.saveNewItemFailed': 'Failed to save new item to server. Please try again.',
  'lumen.bc23Engine.br6.hapusBarang': 'Hapus Barang',
  'lumen.bc23Engine.br6.tindakanTidakDapatDibatalkan': 'Tindakan ini tidak dapat dibatalkan',
  'lumen.bc23Engine.br6.yakinHapusBarang': 'Anda yakin ingin menghapus barang berikut?',
  'lumen.bc23Engine.br6.seriColon': 'Seri:',
  'lumen.bc23Engine.br6.uraianColon': 'Uraian:',
  'lumen.bc23Engine.br6.hsCodeColon': 'HS Code:',
  'lumen.bc23Engine.br6.hapus': 'Hapus',
  'lumen.bc23Engine.br6.dokumenTerlampir': 'Dokumen Terlampir',
  'lumen.bc23Engine.br6.seriInfoLine': 'Seri {seri}: {uraian}',
  'lumen.bc23Engine.br6.dokumenFallback': 'Dokumen {kode}',
  'lumen.bc23Engine.br6.colSeri': 'Seri',
  'lumen.bc23Engine.br6.colJenisDokumen': 'Jenis Dokumen',
  'lumen.bc23Engine.br6.colKode': 'Kode',
  'lumen.bc23Engine.br6.colNomorDokumen': 'Nomor Dokumen',
  'lumen.bc23Engine.br6.colTanggal': 'Tanggal',
  'lumen.bc23Engine.br6.colKodeFasilitas': 'Kode Fasilitas',
  'lumen.bc23Engine.br6.colNamaFasilitas': 'Nama Fasilitas',
  'lumen.bc23Engine.br6.colKodeIjin': 'Kode Ijin',
  'lumen.bc23Engine.br6.colAction': 'Action',
  'lumen.bc23Engine.br6.hapusDokumenAria': 'Hapus dokumen',
  'lumen.bc23Engine.br6.tidakAdaDokumen': 'Tidak ada dokumen yang terlampir pada barang ini',
  'lumen.bc23Engine.br6.tambahBarang': 'Tambah Barang',
  'lumen.bc23Engine.br6.editBarang': 'Edit Barang',
  'lumen.bc23Engine.br7.syncing': 'Syncing...',
  'lumen.bc23Engine.br7.syncLartasTarif': 'Sync Lartas & Tarif',
  'lumen.bc23Engine.br7.clearSearch': 'Hapus pencarian',
  'lumen.bc23Engine.br7.tableLabel': 'Daftar barang',
  'lumen.bc23Engine.dk1.successTitle': 'Success',
  'lumen.bc23Engine.dk1.errorTitle': 'Error',
  'lumen.bc23Engine.dk1.documentAdded': 'Document added successfully',
  'lumen.bc23Engine.dk1.documentUpdated': 'Document updated successfully',
  'lumen.bc23Engine.dk1.saveNewFailed': 'Failed to save new document',
  'lumen.bc23Engine.dk1.saveEditedFailed': 'Failed to save edited document',
  'lumen.bc23Engine.dk2.successTitle': 'Success',
  'lumen.bc23Engine.dk2.errorTitle': 'Error',
  'lumen.bc23Engine.dk2.orderAlreadyCorrect': 'Document order is already correct',
  'lumen.bc23Engine.dk2.orderUpdated': 'Document order updated successfully',
  'lumen.bc23Engine.dk2.orderSaveFailed': 'Failed to save document order',
  'lumen.bc23Engine.dk2.documentCopied': 'Document copied successfully',
  'lumen.bc23Engine.dk2.copyFailed': 'Failed to save copied document',
  'lumen.bc23Engine.dk2.documentDeleted': 'Document deleted successfully',
  'lumen.bc23Engine.dk2.deleteFailed': 'Failed to save changes after deleting document',
  'lumen.bc23Engine.dk2.colSeri': 'Seri',
  'lumen.bc23Engine.dk2.colJenis': 'Jenis',
  'lumen.bc23Engine.dk2.colEcooStatus': 'eCOO Status',
  'lumen.bc23Engine.dk2.colNomor': 'Nomor',
  'lumen.bc23Engine.dk2.colTanggal': 'Tanggal',
  'lumen.bc23Engine.dk2.colFasilitas': 'Fasilitas',
  'lumen.bc23Engine.dk2.colKodeIjin': 'Kode Ijin',
  'lumen.bc23Engine.dk2.colAttached': 'Attached',
  'lumen.bc23Engine.dk2.colAksi': 'Aksi',
  'lumen.bc23Engine.dk2.actionAttachToBarang': 'Attach to Barang',
  'lumen.bc23Engine.dk2.actionEdit': 'Edit',
  'lumen.bc23Engine.dk2.actionCopy': 'Copy',
  'lumen.bc23Engine.dk2.actionDelete': 'Delete',
  'lumen.bc23Engine.dk3.attachTitle': 'Attach Document to Barang',
  'lumen.bc23Engine.dk3.attachIntro': 'Select which barang items this document should be attached to:',
  'lumen.bc23Engine.dk3.selectAllAria': 'Select all barang',
  'lumen.bc23Engine.dk3.selectRowAria': 'Select barang {seri}',
  'lumen.bc23Engine.dk3.colSeriBarang': 'Seri Barang',
  'lumen.bc23Engine.dk3.colHsCode': 'HS Code',
  'lumen.bc23Engine.dk3.colNamaBarang': 'Nama Barang',
  'lumen.bc23Engine.dk3.unnamed': 'UNNAMED',
  'lumen.bc23Engine.dk3.noBarang': 'No barang items available. Please add barang items first.',
  'lumen.bc23Engine.dk3.urutkanOtomatis': 'Urutkan Otomatis',
  'lumen.bc23Engine.dk3.tambahDokumen': 'Tambah dokumen',
  'lumen.bc23Engine.dk3.tableAria': 'Dokumen',
  'lumen.bc23Engine.eb2.simpanPerubahan': 'Simpan Perubahan',
  'lumen.bc23Engine.eb3.nonLartas': 'NON-LARTAS',
  'lumen.bc23Engine.eb5.kodeJenisBm': 'Kode Jenis BM',
  'lumen.bc23Engine.eb5.tarifBm': 'Tarif BM (%)',
  'lumen.bc23Engine.eb5.tarifBmPlaceholder': 'Type decimal like 2.5',
  'lumen.bc23Engine.eb5.jenisTarifBm': 'Jenis Tarif BM',
  'lumen.bc23Engine.eb5.fasilitasTarifBm': 'Fasilitas Tarif BM',
  'lumen.bc23Engine.eb5.tarifPpn': 'Tarif PPN (%)',
  'lumen.bc23Engine.eb5.tarifPpnPlaceholder': 'Type decimal like 11.5',
  'lumen.bc23Engine.eb5.fasilitasPpn': 'Fasilitas PPN',
  'lumen.bc23Engine.eb5.tarifPph': 'Tarif PPH (%)',
  'lumen.bc23Engine.eb5.tarifPphPlaceholder': 'Type decimal like 2.5',
  'lumen.bc23Engine.eb5.fasilitasPph': 'Fasilitas PPH',
  'lumen.bc23Engine.eb5.bmt': 'BMT',
  'lumen.bc23Engine.eb5.bmad': 'BMAD',
  'lumen.bc23Engine.eb5.bmtp': 'BMTP',
  'lumen.bc23Engine.eb5.bmi': 'BMI',
  'lumen.bc23Engine.eb5.sementara': 'Sementara',
  'lumen.bc23Engine.eb5.select': 'Select',
  'lumen.bc23Engine.eb5.tarifAria': 'Tarif',
  'lumen.bc23Engine.eb5.cukai': 'Cukai',
  'lumen.bc23Engine.eb5.komoditi': 'Komoditi',
  'lumen.bc23Engine.eb5.komoditiOption': '3 - HASIL TEMBAKAU',
  'lumen.bc23Engine.eb5.bosarTarif': 'Bosar Tarif',
  'lumen.bc23Engine.eb5.jumlah': 'Jumlah',
  'lumen.bc23Engine.eb5.nilaiCukai': 'Nilai Cukai',
  'lumen.bc23Engine.eb5.hjeRp': 'HJE RP',
  'lumen.bc23Engine.eb5.satuanKemasan': 'Satuan Kemasan',
  'lumen.bc23Engine.eb5.isiPerKemasan': 'Isi Per Kemasan',
  'lumen.bc23Engine.eb5.jumlahPitaCukai': 'Jumlah Pita Cukai',
  'lumen.bc23Engine.eb5.saldoAwal': 'Saldo Awal',
  'lumen.bc23Engine.eb5.saldoAkhir': 'Saldo Akhir',
  'lumen.bc23Engine.he1.fieldJenis': 'Jenis',
  'lumen.bc23Engine.he1.fieldNpwp': 'NPWP {title}',
  'lumen.bc23Engine.he1.fieldNama': 'Nama {title}',
  'lumen.bc23Engine.he1.fieldNegara': 'Negara {title}',
  'lumen.bc23Engine.he1.fieldAlamat': 'Alamat {title}',
  'lumen.bc23Engine.he1.fieldAfiliasi': 'Afiliasi',
  'lumen.bc23Engine.he1.nitku': 'NITKU',
  'lumen.bc23Engine.he1.optAfl': 'AFL - Affiliated Company',
  'lumen.bc23Engine.he1.optCtr': 'CTR - Financial/legally controlled',
  'lumen.bc23Engine.he1.optFam': 'FAM - Family member',
  'lumen.bc23Engine.he1.optTah': 'TAH - Tidak berhubungan',
  'lumen.bc23Engine.he2.titleImportir': 'Importir/Pengusaha TPB',
  'lumen.bc23Engine.he2.fieldJenis': 'Jenis',
  'lumen.bc23Engine.he2.fieldNpwpImportir': 'NPWP Importir',
  'lumen.bc23Engine.he2.fieldNamaImportir': 'Nama Importir',
  'lumen.bc23Engine.he2.fieldStatus': 'Status',
  'lumen.bc23Engine.he2.fieldApiNib': 'API/NIB',
  'lumen.bc23Engine.he2.fieldNib': 'NIB',
  'lumen.bc23Engine.he2.fieldAlamatImportir': 'Alamat Importir',
  'lumen.bc23Engine.he2.fieldNomorIzinTpb': 'Nomor Izin TPB',
  'lumen.bc23Engine.he2.fieldTanggalSkepTpb': 'Tanggal Skep TPB',
  'lumen.bc23Engine.he2.searchByNpwp': 'Cari data Importir berdasarkan NPWP',
  'lumen.bc23Engine.he2.searchByName': 'Cari data Importir berdasarkan nama',
  'lumen.bc23Engine.he3.pemasok': 'Pemasok',
  'lumen.bc23Engine.he3.pemilikBarang': 'Pemilik Barang',
  'lumen.bc23Engine.he3.ppjk': 'PPJK',
  'lumen.bc23Engine.he4.pelabuhanBongkar': 'Pelabuhan Bongkar',
  'lumen.bc23Engine.he4.pilihPelabuhanBongkar': 'Pilih pelabuhan bongkar',
  'lumen.bc23Engine.he4.tujuan': 'Tujuan',
  'lumen.bc23Engine.he4.pilihTujuan': 'Pilih tujuan',
  'lumen.bc23Engine.he4.kantorPabeanBongkar': 'Kantor Pabean Bongkar',
  'lumen.bc23Engine.he4.pilihKantorPabeanBongkar': 'Pilih kantor pabean bongkar',
  'lumen.bc23Engine.he4.kantorPabeanPengawas': 'Kantor Pabean Pengawas',
  'lumen.bc23Engine.he4.pilihKantorPabeanPengawas': 'Pilih kantor pabean pengawas',
  'lumen.bc23Engine.he4.colPungutan': 'Pungutan',
  'lumen.bc23Engine.he4.colDibayar': 'Dibayar',
  'lumen.bc23Engine.he4.colDitanggungPemerintah': 'Ditanggung Pemerintah',
  'lumen.bc23Engine.he4.colDitunda': 'Ditunda',
  'lumen.bc23Engine.he4.colTidakDipungut': 'Tidak Dipungut',
  'lumen.bc23Engine.he4.colDibebaskan': 'Dibebaskan',
  'lumen.bc23Engine.he4.colSudahDilunasi': 'Sudah Dilunasi',
  'lumen.bc23Engine.he4.title': 'Pungutan',
  'lumen.bc23Engine.he4.emptyTitle': 'No data available',
  'lumen.bc23Engine.he4.emptyDescription': 'There are no records to display at the moment.',
  'lumen.bc23Engine.pg5.downloadExcel': 'Download Excel',
  'lumen.bc23Engine.pg5.uploadExcel': 'Upload Excel',
  'lumen.bc23Engine.pg5.updateDraftCeisa': 'Update DRAFT ke CEISA',
  'lumen.bc23Engine.pg5.submitDraftCeisa': 'Submit DRAFT ke CEISA',
  'lumen.bc23Engine.pg5.idHeaderNotFound': 'ID Header tidak ditemukan',
  'lumen.bc23Engine.pg5.draftPibDownloaded': 'Draft PIB berhasil diunduh',
  'lumen.bc23Engine.pg5.draftPibDownloadFailed': 'Gagal mengunduh Draft PIB',
  'lumen.bc23Engine.pg7.securityTitle': 'Secure & Private',
  'lumen.bc23Engine.pg7.securityBody': 'Your data is encrypted & belongs to you',
  'lumen.bc23Engine.pg7.editItems': 'Edit {count} Items',
  'lumen.bc23Engine.pk1.vesselNameRequired': 'Please enter a vessel name first',
  'lumen.bc23Engine.pk1.flagFound': 'Flag found: {flag}',
  'lumen.bc23Engine.pk1.warningTitle': 'Warning',
  'lumen.bc23Engine.pk1.flagNotFound': 'No flag information found for this vessel',
  'lumen.bc23Engine.pk1.flagFetchFailed': 'Failed to fetch vessel flag information',
  'lumen.bc23Engine.pk1.docNotFoundTitle': 'Document Not Found',
  'lumen.bc23Engine.pk1.docNotFoundMsg': 'No B/L (705) document found. Please add a B/L document first.',
  'lumen.bc23Engine.pk1.docIncompleteTitle': 'Incomplete Document',
  'lumen.bc23Engine.pk1.docIncompleteMsg': 'B/L document must have both number and date.',
  'lumen.bc23Engine.pk1.manifestSuccessMsg': 'Manifest BC 1.1 data retrieved successfully',
  'lumen.bc23Engine.pk1.apiErrorTitle': 'API Error',
  'lumen.bc23Engine.pk1.manifestRetrieveFailed': 'Failed to retrieve manifest data',
  'lumen.bc23Engine.pk1.manifestCallFailed': 'Failed to call Manifest BC 1.1 API. Please try again.',
  'lumen.bc23Engine.pk1.tpsRequired': 'Tempat penimbunan wajib dipilih',
  'lumen.bc23Engine.pk2.manifestBc11': 'Manifest BC 1.1',
  'lumen.bc23Engine.pk2.loadingData': 'Loading data...',
  'lumen.bc23Engine.pk2.flagNameFromApi': 'Flag name from API:',
  'lumen.bc23Engine.pk2.portOfLoadingFromApi': 'Port of loading from API:',
  'lumen.bc23Engine.pk2.useThisValue': 'Use this value',
  'lumen.bc23Engine.pk3.seri': 'Seri',
  'lumen.bc23Engine.pk3.jumlah': 'Jumlah',
  'lumen.bc23Engine.pk3.jenis': 'Jenis',
  'lumen.bc23Engine.pk3.merek': 'Merek',
  'lumen.bc23Engine.pk3.aksi': 'Aksi',
  'lumen.bc23Engine.pk3.edit': 'Edit',
  'lumen.bc23Engine.pk3.copy': 'Copy',
  'lumen.bc23Engine.pk3.delete': 'Delete',
  'lumen.bc23Engine.pk4.seri': 'Seri',
  'lumen.bc23Engine.pk4.nomor': 'Nomor',
  'lumen.bc23Engine.pk4.ukuran': 'Ukuran',
  'lumen.bc23Engine.pk4.jenis': 'Jenis',
  'lumen.bc23Engine.pk4.tipe': 'Tipe',
  'lumen.bc23Engine.pk4.aksi': 'Aksi',
  'lumen.bc23Engine.pk4.edit': 'Edit',
  'lumen.bc23Engine.pk4.copy': 'Copy',
  'lumen.bc23Engine.pk4.delete': 'Delete',
  'lumen.bc23Engine.pk4.kemasan': 'Kemasan',
  'lumen.bc23Engine.pk4.petiKemas': 'Peti Kemas',
  'lumen.bc23Engine.pk4.tambahKemasan': 'Tambah Kemasan',
  'lumen.bc23Engine.pk4.tambahPetiKemas': 'Tambah Peti Kemas',
  'lumen.bc23Engine.pk6.warningTitle': 'Warning',
  'lumen.bc23Engine.pk6.ndpbmRetrieveFailed': 'Could not retrieve NDPBM value. Please enter manually.',
  'lumen.bc23Engine.pk6.errorTitle': 'Error',
  'lumen.bc23Engine.pk6.ndpbmFetchFailed': 'Error when fetching NDPBM',
  'lumen.bc23Engine.pk7.harga': 'Harga',
  'lumen.bc23Engine.pk7.warningPastikanValuta': 'Harap pastikan valuta sudah benar',
  'lumen.bc23Engine.pk7.valuta': 'Valuta',
  'lumen.bc23Engine.pk7.pilihValuta': 'Pilih Valuta',
  'lumen.bc23Engine.pk7.ndpbm': 'NDPBM',
  'lumen.bc23Engine.pk7.jenisTransaksi': 'Jenis Transaksi',
  'lumen.bc23Engine.pk7.pilihJenisTransaksi': 'Pilih Jenis Transaksi',
  'lumen.bc23Engine.pk7.incoterm': 'Incoterm',
  'lumen.bc23Engine.pk7.pilihIncoterm': 'Pilih Incoterm',
  'lumen.bc23Engine.pk7.hargaBarang': 'Harga Barang',
  'lumen.bc23Engine.pk7.nilaiPabeanRupiah': 'Nilai Pabean dalam Rupiah',
  'lumen.bc23Engine.pk7.informasiKomponenBiaya': 'Informasi Komponen Biaya',
  'lumen.bc23Engine.pk7.hargaLainnya': 'Harga Lainnya',
  'lumen.bc23Engine.pk7.biayaPenambahanCurrency': 'Biaya penambahan - {currency}',
  'lumen.bc23Engine.pk7.biayaPengurangCurrency': 'Biaya pengurang - {currency}',
  'lumen.bc23Engine.pk7.freightCurrency': 'Freight - {currency}',
  'lumen.bc23Engine.pk7.asuransi': 'Asuransi',
  'lumen.bc23Engine.pk7.nilaiAsuransiCurrency': 'Nilai Asuransi - {currency}',
  'lumen.bc23Engine.pk7.voluntaryDeclaration': 'Voluntary declaration',
  'lumen.bc23Engine.pk7.berat': 'Berat',
  'lumen.bc23Engine.pk7.beratKotor': 'Berat Kotor (KGM)',
  'lumen.bc23Engine.pk7.beratBersih': 'Berat Bersih (KGM)',
  'lumen.bc23Engine.pk7.keteranganPajak': 'Keterangan Pajak',
  'lumen.bc23Engine.pk7.jasaKenaPajak': 'Jasa Kena Pajak',
  'lumen.bc23Engine.pk7.jasaPembelianBkp': '1 - PEMBELIAN BKP',
  'lumen.bc23Engine.pk7.jasaPenerimaBkp': '2 - PENERIMA JASA BKP',
  'lumen.bc23Engine.pk9.assistTip':
    "Pengisian kolom 'nilai pasti' dilakukan apabila nilai komponen sudah dapat diketahui pada saat importasi dan belum termasuk ke dalam harga invoice. Pengisian kolom 'Nilai Perkiraan (VD)' dilakukan apabila nilai komponen belum dapat diketahui kepastiannya pada saat importasi, pengisian dapat dilakukan di masing-masing detail barang / seri barang dengan menggunakan mekanisme VD.",
  'lumen.bc23Engine.pk9.royaltiTip':
    "Royalti adalah pembayaran atas hak cipta, paten dan sejenisnya, sedangkan lisensi adalah pembayaran atas hak penggunaan suatu teknologi atau merek. Pengisian kolom 'nilai pasti' dilakukan apabila nilai komponen sudah dapat diketahui pada saat importasi dan belum termasuk ke dalam harga invoice. Pengisian kolom 'Nilai Perkiraan (VD)' dilakukan apabila nilai komponen belum dapat diketahui kepastiannya pada saat importasi, pengisian dapat dilakukan di masing-masing detail barang / seri barang dengan menggunakan mekanisme VD.",
  'lumen.bc23Engine.pk9.proceedsTip':
    "Proceeds merupakan bagian hasil dari penjualan kembali, pelepasan atau penggunaan yang wajib disetor kepada penjual. Pengisian kolom 'nilai pasti' dilakukan apabila nilai komponen sudah dapat diketahui pada saat importasi dan belum termasuk ke dalam harga invoice. Pengisian kolom 'Nilai Perkiraan (VD)' dilakukan apabila nilai komponen belum dapat diketahui kepastiannya pada saat importasi, pengisian dapat dilakukan di masing-masing detail barang / seri barang dengan menggunakan mekanisme VD.",
  'lumen.bc23Engine.pk9.transportTip':
    "Isikan biaya transportasi / freight dan biaya pemuatan, pembongkaran dan penanganan yang belum termasuk ke dalam biaya transportasi. Pengisian kolom 'nilai pasti' dilakukan apabila nilai komponen sudah dapat diketahui pada saat importasi dan belum termasuk ke dalam harga invoice. Pengisian kolom 'Nilai Perkiraan (VD)' dilakukan apabila nilai komponen belum dapat diketahui kepastiannya pada saat importasi, pengisian dapat dilakukan di masing-masing detail barang / seri barang dengan menggunakan mekanisme VD.",
  'lumen.bc23Engine.pk9.asuransiTip':
    "Pilih jenis asuransi, dalam negeri atau luar negeri. Kemudian isikan nilai asuransi pada kolom sebelah kanan. Pengisian kolom 'nilai pasti' dilakukan apabila nilai komponen sudah dapat diketahui pada saat importasi dan belum termasuk ke dalam harga invoice. Pengisian kolom 'Nilai Perkiraan (VD)' dilakukan apabila nilai komponen belum dapat diketahui kepastiannya pada saat importasi, pengisian dapat dilakukan di masing-masing detail barang / seri barang dengan menggunakan mekanisme VD.",
  'lumen.bc23Engine.pt1.tabHeader': 'Header',
  'lumen.bc23Engine.pt1.tabEntitas': 'Entitas',
  'lumen.bc23Engine.pt1.tabDokumen': 'Dokumen',
  'lumen.bc23Engine.pt1.tabPengangkut': 'Pengangkut',
  'lumen.bc23Engine.pt1.tabKemasan': 'Kemasan & Peti Kemas',
  'lumen.bc23Engine.pt1.tabTransaksi': 'Transaksi',
  'lumen.bc23Engine.pt1.tabBarang': 'Barang',
  'lumen.bc23Engine.pt1.tabPungutan': 'Pungutan',
  'lumen.bc23Engine.pt1.tabPernyataan': 'Pernyataan',
  'lumen.bc23Engine.pt1.errorsBadge': '{count} ERRORS',
  'lumen.bc23Engine.pt1.botAssistAria': 'Bantuan bot',
  'lumen.bc23Engine.pt3.showPdf': 'Show PDF',
  'lumen.bc23Engine.pt3.iframeTitle': 'PDF Viewer - {name}',
  // lumen.account (revamp PR 9a)
  'lumen.account.reviewer.loading': 'Loading...',
  'lumen.account.reviewer.loadFailed': 'Failed to load requests.',
  'lumen.account.reviewer.statTotal': 'Total Requests',
  'lumen.account.reviewer.statPending': 'Pending Review',
  'lumen.account.reviewer.statApproved': 'Approved',
  'lumen.account.reviewer.statNeedRevision': 'Need Revision',
  'lumen.account.reviewer.statusWaiting': 'Pending Review',
  'lumen.account.reviewer.statusApproved': 'Approved',
  'lumen.account.reviewer.statusNeedRevision': 'Need Revision',
  'lumen.account.reviewer.statusRejected': 'Rejected',
  'lumen.account.reviewer.statusInvalidated': 'Invalidated',
  'lumen.account.reviewer.statusScheduled': 'Scheduled',
  'lumen.account.reviewer.colAju': 'AJU Number',
  'lumen.account.reviewer.colVersion': 'Version',
  'lumen.account.reviewer.colRequestedBy': 'Requested By',
  'lumen.account.reviewer.colRequestedAt': 'Requested At',
  'lumen.account.reviewer.review': 'Review',
  'lumen.account.reviewer.dashboardTitle': 'Reviewer Dashboard',
  'lumen.account.reviewer.dashboardDescription': 'Review and approve AJU document requests',
  'lumen.account.reviewer.allRequests': 'All Requests',
  'lumen.account.reviewer.noRequests': 'No approval requests found.',
  'lumen.account.reviewer.colDescription': 'Description',
  'lumen.account.reviewer.colEmailCount': 'Jumlah Email',
  'lumen.account.reviewer.viewGroup': 'View group',
  'lumen.account.reviewer.editGroup': 'Edit group',
  'lumen.account.reviewer.editEmail': 'Edit email',
  'lumen.account.reviewer.toggleStatus': 'Toggle email status',
  'lumen.account.reviewer.active': 'Active',
  'lumen.account.reviewer.inactive': 'Inactive',
  'lumen.account.reviewer.emailGroupsTitle': 'Email Groups',
  'lumen.account.reviewer.emailGroupsDescription': 'Kelola grup email untuk pengiriman approval AJU draft.',
  'lumen.account.reviewer.addGroup': 'Tambah Group',
  'lumen.account.reviewer.editGroupTitle': 'Edit Group',
  'lumen.account.reviewer.groupNamePlaceholder': 'Group name',
  'lumen.account.reviewer.groupDescriptionPlaceholder': 'Group description',
  'lumen.account.reviewer.cancel': 'Batal',
  'lumen.account.reviewer.update': 'Update',
  'lumen.account.reviewer.save': 'Simpan',
  'lumen.account.reviewer.groupDetail': 'Group Detail',
  'lumen.account.reviewer.editEmailTitle': 'Edit Email',
  'lumen.account.reviewer.addEmail': 'Tambah Email',
  'lumen.account.reviewer.recipientPlaceholder': 'Recipient name',
  'lumen.account.reviewer.emailPlaceholder': 'email@example.com',
  'lumen.account.reviewer.toolPencil': 'Pencil',
  'lumen.account.reviewer.toolRectangle': 'Rectangle',
  'lumen.account.reviewer.toolCircle': 'Circle',
  'lumen.account.reviewer.toolArrow': 'Arrow',
  'lumen.account.reviewer.toolText': 'Text',
  'lumen.account.reviewer.stopTool': 'Stop {tool}',
  'lumen.account.reviewer.undo': 'Undo last stroke',
  'lumen.account.reviewer.clear': 'Clear all annotations',
  'lumen.account.reviewer.zoomOut': 'Zoom out',
  'lumen.account.reviewer.zoomIn': 'Zoom in',
  'lumen.account.reviewer.notFound': 'Request not found.',
  'lumen.account.reviewer.backToDashboard': 'Back to Dashboard',
  'lumen.account.reviewer.noAju': 'No AJU Number',
  'lumen.account.reviewer.requestMeta': 'Version {version} · Requested by {name}',
  'lumen.account.reviewer.pdfFailed': 'Failed to load PDF',
  'lumen.account.reviewer.pdfLoading': 'Loading document...',
  'lumen.account.reviewer.reviewResult': 'Review Result',
  'lumen.account.reviewer.reviewActions': 'Review Actions',
  'lumen.account.reviewer.notes': 'Notes',
  'lumen.account.reviewer.checklist': 'Revision Checklist',
  'lumen.account.reviewer.reviewedOn': 'Reviewed on {date}',
  'lumen.account.reviewer.itemPlaceholder': 'Item {n}',
  'lumen.account.reviewer.removeItem': 'Remove item',
  'lumen.account.reviewer.addItem': 'Add item',
  'lumen.account.reviewer.notesPlaceholder': 'Add notes (optional)',
  'lumen.account.reviewer.approve': 'Approve',
  'lumen.account.reviewer.needRevision': 'Need Revision',
  'lumen.account.reviewer.textPlaceholder': 'Type here...',
  'lumen.account.support.allPriorities': 'All Priorities',
  'lumen.account.support.allStatuses': 'All Statuses',
  'lumen.account.support.attachmentsHint':
    'Maksimal 10MB per file. Format yang didukung: gambar, PDF, dokumen, file teks',
  'lumen.account.support.attachmentsLabel': 'Lampiran (Opsional)',
  'lumen.account.support.attachmentsPrompt': 'Unggah screenshot, log, atau file lainnya',
  'lumen.account.support.autoCloseNote': 'Jendela ini akan tertutup otomatis dalam beberapa detik',
  'lumen.account.support.buttonLabel': 'Need Help? Create Support Ticket',
  'lumen.account.support.cancel': 'Batal',
  'lumen.account.support.categoryAccount': 'Masalah Akun',
  'lumen.account.support.categoryBilling': 'Masalah Billing',
  'lumen.account.support.categoryBug': 'Laporan Bug',
  'lumen.account.support.categoryColon': 'Kategori:',
  'lumen.account.support.categoryFallback': 'General',
  'lumen.account.support.categoryFeature': 'Permintaan Fitur',
  'lumen.account.support.categoryGeneral': 'Dukungan Umum',
  'lumen.account.support.categoryLabel': 'Kategori',
  'lumen.account.support.categoryPickPlaceholder': 'Pilih kategori',
  'lumen.account.support.categoryTechnical': 'Masalah Teknis',
  'lumen.account.support.centerTitle': 'Pusat Dukungan',
  'lumen.account.support.clearFiles': 'Hapus lampiran',
  'lumen.account.support.close': 'Tutup',
  'lumen.account.support.createFirst': 'Buat Tiket Pertama Anda',
  'lumen.account.support.descriptionLabel': 'Deskripsi',
  'lumen.account.support.descriptionPlaceholder': 'Harap berikan informasi detail tentang masalah Anda...',
  'lumen.account.support.descriptionRequired': 'Description is required',
  'lumen.account.support.detailHeading': 'Detail Tiket:',
  'lumen.account.support.emptyTitle': 'Tidak ada tiket dukungan ditemukan',
  'lumen.account.support.filterHigh': 'High',
  'lumen.account.support.filterLow': 'Low',
  'lumen.account.support.filterMedium': 'Medium',
  'lumen.account.support.filterUrgent': 'Urgent',
  'lumen.account.support.helpBody':
    'Jelaskan masalah Anda di bawah dan tim dukungan kami akan membantu. Sertakan detail sebanyak mungkin untuk membantu kami menyelesaikan permintaan Anda dengan cepat.',
  'lumen.account.support.helpTitle': 'Butuh Bantuan?',
  'lumen.account.support.invalidDate': 'Invalid date',
  'lumen.account.support.loading': 'Memuat...',
  'lumen.account.support.na': 'N/A',
  'lumen.account.support.noTitle': 'No title',
  'lumen.account.support.priorityColon': 'Prioritas:',
  'lumen.account.support.priorityHigh': 'Tinggi',
  'lumen.account.support.priorityLabel': 'Prioritas',
  'lumen.account.support.priorityLow': 'Rendah',
  'lumen.account.support.priorityMedium': 'Sedang',
  'lumen.account.support.priorityPickPlaceholder': 'Pilih prioritas',
  'lumen.account.support.priorityPlaceholder': 'Filter berdasarkan prioritas',
  'lumen.account.support.priorityUrgent': 'Mendesak',
  'lumen.account.support.searchPlaceholder': 'Cari tiket...',
  'lumen.account.support.statusClosed': 'Closed',
  'lumen.account.support.statusColon': 'Status:',
  'lumen.account.support.statusInProgress': 'In Progress',
  'lumen.account.support.statusOpen': 'Open',
  'lumen.account.support.statusPlaceholder': 'Filter berdasarkan status',
  'lumen.account.support.statusResolved': 'Resolved',
  'lumen.account.support.statusUnknown': 'Unknown',
  'lumen.account.support.submit': 'Buat Tiket',
  'lumen.account.support.submitting': 'Membuat...',
  'lumen.account.support.successDialogTitle': 'Tiket Dukungan Dibuat',
  'lumen.account.support.successFollowUp': 'Tim dukungan kami akan meninjau permintaan Anda dan segera merespons.',
  'lumen.account.support.successIntro': 'Tiket dukungan Anda telah dibuat dan diberikan nomor tiket:',
  'lumen.account.support.successTitle': 'Tiket Berhasil Dibuat!',
  'lumen.account.support.tabCreate': 'Buat Baru',
  'lumen.account.support.tabHistory': 'Tiket Saya',
  'lumen.account.support.titleLabel': 'Judul',
  'lumen.account.support.titlePlaceholder': 'Deskripsi singkat masalah Anda',
  'lumen.account.support.titleRequired': 'Title is required',
  'lumen.account.support.viewTicket': 'Lihat tiket',
  'lumen.account.support.assigned': 'Assigned: {name}',
  'lumen.account.support.attachFile': 'Lampirkan file',
  'lumen.account.support.attachmentCount': '📎 {n}',
  'lumen.account.support.avatarOther': 'U',
  'lumen.account.support.avatarYou': 'You',
  'lumen.account.support.bytes': 'Bytes',
  'lumen.account.support.commentsCount': 'Komentar ({n})',
  'lumen.account.support.copyUrl': 'Copy URL',
  'lumen.account.support.detailFailed': 'Gagal memuat detail tiket',
  'lumen.account.support.detailTitle': 'Detail Tiket',
  'lumen.account.support.downloadFailed': 'Download failed: {message}',
  'lumen.account.support.downloadFallback': 'Failed to download attachment',
  'lumen.account.support.downloadFile': 'Unduh lampiran',
  'lumen.account.support.downloaded': '{fileName} downloaded successfully!',
  'lumen.account.support.downloading': 'Downloading {fileName}...',
  'lumen.account.support.hideInternal': 'Sembunyikan komentar internal',
  'lumen.account.support.internalBadge': 'Internal',
  'lumen.account.support.messagePlaceholder': 'Ketik pesan Anda...',
  'lumen.account.support.noComments': 'Belum ada komentar',
  'lumen.account.support.pageUrlRow': '📄 {url}',
  'lumen.account.support.pickedFiles': 'Lampiran ({n})',
  'lumen.account.support.removeFile': 'Hapus file',
  'lumen.account.support.sendComment': 'Kirim komentar',
  'lumen.account.support.showInternal': 'Tampilkan komentar internal',
  'lumen.account.support.startConversation': 'Mulai percakapan di bawah',
  'lumen.account.support.toastError': 'Error',
  'lumen.account.support.toastInfo': 'Info',
  'lumen.account.support.toastSuccess': 'Success',
  'lumen.account.support.unknownUser': 'Unknown User',
  'lumen.account.support.urlCopied': 'Page URL copied to clipboard!',
  'lumen.account.support.urlCopyFailed': 'Failed to copy URL',
  'lumen.account.support.zeroBytes': '0 Bytes',
  'lumen.account.credit.backToCredit': 'Kembali ke Halaman Kredit',
  'lumen.account.credit.backToTopup': 'Kembali ke Halaman Top-Up',
  'lumen.account.credit.balanceEmpty': 'Tidak ada data saldo',
  'lumen.account.credit.balanceError': 'Gagal memuat saldo',
  'lumen.account.credit.balanceTitle': 'Saldo Anda',
  'lumen.account.credit.bankLabel': 'Pilih Bank',
  'lumen.account.credit.calculating': 'Menghitung biaya…',
  'lumen.account.credit.cardOpen': 'Buka Halaman Pembayaran',
  'lumen.account.credit.cardRedirecting': 'Mengalihkan ke halaman pembayaran...',
  'lumen.account.credit.cardUnavailable': 'URL Pembayaran Tidak Tersedia',
  'lumen.account.credit.cardUnavailableBody':
    'Link pembayaran tidak ditemukan. Silakan hubungi support atau coba lagi.',
  'lumen.account.credit.checkFailed': 'Gagal memeriksa status pembayaran. Silakan coba lagi.',
  'lumen.account.credit.checkStatus': 'Periksa Status Pembayaran',
  'lumen.account.credit.copied': 'Disalin ke clipboard',
  'lumen.account.credit.copy': 'Salin',
  'lumen.account.credit.credit': 'Kredit',
  'lumen.account.credit.creditsCount': '{n} kredit',
  'lumen.account.credit.creditsLabel': 'Jumlah Kredit',
  'lumen.account.credit.creditsPlaceholder': 'Masukkan jumlah kredit',
  'lumen.account.credit.description': 'Beli kredit untuk pengajuan CEISA dan NVOCC',
  'lumen.account.credit.errorTitle': 'Error',
  'lumen.account.credit.failedToast': 'Silakan coba lagi',
  'lumen.account.credit.feeLabel': 'Biaya layanan pembayaran',
  'lumen.account.credit.formTitle': 'Top Up Kredit',
  'lumen.account.credit.invalidUrl': 'URL pembayaran tidak valid',
  'lumen.account.credit.loadErrorToast': 'Gagal memuat detail pembayaran',
  'lumen.account.credit.loadingDetails': 'Memuat detail pembayaran...',
  'lumen.account.credit.loadingProducts': 'Memuat produk...',
  'lumen.account.credit.methodLabel': 'Metode Pembayaran',
  'lumen.account.credit.methodQris': 'QRIS',
  'lumen.account.credit.methodVa': 'Virtual Account',
  'lumen.account.credit.missingParams': 'Parameter Pembayaran Tidak Lengkap',
  'lumen.account.credit.missingParamsBody':
    'Halaman pembayaran membutuhkan parameter tipe dan referensi. Silakan kembali ke halaman top-up.',
  'lumen.account.credit.noProducts': 'Tidak ada produk kredit tersedia',
  'lumen.account.credit.noReference': 'Referensi pembayaran tidak ditemukan',
  'lumen.account.credit.notFound': 'Data Pembayaran Tidak Ditemukan',
  'lumen.account.credit.notFoundBody':
    'Data pembayaran dengan referensi ini tidak ditemukan. Silakan kembali ke halaman top-up.',
  'lumen.account.credit.notFoundToast': 'Data pembayaran tidak ditemukan',
  'lumen.account.credit.paidToast': 'Kredit telah ditambahkan ke akun Anda',
  'lumen.account.credit.paymentTitle': 'Pembayaran',
  'lumen.account.credit.priceLabel': 'Harga per Kredit:',
  'lumen.account.credit.productLabel': 'Pilih Produk',
  'lumen.account.credit.productOption': '{name} - {price}/kredit',
  'lumen.account.credit.productPlaceholder': 'Pilih paket kredit',
  'lumen.account.credit.qrisBody': 'Scan kode QR di bawah ini dengan aplikasi e-wallet Anda:',
  'lumen.account.credit.qrisTitle': 'Scan QRIS',
  'lumen.account.credit.resolveError': 'Gagal memuat akun kredit. Menggunakan akun default.',
  'lumen.account.credit.statusFailed': 'Pembayaran Gagal',
  'lumen.account.credit.statusLabel': 'Status Pembayaran:',
  'lumen.account.credit.statusPaid': 'Pembayaran Berhasil',
  'lumen.account.credit.statusPending': 'Menunggu Pembayaran',
  'lumen.account.credit.submit': 'Lanjut ke Pembayaran',
  'lumen.account.credit.subtotal': 'Subtotal:',
  'lumen.account.credit.successTitle': 'Berhasil',
  'lumen.account.credit.tabSubscription': 'Langganan',
  'lumen.account.credit.tabTopup': 'Top Up Manual',
  'lumen.account.credit.title': 'Top Up Kredit',
  'lumen.account.credit.topupFailed': 'Gagal membuat topup. Silakan coba lagi.',
  'lumen.account.credit.total': 'Total Pembayaran:',
  'lumen.account.credit.totalCredit': 'Total Kredit',
  'lumen.account.credit.vaInstruction': 'Transfer ke nomor Virtual Account di bawah ini:',
  'lumen.account.credit.vaNote': 'Setelah transfer, pembayaran akan diproses secara otomatis dalam 1-5 menit.',
  'lumen.account.credit.warning': 'Peringatan',
  'lumen.account.subscription.virtualAccount': 'Virtual Account',
  'lumen.account.subscription.qrisAlt': 'QRIS',
  'lumen.account.subscription.paymentSuccess': 'Pembayaran Berhasil',
  'lumen.account.subscription.paymentThanks': 'Terima kasih! Tagihan langganan Anda telah dibayar.',
  'lumen.account.subscription.amountPaid': 'Jumlah Dibayar',
  'lumen.account.subscription.period': 'Periode',
  'lumen.account.subscription.invoiceNotFound': 'Detail tagihan tidak ditemukan.',
  'lumen.account.subscription.creditsAdded': 'Kredit yang ditambahkan',
  'lumen.account.subscription.creditsCount': '{n} kredit',
  'lumen.account.subscription.noCredits': 'Tidak ada kuota kredit pada paket ini',
  'lumen.account.subscription.viewSubscription': 'Lihat Langganan',
  'lumen.account.subscription.startFiling': 'Mulai Pengajuan',
  'lumen.account.support.userUnknown': 'Unknown',
  'lumen.account.support.priorityFallback': 'Medium',
};

const zh: TranslationDict = {
  // ---- 应用更新 ----
  'appUpdate.title': '有新版本可用',
  'appUpdate.message': 'Lumen 已更新。请重新加载页面以使用最新版本。',
  'appUpdate.reload': '立即重新加载',

  // ---- 设置（个人 + 公司）----
  'settings.title': '设置',
  'settings.subtitle': '按您的工作习惯调整 Lumen。',
  'settings.sectionPersonal': '我的偏好',
  'settings.sectionCompany': '公司设置',
  'settings.docDetection': '自动识别单证类型',
  'settings.docDetectionDesc': '系统会读取每份上传的单证并自动填写其类型。若您更愿意自行选择，请关闭此项。',
  'settings.docDetectionNote': '适用于 PIB 上传步骤。即使关闭，仍会根据文件名进行推测。',
  'settings.docDetectionLockedNote': '此设置已由贵公司管理员锁定。如需更改请联系管理员。',
  'settings.lockedByCompany': '已被公司锁定',
  'settings.professionalMode': '专业模式',
  'settings.professionalModeDesc': '开启后将在处理流程中隐藏印花税、小游戏和知识问答。',
  'settings.professionalModeNote': '切换模式会重新加载页面，以便界面采用最新的偏好设置。',
  'settings.companyDocDetection': '全公司默认识别设置',
  'settings.companyDocDetectionDesc': '尚未自行设置的成员所采用的初始状态。',
  'settings.companyLock': '锁定此选项',
  'settings.companyLockDesc': '锁定期间成员无法更改自动识别。他们的选择会被保留，解锁后重新生效。',
  'settings.companyNote': '仅公司管理员可见此部分。',
  'settings.saveFailed': '保存失败',
  'settings.saveFailedMsg': '公司设置尚未保存，请重试。',
  // Language switcher
  'language.switcher': '语言',
  'language.indonesia': 'Bahasa Indonesia',
  'language.english': 'English',
  'language.chinese': '中文',

  // Sidebar menus
  'menu.mgmtDashboard': '管理仪表盘',
  'menu.manifest': '舱单',
  'menu.dashboard': '仪表盘',
  'menu.buatAju': '创建申报',
  'menu.draft': '草稿',
  'menu.docManifes': '舱单文件',
  'menu.theGuardian': '守卫',
  'menu.radar': '雷达',
  'menu.kepabeanan': '海关',
  'menu.docPabean': '报关文件',
  'menu.monitoringBlokir': '封锁监控',
  'menu.respon': '响应',
  'menu.databaseBarang': '商品数据库',
  'menu.ppftz': 'PPFTZ',
  'menu.kuotaImporEkspor': '进出口配额',
  'menu.shipmentQuota': '货运配额',
  'menu.hargaReferensi': '参考价格',
  'menu.cukai': '消费税',
  'menu.tutorial': '教程',
  'menu.suratJalan': '发货单',
  'menu.dokumenCk': 'CK文件',
  'menu.billOfMaterial': '物料清单',
  'menu.inventori': '库存',
  'menu.riskSelfCheck': '风险自查',
  'menu.customerApproval': '客户审批',
  'menu.approvalRequests': '审批请求',
  'menu.emailGroups': '电子邮件组',
  'menu.reviewers': '审阅者',
  'menu.rolesPermissions': '角色与权限',
  'menu.creditTopup': '信用充值',
  'menu.langganan': '订阅',
  'menu.berita': '新闻',
  'menu.antaraNews': '安塔拉新闻',
  'menu.cnnIndonesia': 'CNN 印尼',
  'menu.cnbcIndonesia': 'CNBC 印尼',
  'menu.republikaNews': '共和报新闻',
  'menu.kumparanNews': 'Kumparan 新闻',
  'menu.voaNews': '美国之音新闻',
  'menu.layananLainnya': '其他服务',
  'menu.stampDuty': '印花税',
  'menu.miniGames': '小游戏',
  'menu.fileCompress': '文件压缩',
  'menu.splitPdf': '拆分PDF',
  'menu.pengaturan': '设置',
  'menu.master': '主数据',
  'menu.ceisaUser': 'Ceisa用户',
  'menu.user': '用户',
  'menu.seaCarriers': '海运承运人',
  'menu.email': '电子邮件',
  'menu.customerEmailForwarding': '客户邮件转发',
  'menu.statement': '声明',
  'menu.manifestReminder': '舱单提醒',
  'menu.revokeAccess': '撤销访问',
  'menu.exportBank': '出口银行',
  'menu.riwayatPembaruan': '更新历史',

  // Sidebar badges
  'badge.new': '新',
  'badge.bod': 'BOD',
  'badge.mulai': '开始',
  'badge.aiReady': 'AI就绪',

  // Sidebar footer / search
  'sidebar.manageAccount': '管理账户',
  'sidebar.impersonate': '模拟用户',
  'sidebar.impersonating': '正在模拟',
  'sidebar.changeTheme': '切换主题',
  'sidebar.theme': '主题',
  'theme.apex': 'APEX',
  'theme.apexNight': 'APEX 黑夜',
  'theme.horizon': 'Horizon',
  'theme.horizonNight': 'Horizon 黑夜',
  'theme.horizonDawn': 'Horizon 黎明',
  'theme.horizonDusk': 'Horizon 黄昏',
  'theme.horizonMist': 'Horizon 薄雾',
  'sidebar.logout': '退出登录',
  'sidebar.loggingOut': '正在退出...',
  'sidebar.collapse': '收起侧边栏',
  'sidebar.expand': '展开侧边栏',
  'sidebar.quickSearch': '快速搜索...',
  'sidebar.noMatches': '无匹配结果',

  // Login
  'auth.welcome': '欢迎回来！登录以访问您的账户',
  'auth.email': '电子邮件地址',
  'auth.emailPlaceholder': 'example@mail.com',
  'auth.password': '密码',
  'auth.passwordPlaceholder': '您的密码',
  'auth.signIn': '登录',
  'auth.or': '或',
  'auth.cubeLogin': '使用 CUBEforall 账户登录',
  'auth.reviewerLogin': '以审阅者身份登录',
  'auth.cubeErrorTitle': 'CUBEforall 登录失败',

  // Login showcase (right panel of the login page)
  'auth.showcase.headline': '报关文件几分钟完成，而不是几个小时。',
  'auth.showcase.ariaLabel': 'Lumen 功能',
  'auth.showcase.play': '播放',
  'auth.showcase.pause': '暂停',
  'auth.showcase.segBrand': '简介',
  'auth.showcase.segExtract': 'AI 提取',
  'auth.showcase.segHs': 'HS 与 Lartas',
  'auth.showcase.segCeisa': 'CEISA',
  'auth.showcase.segRadar': '雷达',
  'auth.showcase.segUpload': '上传',
  'auth.showcase.extractTitle': 'AI 提取',
  'auth.showcase.extractDesc': '自动读取发票和装箱单，每个数值都附带置信度评分。',
  'auth.showcase.tabBarang': '货物',
  'auth.showcase.itemsDetected': '检测到 {n} 个条目',
  'auth.showcase.reading': '正在读取文件',
  'auth.showcase.draftReady': 'PIB 草稿可供复核',
  'auth.showcase.verified': 'Verified',
  'auth.showcase.sampleData': '示例数据',
  'auth.showcase.tipVerified': 'Verified',
  'auth.showcase.tipCheck': 'Check',
  'auth.showcase.tipAutoVerified': '已根据来源自动校验',
  'auth.showcase.tipClickReview': '点击对照来源复核',
  'auth.showcase.tipHsConfidence': 'HS 编码提取置信度',
  'auth.showcase.hsTitle': 'HS 编码与 Lartas 校验',
  'auth.showcase.hsDesc': 'HS 编码对接 INSW 核对，自动判定 Lartas 状态并计算税率。',
  'auth.showcase.hsCode': '编码',
  'auth.showcase.hsNormalized': '标准化编码',
  'auth.showcase.hsUraian': '描述（印尼语）',
  'auth.showcase.hsInswYear': 'INSW 年份',
  'auth.showcase.no': '否',
  'auth.showcase.tipNoLartas': '无需 Lartas 许可',
  'auth.showcase.tipBm': '进口关税，MFN 税率',
  'auth.showcase.tipPpn': '增值税',
  'auth.showcase.tipPph': '进口所得税第 22 条，持 API',
  'auth.showcase.tipPostel': '需要 Postel 证书',
  'auth.showcase.ceisaTitle': '提交至 CEISA 4.0',
  'auth.showcase.ceisaDesc': '一键提交，状态记录回流到 Lumen。',
  'auth.showcase.sent': '已提交',
  'auth.showcase.tipDraft': '草稿已保存在 Lumen',
  'auth.showcase.tipSubmitted': '已提交至 CEISA 4.0',
  'auth.showcase.tipUmum': '已受理，通道分配中',
  'auth.showcase.tipSppb': '货物放行批准函',
  'auth.showcase.radarTitle': '舱单雷达',
  'auth.showcase.radarDesc': '船舶抵达前即监控进出舱单。',
  'auth.showcase.vessel': '船名',
  'auth.showcase.remaining': '剩余',
  'auth.showcase.uploadTitle': '一次上传最多 50 份文件',
  'auth.showcase.uploadDesc': '自动识别文件类型并分组。',
  'auth.showcase.dropHint': '拖放文件',
  'auth.showcase.typesDetected': '检测到 {n} 种文件类型',

  // Doc Pabean page
  'docpabean.errorLoad': '加载报关文件数据失败。',
  'docpabean.retry': '重试',
  'docpabean.allStatus': '全部状态',
  'docpabean.sortPlaceholder': '排序',
  'docpabean.filterStatus': '筛选状态',
  'docpabean.filterBranch': '筛选分公司',
  'docpabean.branchMine': '我的分公司',
  'docpabean.branchAll': '所有分公司',
  'docpabean.sortNewest': '排序：最新',
  'docpabean.sortAjuAsc': '申报号（A-Z）',
  'docpabean.sortAjuDesc': '申报号（Z-A）',
  'docpabean.sortShipperAsc': '货主名称（A-Z）',
  'docpabean.sortShipperDesc': '货主名称（Z-A）',
  'docpabean.sortDateOldest': '登记日期（最早）',
  'docpabean.sortDateNewest': '登记日期（最新）',
  'docpabean.sortItemLeast': '条目总数（最少）',
  'docpabean.sortItemMost': '条目总数（最多）',
  'docpabean.downloadUsage': '下载使用报告',
  'docpabean.downloadReport': '下载报告',
  'docpabean.startDate': '开始日期',
  'docpabean.endDate': '结束日期',
  'docpabean.selectStartDate': '选择开始日期',
  'docpabean.selectEndDate': '选择结束日期',
  'docpabean.docType': '文件类型',
  'docpabean.all': '全部',
  'docpabean.cancel': '取消',
  'docpabean.download': '下载',
  'docpabean.errSelectDates': '请选择开始日期和结束日期',
  'docpabean.successDownloaded': '使用报告下载成功',
  'docpabean.errDownload': '下载使用报告失败',
  'docpabean.errorTitle': '错误',

  // Doc Pabean credits banner
  'docpabean.remainingCredits': '剩余积分',
  'docpabean.errLoadBalance': '加载余额失败',
  'docpabean.viewSubscription': '查看订阅',

  // Doc Pabean download modal
  'docpabean.downloadModalTitle': '下载报告',
  'docpabean.loadingOptions': '加载选项...',
  'docpabean.filterHint': '按公司名称和/或日期范围筛选导出历史记录。草稿员名称可选。',
  'docpabean.drafterName': '草稿员名称（可选）',
  'docpabean.drafterPlaceholder': '搜索并选择草稿员...',
  'docpabean.noDrafters': '未找到草稿员',
  'docpabean.companyName': '公司名称',
  'docpabean.companyPlaceholder': '搜索并选择公司...',
  'docpabean.noCompanies': '未找到公司',
  'docpabean.errSelectCompanyDates': '请选择公司和/或日期范围（草稿员名称可选）',
  'docpabean.errDateRequiredCompany': '导出 {company} 必须填写开始日期和结束日期（DD-MM-YYYY）',
  'docpabean.errEndBeforeStart': '结束日期必须不早于开始日期',
  'docpabean.successReportDownloaded': '报告下载成功',
  'docpabean.errReportDownload': '下载报告失败',

  // Doc Pabean table
  'docpabean.colNomorAju': '申报号',
  'docpabean.colShipper': '货主名称',
  'docpabean.colBuyer': '买方名称',
  'docpabean.colDate': '登记日期',
  'docpabean.colRespon': '响应',
  'docpabean.colStatus': '状态',
  'docpabean.colType': '类型',
  'docpabean.colJenisKategori': '类型 | 出口类别',
  'docpabean.colDrafter': '草稿员',
  'docpabean.colTotalItem': '条目总数',
  'docpabean.colApproval': '审批',
  'docpabean.colActions': '操作',
  'docpabean.filterShipmentType': '运输类型',
  'docpabean.filterNamaPerusahaan': '公司名称',
  'docpabean.filterDrafter': '草稿员名称',
  'docpabean.filterMotType': '运输方式类型',
  'docpabean.motSea': '海运',
  'docpabean.motAir': '空运',
  'docpabean.filterCountry': '发货人/收货人国家',
  'docpabean.statusHistory': '状态历史',
  'docpabean.latest': '最新',
  'docpabean.respon': '响应',
  'docpabean.tooltipVerified': '完整：发票 + 提单/空运单',
  'docpabean.tooltipView': '查看',
  'docpabean.tooltipViewEdit': '查看 / 编辑',
  'docpabean.tooltipEdit': '编辑',
  'docpabean.tooltipCopy': '复制',
  'docpabean.tooltipUpload': '上传文件',
  'docpabean.tooltipSyncRespon': '同步响应',
  'docpabean.tooltipDelete': '删除',
  'docpabean.tooltipPreviewPdf': '预览 PDF',
  'docpabean.tooltipPreviewPdfNoAju': '尚无 AJU 编号',
  'docpabean.pdfPreview.title': '预览 {doc}',
  'docpabean.pdfPreview.kindFinal': '正式 (NOPEN)',
  'docpabean.pdfPreview.kindDraft': 'CEISA 草稿',
  'docpabean.pdfPreview.fallbackTitle': '暂时无法获取正式文件',
  'docpabean.pdfPreview.fallbackBody': '该文件已获得 NPE/SPPB，但无法从 CEISA 获取正式表格。当前显示的是 CEISA 草稿。',
  'docpabean.pdfPreview.loading': '正在从 CEISA 获取文件…',
  'docpabean.pdfPreview.loadingHint': '如果文件尚未生成，CEISA 需要一些时间来准备 — CEISA 较慢时可能需要约一分钟。',
  'docpabean.pdfPreview.docGeneric': '文件',
  'docpabean.pdfPreview.refreshDraft': '刷新草稿',
  'docpabean.pdfPreview.download': '下载',
  'docpabean.pdfPreview.openNewTab': '在新标签页打开',
  'docpabean.pdfPreview.errorTitle': '无法显示文件',
  'docpabean.pdfPreview.errorGeneric': '获取文件失败，请重试。',
  'docpabean.pdfPreview.errorBilling': '订阅未付款 / 额度不足 — 无法打开预览。',
  'docpabean.pdfPreview.retry': '重试',
  'docpabean.deleteConfirm': '从列表中删除文件 {nomor}？已发送到 CEISA 的文件不受影响。',
  'docpabean.deleteCancel': '取消',
  'docpabean.deleteFiledWarning': '该文件已在 CEISA 登记。删除仅将其从 Lumen 隐藏 — 文件仍保留在 CEISA。',
  'docpabean.showDeleted': '显示已删除',
  'docpabean.deletedBadge': '已删除',
  'docpabean.tooltipRestore': '恢复',
  'docpabean.restoreConfirm': '将文件 {nomor} 恢复到列表？',
  'docpabean.restore': '恢复',
  'docpabean.delete': '删除',
  'docpabean.loadingData': '加载数据...',
  'docpabean.emptyFilter': '当前筛选条件下没有文件。',
  'docpabean.page': '页',
  'docpabean.company': '公司',
  'docpabean.proses': '流程',
  'docpabean.totalItemLabel': '条目总数',
  'docpabean.country': '国家',
  'docpabean.export': '出口',
  'docpabean.import': '进口',
  'docpabean.justNow': '刚刚',
  'docpabean.ago': '前',
  'docpabean.approved': '已批准',
  'docpabean.waiting': '等待中',
  'docpabean.needRevision': '需要修订',
  'docpabean.rejected': '已拒绝',
  'docpabean.cancelled': '已取消',
  'docpabean.scheduled': '已安排',
  // 提交拦截：贸易术语为 FOB/FCA 但运费为 0（issue #234）
  'docpabean.freightZero.title': '运费为 0 — 请检查费用组成信息',
  'docpabean.freightZero.body':
    '{incoterm} 贸易术语要求将运费作为独立的费用组成项填写，因为运费不包含在发票价格中。当前运费仍为 0，申报的完税价格可能有误。',
  'docpabean.freightZero.hint':
    '请在“费用组成信息”中填写运输费用（Freight）并保存。运费大于 0 后，即可将文件提交至 CEISA。',
  'docpabean.freightZero.cta': '打开费用组成信息',
  'docpabean.freightZero.cancel': '取消',
  // 上传运费截图 → 识别金额与币种（issue #235）
  'docpabean.freightUpload.dropTitle': '上传运费截图或 PDF',
  'docpabean.freightUpload.dropHint': '将邮件或 WhatsApp 的截图或 PDF 拖放到此处，点击选择文件，或按 {paste} 粘贴',
  'docpabean.freightUpload.ofUploaded': '已上传海运费（OF）文件',
  'docpabean.freightUpload.ofUploadedFiles': '创建报关单时已从 {files} 读取运费金额。',
  'docpabean.freightUpload.ofUploadedHint': '创建报关单时已从该文件读取运费金额。',
  'docpabean.freightUpload.ofUploadedOverride': '仅在需要替换运费金额时，才在下方上传截图或 PDF。',
  'docpabean.freightUpload.reading': '正在识别文件...',
  'docpabean.freightUpload.readingHint': '通常只需几秒钟',
  'docpabean.freightUpload.detected': '识别到运费：{currency} {amount}',
  'docpabean.freightUpload.detectedSub': '已从文件自动读取（置信度 {pct}%，{method}）',
  'docpabean.freightUpload.detectedSubNoPct': '已从文件自动读取（{method}）',
  'docpabean.freightUpload.mismatchInline': '识别到运费：{currency} {amount}，与交易币种（{txn}）不一致',
  'docpabean.freightUpload.use': '使用此数值',
  'docpabean.freightUpload.useAs': '按 {currency} 使用',
  'docpabean.freightUpload.review': '查看换算',
  'docpabean.freightUpload.retry': '重试',
  'docpabean.freightUpload.dismiss': '关闭',
  'docpabean.freightUpload.lowConfidence': '置信度较低（{pct}%），使用前请核对数值。',
  'docpabean.freightUpload.notFound': '未能从该文件中识别到运费',
  'docpabean.freightUpload.notFoundHint': '请换一个包含运费金额的截图或 PDF，或在“费用组成信息”中手动填写。',
  'docpabean.freightUpload.currencyUnknown': '识别到金额 {amount}，但无法从文件确定币种。',
  'docpabean.freightUpload.invalidType': '文件必须是图片（JPEG/PNG/WebP）或 PDF。',
  'docpabean.freightUpload.tooLarge': '文件大小不能超过 10 MB。',
  'docpabean.freightUpload.failed': '文件识别失败：{message}',
  'docpabean.freightUpload.applyFailed': '运费保存失败：{message}',
  'docpabean.freightUpload.applied': '运费 {currency} {amount} 已保存至费用组成信息',
  'docpabean.freightUpload.appliedInline': '已使用运费 {value}',
  'docpabean.freightUpload.appliedHintField': '已保存至费用组成信息',
  'docpabean.freightUpload.appliedFrom.converted': '由 {currency} {amount} 按 NDPBM 汇率换算为 {txn}',
  'docpabean.freightUpload.appliedFrom.original': '数值 {amount} 已按原样作为 {txn} 填入（文件识别为 {currency}）',
  'docpabean.freightUpload.appliedFrom.assumed': '数值 {amount} 已视为 {txn}；未能从文件识别币种',
  'docpabean.freightUpload.appliedHintRow': '已填入此行，请点击“保存”以保存。',
  'docpabean.freightUpload.method.ocr': 'OCR',
  'docpabean.freightUpload.method.gemini': 'AI',
  'docpabean.freightUpload.method.pdf-text': 'PDF 文本层',
  'docpabean.freightUpload.method.pdf-ocr': 'PDF 页面 OCR',
  'docpabean.freightUpload.mismatch.title': '运费币种不一致',
  'docpabean.freightUpload.mismatch.body':
    '识别到的运费币种为 {detected}（{detected} {detectedAmount}），而本笔交易以 {txn} 计价。系统将按 NDPBM 汇率把 {detected} 换算为 {txn}，约为 {converted} {txn}。是否使用换算结果？',
  'docpabean.freightUpload.mismatch.bodyNoRate':
    '识别到的运费币种为 {detected}（{detected} {detectedAmount}），而本笔交易以 {txn} 计价。',
  'docpabean.freightUpload.mismatch.rate':
    '{detected} 的 NDPBM 汇率：1 {detected} = Rp {ndpbmSrc}\n{txn} 的 NDPBM 汇率：1 {txn} = Rp {ndpbmTxn}\n结果：1 {detected} ≈ {rate} {txn}',
  'docpabean.freightUpload.mismatch.noRate':
    '当前无法获取用于换算的 NDPBM 汇率，因此无法计算换算结果。您可以使用原始数值或手动填写。',
  'docpabean.freightUpload.mismatch.valutaHint':
    '如果发票本身就是 {detected} 计价，请先在“价格”卡片中更改币种，然后重新上传文件。',
  'docpabean.freightUpload.mismatch.useConverted': '使用换算结果',
  'docpabean.freightUpload.mismatch.useOriginal': '将 {amount} 作为 {txn} 填入',
  'docpabean.freightUpload.mismatch.cancel': '取消',

  // Status / Respon history modal
  'statushistory.title': '状态历史',
  'statushistory.loading': '加载中...',
  'statushistory.document': '文件',
  'statushistory.by': '由',
  'statushistory.totalItems': '条目总数',
  'statushistory.item': '项',
  'statushistory.items': '项',
  'statushistory.country': '国家',
  'statushistory.file': '文件',
  'statushistory.totalTime': '总耗时',
  'statushistory.noData': '没有可用数据',
  'statushistory.viewResponHistory': '查看响应历史',
  'statushistory.errFetch': '加载状态历史失败',
  'statushistory.errGeneric': '加载状态历史出错',

  // Buat Aju page
  'buataju.import': '进口',
  'buataju.importDesc': '创建进口到印尼的货物的报关文件。',
  'buataju.export': '出口',
  'buataju.exportDesc': '创建从印尼出口的货物的报关文件。',
  'buataju.bc33Desc': '经由或从保税物流中心（PLB）出口货物的申报单 — 用于通过/从保税物流中心出口。',
  'buataju.ppftzDesc': '使用 AI 从发票、装箱单和提单创建 FTZ (511) 文件，或手动填写。',
  'buataju.bc16Desc': '将进口货物运入保税物流中心（PLB）。',
  'buataju.bc23Desc': '将进口货物从海关区域或 TPS 运入 TPB。',
  'buataju.bc25Desc': '将进口货物从 TPB 运出到 TLDDP 供本地使用。',
  'buataju.bc261Desc': '凭担保将货物从 TPB 临时运出到 TLDDP。',
  'buataju.bc262Desc': '将临时运出的货物重新运入 TPB。',
  'buataju.bc27Desc': '在 TPB、KEK 或自由区之间转移货物。',
  'buataju.bc28Desc': '将货物从 PLB 运出供本地使用或临时使用。',
  'buataju.bc40Desc': '将来自 TLDDP 的货物运入保税仓库。',
  'buataju.bc41Desc': '将来自 TLDDP 的货物从 TPB 运回 TLDDP。',
  'buataju.bcp3betDesc': '用于保税展会活动（P3BET）的申报单。',
  'buataju.popular': '热门',
  'buataju.limitedAccess': '受限访问',
  'buataju.comingSoon': '即将推出',
  'buataju.new': '新',
  'buataju.locked': '已锁定',
  'buataju.start': '开始',
  'buataju.badge': '轻松处理报关文件',
  'buataju.title': '选择文件类型',
  'buataju.subtitle': '选择符合您业务需求的报关文件类型，开始您的旅程。',
  'buataju.typesAvailable': '种类型可用',
  'buataju.tpb': 'TPB',
  'buataju.tpbDesc': '保税仓库',
  'buataju.codeImport': '进口',
  'buataju.codeExport': '出口',
  'buataju.codeEkspor': '出口',
  'buataju.codePpftz': 'PPFTZ',
  'buataju.codeTpb': 'TPB',

  // Doc Pabean Upload page
  'upload.back': '返回',
  'upload.title': '上传文件',
  'upload.subtitle': '上传并分组您的报关文件。',
  'upload.backToWizard': '返回 3 步向导流程',
  'upload.useWizard': '使用向导',
  'upload.documents': '文件',
  'upload.processing': '处理中...',
  'upload.grouped': '已分组',
  'upload.readyToProcess': '准备处理',
  'upload.successCount': '{n} 成功',
  'upload.failedCount': '{n} 失败',
  'upload.reset': '重置',
  'upload.continueReview': '继续到审阅',
  'upload.uploadDocs': '上传 {n} 个文件',
  'upload.processDocs': '处理文件',
  'upload.uploading': '上传中... {p}%',
  'upload.groupingDocs': '按类型分组文件...',
  'upload.resultsTitle': '文件上传结果',
  'upload.total': '总计',
  'upload.success': '成功',
  'upload.failed': '失败',
  'upload.caution': '注意',
  'upload.cautionMsg': '部分文件上传失败。您可以重试或继续使用已成功上传的文件。',
  'upload.successDocs': '成功文件（{n}）',
  'upload.failedDocs': '失败文件（{n}）',
  'upload.docType': '类型：{type}',
  'upload.noDocType': '无文件类型',
  'upload.errorLabel': '错误：{msg}',
  'upload.reUpload': '重新上传',
  'upload.continue': '继续',
  'upload.errRequiredTransport': '必须包含 BL、AWB、MBL 或 MAWB 文件',
  'upload.errCeisaCombine': 'Excel CEISA 不能合并',
  'upload.errCeisaCombineMsg': 'Excel CEISA 文件必须单独上传，不能与其他文件合并。',
  'upload.errNoFile': '没有文件',
  'upload.errNoFileMsg': '请先添加文件',
  'upload.errNoType': '尚未选择文件类型',
  'upload.errNoTypeMsg': '{n} 个文件没有文件类型',
  'upload.errEmptyFile': '0 字节（空文件）',
  'upload.errInvalidPdf': '不是有效的 PDF（标题 "{magic}"，大小 {size} 字节）',
  'upload.errInvalidFile': '文件无效',
  'upload.successUploaded': '上传成功',
  'upload.successUploadedMsg': '所有文件均上传成功。',
  'upload.doneUploading': '上传完成',
  'upload.partialMsg': '{total} 个文件中有 {success} 个上传成功。',
  'upload.errCeisaProcess': '处理 Excel CEISA 失败：{msg}。文件已保存，请继续到草稿页面。',
  'upload.errUpload': '上传文件时出错：{msg}',
  'upload.errUploadFile': '上传文件失败。',
  'upload.errNoBatch': '未找到 Batch UUID。请先上传文件。',
  'upload.uploadGagal': '上传失败：服务器未返回有效数据',
  'upload.ceisaFileNotFound': '未找到 EXCEL CEISA 文件',
  'upload.emptyHeader': '待上传文件（{n}）',
  'upload.searchPlaceholder': '搜索文件...',
  'upload.selectDocType': '选择文件类型',
  'upload.alreadySelected': '已选择',
  'upload.noMatch': '没有与 "{q}" 匹配的文件',
  'upload.noFiles': '尚未上传文件',
  'upload.dragDrop': '拖放或',
  'upload.clickBrowse': '点击浏览',
  'upload.dropPdf': '将 PDF 文件拖放到此处',
  'upload.dropPdfExcel': '将 PDF/Excel 文件拖放到此处',
  'upload.dropPdfExcelImg': '将 PDF/Excel/照片 (JPG/PNG) 文件拖放到此处',
  'upload.maxFiles': '最多 {n} 个文件',
  'upload.enlarge': '放大',
  'upload.shrink': '缩小',
  'upload.fmtNotMatch': '格式不符合',
  'upload.fmtPdfOnly': '仅允许 PDF 文件',
  'upload.fmtPdfExcel': '仅允许 PDF 和 Excel 文件',
  'upload.fmtPdfExcelImg': '仅允许 PDF、Excel 和照片 (JPG/PNG) 文件',
  'upload.tooMany': '文件太多',
  'upload.tooManyMsg': '最多可上传 {n} 个文件',
  'upload.cantSelect': '无法选择',
  'upload.masterOnlyOne': '仅允许 1 个 {name}',
  'upload.fileCount': '{n} 个文件',
  'upload.groupedHeader': '文件已分组',
  'upload.dragReorder': '拖拽调整顺序',
  'upload.splitTitle': '将 PDF 拆分为多个文件',
  'upload.splitHint': '选择 PDF 文件手动标记分段，或点击"智能拆分"自动识别。',
  'upload.notPdf': '此文件不是 PDF',
  'upload.pages': '{n} 页',
  'upload.activeSeg': '活动：段 {n}',
  'upload.pageOf': '第 {cur} 页 / 共 {total} 页',
  'pdf.zoomIn': '放大（Ctrl + 滚轮）',
  'pdf.zoomOut': '缩小（Ctrl + 滚轮）',
  'pdf.zoomReset': '重置缩放',
  'upload.smartSplit': '智能拆分',
  'upload.smartSplitHint': '智能拆分 — 读取 PDF 内容并按文件拆分',
  'upload.smartSplitWorking': '正在读取文件',
  'upload.smartSplitNeedsPages': '至少需要 2 页',
  'upload.smartSplitResult': '找到 {n} 份文件 · {method}',
  'upload.smartSplitViaAi': 'AI 识别',
  'upload.smartSplitViaText': '来自 PDF 文本',
  'upload.smartSplitSingle': '此文件只有一份文件，无需拆分。',
  'upload.smartSplitFailed': '识别失败',
  'upload.smartSplitFailedMsg': '无法读取文件，请手动标记分段。',
  'upload.smartSplitAll': '全部识别',
  'upload.smartSplitAllHint': '一次读取所有 PDF — 识别文件类型与分页',
  'upload.smartSplitAllProgress': '正在读取 {done}/{total}',
  'upload.aiDetectQueued': '等待中',
  'upload.aiDetectFailed': '识别失败 — 重试',
  'upload.mismatchDetected': '文件内容识别为 {type}（{pct}%），而非 {declared}',
  'upload.mismatchUse': '改为 {type}',
  'upload.mismatchIgnore': '忽略',
  'upload.siblingHint': '识别为 {type} — 可能更准确',
  'upload.bundleDetected': '包含 {n} 份文件（{types}）— 请先拆分',
  'upload.bundleOpen': '打开拆分',
  'upload.issuesTitle': '请检查文件类型',
  'upload.issuesIntro': '{n} 个文件的内容与所选类型不符。是否照原样继续？',
  'upload.issuesDeclared': '所选',
  'upload.issuesDetected': '识别',
  'upload.issuesBundle': '包含 {types} — 尚未拆分',
  'upload.issuesContinue': '继续',
  'upload.issuesReview': '再检查',
  'upload.waitDetection': '正在读取文件 {done}/{total} — 请等待完成',
  'upload.waitDetectionHint': '所有文件读取完成后按钮才可用',
  'upload.needsType': '选择类型',
  'upload.lowConfidence': '需复核 · {pct}%',
  'upload.confidence': '置信度 {pct}%',
  'upload.loadingPreview': '正在加载预览...',
  'upload.previewFailed': '无法显示预览',
  'upload.previewFailedMsg': '该文件仍可智能拆分并上传。',
  'upload.addSegment': '添加分段',
  'upload.segmentHint': '点击上方按钮，然后在缩略图上选择页面。',
  'upload.selectPages': '在缩略图上选择页面...',
  'upload.noPages': '还没有页面',
  'upload.pagesLabel': '页：{pages}',
  'upload.docTypePlaceholder': '文件类型',
  'upload.removeOriginal': '删除原始文件',
  'upload.extractSegments': '提取 {n} 个分段',
  'upload.activateSegmentFirst': '点击下方分段以先激活它',
  'upload.pageFreed': '第 {page} 页已从第 {seg} 段移出',
  'upload.pageFreedClickAgain': '第 {page} 页已从第 {seg} 段移出，再次点击可将其移入当前分段。',
  'upload.fileLimitReached': '达到文件上限',
  'upload.fileLimitReachedMsg': '无法添加分段：将超过 {n} 个文件的上限',
  'upload.segMinPages': '每个分段必须至少包含 1 页',
  'upload.segNeedType': '所有分段都必须有文件类型',
  'upload.exceedLimit': '超过 {n} 个文件的上限（当前 {cur}，将添加 {add}）',
  'upload.validationFailed': '验证失败',
  'upload.extractSuccess': '从 "{name}" 创建了 {n} 个文件',
  'upload.extractFailed': '拆分 PDF 失败',

  // Document type options (select/dropdown labels)
  'doctype.PL': '(PL) 装箱单',
  'doctype.I': '(I) 发票',
  'doctype.BL': '(BL) 提单',
  'doctype.MBL': '(MBL) 主提单',
  'doctype.SI': '(SI) 装运指示',
  'doctype.BR': '(BR) 订舱收据',
  'doctype.COO': '(COO) 原产地证书',
  'doctype.ECOO': '(E-COO) 电子原产地证书',
  'doctype.AWB': '(AWB) 空运单',
  'doctype.MAWB': '(MAWB) 主空运单',
  'doctype.LS': '(LS) 检验报告',
  'doctype.POSTEL': '(POSTEL) 邮政',
  'doctype.PI': '(PI) 进口许可',
  'doctype.AKL': '(AKL) 医疗器械注册号/卫生部',
  'doctype.SKI': '(SKI) BPOM 装运批准函',
  'doctype.SKB': '(SKBPPN) 进口增值税免税函',
  'doctype.SKBPPH': '(SKBPPH) 进口所得税第 22 条免税函',
  'doctype.SKBPP23': '(SKBPP23) PP 23 最终所得税免税函',
  'doctype.SNI': '(SNI) SNI',
  'doctype.VLEGAL': '(VLEGAL) V-LEGAL',
  'doctype.CITES': '(CITES) CITES',
  'doctype.HC': '(HC) 健康证书',
  'doctype.HALAL': '(HALAL) 清真证书',
  'doctype.SKEPTPB': '(SKEPTPB) SKEP-TPB',
  'doctype.PE': '(PE) 出口许可',
  'doctype.SKEM': '(SKEM) SKEM',
  'doctype.SNISPBDEPDAG': '(SNISPBDEPDAG) SNISPBDEPDAG',
  'doctype.PP': '(PP) RB3 许可豁免 / B3 注册 / KLH',
  'doctype.EXC-JRE': '(CIPL - JRE) CIPL - JRE',
  'doctype.EXC-ARJUNA': '(CIPL - ARJUNA) CIPL - ARJUNA',
  'doctype.EXC-OBOR': '(CIPL - OBOR) CIPL - OBOR',
  'doctype.EXC-BENING': '(CIPL - BENING) CIPL - BENING',
  'doctype.EXC-NADA': '(CIPL - NADA) CIPL - NADA',
  'doctype.EXC-MINEBEA': '(CIPL - MINEBEA) CIPL - MINEBEA',
  'doctype.EXC-WIDE-SUCCESS': '(CIPL - WIDE SUCCESS) CIPL - WIDE SUCCESS',
  'doctype.EXC-NICESO': '(CIPL - NICESO) CIPL - NICESO',
  'doctype.EXC-CEISA': '(EXCEL CEISA) Excel CEISA',
  'doctype.SKEP': '(SKEP) SKEP',
  'doctype.980': '(980) Deklarasi Impor',
  'doctype.OF': '(OF) 海运费',

  // HeaderForm
  'headerform.labelPelabuhan': '港口',
  'headerform.labelKantorPabean': '海关办公室',
  'headerform.labelPIB': 'PIB',
  'headerform.labelJenisImpor': '进口类型',
  'headerform.labelCaraBayar': '付款方式',
  'headerform.placeholderPelabuhan': '选择港口',
  'headerform.placeholderKantorPabean': '选择海关办公室',
  'headerform.placeholderPIB': '选择 PIB 类型',
  'headerform.placeholderJenisImpor': '选择进口类型',
  'headerform.placeholderCaraBayar': '选择付款方式',
  'headerform.pibOpt1': '1 - 普通 (BIASA)',
  'headerform.pibOpt2': '2 - 定期 (BERKALA)',
  'headerform.imporOpt1': '1 - 供自用 (UNTUK DIPAKAI)',
  'headerform.imporOpt2': '2 - 临时 (SEMENTARA)',
  'headerform.imporOpt5': '5 - 加急处理 (RUSH HANDLING)',
  'headerform.imporOpt9': '9 - 第 1 和第 2 类组合 (GABUNGAN 1 DAN 2)',
  'headerform.bayarOpt1': '1 - 普通/现金 (BIASA/TUNAI)',
  'headerform.bayarOpt2': '2 - 定期 (BERKALA)',
  'headerform.bayarOpt10': '10 - 分期延期付款（赊账）(OPEN ACCOUNT)',
  'headerform.bayarOpt11': '11 - 延期付款（赊账）现金结算 (OPEN ACCOUNT)',
  'headerform.bayarOpt12': '12 - 在国内以现金付款完成',
  'headerform.bayarOpt13': '13 - 在国内以电汇 (T/T) 付款完成',
  'headerform.bayarOpt14': '14 - 无付款完成',
  'headerform.bayarOpt15': '15 - 预付款 (ADVANCE PAYMENT)',
  'headerform.bayarOpt16': '16 - 即期信用证 (SIGHT LETTER OF CREDIT)',
  'headerform.bayarOpt17': '17 - 托收 (COLLECTION DRAFT)',

  // DokumenForm
  'dokumenform.col.seri': '序号',
  'dokumenform.col.jenis': '类型',
  'dokumenform.col.ecooStatus': 'eCOO 状态',
  'dokumenform.col.nomor': '号码',
  'dokumenform.col.tanggal': '日期',
  'dokumenform.col.fasilitas': '设施',
  'dokumenform.col.kodeIjin': '许可代码',
  'dokumenform.col.attached': '已附',
  'dokumenform.col.state': '状态',
  'dokumenform.col.aksi': '操作',

  'dokumenform.action.attachToBarang': '附加到货物',
  'dokumenform.action.edit': '编辑',
  'dokumenform.action.copy': '复制',
  'dokumenform.action.uploadReplace': '上传 / 替换文件',
  'dokumenform.action.uploadReplaceAria': '上传或替换文件',
  'dokumenform.action.delete': '删除',
  'dokumenform.action.deleteLastBlocked': '无法删除最后一份文件 — CEISA 至少需要 2 份文件',
  'dokumenform.action.undo': '撤销',
  'dokumenform.deleted.title': '已删除的文件',
  'dokumenform.deleted.hint': '这些文件不会显示在文件标签页中，也不会提交给 CEISA。如果误删，可以恢复。',
  'dokumenform.deleted.restore': '恢复',

  'dokumenform.modal.attachTitle': '将文档附加到货物',
  'dokumenform.modal.replaceTitle': '替换当前选择？',
  'dokumenform.modal.uploadPdfTitle': '上传 PDF 文档',

  'dokumenform.label.quickSelect': '快速选择（范围输入）',
  'dokumenform.label.filterHsCode': '按 HS 编码筛选',
  'dokumenform.label.bulkSeriIjin': '批量许可序号',
  'dokumenform.label.filePdf': 'PDF 文件',
  'dokumenform.label.tipeDokumen': '文档类型',

  'dokumenform.placeholder.rangeExample': '示例：1-2,3,5-8,10（使用项目编号，而非索引）',
  'dokumenform.placeholder.filterHsCode': '输入 HS 编码筛选（例如 9403）',
  'dokumenform.placeholder.value': '值',
  'dokumenform.placeholder.pilihFilePdf': '选择 PDF 文件',
  'dokumenform.placeholder.url': 'https://... (House-BL / AWB / 支持文档)',

  'dokumenform.button.batal': '取消',
  'dokumenform.button.simpan': '保存',
  'dokumenform.button.menyimpan': '保存中...',
  'dokumenform.button.tambahDokumen': '添加文档',
  'dokumenform.button.uploadPdf': '上传 PDF',
  'dokumenform.button.upload': '上传',
  'dokumenform.button.applyToSelected': '应用到已选 ({n})',
  'dokumenform.button.clearSelection': '清除选择',
  'dokumenform.button.replaceSelection': '替换选择',
  'dokumenform.button.autoMatch': '自动匹配',
  'dokumenform.button.autoMatchEcoo': '从 E-COO 自动匹配',
  'dokumenform.button.validateEcoo': '验证 eCOO',
  'dokumenform.button.autoSort': '自动排序',
  'dokumenform.total': '总计: {n}',

  'dokumenform.notify.success': '成功',
  'dokumenform.notify.successTitle': '成功',
  'dokumenform.notify.errorTitle': '错误',
  'dokumenform.notify.failed': '失败',
  'dokumenform.notify.cannotUpload': '暂不能上传',
  'dokumenform.notify.saveRowFirst': '请先保存文档行，再替换文件。',
  'dokumenform.notify.formatNotSupported': '不支持的格式',
  'dokumenform.notify.onlyPdfExcel': '仅允许 PDF 或 Excel（.xlsx/.xls/.csv）文件。',
  'dokumenform.notify.uploaded': '{name} 已上传',
  'dokumenform.notify.uploadFailed': '文件上传失败',
  'dokumenform.notify.urlSaveFailed': '文档 URL 保存失败',
  'dokumenform.notify.documentAdded': '文档添加成功',
  'dokumenform.notify.documentUpdated': '文档更新成功',
  'dokumenform.notify.documentAddFailed': '保存新文档失败',
  'dokumenform.notify.documentEditFailed': '保存编辑后的文档失败',
  'dokumenform.notify.documentCopied': '文档复制成功',
  'dokumenform.notify.documentCopyFailed': '保存复制的文档失败',
  'dokumenform.notify.documentDeleted': '文档删除成功',
  'dokumenform.notify.documentDeleteFailed': '删除文档后保存更改失败',
  'dokumenform.notify.cannotDeleteLastDocument': '至少需要保留一份文件。CEISA 提交至少需要 2 份文件。',
  'dokumenform.notify.documentRestored': '文件恢复成功',
  'dokumenform.notify.documentRestoreFailed': '恢复文件失败',
  'dokumenform.notify.stateChangedTo': '文档状态已更改为 {state}',
  'dokumenform.notify.stateUpdateFailed': '更新文档状态失败',
  'dokumenform.notify.autoMatch': '自动匹配',
  'dokumenform.notify.noAutoMatch': '未找到此文档的确定匹配。请手动选择货物。',
  'dokumenform.notify.processIdNotFound': '未找到流程 ID',
  'dokumenform.notify.serialNotFound': '未找到文档序列号',
  'dokumenform.notify.attachedToBarang': '文档已附加到 {count} 个货物',
  'dokumenform.notify.attachedPartial':
    '文档已附加到 {requested} 个货物中的 {count} 个。{dropped} 个货物被拒绝，因为它们已附加到相同代码的其他文档。',
  'dokumenform.notify.attachFailed': '保存货物附件失败',
  'dokumenform.notify.pleaseSelectPdf': '请先选择 PDF 文件',
  'dokumenform.notify.pdfExtracted': '文档已从 PDF 成功提取',
  'dokumenform.notify.pdfExtractedWithEntitas': '文档已从 PDF 成功提取，实体标签页已同步更新',
  'dokumenform.notify.pdfUploadError': '上传 PDF 时发生错误',
  'dokumenform.notify.orderUpdated': '文档顺序更新成功',
  'dokumenform.notify.orderSaveFailed': '保存文档顺序失败',
  'dokumenform.notify.orderAlreadySorted': '文档顺序已正确',
  'dokumenform.notify.validationFailed': '验证失败',
  'dokumenform.notify.npwpRequired': 'eCOO 验证需要填写进口商 NPWP',
  'dokumenform.notify.npwpInvalid': '进口商 NPWP 无效',
  'dokumenform.notify.noDocsToValidate': '没有可验证的文档',
  'dokumenform.notify.ecooInvalid': 'eCOO 文档无效',
  'dokumenform.notify.ajuRequired': 'eCOO 验证需要填写 AJU 号码（提单号）',
  'dokumenform.notify.validationSuccess': '验证成功',
  'dokumenform.notify.ecooValidated': 'eCOO 验证成功',
  'dokumenform.notify.ecooValidationFailed': 'eCOO 验证失败',
  'dokumenform.notify.ecooError': '验证 eCOO 时发生错误',

  'dokumenform.barang.selectPrompt': '选择此文档应附加到的货物：',
  'dokumenform.barang.findingEcoo': '正在从 E-COO 行项目查找建议的货物…',
  'dokumenform.barang.finding': '正在为此文档查找建议的货物…',
  'dokumenform.barang.autoMatchShipment': '自动匹配：此托运为单一货物，因此此文档涵盖它（见下方徽章）——保存前请复查。',
  'dokumenform.barang.noAutoMatchEcoo': '未为此 E-COO 找到确定的自动匹配——请手动选择货物。',
  'dokumenform.barang.noAutoMatch': '未为此文档找到确定的自动匹配（配对不明确）——请手动选择货物。',
  'dokumenform.barang.colSeriBarang': '货物序号',
  'dokumenform.barang.colHsCode': 'HS 编码',
  'dokumenform.barang.colNamaBarang': '货物名称',
  'dokumenform.barang.colNoUrut': '许可序号',
  'dokumenform.barang.noItemsMatch': '没有与 HS 编码 "{hs}" 匹配的项目',
  'dokumenform.barang.noBarang': '没有可用货物。请先添加货物。',
  'dokumenform.barang.loading': '正在加载货物...',
  'dokumenform.barang.showingCount': '显示 {count} / {total} 个项目',
  'dokumenform.barang.filterDescription': '按 HS 编码筛选货物',
  'dokumenform.barang.replacePrompt':
    '自动匹配将用为此文档建议的集合替换当前选中的 {count} 个货物。在您点击保存前不会保存任何内容。',
  'dokumenform.barang.rangeDescription':
    '输入货物项目编号，用逗号分隔。使用短横线表示范围（例如 1-5 表示项目 1,2,3,4,5）',
  'dokumenform.barang.unamed': '未命名',
  'dokumenform.barang.suggestedCoverage': '建议 · {label}',
  'dokumenform.barang.suggestedConfidence': '建议 · {confidence} · {percent}%',
  'dokumenform.barang.ecooItem': 'E-COO 项目: {desc}',
  'dokumenform.popover.autoMatch': '自动匹配',
  'dokumenform.popover.loading': '加载中…',
  'dokumenform.popover.noAutoMatchData': '无自动匹配数据——已手动附加',
  'dokumenform.popover.seri': '序号 {n}',
  'dokumenform.popover.wholeShipment': '整个托运',
  'dokumenform.popover.sameHsCode': 'HS 编码相同 ·',
  'dokumenform.popover.andMore': '…还有 {n} 个',
  'dokumenform.popover.moreMatch': '{n} 个货物匹配此文档但未附加',
  'dokumenform.file.downloadAria': '下载 {name}',
  'dokumenform.file.replaceTooltip': '替换文件',
  'dokumenform.file.uploadTooltip': '上传文件',
  'dokumenform.file.replaceAria': '替换文件',
  'dokumenform.file.uploadAria': '上传文件',
  'dokumenform.file.uploading': '上传中…',
  'dokumenform.file.replaceUploading': '正在替换文件…',
  'dokumenform.file.noUrlInResponse': '响应中不包含新的文件 URL',
  'dokumenform.barang.statusSuggested': '已自动勾选 {count} / {total} 个货物。保存前请复查。',
  'dokumenform.barang.legend':
    '绿色徽章：与证书行项目匹配。黄色徽章：匹配度较弱。无徽章：未匹配，仅当证书涵盖时手动勾选。',
  'dokumenform.barang.legendWithCount':
    '绿色徽章：与证书行项目匹配。黄色徽章：证书行数与货物数相同，其余货物很可能也被涵盖。保存前请复查。',
  'dokumenform.barang.claimedNote': '{count} 个货物已附加到其他证书，无法在此勾选。如需移动，请先在那里解除。',
  'dokumenform.barang.showUnmatched': '查看 {count} 个未匹配的货物',
  'dokumenform.barang.hideUnmatched': '隐藏 {count} 个未匹配的货物',
  'dokumenform.barang.suggestedHigh': '建议 {percent}%',
  'dokumenform.barang.suggestedMedium': '可能匹配 {percent}%',
  'dokumenform.barang.suggestedCount': '建议，数量相同',
  'dokumenform.barang.countTooltip': '此证书有 {n} 行，与货物数量相同。该货物未按文本匹配，但很可能被涵盖。',
  'dokumenform.barang.suggestedHsCode': '建议，HS 编码相同',
  'dokumenform.barang.hsCodeTooltip': 'HS 编码与文件中列出的相同：{hs}',
  'dokumenform.barang.claimedBadge': '已在序号 {seri}',
  'dokumenform.barang.claimedTooltip': '该货物已附加到相同代码的序号 {seri} 文档。请先在那里解除，再移到此处。',
  'dokumenform.button.selectAll': '全选 ({n})',
  'dokumenform.button.deselectAll': '清空',
  'dokumenform.button.simpanCount': '保存（{n} 个货物）',
  'dokumenform.barang.more': '+{n} 更多',
  'dokumenform.confidence.overall': '总体置信度',
  'dokumenform.confidence.documentNumber': '文档编号置信度',
  'dokumenform.confidence.documentDate': '文档日期置信度',

  // <i18n-anchor-dokumenform>
  // <i18n-anchor-entitasform>
  'entitasform.entitas': '实体',
  'entitasform.nibWajibDiisi': 'NIB 必填',
  'entitasform.errNibImportirWajib': '进口商 NIB 必填',
  'entitasform.errNamaImportirWajib': '进口商名称必填',
  'entitasform.errJenisApiImportirWajib': '进口商 API 类型必填',
  'entitasform.errJenisIdentitasWajib': '证件类型必填',
  'entitasform.errNpwpImportirWajib': '进口商 NPWP 必填',
  'entitasform.errAlamatImportirWajib': '进口商地址必填',
  'entitasform.errStatusImportirWajib': '进口商状态必填',
  'entitasform.errFieldWajibDiisi': '此字段必填',
  'entitasform.successTitle': '成功',
  'entitasform.successMessage': '实体数据加载成功！',
  'entitasform.titlePemilikBarang': '货主',
  'entitasform.titlePemusatan': '集中地',
  'entitasform.titlePengirim': '发货人',
  'entitasform.titlePenjual': '卖方',
  'entitasform.titlePpjk': 'PPJK',
  'entitasform.actionSalinImportir': '复制进口商',
  'entitasform.actionSalinDataPengirim': '复制发货人数据',
  'entitasform.importir': '进口商',
  'entitasform.fieldJenis': '类型',
  'entitasform.fieldNpwp': 'NPWP {title}',
  'entitasform.fieldNama': '名称 {title}',
  'entitasform.fieldNegara': '国家 {title}',
  'entitasform.fieldAlamat': '地址 {title}',
  'entitasform.fieldStatus': '状态',
  'entitasform.fieldApiNib': 'API/NIB',
  'entitasform.fieldNib': 'NIB',
  'entitasform.fieldAfiliasi': '关联',
  'entitasform.syncDariJarvis': '从 Lumen 同步',
  'entitasform.syncPerluDiperiksa': '与最近一次申报不同 — 从 Lumen 获取数据',
  'entitasform.pilihDataDariJarvis': '从 Lumen 选择 {title} 数据',
  'entitasform.syncGagal': '同步失败',
  'entitasform.tidakAdaDataJarvis': 'Lumen 中此 NPWP 没有数据。',
  'entitasform.gagalSyncJarvis': '从 Lumen 同步数据失败。',
  'entitasform.npwpBelumLengkap': 'NPWP 不完整',
  'entitasform.npwpHarus16Digit': 'NPWP 必须为 16 位才能从 Lumen 同步。',
  'entitasform.diterapkan': '已应用',
  'entitasform.pilihDariRiwayat': '从文档历史中选择',
  'entitasform.dataConsigneeSumber': '收货人数据',
  'entitasform.bukaDiConsignee': '在收货人数据中打开',
  'entitasform.bukaConsignee': '打开收货人数据',
  'entitasform.riwayatDokumenCount': '文档历史（{count}）',
  'entitasform.diperbaruiTanggal': '更新于 {date}',
  'entitasform.belumAdaDiConsignee':
    '此进口商尚未在 主数据 › 收货人数据 中。文档成功提交到 CEISA 后，进口商数据将自动保存为主要来源。',
  'entitasform.belumAdaDiConsigneeSingkat': '尚未在收货人数据中。文档成功提交到 CEISA 后将自动保存。',
  'entitasform.dataMasterTidakBisaDitandai': '收货人数据在主数据菜单中管理，不能在此标记为错误。',
  'entitasform.riwayatTidakDapatDimuat': '无法加载文档历史',
  'entitasform.dibukaDiTabBaru': '在新标签页中打开：主数据 › 收货人数据',
  'entitasform.dataConsigneeSeksi': '收货人数据',
  'entitasform.consigneeTerpakai': '收货人数据已应用到进口商。',
  'entitasform.simpanKeConsignee': '保存到收货人数据',
  'entitasform.simpanKeConsigneeHint': '保存此进口商，下次文档将自动填写。',
  'entitasform.tersimpanKeConsignee': '已保存到收货人数据',
  'entitasform.tersimpanKeConsigneeMsg': '从现在起，此进口商将根据其 NPWP 自动填写。',
  'entitasform.consigneeSudahAda': '此 NPWP 已在收货人数据中。',
  'entitasform.gagalSimpanConsignee': '保存到收货人数据失败。',
  'entitasform.dataDiterapkanSection': 'Lumen 数据已应用到分区。',
  'entitasform.dataDiterapkanImportir': 'Lumen 数据已应用到进口商。',
  'entitasform.gagalMenyimpanEntitas': '保存实体失败',
  'entitasform.dataHistoricalBelumTersimpan': '历史数据已应用，但尚未保存。',
  'entitasform.disinkronDariRiwayat': '已从历史文档同步',
  'entitasform.dataDariDokumenSebelumnya': '此数据取自以前的文档。提交前请检查并调整。',
  'entitasform.optMita': 'MITA',
  'entitasform.optAeo': 'AEO',
  'entitasform.optLainnya': '其他',
  'entitasform.optApiU': 'API U',
  'entitasform.optApiP': 'API P',
  'entitasform.optPaspor': '2 - 护照',
  'entitasform.optKtp': '3 - 身份证',
  'entitasform.optLainnyaIdentitas': '4 - 其他',
  'entitasform.optNpwp15': '5 - NPWP 15 位',
  'entitasform.optNpwp16': '6 - NPWP 16 位',
  'entitasform.optAfl': 'AFL - 关联公司',
  'entitasform.optCtr': 'CTR - 财务/法律控制',
  'entitasform.optFam': 'FAM - 家庭成员',
  'entitasform.optTah': 'TAH - 无关联',
  // <i18n-anchor-kemasanform>
  'kemasanform.seri': '序号',
  'kemasanform.jumlah': '数量',
  'kemasanform.jenis': '类型',
  'kemasanform.merek': '品牌',
  'kemasanform.aksi': '操作',
  'kemasanform.nomor': '编号',
  'kemasanform.ukuran': '尺寸',
  'kemasanform.tipe': '型号',
  'kemasanform.kemasan': '包装',
  'kemasanform.petiKemas': '集装箱',
  'kemasanform.tambahKemasan': '添加包装',
  'kemasanform.tambahPetiKemas': '添加集装箱',
  'kemasanform.totalPetiKemas': '总计: {n}',
  'kemasanform.edit': '编辑',
  'kemasanform.copy': '复制',
  'kemasanform.delete': '删除',
  'kemasanform.required': '此字段为必填项！',
  'kemasanform.jenisOptionEmpty': '4 - 空箱',
  'kemasanform.jenisOptionLcl': '7 - 拼箱货',
  'kemasanform.jenisOptionFcl': '8 - 整箱货',
  'kemasanform.tipeOptionGeneralDry': '1 - 普通/干货',
  'kemasanform.tipeOptionTunnel': '2 - 隧道式',
  'kemasanform.tipeOptionOpenTop': '3 - 开顶钢制',
  'kemasanform.tipeOptionFlatRack': '4 - 平板架',
  'kemasanform.tipeOptionReefer': '5 - 冷藏/制冷',
  'kemasanform.tipeOptionBarge': '6 - 驳船集装箱',
  'kemasanform.tipeOptionBulk': '7 - 散装集装箱',
  'kemasanform.tipeOptionIsotank': '8 - 罐式集装箱',
  'kemasanform.tipeOptionLain': '99 - 其他',
  // PengangkutForm
  'pengangkutform.smartSync': '与 BC 1.1 智能同步',
  'pengangkutform.syncing': '同步中...',
  'pengangkutform.kodeTutupPu': '结关码',
  'pengangkutform.nomorBc11': 'BC 1.1 号码',
  'pengangkutform.tanggalTutupPu': '结关日期',
  'pengangkutform.nomorPos': '序号',
  'pengangkutform.nomorSubpos': '子序号',
  'pengangkutform.nomorSubsubpos': '子子序号',
  'pengangkutform.pengangkutan': '运输',
  'pengangkutform.caraPengangkutan': '运输方式',
  'pengangkutform.namaSaranaPengangkut': '运输工具名称',
  'pengangkutform.nomorVoyFlightNoPol': '航次/航班/车牌号',
  'pengangkutform.bendera': '船旗',
  'pengangkutform.perkiraanTanggalTiba': '预计抵达日期',
  'pengangkutform.cariBendera': '查找船旗',
  'pengangkutform.pelabuhanTempatPenimbunan': '港口与临时存放地',
  'pengangkutform.pelabuhanMuat': '装货港',
  'pengangkutform.pelabuhanTransit': '转运港',
  'pengangkutform.pelabuhanTujuan': '目的港',
  'pengangkutform.tempatPenimbunan': '临时存放地',
  'pengangkutform.noticeOfArrival': '到货通知',
  'pengangkutform.loadingData': '加载数据中...',
  'pengangkutform.useThisValue': '使用此值',
  'pengangkutform.uploading': '上传中...',
  'pengangkutform.maxFileSize': '最大文件大小：2MB',
  'pengangkutform.extractedInfo': '✓ 已提取信息',
  'pengangkutform.warehouse': '仓库:',
  'pengangkutform.invoiceNumber': '发票号码:',
  'pengangkutform.shipper': '发货人:',
  'pengangkutform.consignee': '收货人:',
  'pengangkutform.flagNameFromApi': '来自 API 的船旗名称',
  'pengangkutform.portOfLoadingFromApi': '来自 API 的装货港',
  'pengangkutform.notifError': '错误',
  'pengangkutform.notifSuccess': '成功',
  'pengangkutform.notifWarning': '警告',
  'pengangkutform.notifFileTooLarge': '文件过大',
  'pengangkutform.notifUploadSuccessful': '上传成功',
  'pengangkutform.notifPdfExtractionComplete': 'PDF 提取完成',
  'pengangkutform.notifUploadFailed': '上传失败',
  'pengangkutform.notifDocumentNotFound': '未找到文件',
  'pengangkutform.notifIncompleteDocument': '文件不完整',
  'pengangkutform.notifNoData': '无数据',
  'pengangkutform.notifApiError': 'API 错误',
  'pengangkutform.msgEnterVesselNameFirst': '请先输入船名',
  'pengangkutform.msgFlagFound': '找到船旗：{flag}',
  'pengangkutform.msgNoFlagInfo': '未找到此船舶的船旗信息',
  'pengangkutform.msgNoAirlineFlagInfo': '未识别该航空公司，请手动选择国籍',
  'pengangkutform.msgEnterAirlineFirst': '请先输入航空公司名称或航班号',
  'pengangkutform.msgFailedFetchFlag': '获取船舶船旗信息失败',
  'pengangkutform.msgFileTooLarge': '文件大小必须小于 2MB',
  'pengangkutform.msgBatchUuidNotFound': 'URL 中未找到 Batch UUID',
  'pengangkutform.msgUploadSuccessful': 'NOA 文件“{name}”上传成功',
  'pengangkutform.msgPdfExtractionComplete': '到货通知数据提取成功',
  'pengangkutform.msgUploadFailed': '上传 NOA 文件失败',
  'pengangkutform.msgNoBlDocument': '未找到 B/L (705) 文件。请先添加 B/L 文件。',
  'pengangkutform.msgBlIncomplete': 'B/L 文件必须包含号码和日期。',
  'pengangkutform.msgPopulatedFields': '已从 BC 1.1 舱单填充 {n} 个字段',
  'pengangkutform.msgNoManifestData': 'BC 1.1 舱单响应中未找到数据',
  'pengangkutform.msgFailedRetrieveManifest': '获取舱单数据失败',
  'pengangkutform.msgFailedCallManifest': '调用 BC 1.1 舱单 API 失败。请重试。',
  'pengangkutform.caraOpt1': '1 - 海运',
  'pengangkutform.caraOpt2': '2 - 铁路',
  'pengangkutform.caraOpt3': '3 - 公路',
  'pengangkutform.caraOpt4': '4 - 空运',
  'pengangkutform.caraOpt5': '5 - 邮政',
  'pengangkutform.caraOpt6': '6 - 多式联运',
  'pengangkutform.caraOpt7': '7 - 装置/管道',
  'pengangkutform.caraOpt8': '8 - 水路',
  'pengangkutform.caraOpt9': '9 - 其他',
  // <i18n-anchor-pengangkutform>
  // <i18n-anchor-transaksiform>
  'transaksiform.titleHarga': '价格',
  'transaksiform.warningPastikanValuta': '请确保币种正确',
  'transaksiform.labelValuta': '币种',
  'transaksiform.placeholderPilihValuta': '选择币种',
  'transaksiform.labelNdpbm': 'NDPBM',
  'transaksiform.placeholderNdpbm': 'NDPBM',
  'transaksiform.labelJenisTransaksi': '交易类型',
  'transaksiform.placeholderJenisTransaksi': '选择交易类型',
  'transaksiform.labelIncoterm': 'Incoterm',
  'transaksiform.placeholderIncoterm': '选择 Incoterm',
  'transaksiform.labelHargaBarang': '货物价值',
  'transaksiform.placeholderHargaBarang': '货物价值',
  'transaksiform.labelNilaiPabeanRupiah': '海关价值（卢比）',
  'transaksiform.placeholderNilaiPabeanRupiah': '海关价值（卢比）',
  'transaksiform.informasiKomponenBiaya': '费用构成信息',
  'transaksiform.titleHargaLainnya': '其他费用',
  'transaksiform.biayaPenambahan': '增加费用',
  'transaksiform.biayaPengurang': '减少费用',
  'transaksiform.freight': '运费',
  'transaksiform.labelAsuransi': '保险',
  'transaksiform.placeholderAsuransi': '保险',
  'transaksiform.nilaiAsuransi': '保险价值',
  'transaksiform.labelVoluntaryDeclaration': '自愿申报',
  'transaksiform.placeholderVoluntaryDeclaration': '自愿申报',
  'transaksiform.titleBerat': '重量',
  'transaksiform.labelBeratKotor': '毛重 (KGM)',
  'transaksiform.placeholderBeratKotor': '毛重 (KGM)',
  'transaksiform.labelBeratBersih': '净重 (KGM)',
  'transaksiform.placeholderBeratBersih': '净重 (KGM)',
  'transaksiform.helperNettoDihitung':
    '由商品总净重计算。可使用“对齐到毛重”进行调整，或在商品标签页填写每项净重。在净重 > 0 之前，交易标签保持黄色。',
  'transaksiform.buttonSamakanKeBeratKotor': '对齐到毛重',
  'transaksiform.tooltipSamakanKeBeratKotor': '调整第一项商品净重，使总净重等于毛重',
  'transaksiform.disabledSamakanBrutoKosong': '请先填写毛重',
  'transaksiform.disabledSamakanTidakAdaBarang': '没有可对齐的商品',
  'transaksiform.modalSamakanTitle': '将净重对齐到毛重',
  'transaksiform.modalSamakanBeratKotor': '毛重',
  'transaksiform.modalSamakanTotalNetto': '当前总净重',
  'transaksiform.modalSamakanItem': '将更改的商品',
  'transaksiform.modalSamakanNettoLama': '原净重',
  'transaksiform.modalSamakanNettoBaru': '新净重',
  'transaksiform.modalSamakanConfirm': '对齐',
  'transaksiform.modalSamakanCancel': '取消',
  'transaksiform.hintNettoTidakSamaBruto': '净重与毛重不一致。请使用上方按钮对齐。',
  'transaksiform.errSamakanFirstNegatif': '其他商品的净重已超过毛重。请先在商品标签页减少净重。',
  'transaksiform.errSamakanTidakAdaBarang': '没有可对齐的商品',
  'transaksiform.errSamakanBrutoKosong': '毛重必须大于 0',
  'docpabean.tabs.mandatoryFilled': '已填写 {filled} / {total} 个必填栏位。',
  'docpabean.tabs.hargaMismatchTooltip':
    '总价不一致：商品标签页 {barang} {valuta}（{seri} 项），交易标签页 {harga} {valuta}，相差 {selisih} {valuta}。请打开交易标签页对齐。',
  'transaksiform.hintHargaTidakSamaBarang':
    '商品标签页的总价值（{seri} 项，{barang} {valuta}）与此处的货物价格（{harga} {valuta}）不一致，相差 {selisih} {valuta}。',
  'transaksiform.buttonSamakanHargaBarang': '与商品标签页总额对齐',
  'transaksiform.modalSamakanHargaTitle': '将货物价格对齐到商品总额',
  'transaksiform.modalSamakanHargaSekarang': '当前货物价格',
  'transaksiform.modalSamakanHargaTotalBarang': '商品标签页总价值（{seri} 项）',
  'transaksiform.modalSamakanHargaSelisih': '差额',
  'transaksiform.modalSamakanHargaPenjelasan': '货物价格将填入商品标签页的总价值，各项商品明细不会更改。',
  'transaksiform.modalSamakanHargaCatatanBiaya':
    '注意：运费 {freight} {valuta} 与保险费 {asuransi} {valuta} 单独填写。请确认商品标签页的总额尚未包含这两项，以免完税价格重复计算。',
  'transaksiform.hargaSamakanApplied': '货物价格已按商品标签页总额填入 {amount} {valuta}',
  'transaksiform.errHargaSamakanGagal': '对齐货物价格失败，请重试。',
  'transaksiform.errNettoHarusLebihDari0': '净重必须大于 0 — 请在商品标签页填写每项净重',
  'transaksiform.errNettoLebihDariBruto': '净重不能大于毛重',
  'transaksiform.warningTitle': '警告',
  'transaksiform.errNdpbmRetrieve': '无法获取 NDPBM 值。请手动输入。',
  'transaksiform.errorTitle': '错误',
  'transaksiform.errNdpbmFetch': '获取 NDPBM 时出错',
  'transaksiform.confGrossWeight': '毛重置信度',
  'transaksiform.confCurrency': '币种置信度',
  'transaksiform.confIncoterm': 'Incoterm 置信度',
  'transaksiform.confHargaBarang': '货物价值置信度',
  'transaksiform.confFreight': '运费置信度',
  'transaksiform.confInsurance': '保险价值置信度',
  'transaksiform.confNdpbm': '汇率置信度',
  'transaksiform.confCif': 'CIF价值置信度',
  'transaksiform.confNetto': '净重置信度',
  // BarangForm — 货物清单（货物表格）
  'barangform.notifError': '错误',
  'barangform.notifSuccess': '成功',
  'barangform.notifInfo': '提示',
  'barangform.minOneBarang': '至少必须添加一件货物才能继续',
  'barangform.seriUraianKosong': '货号 [{seri}] 的描述为空',
  'barangform.seriSatuanKosong': '货号 [{seri}] 的计量单位为空',
  'barangform.seriKodeSatuanKosong': '货号 [{seri}] 的计量单位代码为空',
  'barangform.seriNegaraKosong': '货号 [{seri}] 的原产国为空',
  'barangform.seriHsKosong': '货号 [{seri}] 的 HS 编码为空',
  'barangform.seriHs8Digit': '货号 [{seri}] 的 HS 编码必须为 8 位',
  'barangform.gagalMenghapusDokumen': '删除文件失败',
  'barangform.noItemsSelected': '未选择任何项目',
  'barangform.updatedCount': '{count} 个项目已更新',
  'barangform.bulkEditFailed': '批量编辑失败',
  'barangform.seriBarangRequired': '必须填写货号',
  'barangform.dataBerhasilDiperbarui': '货物数据已成功更新',
  'barangform.gagalMemperbaruiData': '更新货物数据失败',
  'barangform.fetchHsDetailsFailed': '获取 HS 编码详情失败',
  'barangform.fetchHsDetailsError': '获取 HS 编码详情时出错',
  'barangform.itemBerhasilDihapus': '项目已成功删除',
  'barangform.gagalMenghapusItem': '删除项目失败',
  'barangform.tidakAdaItemDipilih': '未选择任何项目',
  'barangform.itemBerhasilDihapusCount': '{count} 个项目已成功删除',
  'barangform.itemBerhasilDisalin': '项目已成功复制',
  'barangform.gagalMenyalinItem': '复制项目失败',
  'barangform.loadItemEditFailed': '加载待编辑项目失败',
  'barangform.processIdNotFound': '未找到流程 ID',
  'barangform.downloadSuccess': '下载成功！',
  'barangform.downloadFailed': '下载失败！',
  'barangform.pilihFilePdf': '请先选择 PDF 文件',
  'barangform.processIdTidakDitemukan': '未找到流程 ID',
  'barangform.invoiceUploadSuccess': '发票已上传并正在处理中',
  'barangform.uploadInvoiceError': '上传发票时出错',
  'barangform.noItemsToCheck': '没有可检查的项目',
  'barangform.noDuplicateDescriptions': '未发现重复的描述',
  'barangform.foundDuplicates': '发现 {count} 个项目存在重复描述',
  'barangform.tidakAdaBarangSync': '没有可同步的货物',
  'barangform.tidakAdaHsValid': '没有有效的 HS 编码可同步',
  'barangform.syncProsesDimulai': '已开始同步 {count} 个 HS 编码。请等待完成。',
  'barangform.gagalMemulaiSync': '开始同步失败：{msg}',
  'barangform.tidakAdaHsCodeSync': '没有可同步的 HS 编码',
  'barangform.hsCodeSyncCount': '{count} 个 HS 编码已成功同步',
  'barangform.hsCodeSyncErrorSuffix': '，{count} 个错误',
  'barangform.gagalSyncTarifInsw': '与 INSW 同步税费失败',
  'barangform.processIdTidakTersedia': '流程 ID 不可用。请刷新页面。',
  'barangform.processIdTidakTersediaSingkat': '流程 ID 不可用',
  'barangform.noItemsToSync': '没有可同步的项目',
  'barangform.gagalSimpanSebelumSync': '同步前保存货物数据失败',
  'barangform.smartSyncSukses': '智能同步已成功完成',
  'barangform.smartSyncGagal': '智能同步失败',
  'barangform.noValidHsSync': '未找到可同步的有效 HS 编码',
  'barangform.lartasStatusUpdated': '已为 {count} 个项目更新 LARTAS 状态',
  'barangform.lartasAlreadyUpToDate': 'LARTAS 状态已是最新',
  'barangform.gagalAmbilLartas': '获取 LARTAS 数据失败',
  'barangform.gagalSyncLartas': '同步 LARTAS 数据失败',
  'barangform.itemDariDatabaseSukses': '已成功从数据库添加项目！',
  'barangform.gagalItemDatabase': '从数据库添加项目失败',
  'barangform.cifBerhasil': '已成功计算按比例分摊的费用',
  'barangform.gagalHitungCif': '计算按比例分摊的费用失败',
  'barangform.fobBerhasil': '已成功应用 FOB 价格',
  'barangform.gagalTerapkanFob': '应用 FOB 价格失败',
  'barangform.itemUpdatedApplied': '项目已更新，更改已应用于 {count} 个具有相同或空 HS 编码的项目',
  'barangform.itemUpdatedNoApply': '项目已更新。没有其他项目具有匹配或空的 HS 编码可应用更改。',
  'barangform.gagalSimpanServer': '保存更改到服务器失败。请重试。',
  'barangform.itemAddedSukses': '项目已成功添加',
  'barangform.gagalSimpanItemBaru': '保存新项目到服务器失败。请重试。',
  'barangform.syncedTooltip': '数据取自先前文档',
  'barangform.syncedFromAjuLabel': '从 Aju {aju} 同步',
  'barangform.syncedFromDraftLabel': '从草稿 {id} 同步',
  'barangform.cekTarifInsw': '正在检查 INSW 税费...',
  'barangform.inswCocok': 'INSW 税费匹配（{kind}：{value}%）',
  'barangform.inswBerbeda': 'INSW 税费不同 — INSW {kind}：{value}%',
  'barangform.memuatDetailHs': '正在加载 HS 详情...',
  'barangform.lihatDetailHs': '查看 HS 详情',
  'barangform.hsPick': '从运输单据选择 HS 编码',
  'barangform.hsPickFailed': '无法保存所选的 HS 编码',
  'barangform.lartas': 'Lartas',
  'barangform.non': '非',
  'barangform.unnamedItem': '未命名项目',
  'barangform.justNow': '刚刚',
  'barangform.hoursAgo': '{count} 小时前',
  'barangform.oneDayAgo': '1 天前',
  'barangform.daysAgo': '{count} 天前',
  'barangform.hsCodeKosong': 'HS 编码为空',
  'barangform.tidakAdaHsCodeDicari': '没有可搜索的 HS 编码。',
  'barangform.prefTarif': '{pref} {year}：{nilai} 对比 BM {bm}%',
  'barangform.prefNoTarif': '{pref} — {year} 年没有税率',
  'barangform.skbPphBadge': 'PPh 免征',
  'barangform.skbPphApplied': '已关联 SKB PPh — PPh 免征（优惠代码 5），税率 {tarif}% 保留记录。',
  'barangform.skbPphAppliedNoDoc': 'PPh 免征（优惠代码 5）但未关联 SKB PPh 单证 — 提交前请确认单证页签中有 SKB。',
  'barangform.skbPphPending': '已关联 SKB PPh，但免征优惠尚未应用到此货物 — 请打开税费页签或运行同步 HS 税率。',
  'barangform.skbPpnBadge': 'PPN 免征',
  'barangform.skbPpnApplied': '已关联 SKB PPN — PPN 免征（优惠代码 5），税率 {tarif}% 保留记录，应缴 PPN 为 0。',
  'barangform.skbPpnAppliedNoDoc': 'PPN 免征（优惠代码 5）但未关联 SKB PPN 单证 — 提交前请确认单证页签中有 SKB。',
  'barangform.skbPpnPending': '已关联 SKB PPN，但免征优惠尚未应用到此货物 — 请打开税费页签或运行同步 HS 税率。',
  'barangform.editLabel': '编辑',
  'barangform.copyLabel': '复制',
  'barangform.deleteLabel': '删除',
  'barangform.colSeri': '序号',
  'barangform.colGroup': '组',
  'barangform.colHs': 'HS',
  'barangform.colLartas': 'Lartas',
  'barangform.lartasUnverified': '需核查',
  'barangform.colUraian': '描述',
  'barangform.colTotalNilai': '总价值',
  'barangform.colNw': '净重',
  'barangform.colSatuan': '单位',
  'barangform.colKemasan': '包装',
  'barangform.kemasanMismatchDetail': '{count} 行商品使用包装 {codes}，而“包装与集装箱”标签页申报的是 {target}。',
  'barangform.kemasanMismatchApply': '全部改为 {target}',
  'barangform.kemasanMismatchApplying': '正在统一...',
  'barangform.kemasanMismatchDismiss': '忽略',
  'barangform.kemasanMismatchNoCode': '无代码',
  'barangform.kemasanMismatchDone': '{count} 行商品的包装已改为 {target}。',
  'barangform.kemasanMismatchFailed': '统一商品包装失败。',

  // 商品标签页的 6 位 HS 编码建议
  'barangform.hsShortSummary': '{codes} 个 HS 编码不足 8 位，涉及 {rows} 行。CEISA 只接受 8 位编码。',
  'barangform.hsShortRows': '{count} 行（序号 {seri}）',
  'barangform.hsShortPick': '选择 8 位编码（{count} 个选项）',
  'barangform.hsShortModalTitle': '为 {heading} 选择 8 位 HS 编码',
  'barangform.hsShortModalIntro':
    '印尼税则（BTKI）在 {heading} 下收录了以下编码。所选编码将一次性应用于 {count} 行（序号 {seri}）。',
  'barangform.hsShortCatchAll': '其他',
  'barangform.hsShortInactive': '未启用',
  'barangform.hsShortInactiveSome': '未启用 = 最近一次 INSW 同步中没有该编码，并不表示不能申报。',
  'barangform.hsShortInactiveAll':
    '该品目下所有编码在最近一次 INSW 同步中均未启用 —— 我们的 BTKI 数据（2022）可能已过时，使用前请先核对。',
  'barangform.hsShortUserEdited': '其中 {count} 行曾手动修改（序号 {seri}），也会被覆盖。',
  'barangform.hsShortCancel': '取消',
  'barangform.hsShortConfirm': '应用于 {count} 行',
  'barangform.hsShortDone': '{count} 行已从 {heading} 改为 {code}。',
  'barangform.hsShortDoneSkipped': '{count} 行已改为 {code}。{skipped} 行因已变更而跳过。',
  'barangform.hsShortFailed': '应用 HS 编码建议失败。',
  'barangform.colDok': '文件',
  'barangform.colPpn': 'PPN',
  'barangform.colPph': 'PPH',
  'barangform.colBm': 'BM',
  'barangform.colAction': '操作',
  'barangform.colJenisDokumen': '文件类型',
  'barangform.colKode': '代码',
  'barangform.colNomorDokumen': '文件编号',
  'barangform.colTanggal': '日期',
  'barangform.colKodeFasilitas': '设施代码',
  'barangform.colNamaFasilitas': '设施名称',
  'barangform.colKodeIjin': '许可代码',
  'barangform.hapusBarangTitle': '删除货物',
  'barangform.tindakanTidakBisaDibatalkan': '此操作无法撤销',
  'barangform.konfirmasiHapusBarang': '您确定要删除以下货物吗？',
  'barangform.konfirmasiHapusMany': '您确定要删除选中的 {count} 件货物吗？',
  'barangform.labelSeri': '序号：',
  'barangform.labelUraian': '描述：',
  'barangform.labelHsCode': 'HS 编码：',
  'barangform.cancel': '取消',
  'barangform.deleting': '删除中...',
  'barangform.delete': '删除',
  'barangform.hapusCountTitle': '删除 {count} 件货物',
  'barangform.hapusCountItem': '删除 {count} 个项目',
  'barangform.labelJumlahItem': '项目数量：',
  'barangform.jumlahItemCount': '{count} 个项目',
  'barangform.labelSeriBarang': '货号：',
  'barangform.lagiSuffix': '，...（+{count} 更多）',
  'barangform.hsCodeDetailsTitle': 'HS 编码详情',
  'barangform.tabBasicInfo': '基本信息',
  'barangform.tabTariffRates': '税率',
  'barangform.tabPreferentialCount': '优惠税率（{count}）',
  'barangform.labelCode': '代码：',
  'barangform.labelNormalizedCode': '标准化代码：',
  'barangform.labelIdDescription': '印尼语描述：',
  'barangform.labelEnDescription': '英文描述：',
  'barangform.labelInswYear': 'INSW 年份：',
  'barangform.labelLartas': 'LARTAS：',
  'barangform.yes': '是',
  'barangform.no': '否',
  'barangform.labelPpnBm': 'PPN BM',
  'barangform.na': '无',
  'barangform.placeholderSearchPrefTariffs': '搜索优惠税率...',
  'barangform.labelIssueDate': '发布日期：',
  'barangform.labelEffective': '生效日期：',
  'barangform.nowSuffix': '（当前）',
  'barangform.labelHistoricalRates': '历史税率：',
  'barangform.loadingHsDetails': '正在加载 HS 编码详情...',
  'barangform.dokumenTerlampir': '附带文件',
  'barangform.seriInfoLine': '序号 {seri}：{uraian}',
  'barangform.dokumenFallback': '文件 {kode}',
  'barangform.deleteAttachmentAria': '删除附件',
  'barangform.tidakAdaDokumenTerlampir': '此货物没有附带的文件',
  'barangform.memuatDataBarang': '正在加载货物数据...',
  'barangform.menyalinDataBarang': '正在复制货物数据...',
  'barangform.tambahBarang': '添加货物',
  'barangform.editBarang': '编辑货物',
  'barangform.editMassalCount': '批量编辑 {count} 个项目',
  'barangform.bulkEditHint': '选择要为所有选中项目更改的字段。留空以保留现有值。',
  'barangform.hsCodeField': 'HS 编码',
  'barangform.placeholderPilihHs': '为选中的项目选择新的 HS 编码...',
  'barangform.nonLartasLabel': '非 LARTAS',
  'barangform.kodeSatuanField': '计量单位代码',
  'barangform.placeholderPilihSatuan': '为选中的项目选择新的计量单位代码...',
  'barangform.kodeKemasanField': '包装代码',
  'barangform.placeholderPilihKemasan': '为选中的项目选择新的包装代码...',
  'barangform.kodeNegaraField': '国家代码',
  'barangform.placeholderPilihNegara': '为选中的项目选择新的国家代码...',
  'barangform.tarifPungutan': '税费（征费）',
  'barangform.aturTarifHint': '为选中的项目设置 PPN、PPH 和 BM 税率',
  'barangform.labelPpnPct': 'PPN (%)',
  'barangform.labelPphPct': 'PPH (%)',
  'barangform.labelBmPct': 'BM (%)',
  'barangform.fasilitasPpnField': 'PPN 设施',
  'barangform.fasilitasPphField': 'PPH 设施',
  'barangform.fasilitasBmField': 'BM 设施',
  'barangform.placeholderPilihFasilitas': '选择设施...',
  'barangform.fasByr': '1 - BYR - 已支付',
  'barangform.fasDtp': '2 - 由政府承担',
  'barangform.fasBbs': '5 - BBS - 已豁免',
  'barangform.fasTidakDipungut': '6 - 不征收',
  'barangform.fasDilunasi': '7 - 已结清',
  'barangform.fasDitunda': '9 - 延后',
  'barangform.terapkanPerubahan': '应用更改',
  'barangform.resyncTarifTitle': '重新同步税率数据库',
  'barangform.tersisa': '剩余',
  'barangform.syncingTarif': '正在同步税率...',
  'barangform.resyncDescription': '系统正在从 INSW 数据库下载并更新您货物表格中 HS 编码的税率数据。',
  'barangform.harapTunggu': '请等待流程完成。请勿关闭此页面。',
  'barangform.syncSelesai': '同步完成！',
  'barangform.resyncSelesaiDesc': '税率数据已成功更新。请点击智能同步以将最新税率应用到货物表格。',
  'barangform.selesai': '完成',
  'barangform.loadingBarangData': '正在加载货物数据...',
  'barangform.totalCount': '总计：{count}',
  'barangform.labelHsCodes': 'HS 编码：',
  'barangform.filteredCount': '已筛选：{count}',
  'barangform.duplicatesCount': '重复：{count}',
  'barangform.withDocumentsCount': '有文件：{count}',
  'barangform.lartasCount': 'Lartas：{count}',
  'barangform.nonLartasCount': '非 Lartas：{count}',
  'barangform.selectedCount': '已选：{count}',
  'barangform.editMassal': '批量编辑',
  'barangform.editBtn': '编辑',
  'barangform.hapusMassal': '批量删除',
  'barangform.batalPilih': '取消选择',
  'barangform.duplikat': '复制',
  'barangform.duplikatMassal': '批量复制',
  'barangform.duplikatTitle': '复制商品',
  'barangform.duplikatSelected': '已选择 {count} 行',
  'barangform.duplikatCopiesLabel': '每行副本数',
  'barangform.duplikatCopiesHint': '每个选中的行将被复制此数量，并添加到列表末尾（最多 {max}）。',
  'barangform.duplikatCopiesInvalid': '请输入 1 – {max}',
  'barangform.duplikatAdded': '+{count} 新行',
  'barangform.duplikatTotal': '总计：{from} → {to} 项商品',
  'barangform.duplikatWillAdd': '将增加：',
  'barangform.duplikatTotalsNote': '表头/交易中的总计不会自动更改。请之后调整每行的数量/金额。',
  'barangform.duplikatConfirm': '复制 {count}',
  'barangform.duplikatBerhasil': '已成功复制 {count} 行（序号 {first}–{last}）',
  'barangform.duplikatGagal': '复制商品失败',
  'barangform.pilihHalamanIni': '已选择本页 {count} 行。',
  'barangform.pilihSemuaN': '选择全部 {count} 项商品',
  'barangform.semuaDipilih': '已选择全部 {count} 项商品。',
  'barangform.placeholderCari': '按描述或 HS 编码搜索...',
  'barangform.filterOptions': '筛选选项',
  'barangform.filterHasDocument': '有文件的货物',
  'barangform.lartasStatus': 'Lartas 状态',
  'barangform.filterLartas': 'Lartas 货物',
  'barangform.filterNonLartas': '非 Lartas 货物',
  'barangform.showingCount': '显示 {count} 个项目',
  'barangform.sortBySeri': '按货号排序',
  'barangform.sortByHs': '按 HS 编码排序',
  'barangform.sortedBySeriMsg': '货物已按货号排序',
  'barangform.sortedByHsMsg': '货物已按 HS 编码排序',
  'barangform.legendBarang': '货物',
  'barangform.bulkUpdate': '批量更新',
  'barangform.uploadInvoice': '上传发票',
  'barangform.legendTarif': '税费',
  'barangform.smartSync': '智能同步',
  'barangform.detailTarif': '税费详情',
  'barangform.hitungHargaProporsional': '计算按比例价格',
  'barangform.kembalikanHargaSemula': '恢复原始价格',
  'barangform.labelFileInvoice': '发票文件（PDF）',
  'barangform.placeholderPilihFilePdf': '选择 PDF 文件',
  'barangform.uploadExtract': '上传并提取',
  'barangform.goTo': '转到',
  'barangform.go': '跳转',
  // <i18n-anchor-barangform>
  // PungutanForm
  'pungutanform.title': '税费',
  'pungutanform.generate': '生成税费',
  'pungutanform.total': '税费合计：',
  'pungutanform.colJenisPungutan': '税费类型',
  'pungutanform.colFasilitas': '设施',
  'pungutanform.colNilaiPungutan': '税费金额（IDR）',
  'pungutanform.fasilitas.dibayar': '已支付',
  'pungutanform.fasilitas.ditanggung': '由政府承担',
  'pungutanform.fasilitas.ditunda': '已延期',
  'pungutanform.fasilitas.tidakDipungut': '不予征收',
  'pungutanform.fasilitas.dibebaskan': '已免除',
  'pungutanform.notif.errorTitle': '错误',
  'pungutanform.notif.noProcessId': '流程 ID 不可用，无法计算税费',
  'pungutanform.notif.successTitle': '成功',
  'pungutanform.notif.generated': '项税费已成功生成',
  'pungutanform.notif.calculated': '项税费已根据货物与税率计算',
  'pungutanform.notif.infoTitle': '提示',
  'pungutanform.notif.noData': '没有税费数据',
  'pungutanform.notif.failTitle': '失败',
  'pungutanform.notif.failGenerate': '生成税费失败',
  // Pre-AJU local calculation readiness (issue #237)
  'pungutanform.readiness.ready': '可计算',
  'pungutanform.readiness.estimate': '预估值',
  'pungutanform.readiness.partial': '部分未计算',
  'pungutanform.readiness.blocked': '暂无法计算',
  'pungutanform.readiness.detail.ready': '根据草稿的税率与汇率在本地计算。提交 AJU 后以 CEISA 的数值为准。',
  'pungutanform.readiness.detail.estimate':
    '按预估 CIF 在本地计算（运费与保险费按比例分摊）。提交 AJU 后以 CEISA 的数值为准。',
  'pungutanform.readiness.detail.blocked': '该草稿暂时无法计算税费。',
  'pungutanform.readiness.detail.partialSuffix': '仍有 {count} 项货物未纳入计算。',
  'pungutanform.readiness.reason.barangKosong': '草稿尚无货物数据。',
  'pungutanform.readiness.reason.tarifBelumSinkron': 'HS 税率尚未同步，没有可用的进口税/增值税/所得税税率。',
  'pungutanform.readiness.reason.kursBelumAda': '交易页尚未填写汇率（NDPBM），货值无法折算为印尼盾。',
  'pungutanform.readiness.reason.nilaiBarangKosong': '货值仍为 0，缺少计算依据。',
  'pungutanform.readiness.valuta': '币种',
  'pungutanform.readiness.ndpbm': '汇率',
  'pungutanform.readiness.ndpbmFromCeisa': 'CEISA 汇率 — 尚未保存到交易页',
  'pungutanform.readiness.tarifSource': '税率来源',
  'pungutanform.readiness.source.saved': '已保存税率',
  'pungutanform.readiness.source.hsTariffs': 'HS 税率表',
  'pungutanform.readiness.source.mixed': '混合来源',
  'pungutanform.readiness.source.none': '-',
  'pungutanform.readiness.missingCodes': '缺少税率的 HS 编码',
  'pungutanform.readiness.andMore': '(另有 {count} 个)',
  'pungutanform.readiness.syncTarif': '同步 HS 税率',
  'pungutanform.readiness.syncDone': 'HS 税率同步完成',
  'pungutanform.readiness.syncFailed': 'HS 税率同步失败',
  'pungutanform.readiness.unsavedTarif':
    '{count} 项货物的税率来自 HS 税率表和单证优惠，尚未保存到货物 — 同步时自动保存（需要 Master CEISA 权限）。',
  'pungutanform.readiness.ambiguousPreferential':
    '第 {seri} 项货物的优惠税率（BM 优惠）未自动应用，因为优惠数据相互矛盾 — BM 采用普通税率 (MFN)；请手动核对 BM 优惠。',
  'pungutanform.readiness.pphExempt':
    '{count} 项货物（第 {seri} 项）因已关联 SKB PPh / SKB PP 23 而免征 PPh — 列为 PPH 优惠代码 5（已免除）行。',
  'pungutanform.readiness.ppnExempt':
    '{count} 项货物（第 {seri} 项）因已关联 SKB PPN 而免征 PPN — 列为 PPN 优惠代码 5（已免除）行。',
  // PernyataanForm
  'pernyataanform.title': '声明',
  'pernyataanform.titleSync': '同步声明',
  'pernyataanform.syncing': '同步中...',
  'pernyataanform.declarationHeader': '兹声明如下：',
  'pernyataanform.statement1': '本人对本文件中所申报内容的真实性及作为本文件编制依据的报关补充文件的有效性负责；并且',
  'pernyataanform.statement2':
    '若在货物准备就绪通知日期后最迟 1（一）日内，本人未出席见证现场查验，则本人授权 TPS 经营者代为见证，由此产生的风险和费用由本人承担。',
  'pernyataanform.signerInfo': '签署人信息',
  'pernyataanform.nama': '姓名',
  'pernyataanform.tanggal': '日期',
  'pernyataanform.placeholderTanggal': '日期',
  'pernyataanform.tempat': '地点',
  'pernyataanform.jabatan': '职务',
  'pernyataanform.errorNamaTtd': '必须填写签署人姓名',
  'pernyataanform.errorTanggalTtd': '必须填写签署日期',
  'pernyataanform.errorKotaTtd': '必须填写签署地点',
  'pernyataanform.errorJabatanTtd': '必须填写签署人职务',
  'pernyataanform.notifySuccessTitle': '成功',
  'pernyataanform.notifySuccessMessage': '声明数据已成功同步',
  'pernyataanform.notifyErrorTitle': '错误',
  'pernyataanform.notifyErrorSyncMessage': '声明数据同步失败',
  'pernyataanform.notifyErrorGeneralMessage': '同步声明数据时出错',
  'pernyataanform.notifyNoStatementTitle': '尚未设置声明',
  'pernyataanform.notifyNoStatementMessage': '贵 PPJK 尚未设置声明。请在 Master → Pernyataan 中填写后再同步。',

  // Subscription: free trial
  'subscription.trial.badge.active': '免费试用',
  'subscription.trial.badge.ended': '试用已结束',
  'subscription.trial.free': '免费',
  'subscription.trial.endsOn': '试用结束日期',
  'subscription.trial.cost': '费用',
  'subscription.trial.running.title': '免费试用进行中',
  'subscription.trial.running.daysLeft': '还剩 {n} 天。',
  'subscription.trial.running.endsToday': '试用今天结束。',
  'subscription.trial.running.body': '试用结束后，新的申报将被停用，直到您订阅套餐。',
  'subscription.trial.running.cta': '查看订阅套餐',
  'subscription.trial.header.daysLeft': '免费试用：还剩 {n} 天',
  'subscription.trial.header.endsToday': '免费试用：最后一天',
  'subscription.trial.header.ended': '免费试用已结束',
  'subscription.trial.strip.soon': '免费试用将在 {n} 天后结束。',
  'subscription.trial.strip.today': '免费试用今天结束。',
  'subscription.trial.strip.ended': '免费试用已结束。',
  'subscription.trial.strip.soonDetail': '之后新的申报将被停用，直到您订阅套餐。',
  'subscription.trial.strip.endedDetail': '新的申报已停用，直到您订阅套餐。',
  'subscription.trial.contactSales': '联系销售',
  'subscription.trial.contactSales.message':
    'Halo Sales Lumen, masa uji coba gratis perusahaan kami akan segera berakhir. Saya ingin berlangganan paket Lumen.',
  'subscription.trial.ended.title': '免费试用已结束',
  'subscription.trial.ended.body':
    '您的账户已停止新的申报{since}。无需支付任何账单，请选择订阅套餐以继续使用服务。试用期剩余额度不会转入付费套餐。',
  'subscription.trial.ended.since': '（自 {date} 起）',
  'subscription.trial.ended.cta': '选择订阅套餐',
  'subscription.trial.picker.title': '继续使用付费套餐',
  'subscription.trial.picker.subtitleRunning':
    '您的试用仍在进行中。现在订阅可确保试用结束后服务不中断。试用期剩余额度不会转入付费套餐。',
  'subscription.trial.picker.subtitleEnded': '试用已结束，您的账户已被停用。请选择下方套餐以恢复服务。',
  'subscription.invoice.trialBadge': '免费试用',
  'subscription.invoice.free': '免费',
  // Subscription page + billing components
  'subscription.page.title': '订阅',
  'subscription.page.subtitle': '管理您的订阅套餐和月度账单',
  'subscription.page.loadingSubscription': '正在加载订阅数据...',
  'subscription.page.loadingPlans': '正在加载订阅套餐...',
  'subscription.common.error': '发生错误',
  'subscription.card.title': '订阅',
  'subscription.card.currentPeriod': '当前周期',
  'subscription.card.nextBilling': '下次账单',
  'subscription.card.pricePerMonth': '每月价格',
  'subscription.card.quotaTitle': '每月额度',
  'subscription.card.col.product': '产品',
  'subscription.card.col.quotaPerPeriod': '每周期额度',
  'subscription.card.col.used': '已使用',
  'subscription.card.col.balance': '当前余额',
  'subscription.card.credits': '额度',
  'subscription.card.usedOf': '已使用 {used}/{quota}',
  'subscription.card.balanceError': '无法加载额度余额',
  'subscription.card.override': '专属',
  'subscription.card.noQuota': '此套餐不含额度',
  'subscription.status.active': '生效中',
  'subscription.status.pending': '等待付款',
  'subscription.status.unpaid': '未付款',
  'subscription.status.cancelled': '已取消',
  'subscription.cancel.button': '取消订阅',
  'subscription.cancel.confirm.title': '取消订阅？',
  'subscription.cancel.confirm.body': '您可以继续使用积分直到 {date}。订阅结束后将不再从您的银行卡扣款。',
  'subscription.cancel.confirm.titleImmediate': '立即取消订阅？',
  'subscription.cancel.confirm.bodyImmediate':
    '首期账单尚未支付，订阅还未生效，因此将立即取消。待付账单会一并作废，不会产生任何扣款，也不会发放积分。您可以随时重新订阅。',
  'subscription.cancel.toast.periodEnd.title': '操作成功',
  'subscription.cancel.toast.periodEnd.body': '订阅将不再续费。积分在本周期结束前仍可使用。',
  'subscription.cancel.toast.immediate.title': '订阅已取消',
  'subscription.cancel.toast.immediate.body': '待付账单已作废，未产生任何扣款。',
  'subscription.cancel.toast.error.title': '错误',
  'subscription.cancel.toast.error.body': '取消订阅失败，请重试。',
  'subscription.cancel.confirm.back': '返回',
  'subscription.cancel.confirm.confirm': '是的，取消',
  'subscription.cancel.endsOn': '{date} 结束',
  'subscription.cancel.cancelling.title': '已停止自动续费',
  'subscription.cancel.cancelling.body': '订阅将持续有效至 {date}。不再自动扣款，可随时重新订阅。',
  'subscription.cancel.cancelling.cta': '查看套餐',
  'subscription.cancel.picker.title': '重新订阅',
  'subscription.cancel.picker.subtitle': '选择套餐以继续服务。',
  'subscription.alert.unpaid.title': '账户已停用，请尽快付款',
  'subscription.alert.unpaid.body': '您的订阅尚未付款{since}。账户将被停用直到账单结清。请在下方账单区完成付款。',
  'subscription.alert.unpaid.since': '（自 {date} 起）',
  'subscription.alert.pending.title': '等待付款',
  'subscription.alert.pending.body': '首期账单付款后订阅即生效。请在下方账单区完成付款。',
  'subscription.picker.title': '选择订阅套餐',
  'subscription.picker.subtitle': '您还没有订阅。请选择下方套餐开始订阅。',
  'subscription.picker.empty': '目前没有可用的订阅套餐。',
  'subscription.picker.perMonth': '/ 月',
  'subscription.picker.periodDays': '周期 {n} 天',
  'subscription.picker.accountPrice': '您账户的专属价格',
  'subscription.picker.includedCredits': '包含额度：',
  'subscription.picker.creditLine': '{n} 额度 {product}',
  'subscription.picker.product': '产品 #{id}',
  'subscription.picker.subscribe': '订阅',
  'subscription.invoices.title': '账单',
  'subscription.invoices.col.type': '类型',
  'subscription.invoices.col.period': '周期',
  'subscription.invoices.col.amount': '金额',
  'subscription.invoices.col.status': '状态',
  'subscription.invoices.col.action': '操作',
  'subscription.invoices.type.initial': '首期账单',
  'subscription.invoices.type.renewal': '续期账单',
  'subscription.invoices.status.pending': '等待付款',
  'subscription.invoices.status.paid': '已付款',
  'subscription.invoices.status.cancelled': '已取消',
  'subscription.invoices.paidOn': '付款于 {date}',
  'subscription.invoices.priorAttempt': '存在此前的付款指引',
  'subscription.invoices.continuePayment': '继续付款',
  'subscription.invoices.pay': '付款',
  'subscription.invoices.download': '下载',
  'subscription.invoices.downloadError': '下载发票失败，请重试。',
  'subscription.invoices.empty': '暂无账单。',
  'subscription.banner.unpaid.title': '订阅未付款',
  'subscription.banner.unpaid.body': '您的订阅尚未付款，账户已停止新的申报。',
  'subscription.banner.unpaid.cta': '立即付款',
  'subscription.banner.trial.title': '试用已结束',
  'subscription.banner.trial.body': '您的免费试用已结束，账户已停止新的申报。',
  'subscription.banner.trial.cta': '选择套餐',
  'subscription.banner.pending.title': '账单等待付款',
  'subscription.banner.pending.body': '续期账单正在等待付款。',
  'subscription.banner.pending.cta': '支付续期账单',
  // Subscription payment modal
  'subscription.pay.title': '支付账单 #{id}',
  'subscription.pay.subtotal': '小计',
  'subscription.pay.fee': '支付服务费',
  'subscription.pay.feeNotice': '支付服务费在小计之外另行收取，不同支付方式的费率可能不同。',
  'subscription.pay.total': '应付总额：',
  'subscription.pay.method': '支付方式',
  'subscription.pay.method.va': '虚拟账户',
  'subscription.pay.method.qris': 'QRIS',
  'subscription.pay.method.card': '信用卡',
  'subscription.pay.method.unknown': '未知',
  'subscription.pay.prior.title': '存在此前的付款指引',
  'subscription.pay.prior.body': '您已通过 {method}{bank} 发起付款。可以重新查看该指引，或使用其他方式重新付款。',
  'subscription.pay.prior.cta': '查看此前的付款指引',
  'subscription.pay.selectBank': '选择银行',
  'subscription.pay.continue': '继续付款',
  'subscription.pay.va.transferTo': '请转账至以下虚拟账户号码：',
  'subscription.pay.va.note': '转账后，付款将在 1-5 分钟内自动处理。',
  'subscription.pay.copy': '复制',
  'subscription.pay.copied.title': '成功',
  'subscription.pay.copied.body': '已复制到剪贴板',
  'subscription.pay.qris.title': '扫描 QRIS',
  'subscription.pay.qris.body': '请使用电子钱包应用扫描下方二维码：',
  'subscription.pay.qris.unavailable': '二维码图片不可用',
  'subscription.pay.card.title': '信用卡支付',
  'subscription.pay.card.open': '打开支付页面',
  'subscription.pay.card.unavailable': '支付链接不可用',
  'subscription.pay.waiting': '等待付款',
  'subscription.pay.polling': '每 5 秒自动检查状态',
  'subscription.pay.changeMethod': '更换支付方式',
  'subscription.pay.checkStatus': '检查状态',
  'subscription.pay.success.title': '支付成功',
  'subscription.pay.success.body': '您的订阅账单已支付，谢谢！',
  'subscription.pay.success.notification': '您的订阅账单已支付。',
  'subscription.pay.close': '关闭',

  // Dashboard header notification bell (incoming CEISA email responses)
  'notifications.bell.title': '通知',
  'notifications.bell.aria': '邮件响应通知',
  'notifications.bell.markAllRead': '全部标为已读',
  'notifications.bell.empty': '暂无邮件响应',
  'notifications.bell.emptyHint': '收到的 CEISA 响应将显示在这里',
  'notifications.bell.loading': '正在加载通知...',
  'notifications.bell.error': '加载通知失败',
  'notifications.bell.retry': '重试',
  'notifications.bell.unreadCount': '条未读',
  'notifications.bell.new': '新',
  'notifications.bell.ajuNumber': '申报编号',
  'notifications.bell.filterAll': '全部',
  'notifications.bell.filterUnread': '未读',
  'notifications.bell.emptyUnread': '全部已读',
  'notifications.bell.emptyUnreadHint': '没有待查看的响应',
  'notifications.bell.urgent': '紧急',
  'notifications.bell.download': '下载',
  'notifications.bell.downloading': '正在下载',
  'notifications.bell.downloaded': '下载完成',
  'notifications.bell.downloadFailed': '下载失败',
  'notifications.bell.sinceLastResponse': '自上次响应',
  'notifications.bell.lastResponseAt': '上次响应',
  // Entity history check — see the Indonesian block for the wording rules.
  'entitycheck.cocok': '一致',
  'entitycheck.perluDiperiksa': '请核对',
  'entitycheck.tidakDicek': '未核对',
  'entitycheck.dariAkun': '来自您的账户',
  'entitycheck.samaDenganDokumen': '与文档一致',
  'entitycheck.bedaDariDokumen': '与文档不同',
  'entitycheck.cocokDariNama': '按名称匹配',
  'entitycheck.dokumen': '文档',
  'entitycheck.dokumenSebelumnya': '以前的文档',
  'entitycheck.pakaiIni': '使用这个',
  'entitycheck.biarkanSaja': '保留当前',
  'entitycheck.belumAda': '此处尚无',
  'entitycheck.tambahkan': '添加',

  // ---- HS 编码信息（INSW 商品详情）----
  // 标题与字段沿用 INSW 门户的用词，熟悉该门户的用户无需转换术语。
  'hsCodeInfo.title': 'HS 编码信息',
  'hsCodeInfo.kodeHs': 'HS 编码',
  'hsCodeInfo.tabTarif': '关税信息',
  'hsCodeInfo.tabPreferensi': '优惠关税',
  'hsCodeInfo.tabRegulasiImpor': '进口法规',
  'hsCodeInfo.tabRegulasiEkspor': '出口法规',
  'hsCodeInfo.kolNamaTarif': '税种名称',
  'hsCodeInfo.berlakuSeterusnya': '持续有效',
  'hsCodeInfo.kedaluwarsa': '已失效',
  'hsCodeInfo.belumBerlaku': '尚未生效',
  'hsCodeInfo.bahasa': '印尼文',
  'hsCodeInfo.english': '英文',
  'hsCodeInfo.satuanBarang': '商品计量单位',
  'hsCodeInfo.kolKodeSatuan': '单位代码',
  'hsCodeInfo.kolUraianSatuan': '单位说明',
  'hsCodeInfo.kolJenis': '类别',
  'hsCodeInfo.kolTarif': '税率',
  'hsCodeInfo.kolRegulasi': '法规',
  'hsCodeInfo.tabUmum': '商品描述',
  'hsCodeInfo.tabLainnya': '其他信息',
  'hsCodeInfo.lartasYa': '受管制',
  'hsCodeInfo.lartasTidak': '非管制',
  'hsCodeInfo.kodeNormal': '标准化编码',
  'hsCodeInfo.uraianId': '描述（印尼文）',
  'hsCodeInfo.uraianEn': '描述（英文）',
  'hsCodeInfo.tahunInsw': 'INSW 年份',
  'hsCodeInfo.kodeSatuan': '单位代码',
  'hsCodeInfo.spesifikasi': '商品规格',
  'hsCodeInfo.cariPreferensi': '搜索协定或 PMK 编号',
  'hsCodeInfo.dibandingMfn': '对比 MFN 关税 {rate}',
  'hsCodeInfo.hematBm': '节省 {n}% 关税',
  'hsCodeInfo.tidakLebihMurah': '不低于 MFN 税率',
  'hsCodeInfo.preferensiTidakCocok': '没有符合「{query}」的优惠协定',
  'hsCodeInfo.lartasBorder': '进口法规（Lartas Border）',
  'hsCodeInfo.tataNiagaPostBorder': '进口法规（Tata Niaga Post Border）',
  'hsCodeInfo.regulasiImporUmum': '进口法规（一般）',
  'hsCodeInfo.lartasEkspor': '出口法规（Lartas Ekspor）',
  'hsCodeInfo.kolNamaIzin': '许可证名称',
  'hsCodeInfo.kolKodeIzin': '许可证代码',
  'hsCodeInfo.kolDeskripsi': '描述',
  'hsCodeInfo.kolDasarHukum': '法律依据',
  'hsCodeInfo.kolMasaBerlaku': '有效期',
  'hsCodeInfo.kolKeterangan': '备注',
  'hsCodeInfo.kolDokumenPabean': '海关单证',
  'hsCodeInfo.kolUraianBarang': '货物描述',
  'hsCodeInfo.instansi': '机构',
  'hsCodeInfo.sekarang': '至今',
  'hsCodeInfo.berlaku': '生效',
  'hsCodeInfo.terbaru': '最新',
  'hsCodeInfo.legacy': '旧版',
  'hsCodeInfo.mfnTerbaru': '最惠国税率（最新）',
  'hsCodeInfo.mfn': '最惠国税率',
  'hsCodeInfo.preferensiTerbaru': '优惠税率（最新）',
  'hsCodeInfo.preferensi': '优惠税率',
  'hsCodeInfo.tarifPerTahun': '各年度税率',
  'hsCodeInfo.lanjutan': '后续年度沿用此税率',
  'hsCodeInfo.sda': 'SDA（自然资源）',
  'hsCodeInfo.tidakDiaturLartasBorder': '该 HS 编码未列入 Lartas Border 管制',
  'hsCodeInfo.tidakDiaturPostBorder': '该 HS 编码未列入 Tata Niaga Post Border 管制',
  'hsCodeInfo.tidakDiaturImporUmum': '该 HS 编码未列入一般进口法规',
  'hsCodeInfo.tidakDiaturLartasEkspor': '该 HS 编码未列入 Lartas Ekspor 管制',
  // 用于 INSW 尚未对该编码作答时：空并不意味着“未受管制”。
  'hsCodeInfo.regulasiBelumTersedia': '该编码的法规数据尚未获取',
  'hsCodeInfo.tidakAdaTarif': '暂无最惠国税率数据',
  'hsCodeInfo.tidakAdaPreferensi': '该编码暂无优惠税率方案',
  'hsCodeInfo.tidakAdaData': '该 HS 编码暂无数据',
  'hsCodeInfo.tidakDitemukan': '未找到该 HS 编码的数据',
  'hsCodeInfo.gagalMuat': '加载 HS 编码详情失败',

  // ---- Master: Data Consignee ----
  'menu.dataConsignee': '收货人数据',
  'consignee.title': '收货人数据',
  'consignee.subtitle': '您经办的进口商名单。填写一次，在您的单证中反复使用。',
  'consignee.privacyTitle': '仅供贵报关行使用',
  'consignee.tabOwn': '我的 PPJK',
  'consignee.tabGlobal': '全部 PPJK',
  'consignee.colPpjk': 'PPJK',
  'consignee.globalNoticeTitle': '内部视图，仅供查看',
  'consignee.globalNotice':
    '所有 PPJK 的收货人列表，仅超级管理员可见。如需新增或修改收货人，请以其所属 PPJK 的身份操作。',
  'consignee.globalSearchPlaceholder': '搜索收货人、NPWP 或 PPJK',
  'consignee.privacyBody':
    '此名单仅为 {company}（NPWP {npwp}）保存。不会共享给其他报关行，不用于任何训练，只用于填写您的单证。',
  'consignee.yourPpjk': '贵报关行',
  'consignee.noPpjkTitle': '尚无报关行 NPWP',
  'consignee.noPpjkMsg': '您的账号尚未关联报关行，请联系管理员。',
  'consignee.loadFailedTitle': '加载失败',
  'consignee.loadFailedMsg': '收货人名单暂时无法加载，请稍后再试。',
  'consignee.searchPlaceholder': '搜索名称或 NPWP',
  'consignee.total': '{n} 个收货人',
  'consignee.template': '模板',
  'consignee.exportCurrent': '下载当前数据',
  'consignee.uploadExcel': '上传 Excel',
  'consignee.uploadIntro': '下载模板，在 Excel 中填写后重新上传。保存前您会看到将要发生的变更。',
  'consignee.add': '新增',
  'consignee.addTitle': '新增收货人',
  'consignee.editTitle': '编辑收货人',
  'consignee.emptyTitle': '暂无收货人',
  'consignee.emptyHint': '逐个添加，或通过 Excel 一次导入。',
  'consignee.colNama': '收货人名称',
  'consignee.colNpwp': 'NPWP',
  'consignee.colAlamat': '地址',
  'consignee.colNib': 'NIB',
  'consignee.colJenisApi': 'API 类型',
  'consignee.colStatus': '状态',
  'consignee.colSumber': '来源',
  'consignee.colDiperbarui': '更新时间',
  'consignee.colAksi': '操作',
  'consignee.sourceExcel': 'Excel',
  'consignee.sourceManual': '手动',
  'consignee.sourceCeisa': 'CEISA',
  'consignee.edit': '编辑',
  'consignee.delete': '删除',
  'consignee.cancel': '取消',
  'consignee.save': '保存',
  'consignee.create': '新增',
  'consignee.unknown': '未知',
  'consignee.npwpHint': '15 或 16 位数字。可带点和横线，会自动整理。',
  'consignee.npwpStoredAs': '将保存为 {npwp}',
  'consignee.npwpInvalid': 'NPWP 必须为 15 或 16 位数字',
  'consignee.nibInvalid': 'NIB 必须为 13 位数字',
  'consignee.formInvalidTitle': '请检查输入',
  'consignee.formInvalidMsg': '名称和 NPWP 为必填且须正确。',
  'consignee.savedTitle': '已保存',
  'consignee.createdMsg': '收货人已添加。',
  'consignee.updatedMsg': '收货人已更新。',
  'consignee.existsMsg': '该 NPWP 已在您的名单中。请编辑现有记录，而不是新增。',
  'consignee.saveFailedTitle': '保存失败',
  'consignee.saveFailedMsg': '收货人尚未保存，请重试。',
  'consignee.deleteTitle': '删除收货人',
  'consignee.deleteConfirm': '从名单中删除 {nama}？此后新单证中不再出现。',
  'consignee.deletedTitle': '已删除',
  'consignee.deletedMsg': '收货人已从名单中删除。',
  'consignee.deleteFailedMsg': '收货人尚未删除，请重试。',
  'consignee.downloadFailedTitle': '下载失败',
  'consignee.downloadFailedMsg': '文件暂时无法下载，请稍后再试。',
  'consigneeImport.dropTitle': '将 Excel 文件拖到此处',
  'consigneeImport.dropHint': '一个 .xlsx 文件，最多 5,000 行',
  'consigneeImport.chooseFile': '选择文件',
  'consigneeImport.onlyXlsx': '请使用模板生成的单个 Excel（.xlsx）文件。',
  'consigneeImport.reading': '正在读取 {file}',
  'consigneeImport.previewFailed': '文件无法读取',
  'consigneeImport.previewStale': '收货人数据已变更，预览可能已不准确',
  'consigneeImport.reloadPreview': '重新加载预览',
  'consigneeImport.chooseOther': '选择其他文件',
  'consigneeImport.rowsSeen': '{n} 行',
  'consigneeImport.rowLabel': '第 {n} 行',
  'consigneeImport.actionNew': '新增',
  'consigneeImport.actionUpdated': '更新',
  'consigneeImport.actionUnchanged': '未变更',
  'consigneeImport.actionRejected': '跳过',
  'consigneeImport.neverDeletes': '上传不会删除数据。文件中没有的行保持不变；空单元格不会覆盖已有的值。',
  'consigneeImport.importN': '导入 {n} 行',
  'consigneeImport.importedTitle': '导入完成',
  'consigneeImport.importedMsg': '新增 {new}，更新 {updated}。',
  'consigneeImport.resultLine': '新增 {new}，更新 {updated}，未变更 {unchanged}。',
  'consigneeImport.rejectedTitle': '被跳过的行',
  'consigneeImport.failedTitle': '导入失败',
  'consigneeImport.failedMsg': '数据尚未保存，请重试。',
  'consigneeImport.uploadAnother': '上传其他文件',
  'menu.dataEksportir': '出口商数据',
  'eksportir.title': '出口商数据',
  'eksportir.subtitle': '您经办的出口商名单。填写一次，在您的 PEB 单证中反复使用。',
  'eksportir.privacyTitle': '仅供贵报关行使用',
  'eksportir.tabOwn': '我的 PPJK',
  'eksportir.tabGlobal': '全部 PPJK',
  'eksportir.colPpjk': 'PPJK',
  'eksportir.globalNoticeTitle': '内部视图，仅供查看',
  'eksportir.globalNotice':
    '所有 PPJK 的出口商列表，仅超级管理员可见。如需新增或修改出口商，请以其所属 PPJK 的身份操作。',
  'eksportir.globalSearchPlaceholder': '搜索出口商、证件号码或 PPJK',
  'eksportir.privacyBody':
    '此名单仅为 {company}（NPWP {npwp}）保存。不会共享给其他报关行，不用于任何训练，只用于填写您的单证。',
  'eksportir.yourPpjk': '贵报关行',
  'eksportir.noPpjkTitle': '尚无报关行 NPWP',
  'eksportir.noPpjkMsg': '您的账号尚未关联报关行，请联系管理员。',
  'eksportir.loadFailedTitle': '加载失败',
  'eksportir.loadFailedMsg': '出口商名单暂时无法加载，请稍后再试。',
  'eksportir.searchPlaceholder': '搜索名称或证件号码',
  'eksportir.total': '{n} 个出口商',
  'eksportir.template': '模板',
  'eksportir.exportCurrent': '下载当前数据',
  'eksportir.uploadExcel': '上传 Excel',
  'eksportir.uploadIntro': '下载模板，在 Excel 中填写后重新上传。保存前您会看到将要发生的变更。',
  'eksportir.add': '新增',
  'eksportir.addTitle': '新增出口商',
  'eksportir.editTitle': '编辑出口商',
  'eksportir.emptyTitle': '暂无出口商',
  'eksportir.emptyHint': '逐个添加，或通过 Excel 一次导入。',
  'eksportir.colNama': '出口商名称',
  'eksportir.colIdentitas': '证件',
  'eksportir.colJenisIdentitas': '证件类型',
  'eksportir.colNomorIdentitas': '证件号码',
  'eksportir.colAlamat': '地址',
  'eksportir.colStatus': '状态',
  'eksportir.colSumber': '来源',
  'eksportir.colDiperbarui': '更新时间',
  'eksportir.colAksi': '操作',
  'eksportir.sourceExcel': 'Excel',
  'eksportir.sourceManual': '手动',
  'eksportir.sourceCeisa': 'CEISA',
  'eksportir.edit': '编辑',
  'eksportir.delete': '删除',
  'eksportir.cancel': '取消',
  'eksportir.save': '保存',
  'eksportir.create': '新增',
  'eksportir.unknown': '未知',
  'eksportir.namaPlaceholder': 'PT. 示例',
  'eksportir.npwpHint': '15 或 16 位数字。可带点和横线，会自动整理。',
  'eksportir.identitasHint': '仅限数字，其他字符会被自动去除。',
  'eksportir.identitasStoredAs': '将保存为 {nomor}',
  'eksportir.npwpInvalid': 'NPWP 必须为 15 或 16 位数字',
  'eksportir.ktpInvalid': 'KTP 必须为 16 位数字',
  'eksportir.identitasEmpty': '证件号码必须包含数字',
  'eksportir.identitasTooLong': '证件号码最多 50 位数字',
  'eksportir.formInvalidTitle': '请检查输入',
  'eksportir.formInvalidMsg': '名称和证件号码为必填且须正确。',
  'eksportir.savedTitle': '已保存',
  'eksportir.createdMsg': '出口商已添加。',
  'eksportir.updatedMsg': '出口商已更新。',
  'eksportir.existsMsg': '该证件已在您的名单中。请编辑现有记录，而不是新增。',
  'eksportir.saveFailedTitle': '保存失败',
  'eksportir.saveFailedMsg': '出口商尚未保存，请重试。',
  'eksportir.deleteTitle': '删除出口商',
  'eksportir.deleteConfirm': '从名单中删除 {nama}？此后新单证中不再出现。',
  'eksportir.deletedTitle': '已删除',
  'eksportir.deletedMsg': '出口商已从名单中删除。',
  'eksportir.deleteFailedMsg': '出口商尚未删除，请重试。',
  'eksportir.downloadFailedTitle': '下载失败',
  'eksportir.downloadFailedMsg': '文件暂时无法下载，请稍后再试。',
  'eksportir.jenis.2': '护照',
  'eksportir.jenis.3': '身份证 (KTP)',
  'eksportir.jenis.4': '其他',
  'eksportir.jenis.5': 'NPWP 15 位',
  'eksportir.jenis.6': 'NPWP 16 位',
  'eksportir.jenis.npwp': 'NPWP',
  'eksportir.status.1': '合作社',
  'eksportir.status.2': 'PMDN（油气）',
  'eksportir.status.3': 'PMDN（非油气）',
  'eksportir.status.4': 'PMA（油气）',
  'eksportir.status.5': 'PMA（非油气）',
  'eksportir.status.6': '国有企业 (BUMN)',
  'eksportir.status.7': '地方国企 (BUMD)',
  'eksportir.status.8': '私营企业',
  'eksportir.status.9': '合资企业',
  'eksportir.status.10': '其他',
  'eksportirImport.dropTitle': '将 Excel 文件拖到此处',
  'eksportirImport.dropHint': '一个 .xlsx 文件，最多 5,000 行',
  'eksportirImport.chooseFile': '选择文件',
  'eksportirImport.onlyXlsx': '请使用模板生成的单个 Excel（.xlsx）文件。',
  'eksportirImport.reading': '正在读取 {file}',
  'eksportirImport.previewFailed': '文件无法读取',
  'eksportirImport.previewStale': '出口商数据已变更，预览可能已不准确',
  'eksportirImport.reloadPreview': '重新加载预览',
  'eksportirImport.chooseOther': '选择其他文件',
  'eksportirImport.rowsSeen': '{n} 行',
  'eksportirImport.rowLabel': '第 {n} 行',
  'eksportirImport.actionNew': '新增',
  'eksportirImport.actionUpdated': '更新',
  'eksportirImport.actionUnchanged': '未变更',
  'eksportirImport.actionRejected': '跳过',
  'eksportirImport.neverDeletes': '上传不会删除数据。文件中没有的行保持不变；空单元格不会覆盖已有的值。',
  'eksportirImport.importN': '导入 {n} 行',
  'eksportirImport.importedTitle': '导入完成',
  'eksportirImport.importedMsg': '新增 {new}，更新 {updated}。',
  'eksportirImport.resultLine': '新增 {new}，更新 {updated}，未变更 {unchanged}。',
  'eksportirImport.rejectedTitle': '被跳过的行',
  'eksportirImport.failedTitle': '导入失败',
  'eksportirImport.failedMsg': '数据尚未保存，请重试。',
  'eksportirImport.uploadAnother': '上传其他文件',
  'eksportirCard.dataEksportir': '出口商数据',
  'eksportirCard.dibukaDiTabBaru': '在新标签页打开：Master › 出口商数据',
  'eksportirCard.belumAda': '尚未在出口商数据中。单证成功提交至 CEISA 后将自动保存。',
  'eksportirCard.buka': '打开出口商数据',
  'eksportirCard.simpan': '保存到出口商数据',
  'eksportirCard.simpanHint': '保存此出口商，以便在后续单证中自动填写。',
  'eksportirCard.tersimpan': '已保存到出口商数据',
  'eksportirCard.tersimpanMsg': '从现在起，此出口商将根据其证件号码自动填写。',
  'eksportirCard.sudahAda': '该证件已在出口商数据中。',
  'eksportirCard.gagalSimpan': '保存到出口商数据失败。',
  'eksportirCard.diterapkanTitle': '已应用',
  'eksportirCard.diterapkanMsg': '已将出口商数据应用到出口商。',
  'statement.updatedBy': '由 {email} 于 {date} 更新',
  'statement.utama': '默认',
  'statement.tabOwn': '我的 PPJK',
  'statement.tabGlobal': '全部 PPJK',
  'statement.staleSessionTitle': '您账户的 PPJK 已变更',
  'statement.staleSessionMsg':
    '此浏览器仍保存着旧的 PPJK（{stored}）。您的账户现已关联到 {current}，此处显示的和草稿使用的都是它。请退出并重新登录，以便应用的其他部分同步更新。',
  'statement.jadikanUtama': '设为默认',
  'statement.jadikanUtamaBerhasil': '{name} 现为新草稿的默认声明。',
  'statement.jadikanUtamaGagal': '设为默认失败',
  'statement.nonaktifkanUtamaJudul': '停用默认声明？',
  'statement.nonaktifkanUtamaPesan': '最早创建的其他有效声明将自动成为新草稿的默认声明。',
  'statement.nonaktifkanUtamaTanpaPengganti': '没有其他有效声明。新草稿将不会自动填写声明。',
  'statement.nonaktifkan': '停用',
  'statement.batal': '取消',
  'statement.konflikJudul': '声明刚被您的同事更新',
  'statement.konflikDiperbaruiOleh': '由 {email} 于 {date} 更新',
  'statement.konflikDiperbaruiPada': '更新于 {date}',
  'statement.kolomTempat': '地点',
  'statement.kolomNama': '姓名',
  'statement.kolomJabatan': '职务',
  'statement.konflikMuatUlang': '重新加载',
  'statement.konflikTimpa': '覆盖',
  'statement.konflikGagalMemuat': '暂时无法加载最新数据。',
  'statement.konflikMuatUlangDaftar': '重新加载列表',
  'pernyataanform.pilihPernyataan': '选择声明',
  'pernyataanform.pilihPernyataanPlaceholder': '从 主数据 › 声明 中选择',
  'pernyataanform.diubahManual': '当前值已手动修改',
  'settings.sectionTampilan': '外观',
  'settings.theme': '主题',
  'settings.themeDesc': '应用的配色，仅对您的账号生效。',
  'settings.language': '语言',
  'settings.languageDesc': '菜单和界面文字的语言。',
  'settings.textSize': '文字大小',
  'settings.textSizeDesc': '放大整个应用的文字和按钮。',
  'settings.textSizeNormal': '标准',
  'settings.textSizeLarge': '大',
  'settings.textSizeLarger': '更大',
  'settings.textSizePreview': '示例：Nomor Aju 000020-001234-20260915-000041，进口商 PT. CEMANI TOKA，状态 SPPB。',
  'settings.textSizeNote': '更改立即生效。在最大尺寸下，部分紧凑的表格会显得更密。',

  // ---- 草稿变更历史（编辑页的 “Audit Logs” 抽屉）----
  'docpabean.audit.title': '变更历史',
  'docpabean.audit.refresh': '重新加载',
  'docpabean.audit.count': '{n} 项变更',
  'docpabean.audit.loadMore': '加载更多（剩余 {n}）',
  'docpabean.audit.unavailable': '此草稿暂无可用历史。',
  'docpabean.audit.subtitle.batch': '批次 {uuid}',
  'docpabean.audit.subtitle.none': '草稿尚未保存',
  'docpabean.audit.systemActor': '系统',
  'docpabean.audit.rowCount': '{n} 行',
  'docpabean.audit.empty': '（空）',
  'docpabean.audit.yes': '是',
  'docpabean.audit.no': '否',
  'docpabean.audit.addedEntity': '新增：{entity}',
  'docpabean.audit.removedEntity': '删除：{entity}',
  'docpabean.audit.showMoreFields': '再显示 {n} 项',
  'docpabean.audit.hideMoreFields': '收起',
  'docpabean.audit.showMoreValue': '更多',
  'docpabean.audit.showLessValue': '收起',
  'docpabean.audit.filter.tab.all': '全部',
  'docpabean.audit.filteredEmpty': '此标签页没有变更。',
  'docpabean.audit.empty.title': '暂无历史',
  'docpabean.audit.empty.body': '此草稿的变更将显示在这里。',
  'docpabean.audit.error.title': '无法加载历史',
  'docpabean.audit.error.body': '无法加载历史，请稍后再试。',
  'docpabean.audit.error.retry': '重试',
  'docpabean.audit.notFound.title': '未找到历史',
  'docpabean.audit.notFound.body': '此草稿不适用于您的账户。',
  'docpabean.audit.forbidden.title': '账户未关联 PPJK',
  'docpabean.audit.forbidden.body': '您的账户未关联 PPJK，因此无法显示草稿历史。',
  'docpabean.audit.day.today': '今天',
  'docpabean.audit.day.yesterday': '昨天',
  'docpabean.audit.day.unknown': '日期未知',
  'docpabean.audit.time.justNow': '刚刚',
  'docpabean.audit.time.minutesAgo': '{n} 分钟前',
  'docpabean.audit.time.hoursAgo': '{n} 小时前',
  'docpabean.audit.time.daysAgo': '{n} 天前',
  'docpabean.audit.time.monthsAgo': '{n} 个月前',
  'docpabean.audit.time.yearsAgo': '{n} 年前',
  'docpabean.audit.time.unknown': '时间未知',
  // AI 提取仅显示三个里程碑：不含数量、字段名和值。
  'docpabean.audit.milestone.extractionStarted': '{name} 启动了 AI 提取',
  'docpabean.audit.milestone.extractionStartedAnon': 'AI 提取已启动',
  'docpabean.audit.milestone.extractionCompleted': 'AI 提取完成',
  'docpabean.audit.milestone.extractionFailed': 'AI 提取失败',
  'docpabean.audit.milestone.submitDraft': '{name} 提交了草稿',
  'docpabean.audit.milestone.submitFinal': '{name} 提交了最终文件',
  'docpabean.audit.milestone.draftDeleted': '{name} 删除了草稿',
  'docpabean.audit.milestone.documentFileUploaded': '{name} 上传了文件 {file}',
  'docpabean.audit.milestone.documentFileUploadedAnon': '已上传文件 {file}',
  'docpabean.audit.import.full': 'Excel · 全部',
  'docpabean.audit.import.barangOnly': 'Excel · 仅货物',
  'docpabean.audit.import.allTabs': '全部标签页',
  'docpabean.audit.import.otherTab': '无标签页',
  'docpabean.audit.import.added': '新增 {n}',
  'docpabean.audit.import.changed': '修改 {n}',
  'docpabean.audit.import.removed': '删除 {n}',
  'docpabean.audit.import.fields': '{n} 个字段',
  'docpabean.audit.import.noChanges': '没有变更',
  'docpabean.audit.import.goodsReplaced': '货物清单已按文件内容替换',
  'docpabean.audit.import.showPerTab': '查看各标签页的变更',
  'docpabean.audit.import.hidePerTab': '收起各标签页的变更',
  'docpabean.audit.import.truncated': '仅显示前 300 行',
  'docpabean.audit.action.UPDATE': '已修改',
  'docpabean.audit.action.CREATE': '已新增',
  'docpabean.audit.action.DELETE': '已删除',
  'docpabean.audit.action.HISTORICAL_SYNC': '从历史复制',
  'docpabean.audit.action.AI_APPLIED': '由 AI 填写',
  'docpabean.audit.action.EXTRACTION_REQUESTED': 'AI 提取已启动',
  'docpabean.audit.action.EXTRACTION_COMPLETED': 'AI 提取完成',
  'docpabean.audit.action.EXTRACTION_FAILED': 'AI 提取失败',
  'docpabean.audit.action.SUBMIT_DRAFT': '已提交草稿',
  'docpabean.audit.action.SUBMIT_FINAL': '已提交最终文件',
  'docpabean.audit.action.DRAFT_DELETED': '草稿已删除',
  'docpabean.audit.action.BULK_SUMMARY': '批量变更',
  'docpabean.audit.action.EXCEL_IMPORT': '上传 Excel',
  'docpabean.audit.entity.header': '表头',
  'docpabean.audit.entity.entity': '主体',
  'docpabean.audit.entity.document': '单证',
  'docpabean.audit.entity.carrier': '承运人',
  'docpabean.audit.entity.peti_kemas': '集装箱',
  'docpabean.audit.entity.kemasan': '包装',
  'docpabean.audit.entity.transaksi': '交易',
  'docpabean.audit.entity.barang': '货物',
  'docpabean.audit.entity.statement': '声明',
  'docpabean.audit.entity.process': '流程',
  'docpabean.audit.entity.barang_vd': '交易类型',
  'docpabean.audit.field.barang_vd.kodeJenisVd': '交易类型',
  'docpabean.audit.field.barang_vd.nilaiBarangVd': '自愿申报金额',
  // 海关术语，非界面文案：CEISA 表单印的就是这几个词，故各语言保持一致。
  'docpabean.audit.value.kondisiBarang1': 'Barang Baru',
  'docpabean.audit.value.kondisiBarang2': 'Bukan Barang Baru',
  'docpabean.audit.value.jenisApi01': 'API U',
  'docpabean.audit.value.jenisApi02': 'API P',
  'docpabean.audit.tab.header': '表头',
  'docpabean.audit.tab.entitas': '主体',
  'docpabean.audit.tab.dokumen': '单证',
  'docpabean.audit.tab.pengangkut': '承运人',
  'docpabean.audit.tab.kemasan': '包装与集装箱',
  'docpabean.audit.tab.transaksi': '交易',
  'docpabean.audit.tab.barang': '货物',
  'docpabean.audit.tab.pungutan': '税费',
  'docpabean.audit.tab.pernyataan': '声明',

  // ---- Lumen 界面组件（src/components/lumen：按钮与无障碍标签）----
  // ---- Lumen shell: top bar ----
  'lumen.topbar.openMenu': '打开导航菜单',
  'lumen.topbar.switchToLight': '切换到浅色模式',
  'lumen.topbar.switchToDark': '切换到深色模式',
  'lumen.topbar.account': '账户',
  'lumen.topbar.impersonateDescription': '搜索用户并以其身份登录。之后页面会重新加载。',
  'lumen.close': '关闭',
  'lumen.pagination.label': '分页',
  'lumen.pagination.previous': '上一页',
  'lumen.pagination.next': '下一页',
  'lumen.pagination.previousPage': '转到上一页',
  'lumen.pagination.nextPage': '转到下一页',
  'lumen.pagination.morePages': '更多页面',

  // ---- Lumen table system (src/components/data-table) ----
  // The first six replace the old SharedDataTable / mantine-datatable copy.
  'lumen.table.pageSize': '每页行数',
  'lumen.table.range': '{from} - {to} / {total}',
  'lumen.table.loading': '正在加载数据...',
  'lumen.table.noRecords': '无数据',
  'lumen.table.emptyTitle': '暂无数据',
  'lumen.table.emptyDescription': '目前没有可显示的数据。',
  'lumen.table.pageLink': '第 {n} 页',
  'lumen.table.selected': '已选择 {n} 项',
  'lumen.table.clearSelection': '取消选择',
  'lumen.table.selectAll': '选择本页所有行',
  'lumen.table.selectRow': '选择此行',
  'lumen.table.selectRowNamed': '选择 {name}',
  'lumen.table.search': '搜索',
  'lumen.table.columns': '列',
  'lumen.table.resetColumns': '重置列',
  'lumen.table.filter': '筛选',
  'lumen.table.hideFilter': '隐藏筛选',
  'lumen.table.resetFilters': '重置',
  'lumen.table.activeFilters': '已启用的筛选',
  'lumen.table.removeFilter': '移除筛选：{label}',
  'lumen.table.clearFilters': '清除所有筛选',

  // ---- Lumen common copy (shared parts cleanup) ----
  // Words more than one list page uses. Each value is the value of the page key it replaces, in this
  // language (those were the old pages' literals, verbatim in every language): `cancel` / `save` are the
  // master pages' "Cancel" / "Save", `batal` / `simpan` the approval pages' "Batal" / "Simpan".
  'lumen.common.actions': 'Actions',
  'lumen.common.active': 'Active',
  'lumen.common.inactive': 'Inactive',
  'lumen.common.status': 'Status',
  'lumen.common.edit': 'Edit',
  'lumen.common.deactivate': 'Deactivate',
  'lumen.common.viewDetails': 'View Details',
  'lumen.common.create': 'Create',
  'lumen.common.save': 'Save',
  'lumen.common.cancel': 'Cancel',
  'lumen.common.simpan': 'Simpan',
  'lumen.common.batal': 'Batal',
  'lumen.common.update': 'Update',
  'lumen.common.success': 'Success',
  'lumen.common.error': 'Error',
  'lumen.common.requiredFields': 'Please fill in all required fields',
  'lumen.common.total': 'Total: {n} records',
  'lumen.common.name': 'Name',
  'lumen.common.email': 'Email',
  'lumen.common.emailPlaceholder': 'email@example.com',
  'lumen.common.username': 'Username',
  'lumen.common.password': 'Password',
  'lumen.common.editEmail': 'Edit Email',
  'lumen.common.motType': 'MOT Type',
  'lumen.common.ppjk': 'PPJK: {n}',
  'lumen.common.ppjkNpwp': 'PPJK NPWP',
  'lumen.common.ppjkRequiredTitle': 'PPJK NPWP Required',
  'lumen.common.ppjkRequiredBody': 'No PPJK NPWP found for your account. Please contact your administrator.',

  // ---- Lumen chart parts (dashboards PR 5) ----
  // Labels the chart parts in src/components/charts add, translated (like lumen.table.*).
  'lumen.chart.updating': '正在更新…',

  // ---- Lumen /dashboard (dashboards PR 5) ----
  // The old page's literal text, verbatim in every language (copy unchanged). {error}, {n}, {v} and {pct} are
  // filled with formatTemplate.
  'lumen.dashboard.title': 'Operational Dashboard',
  'lumen.dashboard.subtitle': 'Overview aktivitas, performa, dan tren operasional',
  'lumen.dashboard.selectPpjk': 'Select PPJK',
  'lumen.dashboard.ppjkNotFound': 'PPJK tidak ditemukan',
  'lumen.dashboard.pickStartDate': 'Pick start date',
  'lumen.dashboard.pickEndDate': 'Pick end date',
  'lumen.dashboard.loading': 'Loading dashboard...',
  'lumen.dashboard.error': 'Error: {error}',
  'lumen.dashboard.graphView': 'Graph View',
  'lumen.dashboard.userStats': 'User Stats',
  'lumen.dashboard.loadingCharts': 'Loading charts...',
  'lumen.dashboard.loadingStats': 'Loading stats...',
  'lumen.dashboard.usageTrend': 'Usage Trend',
  'lumen.dashboard.usageTrendDescription': 'Daily AJU submissions over time',
  'lumen.dashboard.loadingGraph': 'Loading graph data...',
  'lumen.dashboard.noGraphData': 'No graph data available for the selected date range.',
  'lumen.dashboard.ajuCount': '{n} AJU',
  'lumen.dashboard.totalAju': 'Total AJU',
  'lumen.dashboard.dailyAverage': 'Daily Average',
  'lumen.dashboard.peakDay': 'Peak Day',
  'lumen.dashboard.loadingUserStats': 'Loading user stats...',
  'lumen.dashboard.noUserStats': 'No user statistics available for the selected date range.',
  'lumen.dashboard.totalUsers': 'Total Users',
  'lumen.dashboard.avgPerUser': 'Avg per User',
  'lumen.dashboard.topPerformance': 'Top Performance',
  'lumen.dashboard.userPerformance': 'User Performance',
  'lumen.dashboard.topN': 'Top {n}',
  'lumen.dashboard.distribution': 'Distribution',
  'lumen.dashboard.others': 'Others',
  'lumen.dashboard.ajuShare': '{v} AJU ({pct}%)',
  'lumen.dashboard.topPerformers': 'Top Performers',
  'lumen.dashboard.rank': '#{n}',

  // ---- Lumen master/email ----
  // The old page's literal English, verbatim in every language (copy unchanged).
  'lumen.masterEmail.searchPlaceholder': 'Search by email...',
  'lumen.masterEmail.add': 'Add Email',
  'lumen.masterEmail.emailType': 'Email Type',
  'lumen.masterEmail.branch': 'Branch',
  'lumen.masterEmail.emailPlaceholder': 'user@example.com',
  'lumen.masterEmail.updated': 'Email updated successfully',
  'lumen.masterEmail.updateFailed': 'Failed to update email',
  'lumen.masterEmail.created': 'Email created successfully',
  'lumen.masterEmail.createFailed': 'Failed to create email',
  'lumen.masterEmail.emailRequired': 'Please fill in the email field',
  'lumen.masterEmail.deactivated': 'Email deactivated successfully',
  'lumen.masterEmail.deactivateFailed': 'Failed to deactivate email',

  // ---- Lumen auth ----
  // Sign-in, MFA dialogs and the reviewer sign-in (src/app/(auth), src/components/auth-frame, mfa-dialogs).
  // Most values are the old pages' literal copy, moved verbatim and identical in every language (copy
  // unchanged); translating them is a copy change. New labels: showPassword, hidePassword, loginFailed,
  // otpLabel, setup.steps, setup.qrLabel.
  'lumen.auth.showPassword': '显示密码',
  'lumen.auth.hidePassword': '隐藏密码',
  'lumen.auth.loginFailed': '登录失败',
  'lumen.auth.otpLabel': '6 位验证码',
  'lumen.auth.cubeLogoAlt': 'CUBEforall by CCN',
  'lumen.auth.version': 'Version 1.0.0 (build 484)',
  'lumen.auth.copyright': '© 2022 - 2026. All rights reserved.',
  'lumen.auth.toast.loginSuccessful': 'Login Successful',
  'lumen.auth.toast.cubeSignedIn': 'Signed in with your CUBEforall account',
  'lumen.auth.toast.cubeError': 'CUBE SSO Error',
  'lumen.auth.toast.mfaSetup': 'MFA Setup',
  'lumen.auth.toast.mfaSetupPending': 'Please complete your pending MFA setup or contact support',
  'lumen.auth.toast.error': 'Error',
  'lumen.auth.toast.mfaSetupFailed': 'Failed to setup MFA. Please try logging in again.',
  'lumen.auth.toast.mfaStatusFailed': 'Failed to check MFA status. Redirecting to app.',
  'lumen.auth.toast.success': 'Success!',
  'lumen.auth.toast.mfaActivated': 'MFA successfully activated',
  'lumen.auth.toast.mfaNotActive': 'MFA not active yet, please try again',
  'lumen.auth.toast.setupCodeIncorrect': 'Verification code is incorrect, please try again',
  'lumen.auth.toast.mfaVerified': 'MFA verification successful',
  'lumen.auth.toast.mfaCodeInvalid': 'Invalid verification code. Please try again.',
  'lumen.auth.toast.deviceAdded': 'Device Added Successfully',
  'lumen.auth.toast.deviceAddedMessage':
    'The new device has been added and verified. Your team member can now use it to login.',
  'lumen.auth.verify.title': 'Two-Factor Authentication',
  'lumen.auth.verify.description': 'Please enter the 6-digit verification code from your authenticator app',
  'lumen.auth.verify.verifying': 'Verifying code...',
  'lumen.auth.verify.help':
    'Open your authenticator app (e.g., Google Authenticator, Authy) to view your verification code',
  'lumen.auth.verify.back': 'Kembali ke Login',
  'lumen.auth.setup.title': 'Setup Autentikasi Multi-Faktor (MFA)',
  'lumen.auth.setup.steps': 'MFA 设置步骤',
  'lumen.auth.setup.step1': 'Scan QR Code',
  'lumen.auth.setup.step1Desc': 'Gunakan Google Authenticator',
  'lumen.auth.setup.step2': 'Backup Codes',
  'lumen.auth.setup.step2Desc': 'Simpan kode darurat',
  'lumen.auth.setup.step3': 'Verifikasi',
  'lumen.auth.setup.step3Desc': 'Masukkan 6 digit kode',
  'lumen.auth.setup.scanHint': 'Buka aplikasi {app} di smartphone Anda dan scan QR code di bawah ini.',
  'lumen.auth.setup.qrLabel': 'MFA 二维码',
  'lumen.auth.setup.manualEntry': 'Atau masukkan kode manual',
  'lumen.auth.setup.copy': 'Salin kode',
  'lumen.auth.setup.copied': 'Tersalin!',
  'lumen.auth.setup.toBackup': 'Lanjut ke Backup Codes',
  'lumen.auth.setup.important': 'PENTING:',
  'lumen.auth.setup.backupWarning':
    'Simpan kode backup ini di tempat yang aman. Anda akan membutuhkannya jika kehilangan akses ke perangkat autentikasi.',
  'lumen.auth.setup.yourCodes': 'Kode Backup Anda:',
  'lumen.auth.setup.download': 'Download Backup Codes',
  'lumen.auth.setup.downloaded': 'Backup Codes Telah Didownload',
  'lumen.auth.setup.back': 'Kembali',
  'lumen.auth.setup.toVerify': 'Lanjut ke Verifikasi',
  'lumen.auth.setup.verifyHint': 'Masukkan 6 digit kode yang muncul di aplikasi Google Authenticator Anda.',
  'lumen.auth.setup.verifySubmit': 'Verifikasi & Aktifkan MFA',
  'lumen.auth.addDevice.title': 'Tambahkan Device Baru',
  'lumen.auth.addDevice.description': 'Add a new device for team members to access this account',
  'lumen.auth.addDevice.hint':
    'After adding the device, the team member will scan the QR code with their authenticator app',
  'lumen.auth.addDevice.deviceName': 'Device Name',
  'lumen.auth.addDevice.deviceNamePlaceholder': "e.g., Friend's iPhone",
  'lumen.auth.addDevice.userName': 'User Name',
  'lumen.auth.addDevice.userNamePlaceholder': 'e.g., Jane Smith',
  'lumen.auth.addDevice.generate': 'Generate QR Code',
  'lumen.auth.addDevice.cancel': 'Cancel',
  'lumen.auth.reviewer.title': 'Reviewer Portal',
  'lumen.auth.reviewer.subtitle': 'Login to review and approve AJU documents',
  'lumen.auth.reviewer.email': 'Email address',
  'lumen.auth.reviewer.emailPlaceholder': 'reviewer@company.com',
  'lumen.auth.reviewer.password': 'Password',
  'lumen.auth.reviewer.passwordPlaceholder': 'Your password',
  'lumen.auth.reviewer.signIn': 'Sign in',
  'lumen.auth.reviewer.footer': 'Lumen Reviewer Portal',
  'lumen.auth.reviewer.caption': 'Review and approve customs documents securely',
  'lumen.breadcrumb.label': '面包屑导航',
  'lumen.breadcrumb.more': '更多',
  // ---- Lumen P4 pages: customer approval (4 pages), riwayat-pembaruan, stamp-duty ----
  // The old pages' literal text, verbatim in every language (copy unchanged). Generic words are lumen.common.*
  // (Active, Name, Actions, …); words two of these pages share live under the first one.
  // customer-approval (Status, Actions are lumen.common.*)
  'lumen.customerApproval.title': 'Approval Requests',
  'lumen.customerApproval.description': 'Kelola dan pantau permintaan approval dari customer',
  'lumen.customerApproval.refresh': 'Refresh',
  'lumen.customerApproval.statTotal': 'Total Requests',
  'lumen.customerApproval.statWaiting': 'Waiting',
  'lumen.customerApproval.statusApproved': 'Approved',
  'lumen.customerApproval.statusRejected': 'Rejected',
  'lumen.customerApproval.statusWaiting': 'Waiting for Review',
  'lumen.customerApproval.statusNeedRevision': 'Need Revision',
  'lumen.customerApproval.statusInvalidated': 'Invalidated',
  'lumen.customerApproval.statusScheduled': 'Scheduled',
  'lumen.customerApproval.searchPlaceholder': 'Search by AJU no., requester...',
  'lumen.customerApproval.count': '{n} requests',
  'lumen.customerApproval.colAju': 'AJU No.',
  'lumen.customerApproval.colVersion': 'Ver',
  'lumen.customerApproval.notes': 'Notes',
  'lumen.customerApproval.colRequested': 'Requested',
  'lumen.customerApproval.colReviewed': 'Reviewed',
  'lumen.customerApproval.scheduledAt': 'Dijadwalkan: {date}',
  'lumen.customerApproval.justNow': 'just now',
  'lumen.customerApproval.minutesAgo': '{m}m ago',
  'lumen.customerApproval.hoursMinutesAgo': '{h}h {m}m ago',
  'lumen.customerApproval.hoursAgo': '{h}h ago',
  'lumen.customerApproval.daysHoursAgo': '{d}d {h}h ago',
  'lumen.customerApproval.daysAgo': '{d}d ago',
  'lumen.customerApproval.resendEmail': 'Resend Email',
  'lumen.customerApproval.cancelScheduled': 'Cancel Scheduled',
  'lumen.customerApproval.empty': 'No approval requests found',
  'lumen.customerApproval.detailsTitle': 'Approval Request Details',
  'lumen.customerApproval.requestInfo': 'Request Information',
  'lumen.customerApproval.requestedBy': 'Requested by:',
  'lumen.customerApproval.requestedOn': 'Requested: {date}',
  'lumen.customerApproval.reviewedOn': 'Reviewed: {date}',
  'lumen.customerApproval.revisionChecklist': 'Revision Checklist',
  'lumen.customerApproval.completed': '{checked}/{total} completed',
  'lumen.customerApproval.recipients': 'Recipients ({n})',
  'lumen.customerApproval.sent': 'Sent',
  'lumen.customerApproval.failed': 'Failed',
  'lumen.customerApproval.pending': 'Pending',
  'lumen.customerApproval.close': 'Close',
  'lumen.customerApproval.editDraft': 'Edit Draft',
  // customer-approval/reviewers (Batal, Simpan, Update and the email placeholder are lumen.common.*)
  'lumen.approvalReviewers.title': 'Reviewer Accounts',
  'lumen.approvalReviewers.description': 'Kelola akun reviewer untuk approval AJU draft.',
  'lumen.approvalReviewers.add': 'Tambah Reviewer',
  'lumen.approvalReviewers.editTitle': 'Edit Reviewer',
  'lumen.approvalReviewers.namePlaceholder': 'Full name',
  'lumen.approvalReviewers.passwordOptional': 'Password (optional)',
  'lumen.approvalReviewers.passwordPlaceholder': 'Min. 6 characters',
  'lumen.approvalReviewers.passwordKeepPlaceholder': 'Leave empty to keep current',
  // customer-approval/email-groups (Edit Email is lumen.common.editEmail)
  'lumen.approvalEmailGroups.title': 'Email Groups',
  'lumen.approvalEmailGroups.description': 'Kelola grup email untuk pengiriman approval AJU draft.',
  'lumen.approvalEmailGroups.addGroup': 'Tambah Group',
  'lumen.approvalEmailGroups.editGroup': 'Edit Group',
  'lumen.approvalEmailGroups.importir': 'Importir',
  'lumen.approvalEmailGroups.loading': 'Loading...',
  'lumen.approvalEmailGroups.filterPlaceholder': 'Pilih importir untuk filter grup',
  'lumen.approvalEmailGroups.importirPlaceholder': 'Pilih importir',
  'lumen.approvalEmailGroups.colDescription': 'Description',
  'lumen.approvalEmailGroups.emailCount': 'Jumlah Email',
  'lumen.approvalEmailGroups.addEmailRow': 'Tambah email',
  'lumen.approvalEmailGroups.groupNamePlaceholder': 'Group name',
  'lumen.approvalEmailGroups.groupDescriptionPlaceholder': 'Group description',
  'lumen.approvalEmailGroups.groupDetail': 'Group Detail',
  'lumen.approvalEmailGroups.addEmail': 'Tambah Email',
  'lumen.approvalEmailGroups.recipientNamePlaceholder': 'Recipient name',
  // customer-approval/roles, role-form-modal, user-assignment-drawer
  'lumen.customRoles.title': 'Roles & Permissions',
  'lumen.customRoles.description':
    'Buat role khusus, pilih menu yang boleh diakses beserta levelnya, lalu tugaskan user.',
  'lumen.customRoles.add': 'Tambah Role',
  'lumen.customRoles.fallback':
    'Akun Anda masih memakai role lama. Semua akses tetap berjalan seperti sebelumnya sampai admin menugaskan custom role.',
  'lumen.customRoles.showInactive': 'Tampilkan role nonaktif',
  'lumen.customRoles.colName': 'Nama Role',
  'lumen.customRoles.colCode': 'Kode',
  'lumen.customRoles.colDescription': 'Deskripsi',
  'lumen.customRoles.colUser': 'User',
  'lumen.customRoles.colMenus': 'Akses Menu',
  'lumen.customRoles.system': 'System',
  'lumen.customRoles.systemHint': 'Role bawaan sistem hasil migrasi role lama. Tidak dapat diubah.',
  'lumen.customRoles.menusNone': 'Tidak ada',
  'lumen.customRoles.menusFull': '{n} menu · penuh',
  'lumen.customRoles.menusRead': '{n} menu · lihat saja',
  'lumen.customRoles.menusMixed': '{n} menu · {full} penuh',
  'lumen.customRoles.editLocked': 'Role sistem tidak dapat diubah',
  'lumen.customRoles.duplicate': 'Duplikat',
  'lumen.customRoles.assignUser': 'Assign user',
  'lumen.customRoles.deactivate': 'Nonaktifkan',
  'lumen.customRoles.deleteLocked': 'Role sistem tidak dapat dihapus',
  'lumen.customRoles.deactivateTitle': 'Nonaktifkan Role',
  'lumen.customRoles.deactivateConfirm':
    'Role {name} akan dinonaktifkan. User yang masih aktif harus dipindahkan terlebih dahulu.',
  'lumen.customRoles.editTitle': 'Edit Role',
  'lumen.customRoles.duplicateTitle': 'Duplikat Role',
  'lumen.customRoles.tabGeneral': 'Informasi Umum',
  'lumen.customRoles.namePlaceholder': 'mis. Document Approver',
  'lumen.customRoles.codeLabel': 'Kode Role',
  'lumen.customRoles.codeHint': 'Format slug, dipakai di kode program. Dibuat otomatis dari nama.',
  'lumen.customRoles.codePlaceholder': 'document_approver',
  'lumen.customRoles.descriptionPlaceholder': 'Menjelaskan tanggung jawab role ini',
  'lumen.customRoles.active': 'Role aktif',
  'lumen.customRoles.menusEmpty': 'Katalog menu belum tersedia.',
  'lumen.customRoles.menusHint':
    'Menu yang dipilih menentukan halaman {and} data yang bisa diakses user dengan role ini. Menu yang tidak dipilih tidak akan tampil di sidebar dan datanya juga tidak bisa dibuka.',
  'lumen.customRoles.menusHintAnd': 'dan',
  'lumen.customRoles.levelRead': 'Lihat saja',
  'lumen.customRoles.levelFull': 'Penuh',
  'lumen.customRoles.levelReadHint':
    'User bisa membuka dan mengunduh, tidak bisa membuat, mengubah, mengirim, atau menghapus.',
  'lumen.customRoles.levelFullHint': 'User bisa melakukan semua aksi di menu ini.',
  'lumen.customRoles.assignTitle': 'Assign User — {name}',
  'lumen.customRoles.assignTitlePlain': 'Assign User',
  'lumen.customRoles.subjectReviewer': 'Reviewer',
  'lumen.customRoles.searchPlaceholder': 'Cari nama atau email',
  'lumen.customRoles.moving': '{n} user akan dipindahkan dari role lain ke role ini.',
  'lumen.customRoles.noUser': 'Tidak ada user yang cocok.',
  'lumen.customRoles.noReviewer': 'Tidak ada reviewer yang cocok.',
  'lumen.customRoles.inactive': 'Nonaktif',
  'lumen.customRoles.selected': '{n} dipilih',

  // ---- Lumen /management-dashboard (dashboards PR 5) ----
  // The old page's literal text, verbatim in every language (copy unchanged). {n}, {name}, {pct}, {rate},
  // {currency}, {at} and {filename} are filled with formatTemplate. dateRange is new (the preset select's
  // accessible name), translated. The toasts' "Error" title is lumen.common.error.
  'lumen.managementDashboard.title': 'Executive Dashboard',
  'lumen.managementDashboard.subtitle': 'Real-time business intelligence',
  'lumen.managementDashboard.rangeThisMonth': 'This Month',
  'lumen.managementDashboard.rangeLastMonth': 'Last Month',
  'lumen.managementDashboard.rangeLast3Months': 'Last 3 Months',
  'lumen.managementDashboard.rangeThisQuarter': 'This Quarter',
  'lumen.managementDashboard.rangeLastQuarter': 'Last Quarter',
  'lumen.managementDashboard.rangeThisYear': 'This Year',
  'lumen.managementDashboard.rangeLastYear': 'Last Year',
  'lumen.managementDashboard.rangeLast7Days': 'Last 7 Days',
  'lumen.managementDashboard.rangeLast30Days': 'Last 30 Days',
  'lumen.managementDashboard.rangeLast90Days': 'Last 90 Days',
  'lumen.managementDashboard.refresh': 'Refresh',
  'lumen.managementDashboard.downloadReport': 'Download Report',
  'lumen.managementDashboard.downloading': 'Downloading...',
  'lumen.managementDashboard.loading': 'Loading Executive Dashboard...',
  'lumen.managementDashboard.loadFailed': 'Failed to load dashboard',
  'lumen.managementDashboard.retry': 'Retry',
  'lumen.managementDashboard.totalProcesses': 'Total Processes',
  'lumen.managementDashboard.successfulCount': '{n} successful',
  'lumen.managementDashboard.nilaiPabean': 'Nilai Pabean',
  'lumen.managementDashboard.totalCustomsValue': 'Total customs value',
  'lumen.managementDashboard.activePpjks': 'Active PPJKs',
  'lumen.managementDashboard.processingAgents': 'Processing agents',
  'lumen.managementDashboard.monthlyTrends': 'Monthly Trends',
  'lumen.managementDashboard.monthlyTrendsDescription': 'Process volume over time',
  'lumen.managementDashboard.timeSeries': 'Time Series',
  'lumen.managementDashboard.noTrendData': 'No trend data available',
  'lumen.managementDashboard.unknown': 'Unknown',
  'lumen.managementDashboard.notAvailable': 'N/A',
  'lumen.managementDashboard.shipmentDistribution': 'Shipment Distribution',
  'lumen.managementDashboard.byShipmentType': 'By shipment type',
  'lumen.managementDashboard.distribution': 'Distribution',
  'lumen.managementDashboard.noShipmentData': 'No shipment data available',
  'lumen.managementDashboard.slicePercent': '{name}: {pct}%',
  'lumen.managementDashboard.ppjkPerformance': 'PPJK Performance',
  'lumen.managementDashboard.agentMetrics': 'Agent metrics',
  'lumen.managementDashboard.performance': 'Performance',
  'lumen.managementDashboard.successRate': '{rate}% Success',
  'lumen.managementDashboard.processes': 'Processes',
  'lumen.managementDashboard.successful': 'Successful',
  'lumen.managementDashboard.noPpjkData': 'No PPJK data available',
  'lumen.managementDashboard.currencyBreakdown': 'Currency Breakdown',
  'lumen.managementDashboard.transactionCurrencies': 'Transaction currencies',
  'lumen.managementDashboard.finance': 'Finance',
  'lumen.managementDashboard.transactions': 'Transactions',
  'lumen.managementDashboard.currencyLeads': '{currency} leads with {n} transactions',
  'lumen.managementDashboard.currencyUnavailable': 'Currency performance information unavailable',
  'lumen.managementDashboard.totalTransactions': 'Total transactions: {n}',
  'lumen.managementDashboard.noCurrencyData': 'No currency data available',
  'lumen.managementDashboard.topImportOrigins': 'Top Import Origins',
  'lumen.managementDashboard.byTotalProcesses': 'By total processes',
  'lumen.managementDashboard.imports': 'Imports',
  'lumen.managementDashboard.topExportDestinations': 'Top Export Destinations',
  'lumen.managementDashboard.exports': 'Exports',
  'lumen.managementDashboard.topImportHsCodes': 'Top Import HS Codes',
  'lumen.managementDashboard.byFrequency': 'By frequency',
  'lumen.managementDashboard.import': 'Import',
  'lumen.managementDashboard.frequency': 'Frequency',
  'lumen.managementDashboard.noImportHsData': 'No import HS code data available',
  'lumen.managementDashboard.topExportHsCodes': 'Top Export HS Codes',
  'lumen.managementDashboard.export': 'Export',
  'lumen.managementDashboard.noExportHsData': 'No export HS code data available',
  'lumen.managementDashboard.topImporters': 'Top Importers',
  'lumen.managementDashboard.topImportersDescription': 'Importer performance by total processes and goods',
  'lumen.managementDashboard.importAnalysis': 'Import Analysis',
  'lumen.managementDashboard.totalGoods': 'Total Goods',
  'lumen.managementDashboard.topExporters': 'Top Exporters',
  'lumen.managementDashboard.topExportersDescription': 'Exporter performance by total processes and goods',
  'lumen.managementDashboard.exportAnalysis': 'Export Analysis',
  'lumen.managementDashboard.financialSummary': 'Financial Summary',
  'lumen.managementDashboard.financialSummaryDescription': 'Value breakdown and exchange rates',
  'lumen.managementDashboard.hargaBarang': 'Harga Barang',
  'lumen.managementDashboard.totalFreight': 'Total Freight',
  'lumen.managementDashboard.biayaPenambah': 'Biaya Penambah',
  'lumen.managementDashboard.avgExchangeRate': 'Avg Exchange Rate',
  'lumen.managementDashboard.avgHargaPerProcess': 'Avg Harga per Process',
  'lumen.managementDashboard.avgPabeanPerProcess': 'Avg Nilai Pabean per Process',
  'lumen.managementDashboard.currencyDetails': 'Currency Details',
  'lumen.managementDashboard.currencyDetailsDescription': 'Exchange rates and transaction volumes',
  'lumen.managementDashboard.details': 'Details',
  'lumen.managementDashboard.currency': 'Currency',
  'lumen.managementDashboard.avgRate': 'Avg Rate',
  'lumen.managementDashboard.minRate': 'Min Rate',
  'lumen.managementDashboard.maxRate': 'Max Rate',
  'lumen.managementDashboard.generatedAt': 'Generated: {at}',
  'lumen.managementDashboard.version': 'Lumen Executive Dashboard v2.0',
  'lumen.managementDashboard.downloadSuccessTitle': 'Berhasil',
  'lumen.managementDashboard.downloadSuccess': 'Report {filename} terunduh.',
  'lumen.managementDashboard.downloadFailed': 'Gagal mengunduh report.',
  'lumen.managementDashboard.dateRange': '日期范围',
  // stamp-duty (Active is lumen.common.active)
  'lumen.stampDuty.title': 'Stamp Duty Generator',
  'lumen.stampDuty.description': 'Upload your PDF document to add official stamp duty marks',
  'lumen.stampDuty.uploadDocument': 'Upload Document',
  'lumen.stampDuty.dropHere': 'Drop your PDF file here',
  'lumen.stampDuty.orBrowse': 'or click to browse from your computer',
  'lumen.stampDuty.pdfOnly': 'PDF files only',
  'lumen.stampDuty.maxSize': 'Max 10MB',
  'lumen.stampDuty.supportedFormat': 'Supported Format',
  'lumen.stampDuty.pdfDocuments': 'PDF Documents',
  'lumen.stampDuty.processing': 'Processing',
  'lumen.stampDuty.automaticStamping': 'Automatic Stamping',
  'lumen.stampDuty.documentPreview': 'Document Preview',
  'lumen.stampDuty.sizeKb': '{n} KB',
  'lumen.stampDuty.uploadNew': 'Upload New File',
  'lumen.command.title': '命令面板',
  'lumen.command.description': '搜索要运行的命令…',
  'lumen.toast.region': '通知',

  // ---- Lumen respon (Kepabeanan › Respon) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.respon.searchPlaceholder': 'Cari berdasarkan nomor pengajuan, nama perusahaan, atau nama respon...',
  'lumen.respon.total': 'Total: {n} AJU',
  'lumen.respon.nomorAju': 'Nomor Pengajuan',
  'lumen.respon.namaPerusahaan': 'Nama Perusahaan',
  'lumen.respon.namaRespon': 'Nama Respon',
  'lumen.respon.count': '{n} respon',
  'lumen.respon.range': '{from} - {to} / {total} AJU',
  'lumen.respon.download': 'Download {label}',
  'lumen.respon.error': 'Error',
  'lumen.respon.success': 'Success',
  'lumen.respon.fetchFailed': 'Failed to fetch response data',
  'lumen.respon.fetchDataFailed': 'Failed to fetch data',
  'lumen.respon.fetchingTitle': 'Mengambil {label} dari CEISA…',
  'lumen.respon.fetchingBody': 'Dokumen belum ada di arsip; CEISA bisa memakan waktu hingga 30 detik.',
  'lumen.respon.downloaded': '{label} berhasil diunduh',
  'lumen.respon.downloadFailed': 'Gagal mengunduh {label}',

  // ---- Lumen database-barang (Kepabeanan › Database Barang) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.databaseBarang.searchPlaceholder': 'Cari kode barang, uraian, HS code...',
  'lumen.databaseBarang.ajuNo': 'Aju No',
  'lumen.databaseBarang.companyName': 'Company Name',
  'lumen.databaseBarang.total': 'Total: {n} records',
  'lumen.databaseBarang.downloadExcel': 'Download Excel',
  'lumen.databaseBarang.kodeNegaraAsal': 'Kode Negara Asal',
  'lumen.databaseBarang.merk': 'Merk',
  'lumen.databaseBarang.uraian': 'Uraian',
  'lumen.databaseBarang.hsCode': 'HS Code',
  'lumen.databaseBarang.kodeBarang': 'Kode Barang',
  'lumen.databaseBarang.uom': 'UOM',
  'lumen.databaseBarang.unitPrice': 'Unit Price',
  'lumen.databaseBarang.currency': 'Currency',
  'lumen.databaseBarang.range': '{from} - {to} / {total}',
  'lumen.databaseBarang.error': 'Error',
  'lumen.databaseBarang.success': 'Success',
  'lumen.databaseBarang.fetchDataFailed': 'Failed to fetch data',
  'lumen.databaseBarang.fetchFailed': 'Failed to fetch database barang data',
  'lumen.databaseBarang.downloaded': 'Database barang downloaded',
  'lumen.databaseBarang.downloadFailed': 'Failed to download database barang',

  // ---- Lumen manifest-dashboard (Manifest › Dashboard) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.manifestDashboard.title': 'Manifest Dashboard',
  'lumen.manifestDashboard.subtitle': 'Real-time overview of your manifest operations',
  'lumen.manifestDashboard.startDate': 'Start date',
  'lumen.manifestDashboard.endDate': 'End date',
  'lumen.manifestDashboard.downloadReport': 'Download Excel Report',
  'lumen.manifestDashboard.downloading': 'Downloading...',
  'lumen.manifestDashboard.loading': 'Loading dashboard...',
  'lumen.manifestDashboard.noData': 'No data available',
  'lumen.manifestDashboard.totalManifests': 'Total Manifests',
  'lumen.manifestDashboard.totalHouseBls': 'Total House BLs',
  'lumen.manifestDashboard.critical': 'Critical',
  'lumen.manifestDashboard.pending': 'Pending',
  'lumen.manifestDashboard.submittedToday': 'Submitted Today',
  'lumen.manifestDashboard.attentionRequired': 'Attention Required',
  'lumen.manifestDashboard.needAttention': '{pct}% of manifests need attention',
  'lumen.manifestDashboard.criticalCount': '{n} Critical',
  'lumen.manifestDashboard.mediumCount': '{n} Medium',
  'lumen.manifestDashboard.normalCount': '{n} Normal',
  'lumen.manifestDashboard.statusDistribution': 'Status Distribution',
  'lumen.manifestDashboard.draft': 'Draft',
  'lumen.manifestDashboard.sent': 'Sent',
  'lumen.manifestDashboard.ready': 'Ready',
  'lumen.manifestDashboard.deleted': 'Deleted',
  'lumen.manifestDashboard.sharePct': '({pct}%)',
  'lumen.manifestDashboard.companyPerformance': 'Company Performance',
  'lumen.manifestDashboard.submitted': 'Submitted',
  'lumen.manifestDashboard.manifestCount': '{n} manifests',
  'lumen.manifestDashboard.criticalManifests': 'Critical Manifests',
  'lumen.manifestDashboard.noCriticalManifests': 'No critical manifests',
  'lumen.manifestDashboard.daysUntil': '{n}d',
  'lumen.manifestDashboard.upcomingEvents': 'Upcoming Events',
  'lumen.manifestDashboard.noUpcomingEvents': 'No upcoming events',
  'lumen.manifestDashboard.typeInwardSea': 'Inward Laut',
  'lumen.manifestDashboard.typeInwardAir': 'Inward Udara',
  'lumen.manifestDashboard.typeOutwardSea': 'Outward Laut',
  'lumen.manifestDashboard.typeOutwardAir': 'Outward Udara',
  'lumen.manifestDashboard.toastSuccess': 'Berhasil',
  'lumen.manifestDashboard.reportDownloaded': 'Report {filename} terunduh.',
  'lumen.manifestDashboard.downloadFailed': 'Gagal mengunduh report.',
  'lumen.manifestDashboard.demoModeTitle': 'Demo Mode',
  'lumen.manifestDashboard.demoModeBody': 'Backend endpoint not available. Showing demo data.',
  'lumen.manifestDashboard.fetchFailed': 'Failed to fetch dashboard data: {message}',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 S): the submit dialog (ModalSubmit) and the incomplete-manifest
  // report (IncompleteManifestModal), their toasts. The old text verbatim in every language; {label}, {bl}, {name},
  // {address}, {message} and {n} are filled with formatTemplate. Nomor AJU and Cek Lengkap (with its three toasts) are
  // the shell block's; Batal, Simpan, Success and Error are lumen.common.*.
  'lumen.manifestEngine.submit.title': 'Manifest',
  'lumen.manifestEngine.submit.ajuPlaceholder': 'Masukkan Nomor AJU',
  'lumen.manifestEngine.submit.refresh': 'Refresh Nomor AJU',
  'lumen.manifestEngine.submit.ajuUpdated': 'Nomor AJU berhasil diperbarui',
  'lumen.manifestEngine.submit.ajuLoadFailed': 'Gagal memuat nomor AJU terbaru',
  'lumen.manifestEngine.submit.ajuEmpty': 'Nomor AJU tidak boleh kosong',
  'lumen.manifestEngine.submit.belumTitle': 'Belum Lengkap',
  'lumen.manifestEngine.submit.belumFallback': 'Data belum lengkap',
  'lumen.manifestEngine.submit.noProcessId': 'Manifest ID tidak ditemukan',
  'lumen.manifestEngine.submit.referenceLabel': 'Reference ID',
  'lumen.manifestEngine.submit.referenceRequiredTitle': '{label} wajib diisi',
  'lumen.manifestEngine.submit.referenceRequiredBody': 'Isi {label} di tab Header sebelum manifest dikirim',
  'lumen.manifestEngine.submit.noBlTitle': 'Manifest belum memiliki {bl}',
  'lumen.manifestEngine.submit.noBlBody': 'Tambahkan minimal satu {bl} sebelum submit ke CEISA',
  'lumen.manifestEngine.submit.companyMissing': 'Data perusahaan tidak tersedia. Name: {name}, Address: {address}',
  'lumen.manifestEngine.submit.companyEmpty': 'empty',
  'lumen.manifestEngine.submit.submitted': 'Manifest berhasil disubmit ke CEISA',
  'lumen.manifestEngine.submit.submitFailed': 'Gagal submit manifest',
  'lumen.manifestEngine.submit.submitFailedWith': 'Gagal submit manifest: {message}',
  'lumen.manifestEngine.submit.tutup': 'Tutup',
  'lumen.manifestEngine.submit.ok': 'OK',
  'lumen.manifestEngine.submit.incompleteTitle': 'Data Belum Lengkap',
  'lumen.manifestEngine.submit.incompleteBody':
    'Manifest belum bisa didorong ke CEISA. Lengkapi {n} kolom wajib berikut terlebih dahulu.',

  // ---- Lumen manifest/draft (revamp PR 6a, unit F6) ----
  // The old page's literal text, verbatim in every language (copy unchanged). Status, Actions, Edit, Error,
  // Success and Cancel are lumen.common.*.
  'lumen.manifestDraft.title': 'Draft Manifest',
  'lumen.manifestDraft.subtitle': 'Kelola draft manifest yang belum disubmit',
  'lumen.manifestDraft.searchPlaceholder': 'Cari berdasarkan nama perusahaan...',
  'lumen.manifestDraft.search': 'Search',
  'lumen.manifestDraft.deleteSelected': 'Delete ({n})',
  'lumen.manifestDraft.colType': 'Type',
  'lumen.manifestDraft.colCompany': 'Nama Perusahaan',
  'lumen.manifestDraft.colVessel': 'Sarana Pengangkut',
  'lumen.manifestDraft.colVoyage': 'Voyage',
  'lumen.manifestDraft.colDeparture': 'Tgl Berangkat',
  'lumen.manifestDraft.colArrival': 'Tgl Tiba',
  'lumen.manifestDraft.modeLaut': 'Laut',
  'lumen.manifestDraft.modeUdara': 'Udara',
  'lumen.manifestDraft.modeDarat': 'Darat',
  'lumen.manifestDraft.imo': ' | IMO: {imo}',
  'lumen.manifestDraft.view': 'View',
  'lumen.manifestDraft.demoCannotView': 'Demo users cannot view',
  'lumen.manifestDraft.demoCannotEdit': 'Demo users cannot edit',
  'lumen.manifestDraft.fetchFailed': 'Failed to fetch drafts: {message}',
  'lumen.manifestDraft.noSelectionTitle': 'No Selection',
  'lumen.manifestDraft.noSelectionBody': 'Please select at least one record to delete',
  'lumen.manifestDraft.deleted': 'Successfully deleted {n} record(s)',
  'lumen.manifestDraft.deleteFailed': 'Failed to delete records: {message}',
  'lumen.manifestDraft.confirmTitle': 'Confirm Delete',
  'lumen.manifestDraft.confirmBody': 'Are you sure you want to delete {n} record(s)? This action cannot be undone.',
  'lumen.manifestDraft.delete': 'Delete',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 B1): the BL list (table, toolbar, bulk edit, sync, print chrome,
  // NOA) and the PEB / BL susulan upload. The old text verbatim in every language (copy unchanged); {n}, {message}, {ok},
  // {fail}, {mapped}, {direction}, {doc}, {checked}, {total}, {label} and {name} are filled with formatTemplate. New labels the
  // new parts need (bl.selectAllRows, bl.reorderHint, susulan.removeFile) are Indonesian like the page. The print documents
  // and the CEISA code labels stay as constants (i1 §11 settled 2).
  'lumen.manifestEngine.bl.titleBl': 'Data BL',
  'lumen.manifestEngine.bl.titleAwb': 'Data AWB',
  'lumen.manifestEngine.bl.bulkEdit': 'Bulk Edit ({n} dipilih)',
  'lumen.manifestEngine.bl.uploadNoa': 'Upload NOA',
  'lumen.manifestEngine.bl.susulanOutBl': 'Upload PEB / BL Susulan',
  'lumen.manifestEngine.bl.susulanOutAwb': 'Upload PEB / AWB Susulan',
  'lumen.manifestEngine.bl.susulanInBl': 'Upload BL Susulan',
  'lumen.manifestEngine.bl.susulanInAwb': 'Upload AWB Susulan',
  'lumen.manifestEngine.bl.printAllBl': 'Cetak Semua BL',
  'lumen.manifestEngine.bl.printAllAwb': 'Cetak Semua AWB',
  'lumen.manifestEngine.bl.syncMasterBl': 'Sync with Master BL',
  'lumen.manifestEngine.bl.syncMasterAwb': 'Sync with Master AWB',
  'lumen.manifestEngine.bl.syncAllPorts': 'Sync All Ports',
  'lumen.manifestEngine.bl.addBl': 'Tambah Data BL',
  'lumen.manifestEngine.bl.addAwb': 'Tambah Data AWB',
  'lumen.manifestEngine.bl.colNo': 'No',
  'lumen.manifestEngine.bl.colNoPos': 'No Pos',
  'lumen.manifestEngine.bl.colPorts': 'Kode Pelabuhan',
  'lumen.manifestEngine.bl.portAsal': 'Asal:',
  'lumen.manifestEngine.bl.portBongkar': 'Bongkar:',
  'lumen.manifestEngine.bl.portTransit': 'Transit:',
  'lumen.manifestEngine.bl.portAkhir': 'Akhir:',
  'lumen.manifestEngine.bl.colMasterBl': 'Master BL',
  'lumen.manifestEngine.bl.colMasterAwb': 'Master AWB',
  'lumen.manifestEngine.bl.colHostBl': 'Host BL',
  'lumen.manifestEngine.bl.colHostAwb': 'Host AWB',
  'lumen.manifestEngine.bl.colPeb': 'No. PEB / PPKEK',
  'lumen.manifestEngine.bl.colShipper': 'Shipper',
  'lumen.manifestEngine.bl.colConsignee': 'Consignee',
  'lumen.manifestEngine.bl.colFileName': 'File Name',
  'lumen.manifestEngine.bl.colActions': 'Aksi',
  'lumen.manifestEngine.bl.actionEdit': 'Edit',
  'lumen.manifestEngine.bl.actionCopy': 'Copy',
  'lumen.manifestEngine.bl.actionPrint': 'Print',
  'lumen.manifestEngine.bl.actionDelete': 'Delete',
  'lumen.manifestEngine.bl.selectAllRows': 'Pilih semua baris',
  'lumen.manifestEngine.bl.reorderHint': 'Seret untuk mengubah urutan',
  'lumen.manifestEngine.bl.copyUnsaved': 'Tidak dapat menyalin BL yang belum disimpan',
  'lumen.manifestEngine.bl.copyingTitle': 'Copying...',
  'lumen.manifestEngine.bl.copying': 'Menyalin BL...',
  'lumen.manifestEngine.bl.copied': 'BL berhasil disalin',
  'lumen.manifestEngine.bl.copyFailed': 'Gagal menyalin BL',
  'lumen.manifestEngine.bl.copyFailedWith': 'Gagal menyalin BL: {message}',
  'lumen.manifestEngine.bl.deleted': 'BL berhasil dihapus',
  'lumen.manifestEngine.bl.deletingTitle': 'Deleting...',
  'lumen.manifestEngine.bl.deleting': 'Menghapus BL...',
  'lumen.manifestEngine.bl.deleteFailed': 'Gagal menghapus BL',
  'lumen.manifestEngine.bl.deleteFailedWith': 'Gagal menghapus BL: {message}',
  'lumen.manifestEngine.bl.processingTitle': 'Processing...',
  'lumen.manifestEngine.bl.partialTitle': 'Partial Success',
  'lumen.manifestEngine.bl.partial': 'Berhasil: {ok} BL, Gagal: {fail} BL',
  'lumen.manifestEngine.bl.infoTitle': 'Info',
  'lumen.manifestEngine.bl.noBls': 'Tidak ada BL untuk disinkronkan',
  'lumen.manifestEngine.bl.noMasterData': 'Tidak ada data Master BL atau Vessel untuk disinkronkan',
  'lumen.manifestEngine.bl.syncingMaster': 'Menyinkronkan {n} BL dengan Master BL...',
  'lumen.manifestEngine.bl.syncedMaster': 'Berhasil menyinkronkan {n} BL dengan Master BL',
  'lumen.manifestEngine.bl.syncFailed': 'Sinkronisasi gagal',
  'lumen.manifestEngine.bl.noPortData': 'Tidak ada data pelabuhan untuk disinkronkan',
  'lumen.manifestEngine.bl.lookingUpPorts': 'Mencari kode pelabuhan untuk {n} pelabuhan...',
  'lumen.manifestEngine.bl.portsAllCorrect': 'Semua pelabuhan sudah menggunakan kode yang benar',
  'lumen.manifestEngine.bl.updatingPorts': 'Memperbarui {n} BL dengan kode pelabuhan...',
  'lumen.manifestEngine.bl.portsMapped': '{mapped} pelabuhan berhasil dimapping, {ok} BL diperbarui',
  'lumen.manifestEngine.bl.portsFailedWith': 'Sinkronisasi pelabuhan gagal: {message}',
  'lumen.manifestEngine.bl.noneSelected': 'Tidak ada BL yang dipilih',
  'lumen.manifestEngine.bl.bulkUpdating': 'Memperbarui {n} BL...',
  'lumen.manifestEngine.bl.bulkUpdated': 'Berhasil memperbarui {n} BL',
  'lumen.manifestEngine.bl.bulkFailed': 'Bulk edit gagal',
  'lumen.manifestEngine.bl.reordering': 'Menyimpan urutan BL...',
  'lumen.manifestEngine.bl.reordered': 'Urutan BL berhasil diubah dan disimpan',
  'lumen.manifestEngine.bl.reorderFailed': 'Gagal menyimpan urutan BL',
  'lumen.manifestEngine.bl.bulkTitle': 'Bulk Edit BL',
  'lumen.manifestEngine.bl.bulkIntro': 'Isi field yang ingin diupdate. Field yang kosong tidak akan diubah.',
  'lumen.manifestEngine.bl.bulkMasterBlPlaceholder': 'Master BL (opsional)',
  'lumen.manifestEngine.bl.bulkDate': 'Tanggal Master BL',
  'lumen.manifestEngine.bl.bulkDatePlaceholder': 'Tanggal Master BL (opsional)',
  'lumen.manifestEngine.bl.bulkVessel': 'Vessel Name',
  'lumen.manifestEngine.bl.bulkVesselPlaceholder': 'Vessel Name (opsional)',
  'lumen.manifestEngine.bl.pelabuhanAsal': 'Pelabuhan Asal',
  'lumen.manifestEngine.bl.pelabuhanBongkar': 'Pelabuhan Bongkar',
  'lumen.manifestEngine.bl.pelabuhanTransit': 'Pelabuhan Transit',
  'lumen.manifestEngine.bl.pelabuhanAkhir': 'Pelabuhan Akhir',
  'lumen.manifestEngine.bl.pelabuhanAsalPlaceholder': 'Pilih Pelabuhan Asal (opsional)',
  'lumen.manifestEngine.bl.pelabuhanBongkarPlaceholder': 'Pilih Pelabuhan Bongkar (opsional)',
  'lumen.manifestEngine.bl.pelabuhanTransitPlaceholder': 'Pilih Pelabuhan Transit (opsional)',
  'lumen.manifestEngine.bl.pelabuhanAkhirPlaceholder': 'Pilih Pelabuhan Akhir (opsional)',
  'lumen.manifestEngine.bl.bulkApply': 'Terapkan ke {n} BL',
  'lumen.manifestEngine.bl.syncPortsText':
    'Proses ini akan mencari kode pelabuhan untuk semua nama pelabuhan di {n} BL, lalu memperbarui semua BL dengan kode pelabuhan yang ditemukan.',
  'lumen.manifestEngine.bl.syncPortsFound': '{n} pelabuhan unik ditemukan:',
  'lumen.manifestEngine.bl.lanjutkan': 'Lanjutkan',
  'lumen.manifestEngine.bl.printTitle': 'Print Preview - {direction} Manifest BC 1.1',
  'lumen.manifestEngine.bl.printAllTitle': 'Print Preview - {direction} Manifest BC 1.1 ({n} {doc})',
  'lumen.manifestEngine.bl.tutup': 'Tutup',
  'lumen.manifestEngine.bl.printManifest': 'Print Manifest',
  'lumen.manifestEngine.bl.printAll': 'Print Semua Manifest ({n})',
  'lumen.manifestEngine.bl.showChecklist': 'Show Checklist',
  'lumen.manifestEngine.bl.hideChecklist': 'Hide Checklist',
  'lumen.manifestEngine.bl.checkedCount': '{checked}/{total} checked',
  'lumen.manifestEngine.bl.checkAll': 'Check All',
  'lumen.manifestEngine.bl.uncheckAll': 'Uncheck All',
  'lumen.manifestEngine.bl.noaBusy': 'Memproses NOA...',
  'lumen.manifestEngine.bl.noaBusyHint': 'Mohon tunggu, jangan tutup halaman.',
  'lumen.manifestEngine.bl.noaNoProcess': 'Manifest belum tersedia. Simpan header dulu sebelum upload NOA.',
  'lumen.manifestEngine.bl.noaNoBatch': 'Batch UUID tidak ditemukan.',
  'lumen.manifestEngine.bl.noaNoFileUrl': 'Upload response tidak mengandung file_url.',
  'lumen.manifestEngine.bl.noaDone': 'Ekstraksi NOA selesai. Memuat ulang data...',
  'lumen.manifestEngine.bl.noaFailed': 'Upload NOA gagal.',
  'lumen.manifestEngine.bl.noaNotFound': 'Manifest tidak ditemukan.',
  'lumen.manifestEngine.bl.noaNoContainer': 'NOA tidak punya container yang bisa dipakai, atau BL/PEB belum diupload.',
  'lumen.manifestEngine.susulan.descInAwb': 'Upload file AWB tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.descInBl': 'Upload file BL tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.descOutAwb': 'Upload file PEB atau AWB tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.descOutBl': 'Upload file PEB atau BL tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.dropInAwb': 'Drag & drop file AWB',
  'lumen.manifestEngine.susulan.dropInBl': 'Drag & drop file BL',
  'lumen.manifestEngine.susulan.dropOutAwb': 'Drag & drop file PEB / AWB',
  'lumen.manifestEngine.susulan.dropOutBl': 'Drag & drop file PEB / BL',
  'lumen.manifestEngine.susulan.dropActive': 'Drop file PDF disini',
  'lumen.manifestEngine.susulan.browseOr': 'atau',
  'lumen.manifestEngine.susulan.browseLink': 'klik untuk browse',
  'lumen.manifestEngine.susulan.pdfOnly': 'PDF Only',
  'lumen.manifestEngine.susulan.maxFiles': 'Maks. 20 file',
  'lumen.manifestEngine.susulan.docType': 'Tipe Dokumen',
  'lumen.manifestEngine.susulan.docTypeHint':
    'Pilih tipe dokumen yang akan diupload. File yang di-drop akan otomatis menggunakan tipe ini.',
  'lumen.manifestEngine.susulan.listTitle': 'File yang akan diupload ({n})',
  'lumen.manifestEngine.susulan.uploadFailed': 'Gagal mengupload',
  'lumen.manifestEngine.susulan.uploading': 'Uploading...',
  'lumen.manifestEngine.susulan.uploaded': 'Uploaded',
  'lumen.manifestEngine.susulan.removeFile': 'Hapus {name}',
  'lumen.manifestEngine.susulan.proceed': 'Proceed',
  'lumen.manifestEngine.susulan.processing': 'Processing...',
  'lumen.manifestEngine.susulan.badFormatTitle': 'Format tidak sesuai',
  'lumen.manifestEngine.susulan.badFormat': 'Hanya file PDF yang diperbolehkan',
  'lumen.manifestEngine.susulan.tooManyTitle': 'Terlalu banyak file',
  'lumen.manifestEngine.susulan.tooMany': 'Maksimal 20 file dapat diupload',
  'lumen.manifestEngine.susulan.addedTitle': 'File ditambahkan',
  'lumen.manifestEngine.susulan.added': '{n} file berhasil ditambahkan',
  'lumen.manifestEngine.susulan.noFilesTitle': 'Tidak ada file',
  'lumen.manifestEngine.susulan.noFiles': 'Silakan tambahkan file terlebih dahulu',
  'lumen.manifestEngine.susulan.noneUploaded': 'Tidak ada file yang berhasil diupload',
  'lumen.manifestEngine.susulan.done': 'Berhasil menambahkan {n} {label} susulan',
  'lumen.manifestEngine.susulan.failed': 'Gagal menambahkan dokumen susulan',
  'lumen.manifestEngine.susulan.failedWith': 'Gagal menambahkan dokumen susulan: {message}',

  // ---- Lumen harga-referensi (Kuota Impor / Ekspor › Harga Referensi) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.hargaReferensi.title': 'Harga Referensi',
  'lumen.hargaReferensi.description': 'Search and view preferential tariff reference prices by HS Code',
  'lumen.hargaReferensi.searchPlaceholder': 'Enter HS Code (min. 6 digits)...',
  'lumen.hargaReferensi.hsCode': 'HS Code',
  'lumen.hargaReferensi.period': 'Period',
  'lumen.hargaReferensi.month': 'Month',
  'lumen.hargaReferensi.year': 'Year',
  'lumen.hargaReferensi.referencePrice': 'Reference Price',
  'lumen.hargaReferensi.currency': 'Currency',
  'lumen.hargaReferensi.uom': 'UOM',
  'lumen.hargaReferensi.notAvailable': 'N/A',
  'lumen.hargaReferensi.noRecordsFor': 'No reference prices found for HS Code: {hsCode}',
  'lumen.hargaReferensi.noRecords': 'No reference prices available',
  'lumen.hargaReferensi.error': 'Error',
  'lumen.hargaReferensi.fetchFailed': 'Failed to fetch tariffs',

  // ---- Lumen shipment-quota (Kuota Impor / Ekspor › Kuota Pengiriman, + create) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.shipmentQuota.title': 'Shipment Quota Management',
  'lumen.shipmentQuota.create': 'Create Quota',
  'lumen.shipmentQuota.searchPlaceholder': 'Search by HS Code...',
  'lumen.shipmentQuota.empty': 'No shipment quotas yet',
  'lumen.shipmentQuota.createFirst': 'Create Your First Quota',
  'lumen.shipmentQuota.status': 'Status',
  'lumen.shipmentQuota.hsCode': 'HS Code',
  'lumen.shipmentQuota.shipmentType': 'Shipment Type',
  'lumen.shipmentQuota.totalQuota': 'Total Quota',
  'lumen.shipmentQuota.quotaLeft': 'Quota Left',
  'lumen.shipmentQuota.usage': 'Usage %',
  'lumen.shipmentQuota.expiredDate': 'Expired Date',
  'lumen.shipmentQuota.createdAt': 'Created At',
  'lumen.shipmentQuota.expired': 'Expired',
  'lumen.shipmentQuota.depleted': 'Depleted',
  'lumen.shipmentQuota.low': 'Low',
  'lumen.shipmentQuota.active': 'Active',
  'lumen.shipmentQuota.error': 'Error',
  'lumen.shipmentQuota.success': 'Success',
  'lumen.shipmentQuota.fetchFailed': 'Failed to fetch quotas',
  'lumen.shipmentQuota.createTitle': 'Create Shipment Quota',
  'lumen.shipmentQuota.createDescription': 'Fill in the details below to create a new shipment quota',
  'lumen.shipmentQuota.ppjkNpwp': 'PPJK NPWP',
  'lumen.shipmentQuota.ppjkLoading': 'Loading PPJK NPWP...',
  'lumen.shipmentQuota.ppjkPlaceholder': 'PPJK NPWP from your account',
  'lumen.shipmentQuota.hsPlaceholder': 'Search HS Code...',
  'lumen.shipmentQuota.lartas': 'LARTAS',
  'lumen.shipmentQuota.nonLartas': 'NON-LARTAS',
  'lumen.shipmentQuota.uom': 'Unit of Measure (UOM)',
  'lumen.shipmentQuota.uomPlaceholder': 'Select UOM...',
  'lumen.shipmentQuota.typePlaceholder': 'Select shipment type',
  'lumen.shipmentQuota.import': 'Import',
  'lumen.shipmentQuota.export': 'Export',
  'lumen.shipmentQuota.quota': 'Quota',
  'lumen.shipmentQuota.quotaPlaceholder': 'Enter quota amount',
  'lumen.shipmentQuota.expiredPlaceholder': 'Select expiration date and time',
  'lumen.shipmentQuota.cancel': 'Cancel',
  'lumen.shipmentQuota.required': 'Please fill in all required fields',
  'lumen.shipmentQuota.created': 'Shipment quota created successfully!',
  'lumen.shipmentQuota.createFailed': 'Failed to create shipment quota',
  // New labels for the Lumen date-time field (translated).
  'lumen.shipmentQuota.time': '时间',
  'lumen.shipmentQuota.done': '完成',

  // ---- Lumen ssm/data (SSM › Data, + SSMForm) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.ssmData.pageTitle': 'SSM Data Management',
  'lumen.ssmData.totalItems': 'Total Items',
  'lumen.ssmData.activeItems': 'Active Items',
  'lumen.ssmData.inactiveItems': 'Inactive Items',
  'lumen.ssmData.lastUpdated': 'Last Updated',
  'lumen.ssmData.today': 'Today',
  'lumen.ssmData.sectionTitle': 'SSM Data',
  'lumen.ssmData.sectionDescription': 'Manage system configuration and master data',
  'lumen.ssmData.refresh': 'Refresh',
  'lumen.ssmData.addNew': 'Add New Item',
  'lumen.ssmData.searchPlaceholder': 'Search by code, name, or description...',
  'lumen.ssmData.code': 'Code',
  'lumen.ssmData.name': 'Name',
  'lumen.ssmData.description': 'Description',
  'lumen.ssmData.status': 'Status',
  'lumen.ssmData.actions': 'Actions',
  'lumen.ssmData.active': 'Active',
  'lumen.ssmData.inactive': 'Inactive',
  'lumen.ssmData.viewDetails': 'View Details',
  'lumen.ssmData.edit': 'Edit',
  'lumen.ssmData.delete': 'Delete',
  'lumen.ssmData.noData': 'No data found',
  'lumen.ssmData.showing': 'Showing {n} of {total} items',
  'lumen.ssmData.step.pemberitahuan': 'Pemberitahuan',
  'lumen.ssmData.step.transportasi': 'Transportasi',
  'lumen.ssmData.step.dokumen': 'Dokumen',
  'lumen.ssmData.step.komoditi': 'Komoditi',
  'lumen.ssmData.step.layanan': 'Layanan',
  'lumen.ssmData.formMeta': 'No Pengajuan : | Jenis API : 02',
  'lumen.ssmData.formTitle': 'Data Pemberitahuan',
  'lumen.ssmData.tabUtama': 'Data Utama',
  'lumen.ssmData.tabEntitas': 'Data Entitas',
  'lumen.ssmData.tabPungutan': 'Data Pungutan',
  'lumen.ssmData.nomerPengajuan': 'Nomer Pengajuan',
  'lumen.ssmData.tanggalPengajuan': 'Tanggal Pengajuan',
  'lumen.ssmData.nomorPendaftaran': 'Nomor Pendaftaran',
  'lumen.ssmData.tanggalPendaftaran': 'Tanggal Pendaftaran',
  'lumen.ssmData.kantorPabean': 'Kantor Pabean',
  'lumen.ssmData.skepFasilitas': 'SKEP Fasilitas',
  'lumen.ssmData.jenisPib': 'Jenis PIB',
  'lumen.ssmData.jenisImpor': 'Jenis Impor',
  'lumen.ssmData.caraPembayaran': 'Cara Pembayaran',
  'lumen.ssmData.transaksi': 'Transaksi',
  'lumen.ssmData.kodePembayaran': 'Kode Pembayaran',
  'lumen.ssmData.previous': 'Sebelumnya',
  'lumen.ssmData.next': 'Selanjutnya',
  'lumen.ssmData.opt.kantorPabean.kpu_tanjung_priok': 'KPU TANJUNG PRIOK',
  'lumen.ssmData.opt.kantorPabean.kpu_soekarno_hatta': 'KPU SOEKARNO HATTA',
  'lumen.ssmData.opt.kantorPabean.kpu_juanda': 'KPU JUANDA',
  'lumen.ssmData.opt.skepFasilitas.asean_china_fta': 'PREFERENSI TARIF IMPORTASI ASEAN-CHINA FTA',
  'lumen.ssmData.opt.skepFasilitas.asean_korea_fta': 'PREFERENSI TARIF IMPORTASI ASEAN-KOREA FTA',
  'lumen.ssmData.opt.skepFasilitas.asean_india_fta': 'PREFERENSI TARIF IMPORTASI ASEAN-INDIA FTA',
  'lumen.ssmData.opt.jenisPib.biasa': 'Biasa',
  'lumen.ssmData.opt.jenisPib.khusus': 'Khusus',
  'lumen.ssmData.opt.jenisPib.sementara': 'Sementara',
  'lumen.ssmData.opt.jenisImpor.untuk_dipakai': 'UNTUK DIPAKAI',
  'lumen.ssmData.opt.jenisImpor.sementara': 'SEMENTARA',
  'lumen.ssmData.opt.jenisImpor.angkutan': 'ANGKUTAN',
  'lumen.ssmData.opt.caraPembayaran.biasa_tunai': 'BIASA/TUNAI',
  'lumen.ssmData.opt.caraPembayaran.kredit': 'KREDIT',
  'lumen.ssmData.opt.caraPembayaran.transfer': 'TRANSFER',
  'lumen.ssmData.opt.transaksi.perdagangan': 'Transaksi Perdagangan Atau Cara Pemi',
  'lumen.ssmData.opt.transaksi.non_perdagangan': 'Non Perdagangan',

  'lumen.shell.menu': '菜单',
  'lumen.shell.menuDescription': '应用主导航',
  // ---- Lumen shell: sidebar ----
  'lumen.sidebar.navLabel': '主菜单',
  'lumen.sidebar.locked': '模块未启用',
  // ---- Lumen shell: reviewer area and feature lock ----
  // The old screens showed this copy as literals, one language for everyone; kept verbatim (copy decision).
  'lumen.reviewer.dashboard': 'Dashboard',
  'lumen.reviewer.role': 'Reviewer',
  'lumen.reviewer.logout': 'Logout',
  // ---- Lumen master B (revamp PR 4): customer-email-forwarding, sea-carriers, revoke-access, consignee ----
  // The old pages' literal copy is kept verbatim in every language; labels new components need are translated.
  'lumen.customerEmailForwarding.title': 'CEISA Customer Email Forwarding',
  'lumen.customerEmailForwarding.description': 'Kelola mapping importir dan penerima email forwarding CEISA.',
  'lumen.customerEmailForwarding.addMapping': 'Tambah Mapping',
  'lumen.customerEmailForwarding.editMappingTitle': 'Edit Mapping',
  'lumen.customerEmailForwarding.failed': 'Gagal',
  'lumen.customerEmailForwarding.importirLoadFailed': 'Daftar importir tidak dapat dimuat.',
  'lumen.customerEmailForwarding.loadFailedTitle': 'Data tidak dapat dimuat',
  'lumen.customerEmailForwarding.tenantImportirLoadFailed': 'Daftar importir tenant tidak dapat dimuat.',
  'lumen.customerEmailForwarding.filterImportir': 'Filter importir',
  'lumen.customerEmailForwarding.loadingImportir': 'Memuat importir...',
  'lumen.customerEmailForwarding.importirPlaceholder': 'Cari nama atau NPWP importir',
  'lumen.customerEmailForwarding.searchMapping': 'Cari mapping',
  'lumen.customerEmailForwarding.searchPlaceholder': 'Nama atau NPWP importir',
  'lumen.customerEmailForwarding.importir': 'Importir',
  'lumen.customerEmailForwarding.recipients': 'Penerima',
  'lumen.customerEmailForwarding.status': 'Status',
  'lumen.customerEmailForwarding.active': 'Aktif',
  'lumen.customerEmailForwarding.inactive': 'Nonaktif',
  'lumen.customerEmailForwarding.actions': 'Aksi',
  'lumen.customerEmailForwarding.manageRecipients': 'Kelola penerima',
  'lumen.customerEmailForwarding.editMapping': 'Edit mapping',
  'lumen.customerEmailForwarding.deactivateMapping': 'Nonaktifkan mapping',
  'lumen.customerEmailForwarding.activateMapping': 'Aktifkan mapping',
  'lumen.customerEmailForwarding.importirRequired': 'Importir wajib dipilih.',
  'lumen.customerEmailForwarding.importirUnavailable': 'Importir tidak tersedia untuk tenant ini.',
  'lumen.customerEmailForwarding.cancel': 'Batal',
  'lumen.customerEmailForwarding.save': 'Simpan',
  'lumen.customerEmailForwarding.recipientsTitle': 'Penerima Email',
  'lumen.customerEmailForwarding.showInactive': 'Tampilkan penerima nonaktif',
  'lumen.customerEmailForwarding.inactiveLoadFailed': 'Penerima nonaktif tidak dapat dimuat.',
  'lumen.customerEmailForwarding.name': 'Nama',
  'lumen.customerEmailForwarding.email': 'Email',
  'lumen.customerEmailForwarding.emailPlaceholder': 'nama@perusahaan.com',
  'lumen.customerEmailForwarding.editRecipient': 'Edit Penerima',
  'lumen.customerEmailForwarding.addRecipient': 'Tambah Penerima',
  'lumen.customerEmailForwarding.nameRequired': 'Nama penerima wajib diisi.',
  'lumen.customerEmailForwarding.emailInvalid': 'Masukkan alamat email yang valid.',
  'lumen.customerEmailForwarding.activateRecipient': '启用收件人',
  'lumen.customerEmailForwarding.deactivateRecipient': '停用收件人',
  'lumen.customerEmailForwarding.noImportir': '未找到进口商',
  'lumen.customerEmailForwarding.clearImportir': '清除进口商筛选',
  'lumen.seaCarriers.title': 'Sea Carriers',
  'lumen.seaCarriers.description': 'Upload a CSV or TXT file containing sea carrier data.',
  'lumen.seaCarriers.dropTitle': 'Click or drag & drop to upload',
  'lumen.seaCarriers.accepted': 'Accepted formats: .csv, .txt',
  'lumen.seaCarriers.size': '{n} KB',
  'lumen.seaCarriers.submit': 'Submit',
  'lumen.seaCarriers.invalidTitle': 'Invalid file type',
  'lumen.seaCarriers.invalidMsg': 'Only .csv or .txt files are accepted.',
  'lumen.seaCarriers.successTitle': 'Upload successful',
  'lumen.seaCarriers.successMsg': 'Sea carriers file has been uploaded successfully.',
  'lumen.seaCarriers.failedTitle': 'Upload failed',
  'lumen.seaCarriers.failedMsg': 'An error occurred while uploading the file.',
  'lumen.seaCarriers.removeFile': '移除文件',
  'lumen.revokeAccess.title': 'Revoke Access by PPJK NPWP',
  'lumen.revokeAccess.description':
    "Block or unblock a PPJK's CEISA access. Blocking revokes all active tokens immediately.",
  'lumen.revokeAccess.warning': 'This action affects all app users tied to the given PPJK NPWP. Use with care.',
  'lumen.revokeAccess.npwp': 'PPJK NPWP',
  'lumen.revokeAccess.placeholder': 'e.g. 0029326105001000',
  'lumen.revokeAccess.unblock': 'Unblock',
  'lumen.revokeAccess.block': 'Block / Revoke Access',
  'lumen.revokeAccess.validationTitle': 'Validation Error',
  'lumen.revokeAccess.npwpRequired': 'PPJK NPWP is required',
  'lumen.revokeAccess.success': 'Success',
  'lumen.revokeAccess.blocked': 'PPJK blocked successfully',
  'lumen.revokeAccess.unblocked': 'PPJK unblocked successfully',
  'lumen.revokeAccess.error': 'Error',
  'lumen.revokeAccess.requestFailed': 'Request failed',
  'lumen.revokeAccess.resultNpwp': 'NPWP:',
  'lumen.revokeAccess.resultState': 'State:',
  'lumen.revokeAccess.stateBlocked': 'BLOCKED',
  'lumen.revokeAccess.stateUnblocked': 'UNBLOCKED',
  'lumen.revokeAccess.appUsersAffected': 'App Users Affected:',
  'lumen.revokeAccess.ceisaUsersHit': 'CEISA Users Hit:',
  'lumen.revokeAccess.ceisaAccountsHit': 'CEISA Accounts Hit:',
  'lumen.revokeAccess.tokensRevoked': 'Tokens Revoked:',
  'lumen.revokeAccess.appUserIds': 'App User IDs:',

  // ---- Lumen manifest/guardian/radar (revamp PR 5, unit R) ----
  // The old page's literal text, verbatim in every language (copy unchanged). New, the same in every language:
  // dotLabel (each radar dot's accessible name, only placeholders and separators) and the table view's title and
  // column headers (tableTitle, col*), in English like the detail card's labels. The rail toggle is lumen.table.*.
  'lumen.manifestRadar.title': 'Orbital Radar',
  'lumen.manifestRadar.ppjk': 'PPJK {npwp}',
  'lumen.manifestRadar.ppjkAll': 'all',
  'lumen.manifestRadar.refresh': 'Refresh',
  'lumen.manifestRadar.windowHours': 'Window (h)',
  'lumen.manifestRadar.pastHours': 'Past (h)',
  'lumen.manifestRadar.critHours': 'Critical ≤ (h)',
  'lumen.manifestRadar.warnHours': 'Warning ≤ (h)',
  'lumen.manifestRadar.direction': 'Direction',
  'lumen.manifestRadar.both': 'Both',
  'lumen.manifestRadar.inward': 'Inward',
  'lumen.manifestRadar.outward': 'Outward',
  'lumen.manifestRadar.status': 'Status (CSV)',
  'lumen.manifestRadar.statusPlaceholder': 'DRAFT,SENT',
  'lumen.manifestRadar.apply': 'Apply',
  'lumen.manifestRadar.counts': 'Counts',
  'lumen.manifestRadar.critical': 'Critical',
  'lumen.manifestRadar.warning': 'Warning',
  'lumen.manifestRadar.normal': 'Normal',
  'lumen.manifestRadar.overdue': 'Overdue',
  'lumen.manifestRadar.done': 'Done',
  'lumen.manifestRadar.active': 'Active',
  'lumen.manifestRadar.loading': 'Memuat radar...',
  'lumen.manifestRadar.toastError': 'Gagal',
  'lumen.manifestRadar.loadFailed': 'Gagal memuat timeline radar',
  'lumen.manifestRadar.eyebrow': 'Manifest · Orbital Radar',
  'lumen.manifestRadar.headline': '{critical} critical · {warning} warning',
  'lumen.manifestRadar.tRange': 'T-RANGE: {h}h',
  'lumen.manifestRadar.scan': 'SCAN: {time} WIB',
  'lumen.manifestRadar.ringHours': '{h}h',
  'lumen.manifestRadar.axisInward': '↑ INWARD · ETA',
  'lumen.manifestRadar.axisOutward': '↓ OUTWARD · ETD',
  'lumen.manifestRadar.sevCritical': 'CRITICAL',
  'lumen.manifestRadar.sevWarning': 'WARNING',
  'lumen.manifestRadar.sevNormal': 'NORMAL',
  'lumen.manifestRadar.legendInward': '▲ INWARD',
  'lumen.manifestRadar.legendOutward': '▼ OUTWARD',
  'lumen.manifestRadar.manifestId': 'Manifest #{id}',
  'lumen.manifestRadar.bl': 'BL · {bl}',
  'lumen.manifestRadar.eta': 'ETA',
  'lumen.manifestRadar.etd': 'ETD',
  'lumen.manifestRadar.detailStatus': 'Status',
  'lumen.manifestRadar.dotLabel': '{severity} · {countdown} · {aju} · {direction}',
  'lumen.manifestRadar.tableTitle': 'Manifests',
  'lumen.manifestRadar.colAjuBl': 'AJU / BL',
  'lumen.manifestRadar.colSeverity': 'Severity',
  'lumen.manifestRadar.colCountdown': 'Countdown',
  'lumen.manifestRadar.colVesselVoyage': 'Vessel / Voyage',
  'lumen.manifestRadar.colRoute': 'Route',
  'lumen.manifestRadar.colEvent': 'ETA/ETD',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 C): the Container section (table, Host BL filter, the
  // Tambah / Edit / Attach dialogs, their toasts). The old text verbatim in every language (copy unchanged, mixed English
  // and Indonesian as before); {filtered}, {total}, {plural}, {size}, {n}, {ok}, {fail}, {host} and {message} are filled
  // with formatTemplate. The code lists (Ukuran, Jenis, Type) stay as constants (i1 §11 settled 2). Error, Success and
  // Cancel reuse lumen.common.*.
  'lumen.manifestEngine.container.title': 'All Containers from BLs',
  'lumen.manifestEngine.container.showing': 'Showing: {filtered} of {total} container{plural}',
  'lumen.manifestEngine.container.add': 'Tambah Container',
  'lumen.manifestEngine.container.filterPlaceholder': 'Filter by Host BL',
  'lumen.manifestEngine.container.allHostBls': 'All Host BLs',
  'lumen.manifestEngine.container.noResults': 'No results found.',
  'lumen.manifestEngine.container.clearFilter': 'Clear selection',
  'lumen.manifestEngine.container.colNoPos': 'No Pos',
  'lumen.manifestEngine.container.colMasterBl': 'Master BL',
  'lumen.manifestEngine.container.colHostBl': 'Host BL',
  'lumen.manifestEngine.container.colNomor': 'Nomor Container',
  'lumen.manifestEngine.container.colUkuran': 'Ukuran',
  'lumen.manifestEngine.container.colJenis': 'Jenis',
  'lumen.manifestEngine.container.colType': 'Type',
  'lumen.manifestEngine.container.colAksi': 'Aksi',
  'lumen.manifestEngine.container.feet': '{size} FEET',
  'lumen.manifestEngine.container.edit': 'Edit Container',
  'lumen.manifestEngine.container.attach': 'Attach to BL',
  'lumen.manifestEngine.container.delete': 'Delete Container',
  'lumen.manifestEngine.container.info': 'Info',
  'lumen.manifestEngine.container.deletingTitle': 'Deleting...',
  'lumen.manifestEngine.container.partialTitle': 'Partial Success',
  'lumen.manifestEngine.container.idNotFound': 'Container ID not found',
  'lumen.manifestEngine.container.deleting': 'Menghapus container...',
  'lumen.manifestEngine.container.deleted': 'Container berhasil dihapus',
  'lumen.manifestEngine.container.deleteFailed': 'Failed to delete container',
  'lumen.manifestEngine.container.deleteFailedWith': 'Failed to delete container: {message}',
  'lumen.manifestEngine.container.numberRequired': 'Container number is required',
  'lumen.manifestEngine.container.pickBl': 'Please select at least 1 BL to attach this container',
  'lumen.manifestEngine.container.pickSize': 'Please select Ukuran Container',
  'lumen.manifestEngine.container.added': 'Container added successfully to {n} BL(s)',
  'lumen.manifestEngine.container.addFailed': 'Failed to add container',
  'lumen.manifestEngine.container.addFailedWith': 'Failed to add container: {message}',
  'lumen.manifestEngine.container.noEditing': 'No container selected for editing',
  'lumen.manifestEngine.container.numberEmpty': 'Container number cannot be empty',
  'lumen.manifestEngine.container.noChanges': 'No changes made to container',
  'lumen.manifestEngine.container.blNotFound': 'BL not found',
  'lumen.manifestEngine.container.notInBl': 'Container not found in BL',
  'lumen.manifestEngine.container.updated': 'Container number updated successfully',
  'lumen.manifestEngine.container.updateFailed': 'Failed to update container',
  'lumen.manifestEngine.container.updateFailedWith': 'Failed to update container: {message}',
  'lumen.manifestEngine.container.noSelected': 'No container selected',
  'lumen.manifestEngine.container.noChangesToSave': 'No changes to save',
  'lumen.manifestEngine.container.attached': 'Container attached/detached successfully ({n} BL(s) updated)',
  'lumen.manifestEngine.container.partial': 'Success: {ok} BL(s), Failed: {fail} BL(s)',
  'lumen.manifestEngine.container.attachFailedWith': 'Failed to attach container: {message}',
  'lumen.manifestEngine.container.attachTitle': 'Attach Container to BLs',
  'lumen.manifestEngine.container.containerInfo': 'Container Information',
  'lumen.manifestEngine.container.infoNomor': 'Nomor:',
  'lumen.manifestEngine.container.infoUkuran': 'Ukuran:',
  'lumen.manifestEngine.container.infoJenis': 'Jenis:',
  'lumen.manifestEngine.container.infoType': 'Type:',
  'lumen.manifestEngine.container.pickAttach': 'Select BLs to attach this container (can select multiple):',
  'lumen.manifestEngine.container.pickAddBefore': 'Select BLs to attach this container',
  'lumen.manifestEngine.container.pickAddAfter': '(must select at least 1):',
  'lumen.manifestEngine.container.selectAll': 'Pilih Semua',
  'lumen.manifestEngine.container.hostBlLine': 'Host BL: {host}',
  'lumen.manifestEngine.container.saveAttach': 'Save ({n} BL{plural} selected)',
  'lumen.manifestEngine.container.editTitle': 'Edit Container',
  'lumen.manifestEngine.container.blInfo': 'BL Information',
  'lumen.manifestEngine.container.hostBl': 'Host BL:',
  'lumen.manifestEngine.container.saveChanges': 'Save Changes',
  'lumen.manifestEngine.container.addTitle': 'Tambah Container',
  'lumen.manifestEngine.container.addSubmit': 'Add Container ({n} BL{plural} selected)',
  'lumen.manifestEngine.container.nomorContainer': 'Nomor Container',
  'lumen.manifestEngine.container.ukuranContainer': 'Ukuran Container',
  'lumen.manifestEngine.container.jenisContainer': 'Jenis Container',
  'lumen.manifestEngine.container.typeContainer': 'Type Container',
  'lumen.manifestEngine.container.nomorSegel': 'Nomor Segel',
  'lumen.manifestEngine.container.nomorPolisi': 'Nomor Polisi',
  'lumen.manifestEngine.container.driver': 'Driver',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 C): the Barang section (table, Combine / Slice views,
  // Edit Barang, its toasts). The old text verbatim in every language; {filtered}, {total} and {message} are filled with
  // formatTemplate. The filter's texts and the Info title are the Container block's.
  'lumen.manifestEngine.barang.title': 'All Barang from BLs',
  'lumen.manifestEngine.barang.combine': 'Combine Goods',
  'lumen.manifestEngine.barang.uncombine': 'Uncombine Goods',
  'lumen.manifestEngine.barang.slice': 'Slice HS Codes (4 Digits)',
  'lumen.manifestEngine.barang.unslice': 'Unslice HS Codes',
  'lumen.manifestEngine.barang.showing': 'Showing: {filtered} of {total} barang',
  'lumen.manifestEngine.barang.colNoPos': 'No Pos',
  'lumen.manifestEngine.barang.colNoPeb': 'No. PEB',
  'lumen.manifestEngine.barang.colNoAwb': 'No. AWB',
  'lumen.manifestEngine.barang.colMasterAwb': 'Master AWB',
  'lumen.manifestEngine.barang.colHostAwb': 'Host AWB',
  'lumen.manifestEngine.barang.colNoBl': 'No. BL',
  'lumen.manifestEngine.barang.colMasterBl': 'Master BL',
  'lumen.manifestEngine.barang.colHostBl': 'Host BL',
  'lumen.manifestEngine.barang.colKodeHs': 'Kode HS',
  'lumen.manifestEngine.barang.colUraianHs': 'Uraian HS',
  'lumen.manifestEngine.barang.colAksi': 'Aksi',
  'lumen.manifestEngine.barang.edit': 'Edit Barang',
  'lumen.manifestEngine.barang.editTitle': 'Edit Barang',
  'lumen.manifestEngine.barang.barangInfo': 'Barang Information',
  'lumen.manifestEngine.barang.blLine': 'BL:',
  'lumen.manifestEngine.barang.kodeHs': 'Kode HS',
  'lumen.manifestEngine.barang.kodeHsPlaceholder': 'Enter Kode HS',
  'lumen.manifestEngine.barang.previous': 'Previous:',
  'lumen.manifestEngine.barang.uraianHs': 'Uraian HS',
  'lumen.manifestEngine.barang.uraianHsPlaceholder': 'Enter Uraian HS',
  'lumen.manifestEngine.barang.saveChanges': 'Save Changes',
  'lumen.manifestEngine.barang.noBarang': 'No barang selected for editing',
  'lumen.manifestEngine.barang.kodeEmpty': 'Kode HS cannot be empty',
  'lumen.manifestEngine.barang.uraianEmpty': 'Uraian HS cannot be empty',
  'lumen.manifestEngine.barang.noChanges': 'No changes made to barang',
  'lumen.manifestEngine.barang.blNotFound': 'BL not found',
  'lumen.manifestEngine.barang.notInBl': 'Barang not found in BL',
  'lumen.manifestEngine.barang.updated': 'Barang updated successfully',
  'lumen.manifestEngine.barang.updateFailed': 'Failed to update barang',
  'lumen.manifestEngine.barang.updateFailedWith': 'Failed to update barang: {message}',

  // ---- Lumen manifest/product + manifest/product/upload (revamp PR 6a, unit P) ----
  // Both pages' literal text, verbatim in every language (copy unchanged). Toast titles "Error" are lumen.common.error;
  // the upload kit keeps its upload.* keys and the Excel hook its own toasts.
  'lumen.manifestProduct.pill': 'Kelola Manifest dengan Mudah dan Cepat',
  'lumen.manifestProduct.titleCategory': 'Pilih Jalur Manifest',
  'lumen.manifestProduct.titleDirection': 'Pilih Arah Manifest',
  'lumen.manifestProduct.subtitleCategory': 'Mulai proses manifest dengan memilih jalur pengiriman terlebih dahulu',
  'lumen.manifestProduct.subtitleDirection': 'Tentukan arah manifest untuk melanjutkan proses',
  'lumen.manifestProduct.pickedLabel': 'Jalur terpilih:',
  'lumen.manifestProduct.udara': 'Udara',
  'lumen.manifestProduct.laut': 'Laut',
  'lumen.manifestProduct.changeCategory': 'Ganti Jalur',
  'lumen.manifestProduct.categoryUdaraTitle': 'Manifest - Udara',
  'lumen.manifestProduct.categoryUdaraDesc': 'Pilih jalur udara untuk proses manifest',
  'lumen.manifestProduct.categoryLautTitle': 'Manifest - Laut',
  'lumen.manifestProduct.categoryLautDesc': 'Pilih jalur laut untuk proses manifest',
  'lumen.manifestProduct.pickCategory': 'Pilih Jalur',
  'lumen.manifestProduct.pick': 'Pilih',
  'lumen.manifestProduct.start': 'Mulai',
  'lumen.manifestProduct.inwardUdaraTitle': 'Inward Manifest - Udara',
  'lumen.manifestProduct.inwardUdaraDesc': 'Manifest untuk barang masuk melalui jalur udara',
  'lumen.manifestProduct.outwardUdaraTitle': 'Outward Manifest - Udara',
  'lumen.manifestProduct.outwardUdaraDesc': 'Manifest untuk barang keluar melalui jalur udara',
  'lumen.manifestProduct.inwardLautTitle': 'Inward Manifest - Laut',
  'lumen.manifestProduct.inwardLautDesc': 'Manifest untuk barang masuk melalui jalur laut',
  'lumen.manifestProduct.outwardLautTitle': 'Outward Manifest - Laut',
  'lumen.manifestProduct.outwardLautDesc': 'Manifest untuk barang keluar melalui jalur laut',
  'lumen.manifestProduct.popular': 'Popular',
  'lumen.manifestProduct.methodTitle': 'Pilih Metode Input',
  'lumen.manifestProduct.methodBody': 'Pilih metode yang ingin Anda gunakan untuk mengisi {title}',
  'lumen.manifestProduct.aiTitle': 'AI Assistant',
  'lumen.manifestProduct.aiDesc': 'Biarkan AI membantu mengisi form dengan cepat dan akurat',
  'lumen.manifestProduct.manualTitle': 'Manual Input',
  'lumen.manifestProduct.manualDesc': 'Isi form secara manual dengan kontrol penuh',
  'lumen.manifestProduct.back': 'Kembali',
  'lumen.manifestProduct.uploadTitle': 'Upload Dokumen Manifest {direction} {mode}',
  'lumen.manifestProduct.uploadTitleMode': '- {mode}',
  'lumen.manifestProduct.inward': 'Inward',
  'lumen.manifestProduct.outward': 'Outward',
  'lumen.manifestProduct.tabPdf': 'Upload PDF',
  'lumen.manifestProduct.tabExcel': 'Upload Excel',
  'lumen.manifestProduct.docsReady': '{n} dokumen siap diupload',
  'lumen.manifestProduct.docsGrouped': '{n} dokumen telah dikelompokkan',
  'lumen.manifestProduct.succeeded': '{n} berhasil',
  'lumen.manifestProduct.failed': '{n} gagal',
  'lumen.manifestProduct.reset': 'Reset',
  'lumen.manifestProduct.uploading': 'Uploading... {p}%',
  'lumen.manifestProduct.processing': 'Processing...',
  'lumen.manifestProduct.toReview': 'Lanjut ke Review',
  'lumen.manifestProduct.uploadN': 'Upload {n} Dokumen',
  'lumen.manifestProduct.process': 'Process',
  'lumen.manifestProduct.grouping': 'Mengelompokkan dokumen berdasarkan jenis...',
  'lumen.manifestProduct.fileFailed': 'Gagal mengupload file. Silakan coba lagi.',
  'lumen.manifestProduct.noFileTitle': 'Tidak ada file',
  'lumen.manifestProduct.noFileBody': 'Silakan tambahkan file terlebih dahulu',
  'lumen.manifestProduct.noTypeTitle': 'Jenis dokumen belum dipilih',
  'lumen.manifestProduct.noTypeBody': '{n} file belum memiliki jenis dokumen',
  'lumen.manifestProduct.extractFailed': 'Gagal memulai ekstraksi manifest',
  'lumen.manifestProduct.uploadDoneTitle': 'Upload Selesai',
  'lumen.manifestProduct.uploadDoneBody': '{s} dari {t} dokumen berhasil diupload.',
  'lumen.manifestProduct.uploadError': 'Terjadi kesalahan saat mengupload dokumen: {message}',
  'lumen.manifestProduct.noBatch': 'Batch UUID tidak ditemukan. Silakan upload dokumen terlebih dahulu.',
  'lumen.manifestProduct.excelTitle': 'Upload Draft Manifest via Excel',
  'lumen.manifestProduct.excelSubtitle':
    'Upload 1 file Excel (.xls atau .xlsx) untuk membuat draft manifest secara langsung.',
  'lumen.manifestProduct.excelDrop': 'Tarik & lepas file Excel di sini',
  'lumen.manifestProduct.excelHint': 'Maksimal 1 file dengan format .xls atau .xlsx',
  'lumen.manifestProduct.excelPick': 'Pilih File Excel',
  'lumen.manifestProduct.excelRemove': 'Hapus File',
  'lumen.manifestProduct.excelRejected': 'Gunakan 1 file Excel (.xls atau .xlsx) untuk melanjutkan upload.',
  'lumen.manifestProduct.excelNoFile': 'Silakan pilih 1 file Excel terlebih dahulu.',
  'lumen.manifestProduct.excelUploading': 'Mengunggah file...',
  'lumen.manifestProduct.excelProcessing': 'Memproses manifest...',
  'lumen.manifestProduct.excelReady': '1 file Excel siap diproses',
  'lumen.manifestProduct.excelNone': 'Belum ada file Excel yang dipilih',
  'lumen.manifestProduct.excelNote': 'File Excel akan diproses dengan flow terpisah dari upload PDF.',
  'lumen.manifestProduct.excelContinue': 'Lanjutkan Upload Excel',
  'lumen.manifestProduct.excelBatchMissing': 'Batch UUID tidak ditemukan dari response upload.',
  'lumen.manifestProduct.excelUrlMissing': 'URL file hasil upload tidak ditemukan.',
  'lumen.manifestProduct.excelFailed': 'Upload Excel gagal diproses.',
  'lumen.manifestProduct.extractTitle': 'Mengekstraksi Manifest',
  'lumen.manifestProduct.extractDoneTitle': 'Ekstraksi Selesai!',
  'lumen.manifestProduct.extractBody': 'AI sedang membaca dan mengekstrak data dari dokumen Anda',
  'lumen.manifestProduct.extractDoneBody': 'Semua dokumen berhasil diekstraksi',
  'lumen.manifestProduct.startedAt': 'Mulai',
  'lumen.manifestProduct.duration': 'Durasi',
  'lumen.manifestProduct.statDone': 'Selesai',
  'lumen.manifestProduct.statRunning': 'Proses',
  'lumen.manifestProduct.statFailed': 'Gagal',
  'lumen.manifestProduct.statTotal': 'Total',
  'lumen.manifestProduct.viewResults': 'Lihat Hasil Ekstraksi',

  // ---- Lumen manifest form engine (revamp PR 6b): the page shell and the Header pilot (wave 1 F) ----
  // The old page's literal text, verbatim in every language (copy unchanged); {message}, {status}, {when}, {label},
  // {list} and {imo} are filled with formatTemplate, and **…** marks the bold words of a dialog line. New labels the
  // new parts need (sections, sectionDone/Todo, summary*, completeness, security, header.time/timeDone) are Indonesian
  // like the page. Wave 2 adds its own blocks (masterBl, bl, blEditor, container, barang, submit, susulan).
  'lumen.manifestEngine.shell.back': 'Back',
  'lumen.manifestEngine.shell.inward': 'Inward',
  'lumen.manifestEngine.shell.outward': 'Outward',
  'lumen.manifestEngine.shell.air': 'Air',
  'lumen.manifestEngine.shell.sea': 'Sea',
  'lumen.manifestEngine.shell.lihatDiCeisa': 'Lihat di Ceisa',
  'lumen.manifestEngine.shell.hapusAju': 'Hapus Aju Di Ceisa',
  'lumen.manifestEngine.shell.cekLengkap': 'Cek Lengkap',
  'lumen.manifestEngine.shell.submitDraft': 'Submit Draft',
  'lumen.manifestEngine.shell.prosesPenerimaan': 'Proses Penerimaan',
  'lumen.manifestEngine.shell.header': 'Header',
  'lumen.manifestEngine.shell.masterBl': 'Master BL',
  'lumen.manifestEngine.shell.masterAwb': 'Master AWB',
  'lumen.manifestEngine.shell.bl': 'BL',
  'lumen.manifestEngine.shell.awb': 'AWB',
  'lumen.manifestEngine.shell.container': 'Container',
  'lumen.manifestEngine.shell.barang': 'Barang',
  'lumen.manifestEngine.shell.previous': 'Sebelumnya',
  'lumen.manifestEngine.shell.next': 'Selanjutnya',
  'lumen.manifestEngine.shell.secureTitle': 'Secure & Private',
  'lumen.manifestEngine.shell.secureBody': 'Protected by enterprise-grade security',
  'lumen.manifestEngine.shell.ownershipTitle': 'Data Ownership',
  'lumen.manifestEngine.shell.ownershipBody': 'Your data belongs to you, always',
  'lumen.manifestEngine.shell.bankTitle': 'Bank-Level Security',
  'lumen.manifestEngine.shell.bankBody': 'Military-grade protection for your business',
  'lumen.manifestEngine.shell.loading': 'Loading document data',
  'lumen.manifestEngine.shell.loadingBody': 'This may take a moment as we process your document.',
  'lumen.manifestEngine.shell.savingTitle': 'Saving...',
  'lumen.manifestEngine.shell.savingHeader': 'Menyimpan header data...',
  'lumen.manifestEngine.shell.headerSaved': 'Header data berhasil disimpan',
  'lumen.manifestEngine.shell.headerSaveFailed': 'Gagal menyimpan header data. Silakan coba lagi.',
  'lumen.manifestEngine.shell.loadFailed': 'Gagal memuat data manifest',
  'lumen.manifestEngine.shell.loadFailedWith': 'Gagal memuat data manifest: {message}',
  'lumen.manifestEngine.shell.ajuNotFound': 'Nomor AJU tidak ditemukan',
  'lumen.manifestEngine.shell.prosesOk': 'Proses kirim berhasil',
  'lumen.manifestEngine.shell.prosesFailed': 'Proses kirim gagal',
  'lumen.manifestEngine.shell.prosesError': 'Gagal proses kirim: {message}',
  'lumen.manifestEngine.shell.cekOk': 'Cek lengkap berhasil',
  'lumen.manifestEngine.shell.cekFailed': 'Cek lengkap gagal',
  'lumen.manifestEngine.shell.cekError': 'Gagal cek lengkap: {message}',
  'lumen.manifestEngine.shell.berhasil': 'Berhasil',
  'lumen.manifestEngine.shell.hapusOk': 'AJU berhasil dihapus dari CEISA. Memuat ulang data...',
  'lumen.manifestEngine.shell.hapusFailed': 'Gagal hapus AJU di CEISA',
  'lumen.manifestEngine.shell.hapusError': 'Gagal hapus AJU: {message}',
  'lumen.manifestEngine.shell.lengkapTitle': 'Data Lengkap!',
  'lumen.manifestEngine.shell.lengkapBody': 'Semua data manifest telah lengkap dan siap diproses',
  'lumen.manifestEngine.shell.lengkapStatus': 'Status: {status}',
  'lumen.manifestEngine.shell.mengerti': 'Mengerti',
  'lumen.manifestEngine.shell.hapusTitle': 'Konfirmasi Hapus AJU',
  'lumen.manifestEngine.shell.hapusBody':
    'Apakah Anda yakin ingin **menghapus AJU** ini dari CEISA? Tindakan ini tidak dapat dibatalkan.',
  'lumen.manifestEngine.shell.nomorAju': 'Nomor AJU',
  'lumen.manifestEngine.shell.yaHapus': 'Ya, Hapus',
  'lumen.manifestEngine.shell.prosesTitle': 'Konfirmasi Proses Penerimaan',
  'lumen.manifestEngine.shell.prosesBody':
    'Apakah Anda yakin ingin **mengirim (proses penerimaan)** manifest ini ke CEISA?',
  'lumen.manifestEngine.shell.yaProses': 'Ya, Proses Penerimaan',
  'lumen.manifestEngine.shell.sections': 'Bagian manifest',
  'lumen.manifestEngine.shell.sectionDone': 'lengkap',
  'lumen.manifestEngine.shell.sectionTodo': 'belum lengkap',
  'lumen.manifestEngine.shell.summary': 'Ringkasan',
  'lumen.manifestEngine.shell.summaryDirection': 'Arah',
  'lumen.manifestEngine.shell.summaryKantor': 'Kantor',
  'lumen.manifestEngine.shell.completeness': 'Kelengkapan',
  'lumen.manifestEngine.shell.security': 'Keamanan',
  'lumen.manifestEngine.shell.reminderLoading': 'Reminder...',
  'lumen.manifestEngine.shell.reminderOff': 'Reminder belum aktif',
  'lumen.manifestEngine.shell.reminderArmed': 'Reminder armed · {when}',
  'lumen.manifestEngine.shell.reminderCancelLabel': 'Cancel reminder',
  'lumen.manifestEngine.shell.reminderCancelTitle': 'Batalkan Reminder?',
  'lumen.manifestEngine.shell.reminderCancelBody':
    'Reminder yang sedang aktif akan dibatalkan. Tindakan ini tidak otomatis menghapus rule — rule tetap berjalan untuk manifest lain.',
  'lumen.manifestEngine.shell.reminderClose': 'Tutup',
  'lumen.manifestEngine.shell.reminderConfirm': 'Ya, Batalkan',
  'lumen.manifestEngine.shell.reminderCancelled': 'Reminder dibatalkan.',
  'lumen.manifestEngine.shell.reminderCancelFailed': 'Gagal membatalkan reminder',
  'lumen.manifestEngine.shell.reminderLoadFailed': 'Gagal memuat reminder',
  'lumen.manifestEngine.shell.gagal': 'Gagal',
  'lumen.manifestEngine.header.kantor': 'Pilih kantor pabean',
  'lumen.manifestEngine.header.required': 'Field ini wajib diisi',
  'lumen.manifestEngine.header.vessel': 'Nama Sarana Pengangkut',
  'lumen.manifestEngine.header.imo': 'Nomor IMO / Registrasi',
  'lumen.manifestEngine.header.updateImo': 'Update Nomor IMO',
  'lumen.manifestEngine.header.new': 'New',
  'lumen.manifestEngine.header.voyage': 'Nomor Voyage',
  'lumen.manifestEngine.header.tanggalBerangkat': 'Tanggal Berangkat',
  'lumen.manifestEngine.header.tanggalTiba': 'Tanggal Tiba',
  'lumen.manifestEngine.header.reference': 'Reference ID',
  'lumen.manifestEngine.header.referenceOptional': '{label} (opsional)',
  'lumen.manifestEngine.header.referenceRequired': '{label} wajib diisi',
  'lumen.manifestEngine.header.referenceHintSource': 'Pilih dari daftar job perusahaan Anda, atau ketik manual',
  'lumen.manifestEngine.header.referenceHintFree': 'ID internal dari sistem Anda, mis. nomor PO/Job',
  'lumen.manifestEngine.header.referenceUnavailable':
    'Daftar job sedang tidak tersedia — silakan ketik nomornya manual.',
  'lumen.manifestEngine.header.duplicateWithAju': 'Reference ID ini sudah dipakai di AJU {list}',
  'lumen.manifestEngine.header.duplicateOther': 'Reference ID ini sudah dipakai di manifest lain',
  'lumen.manifestEngine.header.reusedTitle': 'Reference ID sudah dipakai',
  'lumen.manifestEngine.header.reusedWithAju': 'Reference ID ini juga dipakai di AJU {list}. Data tetap tersimpan.',
  'lumen.manifestEngine.header.reusedOther': 'Reference ID ini juga dipakai di manifest lain. Data tetap tersimpan.',
  'lumen.manifestEngine.header.imoNeedVessel': 'Masukkan nama sarana pengangkut terlebih dahulu',
  'lumen.manifestEngine.header.imoFound': 'Nomor IMO {imo} berhasil ditemukan',
  'lumen.manifestEngine.header.imoNotFoundTitle': 'Tidak ditemukan',
  'lumen.manifestEngine.header.imoNotFound': 'Nomor IMO tidak ditemukan untuk kapal ini',
  'lumen.manifestEngine.header.imoFailed': 'Gagal mencari nomor IMO',
  'lumen.manifestEngine.header.saveFailed': 'Gagal menyimpan header data',
  'lumen.manifestEngine.header.lookupLoading': 'Loading...',
  'lumen.manifestEngine.header.lookupEmpty': 'Tidak dapat menemukan',
  'lumen.manifestEngine.header.lookupFailed': 'Error when get {label}',
  'lumen.manifestEngine.header.time': 'Jam',
  'lumen.manifestEngine.header.timeDone': 'OK',
  // ---- end Lumen manifest/guardian/radar ----

  'lumen.consignee.namaPlaceholder': 'PT. CONTOH',
  // ---- end Lumen master B ----
  'lumen.featureLock.title': 'Fitur Belum Aktif',
  'lumen.featureLock.moduleInactive': 'Modul {module} belum aktif untuk perusahaan Anda.',
  'lumen.featureLock.thisModuleInactive': 'Modul ini belum aktif untuk perusahaan Anda.',
  'lumen.featureLock.contactAdmin': 'Silakan hubungi Admin Lumen untuk mengaktifkan fitur ini dan membahas pembayaran.',
  'lumen.featureLock.contactSales': 'Hubungi Customer Service',
  'lumen.featureLock.understood': 'Mengerti',
  // ---- Lumen master pages (P1): user, ceisa-user, export-bank, manifest-reminder, statement ----
  // The old pages' literal English, verbatim in every language (copy unchanged). Generic words are
  // lumen.common.* (Active, Cancel, Save, …); words two of these pages share live under the first one.
  // master/user
  'lumen.masterUser.searchPlaceholder': 'Search by name, email, ceisa user...',
  'lumen.masterUser.add': 'Add User',
  'lumen.masterUser.editTitle': 'Edit User',
  'lumen.masterUser.ceisaUser': 'Ceisa User',
  'lumen.masterUser.ceisaUserPlaceholder': 'Cari Ceisa User...',
  'lumen.masterUser.updated': 'User updated successfully',
  'lumen.masterUser.updateFailed': 'Failed to update user',
  'lumen.masterUser.created': 'User created successfully',
  'lumen.masterUser.createFailed': 'Failed to create user',
  // master/ceisa-user (also uses lumen.masterUser.add, updated, created and their failures)
  'lumen.masterCeisaUser.searchPlaceholder': 'Search by username, name, NPWP, company code...',
  'lumen.masterCeisaUser.editTitle': 'Edit Ceisa User',
  'lumen.masterCeisaUser.addTitle': 'Add Ceisa User',
  'lumen.masterCeisaUser.npwp': 'NPWP',
  'lumen.masterCeisaUser.npwpHint': 'Minimum 12 digits',
  'lumen.masterCeisaUser.companyCode': 'Company Code',
  'lumen.masterCeisaUser.address': 'Address',
  'lumen.masterCeisaUser.apiKey': 'API Key',
  'lumen.masterCeisaUser.apiKeyHint': 'CEISA beacukai-api-key',
  'lumen.masterCeisaUser.apiKeyEditHint': 'CEISA beacukai-api-key. Leave empty to clear.',
  'lumen.masterCeisaUser.applicationId': 'Application ID',
  'lumen.masterCeisaUser.lastSixDigitPrefix': 'Last Six Digit Prefix',
  'lumen.masterCeisaUser.npwpTooShort': 'NPWP must be at least 12 characters',
  'lumen.masterCeisaUser.deactivateTitle': 'Deactivate User',
  'lumen.masterCeisaUser.warning': 'Warning',
  'lumen.masterCeisaUser.deactivateConfirm':
    'Are you sure you want to deactivate user {username}? This action will set the user status to inactive.',
  'lumen.masterCeisaUser.deactivated': 'User deactivated successfully',
  'lumen.masterCeisaUser.deactivateFailed': 'Failed to deactivate user',
  // master/export-bank (the old page's own heading and line; Name is lumen.common.name)
  'lumen.masterExportBank.title': 'Export Bank',
  'lumen.masterExportBank.description': 'Manage the bank devisa catalogue used in export transaction forms.',
  'lumen.masterExportBank.searchPlaceholder': 'Search by code or name...',
  'lumen.masterExportBank.add': 'Add Export Bank',
  'lumen.masterExportBank.editTitle': 'Edit Export Bank',
  'lumen.masterExportBank.deleteTitle': 'Delete Export Bank',
  'lumen.masterExportBank.code': 'Code',
  'lumen.masterExportBank.codePlaceholder': 'e.g. BNI',
  'lumen.masterExportBank.namePlaceholder': 'Bank Name',
  'lumen.masterExportBank.activate': 'Activate',
  'lumen.masterExportBank.delete': 'Delete',
  'lumen.masterExportBank.required': 'Code and Name are required',
  'lumen.masterExportBank.created': 'Export bank created successfully',
  'lumen.masterExportBank.createFailed': 'Failed to create export bank',
  'lumen.masterExportBank.updated': 'Export bank updated successfully',
  'lumen.masterExportBank.updateFailed': 'Failed to update export bank',
  'lumen.masterExportBank.deactivated': 'Export bank deactivated',
  'lumen.masterExportBank.activated': 'Export bank activated',
  'lumen.masterExportBank.deleted': 'Export bank deleted successfully',
  'lumen.masterExportBank.deleteFailed': 'Failed to delete export bank',
  'lumen.masterExportBank.deleteConfirm':
    'Are you sure you want to delete bank {code} - {name}? This action cannot be undone.',
  // master/manifest-reminder (PPJK NPWP, MOT Type and the PPJK-required alert are lumen.common.*)
  'lumen.masterManifestReminder.searchPlaceholder': 'Search by email, direction, MOT...',
  'lumen.masterManifestReminder.add': 'Add Reminder',
  'lumen.masterManifestReminder.addTitle': 'Add Manifest Reminder',
  'lumen.masterManifestReminder.editTitle': 'Edit Manifest Reminder',
  'lumen.masterManifestReminder.direction': 'Direction',
  'lumen.masterManifestReminder.mot': 'MOT',
  'lumen.masterManifestReminder.refDate': 'Ref Date',
  'lumen.masterManifestReminder.offset': 'Offset',
  'lumen.masterManifestReminder.emails': 'Emails',
  'lumen.masterManifestReminder.referenceDate': 'Reference Date',
  'lumen.masterManifestReminder.offsetUnit': 'Offset Unit',
  'lumen.masterManifestReminder.offsetValue': 'Offset Value',
  'lumen.masterManifestReminder.emailsHint': 'Comma-separated email addresses',
  'lumen.masterManifestReminder.emailsPlaceholder': 'user@example.com,admin@example.com',
  'lumen.masterManifestReminder.emailsRequired': 'Please fill in the emails field',
  'lumen.masterManifestReminder.updated': 'Reminder config updated successfully',
  'lumen.masterManifestReminder.updateFailed': 'Failed to update reminder config',
  'lumen.masterManifestReminder.created': 'Reminder config created successfully',
  'lumen.masterManifestReminder.createFailed': 'Failed to create reminder config',
  'lumen.masterManifestReminder.deactivated': 'Reminder config deactivated successfully',
  'lumen.masterManifestReminder.deactivateFailed': 'Failed to deactivate reminder config',
  // ---- Lumen manifest/guardian (revamp PR 5, unit G) ----
  // The old page's literal text, verbatim in every language (copy unchanged). Active, Inactive, Edit, Create, Save,
  // Batal and PPJK NPWP are lumen.common.*.
  'lumen.manifestGuardian.title': 'The Guardian',
  'lumen.manifestGuardian.subtitle': 'Manifest reminder rules untuk PPJK {npwp}',
  'lumen.manifestGuardian.none': '—',
  'lumen.manifestGuardian.createRule': 'Create Rule',
  'lumen.manifestGuardian.colNo': '#',
  'lumen.manifestGuardian.manifestType': 'Manifest Type',
  'lumen.manifestGuardian.offset': 'Offset',
  'lumen.manifestGuardian.snooze': 'Snooze',
  'lumen.manifestGuardian.maxFires': 'Max Fires',
  'lumen.manifestGuardian.recipients': 'Recipients',
  'lumen.manifestGuardian.actions': 'Aksi',
  'lumen.manifestGuardian.offsetBefore': '{offset} sebelum',
  'lumen.manifestGuardian.snoozeEvery': 'setiap {snooze}',
  'lumen.manifestGuardian.unlimited': 'Unlimited',
  'lumen.manifestGuardian.delete': 'Delete',
  'lumen.manifestGuardian.loading': 'Memuat...',
  'lumen.manifestGuardian.noPpjk': 'PPJK NPWP tidak tersedia. Pastikan login.',
  'lumen.manifestGuardian.empty': 'Belum ada rule. Klik "Create Rule" untuk menambahkan.',
  'lumen.manifestGuardian.typeInwardAir': 'Inward Air',
  'lumen.manifestGuardian.typeInwardOcean': 'Inward Ocean',
  'lumen.manifestGuardian.typeOutwardAir': 'Outward Air',
  'lumen.manifestGuardian.typeOutwardOcean': 'Outward Ocean',
  'lumen.manifestGuardian.createTitle': 'Create Reminder Rule',
  'lumen.manifestGuardian.editTitle': 'Edit Reminder Rule',
  'lumen.manifestGuardian.typeLocked': 'Manifest type tidak bisa diubah — buat rule baru jika ingin tipe lain.',
  'lumen.manifestGuardian.offsetLabel': 'Offset (menit sebelum ETA/ETD)',
  'lumen.manifestGuardian.snoozeLabel': 'Snooze (menit)',
  'lumen.manifestGuardian.maxFireLabel': 'Max Fire Count (0 = unlimited)',
  'lumen.manifestGuardian.recipientsLabel': 'Recipients (comma-separated)',
  'lumen.manifestGuardian.recipientsPlaceholder': 'ops@dextercargo.com,manager@dextercargo.com',
  'lumen.manifestGuardian.deleteTitle': 'Hapus Rule?',
  'lumen.manifestGuardian.deleteBody':
    'Rule akan dihapus permanen. Reminder yang sedang berjalan untuk rule ini juga dibatalkan oleh backend pada fire berikutnya.',
  'lumen.manifestGuardian.deleteConfirm': 'Hapus',
  'lumen.manifestGuardian.toastSuccess': 'Berhasil',
  'lumen.manifestGuardian.toastError': 'Gagal',
  'lumen.manifestGuardian.toastWarning': 'Perhatian',
  'lumen.manifestGuardian.noPpjkWarning': 'PPJK NPWP belum tersedia. Pastikan login dengan PPJK terkait.',
  'lumen.manifestGuardian.recipientsRequired': 'Recipients wajib diisi.',
  'lumen.manifestGuardian.emailInvalid': 'Email tidak valid: {email}',
  'lumen.manifestGuardian.offsetPositive': 'Offset Minutes harus > 0.',
  'lumen.manifestGuardian.snoozePositive': 'Snooze Minutes harus > 0.',
  'lumen.manifestGuardian.maxFireNegative': 'Max Fire Count tidak boleh negatif (0 = unlimited).',
  'lumen.manifestGuardian.created': 'Rule berhasil dibuat.',
  'lumen.manifestGuardian.updated': 'Rule berhasil diperbarui.',
  'lumen.manifestGuardian.deleted': 'Rule berhasil dihapus.',
  'lumen.manifestGuardian.loadFailed': 'Gagal memuat daftar rule',
  'lumen.manifestGuardian.saveFailed': 'Gagal menyimpan rule',
  'lumen.manifestGuardian.deleteFailed': 'Gagal menghapus rule',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 M): the Master BL / AWB section ----
  // The old section's literal text, verbatim in every language (copy unchanged); {count}, {failed} and {message} are
  // filled with formatTemplate. Kelompok Pos option labels stay constants in master-bl.logic.ts (CEISA code names).
  'lumen.manifestEngine.masterBl.titleBl': 'Data Master BL',
  'lumen.manifestEngine.masterBl.titleAwb': 'Data Master AWB',
  'lumen.manifestEngine.masterBl.uploadBl': 'Upload Master BL',
  'lumen.manifestEngine.masterBl.uploadAwb': 'Upload Master AWB',
  'lumen.manifestEngine.masterBl.addBl': 'Tambah Master BL',
  'lumen.manifestEngine.masterBl.addAwb': 'Tambah Master AWB',
  'lumen.manifestEngine.masterBl.editBl': 'Edit Master BL',
  'lumen.manifestEngine.masterBl.editAwb': 'Edit Master AWB',
  'lumen.manifestEngine.masterBl.colKelompok': 'Kel. Pos',
  'lumen.manifestEngine.masterBl.colNomor': 'No Master',
  'lumen.manifestEngine.masterBl.colTanggal': 'Tgl. Master',
  'lumen.manifestEngine.masterBl.colJumlah': 'Jml Pos',
  'lumen.manifestEngine.masterBl.colAksi': 'Aksi',
  'lumen.manifestEngine.masterBl.attach': 'Attach to BL',
  'lumen.manifestEngine.masterBl.copy': 'Copy',
  'lumen.manifestEngine.masterBl.delete': 'Delete',
  'lumen.manifestEngine.masterBl.kelompokPos': 'Kelompok Pos',
  'lumen.manifestEngine.masterBl.nomorMaster': 'Nomor Master',
  'lumen.manifestEngine.masterBl.tanggalMaster': 'Tanggal Master',
  'lumen.manifestEngine.masterBl.required': 'Field ini wajib diisi',
  'lumen.manifestEngine.masterBl.noResults': 'No results found.',
  'lumen.manifestEngine.masterBl.matchedBl': '{count} Host BL ditemukan dengan nomor Master BL ini',
  'lumen.manifestEngine.masterBl.matchedAwb': '{count} Host AWB ditemukan dengan nomor Master AWB ini',
  'lumen.manifestEngine.masterBl.validationTitle': 'Validation Error',
  'lumen.manifestEngine.masterBl.validationBody': 'Silakan lengkapi semua field yang wajib diisi',
  'lumen.manifestEngine.masterBl.processingBl': 'Memproses Master BL...',
  'lumen.manifestEngine.masterBl.processingAwb': 'Memproses Master AWB...',
  'lumen.manifestEngine.masterBl.processingHint': 'Mohon tunggu, jangan tutup halaman.',
  'lumen.manifestEngine.masterBl.needHeader': 'Manifest belum tersedia. Simpan header dulu sebelum upload Master BL.',
  'lumen.manifestEngine.masterBl.noBatch': 'Batch UUID tidak ditemukan.',
  'lumen.manifestEngine.masterBl.badUpload': 'Upload response tidak mengandung file_url / file_id.',
  'lumen.manifestEngine.masterBl.extracted': 'Ekstraksi Master BL selesai. Memuat ulang data...',
  'lumen.manifestEngine.masterBl.uploadFailed': 'Gagal upload Master BL.',
  'lumen.manifestEngine.masterBl.blsUpdated': '{count} BL berhasil diperbarui',
  'lumen.manifestEngine.masterBl.warningTitle': 'Warning',
  'lumen.manifestEngine.masterBl.blsFailed': '{failed} dari {count} BL gagal diperbarui',
  'lumen.manifestEngine.masterBl.noProcess': 'Lumen Process ID tidak ditemukan',
  'lumen.manifestEngine.masterBl.duplicateTitle': 'Duplikat',
  'lumen.manifestEngine.masterBl.duplicateBody': 'Master BL dengan nomor ini sudah ada',
  'lumen.manifestEngine.masterBl.saving': 'Menyimpan Master BL...',
  'lumen.manifestEngine.masterBl.added': 'Master BL berhasil ditambahkan',
  'lumen.manifestEngine.masterBl.updated': 'Master BL berhasil diperbarui',
  'lumen.manifestEngine.masterBl.saveFailed': 'Gagal menyimpan Master BL',
  'lumen.manifestEngine.masterBl.saveFailedWith': 'Gagal menyimpan Master BL: {message}',
  'lumen.manifestEngine.masterBl.copyUnsaved': 'Tidak dapat menyalin Master BL yang belum disimpan',
  'lumen.manifestEngine.masterBl.copyingTitle': 'Copying...',
  'lumen.manifestEngine.masterBl.copying': 'Menyalin Master BL...',
  'lumen.manifestEngine.masterBl.copied': 'Master BL berhasil disalin',
  'lumen.manifestEngine.masterBl.copyFailed': 'Gagal menyalin Master BL',
  'lumen.manifestEngine.masterBl.copyFailedWith': 'Gagal menyalin Master BL: {message}',
  'lumen.manifestEngine.masterBl.deletingTitle': 'Deleting...',
  'lumen.manifestEngine.masterBl.deleting': 'Menghapus Master BL...',
  'lumen.manifestEngine.masterBl.deleted': 'Master BL berhasil dihapus',
  'lumen.manifestEngine.masterBl.deleteFailed': 'Gagal menghapus Master BL',
  'lumen.manifestEngine.masterBl.deleteFailedWith': 'Gagal menghapus Master BL: {message}',
  'lumen.manifestEngine.masterBl.applyNone': 'Silakan pilih minimal satu BL untuk menerapkan data Master BL.',
  'lumen.manifestEngine.masterBl.masterNotFound': 'Master BL tidak ditemukan',
  'lumen.manifestEngine.masterBl.applied': 'Master BL data diterapkan ke {count} BL dan diperbarui di latar belakang.',
  'lumen.manifestEngine.masterBl.applyTitleBl': 'Terapkan Master BL ke BL',
  'lumen.manifestEngine.masterBl.applyTitleAwb': 'Terapkan Master AWB ke AWB',
  'lumen.manifestEngine.masterBl.applyIntroBl': 'Data Master BL berikut akan diterapkan ke BL:',
  'lumen.manifestEngine.masterBl.applyIntroAwb': 'Data Master AWB berikut akan diterapkan ke AWB:',
  'lumen.manifestEngine.masterBl.applyKelompok': 'Kelompok Pos:',
  'lumen.manifestEngine.masterBl.applyNomor': 'Nomor Master:',
  'lumen.manifestEngine.masterBl.applyTanggal': 'Tanggal Master:',
  'lumen.manifestEngine.masterBl.pickBls': 'Pilih BL yang akan diterapkan:',
  'lumen.manifestEngine.masterBl.selectAll': 'Pilih Semua',
  'lumen.manifestEngine.masterBl.noBls': 'Tidak ada BL yang tersedia. Silakan buat BL terlebih dahulu di tab BL.',
  'lumen.manifestEngine.masterBl.houseBl': 'House BL:',
  'lumen.manifestEngine.masterBl.selected': '{count} BL dipilih',
  'lumen.manifestEngine.masterBl.lanjutkan': 'Lanjutkan',

  // /manifest/doc-pabean "Doc Manifes" (revamp PR 6a, unit D): the page, its dialogs, Cargo Tracking and
  // the upload dialog. Copied word for word, the same text in id, zh and en. The ID/JA column labels stay in
  // the page's own dictionary (doc-manifes-dict.ts).
  'lumen.manifestDocPabean.loadFailed': 'Gagal memuat data Manifest Doc Pabean.',
  'lumen.manifestDocPabean.retry': 'Coba lagi',
  'lumen.manifestDocPabean.langId': 'ID',
  'lumen.manifestDocPabean.langJa': 'JA',
  'lumen.manifestDocPabean.actDownload': 'Download',
  'lumen.manifestDocPabean.actView': 'View',
  'lumen.manifestDocPabean.actCopy': 'Copy',
  'lumen.manifestDocPabean.actUpload': 'Upload Dokumen',
  'lumen.manifestDocPabean.actRekon': 'Update ke REKON',
  'lumen.manifestDocPabean.actDelete': 'Delete',
  'lumen.manifestDocPabean.demoCannotCopy': 'Demo users cannot copy',
  'lumen.manifestDocPabean.demoCannotEdit': 'Demo users cannot edit',
  'lumen.manifestDocPabean.demoCannotUpload': 'Demo users cannot upload',
  'lumen.manifestDocPabean.demoCannotRekon': 'Demo users cannot update to REKON',
  'lumen.manifestDocPabean.demoCannotDelete': 'Demo users cannot delete',
  'lumen.manifestDocPabean.imo': ' | IMO: {imo}',
  'lumen.manifestDocPabean.copied': 'Manifest berhasil disalin',
  'lumen.manifestDocPabean.copyFailed': 'Gagal menyalin manifest',
  'lumen.manifestDocPabean.copyFailedWith': 'Gagal menyalin manifest: {message}',
  'lumen.manifestDocPabean.deleted': 'Manifest berhasil dihapus',
  'lumen.manifestDocPabean.deleteFailed': 'Gagal menghapus manifest',
  'lumen.manifestDocPabean.deleteFailedWith': 'Gagal menghapus manifest: {message}',
  'lumen.manifestDocPabean.rekonDone': 'Status berhasil diubah ke REKON',
  'lumen.manifestDocPabean.rekonFailed': 'Gagal mengubah status',
  'lumen.manifestDocPabean.rekonFailedWith': 'Gagal mengubah status: {message}',
  'lumen.manifestDocPabean.statusFailed': 'Gagal mengambil data status manifest',
  'lumen.manifestDocPabean.statusFailedWith': 'Gagal mengambil data status: {message}',
  'lumen.manifestDocPabean.pdfFailedWith': 'Gagal mengunduh PDF: {message}',
  'lumen.manifestDocPabean.deleteTitle': 'Konfirmasi Hapus',
  'lumen.manifestDocPabean.deleteBody': 'Apakah Anda yakin ingin menghapus manifest ini?',
  'lumen.manifestDocPabean.detailCompany': 'Nama Perusahaan',
  'lumen.manifestDocPabean.detailVoyage': 'Voyage',
  'lumen.manifestDocPabean.detailAju': 'Nomor AJU',
  'lumen.manifestDocPabean.detailVessel': 'Vessel',
  'lumen.manifestDocPabean.delete': 'Hapus',
  'lumen.manifestDocPabean.rekonTitle': 'Konfirmasi Update Status',
  'lumen.manifestDocPabean.rekonBody': 'Apakah Anda yakin ingin mengubah status manifest ini ke {status}?',
  'lumen.manifestDocPabean.downloadTitle': 'Download Dokumen',
  'lumen.manifestDocPabean.responCount': 'Respon ({n})',
  'lumen.manifestDocPabean.responRekon': 'Rekon',
  'lumen.manifestDocPabean.responPenerimaan': 'Penerimaan',
  'lumen.manifestDocPabean.responPerbaikan': 'Perbaikan',
  'lumen.manifestDocPabean.close': 'Tutup',
  'lumen.manifestDocPabean.trackingTitle': 'Cargo Tracking',
  'lumen.manifestDocPabean.trackingLoading': 'Loading cargo tracking...',
  'lumen.manifestDocPabean.trackingEmpty': 'No cargo tracking data available',
  'lumen.manifestDocPabean.trackingFailed': 'Failed to fetch cargo tracking data',
  'lumen.manifestDocPabean.trackingContainers': 'Container',
  'lumen.manifestDocPabean.trackingContainer': 'Container {n}',
  'lumen.manifestDocPabean.trackingEta': 'ETA {date}',
  'lumen.manifestDocPabean.trackingEvents': 'Events',
  'lumen.manifestDocPabean.trackingActual': 'Actual',
  'lumen.manifestDocPabean.trackingEstimated': 'Estimated',
  'lumen.manifestDocPabean.uploadType': 'Tipe Dokumen',
  'lumen.manifestDocPabean.typeRevisi': 'Revisi',
  'lumen.manifestDocPabean.typePenerimaan': 'Penerimaan',
  'lumen.manifestDocPabean.typeSync': 'Sync',
  'lumen.manifestDocPabean.hintRevisi': '* Revisi: Hanya 1 file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.hintSync': '* Sync: Hanya 1 file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.hintPenerimaan': '* Penerimaan: Bisa multiple files (PDF atau Excel)',
  'lumen.manifestDocPabean.labelExcel': 'Upload File Excel (1 file)',
  'lumen.manifestDocPabean.labelMulti': 'Upload File (PDF atau Excel, bisa multiple)',
  'lumen.manifestDocPabean.labelAny': 'Upload File (PDF atau Excel)',
  'lumen.manifestDocPabean.placeholderExcel': 'Pilih 1 file Excel...',
  'lumen.manifestDocPabean.placeholderMulti': 'Pilih file (bisa lebih dari satu)...',
  'lumen.manifestDocPabean.fileLine': '{i}. {name} ({size} KB)',
  'lumen.manifestDocPabean.fileTotal': 'Total: {n} file(s)',
  'lumen.manifestDocPabean.upload': 'Upload',
  'lumen.manifestDocPabean.errNoType': 'Pilih tipe dokumen terlebih dahulu',
  'lumen.manifestDocPabean.errNoFile': 'Pilih file terlebih dahulu',
  'lumen.manifestDocPabean.errRevisiOne': 'Revisi hanya bisa upload 1 file Excel',
  'lumen.manifestDocPabean.errRevisiExcel': 'Revisi hanya menerima file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.errSyncOne': 'Sync hanya bisa upload 1 file Excel',
  'lumen.manifestDocPabean.errSyncExcel': 'Sync hanya menerima file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.errNotPdfExcel': 'File {name} bukan PDF atau Excel',
  'lumen.manifestDocPabean.uploadedAll': '{n} file berhasil diupload',
  'lumen.manifestDocPabean.partialTitle': 'Partial Success',
  'lumen.manifestDocPabean.uploadedPartial': '{ok} file berhasil, {fail} file gagal',
  'lumen.manifestDocPabean.uploadedNone': 'Semua file gagal diupload',
  'lumen.manifestDocPabean.uploadFailedWith': 'Gagal upload file: {message}',
  'lumen.draft.colShipmentType': '运输类型',
  'lumen.draft.colCustomer': '客户名称',
  'lumen.draft.colImportir': '进口商名称',
  'lumen.draft.colLatestUpdate': '最近更新',
  'lumen.draft.colMot': '运输方式',
  'lumen.draft.colKantor': '海关',
  'lumen.draft.colActions': '操作',
  'lumen.draft.edit': '编辑',
  'lumen.draft.selected': '已选择 {n} 项',
  'lumen.draft.deleteSelected': '删除所选',
  'lumen.draft.filterShipment': '运输类型',
  'lumen.draft.filterCustomer': '客户名称',
  'lumen.draft.filterImportir': '进口商名称',
  'lumen.draft.filterMot': '运输方式',
  'lumen.docPabean.logoNoWebsite': '暂无网站',
  'lumen.docPabean.logoWrong': '此标志有误',
  'lumen.docPabean.logoMissing': '该公司有标志',
  'lumen.docPabean.logoWebsitePlaceholder': '正确的网站，例如 mahle.com',
  'lumen.docPabean.logoSendWebsite': '提交网站',
  'lumen.docPabean.logoReviewNote': '报告在应用前会先经过审核。',
  'lumen.docPabean.logoOf': '{name} 标志',
  'lumen.docPabean.uploadTitle': '上传文件',
  'lumen.docPabean.uploadRefresh': '刷新',
  'lumen.docPabean.uploadColSeri': '序号',
  'lumen.docPabean.uploadColJenis': '类型',
  'lumen.docPabean.uploadColNo': '文件编号',
  'lumen.docPabean.uploadColFile': '文件',
  'lumen.docPabean.uploadColAksi': '操作',
  'lumen.docPabean.uploadLoading': '正在加载文件...',
  'lumen.docPabean.uploadEmpty': '此批次暂无文件。',
  'lumen.docPabean.uploadNoFile': '暂无文件',
  'lumen.docPabean.uploadReplace': '替换文件',
  'lumen.docPabean.uploadUpload': '上传文件',
  'lumen.docPabean.uploadClose': '关闭',
  'lumen.docPabean.uploadDone': '{name} 已上传',
  'lumen.docPabean.uploadFailed': '上传失败',
  'lumen.docPabean.uploadListFailed': '无法加载文件列表',
  'lumen.docPabean.uploadBadFormatTitle': '不支持的格式',
  'lumen.docPabean.uploadBadFormat': '仅允许 PDF 或 Excel 文件（.xlsx/.xls/.csv）。',
  'lumen.docPabean.blokirLoadFailed': '无法加载封锁监控数据。',
  'lumen.uploadKit.loadingText': 'Memuat...',
  'lumen.uploadKit.emptyText': 'Tidak ditemukan',
  'lumen.uploadKit.loadErrorText': 'Gagal memuat',
  'lumen.docReview.loading': 'Loading...',
  'lumen.docReview.errorTitle': 'Error',
  'lumen.docReview.title': 'Review Dokumen',
  'lumen.docReview.noDocsFound': 'No Documents Found',
  'lumen.docReview.noDocsDesc': 'No documents were found for this batch. Please go back and try again.',
  'lumen.docReview.goBack': 'Go Back',
  'lumen.docReview.back': 'Back',
  'lumen.docReview.documents': 'Dokumen',
  'lumen.docReview.pages': 'halaman',
  'lumen.docReview.selectedPages': 'Halaman terpilih:',
  'lumen.docReview.noSelection': 'Belum ada halaman terpilih',
  'lumen.docReview.loadingPdfPreview': 'Loading PDF preview...',
  'lumen.docReview.openInNewTab': 'Buka di tab baru',
  'lumen.docReview.openPdfInNewTab': 'Open PDF in new tab',
  'lumen.docReview.documentSelection': 'Document Selection',
  'lumen.docReview.documentsByCategory': 'Documents by Category',
  'lumen.docReview.excelUnavailable': 'Excel - Preview unavailable',
  'lumen.docReview.includedInSubmission': 'Included in submission',
  'lumen.docReview.pagesAllSelected': 'pages selected',
  'lumen.docReview.extractedBy': 'Extracted by',
  'lumen.docReview.processing': 'Processing...',
  'lumen.docReview.preparingDocs': 'Preparing your documents...',
  'lumen.docReview.fetchingDocs': 'Fetching document data...',
  'lumen.docReview.waitProcessing': 'Please wait while we process your request. This may take a few moments.',
  'lumen.docReview.donNavigateAway': 'Please do not close this page or navigate away.',
  'lumen.docReview.dataLossWarning': 'Closing this page may result in data loss',
  'lumen.docReview.successTitle': 'Berhasil',
  'lumen.docReview.selectionSaved': 'Pilihan halaman berhasil disimpan',
  'lumen.docReview.submitError': 'Failed to submit selection. Please try again.',
  'lumen.docReview.fetchError': 'Failed to fetch files. Please try again.',
  'lumen.docReview.viewerError': 'Gagal memuat pratinjau PDF. Coba unduh file atau refresh halaman.',
  'lumen.docReview.noPdfPreview': 'No PDF documents available for preview',
  'lumen.docReview.processingModalTitle': 'Processing Documents',
  'lumen.docReview.processingCompleteTitle': 'Processing Complete',
  'lumen.docReview.processingSuccessDesc': 'Your documents have been processed successfully!',
  'lumen.docReview.submitSelection': 'Submit Selection',
  'lumen.docReview.documentPlaceholder': 'Dokumen {id}',
  'lumen.docReview.allExcelNote':
    'All uploaded files are Excel documents. They will be included in the submission but cannot be previewed here.',
  'lumen.docReview.categoryHeading': '{category} ({count})',

  // PR 7b B6a: the export upload wizard
  'lumen.exportWizard.title': 'Upload Dokumen Ekspor',
  'lumen.exportWizard.subtitle': 'BC 3.0 · Alur 3 langkah',
  'lumen.exportWizard.oldMode': 'Mode Lama (PDF / Excel)',
  'lumen.exportWizard.oldModeTitle': 'Pakai Mode Lama: Upload PDF / Excel langsung tanpa wizard',
  'lumen.exportWizard.step1': 'Pelabuhan Muat',
  'lumen.exportWizard.step1Desc': 'Pilih kode pelabuhan',
  'lumen.exportWizard.step2': 'Eksportir',
  'lumen.exportWizard.step2Desc': 'Pilih perusahaan eksportir',
  'lumen.exportWizard.step3': 'Dokumen',
  'lumen.exportWizard.step3Desc': 'Upload file PDF',
  'lumen.exportWizard.back': 'Kembali',
  'lumen.exportWizard.next': 'Lanjutkan',
  'lumen.exportWizard.upload': 'Upload Dokumen',
  'lumen.exportWizard.uploading': 'Mengunggah...',
  'lumen.exportWizard.scaffolding': 'Menyiapkan draft...',
  'lumen.exportWizard.readingDocs': 'Membaca dokumen %s/%s...',
  'lumen.exportWizard.uploadDisabled': 'Tombol aktif setelah semua dokumen selesai dibaca',
  'lumen.exportWizard.portLabel': 'Pelabuhan Muat',
  'lumen.exportWizard.portPlaceholder': 'Cari pelabuhan (kode atau nama)',
  'lumen.exportWizard.portTitle': 'Kode Pelabuhan Muat',
  'lumen.exportWizard.portDesc':
    'Pilih pelabuhan tempat barang akan dimuat untuk ekspor. Anda dapat mencari berdasarkan kode atau nama pelabuhan.',
  'lumen.exportWizard.whyImportant': 'Mengapa ini penting?',
  'lumen.exportWizard.whyDesc':
    'Kode pelabuhan muat akan digunakan untuk mengisi data header PEB secara otomatis pada langkah berikutnya.',
  'lumen.exportWizard.required': 'Field ini wajib diisi',
  'lumen.exportWizard.exporterTitle': 'Pilih Eksportir',
  'lumen.exportWizard.exporterDesc': 'Pilih perusahaan eksportir yang akan digunakan untuk dokumen ini.',
  'lumen.exportWizard.exporterPlaceholder': 'Cari nama, NPWP, penerima, atau pembeli',
  'lumen.exportWizard.results': 'Menampilkan %s-%s dari %s',
  'lumen.exportWizard.noData': 'Tidak ada data',
  'lumen.exportWizard.or': 'ATAU',
  'lumen.exportWizard.excelUpload': 'Upload File Excel CEISA',
  'lumen.exportWizard.excelUploadDesc': 'Klik atau seret file Excel (.xlsx, .xls) ke area ini',
  'lumen.exportWizard.change': 'Ubah',
  'lumen.exportWizard.loading': 'Loading...',
  'lumen.exportWizard.step1PelabuhanMuat': 'Pelabuhan Muat',
  'lumen.exportWizard.step1PelabuhanMuatDesc': 'Pilih kode pelabuhan',
  'lumen.exportWizard.excelFormatError': 'Format tidak didukung',
  'lumen.exportWizard.excelFormatErrorDesc': 'Hanya file Excel (.xls, .xlsx) yang diterima.',
  'lumen.exportWizard.excelSearchPlaceholder': 'Cari nama, NPWP, penerima, atau pembeli',
  'lumen.exportWizard.resultsCount': 'Menampilkan {from}-{to} dari {total}',
  'lumen.exportWizard.failedLoad': 'Gagal memuat data',
  'lumen.exportWizard.retry': 'Coba Lagi',
  'lumen.exportWizard.emptyState': 'Tidak ada eksportir ditemukan',
  'lumen.exportWizard.emptyStateDesc': 'Coba ubah kata kunci pencarian atau periksa kembali data Anda.',
  'lumen.exportWizard.previous': 'Sebelumnya',
  'lumen.exportWizard.paginationNext': 'Selanjutnya',
  'lumen.exportWizard.uploadExcelDatabase': 'Upload Excel Database',
  'lumen.exportWizard.uploadExcelDatabaseDesc': 'Upload file Excel CEISA untuk memproses data ekspor secara langsung.',
  'lumen.exportWizard.emptyStateClick': 'Klik untuk pilih file Excel CEISA',
  'lumen.exportWizard.emptyStateFormat': 'Format: .xls, .xlsx',
  'lumen.exportWizard.uploadingProcessing': 'Mengupload dan memproses...',
  'lumen.exportWizard.uploadingProcessingDesc': 'Mohon tunggu, sedang memproses file Excel CEISA',
  'lumen.exportWizard.step3Title': 'Upload Dokumen',
  'lumen.exportWizard.step3Subtitle': 'Unggah file PDF untuk masing-masing jenis dokumen yang diperlukan.',
  'lumen.exportWizard.selectUnspecified': 'Belum dipilih',
  'lumen.exportWizard.summaryTitle': 'Ringkasan Upload',
  'lumen.exportWizard.summaryDesc':
    'Periksa jenis dokumen untuk setiap file sebelum upload. Ubah di daftar di atas jika ada yang salah.',
  'lumen.exportWizard.noInvoiceTitle': 'Belum ada file Invoice',
  'lumen.exportWizard.noInvoiceBefore': 'Salah satu file harus bertipe ',
  'lumen.exportWizard.noInvoiceStrong': 'Invoice (I)',
  'lumen.exportWizard.noInvoiceAfter':
    ' atau format Excel CEISA. Tanpa Invoice, Python tidak akan mengekstrak data barang dan tab Barang akan kosong. Ubah jenis dokumen salah satu file di daftar di atas.',
  'lumen.exportWizard.dupTypeTitle': 'Duplikat jenis dokumen',
  'lumen.exportWizard.dupTypeBefore': 'Beberapa file memiliki jenis dokumen yang sama: ',
  'lumen.exportWizard.dupTypeStrong':
    ', Pastikan ini memang disengaja — biasanya setiap jenis dokumen hanya diunggah satu kali.',
  'lumen.exportWizard.dataFilledTitle': 'Data eksportir & pelabuhan sudah terisi',
  'lumen.exportWizard.dataFilledDesc':
    'Setelah upload selesai, halaman review hanya akan meminta Anda memverifikasi halaman-halaman yang berisi data barang. Informasi eksportir dan pelabuhan akan otomatis terisi dari pilihan Anda di langkah sebelumnya.',
  'lumen.exportWizard.uploadSuccessTitle': 'Upload Berhasil',
  'lumen.exportWizard.uploadSuccessMsg': 'File Excel CEISA berhasil diupload dan diproses.',
  'lumen.exportWizard.uploadFailedTitle': 'Upload gagal',
  'lumen.exportWizard.scaffoldFailedTitle': 'Gagal scaffold',
  'lumen.exportWizard.uploadDoneTitle': 'Berhasil',
  'lumen.exportWizard.uploadDoneMsg': 'Dokumen berhasil diunggah. Mengarahkan ke halaman review.',
  'lumen.exportWizard.confirmDiscard':
    'Berkas sudah terunggah ke draft ini. Kembali akan membuang progres upload. Lanjutkan?',
  'lumen.exportWizard.stepBadge': 'Langkah {step} dari {total}',
  'lumen.exportWizard.stepPageInfo': 'Halaman {page} dari {totalPages}',

  // PR 6b B2: the BL editor (Sheet, sections, inner HS / Container / Dokumen lists). Old text verbatim,
  // the same in id, zh and en; sections, selectAll and selectRow are new labels for the new parts.
  'lumen.manifestEngine.blEditor.titleAddBl': 'Tambah Data BL',
  'lumen.manifestEngine.blEditor.titleAddAwb': 'Tambah Data AWB',
  'lumen.manifestEngine.blEditor.titleEditBl': 'Edit Data BL',
  'lumen.manifestEngine.blEditor.titleEditAwb': 'Edit Data AWB',
  'lumen.manifestEngine.blEditor.sections': 'Bagian BL',
  'lumen.manifestEngine.blEditor.batal': 'Batal',
  'lumen.manifestEngine.blEditor.simpan': 'Simpan',
  'lumen.manifestEngine.blEditor.required': 'Field ini wajib diisi',
  'lumen.manifestEngine.blEditor.successTitle': 'Success',
  'lumen.manifestEngine.blEditor.errorTitle': 'Error',
  'lumen.manifestEngine.blEditor.warningTitle': 'Warning',
  'lumen.manifestEngine.blEditor.validationTitle': 'Validation Error',
  'lumen.manifestEngine.blEditor.validationMessage': 'Please fill in all required fields',
  'lumen.manifestEngine.blEditor.updated': 'BL data has been updated successfully',
  'lumen.manifestEngine.blEditor.added': 'BL data has been added successfully',
  'lumen.manifestEngine.blEditor.saveFailed': 'Failed to save BL: {message}',
  'lumen.manifestEngine.blEditor.noResults': 'No results found.',
  'lumen.manifestEngine.blEditor.lookupLoading': 'Loading...',
  'lumen.manifestEngine.blEditor.lookupEmpty': 'Tidak dapat menemukan',
  'lumen.manifestEngine.blEditor.lookupFailed': 'Error when get {label}',
  'lumen.manifestEngine.blEditor.kelompokPosTitle': 'Kelompok Pos & Nomor Pos',
  'lumen.manifestEngine.blEditor.kelompokPos': 'Kelompok Pos',
  'lumen.manifestEngine.blEditor.nomorPos': 'Nomor Pos',
  'lumen.manifestEngine.blEditor.masterHostBl': 'Master BL & Host BL',
  'lumen.manifestEngine.blEditor.masterHostAwb': 'Master AWB & Host AWB',
  'lumen.manifestEngine.blEditor.masterBl': 'Master BL',
  'lumen.manifestEngine.blEditor.masterAwb': 'Master AWB',
  'lumen.manifestEngine.blEditor.tanggalMasterBl': 'Tanggal Master BL',
  'lumen.manifestEngine.blEditor.tanggalMasterAwb': 'Tanggal Master AWB',
  'lumen.manifestEngine.blEditor.hostBl': 'Host BL',
  'lumen.manifestEngine.blEditor.hostAwb': 'Host AWB',
  'lumen.manifestEngine.blEditor.tanggalHostBl': 'Tanggal Host BL',
  'lumen.manifestEngine.blEditor.tanggalHostAwb': 'Tanggal Host AWB',
  'lumen.manifestEngine.blEditor.flagBl': 'Flag BL',
  'lumen.manifestEngine.blEditor.konsolidasi': 'Konsolidasi',
  'lumen.manifestEngine.blEditor.parsial': 'Parsial',
  'lumen.manifestEngine.blEditor.partOf': 'Part Of',
  'lumen.manifestEngine.blEditor.pelabuhan': 'Pelabuhan',
  'lumen.manifestEngine.blEditor.pelabuhanAsal': 'Pelabuhan Asal',
  'lumen.manifestEngine.blEditor.pelabuhanBongkar': 'Pelabuhan Bongkar',
  'lumen.manifestEngine.blEditor.pelabuhanTransit': 'Pelabuhan Transit',
  'lumen.manifestEngine.blEditor.pelabuhanAkhir': 'Pelabuhan Akhir',
  'lumen.manifestEngine.blEditor.pilihPelabuhanAsal': 'Pilih Pelabuhan Asal',
  'lumen.manifestEngine.blEditor.pilihPelabuhanBongkar': 'Pilih Pelabuhan Bongkar',
  'lumen.manifestEngine.blEditor.pilihPelabuhanTransit': 'Pilih Pelabuhan Transit',
  'lumen.manifestEngine.blEditor.pilihPelabuhanAkhir': 'Pilih Pelabuhan Akhir',
  'lumen.manifestEngine.blEditor.motherVessel': 'Mother Vessel',
  'lumen.manifestEngine.blEditor.vesselName': 'Vessel Name',
  'lumen.manifestEngine.blEditor.copyFromHeader': 'Copy dari Header',
  'lumen.manifestEngine.blEditor.vesselCopied': 'Mother vessel copied from header',
  'lumen.manifestEngine.blEditor.vesselMissing': 'Header vessel or voyage data not found',
  'lumen.manifestEngine.blEditor.kemasan': 'Kemasan',
  'lumen.manifestEngine.blEditor.berat': 'Berat',
  'lumen.manifestEngine.blEditor.dimensi': 'Dimensi',
  'lumen.manifestEngine.blEditor.unitKg': 'kg',
  'lumen.manifestEngine.blEditor.unitM3': 'm3',
  'lumen.manifestEngine.blEditor.numberPlaceholder': '0',
  'lumen.manifestEngine.blEditor.marking': 'Marking',
  'lumen.manifestEngine.blEditor.markingPlaceholder': 'marking',
  'lumen.manifestEngine.blEditor.jenisKemasan': 'Jenis Kemasan',
  'lumen.manifestEngine.blEditor.pilihJenisKemasan': 'Pilih Jenis Kemasan',
  'lumen.manifestEngine.blEditor.totalKemasan': 'Total Kemasan',
  'lumen.manifestEngine.blEditor.jumlahKemasanTerangkut': 'Jumlah Kemasan Terangkut',
  'lumen.manifestEngine.blEditor.shipper': 'Shipper',
  'lumen.manifestEngine.blEditor.jenisIdentitas': 'Jenis Identitas',
  'lumen.manifestEngine.blEditor.npwpShipper': 'NPWP Shipper / Pengirim',
  'lumen.manifestEngine.blEditor.namaShipper': 'Nama Shipper / Pengirim',
  'lumen.manifestEngine.blEditor.alamatShipper': 'Alamat Shipper / Pengirim',
  'lumen.manifestEngine.blEditor.consignee': 'Consignee',
  'lumen.manifestEngine.blEditor.normalizeNpwp': 'Normalize NPWP',
  'lumen.manifestEngine.blEditor.npwpNormalizedTitle': 'NPWP Normalized',
  'lumen.manifestEngine.blEditor.npwpNormalized': 'NPWP diubah dari "{raw}" menjadi "{normalized}"',
  'lumen.manifestEngine.blEditor.npwpCleanTitle': 'NPWP sudah bersih',
  'lumen.manifestEngine.blEditor.npwpClean': 'Tidak ada simbol yang perlu dihapus.',
  'lumen.manifestEngine.blEditor.npwpConsignee': 'NPWP Consignee / Penerima',
  'lumen.manifestEngine.blEditor.namaConsignee': 'Nama Consignee / Penerima',
  'lumen.manifestEngine.blEditor.alamatConsignee': 'Alamat Consignee / Penerima',
  'lumen.manifestEngine.blEditor.notify': 'Notify',
  'lumen.manifestEngine.blEditor.salinConsignee': 'Salin Data Consignee',
  'lumen.manifestEngine.blEditor.consigneeCopied': 'Data Consignee telah disalin ke Notify',
  'lumen.manifestEngine.blEditor.npwpNotify': 'NPWP Notify',
  'lumen.manifestEngine.blEditor.namaNotify': 'Nama Notify',
  'lumen.manifestEngine.blEditor.alamatNotify': 'Alamat Notify',
  'lumen.manifestEngine.blEditor.dataHsCount': 'Data HS ({n})',
  'lumen.manifestEngine.blEditor.dataHs': 'Data HS',
  'lumen.manifestEngine.blEditor.hapusSelected': 'Hapus ({n} dipilih)',
  'lumen.manifestEngine.blEditor.combine': 'Combine Goods',
  'lumen.manifestEngine.blEditor.uncombine': 'Uncombine Goods',
  'lumen.manifestEngine.blEditor.slice': 'Slice HS Codes (4 Digits)',
  'lumen.manifestEngine.blEditor.addHs': 'TAMBAH DATA HS BARU',
  'lumen.manifestEngine.blEditor.colHs': 'HS',
  'lumen.manifestEngine.blEditor.colUraian': 'Uraian',
  'lumen.manifestEngine.blEditor.colAksi': 'Aksi',
  'lumen.manifestEngine.blEditor.edit': 'Edit',
  'lumen.manifestEngine.blEditor.copy': 'Copy',
  'lumen.manifestEngine.blEditor.delete': 'Delete',
  'lumen.manifestEngine.blEditor.selectAll': 'Pilih semua',
  'lumen.manifestEngine.blEditor.selectRow': 'Pilih baris {n}',
  'lumen.manifestEngine.blEditor.noSelection': 'Tidak ada item yang dipilih',
  'lumen.manifestEngine.blEditor.deletedCount': '{n} item berhasil dihapus',
  'lumen.manifestEngine.blEditor.slicedTitle': 'HS Codes Sliced',
  'lumen.manifestEngine.blEditor.sliced': 'All HS codes longer than 4 digits have been trimmed to 4 digits.',
  'lumen.manifestEngine.blEditor.hsDialogAdd': 'Tambah Data HS',
  'lumen.manifestEngine.blEditor.hsDialogEdit': 'Edit Data HS',
  'lumen.manifestEngine.blEditor.kodeHs': 'Kode HS',
  'lumen.manifestEngine.blEditor.uraianHs': 'Uraian HS',
  'lumen.manifestEngine.blEditor.cancel': 'Cancel',
  'lumen.manifestEngine.blEditor.ok': 'OK',
  'lumen.manifestEngine.blEditor.dataContainerCount': 'Data Container ({n})',
  'lumen.manifestEngine.blEditor.dataContainer': 'Data Container',
  'lumen.manifestEngine.blEditor.addContainer': 'TAMBAH CONTAINER BARU',
  'lumen.manifestEngine.blEditor.nomorContainer': 'Nomor Container',
  'lumen.manifestEngine.blEditor.tipeContainer': 'Tipe Container',
  'lumen.manifestEngine.blEditor.ukuranContainer': 'Ukuran Container',
  'lumen.manifestEngine.blEditor.jenisContainer': 'Jenis Container',
  'lumen.manifestEngine.blEditor.nomorSegel': 'Nomor Segel',
  'lumen.manifestEngine.blEditor.isPartOf': 'Is Part Of',
  'lumen.manifestEngine.blEditor.yes': 'Yes',
  'lumen.manifestEngine.blEditor.containerDialogAdd': 'Tambah Peti Kemas',
  'lumen.manifestEngine.blEditor.containerDialogEdit': 'Edit Peti Kemas',
  'lumen.manifestEngine.blEditor.type': 'Type',
  'lumen.manifestEngine.blEditor.nomorPolisi': 'Nomor Polisi',
  'lumen.manifestEngine.blEditor.driver': 'Driver',
  'lumen.manifestEngine.blEditor.ukuranPlaceholder': 'Ukuran',
  'lumen.manifestEngine.blEditor.jenisPlaceholder': 'Jenis',
  'lumen.manifestEngine.blEditor.segelPlaceholder': 'Segel',
  'lumen.manifestEngine.blEditor.tipePlaceholder': 'Tipe',
  'lumen.manifestEngine.blEditor.platNomorPlaceholder': 'Plat Nomor',
  'lumen.manifestEngine.blEditor.dataDokumenCount': 'Data Dokumen ({n})',
  'lumen.manifestEngine.blEditor.dataDokumen': 'Data Dokumen',
  'lumen.manifestEngine.blEditor.addDokumen': 'TAMBAH DOKUMEN BARU',
  'lumen.manifestEngine.blEditor.jenisDokumen': 'Jenis Dokumen',
  'lumen.manifestEngine.blEditor.nomorDok': 'Nomor Dok',
  'lumen.manifestEngine.blEditor.tanggalDokumen': 'Tanggal Dokumen',
  'lumen.manifestEngine.blEditor.kodeKantor': 'Kode Kantor',
  'lumen.manifestEngine.blEditor.kodeDokumenAsal': 'Kode Dokumen Asal',
  'lumen.manifestEngine.blEditor.pilihKodeDokumen': 'Pilih Kode Dokumen',
  'lumen.manifestEngine.blEditor.nomorDokumenAsal': 'Nomor Dokumen Asal',
  'lumen.manifestEngine.blEditor.nomorDokumenPlaceholder': '000000',
  'lumen.manifestEngine.blEditor.tanggalPlaceholder': '2025-10-19',
  'lumen.manifestEngine.blEditor.pilihKodeKantor': 'Pilih Kode Kantor',
  // ---- end Lumen manifest/guardian ----
  // master/statement (the Utama, scope, conflict and confirm copy stays in statement.*)
  'lumen.masterStatement.searchPlaceholder': 'Search by name, place, position...',
  'lumen.masterStatement.add': 'Add Config',
  'lumen.masterStatement.addTitle': 'Add Statement Config',
  'lumen.masterStatement.editTitle': 'Edit Statement Config',
  'lumen.masterStatement.position': 'Position',
  'lumen.masterStatement.place': 'Place',
  'lumen.masterStatement.positionPlaceholder': 'e.g. Manager',
  'lumen.masterStatement.placePlaceholder': 'e.g. Jakarta',
  'lumen.masterStatement.updated': 'Statement config updated successfully',
  'lumen.masterStatement.updateFailed': 'Failed to update statement config',
  'lumen.masterStatement.created': 'Statement config created successfully',
  'lumen.masterStatement.createFailed': 'Failed to create statement config',
  'lumen.masterStatement.deactivated': 'Statement config deactivated successfully',
  'lumen.masterStatement.deactivateFailed': 'Failed to deactivate statement config',
  // lumen.pibEngine (revamp PR 7c)
  'lumen.pibEngine.lookup.loading': '加载中...',
  'lumen.pibEngine.lookup.empty': '未找到',
  'lumen.pibEngine.lookup.failed': '获取 {label} 时出错',
  'lumen.pibEngine.lookup.clear': '清除',
  'lumen.pibEngine.select.empty': '未找到结果。',
  'lumen.pibEngine.select.clear': '清除选择',
  'lumen.pibEngine.s1.draftTitle': '草稿 PIB',
  'lumen.pibEngine.s1.draftSubtitulo': '本地预览，未发送至 CEISA',
  'lumen.pibEngine.s1.printPdf': '打印 / 保存 PDF',
  'lumen.pibEngine.s1.backToDraft': '返回草稿',
  'lumen.pibEngine.s1.loadingDraft': '正在准备 PIB 草稿...',
  'lumen.pibEngine.eb1.errorPickHsFirst': '请先选择 HS 码',
  'lumen.pibEngine.eb1.hsSpekMarked': 'HS 码已标记为特殊商品 HS 码',
  'lumen.pibEngine.eb1.hsSpekUnmarked': 'HS 码已从特殊商品 HS 码中移除',
  'lumen.pibEngine.eb1.hsSpekToggleFailed': '更改商品状态失败',
  'lumen.pibEngine.eb1.processIdMissing': '无法获取 Process ID。请重新加载页面。',
  'lumen.pibEngine.eb1.hsDetailsFetchFailed': '获取 HS 码详情失败',
  'lumen.pibEngine.eb1.hsDetailsFetchError': '获取 HS 码详情时出错',
  'lumen.pibEngine.eb2.navInformasiDasar': '基本信息',
  'lumen.pibEngine.eb2.navDokumenTransaksi': '文档与交易',
  'lumen.pibEngine.eb2.navSpesifikasiKhusus': '特殊规格',
  'lumen.pibEngine.eb2.navPungutan': '税费',
  'lumen.pibEngine.eb2.sectionInformasiDasar': '基本信息',
  'lumen.pibEngine.eb2.sectionDetailHarga': '详情与价格',
  'lumen.pibEngine.eb2.sectionPungutan': '税费',
  'lumen.pibEngine.eb2.sectionDokumen': '文档',
  'lumen.pibEngine.eb2.sectionJenisTransaksi': '交易类型',
  'lumen.pibEngine.eb2.sectionSpesifikasiKhusus': '特殊规格',
  'lumen.pibEngine.eb2.tambahBiaya': '添加费用',
  'lumen.pibEngine.eb2.btnBatal': '取消',
  'lumen.pibEngine.eb2.btnMenyimpan': '保存中…',
  'lumen.pibEngine.eb2.btnTambahBarang': '添加商品',
  'lumen.pibEngine.eb2.btnSimpan': '保存',
  'lumen.pibEngine.eb2.btnHsSpekKhusus': '特殊HS编码',
  'lumen.pibEngine.eb2.btnTandaiHsSpekKhusus': '标记为特殊HS编码',
  'lumen.pibEngine.eb2.btnYaTerapkan': '是，应用',
  'lumen.pibEngine.eb2.modalKonfirmasiTitle': '应用到所有项目确认',
  'lumen.pibEngine.eb2.modalKonfirmasiDesc':
    '您将把此项目的HS编码、单位代码、包装代码、原产国和税费（PPN、PPH、BM）应用到列表中所有其他项目。',
  'lumen.pibEngine.eb2.modalKonfirmasiWarning': '此操作将覆盖所有项目的现有数据。您确定要继续吗？',
  'lumen.pibEngine.eb2.modalMenyimpan': '保存商品数据中…',
  'lumen.pibEngine.eb2.errorTitle': '错误',
  'lumen.pibEngine.eb2.errHsCodeRequired': '必须填写HS编码',
  'lumen.pibEngine.eb2.errUraianRequired': '必须填写商品描述',
  'lumen.pibEngine.eb2.errSatuanRequired': '数量必须填写且大于0',
  'lumen.pibEngine.eb2.errKodeSatuanRequired': '必须填写单位代码',
  'lumen.pibEngine.ebfix.successTitle': '成功',
  'lumen.pibEngine.s2.kolomBelumLengkap': '请填写遗漏的字段',
  'lumen.pibEngine.s2.hargaMismatch': '总价格不匹配',
  'lumen.pibEngine.s2.hargaMismatchDetail':
    '货物页签 {totalBarang} {valuta}（{totalItems} 项）对比交易页签 {hargaBarang} {valuta} — 差额 {selisih} {valuta}。',
  'lumen.pibEngine.s2.hargaMismatchHint': '不阻止提交。请检查交易页签的商品价格或货物页签的单项价格。',
  'lumen.pibEngine.s2.oneWarning': '1 条警告',
  'lumen.pibEngine.s2.go': '转至',
  'lumen.pibEngine.s2.view': '查看',
  'lumen.pibEngine.s2.hide': '隐藏',
  'lumen.pibEngine.s2.show': '显示',
  'lumen.pibEngine.s2.fieldRequired': '{field} 为必填项',
  'lumen.pibEngine.s2.nibRequired': '进口商 NIB 为必填项',
  'lumen.pibEngine.s2.namaRequired': '{entity} 名称为必填项',
  'lumen.pibEngine.s2.alamatRequired': '{entity} 地址为必填项',
  'lumen.pibEngine.s2.identitasRequired': '{entity} 证件类型为必填项',
  'lumen.pibEngine.s2.npwpRequired': '{entity} NPWP 为必填项',
  'lumen.pibEngine.s2.statusRequired': '进口商状态为必填项',
  'lumen.pibEngine.s2.apiRequired': '进口商 API 类型为必填项',
  'lumen.pibEngine.s2.afiliasiRequired': '货主关联必须选择',
  'lumen.pibEngine.s2.ndpbmRequired': 'NDPBM 为必填项且须大于 0',
  'lumen.pibEngine.s2.hargaBarangRequired': '商品价格为必填项且须大于 0',
  'lumen.pibEngine.s2.brutoRequired': '毛重为必填项且须大于 0',
  'lumen.pibEngine.s2.nettoRequired': '净重须大于 0 — 请在货物页签填写单项净重',
  'lumen.pibEngine.s2.loadingAju': '正在加载 AJU…',
  'lumen.pibEngine.s2.refreshAju': '刷新 AJU 号码',
  'lumen.pibEngine.s2.saveAju': '保存 AJU',
  'lumen.pibEngine.s2.cancel': '取消',
  'lumen.pibEngine.s2.editAju': '编辑 AJU 号码',
  'lumen.pibEngine.s2.submitDraft': '提交草稿',
  'lumen.pibEngine.s2.ajuPlaceholder': '000000-000000-00000000-000000',
  'lumen.pibEngine.s2.refreshAjuAria': '刷新 AJU 号码',
  'lumen.pibEngine.s2.cancelEditAria': '取消 AJU 编辑',
  'lumen.pibEngine.s3.ajuModalTitle': '进口编号 - 进口申报',
  'lumen.pibEngine.s3.nomorAjuDihasilkan': '生成的 AJU 编号',
  'lumen.pibEngine.s3.berhasilDisalin': 'AJU 编号已复制到剪贴板！',
  'lumen.pibEngine.s3.nomorAjuTerbaru': '最近的 AJU 编号',
  'lumen.pibEngine.s3.statusSelesai': '完成',
  'lumen.pibEngine.s3.statusTerkirim': '已发送',
  'lumen.pibEngine.s3.statusDraft': '草稿',
  'lumen.pibEngine.s3.batal': '取消',
  'lumen.pibEngine.s3.simpan': '保存',
  'lumen.pibEngine.s3.kirimApproval': '发送审批',
  'lumen.pibEngine.s3.pilihEmailGroup': '选择电子邮件组以将审批请求发送给审阅者。',
  'lumen.pibEngine.s3.buatGroupBaru': '创建新组',
  'lumen.pibEngine.s3.namaGroup': '组名称',
  'lumen.pibEngine.s3.namaGroupPlaceholder': '组名称',
  'lumen.pibEngine.s3.deskripsiOpsional': '描述（可选）',
  'lumen.pibEngine.s3.deskripsiGroupPlaceholder': '组描述',
  'lumen.pibEngine.s3.pilihEmailGroupPlaceholder': '选择电子邮件组',
  'lumen.pibEngine.s3.loading': '加载中...',
  'lumen.pibEngine.s3.kirimSekarang': '立即发送',
  'lumen.pibEngine.s3.jadwalkan': '计划',
  'lumen.pibEngine.s3.pilihTanggalWaktu': '选择日期和时间',
  'lumen.pibEngine.s3.waktuPengiriman': '发送时间',
  'lumen.pibEngine.s3.selesai': '完成',
  'lumen.pibEngine.s3.emailAkanDikirim': '将发送的电子邮件',
  'lumen.pibEngine.s3.tidakAdaEmailAktif': '此组中没有活动的电子邮件。',
  'lumen.pibEngine.s3.nama': '名称',
  'lumen.pibEngine.s3.email': 'E-mail',
  'lumen.pibEngine.s3.tambah': '添加',
  'lumen.pibEngine.s3.tambahEmail': '添加电子邮件',
  'lumen.pibEngine.s3.jadwalkanApproval': '计划审批',
  'lumen.pibEngine.s3.kirimApprovalBtn': '发送审批',
  'lumen.pibEngine.s14.basicInfoTitle': '基本信息',
  'lumen.pibEngine.s14.seriLabel': '系列',
  'lumen.pibEngine.s14.seriPlaceholder': '系列',
  'lumen.pibEngine.s14.satuanLabel': '单位',
  'lumen.pibEngine.s14.satuanPlaceholder': '单位',
  'lumen.pibEngine.s14.kodeSatuanLabel': '单位代码',
  'lumen.pibEngine.s14.kodeSatuanPlaceholder': '单位代码',
  'lumen.pibEngine.s14.kemasanLabel': '包装',
  'lumen.pibEngine.s14.kemasanPlaceholder': '包装',
  'lumen.pibEngine.s14.kodeKemasanLabel': '包装代码',
  'lumen.pibEngine.s14.kodeKemasanPlaceholder': '包装代码',
  'lumen.pibEngine.s14.hsCodeLabel': 'HS编码',
  'lumen.pibEngine.s14.hsCodePlaceholder': 'HS编码',
  'lumen.pibEngine.s14.hsCodeAria': 'HS编码',
  'lumen.pibEngine.s14.viewHsCodeDetails': '查看HS编码详情',
  'lumen.pibEngine.s14.lartasBadge': 'LARTAS',
  'lumen.pibEngine.s14.pernyataanLartasLabel': 'LARTAS声明',
  'lumen.pibEngine.s14.ya': '是',
  'lumen.pibEngine.s14.tidak': '否',
  'lumen.pibEngine.s14.uraianLabel': '描述',
  'lumen.pibEngine.s14.sesuaiHs': '匹配HS',
  'lumen.pibEngine.s14.uraianPlaceholder': '货物描述',
  'lumen.pibEngine.s14.tanpaMerek': '无品牌',
  'lumen.pibEngine.s14.merekLabel': '品牌',
  'lumen.pibEngine.s14.merekPlaceholder': '品牌',
  'lumen.pibEngine.s14.tanpaTipe': '无型号',
  'lumen.pibEngine.s14.tipeLabel': '型号',
  'lumen.pibEngine.s14.tipePlaceholder': '型号',
  'lumen.pibEngine.s14.ukuranLabel': '尺寸',
  'lumen.pibEngine.s14.ukuranPlaceholder': '0.00',
  'lumen.pibEngine.s14.spesifikasiLainLabel': '其他规格',
  'lumen.pibEngine.s14.spesifikasiLainPlaceholder': '其他规格',
  'lumen.pibEngine.s14.kodeBarangLabel': '货物代码',
  'lumen.pibEngine.s14.kodeBarangPlaceholder': '货物代码',
  'lumen.pibEngine.s14.beratBersihLabel': '净重（公斤）',
  'lumen.pibEngine.s14.nettoPlaceholder': '0.00',
  'lumen.pibEngine.s14.kondisiBaru': '新货物',
  'lumen.pibEngine.s14.kondisiBukanBaru': '非新货物',
  'lumen.pibEngine.s14.kondisiBarangLabel': '商品状况',
  'lumen.pibEngine.s14.kondisiBarangPlaceholder': '商品状况',
  'lumen.pibEngine.s14.volumeLabel': '体积（立方米）',
  'lumen.pibEngine.s14.volumePlaceholder': '0.0000',
  'lumen.pibEngine.s14.negaraAsalLabel': '原产国',
  'lumen.pibEngine.s14.negaraAsalPlaceholder': '原产国',
  'lumen.pibEngine.s15.docCount': '文件',
  'lumen.pibEngine.s15.tambah': '添加',
  'lumen.pibEngine.s15.seri': 'Serial',
  'lumen.pibEngine.s15.jenis': '类型',
  'lumen.pibEngine.s15.nomor': '号码',
  'lumen.pibEngine.s15.tanggal': '日期',
  'lumen.pibEngine.s15.fasilitas': '设施',
  'lumen.pibEngine.s15.izin': '许可证',
  'lumen.pibEngine.s15.aksi': '操作',
  'lumen.pibEngine.s15.edit': '编辑',
  'lumen.pibEngine.s15.editAria': '编辑',
  'lumen.pibEngine.s15.delete': '删除',
  'lumen.pibEngine.s15.deleteAria': '删除',
  'lumen.pibEngine.s15.emptyState': '尚无文件。点击"Tambah"添加。',
  'lumen.pibEngine.s15.attachModalTitle': '附加文件到商品',
  'lumen.pibEngine.s15.attachDescription': '选择要附加到此商品的文件：',
  'lumen.pibEngine.s15.noDocsAvailable': '暂无可用文件。请先在文件标签页添加文件。',
  'lumen.pibEngine.s15.failSaveDocTitle': '保存商品文件失败',
  'lumen.pibEngine.s15.failSaveDocMessage': '文件更改未保存。请重试。',
  'lumen.pibEngine.s8.syncDariJarvis': '从 Lumen 同步',
  'lumen.pibEngine.s8.syncPerluDiperiksa': '与上次提交不同 — 从 Lumen 获取数据',
  'lumen.pibEngine.s8.pilihDataDariLumen': '从 Lumen 选择数据',
  'lumen.pibEngine.s8.dataTandaDiSalahkan': '数据标记错误',
  'lumen.pibEngine.s8.dataTidakAkanDitampilkan': '此数据将在后续搜索中不再显示。',
  'lumen.pibEngine.s8.gagalMenandaiData': '标记数据失败',
  'lumen.pibEngine.s8.terjadiKesalahan': '更新数据时发生错误。',
  'lumen.pibEngine.s8.tandaiDataSalah': '标记数据错误',
  'lumen.pibEngine.s8.yaTandaiSalah': '是的，标记错误',
  'lumen.pibEngine.s8.tidak': '不',
  'lumen.pibEngine.s8.batal': '取消',
  'lumen.pibEngine.s8.apply': '应用',
  'lumen.pibEngine.s8.tidakAdaDataUntukDipilih': '没有可选数据。',
  'lumen.pibEngine.s8.bukaConsignee': '打开 Consignee 数据',
  'lumen.pibEngine.s8.riwayatDokumenCount': '文档历史记录 ({count})',
  'lumen.pibEngine.s8.diperbaruiTanggal': '更新于 {date}',
  'lumen.pibEngine.s8.bukaDiConsignee': '在 Consignee 数据中打开',
  'lumen.pibEngine.s8.riwayatTidakDapatDimuat': '无法加载文档历史记录',
  'lumen.pibEngine.s8.tandaiSebagaiSalah': '将“{name}”标记为错误数据？此数据将从后续搜索中隐藏。',
  'lumen.pibEngine.s8.dataMasterTidakBisaDitandai': 'Consignee 数据在 Master 菜单中管理，不能在此标记错误。',
  'lumen.pibEngine.s16.amountCif': '金额 (CIF)',
  'lumen.pibEngine.s16.typeHere': '在此输入…',
  'lumen.pibEngine.s16.fob': 'FOB',
  'lumen.pibEngine.s16.hargaSatuan': '单价',
  'lumen.pibEngine.s16.biayaTambahanDiskon': '附加费用 - 折扣',
  'lumen.pibEngine.s16.freight': '运费',
  'lumen.pibEngine.s16.biayaAsuransi': '保险费',
  'lumen.pibEngine.s16.cifRupiah': 'CIF - 印尼盾 (计算)',
  'lumen.pibEngine.s16.freeOfChargeItem': '免费物品',
  'lumen.pibEngine.s16.metodePenentuanNilai': '海关完税价格确定方法',
  'lumen.pibEngine.s16.pilihMetode': '选择方法',
  'lumen.pibEngine.s16.alasan': '原因',
  'lumen.pibEngine.s16.pilihAlasan': '选择原因',
  'lumen.pibEngine.s16.statementPerbedaanHarga': '价格差异声明',
  'lumen.pibEngine.s16.ada': '有',
  'lumen.pibEngine.s16.tidakAda': '无',
  'lumen.pibEngine.s16.transaksiCount': '交易: {count}',
  'lumen.pibEngine.s16.tambah': '添加',
  'lumen.pibEngine.s16.aksi': '操作',
  'lumen.pibEngine.s16.jenisTransaksi': '交易类型',
  'lumen.pibEngine.s16.nilaiVD': '自愿申报价值',
  'lumen.pibEngine.s16.belumAdaTransaksi': '尚未添加交易类型',
  'lumen.pibEngine.s16.tambahJenisTransaksi': '添加交易类型',
  'lumen.pibEngine.s16.ubahJenisTransaksi': '编辑交易类型',
  'lumen.pibEngine.s16.jenisNilai': '交易类型',
  'lumen.pibEngine.s16.pilihJenisNilai': '选择交易类型',
  'lumen.pibEngine.s16.voluntaryDeclaration': '自愿申报',
  'lumen.pibEngine.s16.wajibDiisi': '此交易类型必填',
  'lumen.pibEngine.s16.opsional': '此交易类型可选',
  'lumen.pibEngine.s16.batal': '取消',
  'lumen.pibEngine.s16.simpan': '保存',
  'lumen.pibEngine.s16.errorPilihJenisTransaksi': '必须选择交易类型',
  'lumen.pibEngine.s16.errorVoluntaryDeclaration': '此交易类型必须填写自愿申报',
  'lumen.pibEngine.s16.errorDuplicate': '交易类型已存在于列表中',
  'lumen.pibEngine.s16.edit': '编辑',
  'lumen.pibEngine.s16.hapus': '删除',
  'lumen.pibEngine.s16.editAriaLabel': '编辑交易类型',
  'lumen.pibEngine.s16.hapusAriaLabel': '删除交易类型',
  'lumen.pibEngine.s4.titleTransfer': '转交给 CEISA 的摘要',
  'lumen.pibEngine.s4.titleSubmit': '提交草稿摘要',
  'lumen.pibEngine.s4.hargaMismatchTitle': '总价不符',
  'lumen.pibEngine.s4.barangTab': '商品标签 ({n} 系列)',
  'lumen.pibEngine.s4.transaksiTab': '交易标签',
  'lumen.pibEngine.s4.selisih': '差额',
  'lumen.pibEngine.s4.hargaMismatchMessage': '请先检查交易标签中的商品价格和商品标签中的单项价值。',
  'lumen.pibEngine.s4.hargaAck': '我已检查差额，仍要提交',
  'lumen.pibEngine.s4.duplicateTitle': '商品附在两份相同文件上',
  'lumen.pibEngine.s4.duplicateMessage':
    '每项只能附一份代码文件。CEISA 将拒绝此提交。打开文件标签，然后将以下商品从其中一份文件中移除。',
  'lumen.pibEngine.s4.duplicateAck': '我已检查，仍要提交',
  'lumen.pibEngine.s4.kantorPelTitle': '办公室和港口',
  'lumen.pibEngine.s4.kantor': '办公室',
  'lumen.pibEngine.s4.pelTujuan': '目的港口',
  'lumen.pibEngine.s4.importirTitle': '进口商',
  'lumen.pibEngine.s4.nama': '名称',
  'lumen.pibEngine.s4.npwp': 'NPWP',
  'lumen.pibEngine.s4.apiNib': 'API / NIB',
  'lumen.pibEngine.s4.alamat': '地址',
  'lumen.pibEngine.s4.pengirimTitle': '发货人',
  'lumen.pibEngine.s4.penjualTitle': '卖家',
  'lumen.pibEngine.s4.negara': 'Country',
  'lumen.pibEngine.s4.pengangkutTitle': '承运人',
  'lumen.pibEngine.s4.sarana': '交通工具',
  'lumen.pibEngine.s4.voyFlight': '航次/航班',
  'lumen.pibEngine.s4.bendera': '旗帜',
  'lumen.pibEngine.s4.pelMuat': '装货港口',
  'lumen.pibEngine.s4.kemasanLabel': '包装',
  'lumen.pibEngine.s4.kontainerLabel': '集装箱',
  'lumen.pibEngine.s4.dokumenLabel': '文件',
  'lumen.pibEngine.s4.barangLabel': '商品',
  'lumen.pibEngine.s4.unit': 'unit',
  'lumen.pibEngine.s4.dokumenUnit': 'document',
  'lumen.pibEngine.s4.seri': '系列',
  'lumen.pibEngine.s4.transaksiTitle': '交易',
  'lumen.pibEngine.s4.jenisTransaksi': '交易类型',
  'lumen.pibEngine.s4.incoterm': '贸易术语',
  'lumen.pibEngine.s4.totalCif': '总 CIF',
  'lumen.pibEngine.s4.valuta': '币种',
  'lumen.pibEngine.s4.ndpbm': 'NDPBM',
  'lumen.pibEngine.s4.beratKotor': '毛重',
  'lumen.pibEngine.s4.beratBersih': '净重',
  'lumen.pibEngine.s4.lartasTitle': 'Restriction & Prohibition',
  'lumen.pibEngine.s4.lartasY': '是 (Y)',
  'lumen.pibEngine.s4.lartasT': '否 (T)',
  'lumen.pibEngine.s4.lartasN': '无 (N)',
  'lumen.pibEngine.s4.loadingBarang': '加载商品数据…',
  'lumen.pibEngine.s4.back': '返回',
  'lumen.pibEngine.s4.transferConfirm': '是，转交给 CEISA',
  'lumen.pibEngine.s4.submitConfirm': '提交给 CEISA',
  'lumen.pibEngine.s4.tooltipDuplicate': '先修复附在两份相同文件上的商品',
  'lumen.pibEngine.s4.tooltipHarga': '先确认上方的价格差额',
  'lumen.pibEngine.s4.editAria': '编辑 {n} 项',
  'lumen.pibEngine.s5.errorWorker': 'PDF 工作者通信失败。请刷新页面重试。',
  'lumen.pibEngine.s5.errorNetwork': '由于网络限制无法加载 PDF。请联系支持。',
  'lumen.pibEngine.s5.errorLoad': '加载 PDF 失败。请稍后再试。',
  'lumen.pibEngine.s5.labelInvoice': '发票',
  'lumen.pibEngine.s5.labelPackingList': '装箱单',
  'lumen.pibEngine.s5.labelBillOfLading': '提单',
  'lumen.pibEngine.s5.labelAirWaybill': '空运提单',
  'lumen.pibEngine.s5.labelCertOrigin': '原产地证书',
  'lumen.pibEngine.s5.labelImportCert': '进口证书',
  'lumen.pibEngine.s5.excelPreviewNotAvailable': '无法预览 Excel 文件',
  'lumen.pibEngine.s5.excelCannotDisplay': 'Excel 文件（.xlsx、.xls、.csv）无法在 PDF 查看器中显示。',
  'lumen.pibEngine.s5.downloadExcel': '下载 Excel 文件',
  'lumen.pibEngine.s5.fallingBackIframe': '回退到 iframe 查看器...',
  'lumen.pibEngine.s5.loadingPdf': '正在加载 PDF...',
  'lumen.pibEngine.s5.loadingPage': '正在加载第 {page} 页...',
  'lumen.pibEngine.s5.pageIndicator': '第 {page} 页，共 {total} 页',
  'lumen.pibEngine.s5.zoomOutAria': '缩小',
  'lumen.pibEngine.s5.zoomOutTitle': '缩小（Ctrl + -）',
  'lumen.pibEngine.s5.zoomInAria': '放大',
  'lumen.pibEngine.s5.zoomInTitle': '放大（Ctrl + +）',
  'lumen.pibEngine.s5.resetZoomAria': '重置缩放',
  'lumen.pibEngine.s5.resetZoomTitle': '重置缩放（Ctrl + 0）',
  'lumen.pibEngine.s5.zoomLevelTitle': '缩放级别（Ctrl +/- 缩放，Ctrl 0 重置）',
  'lumen.pibEngine.s5.prevPdfAria': '上一份 PDF',
  'lumen.pibEngine.s5.prevPdfTitle': '上一份 PDF',
  'lumen.pibEngine.s5.nextPdfAria': '下一份 PDF',
  'lumen.pibEngine.s5.nextPdfTitle': '下一份 PDF',
  'lumen.pibEngine.s5.downloadPdfAria': '下载 PDF',
  'lumen.pibEngine.s5.downloadPdfTitle': '下载 PDF',
  'lumen.pibEngine.s5.hidePdfAria': '隐藏 PDF',
  'lumen.pibEngine.s5.hidePdfTitle': '隐藏 PDF',
  'lumen.pibEngine.s17.beaMasuk': '进口附加费',
  'lumen.pibEngine.s17.ppn': '增值税',
  'lumen.pibEngine.s17.pph': '所得税',
  'lumen.pibEngine.s17.kodeJenis': '类型代码',
  'lumen.pibEngine.s17.tarif': '费率 (%)',
  'lumen.pibEngine.s17.tarifPlaceholder': '费率',
  'lumen.pibEngine.s17.ppnPlaceholder': '费率',
  'lumen.pibEngine.s17.pphPlaceholder': '费率',
  'lumen.pibEngine.s17.jenisTarif': '税率类型',
  'lumen.pibEngine.s17.fasilitas': '优惠',
  'lumen.pibEngine.s17.pilih': '选择',
  'lumen.pibEngine.s17.advalorum': '从价税',
  'lumen.pibEngine.s17.spesifik': '从量税',
  'lumen.pibEngine.s17.tambahBiaya': '添加费用',
  'lumen.pibEngine.s17.biayaTambahan': '附加费用',
  'lumen.pibEngine.s17.hapus': '删除',
  'lumen.pibEngine.s17.kategoriSpesifikasi': '规格类别',
  'lumen.pibEngine.s17.otomotif': '汽车',
  'lumen.pibEngine.s17.others': '其他',
  'lumen.pibEngine.s17.cbuLabel': '完税价格',
  'lumen.pibEngine.s17.pilihCbu': '选择 CBU',
  'lumen.pibEngine.s17.noncbu': '非完税',
  'lumen.pibEngine.s17.cbu': '完税',
  'lumen.pibEngine.s17.jenisKendaraan': '车辆类型',
  'lumen.pibEngine.s17.jenisKendaraanPlaceholder': '车辆类型',
  'lumen.pibEngine.s17.merk': '品牌',
  'lumen.pibEngine.s17.merkPlaceholder': '品牌',
  'lumen.pibEngine.s17.tipe': '型号',
  'lumen.pibEngine.s17.tipePlaceholder': '型号',
  'lumen.pibEngine.s17.tahunPembuatan': '制造年份',
  'lumen.pibEngine.s17.tahunPembuatanPlaceholder': '制造年份',
  'lumen.pibEngine.s17.nomorRangka': '车架号',
  'lumen.pibEngine.s17.nomorRangkaPlaceholder': '车架号',
  'lumen.pibEngine.s17.nomorMesin': '发动机号',
  'lumen.pibEngine.s17.nomorMesinPlaceholder': '发动机号',
  'lumen.pibEngine.s17.silinder': '气缸',
  'lumen.pibEngine.s17.silinderPlaceholder': '气缸',
  'lumen.pibEngine.s17.daya': '功率',
  'lumen.pibEngine.s17.dayaPlaceholder': '功率',
  'lumen.pibEngine.s17.modelLabel': '型号',
  'lumen.pibEngine.s17.modelPlaceholder': '型号',
  'lumen.pibEngine.s17.nomorCasiLabel': '装箱单号',
  'lumen.pibEngine.s17.nomorCasiPlaceholder': '装箱单号',
  'lumen.pibEngine.s17.mutuLabel': '质量',
  'lumen.pibEngine.s17.pilihMutu': '选择质量',
  'lumen.pibEngine.s17.mutuPangan': '食品级',
  'lumen.pibEngine.s17.mutuFarmasi': '制药级',
  'lumen.pibEngine.s17.mutuPakanTernak': '饲料级',
  'lumen.pibEngine.s17.mutuLainnya': '其他级',
  'lumen.pibEngine.s9.verified': '已验证',
  'lumen.pibEngine.s9.check': '检查',
  'lumen.pibEngine.s9.review': '审核',
  'lumen.pibEngine.s9.clickReviewSource': '点击核对来源',
  'lumen.pibEngine.s9.autoVerified': '自动验证来源',
  'lumen.pibEngine.s9.needsManualReview': '需人工审核',
  'lumen.pibEngine.s9.suggestVerify': '建议核对此值',
  'lumen.pibEngine.s6.kalibrasiTitle': '校准PIB草稿（内部）',
  'lumen.pibEngine.s6.checklistTitle': '检查清单：草稿PDF与最终PDF对比',
  'lumen.pibEngine.s6.loadingData': '正在获取 {nomorAju} 的对比数据...',
  'lumen.pibEngine.s6.failedTitle': '获取数据失败',
  'lumen.pibEngine.s6.nomorAjuLabel': 'AJU编号',
  'lumen.pibEngine.s6.statusLabel': '状态：',
  'lumen.pibEngine.s6.printSave': '打印 / 保存为PDF',
  'lumen.pibEngine.s6.totalFields': '字段总数',
  'lumen.pibEngine.s6.matches': '匹配',
  'lumen.pibEngine.s6.mismatches': '不匹配',
  'lumen.pibEngine.s6.missingInDraft': '草稿中缺失',
  'lumen.pibEngine.s6.missingInFinal': '最终文件中缺失',
  'lumen.pibEngine.s6.goodsAdded': '新增商品',
  'lumen.pibEngine.s6.goodsRemoved': '移除商品',
  'lumen.pibEngine.s6.goodsModified': '修改商品',
  'lumen.pibEngine.s6.goodsUnchanged': '未变商品',
  'lumen.pibEngine.s6.draftPdf': '草稿PDF',
  'lumen.pibEngine.s6.finalPdf': '最终PDF',
  'lumen.pibEngine.s6.pages': '页',
  'lumen.pibEngine.s6.localTab': '本地与CEISA对比',
  'lumen.pibEngine.s6.headerTab': '头字段',
  'lumen.pibEngine.s6.goodsTab': '商品',
  'lumen.pibEngine.s6.localAlert':
    '内部校准：将本地PIB草稿值（来自表单）与CEISA为此AJU发布的PIB草稿进行比较。不匹配表明需要调整模板或本地值映射。',
  'lumen.pibEngine.s6.emptyInLocal': '本地为空',
  'lumen.pibEngine.s6.emptyInCeisa': 'CEISA为空',
  'lumen.pibEngine.s6.field': '字段',
  'lumen.pibEngine.s6.draftLokal': '本地草稿',
  'lumen.pibEngine.s6.draftCeisa': 'CEISA草稿',
  'lumen.pibEngine.s6.status': '状态',
  'lumen.pibEngine.s6.draftValue': '草稿值',
  'lumen.pibEngine.s6.finalValue': '最终值',
  'lumen.pibEngine.s6.noHeader': '无头数据',
  'lumen.pibEngine.s6.noGoods': '无商品数据。',
  'lumen.pibEngine.s6.addedText': '新增：',
  'lumen.pibEngine.s6.removedText': '移除：',
  'lumen.pibEngine.s6.modifiedText': '修改：',
  'lumen.pibEngine.s6.unchangedText': '未变：',
  'lumen.pibEngine.s6.barang': '商品',
  'lumen.pibEngine.s6.comparisonFailed': '对比失败',
  'lumen.pibEngine.s6.unknownError': '未知错误',
  'lumen.pibEngine.p2.loadingValidation': '加载并验证表单数据',
  'lumen.pibEngine.p3.initErrorTitle': '错误',
  'lumen.pibEngine.p3.initErrorMessage': '初始化表单失败',
  'lumen.pibEngine.p3.npwpErrorTitle': '实体验证失败',
  'lumen.pibEngine.p3.npwpErrorMessage': 'NPWP PPJK 无效。请先填写 NPWP PPJK。',
  'lumen.pibEngine.p3.processIdNotFoundTitle': '错误',
  'lumen.pibEngine.p3.processIdNotFoundMessage': '找不到 Process ID',
  'lumen.pibEngine.p3.downloadSuccessTitle': '成功',
  'lumen.pibEngine.p3.downloadSuccessMessage': '下载成功！',
  'lumen.pibEngine.p3.downloadFailedTitle': '错误',
  'lumen.pibEngine.p3.downloadFailedMessage': '下载失败！',
  'lumen.pibEngine.p3.downloadBarangSuccessTitle': '成功',
  'lumen.pibEngine.p3.downloadBarangSuccessMessage': '下载商品 Excel 成功！',
  'lumen.pibEngine.p3.downloadBarangFailedTitle': '错误',
  'lumen.pibEngine.p3.downloadBarangFailedMessage': '下载商品 Excel 失败！',
  'lumen.pibEngine.p3.uploadBarangSuccessTitle': '成功',
  'lumen.pibEngine.p3.uploadBarangSuccessMessage': '上传商品 Excel 成功！刷新中…',
  'lumen.pibEngine.p3.uploadBarangFailedTitle': '错误',
  'lumen.pibEngine.p3.uploadBarangFailedMessage': '上传商品 Excel 失败！',
  'lumen.pibEngine.p3.uploadSuccessTitle': '成功',
  'lumen.pibEngine.p3.uploadSuccessMessage': '上传成功！刷新表单数据…',
  'lumen.pibEngine.p3.uploadFailedTitle': '错误',
  'lumen.pibEngine.p3.uploadFailedMessage': '上传失败！',
  'lumen.pibEngine.p3.ajuCancelledMsg': '❌ 通过取消按钮取消了 AJU',
  'lumen.pibEngine.p4.noAjuTitle': '错误',
  'lumen.pibEngine.p4.noAjuMessage': 'Nomor AJU 尚不可用。请先提交 DRAFT 到 CEISA。',
  'lumen.pibEngine.p4.noProcessIdTitle': '错误',
  'lumen.pibEngine.p4.noProcessIdMessage': 'Process ID 不可用，无法计算税款',
  'lumen.pibEngine.p4.noDataPungutanTitle': '信息',
  'lumen.pibEngine.p4.noDataPungutanMessage': '无税款数据',
  'lumen.pibEngine.p4.gagalTitle': '失败',
  'lumen.pibEngine.p4.syncDoneTitle': '成功',
  'lumen.pibEngine.p4.syncDefaultMessage': 'HS 关税同步完成',
  'lumen.pibEngine.p4.canNotTransferTitle': '无法转账',
  'lumen.pibEngine.p4.validationFailedTitle': '验证失败',
  'lumen.pibEngine.p4.validationFailedMessage': '有 {n} 条错误消息。请先修复后再转账。',
  'lumen.pibEngine.p4.transferSuccessTitle': '转账成功',
  'lumen.pibEngine.p4.transferSuccessMessage': '文档已成功转移到 CEISA',
  'lumen.pibEngine.p4.transferFailedTitle': '转账失败',
  'lumen.pibEngine.p4.noDataStatusTitle': '信息',
  'lumen.pibEngine.p4.noDataStatusMessage': '无状态数据',
  'lumen.pibEngine.p4.noFormDataTitle': '错误',
  'lumen.pibEngine.p4.noFormDataMessage': '表单数据不可用',
  'lumen.pibEngine.p4.gateSuccessTitle': '成功',
  'lumen.pibEngine.p4.successMessage': '成功',
  'lumen.pibEngine.p4.gagalGeneratePungutanMessage': '生成税款失败',
  'lumen.pibEngine.p4.gagalSinkronisasiHsMessage': '同步HS关税失败',
  'lumen.pibEngine.p4.gagalMengambilStatusMessage': '获取状态失败',
  'lumen.pibEngine.p4.gagalCetakFormulirMessage': '打印表单失败',
  'lumen.pibEngine.p4.gagalShort': '失败',
  'lumen.pibEngine.p5.gateAjuTitle': '错误',
  'lumen.pibEngine.p5.gateAjuMsg': 'AJU 号不可用',
  'lumen.pibEngine.p5.nomorPolisiMsg': '车牌号必填',
  'lumen.pibEngine.p5.gateKontainerMsg': '集装箱号必填',
  'lumen.pibEngine.p5.gateSuccessTitle': '成功',
  'lumen.pibEngine.p5.gateSuccessMsg': '成功',
  'lumen.pibEngine.p5.gateFailTitle': '失败',
  'lumen.pibEngine.p5.gateFailMsg': '失败',
  'lumen.pibEngine.p5.submitBlockedTitle': '尚不能提交',
  'lumen.pibEngine.p5.validationTitle': '验证错误',
  'lumen.pibEngine.p5.validationMsg': '净重不得超过毛重',
  'lumen.pibEngine.p5.entitySaveFailTitle': '保存实体失败',
  'lumen.pibEngine.p5.entitySaveFailMsg': '同步结果数据未保存。CEISA 提交已取消',
  'lumen.pibEngine.p5.draftSuccessTitle': '成功',
  'lumen.pibEngine.p5.draftSuccessMsg': '草稿已成功更新至 CEISA',
  'lumen.pibEngine.p5.draftFailTitle': '错误',
  'lumen.pibEngine.p5.draftFailMsg': '更新至 CEISA 的草稿失败',
  'lumen.pibEngine.p5.loadingTitle': '正在加载文档数据',
  'lumen.pibEngine.p5.loadingDesc': '处理文档需要一些时间',
  'lumen.pibEngine.p6.loadingTitle': '正在加载数据',
  'lumen.pibEngine.p6.loadingSub': '处理文档可能需要一些时间',
  'lumen.pibEngine.p6.back': '返回',
  'lumen.pibEngine.p6.auditLogs': '审计日志',
  'lumen.pibEngine.p6.excelFull': 'Excel (完整)',
  'lumen.pibEngine.p6.downloadExcelFull': '下载 Excel (完整)',
  'lumen.pibEngine.p6.uploadExcelFull': '上传 Excel (完整)',
  'lumen.pibEngine.p6.excelBarang': 'Excel (仅货物)',
  'lumen.pibEngine.p6.downloadExcelBarang': '下载 Excel (仅货物)',
  'lumen.pibEngine.p6.uploadExcelBarang': '上传 Excel (仅货物)',
  'lumen.pibEngine.p6.historical': '历史记录',
  'lumen.pibEngine.p6.syncHistorical': '与历史记录同步',
  'lumen.pibEngine.p6.draftPib': 'PIB 草稿',
  'lumen.pibEngine.p6.aksi': '操作',
  'lumen.pibEngine.p6.generatePungutan': '生成税款',
  'lumen.pibEngine.p6.validasi': '验证',
  'lumen.pibEngine.p6.approval': '审批',
  'lumen.pibEngine.p6.kirimApproval': '发送审批',
  'lumen.pibEngine.p6.cetak': '打印',
  'lumen.pibEngine.p6.cetakFormulirDraft': '打印 CEISA 草稿表格',
  'lumen.pibEngine.p6.draftPibPreview': 'PIB 草稿（本地预览）',
  'lumen.pibEngine.p6.internal': '内部',
  'lumen.pibEngine.p6.kalibrasi': '校准 PIB 草稿（内部）',
  'lumen.pibEngine.p6.ceisaPortal': 'CEISA 门户',
  'lumen.pibEngine.p6.lihatCeisa': '在 Ceisa 中查看',
  'lumen.pibEngine.p6.submit': '提交',
  'lumen.pibEngine.p6.transferBilling': '转账（计费）',
  'lumen.pibEngine.p6.revisi': '修订',
  'lumen.pibEngine.p6.revisionChecklist': '修订清单',
  'lumen.pibEngine.p6.completed': '已完成',
  'lumen.pibEngine.p6.selesaikanChecklist': '提交前完成所有清单',
  'lumen.pibEngine.p6.sebelumnya': '之前',
  'lumen.pibEngine.p6.lihatPdf': '查看 PDF',
  'lumen.pibEngine.p6.tutupPdf': '关闭 PDF',
  'lumen.pibEngine.p6.editItem': '编辑项目',
  'lumen.pibEngine.p6.selanjutnya': '下一步',
  'lumen.pibEngine.p6.perhatianProporsional': '注意：检测到比例费用',
  'lumen.pibEngine.p6.lumenMendeteksi': 'Lumen 检测到',
  'lumen.pibEngine.p6.biayaPenambah': '增加费用',
  'lumen.pibEngine.p6.biayaPengurang': '减少费用',
  'lumen.pibEngine.p6.harapLakukan': '请先在 CEISA 中执行以下步骤：',
  'lumen.pibEngine.p6.setelahDua': '完成上述两个步骤后，您可以',
  'lumen.pibEngine.p6.melewatiLumen': '通过 Lumen。',
  'lumen.pibEngine.p6.sayaMengerti': '我了解了',
  'lumen.pibEngine.p6b.freight': 'Freight',
  'lumen.pibEngine.p6b.atau': '或',
  'lumen.pibEngine.p6b.asuransi': '保险',
  'lumen.pibEngine.p6b.padaDokumenIni': '本文件上。',
  'lumen.pibEngine.p6b.klik': '点击',
  'lumen.pibEngine.p6b.hitungProporsionalAsuransi': '计算保险和运费的比例',
  'lumen.pibEngine.p6b.hitungProporsionalBiaya': '计算增加和减少费用的比例',
  'lumen.pibEngine.p6b.dan': '和',
  'lumen.pibEngine.p6b.generatePungutan': '生成税款',
  'lumen.pibEngine.p6b.cetakDraftPib': '打印 PIB 草稿',
  'lumen.pibEngine.p7.kemasanGateIn': '集装箱入库',
  'lumen.pibEngine.p7.kemasanGateOut': '集装箱出库',
  'lumen.pibEngine.p7.kontainerGateIn': '集装箱入库',
  'lumen.pibEngine.p7.nomorPolisiLabel': '车牌号',
  'lumen.pibEngine.p7.nomorPolisiPlaceholder': '示例：B 1234 ABC',
  'lumen.pibEngine.p7.nomorSegelLabel': '封条号',
  'lumen.pibEngine.p7.nomorSegelPlaceholder': '封条号',
  'lumen.pibEngine.p7.nomorKontainerLabel': '集装箱编号 *',
  'lumen.pibEngine.p7.nomorKontainerPlaceholder': '示例：ABCU1234567',
  'lumen.pibEngine.p7.waktuGateLabel': '闸门时间 *',
  'lumen.pibEngine.p7.kirim': '发送',
  'lumen.pibEngine.p7.konfirmasiTitle': '确认',
  'lumen.pibEngine.p7.transferBilling': '转账（计费）',
  'lumen.pibEngine.p7.revisi': '修订',
  'lumen.pibEngine.p7.transferWarning': '您将执行转账（计费）。文件将最终提交至 CEISA 以获取账单。请确保所有数据正确。',
  'lumen.pibEngine.p7.revisiWarning': '您将修订文件。之前提交的数据将在 CEISA 中更新。',
  'lumen.pibEngine.p7.batal': '取消',
  'lumen.pibEngine.p7.lanjutkan': '是，继续',
  'lumen.pibEngine.p7.konfirmasiTransfer': '转账确认',
  'lumen.pibEngine.p7.konfirmasiTransferDesc': '文件将最终发送至 CEISA。请在继续前确保所有数据正确。',
  'lumen.pibEngine.p7.yaTransfer': '是，转账至 CEISA',
  'lumen.pibEngine.p7.dokumenBelumLengkap': '必要文件尚未完整',
  'lumen.pibEngine.p7.submitKombinasi': '提交至 CEISA 至少需要以下组合：',
  'lumen.pibEngine.p7.invoiceBl': 'INVOICE + BL（或 AWB）',
  'lumen.pibEngine.p7.belumTersedia': '尚未可用',
  'lumen.pibEngine.p7.tambahkanDokumen': '在文件标签页添加缺少的文件，然后重试提交。',
  'lumen.pibEngine.p7.mengerti': '明白',
  'lumen.pibEngine.p7.dokumenBermasalah': '有问题的文件',
  'lumen.pibEngine.p7.submitDedup': '提交已取消，因为后端将对文件列表去重（基于类型+文件号）。请先在文件标签页修复。',
  'lumen.pibEngine.p7.barisKosong': '空行（序号）',
  'lumen.pibEngine.p7.lengkapiJenisNomor': '填写文件类型和编号，或删除该行。',
  'lumen.pibEngine.p7.duplikat': '重复（类型 · 编号）',
  'lumen.pibEngine.p7.hapusBarisKembar': '删除重复行或修改其中一个编号。',
  'lumen.pibEngine.p7.statusCEISA': 'CEISA 状态',
  'lumen.pibEngine.p7.kode': '代码',
  'lumen.pibEngine.p7.waktu': '时间',
  'lumen.pibEngine.p7.nomorDaftar': '注册号',
  'lumen.pibEngine.p7.responCEISA': 'CEISA 回复',
  'lumen.pibEngine.p7.pesan': '消息',
  'lumen.pibEngine.p7.tutup': '关闭',
  'lumen.pibEngine.p7.hasilPungutan': '费用生成结果',
  'lumen.pibEngine.p7.totalPungutan': '费用总计',
  'lumen.pibEngine.p7.submittingCEISA': '正在提交至 CEISA',
  'lumen.pibEngine.p7.processingDocument': '正在处理您的文件...',
  'lumen.pibEngine.p7.progress': '进度',
  'lumen.pibEngine.p7.submissionComplete': '提交完成',
  'lumen.pibEngine.p7.submittedSuccessfully': '文件已成功提交至 CEISA',
  'lumen.pibEngine.p7.submissionFailed': '提交失败',
  'lumen.pibEngine.p7.close': '关闭',
  'lumen.pibEngine.s10.lihatDatabase': 'See database',
  'lumen.pibEngine.s10.loadingItems': 'Memuat...',
  'lumen.pibEngine.s10.searchPlaceholder': 'Search by description, HS code, brand... (press Enter to search)',
  'lumen.pibEngine.s10.originLabel': 'Origin: {name} ({code})',
  'lumen.pibEngine.s10.ajuLabel': 'Aju: {ajuNo}',
  'lumen.pibEngine.tr1.successTitle': '成功',
  'lumen.pibEngine.s21.welcome': '你好！我是你的AI助手 👋',
  'lumen.pibEngine.s21.welcomeHint': '请在上方选择上下文，然后随意提问！',
  'lumen.pibEngine.s21.placeholder': '输入消息...',
  'lumen.pibEngine.s21.thinking': 'AI正在思考...',
  'lumen.pibEngine.s21.pChecking': '🔍 正在检查所有标签页...请稍候...',
  'lumen.pibEngine.s21.pVerified': '所有标签页完整验证',
  'lumen.pibEngine.s21.pStatus': '与PDF核对状态',
  'lumen.pibEngine.s21.pResult': '结果：9/9 个标签页已验证 ✅',
  'lumen.pibEngine.s21.pMatch': '所有数据均与PDF一致',
  'lumen.pibEngine.s21.aiAssistant': 'AI助手',
  'lumen.pibEngine.s21.online': '在线',
  'lumen.pibEngine.s21.error': '抱歉，我现在无法回复，请稍后再试。',
  'lumen.pibEngine.s21.contextLabel': '📍 {label}',
  'lumen.pibEngine.s11.tambahKemasan': '添加包装',
  'lumen.pibEngine.s11.tambahPetiKemas': '添加集装箱',
  'lumen.pibEngine.s11.seri': '序号',
  'lumen.pibEngine.s11.jumlah': '数量',
  'lumen.pibEngine.s11.jenis': '类型',
  'lumen.pibEngine.s11.merek': '品牌',
  'lumen.pibEngine.s11.merk': '品牌',
  'lumen.pibEngine.s11.nomor': '编号',
  'lumen.pibEngine.s11.ukuran': '尺寸',
  'lumen.pibEngine.s11.tipe': '类型',
  'lumen.pibEngine.kb1.modalTitle': '成本组成部分信息',
  'lumen.pibEngine.kb1.keterangan': '说明',
  'lumen.pibEngine.kb1.nilaiPasti': '固定值',
  'lumen.pibEngine.kb1.nilaiPerkiraan': '估计值 (VD)',
  'lumen.pibEngine.kb1.hanyaSebenarnya': '实际或应付价格',
  'lumen.pibEngine.kb1.hargaInvoice': '1. 发票中载明的价格',
  'lumen.pibEngine.kb1.pembayaranTdkLangsung': '2. 间接付款（如减少买方/进口商应收款、贷项通知单等）',
  'lumen.pibEngine.kb1.jumlahHarga': 'A. 实际或应付价格总额 (1+2)',
  'lumen.pibEngine.kb1.biayaPengurang': 'B. 发票中{highlight}的扣减费用（折扣）',
  'lumen.pibEngine.kb1.jumlahA_DikurangiB': 'C. A 减去 B 的总额',
  'lumen.pibEngine.kb1.penambahBelumTermasuk': '发票价格中{highlight}的附加费用',
  'lumen.pibEngine.kb1.komisiPenjualan': '1. 销售佣金和中间服务费',
  'lumen.pibEngine.kb1.biayaPengemasan': '2. 包装费用',
  'lumen.pibEngine.kb1.biayaPengepakan': '3. 装箱费用',
  'lumen.pibEngine.kb1.nilaiBantuan': '4. 协助价值',
  'lumen.pibEngine.kb1.assistDesc':
    '"协助价值是买方直接或间接提供的、免费或减价的商品和服务的价值，用于进口商品的生产或销售。"',
  'lumen.pibEngine.kb1.royalti': '5. 特许权使用费和许可证费',
  'lumen.pibEngine.kb1.royaltiDesc':
    '特许权使用费是为版权、专利等支付的款项，而许可证费是为使用某项技术或品牌支付的款项。',
  'lumen.pibEngine.kb1.proceeds': '6. 收益',
  'lumen.pibEngine.kb1.proceedsDesc': '收益是指转售、释放或使用进口商品的收益部分，必须存入卖方。',
  'lumen.pibEngine.kb1.biayaTransport': '7. 运输/货运费用',
  'lumen.pibEngine.kb1.transportDesc': '运输/货运费用是将货物从装运港运至卸货港的费用，尚未包含在发票价格中。',
  'lumen.pibEngine.kb1.biayaPemuatan': '8. 尚未包含在运输费用中的装货、卸货和搬运费用',
  'lumen.pibEngine.kb1.asuransi': '9. 保险',
  'lumen.pibEngine.kb1.asuransiDesc': '选择保险类型（国内或国外），然后填写尚未包含在发票价格中的保险金额。',
  'lumen.pibEngine.kb1.garansi': '10. 保修',
  'lumen.pibEngine.kb1.jumlahPenambah': 'D. 附加费用总额（1至10项合计）',
  'lumen.pibEngine.kb1.jumlahC_DitambahD': 'E. C 加上 D 的总额',
  'lumen.pibEngine.kb1.tidakPerluDitambahkan': '无需添加但{highlight}发票价格中的费用',
  'lumen.pibEngine.kb1.kegiatanPembeli': '1. 买方为自身利益而进行的活动产生的费用',
  'lumen.pibEngine.kb1.pengimporan': '2. 货物进口后产生的费用',
  'lumen.pibEngine.kb1.pajakInternal': '3. 出口国的内部税费',
  'lumen.pibEngine.kb1.bunga': '4. 利息',
  'lumen.pibEngine.kb1.deviden': '5. 股息',
  'lumen.pibEngine.kb1.jumlahTidakDitambahkan': 'F. 未添加的费用总额（1至5项合计）',
  'lumen.pibEngine.kb1.jumlahE_DikurangiF': 'G. E 减去 F 的总额',
  'lumen.pibEngine.kb1.hapus': '删除',
  'lumen.pibEngine.kb1.simpan': '保存',
  'lumen.pibEngine.kb1.menyimpan': '正在保存...',
  'lumen.pibEngine.kb1.apakahYakin': '您确定吗？',
  'lumen.pibEngine.kb1.andAkanMenghapusAnda': '您即将删除此数据！',
  'lumen.pibEngine.kb1.tidak': '否',
  'lumen.pibEngine.kb1.ya': '是',
  'lumen.pibEngine.kb1.error': '错误',
  'lumen.pibEngine.kb1.lumenProcessIdNotFound': 'Lumen 流程 ID 未找到',
  'lumen.pibEngine.kb1.saveSuccess': '成本组成部分保存成功',
  'lumen.pibEngine.kb1.successTitle': '成功',
  'lumen.pibEngine.kb1.saveError': '保存成本组件失败',
  'lumen.pibEngine.kb1.deleteSuccess': '成本数据删除成功',
  'lumen.pibEngine.kb1.deleteError': '删除成本组件失败',
  'lumen.pibEngine.kb1.notApplicable': 'N/A',
  'lumen.pibEngine.kb1.tidakTermasuk': '未包含',
  'lumen.pibEngine.kb1.belumTermasuk': '尚未包含',
  'lumen.pibEngine.kb1.sudahTermasuk': '已包含',
  'lumen.pibEngine.kb2.incoterm': '国际贸易术语',
  'lumen.pibEngine.kb2.dalamNegeri': '国内',
  'lumen.pibEngine.kb2.luarNegeri': '国外',
  'lumen.pibEngine.sh1.successTitle': '成功',
  'lumen.pibEngine.sh1.syncSuccess': '数据同步成功。{total} 项货物中有 {matched} 项匹配成功。',
  'lumen.pibEngine.sh1.syncFailed': '同步历史数据失败',
  'lumen.pibEngine.sh1.sourcesFailed': '加载历史数据来源失败',
  'lumen.pibEngine.sh1.previewFailed': '加载数据预览失败',
  'lumen.pibEngine.sh1.forceApplied': '已从最接近的候选项应用序号 {seri}。',
  'lumen.pibEngine.sh1.forceApplyUnavailable': '后端暂未提供强制应用功能。',
  'lumen.pibEngine.sh1.forceApplyFailed': '应用候选项失败。',
  'lumen.pibEngine.sh1.labelSaved': '标签“{label}”已保存',
  'lumen.pibEngine.sh1.labelRemoved': '标签已删除',
  'lumen.pibEngine.sh1.labelSaveFailed': '保存标签失败',
  'lumen.pibEngine.sh1.stepSources': '选择历史数据来源',
  'lumen.pibEngine.sh1.stepPreview': '历史数据预览',
  'lumen.pibEngine.sh1.stepResult': '同步结果',
  'lumen.pibEngine.sh1.processIdLine': '流程 ID：{id} — {name}',
  'lumen.pibEngine.sh1.matchedSummary': '{total} 项货物中已匹配 {matched} 项',
  'lumen.pibEngine.sh2.aboutTitle': '关于此功能',
  'lumen.pibEngine.sh2.aboutBodyExport': '从相同出口商 NPWP 的既往出口单据中获取数据，以补全正在创建的单据。',
  'lumen.pibEngine.sh2.aboutBodyImport': '从相同进口商 NPWP 的既往进口单据中获取数据，以补全正在创建的单据。',
  'lumen.pibEngine.sh2.updatedTitle': '将更新的内容',
  'lumen.pibEngine.sh2.updatedBody': '实体、货物（HS 编码、品名、单位、包装、原产国）、包装、交易',
  'lumen.pibEngine.sh2.unchangedTitle': '保持不变的内容',
  'lumen.pibEngine.sh2.unchangedBody': '数量、重量、价格、运费、保险及其他数量数据',
  'lumen.pibEngine.sh2.loadingSources': '正在加载数据来源...',
  'lumen.pibEngine.sh2.loadFailed': '加载失败',
  'lumen.pibEngine.sh2.retry': '重试',
  'lumen.pibEngine.sh2.noHistory': '未找到该进口商的历史数据。',
  'lumen.pibEngine.sh2.summaryExport': '来自 {groups} 位买家的 {sources} 个来源 — 选择一个以查看预览',
  'lumen.pibEngine.sh2.summaryImport': '来自 {groups} 位发货人的 {sources} 个来源 — 选择一个以查看预览',
  'lumen.pibEngine.sh2.buyer': '买家',
  'lumen.pibEngine.sh2.shipper': '发货人',
  'lumen.pibEngine.sh2.barangCount': '{count} 项货物',
  'lumen.pibEngine.sh2.uniqueUraian': '{count} 个唯一品名',
  'lumen.pibEngine.sh2.npwpLine': 'NPWP：{npwp}',
  'lumen.pibEngine.sh2.labelPlaceholder': '输入标签...',
  'lumen.pibEngine.sh2.addLabel': '添加标签',
  'lumen.pibEngine.sh2.editLabel': '编辑标签',
  'lumen.pibEngine.sh2.mergedSources': '已合并 {count} 个来源',
  'lumen.pibEngine.sh2.previewButton': '查看预览',
  'lumen.pibEngine.sh2.loadingPreview': '正在加载数据预览...',
  'lumen.pibEngine.sh2.back': '返回',
  'lumen.pibEngine.sh2.applySync': '应用同步',
  'lumen.pibEngine.sh2.exporter': '出口商',
  'lumen.pibEngine.sh2.importer': '进口商',
  'lumen.pibEngine.sh2.recipient': '收货人',
  'lumen.pibEngine.sh2.sender': '发货人',
  'lumen.pibEngine.sh2.carrier': '承运人',
  'lumen.pibEngine.sh2.name': '名称',
  'lumen.pibEngine.sh2.npwp': 'NPWP',
  'lumen.pibEngine.sh2.address': '地址',
  'lumen.pibEngine.sh2.country': '国家',
  'lumen.pibEngine.sh2.vessel': '运输工具',
  'lumen.pibEngine.sh2.voyage': '航次/航班',
  'lumen.pibEngine.sh2.flag': '船旗',
  'lumen.pibEngine.sh2.loadPort': '装货港',
  'lumen.pibEngine.sh2.statDocuments': '单据',
  'lumen.pibEngine.sh2.statDocumentsUnit': '份单据',
  'lumen.pibEngine.sh2.statGoods': '货物',
  'lumen.pibEngine.sh2.statGoodsUnit': '序号',
  'lumen.pibEngine.sh2.statTransaction': '交易',
  'lumen.pibEngine.sh2.barangTitle': '货物（{count} 项）',
  'lumen.pibEngine.sh2.barangTitleLimited': '货物（{count} 项中最多 10 项）',
  'lumen.pibEngine.sh2.colSeri': '序号',
  'lumen.pibEngine.sh2.colHsCode': 'HS 编码',
  'lumen.pibEngine.sh2.colUraian': '品名',
  'lumen.pibEngine.sh2.colCountry': '国家',
  'lumen.pibEngine.sh2.moreItems': '... 以及另外 {count} 项货物',
  'lumen.pibEngine.sh2.syncedBanner': '已同步 {total} 项货物中的 {matched} 项',
  'lumen.pibEngine.sh2.fromSource': '来自 {name}',
  'lumen.pibEngine.sh2.ajuInfo': '（Aju {aju}）',
  'lumen.pibEngine.sh2.ajuInfoMore': '（Aju {aju}，另有 {count} 个）',
  'lumen.pibEngine.sh2.tabMatched': '已匹配',
  'lumen.pibEngine.sh2.tabNotMerged': '未合并',
  'lumen.pibEngine.sh2.noneMatched': '没有已合并的货物。',
  'lumen.pibEngine.sh2.allMerged': '所有货物均已合并。',
  'lumen.pibEngine.sh2.sourceAju': '来源 Aju',
  'lumen.pibEngine.sh2.sourceSeri': '来源序号',
  'lumen.pibEngine.sh2.sourceUraian': '来源品名',
  'lumen.pibEngine.sh2.matchTier': '匹配等级',
  'lumen.pibEngine.sh2.colUraianCurrent': '品名（当前）',
  'lumen.pibEngine.sh2.colScore': '得分',
  'lumen.pibEngine.sh2.colReason': '原因',
  'lumen.pibEngine.sh2.colClosest': '最接近的候选项',
  'lumen.pibEngine.sh2.colAction': '操作',
  'lumen.pibEngine.sh2.candidateLine': 'Aju {aju} · 序号 {seri}',
  'lumen.pibEngine.sh2.useCandidate': '使用此候选项',
  'lumen.pibEngine.sh2.editManually': '手动编辑',
  'lumen.pibEngine.sh2.closeModalTitle': '关闭弹窗',
  'lumen.pibEngine.sh2.editManuallyHint': '请在主表中手动编辑货物序号 {seri}。',
  'lumen.pibEngine.sh2.pickDifferent': '选择其他来源',
  'lumen.pibEngine.sh2.close': '关闭',
  'lumen.pibEngine.ji1.statusOk': '从文档中读取',
  'lumen.pibEngine.ji1.statusMasterOk': '已从主数据解析',
  'lumen.pibEngine.ji1.statusDefault': '模板常量',
  'lumen.pibEngine.ji1.statusShape': '不在控件的选项范围内',
  'lumen.pibEngine.ji1.statusMaster': '等待主数据',
  'lumen.pibEngine.ji1.statusCalc': '由 CEISA 计算',
  'lumen.pibEngine.ji1.statusUser': '仅限人工填写',
  'lumen.pibEngine.ji1.copied': '已复制',
  'lumen.pibEngine.ji1.copy': '复制',
  'lumen.pibEngine.ji1.sectionJsonAria': '区块 JSON',
  'lumen.pibEngine.ji1.saveToGroundTruth': '保存到基准数据',
  'lumen.pibEngine.ji1.cancel': '取消',
  'lumen.pibEngine.ji1.emptySectionHint': '留空表示该文档没有此区块。',
  'lumen.pibEngine.ji1.reviewedBy': '由 {who} 审核',
  'lumen.pibEngine.ji1.someone': '某人',
  'lumen.pibEngine.ji1.reviewedAt': '审核于 {when}',
  'lumen.pibEngine.ji1.notYetReviewed': '尚未审核',
  'lumen.pibEngine.ji1.outputFromForm': '输出来自表单（已同步 {count} 次，最近一次 {when}）',
  'lumen.pibEngine.ji1.outputDrafted': '输出为流水线起草的内容',
  'lumen.pibEngine.ji1.sectionsEditedOne': '已编辑 {count} 个区块',
  'lumen.pibEngine.ji1.sectionsEditedMany': '已编辑 {count} 个区块',
  'lumen.pibEngine.ji1.noSectionsEdited': '未编辑任何区块',
  'lumen.pibEngine.ji1.rerunSinceSeeded': '播种后已重新运行',
  'lumen.pibEngine.ji1.rerunSinceSeededTip':
    '此审核开始后，该批次又经过了一次流水线运行。流水线的记录是新的运行结果；此基准数据仍保留已审核的内容。',
  'lumen.pibEngine.ji1.resyncFromForm': '从表单重新同步',
  'lumen.pibEngine.ji1.resyncTip': '立即将表单的行读回已审核的输出。表单上的每次保存都已执行此操作。',
  'lumen.pibEngine.ji1.withdrawReview': '撤回审核',
  'lumen.pibEngine.ji1.markAsReviewed': '标记为已审核',
  'lumen.pibEngine.ji1.groundTruthIntroBefore': '已审核的九个标签页数据——与流水线写入的结构相同，位于',
  'lumen.pibEngine.ji1.groundTruthIntroAfter': '，已合并。区块部分在“文档”视图中，每个区块都可以在那里编辑。',
  'lumen.pibEngine.ji1.rowsCount': '{count} 行',
  'lumen.pibEngine.ji1.keysCount': '{count} 个键',
  'lumen.pibEngine.ji1.empty': '空',
  'lumen.pibEngine.ji1.sectionEdits': '区块编辑',
  'lumen.pibEngine.ji1.recordedCount': '已记录 {count} 条',
  'lumen.pibEngine.ji1.moreCharacters': '… 还有 {count} 个字符',
  'lumen.pibEngine.ji1.noSections':
    '此次运行没有保存任何区块。检查器出现之前的运行没有保留它们——请重新运行该批次以查看。',
  'lumen.pibEngine.ji1.noSectionList': '无区块列表',
  'lumen.pibEngine.ji1.sharedFile': '共享文件',
  'lumen.pibEngine.ji1.sharedFileTip': '另一份文档写入了同一个文件；这些区块可能属于另一份文档。',
  'lumen.pibEngine.ji1.fileOverwritten': '文件已被覆盖',
  'lumen.pibEngine.ji1.fileOverwrittenTip':
    '此 Pod 上的提取文件与各标签页实际获得的内容不一致，说明同名文档的另一次运行覆盖了它。下方标记为“另一次运行的文件”的区块不属于本次运行；标签页获得的所有内容仍属于本次运行。',
  'lumen.pibEngine.ji1.requiredEmpty': '{count} 个必填区块为空',
  'lumen.pibEngine.ji1.sectionsFound': '{found}/{total} 个区块',
  'lumen.pibEngine.ji1.readBackFailed':
    '无法读回此文档的提取文件，因此仅显示标签页实际获得的区块。其余区块在此处为空，但在运行中并非为空。',
  'lumen.pibEngine.ji1.edited': '已编辑',
  'lumen.pibEngine.ji1.reviewedEditBy': '由 {who} 审核编辑于 {when}。流水线自身的答案显示在其下方。',
  'lumen.pibEngine.ji1.offSchema': '不在架构内',
  'lumen.pibEngine.ji1.offSchemaTip': '模型给出了此文档类型的架构中未列出的区块。',
  'lumen.pibEngine.ji1.required': '必填',
  'lumen.pibEngine.ji1.multiRegion': '多区域',
  'lumen.pibEngine.ji1.anotherRunsFile': '另一次运行的文件',
  'lumen.pibEngine.ji1.anotherRunsFileTip':
    '从 Pod 的提取文件中读回，该文件此后已被另一次运行覆盖。没有标签页获得此区块，因此运行本身没有保留其他副本。',
  'lumen.pibEngine.ji1.sentToATab': '已发送到标签页',
  'lumen.pibEngine.ji1.sentToATabTip': '这是标签页实际获得的副本。',
  'lumen.pibEngine.ji1.editAgain': '再次编辑',
  'lumen.pibEngine.ji1.editForGroundTruth': '编辑为基准数据',
  'lumen.pibEngine.ji1.resetToPipelines': '重置为流水线的结果',
  'lumen.pibEngine.ji1.reviewerRecordedNone': '审核人记录此文档没有这个区块。',
  'lumen.pibEngine.ji1.nothingExtracted': '此标题下没有提取到任何内容。',
  'lumen.pibEngine.ji1.pipelinesOwnAnswer': '流水线自身的答案',
  'lumen.pibEngine.ji1.whatTheReaderSaw': '读取器看到的内容',
  'lumen.pibEngine.ji1.charactersCount': '{count} 个字符',
  'lumen.pibEngine.ji1.pagesCount': '{count} 页',
  'lumen.pibEngine.ji1.truncated': '已截断',
  'lumen.pibEngine.ji1.noPerFieldView': '此标签页没有逐字段视图。它由 PIB 覆盖层存储，而本次运行没有保留该覆盖层。',
  'lumen.pibEngine.ji1.value': '值',
  'lumen.pibEngine.ji1.ruleThePromptStates': '提示词所述的规则',
  'lumen.pibEngine.ji1.whereItComesFrom': '来源',
  'lumen.pibEngine.ji1.sentToTheModel': '已发送给模型',
  'lumen.pibEngine.ji1.notInTheSlice': '不在切片中',
  'lumen.pibEngine.ji1.neverGivenSection': '此类型的文档都没有这个区块，因此该标签页从未获得它。',
  'lumen.pibEngine.ji1.nothingSpeaksToInput': '文档中没有任何内容涉及此输入——它是常量、计算结果，或需由人工填写。',
  'lumen.pibEngine.ji2.noTabCalls': '此次运行未保存任何标签页调用。检查器出现之前的运行没有保留这些记录。',
  'lumen.pibEngine.ji2.tabsAria': '标签页调用',
  'lumen.pibEngine.ji2.nothingStoredTab': '此标签页没有存储任何内容。',
  'lumen.pibEngine.ji2.askedModel': '已询问模型',
  'lumen.pibEngine.ji2.assembledRules': '按规则组装',
  'lumen.pibEngine.ji2.callOne': '{count} 次调用',
  'lumen.pibEngine.ji2.callMany': '{count} 次调用',
  'lumen.pibEngine.ji2.documentOne': '{count} 份文档',
  'lumen.pibEngine.ji2.documentMany': '{count} 份文档',
  'lumen.pibEngine.ji2.sharePct': '占提取内容的 {pct}%',
  'lumen.pibEngine.ji2.shareTip': '此标签页实际收到了全部提取内容中的多少',
  'lumen.pibEngine.ji2.promptNotVerified': '提示词未核实',
  'lumen.pibEngine.ji2.promptNotVerifiedTip':
    '提示词是根据已存储的片段重建的,与该次运行记录的调用次数不一致。片段和答案仍然是该次运行本身的。',
  'lumen.pibEngine.ji2.inputTitle': '输入 — 此标签页收到的片段',
  'lumen.pibEngine.ji2.inputSubtitle': '{shown} / {total} 个字符',
  'lumen.pibEngine.ji2.sectionsCount': '{count} 个章节',
  'lumen.pibEngine.ji2.notSentToTab': '未发送到此标签页:{list}',
  'lumen.pibEngine.ji2.heldBackDoc':
    '因重复而保留未发:{list} — 映射确实会把这些提供给此标签页,但这一组中已有主要文档回答了同一字段。',
  'lumen.pibEngine.ji2.noDocMapped': '没有文档映射到此标签页,因此没有发出任何调用。',
  'lumen.pibEngine.ji2.notGivenAtAll': '完全未提供给此标签页:{list}',
  'lumen.pibEngine.ji2.heldBackAbsent':
    '因重复而保留未发:{list} — 映射提供给此标签页的这些文档内容都是表格,而这一组中已有主要文档回答了它们。',
  'lumen.pibEngine.ji2.promptTitle': '提示词 — 发送给模型的原文',
  'lumen.pibEngine.ji2.systemInstruction': '系统指令',
  'lumen.pibEngine.ji2.callOfTotal': '第 {n} 次调用,共 {total} 次',
  'lumen.pibEngine.ji2.promptWord': '提示词',
  'lumen.pibEngine.ji2.noPromptKept':
    '此标签页没有保留提示词 — 要么没有发出调用,要么为了不超出大小上限,捕获时丢弃了它们。',
  'lumen.pibEngine.ji2.outputTitle': '输出 — 模型的回答',
  'lumen.pibEngine.ji2.emptyWord': '空',
  'lumen.pibEngine.ji2.payloadTitle': '载荷 — 写入表单的内容',
  'lumen.pibEngine.ji2.payloadSubtitle': '经过规则和主数据查询之后',
  'lumen.pibEngine.ji2.fieldsTitle': '字段 — 此标签页每个输入一行',
  'lumen.pibEngine.ji2.pendingTitle': '待定 — 此标签页无法回答的内容',
  'lumen.pibEngine.ji2.choicesTitle': '选项 — 文档中出现不止一个正确答案的地方',
  'lumen.pibEngine.ji2.noModelCalls':
    '此次运行没有保留模型调用记录。在账本与草稿一同存储之前的运行没有保留这些记录 — 请重新运行批处理以查看。',
  'lumen.pibEngine.ji2.hostTip': '作出回答的服务器 — OpenRouter 的提供方,或 google',
  'lumen.pibEngine.ji2.slowestRetried': '最慢的{stage}:{seconds} · {attempts} 次尝试',
  'lumen.pibEngine.ji2.slowestBadge': '最慢的{stage}:{seconds}',
  'lumen.pibEngine.ji2.slowestTip':
    '最慢的{stage}调用:{subject},在 {host} 上耗时 {seconds},{attempts},{tokens} 个回答 token',
  'lumen.pibEngine.ji2.attemptOne': '{count} 次尝试',
  'lumen.pibEngine.ji2.attemptMany': '{count} 次尝试',
  'lumen.pibEngine.ji2.inOrder': '按顺序',
  'lumen.pibEngine.ji2.slowestFirst': '最慢的在前',
  'lumen.pibEngine.ji2.callsNote':
    '秒数包含各次尝试之间的等待时间。多于一次尝试意味着调用先被拒绝 — 触发了速率限制或提供方已满 — 而只有一次尝试的慢调用则是主机慢或回答过长。',
  'lumen.pibEngine.ji2.colStage': '阶段',
  'lumen.pibEngine.ji2.colSubject': '主题',
  'lumen.pibEngine.ji2.colModel': '模型',
  'lumen.pibEngine.ji2.colHost': '主机',
  'lumen.pibEngine.ji2.colSeconds': '秒数',
  'lumen.pibEngine.ji2.colAttempts': '尝试次数',
  'lumen.pibEngine.ji2.colIn': '输入',
  'lumen.pibEngine.ji2.colOut': '输出',
  'lumen.pibEngine.ji2.colCost': '费用',
  'lumen.pibEngine.ji2.colFinish': '结束原因',
  'lumen.pibEngine.ji2.rowCandidateMissed': '第 {seri} 行({code}):{reason}',
  'lumen.pibEngine.ji2.rowCandidateTaken': '第 {seri} 行({code})已在第 {line} 项上',
  'lumen.pibEngine.ji2.notShippedDetail': '没有任何货物行印有与此代码相近的内容',
  'lumen.pibEngine.ji2.noCodeDetail': '该行未印有可用来核对货物行的物品代码',
  'lumen.pibEngine.ji2.pendingDash': '待定 —',
  'lumen.pibEngine.ji2.noAttachRecord':
    '此次运行没有保留关联记录。要么它读取的内容没有可关联到货物行的 — 没有证书、许可证或检验报告 — 要么它在记录存储之前运行,重新运行批处理即可看到。',
  'lumen.pibEngine.ji2.filterPlaceholder': '按货物序号、代码或名称筛选',
  'lumen.pibEngine.ji2.allLines': '所有行',
  'lumen.pibEngine.ji2.unmatchedOnly': '仅未匹配的行',
  'lumen.pibEngine.ji2.likelyMissedOnly': '仅可能遗漏的',
  'lumen.pibEngine.ji2.attachNote':
    '文档印出的每一条货物行,连同其关联的货物行以及决定关联的判定依据。先在整份文档范围内比对物品代码;然后是相同数量、名称、行号。没有对应行的条目保持待定,并说明这样是否合理:当没有货物行印有相近代码,或印有相近代码的行已各自有归属时,属于合理;当带有相近代码的行 — 前导零、嵌在更长代码中的代码、被文档截断的代码 — 仍然空闲时,则可能是遗漏。依据该次运行自身的文档重放,而非重新读取。',
  'lumen.pibEngine.ji2.replayMismatch':
    '重放关联所得到的链接与该次运行存储的不完全一致,因此下面的原因未必就是实际决定关联的原因。',
  'lumen.pibEngine.ji2.dokumenSerials': ' · 文档 #{list}',
  'lumen.pibEngine.ji2.rowsLines': '{rows} 行 · {lines} 项',
  'lumen.pibEngine.ji2.unmatchedCount': '{count} 项未匹配',
  'lumen.pibEngine.ji2.likelyMissedCount': '{count} 项可能遗漏',
  'lumen.pibEngine.ji2.attachedNothing': '未关联任何内容:{reason}',
  'lumen.pibEngine.ji2.colLine': '项',
  'lumen.pibEngine.ji2.colCode': '代码',
  'lumen.pibEngine.ji2.colNaming': '文档中的名称',
  'lumen.pibEngine.ji2.colQty': '数量',
  'lumen.pibEngine.ji2.colSeri': '序号',
  'lumen.pibEngine.ji2.colBarang': '货物',
  'lumen.pibEngine.ji2.colSettledBy': '判定依据',
  'lumen.pibEngine.ji2.colWhatHeld': '成立依据',
  'lumen.pibEngine.ji2.noLineMatches': '没有符合此筛选条件的行。',
  'lumen.pibEngine.ji2.panelTitle': 'Lumen 2.0 — 流水线读取了什么',
  'lumen.pibEngine.ji2.documentsCount': '{count} 份文档',
  'lumen.pibEngine.ji2.fetching': '正在获取该次运行读取的内容 — 这与提取内容的大小相当。',
  'lumen.pibEngine.ji2.fetchFailed': '无法获取草稿。它可能是在检查器出现之前运行的,或者服务无法访问。',
  'lumen.pibEngine.ji2.viewsAria': '检查器视图',
  'lumen.pibEngine.ji2.viewDocuments': '文档 ({count})',
  'lumen.pibEngine.ji2.viewTabs': '标签页 ({count})',
  'lumen.pibEngine.ji2.viewCalls': '模型调用 ({count})',
  'lumen.pibEngine.ji2.viewAttach': '关联 ({count})',
  'lumen.pibEngine.ji2.viewTruth': '基准真值',
  'lumen.pibEngine.mtb.seriIzinTitle': 'Series permit',
  'lumen.pibEngine.mtb.seriIzinSubtitle': 'Item number within one permit document',
  'lumen.pibEngine.mtb.dokumenIzin': 'Permit document',
  'lumen.pibEngine.mtb.noDocumentPlaceholder': 'No documents in this draft',
  'lumen.pibEngine.mtb.documentPlaceholder': 'Pick a permit document...',
  'lumen.pibEngine.mtb.documentHint':
    'Permit series attaches to item & document pairs, so a destination document must be selected. Items not yet linked to this document will be automatically attached.',
  'lumen.pibEngine.mtb.fillMethod': 'Filling method',
  'lumen.pibEngine.mtb.serialList': 'List of Item Series & Permit Series',
  'lumen.pibEngine.mtb.serialHintA': 'One pair per row —',
  'lumen.pibEngine.mtb.serialHintCode': 'item series : permit series',
  'lumen.pibEngine.mtb.serialHintB':
    '. Can be pasted directly from Excel; separators: comma, colon, equals, space, or tab.',
  'lumen.pibEngine.mtb.startFrom': 'Start from',
  'lumen.pibEngine.mtb.serialValue': 'Permit series value',
  'lumen.pibEngine.mtb.startHint': 'Number increments one by one following the item series order.',
  'lumen.pibEngine.mtb.sameValueHint': 'The same number applies to all item series in this row.',
  'lumen.pibEngine.mtb.previewLabel': 'Numbering preview',
  'lumen.pibEngine.mtb.barang': 'items',
  'lumen.pibEngine.mtb.notYet': 'not yet',
  'lumen.pibEngine.mtb.pasteHint': 'Paste the list of item series and permit series pairs above.',
  'lumen.pibEngine.mtb.fillHint': 'Enter Item Series and a start number to see the numbering result.',
  'lumen.pibEngine.mtb.others': 'other(s)',
  'lumen.pibEngine.mtb.outsideRange':
    'item series outside this row\'s "Item Series" range — still applied, but skip if unintentional.',
  'lumen.pibEngine.hcc.title': 'HS 代码关税数据',
  'lumen.pibEngine.hcc.hsCodes': 'HS 代码',
  'lumen.pibEngine.hcc.items': '项目',
  'lumen.pibEngine.hcc.loading': '正在加载关税数据...',
  'lumen.pibEngine.hcc.noData': '无数据可显示',
  'lumen.pibEngine.hcc.group': '组',
  'lumen.pibEngine.hcc.hsCode': 'HS 代码',
  'lumen.pibEngine.hcc.dokumen': '文档',
  'lumen.pibEngine.hcc.ppn': 'PPN (%)',
  'lumen.pibEngine.hcc.pph': 'PPH (%)',
  'lumen.pibEngine.hcc.bm': 'BM (%)',
  'lumen.pibEngine.hcc.count': '数量',
  'lumen.pibEngine.hcc.seriBarang': '商品编号',
  'lumen.pibEngine.hcc.lartas': 'Lartas',
  'lumen.pibEngine.hcc.sync': '同步',
  'lumen.pibEngine.s19.modul': '模块：{modul}',
  'lumen.pibEngine.s19.na': '不适用',
  'lumen.pibEngine.s19.wajibLaporDheSda': '须申报 DHE-SDA',
  'lumen.pibEngine.s19.tidak': '否',
  'lumen.pibEngine.s19.note': '备注',
  'lumen.pibEngine.s12.selectDocumentError': '请选择文档',
  'lumen.pibEngine.s12.dokumenFasilitasLartas': '设施 / 禁限文件',
  'lumen.pibEngine.s12.dokumen': '文档',
  'lumen.pibEngine.s12.pilihDokumen': '选择文档',
  'lumen.pibEngine.s12.izin': '许可',
  'lumen.pibEngine.s12.masukkanIzin': '输入许可',
  'lumen.pibEngine.s12.dokumenLampiran': '附件文档',
  'lumen.pibEngine.s12.modalIsOpen': '弹窗已打开：{open}',
  'lumen.pibEngine.s12.seri': '序号',
  'lumen.pibEngine.s12.jenisDokumen': '文档类型',
  'lumen.pibEngine.s12.pilihJenisDokumen': '选择文档类型',
  'lumen.pibEngine.s12.nomor': '编号',
  'lumen.pibEngine.s12.tanggal': '日期',
  'lumen.pibEngine.s12.pilihTanggal': '选择日期',
  'lumen.pibEngine.s12.kodeIjin': '许可代码',
  'lumen.pibEngine.s12.pilihKodeIjin': '选择许可代码',
  'lumen.pibEngine.s12.tidakDitemukan': '未找到',
  'lumen.pibEngine.s12.fasilitasDokumen': '文档设施',
  'lumen.pibEngine.s12.pilihFasilitasDokumen': '选择文档设施',
  'lumen.pibEngine.s12.statusDokumen': '文档状态',
  'lumen.pibEngine.s12.cancel': '取消',
  'lumen.pibEngine.rv1.draftPibTitle': 'PIB 草稿',
  'lumen.pibEngine.rv2.syncInfoTitle': '提示',
  'lumen.pibEngine.rv2.revisionProgressAria': '修订清单进度',
  'lumen.pibEngine.mtd.row': '行',
  'lumen.pibEngine.mtd.removeRow': '删除行',
  'lumen.pibEngine.mtd.identityTitle': '货物标识',
  'lumen.pibEngine.mtd.identitySubtitle': '目标行及HS分类',
  'lumen.pibEngine.mtd.seriBarang': '货物序号',
  'lumen.pibEngine.mtd.seriBarangHint': '要更新的行号。可使用逗号或连字符 — 例如',
  'lumen.pibEngine.mtd.hsCode': 'HS编码',
  'lumen.pibEngine.mtd.hsCodeHint': '货物的协调制度（HS）分类编码。',
  'lumen.pibEngine.mtd.hsCodePlaceholder': '选择HS编码…',
  'lumen.pibEngine.mtd.uraian': '货物描述',
  'lumen.pibEngine.mtd.uraianHint': '与单据（发票/装箱单）一致的完整货物描述。',
  'lumen.pibEngine.mtd.uraianPlaceholder': '例如：6.7英寸屏幕智能手机，256GB',
  'lumen.pibEngine.mtd.kodeBarang': '货物编码',
  'lumen.pibEngine.mtd.kodeBarangPlaceholder': 'SKU / 内部编码（可选）',
  'lumen.pibEngine.mtd.merkTitle': '品牌与规格',
  'lumen.pibEngine.mtd.merkSubtitle': '若货物无品牌/型号，请标记“无”',
  'lumen.pibEngine.mtd.merek': '品牌',
  'lumen.pibEngine.mtd.noBrand': '无品牌',
  'lumen.pibEngine.mtd.brandPlaceholder': '品牌名称',
  'lumen.pibEngine.mtd.noBrandFlag': '无品牌',
  'lumen.pibEngine.mtd.tipe': '型号',
  'lumen.pibEngine.mtd.noType': '无型号',
  'lumen.pibEngine.mtd.typePlaceholder': '型号名称',
  'lumen.pibEngine.mtd.noTypeFlag': '无型号',
  'lumen.pibEngine.mtd.ukuran': '尺寸',
  'lumen.pibEngine.mtd.ukuranHint': '如有相关，请填写尺寸/规格。',
  'lumen.pibEngine.mtd.ukuranPlaceholder': '例如：XL / 42',
  'lumen.pibEngine.mtd.originTitle': '原产地、单位与包装',
  'lumen.pibEngine.mtd.originSubtitle': '物流数据及货物重量',
  'lumen.pibEngine.mtd.negaraAsal': '原产国',
  'lumen.pibEngine.mtd.negaraAsalHint': '货物生产所在国家。',
  'lumen.pibEngine.mtd.countryPlaceholder': '选择国家…',
  'lumen.pibEngine.mtd.kodeSatuan': '单位代码',
  'lumen.pibEngine.mtd.kodeSatuanHint': '货物数量单位。',
  'lumen.pibEngine.mtd.unitPlaceholder': '选择单位…',
  'lumen.pibEngine.mtd.kodeKemasan': '包装代码',
  'lumen.pibEngine.mtd.kodeKemasanHint': '运输包装类型。',
  'lumen.pibEngine.mtd.packagingPlaceholder': '选择包装…',
  'lumen.pibEngine.mtd.nettLabel': '净重（KGM）',
  'lumen.pibEngine.mtd.nettHint': '每单位净重（千克）。',
  'lumen.pibEngine.mtd.taxTitle': '税费与优惠',
  'lumen.pibEngine.mtd.taxSubtitle': '货物税率及海关优惠',
  'lumen.pibEngine.mtd.fasBM': 'BM优惠',
  'lumen.pibEngine.mtd.taxNameBM': '进口关税',
  'lumen.pibEngine.mtd.fasPPN': 'PPN优惠',
  'lumen.pibEngine.mtd.taxNamePPN': '增值税',
  'lumen.pibEngine.mtd.fasPPh': 'PPh优惠',
  'lumen.pibEngine.mtd.taxNamePPh': '所得税',
  'lumen.pibEngine.mtd.facilityPlaceholder': '选择优惠...',
  'lumen.pibEngine.mtd.pastedList': '粘贴列表',
  'lumen.pibEngine.mtd.notSet': '尚未确定',
  'lumen.pibEngine.mtd.noHsSelected': '尚未选择HS编码',
  'lumen.pibEngine.mtd.noDescription': '尚无货物描述。',
  'lumen.pibEngine.mtd.none': '无',
  'lumen.pibEngine.mtd.dialogEyebrow': '进口货物详情',
  'lumen.pibEngine.mtd.dialogTitle': '设置货物品牌、型号、尺寸及HS编码',
  'lumen.pibEngine.mtd.dialogIntro': '仅填写需要更新的字段 — 留空的字段不会更改所选行的数据。',
  'lumen.pibEngine.mtd.close': '关闭',
  'lumen.pibEngine.mtd.summaryTitle': '行摘要',
  'lumen.pibEngine.mtd.summaryIntro': '即将保存数据的实时预览。',
  'lumen.pibEngine.mtd.requiredFields': '必填字段',
  'lumen.pibEngine.mtd.appliedToSeri': '应用于序号：',
  'lumen.pibEngine.mtd.summaryNegara': '原产国',
  'lumen.pibEngine.mtd.summarySatuan': '单位',
  'lumen.pibEngine.mtd.summaryKemasan': '包装',
  'lumen.pibEngine.mtd.summaryNett': '净重',
  'lumen.pibEngine.mtd.summaryTax': '税费',
  'lumen.pibEngine.mtd.summarySeriIzin': '许可序号',
  'lumen.pibEngine.mtd.numbered': '件货物已编号',
  'lumen.pibEngine.mtd.noPermitDoc': '尚未选择许可文件 — 许可序号不变。',
  'lumen.pibEngine.mtd.footerA': '更改将应用于序号',
  'lumen.pibEngine.mtd.footerB': '许可序号将写入',
  'lumen.pibEngine.mtd.footerC': '共',
  'lumen.pibEngine.mtd.footerD': '件货物。',
  'lumen.pibEngine.mtd.cancel': '取消',
  'lumen.pibEngine.mtd.addRow': '添加行',
  'lumen.pibEngine.mtd.apply': '应用',
  'lumen.pibEngine.rv5.rowN': '行 {n}',
  'lumen.pibEngine.rv5.numberedN': '{n} 件货物已编号',
  'lumen.pibEngine.rv5.statusMatch': '匹配',
  'lumen.pibEngine.rv5.statusMismatch': '不匹配',
  'lumen.pibEngine.rv5.mandatory': '必填',
  'lumen.pibEngine.rv5.fetchError': '获取对比数据失败',
  'lumen.pibEngine.rv5.dupSeri': 'Seri',
  'lumen.pibEngine.rv5.dupDokumen': '文件',
  'lumen.pibEngine.rv5.dupSeriDok': '序号',
  'lumen.pibEngine.rv5.jenisN': '{n} 种',
  'lumen.pibEngine.rv5.kgN': '{n} 千克',
  // lumen.otherDocs (revamp PR 8a)
  'lumen.otherDocs.ck1.statusDraft': '草稿',
  'lumen.otherDocs.ck1.statusFinal': '最终',
  'lumen.otherDocs.ck1.statusCkGenerated': 'CK 已生成',
  'lumen.otherDocs.ck1.statusCancelled': '已取消',
  'lumen.otherDocs.ck1.statusGenerated': 'CK 草稿',
  'lumen.otherDocs.ck1.statusSubmitted': '已发送',
  'lumen.otherDocs.ck1.statusAccepted': '已接受',
  'lumen.otherDocs.ck1.statusRejected': '已拒绝',
  'lumen.otherDocs.ck1.statusError': '失败',
  'lumen.otherDocs.ck1.docCk1Desc': '消费税标签订购',
  'lumen.otherDocs.ck1.docCk4Desc': '应税货物生产报告',
  'lumen.otherDocs.ck1.docCk5Desc': '应税货物调拨',
  'lumen.otherDocs.ck1.itemBahanBaku': '原材料',
  'lumen.otherDocs.ck1.itemBarangJadi': '成品',
  'lumen.otherDocs.ck1.itemPitaCukai': '消费税标签',
  'lumen.otherDocs.ck1.addItem': '添加货物',
  'lumen.otherDocs.ck1.allStatus': '全部状态',
  'lumen.otherDocs.ck1.caraKredit': '赊账',
  'lumen.otherDocs.ck1.caraTunai': '现金',
  'lumen.otherDocs.ck1.cellRows': '{n} 行',
  'lumen.otherDocs.ck1.colAksi': '操作',
  'lumen.otherDocs.ck1.colAngkutan': '运输',
  'lumen.otherDocs.ck1.colBarang': '货物',
  'lumen.otherDocs.ck1.colPengirimPenerima': '发货人 → 收货人',
  'lumen.otherDocs.ck1.colStatus': '状态',
  'lumen.otherDocs.ck1.colSuratJalan': '送货单',
  'lumen.otherDocs.ck1.createButton': '创建送货单',
  'lumen.otherDocs.ck1.delBodyAfter': '？已生成的 CK 文件不会被删除。',
  'lumen.otherDocs.ck1.delBodyBefore': '确定要删除',
  'lumen.otherDocs.ck1.deleteItemAria': '删除货物 #{n}',
  'lumen.otherDocs.ck1.delTitle': '删除送货单',
  'lumen.otherDocs.ck1.emptyDesc': '创建您的第一张送货单，然后据此开具 CK-1 / CK-4 / CK-5。',
  'lumen.otherDocs.ck1.emptyTitle': '暂无送货单',
  'lumen.otherDocs.ck1.existingDocs': '已根据此送货单生成的文件',
  'lumen.otherDocs.ck1.fAlamatPenerima': '收货人地址',
  'lumen.otherDocs.ck1.fAlamatPengirim': '发货人地址',
  'lumen.otherDocs.ck1.fHje': 'HJE / 包装',
  'lumen.otherDocs.ck1.fIsiPerKemasan': '每包装含量',
  'lumen.otherDocs.ck1.fJenisBkc': '应税货物类型',
  'lumen.otherDocs.ck1.fJenisKemasan': '包装类型',
  'lumen.otherDocs.ck1.fJenisKemasanPlaceholder': '包 / 纸箱',
  'lumen.otherDocs.ck1.fJumlah': '数量',
  'lumen.otherDocs.ck1.fJumlahKemasan': '包装数量',
  'lumen.otherDocs.ck1.fKadarAlkohol': '酒精含量 %',
  'lumen.otherDocs.ck1.fKeterangan': '备注',
  'lumen.otherDocs.ck1.fKodeBarang': '货物代码',
  'lumen.otherDocs.ck1.fKodeKantorAsal': '起运海关办公室代码 (KPPBC)',
  'lumen.otherDocs.ck1.fKodeKantorTujuan': '目的地办公室代码',
  'lumen.otherDocs.ck1.fMerk': '品牌',
  'lumen.otherDocs.ck1.fModa': '运输方式',
  'lumen.otherDocs.ck1.fNamaPenerima': '收货人名称',
  'lumen.otherDocs.ck1.fNamaPengangkut': '承运人名称',
  'lumen.otherDocs.ck1.fNamaPengirim': '发货人名称',
  'lumen.otherDocs.ck1.fNomorPolisi': '车牌号',
  'lumen.otherDocs.ck1.fNomorSuratJalan': '送货单号',
  'lumen.otherDocs.ck1.fNppbkcPenerima': '收货人 NPPBKC',
  'lumen.otherDocs.ck1.fNppbkcPengirim': '发货人 NPPBKC',
  'lumen.otherDocs.ck1.fNpwpPenerima': '收货人 NPWP',
  'lumen.otherDocs.ck1.fNpwpPengirim': '发货人 NPWP',
  'lumen.otherDocs.ck1.formTitleCreate': '创建送货单',
  'lumen.otherDocs.ck1.formTitleEdit': '编辑送货单 — {nomor}',
  'lumen.otherDocs.ck1.fPengemudi': '司机',
  'lumen.otherDocs.ck1.fPerkiraanTiba': '预计到达',
  'lumen.otherDocs.ck1.fromSuratJalan': '来自送货单',
  'lumen.otherDocs.ck1.fSatuan': '单位',
  'lumen.otherDocs.ck1.fStatus': '状态',
  'lumen.otherDocs.ck1.fTanggal': '日期',
  'lumen.otherDocs.ck1.fTarifCukai': '消费税税率 / 单位',
  'lumen.otherDocs.ck1.fTglBerangkat': '出发日期',
  'lumen.otherDocs.ck1.fUraianBarang': '货物描述',
  'lumen.otherDocs.ck1.gCaraBayar': '付款方式',
  'lumen.otherDocs.ck1.genAlertBody':
    '发货人、收货人、运输及 {n} 项货物信息将自动从此送货单填入。草稿在提交海关之前仍可编辑。',
  'lumen.otherDocs.ck1.genSubmit': '创建 {docType} 草稿',
  'lumen.otherDocs.ck1.genTitle': '根据 {nomor} 创建 {docType}',
  'lumen.otherDocs.ck1.gKodeKantor': '办公室代码 (KPPBC)',
  'lumen.otherDocs.ck1.gNppbkc': 'NPPBKC',
  'lumen.otherDocs.ck1.gPeriodeAkhir': '生产期间结束',
  'lumen.otherDocs.ck1.gPeriodeAwal': '生产期间开始',
  'lumen.otherDocs.ck1.gStatusPelunasan': '消费税缴纳状态',
  'lumen.otherDocs.ck1.gTujuanPengiriman': '运送目的',
  'lumen.otherDocs.ck1.itemHeader': '货物 #{n}',
  'lumen.otherDocs.ck1.menuCk1': 'CK-1 · 消费税标签订购',
  'lumen.otherDocs.ck1.menuCk4': 'CK-4 · 生产报告',
  'lumen.otherDocs.ck1.menuCk5': 'CK-5 · 应税货物调拨',
  'lumen.otherDocs.ck1.menuCkLabel': '根据送货单创建文件',
  'lumen.otherDocs.ck1.menuDelete': '删除',
  'lumen.otherDocs.ck1.menuEdit': '编辑',
  'lumen.otherDocs.ck1.pilih': '选择',
  'lumen.otherDocs.ck1.rowMenu': '更多操作',
  'lumen.otherDocs.ck1.saveCreate': '保存送货单',
  'lumen.otherDocs.ck1.saveEdit': '保存更改',
  'lumen.otherDocs.ck1.searchPlaceholder': '搜索单号、发货人、收货人、车牌...',
  'lumen.otherDocs.ck1.secBarang': '应税货物',
  'lumen.otherDocs.ck1.secPenerima': '收货人',
  'lumen.otherDocs.ck1.secPengangkutan': '运输',
  'lumen.otherDocs.ck1.secPengirim': '发货人（工厂 / 仓库）',
  'lumen.otherDocs.ck1.sjCreatedMsg': '送货单已创建。',
  'lumen.otherDocs.ck1.sjDeletedMsg': '送货单已删除。',
  'lumen.otherDocs.ck1.sjDeletedTitle': '已删除',
  'lumen.otherDocs.ck1.sjDeleteFailedTitle': '删除失败',
  'lumen.otherDocs.ck1.sjGeneratedMsg': '已根据 {nomor} 创建 {desc} 草稿。',
  'lumen.otherDocs.ck1.sjGeneratedTitle': '{docType} 已创建',
  'lumen.otherDocs.ck1.sjGenerateFailedTitle': '创建 CK 失败',
  'lumen.otherDocs.ck1.sjIncompleteMsg': '必须填写送货单号、发货人 NPWP 和名称以及收货人名称。',
  'lumen.otherDocs.ck1.sjIncompleteTitle': '数据不完整',
  'lumen.otherDocs.ck1.sjNoItemsMsg': '至少需要填写一项带描述和数量的货物。',
  'lumen.otherDocs.ck1.sjNoItemsTitle': '没有货物',
  'lumen.otherDocs.ck1.sjPostStockFailedTitle': '库存过账失败',
  'lumen.otherDocs.ck1.sjSavedTitle': '已保存',
  'lumen.otherDocs.ck1.sjSaveFailedTitle': '保存失败',
  'lumen.otherDocs.ck1.sjSkippedInfo': '（已跳过 {n} 行 — 尚未关联库存项目）',
  'lumen.otherDocs.ck1.sjStockPostedMsg': '已为 {nomor} 记录 {n} 笔库存变动{skipped}。',
  'lumen.otherDocs.ck1.sjStockPostedTitle': '出库已过账',
  'lumen.otherDocs.ck1.sjUpdatedMsg': '送货单已更新。',
  'lumen.otherDocs.ck1.statGenerated': '已生成 CK',
  'lumen.otherDocs.ck1.statTotal': '送货单总数',
  'lumen.otherDocs.ck1.subtitle': '消费税源文件 — 可据送货单创建 CK-1、CK-4 和 CK-5',
  'lumen.otherDocs.ck1.tipCreateCk': '创建 CK 文件',
  'lumen.otherDocs.ck1.tipPostStock': '出库过账',
  'lumen.otherDocs.ck1.title': '送货单',
  'lumen.otherDocs.ck3.title': '物料清单 (BOM)',
  'lumen.otherDocs.ck3.subtitle': '每个应税产品的生产配方，CK-4 用它计算原材料用量',
  'lumen.otherDocs.ck3.createBom': '创建 BOM',
  'lumen.otherDocs.ck3.searchPlaceholder': '搜索产品代码、名称、品牌...',
  'lumen.otherDocs.ck3.colProduk': '产品',
  'lumen.otherDocs.ck3.colJenisBkc': '应税类型',
  'lumen.otherDocs.ck3.colOutput': '每批产量',
  'lumen.otherDocs.ck3.colKomposisi': '配料',
  'lumen.otherDocs.ck3.colItemHasil': '产出库存项',
  'lumen.otherDocs.ck3.colAksi': '操作',
  'lumen.otherDocs.ck3.merkPrefix': '品牌 ',
  'lumen.otherDocs.ck3.notLinked': '未关联',
  'lumen.otherDocs.ck3.notLinkedHint': '请关联成品项，以便 CK-4 生产库存过账',
  'lumen.otherDocs.ck3.edit': '编辑',
  'lumen.otherDocs.ck3.hapus': '删除',
  'lumen.otherDocs.ck3.emptyTitle': '暂无 BOM',
  'lumen.otherDocs.ck3.emptyBody': '请定义生产配方，CK-4 即可自动计算原材料用量。',
  'lumen.otherDocs.ck3.createTitle': '创建物料清单',
  'lumen.otherDocs.ck3.editTitlePrefix': '编辑 BOM — ',
  'lumen.otherDocs.ck3.kodeProduk': '产品代码',
  'lumen.otherDocs.ck3.namaProduk': '产品名称',
  'lumen.otherDocs.ck3.merk': '品牌',
  'lumen.otherDocs.ck3.jenisBkc': '应税类型',
  'lumen.otherDocs.ck3.jumlahOutput': '每批产出数量',
  'lumen.otherDocs.ck3.satuanOutput': '产出单位',
  'lumen.otherDocs.ck3.outputItem': '成品库存项（生产产出）',
  'lumen.otherDocs.ck3.outputItemHint': 'CK-4 生产库存过账必填：成品将入此项',
  'lumen.otherDocs.ck3.outputItemPlaceholder': '选择成品项',
  'lumen.otherDocs.ck3.outputItemNone': '库存中暂无 BARANG_JADI 项',
  'lumen.otherDocs.ck3.clearSelection': '清除选择',
  'lumen.otherDocs.ck3.compositionHeading': '原材料配比（每 {n} {satuan}）',
  'lumen.otherDocs.ck3.kodeBahan': '材料代码',
  'lumen.otherDocs.ck3.namaBahan': '材料名称',
  'lumen.otherDocs.ck3.jumlah': '数量',
  'lumen.otherDocs.ck3.satuan': '单位',
  'lumen.otherDocs.ck3.itemStok': '库存项',
  'lumen.otherDocs.ck3.itemStokPlaceholder': '关联原材料',
  'lumen.otherDocs.ck3.deleteRowAria': '删除配料行',
  'lumen.otherDocs.ck3.addIngredient': '添加材料',
  'lumen.otherDocs.ck3.keterangan': '备注',
  'lumen.otherDocs.ck3.saveChanges': '保存更改',
  'lumen.otherDocs.ck3.saveBom': '保存 BOM',
  'lumen.otherDocs.ck3.deleteTitle': '删除 BOM',
  'lumen.otherDocs.ck3.deleteConfirmPre': '确定要删除 BOM ',
  'lumen.otherDocs.ck3.deleteConfirmPost': '？',
  'lumen.otherDocs.ck3.incompleteTitle': '数据不完整',
  'lumen.otherDocs.ck3.incompleteMessage': '产品代码、产品名称和产出数量为必填项。',
  'lumen.otherDocs.ck3.emptyCompositionTitle': '配比为空',
  'lumen.otherDocs.ck3.emptyCompositionMessage': '至少需填写一项含名称和数量的材料。',
  'lumen.otherDocs.ck3.savedTitle': '已保存',
  'lumen.otherDocs.ck3.updated': 'BOM 已更新。',
  'lumen.otherDocs.ck3.created': 'BOM 已创建。',
  'lumen.otherDocs.ck3.saveFailed': '保存失败',
  'lumen.otherDocs.ck3.deletedTitle': '已删除',
  'lumen.otherDocs.ck3.deleted': 'BOM 已删除。',
  'lumen.otherDocs.ck3.deleteFailed': '删除失败',
  'lumen.otherDocs.ck3.pageTitle': '风险自检',
  'lumen.otherDocs.ck3.pageSubtitle': '企业版消费税风险指标——对应海关 SPT-BKC 监管，让问题在检查前即可发现',
  'lumen.otherDocs.ck3.periodeAwal': '起始日期',
  'lumen.otherDocs.ck3.periodeAkhir': '结束日期',
  'lumen.otherDocs.ck3.until': '至',
  'lumen.otherDocs.ck3.recalculate': '重新计算',
  'lumen.otherDocs.ck3.calculating': '正在计算风险指标...',
  'lumen.otherDocs.ck3.loadFailed': '加载自检失败',
  'lumen.otherDocs.ck3.riskScore': '风险评分 0 – 1',
  'lumen.otherDocs.ck3.scoreHint': '评分基于海关监控的同一组指标 (SPT-BKC) 计算',
  'lumen.otherDocs.ck3.bucketSangatRendah': '很低',
  'lumen.otherDocs.ck3.bucketRendah': '低',
  'lumen.otherDocs.ck3.bucketSedang': '中',
  'lumen.otherDocs.ck3.bucketTinggi': '高',
  'lumen.otherDocs.ck3.bucketSangatTinggi': '很高',
  'lumen.otherDocs.ck3.statusOk': '安全',
  'lumen.otherDocs.ck3.statusWarning': '注意',
  'lumen.otherDocs.ck3.statusCritical': '严重',
  'lumen.otherDocs.ck3.weight': '权重 {n}%',
  'lumen.otherDocs.ck3.periodSummary': '期间摘要',
  'lumen.otherDocs.ck3.periodRange': '{awal} 至 {akhir}',
  'lumen.otherDocs.ck3.criticalIndicators': '严重指标',
  'lumen.otherDocs.ck3.needAttention': '需关注',
  'lumen.otherDocs.ck3.safe': '安全',
  'lumen.otherDocs.ck3.calculatedOn': '于 {date} 根据您的 CK-1、CK-4、CK-5、BOM 和库存卡数据计算。',
  'lumen.otherDocs.ck2.actCreate': '已创建',
  'lumen.otherDocs.ck2.actEdit': '已修改',
  'lumen.otherDocs.ck2.actSubmit': '已发送',
  'lumen.otherDocs.ck2.actStatusPull': '拉取状态',
  'lumen.otherDocs.ck2.actDelete': '已删除',
  'lumen.otherDocs.ck2.allStatus': '全部状态',
  'lumen.otherDocs.ck2.angkutFmt': '{moda} · {nopol}',
  'lumen.otherDocs.ck2.arrowFmt': '{asal} → {tujuan}',
  'lumen.otherDocs.ck2.btnHistory': '历史',
  'lumen.otherDocs.ck2.btnPull': '拉取状态',
  'lumen.otherDocs.ck2.btnSend': '发送至海关',
  'lumen.otherDocs.ck2.byUser': '· 操作人 用户 #{id}',
  'lumen.otherDocs.ck2.colAksi': '操作',
  'lumen.otherDocs.ck2.colDikirim': '发送时间',
  'lumen.otherDocs.ck2.colDokumen': '文件',
  'lumen.otherDocs.ck2.colNomorAju': '申报编号',
  'lumen.otherDocs.ck2.colNppbkc': 'NPPBKC / 办公室',
  'lumen.otherDocs.ck2.colStatus': '状态',
  'lumen.otherDocs.ck2.copyAria': '复制申报编号',
  'lumen.otherDocs.ck2.delAju': '({nomorAju})',
  'lumen.otherDocs.ck2.delBodyBefore': '确定要删除草稿',
  'lumen.otherDocs.ck2.delBodyEnd': '？',
  'lumen.otherDocs.ck2.delConfirm': '删除',
  'lumen.otherDocs.ck2.delTitle': '删除文件',
  'lumen.otherDocs.ck2.emptyDesc': '打开送货单菜单，在某张送货单上选择“生成 CK 文件”。',
  'lumen.otherDocs.ck2.emptyTitle': '暂无消费税文件',
  'lumen.otherDocs.ck2.historyDesc': '文件每次状态变更的审计记录（谁、何时、从 → 到），不可修改。',
  'lumen.otherDocs.ck2.historyEmpty': '该文件暂无历史记录。',
  'lumen.otherDocs.ck2.historyTitle': '{docType} 历史',
  'lumen.otherDocs.ck2.historyTitleFallback': '历史',
  'lumen.otherDocs.ck2.kirimSekarang': '立即发送',
  'lumen.otherDocs.ck2.lblAngkutan': '运输',
  'lumen.otherDocs.ck2.lblBerangkatTiba': '出发 / 到达',
  'lumen.otherDocs.ck2.lblCaraBayar': '付款方式',
  'lumen.otherDocs.ck2.lblDikirim': '发送时间',
  'lumen.otherDocs.ck2.lblIdHeader': '表头 ID',
  'lumen.otherDocs.ck2.lblJenisBkc': 'BKC 类型',
  'lumen.otherDocs.ck2.lblKantor': '办公室代码',
  'lumen.otherDocs.ck2.lblKantorAsalTujuan': '起始 → 目的办公室',
  'lumen.otherDocs.ck2.lblKodeDok': 'H2H 文件代码',
  'lumen.otherDocs.ck2.lblMode': '发送模式',
  'lumen.otherDocs.ck2.lblNomorAju': '申报编号',
  'lumen.otherDocs.ck2.lblNomorPemesanan': '订单编号',
  'lumen.otherDocs.ck2.lblNppbkc': 'NPPBKC',
  'lumen.otherDocs.ck2.lblNpwp': '申请人 NPWP',
  'lumen.otherDocs.ck2.lblPenerima': '收货人',
  'lumen.otherDocs.ck2.lblPengirim': '发货人',
  'lumen.otherDocs.ck2.lblPengusaha': '企业主',
  'lumen.otherDocs.ck2.lblPeriode': '期间',
  'lumen.otherDocs.ck2.lblPerusahaan': '公司',
  'lumen.otherDocs.ck2.lblStatusPelunasan': '结清状态',
  'lumen.otherDocs.ck2.lblSuratJalan': '送货单',
  'lumen.otherDocs.ck2.lblTanggal': '日期',
  'lumen.otherDocs.ck2.lblTotalKemasan': '包装总数',
  'lumen.otherDocs.ck2.lblTujuanKirim': '运送目的',
  'lumen.otherDocs.ck2.loading': '加载中...',
  'lumen.otherDocs.ck2.modeDraft': 'CEISA 草稿',
  'lumen.otherDocs.ck2.modeFinal': '最终',
  'lumen.otherDocs.ck2.noAju': '暂无 — 发送时生成',
  'lumen.otherDocs.ck2.noAjuYet': '发送时生成',
  'lumen.otherDocs.ck2.optAccepted': '已接受',
  'lumen.otherDocs.ck2.optDraftCk': 'CK 草稿',
  'lumen.otherDocs.ck2.optError': '失败',
  'lumen.otherDocs.ck2.optRejected': '已拒绝',
  'lumen.otherDocs.ck2.optSubmitted': '已发送',
  'lumen.otherDocs.ck2.partyFmt': '{nama} ({nppbkc})',
  'lumen.otherDocs.ck2.periodeRange': '{awal} 至 {akhir}',
  'lumen.otherDocs.ck2.postSkipped': '（跳过 {n} 行 — 请检查 BOM 链接和库存项目）',
  'lumen.otherDocs.ck2.respon': '海关回复：{msg}',
  'lumen.otherDocs.ck2.searchPlaceholder': '搜索申报编号、NPPBKC、NPWP...',
  'lumen.otherDocs.ck2.slashFmt': '{berangkat} / {tiba}',
  'lumen.otherDocs.ck2.statDraft': '草稿',
  'lumen.otherDocs.ck2.statProblem': '已拒绝 / 失败',
  'lumen.otherDocs.ck2.statSubmitted': '已发送',
  'lumen.otherDocs.ck2.statTotal': '文件总数',
  'lumen.otherDocs.ck2.submitBody': '文件将通过 CEISA H2H 网关发送。如无申报编号将自动生成。',
  'lumen.otherDocs.ck2.submitTitle': '将 {docType} 发送至海关',
  'lumen.otherDocs.ck2.subtitle': '管理并向海关发送 CK-1（消费税标签）、CK-4（生产）和 CK-5（BKC 转移）',
  'lumen.otherDocs.ck2.switchFinal': '作为最终版发送 (isFinal) — 否则文件将在 CEISA 中保存为草稿',
  'lumen.otherDocs.ck2.tabAll': '全部',
  'lumen.otherDocs.ck2.tabCk1': 'CK-1 · 消费税标签',
  'lumen.otherDocs.ck2.tabCk4': 'CK-4 · 生产',
  'lumen.otherDocs.ck2.tabCk5': 'CK-5 · 转移',
  'lumen.otherDocs.ck2.thHje': 'HJE',
  'lumen.otherDocs.ck2.thIsiKemasan': '每包数量',
  'lumen.otherDocs.ck2.thJenisBkc': 'BKC 类型',
  'lumen.otherDocs.ck2.thJmlKemasan': '包装数量',
  'lumen.otherDocs.ck2.thJmlProduksi': '生产数量',
  'lumen.otherDocs.ck2.thJumlah': '数量',
  'lumen.otherDocs.ck2.thKemasan': '包装',
  'lumen.otherDocs.ck2.thKeping': '片数',
  'lumen.otherDocs.ck2.thLembar': '张数',
  'lumen.otherDocs.ck2.thMerk': '品牌',
  'lumen.otherDocs.ck2.thNilaiCukai': '消费税额',
  'lumen.otherDocs.ck2.thPpn': '增值税',
  'lumen.otherDocs.ck2.thSeriPita': '标签序列',
  'lumen.otherDocs.ck2.thTarif': '税率',
  'lumen.otherDocs.ck2.thTglProduksi': '生产日期',
  'lumen.otherDocs.ck2.thUraian': '说明',
  'lumen.otherDocs.ck2.tipDelete': '删除草稿',
  'lumen.otherDocs.ck2.tipDetail': '查看详情',
  'lumen.otherDocs.ck2.tipHistory': '变更历史',
  'lumen.otherDocs.ck2.tipPostStock': '过账生产库存（成品入库，原料出库）',
  'lumen.otherDocs.ck2.tipPullStatus': '从海关拉取状态',
  'lumen.otherDocs.ck2.tipSend': '发送至海关',
  'lumen.otherDocs.ck2.title': '消费税文件',
  'lumen.otherDocs.ck2.toastDeleted': '已删除',
  'lumen.otherDocs.ck2.toastDeletedMsg': '文件已删除。',
  'lumen.otherDocs.ck2.toastDeleteFail': '删除失败',
  'lumen.otherDocs.ck2.toastLoadDocFail': '加载文件失败',
  'lumen.otherDocs.ck2.toastLoadHistoryFail': '加载历史失败',
  'lumen.otherDocs.ck2.toastPosted': '生产库存已过账',
  'lumen.otherDocs.ck2.toastPostedMsg': '{n} 笔变动（成品入库 + 原料出库）{skipped}。',
  'lumen.otherDocs.ck2.toastPostFail': '库存过账失败',
  'lumen.otherDocs.ck2.toastSent': '已发送',
  'lumen.otherDocs.ck2.toastSentMsg': '{docType} 已发送至海关。申报编号：{nomorAju}',
  'lumen.otherDocs.ck2.toastStatusDone': '状态已更新',
  'lumen.otherDocs.ck2.toastStatusDoneMsg': '已从海关拉取 {docType} ({nomorAju}) 的状态。',
  'lumen.otherDocs.ck2.toastStatusFail': '拉取状态失败',
  'lumen.otherDocs.ck2.toastSubmitFail': '发送失败',
  'lumen.otherDocs.ck2.totBatang': '总支数',
  'lumen.otherDocs.ck2.totBayar': '应付总额',
  'lumen.otherDocs.ck2.totCukai': '消费税总额',
  'lumen.otherDocs.ck2.totGram': '总克数',
  'lumen.otherDocs.ck2.totLiter': '总升数',
  'lumen.otherDocs.ck2.totNilaiCukai': '消费税总额',
  'lumen.otherDocs.ck2.totPpn': '增值税总额 (9,9%)',
  'lumen.otherDocs.ck4.alertStokAwalPost': '在创建物品后进行 — 不直接录入 — 以保持库存卡一致。',
  'lumen.otherDocs.ck4.alertStokAwalPre': '期初库存通过',
  'lumen.otherDocs.ck4.alertStokKeluar': '出库数量超过可用余额时将被自动拒绝。',
  'lumen.otherDocs.ck4.allTypes': '所有类型',
  'lumen.otherDocs.ck4.btnBukukan': '过账',
  'lumen.otherDocs.ck4.btnBukukanPenyesuaian': '过账调整',
  'lumen.otherDocs.ck4.btnHapus': '删除',
  'lumen.otherDocs.ck4.btnItemBaru': '新建物品',
  'lumen.otherDocs.ck4.btnSimpanItem': '保存物品',
  'lumen.otherDocs.ck4.btnSimpanPerubahan': '保存更改',
  'lumen.otherDocs.ck4.btnStockOpname': '库存盘点',
  'lumen.otherDocs.ck4.btnStokKeluar': '出库',
  'lumen.otherDocs.ck4.btnStokMasuk': '入库',
  'lumen.otherDocs.ck4.btnStokMenipis': '库存偏低',
  'lumen.otherDocs.ck4.btnTambahBaris': '添加行',
  'lumen.otherDocs.ck4.colAksi': '操作',
  'lumen.otherDocs.ck4.colArah': '方向',
  'lumen.otherDocs.ck4.colItem': '物品',
  'lumen.otherDocs.ck4.colJenisMutasi': '变动类型',
  'lumen.otherDocs.ck4.colJumlah': '数量',
  'lumen.otherDocs.ck4.colLokasi': '位置',
  'lumen.otherDocs.ck4.colMinStok': '最低库存',
  'lumen.otherDocs.ck4.colReferensi': '参考',
  'lumen.otherDocs.ck4.colSaldoAkhir': '期末余额',
  'lumen.otherDocs.ck4.colStokSaatIni': '当前库存',
  'lumen.otherDocs.ck4.colTanggal': '日期',
  'lumen.otherDocs.ck4.colTipe': '类型',
  'lumen.otherDocs.ck4.delBodyPost': '？其变动记录将保留。',
  'lumen.otherDocs.ck4.delBodyPre': '确定要删除物品',
  'lumen.otherDocs.ck4.deleteRowAria': '删除行',
  'lumen.otherDocs.ck4.dirKeluar': '出',
  'lumen.otherDocs.ck4.dirMasuk': '入',
  'lumen.otherDocs.ck4.emptyItemsDesc': '创建原材料/成品物品，然后过账您的第一笔入库。',
  'lumen.otherDocs.ck4.emptyItemsTitle': '暂无库存物品',
  'lumen.otherDocs.ck4.emptyMovementsTitle': '暂无库存变动',
  'lumen.otherDocs.ck4.hintPerluPengadaan': '需要采购',
  'lumen.otherDocs.ck4.hintSemuaAman': '一切正常',
  'lumen.otherDocs.ck4.hintStokTercatat': '当前记录库存：',
  'lumen.otherDocs.ck4.itemOptionFmt': '{kode} — {nama}（库存：{qty} {satuan}）',
  'lumen.otherDocs.ck4.lblBarisItem': '物品行',
  'lumen.otherDocs.ck4.lblHasilHitung': '实物盘点结果',
  'lumen.otherDocs.ck4.lblItem': '物品',
  'lumen.otherDocs.ck4.lblJenisMutasi': '变动类型',
  'lumen.otherDocs.ck4.lblJumlah': '数量',
  'lumen.otherDocs.ck4.lblKeterangan': '备注',
  'lumen.otherDocs.ck4.lblKodeItem': '物品编码',
  'lumen.otherDocs.ck4.lblLokasi': '仓库位置',
  'lumen.otherDocs.ck4.lblMerk': '品牌（成品）',
  'lumen.otherDocs.ck4.lblNamaItem': '物品名称',
  'lumen.otherDocs.ck4.lblReferensi': '参考（采购单号/文件）',
  'lumen.otherDocs.ck4.lblSatuan': '单位',
  'lumen.otherDocs.ck4.lblStokMinimum': '最低库存（预警）',
  'lumen.otherDocs.ck4.lblTanggal': '日期',
  'lumen.otherDocs.ck4.lblTipeItem': '物品类型',
  'lumen.otherDocs.ck4.merkFmt': '品牌 {merk}',
  'lumen.otherDocs.ck4.mvHasilProduksi': '生产产出',
  'lumen.otherDocs.ck4.mvOpnameMinus': '盘点 (−)',
  'lumen.otherDocs.ck4.mvOpnamePlus': '盘点 (+)',
  'lumen.otherDocs.ck4.mvPemakaianProduksi': '生产领用',
  'lumen.otherDocs.ck4.mvPenerimaan': '收货',
  'lumen.otherDocs.ck4.mvPengiriman': '发货',
  'lumen.otherDocs.ck4.mvReturMasuk': '退货入库',
  'lumen.otherDocs.ck4.optHasilProduksi': '生产产出',
  'lumen.otherDocs.ck4.optPemakaianProduksi': '生产领用',
  'lumen.otherDocs.ck4.optPenerimaan': '收货（采购）',
  'lumen.otherDocs.ck4.optPengiriman': '发货',
  'lumen.otherDocs.ck4.optReturMasuk': '退货入库',
  'lumen.otherDocs.ck4.phAlasan': '调整原因',
  'lumen.otherDocs.ck4.phPilihItem': '选择物品',
  'lumen.otherDocs.ck4.satuanPlaceholder': '公斤 / 支 / 升 / 张',
  'lumen.otherDocs.ck4.searchPlaceholder': '搜索编码、名称、品牌...',
  'lumen.otherDocs.ck4.statKeluarHariIni': '今日出库',
  'lumen.otherDocs.ck4.statMasukHariIni': '今日入库',
  'lumen.otherDocs.ck4.statSaldoSaatIni': '当前余额',
  'lumen.otherDocs.ck4.statStokMenipis': '库存偏低',
  'lumen.otherDocs.ck4.statTotalItem': '物品总数',
  'lumen.otherDocs.ck4.statTotalKeluar': '出库合计',
  'lumen.otherDocs.ck4.statTotalMasuk': '入库合计',
  'lumen.otherDocs.ck4.subtitle': '原材料、成品和消费税标签的库存卡 — 变动由送货单和 CK-4 自动记录',
  'lumen.otherDocs.ck4.tabItemStok': '物品与库存',
  'lumen.otherDocs.ck4.tabRiwayat': '变动记录',
  'lumen.otherDocs.ck4.tAdjustFailed': '调整失败',
  'lumen.otherDocs.ck4.tAdjustPosted': '调整已过账',
  'lumen.otherDocs.ck4.tCardFailed': '加载库存卡失败',
  'lumen.otherDocs.ck4.tDeletedTitle': '已删除',
  'lumen.otherDocs.ck4.tDeleteFailed': '删除失败',
  'lumen.otherDocs.ck4.tEmptyLinesMsg': '请至少为一行选择物品并填写数量。',
  'lumen.otherDocs.ck4.tEmptyLinesTitle': '空行',
  'lumen.otherDocs.ck4.thJenis': '类型',
  'lumen.otherDocs.ck4.thKeluar': '出',
  'lumen.otherDocs.ck4.thMasuk': '入',
  'lumen.otherDocs.ck4.thSaldo': '余额',
  'lumen.otherDocs.ck4.tIncompleteMsg': '物品编码、名称和单位为必填项。',
  'lumen.otherDocs.ck4.tIncompleteTitle': '数据不完整',
  'lumen.otherDocs.ck4.tipEdit': '编辑',
  'lumen.otherDocs.ck4.tipHapus': '删除',
  'lumen.otherDocs.ck4.tipKartuStok': '库存卡',
  'lumen.otherDocs.ck4.tipLowStock': '低于最低库存（{min}）',
  'lumen.otherDocs.ck4.tipStokKeluar': '出库',
  'lumen.otherDocs.ck4.tipStokMasuk': '入库',
  'lumen.otherDocs.ck4.tItemCreated': '物品已创建。',
  'lumen.otherDocs.ck4.tItemDeleted': '物品已删除。',
  'lumen.otherDocs.ck4.tItemUpdated': '物品已更新。',
  'lumen.otherDocs.ck4.title': '消费税货物库存',
  'lumen.otherDocs.ck4.titleBukukanKeluar': '过账出库',
  'lumen.otherDocs.ck4.titleBukukanMasuk': '过账入库',
  'lumen.otherDocs.ck4.titleEditItem': '编辑物品 — {kode}',
  'lumen.otherDocs.ck4.titleHapusItem': '删除物品',
  'lumen.otherDocs.ck4.titleKartuStok': '库存卡 — {kode}（{nama}）',
  'lumen.otherDocs.ck4.titleMemuatKartu': '正在加载库存卡...',
  'lumen.otherDocs.ck4.titleNewItem': '新建库存物品',
  'lumen.otherDocs.ck4.titleOpname': '库存盘点（调整）',
  'lumen.otherDocs.ck4.tNewBalance': '新余额：{saldo}。',
  'lumen.otherDocs.ck4.tPickItemMsg': '必须选择物品。',
  'lumen.otherDocs.ck4.tPickItemTitle': '选择物品',
  'lumen.otherDocs.ck4.tPostedCount': '已记录 {n} 笔变动。',
  'lumen.otherDocs.ck4.tPostedIn': '入库已过账',
  'lumen.otherDocs.ck4.tPostedOut': '出库已过账',
  'lumen.otherDocs.ck4.tPostFailed': '过账失败',
  'lumen.otherDocs.ck4.tSavedTitle': '已保存',
  'lumen.otherDocs.ck4.tSaveFailed': '保存失败',
  'lumen.otherDocs.ck4.typeBahanBaku': '原材料',
  'lumen.otherDocs.ck4.typeBarangJadi': '成品（消费税货物）',
  'lumen.otherDocs.ck4.typePitaCukai': '消费税标签',
  'lumen.otherDocs.rp1.home': '首页',
  'lumen.otherDocs.rp1.report': '报表',
  'lumen.otherDocs.rp1.title20': 'BC 2.0 报表',
  'lumen.otherDocs.rp1.title30': 'BC 3.0 报表',
  'lumen.otherDocs.rp1.title57': 'BC 5.7 报表',
  'lumen.otherDocs.rp1.filterByNpwp': '按客户 NPWP 筛选',
  'lumen.otherDocs.rp1.npwpCustomer': '客户 NPWP',
  'lumen.otherDocs.rp1.npwpCustomerPlaceholder': '输入客户 NPWP',
  'lumen.otherDocs.rp1.npwp': 'NPWP',
  'lumen.otherDocs.rp1.npwpPlaceholder': '输入 NPWP',
  'lumen.otherDocs.rp1.startDate': '开始日期',
  'lumen.otherDocs.rp1.startDatePlaceholder': '选择开始日期',
  'lumen.otherDocs.rp1.endDate': '结束日期',
  'lumen.otherDocs.rp1.endDatePlaceholder': '选择结束日期',
  'lumen.otherDocs.rp1.generateReport': '生成报表',
  'lumen.otherDocs.rp1.errorTitle': '错误',
  'lumen.otherDocs.rp1.successTitle': '成功',
  'lumen.otherDocs.rp1.generateFailed': '生成报表失败',
  'lumen.otherDocs.rp1.generated': '报表生成成功',
  'lumen.otherDocs.rp1.connectFailed': '无法连接到服务器',
  'lumen.otherDocs.pz1.processIdMissing': '未找到 processId 参数。请手动创建 FTZ 文档。',
  'lumen.otherDocs.pz1.buatManual': '手动创建',
  'lumen.otherDocs.pz1.errorTitle': '创建 PPFTZ 草稿失败',
  'lumen.otherDocs.pz1.cobaLagi': '重试',
  'lumen.otherDocs.pz1.keDaftar': '前往 PPFTZ 列表',
  'lumen.otherDocs.pz1.menyusunTitle': '正在根据提取结果生成 PPFTZ 草稿…',
  'lumen.otherDocs.pz1.menyusunBody': '发票 / 装箱单 / 提单数据正在映射到 FTZ 511 文档',
  'lumen.otherDocs.pz1.createFailed': '根据提取结果创建 PPFTZ 草稿失败',
  'lumen.otherDocs.pz1.terhapus': '已删除',
  'lumen.otherDocs.pz1.draftDihapus': 'PPFTZ 草稿已成功删除',
  'lumen.otherDocs.pz1.gagalMenghapus': '删除失败',
  'lumen.otherDocs.pz1.gagalMenghapusDraft': '删除 PPFTZ 草稿失败',
  'lumen.otherDocs.pz1.colNomorAju': 'AJU 编号',
  'lumen.otherDocs.pz1.colFamily': '家族',
  'lumen.otherDocs.pz1.colKodeDokumen': '文档代码',
  'lumen.otherDocs.pz1.colArah': '方向',
  'lumen.otherDocs.pz1.colStatus': '状态',
  'lumen.otherDocs.pz1.colKodeKantor': '关区代码',
  'lumen.otherDocs.pz1.colDiperbarui': '更新时间',
  'lumen.otherDocs.pz1.colAksi': '操作',
  'lumen.otherDocs.pz1.buka': '打开',
  'lumen.otherDocs.pz1.hapusDraft': '删除草稿',
  'lumen.otherDocs.pz1.hapus': '删除',
  'lumen.otherDocs.pz1.title': 'PPFTZ / FTZ 文档',
  'lumen.otherDocs.pz1.subtitle': 'CEISA FTZ 文档（511–531）的草稿与主机对主机提交',
  'lumen.otherDocs.pz1.buatDokumen': '创建 FTZ 文档',
  'lumen.otherDocs.pz1.phFamily': '家族',
  'lumen.otherDocs.pz1.phKodeDokumen': '文档代码',
  'lumen.otherDocs.pz1.phStatus': '状态',
  'lumen.otherDocs.pz1.loadFailed': '加载 PPFTZ 文档列表失败',
  'lumen.otherDocs.pz1.belumAda': '暂无 PPFTZ 文档',
  'lumen.otherDocs.pz1.confirmHapus': '删除 PPFTZ 草稿 {nomor}？',
  'lumen.otherDocs.pz2.tidakAdaPilihan': '没有选项',
  'lumen.otherDocs.pz2.nomorAjuInvalid': 'AJU 号码必须为空或恰好 {length} 位数字（当前 {count} 个字符）',
  'lumen.otherDocs.pz2.kodeKantorWajib': '办公室代码为必填项',
  'lumen.otherDocs.pz2.validasiGagal': '验证失败',
  'lumen.otherDocs.pz2.periksaHeader': '请重新检查标记的表头字段',
  'lumen.otherDocs.pz2.tersimpan': '已保存',
  'lumen.otherDocs.pz2.headerTersimpan': '表头保存成功',
  'lumen.otherDocs.pz2.header': '表头',
  'lumen.otherDocs.pz2.simpanHeader': '保存表头',
  'lumen.otherDocs.pz2.belumDisimpan': '表头有未保存的更改。',
  'lumen.otherDocs.pz2.pilihKantorDulu': '请先选择或填写办公室代码，以便获得准确的 AJU 号码建议',
  'lumen.otherDocs.pz2.gagalSarankan': '无法建议 AJU 号码。请确认租户的 CEISA 账户已关联，或手动填写 AJU 号码。',
  'lumen.otherDocs.pz2.familyTidakCocok': 'Family 与文档代码不匹配',
  'lumen.otherDocs.pz2.familyTidakCocokDesc':
    'Family {family} 与文档代码 {kodeDokumen} 不符。请返回“文档”步骤重新选择。',
  'lumen.otherDocs.pz2.ajuTidakValid': 'AJU 号码无效',
  'lumen.otherDocs.pz2.ajuTidakValidDesc':
    'AJU 号码必须为空（服务器将给出建议）或恰好 {length} 位数字（当前 {count} 个字符）',
  'lumen.otherDocs.pz2.draftDibuat': '草稿已创建',
  'lumen.otherDocs.pz2.draftDibuatDesc': 'PPFTZ 草稿 {nomorAju} 创建成功',
  'lumen.otherDocs.pz2.gagalMembuatDraft': '创建草稿失败',
  'lumen.otherDocs.pz2.gagalMembuatDraftFallback': '创建 PPFTZ 草稿失败',
  'lumen.otherDocs.pz2.gagalMemuatKatalog': '无法加载 PPFTZ 文档目录',
  'lumen.otherDocs.pz2.cobaLagi': '重试',
  'lumen.otherDocs.pz2.stepFamily': 'Family',
  'lumen.otherDocs.pz2.stepFamilyHint': '区域类型',
  'lumen.otherDocs.pz2.stepDokumen': '文档',
  'lumen.otherDocs.pz2.stepDokumenHint': '文档代码',
  'lumen.otherDocs.pz2.stepKantor': '办公室',
  'lumen.otherDocs.pz2.stepKantorHint': '海关办公室代码',
  'lumen.otherDocs.pz2.stepNomorAju': 'AJU 号码',
  'lumen.otherDocs.pz2.stepNomorAjuHint': '确认并创建',
  'lumen.otherDocs.pz2.pilihJenisKawasan': '选择区域类型',
  'lumen.otherDocs.pz2.familyMenentukan': '每个 family 决定可用的文档类型。',
  'lumen.otherDocs.pz2.countDokumen': '{count} 份文档',
  'lumen.otherDocs.pz2.pilihKodeDokumen': '选择文档代码',
  'lumen.otherDocs.pz2.kodeMenentukan': '代码决定海关活动的方向和类型。',
  'lumen.otherDocs.pz2.tidakAdaDokumen': '此 family 没有文档。',
  'lumen.otherDocs.pz2.pilihKantorPabean': '选择海关办公室',
  'lumen.otherDocs.pz2.kantorPemrosesan': '按活动地点处理文档的办公室。',
  'lumen.otherDocs.pz2.daftarKantorKosong': '参考办公室列表不可用 — 请在下方手动输入办公室代码。',
  'lumen.otherDocs.pz2.kodeKantorLain': '其他办公室代码',
  'lumen.otherDocs.pz2.masukkanManual': '手动输入海关办公室代码',
  'lumen.otherDocs.pz2.kodeKantor': '办公室代码',
  'lumen.otherDocs.pz2.kodeKantorPlaceholder': '例如 020400',
  'lumen.otherDocs.pz2.ringkasan': '摘要',
  'lumen.otherDocs.pz2.ajuHint':
    '服务器给出的 {length} 位数字（第 7–12 位 = CEISA 公司代码）。可以修改或留空 — 若为空，后端会在提交时给出建议。',
  'lumen.otherDocs.pz2.saranGagal': 'AJU 号码建议失败',
  'lumen.otherDocs.pz2.ajuDiperbarui': 'AJU 号码已更新',
  'lumen.otherDocs.pz2.saranDimuat': '已加载服务器建议',
  'lumen.otherDocs.pz2.cobaSaranLagi': '重试建议',
  'lumen.otherDocs.pz2.ajuEksternalPlaceholder': '填写外部 AJU 号码，或留空',
  'lumen.otherDocs.pz2.draftDapatDiedit': '草稿在发送到 CEISA 系统之前可以编辑。',
  'lumen.otherDocs.pz2.buatDokumenFtz': '创建 FTZ 文档',
  'lumen.otherDocs.pz2.ikutiLangkah': '按 4 个步骤创建自由区海关文档。',
  'lumen.otherDocs.pz2.kembaliKeDaftar': '返回列表',
  'lumen.otherDocs.pz2.langkahDari': '第 {step} 步，共 4 步',
  'lumen.otherDocs.pz2.kembali': '返回',
  'lumen.otherDocs.pz2.buatDraft': '创建草稿',
  'lumen.otherDocs.pz2.sarankanAju': '建议 AJU',
  'lumen.otherDocs.pz2.lanjut': '下一步',
  'lumen.otherDocs.pz3.gagalMemuatPayload': '加载 CEISA 载荷失败',
  'lumen.otherDocs.pz3.previewPayloadCeisa': 'CEISA 载荷预览',
  'lumen.otherDocs.pz3.memuat': '加载中...',
  'lumen.otherDocs.pz3.gagalMemuatRiwayat': '加载状态历史失败',
  'lumen.otherDocs.pz3.riwayatStatus': '状态历史',
  'lumen.otherDocs.pz3.belumAdaRiwayat': '暂无历史记录',
  'lumen.otherDocs.pz3.waktu': '时间',
  'lumen.otherDocs.pz3.aksi': '操作',
  'lumen.otherDocs.pz3.status': '状态',
  'lumen.otherDocs.pz3.keterangan': '备注',
  'lumen.otherDocs.pz3.selengkapnya': '展开',
  'lumen.otherDocs.pz3.sembunyikan': '收起',
  'lumen.otherDocs.pz3.wajibDiisi': '{label}为必填项',
  'lumen.otherDocs.pz3.harusArrayJson': '{label}必须是有效的 JSON 数组',
  'lumen.otherDocs.pz3.tersimpan': '已保存',
  'lumen.otherDocs.pz3.dataBerhasilDisimpan': '{label}数据已成功保存',
  'lumen.otherDocs.pz3.tambahLabel': '添加{label}',
  'lumen.otherDocs.pz3.simpanLabel': '保存{label}',
  'lumen.otherDocs.pz3.ubahLabel': '修改{label}',
  'lumen.otherDocs.pz3.adaPerubahan': '有未保存的{label}更改。',
  'lumen.otherDocs.pz3.belumAdaData': '暂无{label}数据',
  'lumen.otherDocs.pz3.tambah': '添加',
  'lumen.otherDocs.pz3.ubahBaris': '修改此行',
  'lumen.otherDocs.pz3.hapusBaris': '删除此行',
  'lumen.otherDocs.pz3.tidakAdaYangDiisi': '没有需要填写的内容',
  'lumen.otherDocs.pz3.semuaBarangSudahTarif': '所有商品均已有 BM 税率',
  'lumen.otherDocs.pz3.tarifTidakDitemukan': '未找到税率',
  'lumen.otherDocs.pz3.tarifHsTidakDitemukan': '未找到序号 {seri} 商品的 HS 税率',
  'lumen.otherDocs.pz3.tarifBmTerisi': 'BM 税率已填写',
  'lumen.otherDocs.pz3.barangDiisiTarifBm': '已从 HS 主数据为 {filled} 件商品填写 BM 税率',
  'lumen.otherDocs.pz3.seriTidakDitemukan': '；未找到序号 {seri}',
  'lumen.otherDocs.pz3.gagalMengisiTarif': '填写税率失败',
  'lumen.otherDocs.pz3.gagalMengambilTarif': '从 HS 主数据获取税率失败',
  'lumen.otherDocs.pz3.nilaiPabean': '关税价值',
  'lumen.otherDocs.pz3.totalBm': 'BM 合计',
  'lumen.otherDocs.pz3.nilaiImpor': '进口价值',
  'lumen.otherDocs.pz3.estimasiPpn': '预估增值税 {rate}%',
  'lumen.otherDocs.pz3.estimasiPph': '预估所得税 {rate}%',
  'lumen.otherDocs.pz3.pungutan': '征费',
  'lumen.otherDocs.pz3.isiTarifBm': '从 HS 主数据填写 BM 税率',
  'lumen.otherDocs.pz3.dokumen513Wajib': '513 文件必须按商品申报 BM 税率。序号 {seri} 的商品尚无税率。',
  'lumen.otherDocs.pz3.seri': '序号',
  'lumen.otherDocs.pz3.posTarif': '税则号',
  'lumen.otherDocs.pz3.uraian': '描述',
  'lumen.otherDocs.pz3.bm': 'BM',
  'lumen.otherDocs.pz3.statusTarif': '税率状态',
  'lumen.otherDocs.pz3.belumAdaBarang': '暂无商品',
  'lumen.otherDocs.pz3.ada': '有',
  'lumen.otherDocs.pz3.belum': '未有',
  'lumen.otherDocs.pz3.ppnPphEstimasi':
    '增值税和所得税为预估值（API 进口商分别为 {ppn}% 和 {pph}%），在 CEISA 接受文件后通过账单收取。BM 缴纳金额可在“Barang”标签页中按商品调整。',
  'lumen.otherDocs.pz3.tarifBmBarangTarif': 'BM 税率 (barangTarif)',
  'lumen.otherDocs.pz3.nilaiPabeanLabel': '关税价值：{nilai}',
  'lumen.otherDocs.pz3.belumAdaTarif': '暂无税率。513 文件（发往 TLDDP）的每件商品都必须有 BM 税率。',
  'lumen.otherDocs.pz3.jenisTarif': '税率类型',
  'lumen.otherDocs.pz3.tarif': '税率',
  'lumen.otherDocs.pz3.tarifFasilitas': '优惠税率',
  'lumen.otherDocs.pz3.kodeFasilitas': '优惠代码',
  'lumen.otherDocs.pz3.jumlahSatuan': '单位数量',
  'lumen.otherDocs.pz3.satuan': '单位',
  'lumen.otherDocs.pz3.nilaiBayarBm': '缴纳金额 (BM)',
  'lumen.otherDocs.pz3.hapusTarif': '删除税率',
  'lumen.otherDocs.pz3.gagalMenyimpanHeader': '保存表头失败',
  'lumen.otherDocs.pz3.gagalMenyimpanHeaderPpftz': '保存 PPFTZ 表头失败',
  'lumen.otherDocs.pz3.gagalMenyimpanSection': '保存 {section} 失败',
  'lumen.otherDocs.pz3.gagalMenyimpanDataSection': '保存 {section} 数据失败',
  'lumen.otherDocs.pz3.cekCeisaStatus': 'CEISA 检查：{status}',
  'lumen.otherDocs.pz3.lihatPanelPesan': '详情请查看消息面板',
  'lumen.otherDocs.pz3.gagalCekDokumen': '向 CEISA 检查文件失败',
  'lumen.otherDocs.pz3.skemaCeisaTidakValid': 'CEISA 方案无效',
  'lumen.otherDocs.pz3.cekCeisaGagal': 'CEISA 检查失败',
  'lumen.otherDocs.pz3.kirimCeisaStatus': 'CEISA 提交：{status}',
  'lumen.otherDocs.pz3.idHeaderValue': 'idHeader：{idHeader}',
  'lumen.otherDocs.pz3.dokumenDikirim': '文件已发送至 CEISA',
  'lumen.otherDocs.pz3.draftTerkirim': 'CEISA 草稿已发送，状态更新后即可打印草稿表单',
  'lumen.otherDocs.pz3.kirimCeisaGagal': 'CEISA 提交失败',
  'lumen.otherDocs.pz3.gagalMengirimDokumen': '向 CEISA 发送文件失败',
  'lumen.otherDocs.pz3.gagalMemuatFormulir': '加载 {type} 表单失败',
  'lumen.otherDocs.pz3.formulirBelumTersedia': '此文件的表单在 CEISA 中尚不可用',
  'lumen.otherDocs.pz3.statusCeisa': 'CEISA 状态',
  'lumen.otherDocs.pz3.nomorAjuStatus': '{nomorAju}：{status}',
  'lumen.otherDocs.pz3.idHeaderParen': '(idHeader {idHeader})',
  'lumen.otherDocs.pz3.gagalMemuatStatus': '加载状态失败',
  'lumen.otherDocs.pz3.gagalMemuatStatusCeisa': '从 CEISA 加载状态失败',
  'lumen.otherDocs.pz3.gagalMemuatDokumen': '加载 PPFTZ 文件失败',
  'lumen.otherDocs.pz3.cobaLagi': '重试',
  'lumen.otherDocs.pz3.kembaliKeDaftar': '返回列表',
  'lumen.otherDocs.pz3.draftId': '草稿 #{id}',
  'lumen.otherDocs.pz3.dokumenFtz': 'FTZ 文件',
  'lumen.otherDocs.pz3.idHeaderBullet': '• idHeader：{idHeader}',
  'lumen.otherDocs.pz3.cekCeisa': '检查 CEISA',
  'lumen.otherDocs.pz3.kirim': '提交',
  'lumen.otherDocs.pz3.refreshStatus': '刷新状态',
  'lumen.otherDocs.pz3.cetakDraft': '打印草稿',
  'lumen.otherDocs.pz3.cetakFormulir': '打印表单',
  'lumen.otherDocs.pz3.previewPayload': '预览载荷',
  'lumen.otherDocs.pz3.history': '历史',
  'lumen.otherDocs.pz3.dokumenBerstatus': '文件状态为 {status}，无法再修改。',
  'lumen.otherDocs.pz3.pesanCeisaTerakhir': '最新 CEISA 消息',
  'lumen.otherDocs.pz3.header': '表头',
  'lumen.otherDocs.pz3.perubahanBelumDisimpan': '更改尚未保存',
  'lumen.otherDocs.pz3.adaPerubahanTab': '此标签页有未保存的更改。切换标签页将丢弃这些更改。是否继续？',
  'lumen.otherDocs.pz3.lanjutkan': '继续',
  'lumen.otherDocs.pz3.kirimKeCeisa': '提交到 CEISA',
  'lumen.otherDocs.pz3.cekTerakhirBerstatus': '上次检查状态为 {status}。请先修正文件，或在确认无误时提交。',
  'lumen.otherDocs.pz3.dokumen513WajibKirim':
    '513 文件必须按商品申报 BM 税率。序号 {seri} 的商品尚无税率，请在提交前通过“Pungutan”或“Barang”标签页补全。',
  'lumen.otherDocs.pz3.pengajuanFinal': '正式申报',
  'lumen.otherDocs.pz3.nonaktifkanDraft': '关闭则先作为 CEISA 草稿发送',
  'lumen.otherDocs.pz3.revisiAtasAju': '对已提交申报的修订',
  'lumen.otherDocs.pz3.centangHanyaKoreksi': '仅在更正已提交的文件时勾选',
  'lumen.otherDocs.pz3.setiapPengiriman': '每次提交消耗 1 个 CEISA 提交额度。如被 CEISA 拒绝，额度将自动退还。',
  'lumen.otherDocs.pz3.kirimSekarang': '立即提交',
  'lumen.otherDocs.pz3.kirimFinal': '提交正式申报',
  'lumen.otherDocs.pz3.kirimDraft': '提交草稿',
  'lumen.otherDocs.ck5.title': '消费税模块指南',
  'lumen.otherDocs.ck5.subtitle': '从送货单到向海关申报——几分钟内了解每个菜单。第一次使用？请从上到下依次阅读。',
  'lumen.otherDocs.ck5.learnProgress': '学习进度',
  'lumen.otherDocs.ck5.railCount': '{current}/{total} 部分',
  'lumen.otherDocs.ck5.secAlur': '完整流程',
  'lumen.otherDocs.ck5.secInventori': '库存',
  'lumen.otherDocs.ck5.secBom': '物料清单',
  'lumen.otherDocs.ck5.secSuratJalan': '送货单',
  'lumen.otherDocs.ck5.secDokumen': 'CK 文件',
  'lumen.otherDocs.ck5.secStok': '库存过账',
  'lumen.otherDocs.ck5.secRisk': '风险自查',
  'lumen.otherDocs.ck5.secMulai': '从这里开始',
  'lumen.otherDocs.ck5.flowInventori': '库存',
  'lumen.otherDocs.ck5.flowBom': 'BOM',
  'lumen.otherDocs.ck5.flowStokMasuk': '入库',
  'lumen.otherDocs.ck5.flowSuratJalan': '送货单',
  'lumen.otherDocs.ck5.flowDokumenCk': 'CK 文件',
  'lumen.otherDocs.ck5.flowSubmit': '提交',
  'lumen.otherDocs.ck5.flowPostingStok': '库存过账',
  'lumen.otherDocs.ck5.flowRiskCheck': '风险检查',
  'lumen.otherDocs.ck5.flowTitle': '完整流程：一段旅程，八个步骤',
  'lumen.otherDocs.ck5.scrollHint': '向下滚动开始',
  'lumen.otherDocs.ck5.menuLabel': '菜单 {n}',
  'lumen.otherDocs.ck5.whenToUse': '何时使用',
  'lumen.otherDocs.ck5.stepsHeading': '步骤',
  'lumen.otherDocs.ck5.tipLabel': '提示：',
  'lumen.otherDocs.ck5.openMenu': '打开{name}',
  'lumen.otherDocs.ck5.s1Title': '登记库存项目',
  'lumen.otherDocs.ck5.s1Desc': '创建原材料、成品（应税货物）和税票项目。它们将成为所有功能自动读取的库存卡。',
  'lumen.otherDocs.ck5.s2Title': '编制 BOM（生产配方）',
  'lumen.otherDocs.ck5.s2Desc': '为每个产品创建配方：成品需要哪些原材料以及用量。将产出和组件关联到库存。',
  'lumen.otherDocs.ck5.s3Title': '登记原材料入库',
  'lumen.otherDocs.ck5.s3Desc': '将原材料收货记为入库，使仓库拥有正确的期初余额。',
  'lumen.otherDocs.ck5.s4Title': '创建送货单',
  'lumen.otherDocs.ck5.s4Desc': '填写发货人、收货人、运输和货物清单。这是所有 CK 文件的源文件。',
  'lumen.otherDocs.ck5.s5Title': '生成 CK 文件',
  'lumen.otherDocs.ck5.s5Desc': '从送货单出具 CK-5（移转）、CK-4（生产）或 CK-1（税票订购）。',
  'lumen.otherDocs.ck5.s6Title': '编辑后提交给海关',
  'lumen.otherDocs.ck5.s6Desc': '检查并补全文件，通过 host-to-host 发送，并跟踪状态直至 ACCEPTED。',
  'lumen.otherDocs.ck5.s7Title': '库存过账',
  'lumen.otherDocs.ck5.s7Desc': '最终送货单发出成品；CK-4 增加产量并按 BOM 扣减原材料。',
  'lumen.otherDocs.ck5.s8Title': '监控风险自查',
  'lumen.otherDocs.ck5.s8Desc': '查看 7 项指标，在海关发现之前先修复风险红旗。',
  'lumen.otherDocs.ck5.mInvTitle': '库存——库存卡',
  'lumen.otherDocs.ck5.mInvApa':
    '您的库存卡分为三种类型：原材料（黄色）、成品/应税货物（绿色）和税票（紫色）。在这里记录入库、出库和盘点，并在库存不足时收到提醒。',
  'lumen.otherDocs.ck5.mInvKapan':
    '最先进行，早于 BOM 和送货单。每次收到原材料/税票时登记入库，调整实物余额时进行盘点。',
  'lumen.otherDocs.ck5.mInvL1': '点击“Tambah Item”，选择类型（BAHAN_BAKU / BARANG_JADI / PITA_CUKAI）。',
  'lumen.otherDocs.ck5.mInvL2': '填写名称、单位和最低库存阈值以触发提醒。',
  'lumen.otherDocs.ck5.mInvL3': '收到原材料或税票时登记“Stok Masuk”。',
  'lumen.otherDocs.ck5.mInvL4': '让送货单和 CK-4 自动过账移转。',
  'lumen.otherDocs.ck5.mInvL5': '当系统余额与实物盘点不符时执行“Stock Opname”。',
  'lumen.otherDocs.ck5.mInvTip': '任何未关联到文件的项目都会中断自动对账。同步的库存卡是健康风险评分的基础。',
  'lumen.otherDocs.ck5.mBomTitle': '物料清单——生产配方',
  'lumen.otherDocs.ck5.mBomApa':
    '您的生产配方：对每个产品/品牌，BOM 列出所需原材料及用量。由于与库存关联，CK-4 可以“展开”该配方，按产量自动扣减原材料库存。',
  'lumen.otherDocs.ck5.mBomKapan':
    '每个产品在开始时设置一次，成分变化时更新。必须先有 BOM，CK-4 才能自动计算材料用量。',
  'lumen.otherDocs.ck5.mBomL1': '点击“Buat BOM”，选择成品的产品/品牌作为产出。',
  'lumen.otherDocs.ck5.mBomL2': '将产出关联到类型为 BARANG_JADI 的库存项目。',
  'lumen.otherDocs.ck5.mBomL3': '添加原材料组件及每单位用量。',
  'lumen.otherDocs.ck5.mBomL4': '将每个组件关联到 BAHAN_BAKU 库存项目。',
  'lumen.otherDocs.ck5.mBomL5': '保存——CK-4 现在会用它来自动消耗材料。',
  'lumen.otherDocs.ck5.mBomTip':
    'BOM 用量的准确性很重要：若有偏差，风险自查中的“Pemakaian Bahan vs BOM”指标会显示较大差异，被视为材料流失。',
  'lumen.otherDocs.ck5.mSjTitle': '送货单——源文件',
  'lumen.otherDocs.ck5.mSjApa':
    '您的内部发货文件，也是整个模块的起点。记录发货人、收货人、运输和应税货物清单。其数据随后会自动流入 CK 文件。',
  'lumen.otherDocs.ck5.mSjKapan': '每当有货物要移动或申报时——始终是一笔交易的第一步。',
  'lumen.otherDocs.ck5.mSjL1': '点击“Buat Surat Jalan”，填写发货人和收货人及其 NPPBKC。',
  'lumen.otherDocs.ck5.mSjL2': '补全运输信息：运输方式和车牌号。',
  'lumen.otherDocs.ck5.mSjL3': '添加货物：应税类型（EA/MMEA/HT）、品牌、包装、数量、单位。',
  'lumen.otherDocs.ck5.mSjL4': '将每件货物关联到库存项目，以便库存自动过账。',
  'lumen.otherDocs.ck5.mSjL5': '保存为 DRAFT 或标记为 FINAL，然后点击“Generate”创建 CK。',
  'lumen.otherDocs.ck5.mSjTip':
    '从一开始就把每个货物行关联到库存项目。未关联的行会降低“Kesiapan Data”得分，并使库存过账无法自动完成。',
  'lumen.otherDocs.ck5.mDokTitle': 'CK 文件——CK-1、CK-4、CK-5',
  'lumen.otherDocs.ck5.mDokApa':
    '管理三种官方消费税文件：由送货单出具，通过 host-to-host 发送给海关，然后跟踪其状态。CK-1 = 税票订购（紫色）。CK-4 = 生产完成报告（橙色）。CK-5 = 应税货物移转通知（青色）。',
  'lumen.otherDocs.ck5.mDokKapan':
    '在不同地点之间转移应税货物时使用 CK-5。报告生产成果时使用 CK-4。订购税票时使用 CK-1。',
  'lumen.otherDocs.ck5.mDokL1': '在送货单中选择“Generate”并选择类型（CK-1/CK-4/CK-5）。',
  'lumen.otherDocs.ck5.mDokL2': '发货人、收货人和货物数据会自动复制——请再次检查。',
  'lumen.otherDocs.ck5.mDokL3': '补全特定字段：HJE 和税率（CK-1）、缴清状态（CK-5）等。',
  'lumen.otherDocs.ck5.mDokL4': '保存为 GENERATED，然后“Submit ke Bea Cukai”。',
  'lumen.otherDocs.ck5.mDokL5': '跟踪状态：SUBMITTED → ACCEPTED 或 REJECTED。',
  'lumen.otherDocs.ck5.mDokL6': '如被 REJECTED，请根据拒绝说明修正后重新提交。',
  'lumen.otherDocs.ck5.mDokTip':
    '提交前请确认 HJE 和消费税税率正确。对于 CK-1：每张按系列包含相应数量的税票（I:120、II:56、III:150），HT 税票增值税为 9.9%。',
  'lumen.otherDocs.ck5.mRiskTitle': '风险自查——合规仪表板',
  'lumen.otherDocs.ck5.mRiskApa':
    '模仿 DJBC SPT-BKC 风险指标的仪表板。系统根据您自己的数据计算 0–1 的风险评分，分为 5 个类别，并通过 7 项可解释的指标细化。目的：让您先于海关发现风险红旗。',
  'lumen.otherDocs.ck5.mRiskKapan': '定期使用——尤其是在定期申报之前，以及大量生产/移转/税票订购交易之后。',
  'lumen.otherDocs.ck5.mRiskL1': '打开风险自查并选择评估期间。',
  'lumen.otherDocs.ck5.mRiskL2': '留意总体风险评分及其类别。',
  'lumen.otherDocs.ck5.mRiskL3': '查看每项指标，展开 WARNING/CRITICAL 行的详情。',
  'lumen.otherDocs.ck5.mRiskL4': '阅读有问题指标的建议。',
  'lumen.otherDocs.ck5.mRiskL5': '在相关菜单中修复根本原因，然后重新加载。',
  'lumen.otherDocs.ck5.mRiskTip':
    '高分不是判决，而是早期预警。优先处理 CRITICAL 指标，从“Kesiapan Data”开始：一旦所有库存关联完整，许多其他问题也会改善。',
  'lumen.otherDocs.ck5.chipBahanBaku': '原材料',
  'lumen.otherDocs.ck5.chipBarangJadi': '成品',
  'lumen.otherDocs.ck5.chipPitaCukai': '税票',
  'lumen.otherDocs.ck5.invName1': '烟丝',
  'lumen.otherDocs.ck5.invQty1': '450 公斤',
  'lumen.otherDocs.ck5.invName2': 'SKM A 品牌',
  'lumen.otherDocs.ck5.invQty2': '12,000 支',
  'lumen.otherDocs.ck5.invName3': 'II 系列税票',
  'lumen.otherDocs.ck5.invQty3': '80 张',
  'lumen.otherDocs.ck5.lowStockWarn': '⚠ 1 个项目低于最低库存',
  'lumen.otherDocs.ck5.bomMockTitle': 'SKM A 品牌 · 每 1,000 支',
  'lumen.otherDocs.ck5.bomIng1': '烟丝',
  'lumen.otherDocs.ck5.bomQty1': '0.9 公斤',
  'lumen.otherDocs.ck5.bomIng2': '丁香',
  'lumen.otherDocs.ck5.bomQty2': '0.3 公斤',
  'lumen.otherDocs.ck5.bomIng3': '卷烟纸',
  'lumen.otherDocs.ck5.bomQty3': '1,000 张',
  'lumen.otherDocs.ck5.bomMockNote': 'CK-4 自动扣减材料库存',
  'lumen.otherDocs.ck5.docDesc1': '税票订购',
  'lumen.otherDocs.ck5.docDesc2': '生产报告',
  'lumen.otherDocs.ck5.docDesc3': '应税货物移转',
  'lumen.otherDocs.ck5.statusCycle': '周期状态：',
  'lumen.otherDocs.ck5.statusDraft': 'CK 草稿',
  'lumen.otherDocs.ck5.statusSent': '已发送',
  'lumen.otherDocs.ck5.statusAccepted': '已接受',
  'lumen.otherDocs.ck5.fanTitle': '1 张送货单',
  'lumen.otherDocs.ck5.fanSub': 'SJ/2026/00123 · 3 件货物',
  'lumen.otherDocs.ck5.fanPita': '税票',
  'lumen.otherDocs.ck5.fanProduksi': '生产',
  'lumen.otherDocs.ck5.fanMutasi': '移转',
  'lumen.otherDocs.ck5.fanNote': '数据自动复制——您只需补全',
  'lumen.otherDocs.ck5.riskSliderHint': '拖动以体验 0–1 的风险刻度',
  'lumen.otherDocs.ck5.riskSliderAria': '风险评分',
  'lumen.otherDocs.ck5.katSangatRendah': '很低',
  'lumen.otherDocs.ck5.katRendah': '低',
  'lumen.otherDocs.ck5.katSedang': '中',
  'lumen.otherDocs.ck5.katTinggi': '高',
  'lumen.otherDocs.ck5.katSangatTinggi': '很高',
  'lumen.otherDocs.ck5.postingBadge': '自动',
  'lumen.otherDocs.ck5.postingTitle': '库存过账——文件 ↔ 库存卡始终同步',
  'lumen.otherDocs.ck5.postingSj': '最终送货单',
  'lumen.otherDocs.ck5.postingSjBody': '按所发货物从仓库发出<b>成品</b>（出库）。',
  'lumen.otherDocs.ck5.postingCk4': 'CK-4 已处理',
  'lumen.otherDocs.ck5.postingCk4Body': '增加生产出的<b>成品</b>，并按 BOM 扣减<b>原材料</b>（BOM 被展开）。',
  'lumen.otherDocs.ck5.postingNote': '<b>原材料/税票入库</b>和<b>盘点</b>仍需手动登记。其余自动完成。',
  'lumen.otherDocs.ck5.startHere': '从这里开始',
  'lumen.otherDocs.ck5.reset': '重置',
  'lumen.otherDocs.ck5.checklistHint': '边做边勾选每个步骤——保存在此浏览器中。',
  'lumen.otherDocs.ck5.allDone': '完成！您已了解消费税模块的完整流程。🎉',
  'lumen.otherDocs.ck5.openMenuTip': '打开菜单',
  'lumen.otherDocs.ck5.glossaryTitle': '重要术语',
  'lumen.otherDocs.ck5.glossarySearch': '搜索术语…',
  'lumen.otherDocs.ck5.glossaryEmpty': '没有匹配的术语。',
  'lumen.otherDocs.ck5.gBkcTerm': 'BKC',
  'lumen.otherDocs.ck5.gBkcDef':
    '应税货物（Barang Kena Cukai）。分三类：EA（乙醇）、MMEA（含酒精饮料）和 HT（烟草制品）。',
  'lumen.otherDocs.ck5.gNppbkcTerm': 'NPPBKC',
  'lumen.otherDocs.ck5.gNppbkcDef': '应税货物经营者登记号——海关颁发给应税货物经营者的正式许可/身份。',
  'lumen.otherDocs.ck5.gCk1Term': 'CK-1',
  'lumen.otherDocs.ck5.gCk1Def': '税票订购文件（贴在应税货物上的税票）。紫色。',
  'lumen.otherDocs.ck5.gCk4Term': 'CK-4',
  'lumen.otherDocs.ck5.gCk4Def': '应税货物生产完成的报告。增加成品库存并按 BOM 扣减原材料。橙色。',
  'lumen.otherDocs.ck5.gCk5Term': 'CK-5',
  'lumen.otherDocs.ck5.gCk5Def': '应税货物在不同地点之间移转（转移）的通知，保存缴清状态。青色。',
  'lumen.otherDocs.ck5.gPitaTerm': '税票',
  'lumen.otherDocs.ck5.gPitaDef':
    '以应税货物包装上的税票形式出现的消费税缴清凭证。通过 CK-1 订购；每张的数量因系列而异（I:120、II:56、III:150）。',
  'lumen.otherDocs.ck5.gHjeTerm': 'HJE',
  'lumen.otherDocs.ck5.gHjeDef': '每包装零售价——计算消费税的基础。',
  'lumen.otherDocs.ck5.gTarifTerm': '消费税税率',
  'lumen.otherDocs.ck5.gTarifDef': '每单位（支/克/升）的消费税额，乘以数量即得消费税金额。',
  'lumen.otherDocs.ck5.gStokTerm': '库存卡',
  'lumen.otherDocs.ck5.gStokDef': '每个项目的库存变动记录：入库、出库和调整。应税货物经营者必备的库存账簿。',
  'lumen.otherDocs.ck5.gMutasiTerm': '移转',
  'lumen.otherDocs.ck5.gMutasiDef': '应税货物的移动或库存余额的变化。在文件中通过 CK-5 申报。',
  'lumen.otherDocs.ck5.gPelunasanTerm': '缴清',
  'lumen.otherDocs.ck5.gPelunasanDef': '消费税支付状态：未缴清、已缴清、不征收或免征。附属于 CK-5。',
  'lumen.otherDocs.ck5.gBomTerm': 'BOM',
  'lumen.otherDocs.ck5.gBomDef': '物料清单——生产配方：制造一件成品所需的原材料及用量。与库存关联。',
  'lumen.otherDocs.ck5.gOpnameTerm': '库存盘点',
  'lumen.otherDocs.ck5.gOpnameDef': '调整库存余额以符合仓库实物盘点——产生增加/减少的移转。',
  'lumen.otherDocs.ck5.gH2hTerm': 'Host-to-Host',
  'lumen.otherDocs.ck5.gH2hDef': '文件直接从您的系统发送给海关，无需重新录入；回复状态自动拉取。',
  'lumen.otherDocs.ck5.faqTitle': '常见问题',
  'lumen.otherDocs.ck5.faq1Q': '我是新手。该从哪里开始？',
  'lumen.otherDocs.ck5.faq1A':
    '按“Mulai dari sini”的顺序进行：库存 → BOM → 入库 → 送货单 → 生成 CK → 提交 → 库存过账 → 风险自查。此顺序可让自动化顺畅运行。',
  'lumen.otherDocs.ck5.faq2Q': 'CK-1、CK-4 和 CK-5 有什么区别？',
  'lumen.otherDocs.ck5.faq2A':
    'CK-1 订购税票（紫色）。CK-4 报告生产完成（橙色）。CK-5 通知应税货物移转及缴清情况（青色）。三者均由送货单出具，然后提交给海关。',
  'lumen.otherDocs.ck5.faq3Q': '为什么先创建送货单？',
  'lumen.otherDocs.ck5.faq3A':
    '送货单是源文件。发货人、收货人、运输和货物数据只需填写一次，生成 CK 时自动复制——节省时间且保持一致。',
  'lumen.otherDocs.ck5.faq4Q': '库存会自动变化吗？',
  'lumen.otherDocs.ck5.faq4A':
    '大部分是自动的：最终送货单发出成品，CK-4 增加产量并按 BOM 扣减原材料。原材料/税票入库和盘点仍需手动登记。',
  'lumen.otherDocs.ck5.faq5Q': '我的风险评分很高，这意味着什么？',
  'lumen.otherDocs.ck5.faq5A':
    '这是早期预警，而不是处罚。先查看 CRITICAL 指标并阅读其建议。通常从“Kesiapan Data”开始（补全库存关联），缴清 CK-5，并确保 CK-4/送货单已过账。',
  'lumen.otherDocs.fxp.dateRangeMax3Months': '日期范围不能超过 3 个月',
  'lumen.otherDocs.fxp.submitSentenceFinal': '文件 <b>{title}</b>（{kode}）将作为正式申报发送至 CEISA。',
  'lumen.otherDocs.fxp.submitSentenceDraft':
    '文件 <b>{title}</b>（{kode}）将作为草稿发送至 CEISA（可在 CEISA 门户中打印和查看）。',
  // lumen.exportEngine (revamp PR 8c)
  'lumen.exportEngine.g1.scaffoldPill': '自动填写',
  'lumen.exportEngine.g1.scaffoldPillTooltip': '此值根据您上传时选择的出口商 / 港口自动填写。',
  'lumen.exportEngine.g1.cardRecommendedTooltip': '货物与此草稿相似 — {matchTotal} 个税号中有 {matchCount} 个匹配',
  'lumen.exportEngine.g1.cardSelectedAria': '已选择',
  'lumen.exportEngine.g1.cardNpwpNik': 'NPWP/NIK：',
  'lumen.exportEngine.g1.cardNoAddress': '地址不可用',
  'lumen.exportEngine.g1.cardPenerima': '收货人：',
  'lumen.exportEngine.g1.cardPembeli': '买方：',
  'lumen.exportEngine.g1.cardPelMuat': '出口装货港：',
  'lumen.exportEngine.pg1.secureTitle': '安全与私密',
  'lumen.exportEngine.pg1.secureMessage': '受企业级安全保护',
  'lumen.exportEngine.pg1.ownershipTitle': '数据所有权',
  'lumen.exportEngine.pg1.ownershipMessage': '您的数据始终属于您',
  'lumen.exportEngine.pg1.bankTitle': '银行级安全',
  'lumen.exportEngine.pg1.bankMessage': '为您的业务提供军工级保护',
  'lumen.exportEngine.pg2.loading': '加载中...',
  'lumen.exportEngine.pg4.saveFailedTitle': '保存失败',
  'lumen.exportEngine.pg4.saveBarangFailed': '保存货物数据失败',
  'lumen.exportEngine.pg4.saveTabFailed': '保存标签页 {tab} 失败',
  'lumen.exportEngine.pg4.ajuMissing': 'AJU 编号尚不可用',
  'lumen.exportEngine.pg4.failedTitle': '失败',
  'lumen.exportEngine.pg4.printFormFailed': '打印表单失败',
  'lumen.exportEngine.pg4.ppjkNpwpMissing': '未找到 PPJK NPWP。请确认 PPJK 数据已正确填写。',
  'lumen.exportEngine.pg5.formDataMissing': '表单数据不可用，请先填写表单。',
  'lumen.exportEngine.pg5.submitSuccess': '出口文件已成功提交至 CEISA。',
  'lumen.exportEngine.pg5.submitFailed': '提交出口文件失败',
  'lumen.exportEngine.pg6.loadingPage': '正在加载页面',
  'lumen.exportEngine.pg6.back': '返回',
  'lumen.exportEngine.pg6.auditLogs': '审计日志',
  'lumen.exportEngine.pg6.lihatDiCeisa': '在 Ceisa 中查看',
  'lumen.exportEngine.pg6.syncHistoricalData': '与历史数据同步',
  'lumen.exportEngine.pg6.aksi': '操作',
  'lumen.exportEngine.pg6.cetak': '打印',
  'lumen.exportEngine.pg6.loadingEllipsis': '加载中...',
  'lumen.exportEngine.pg6.cetakDraftPeb': '打印 PEB 草稿',
  'lumen.exportEngine.pg6.submit': '提交',
  'lumen.exportEngine.pg6.transferNpe': '转移 (NPE)',
  'lumen.exportEngine.pg6.revisi': '修订',
  'lumen.exportEngine.pg6.submitKeCeisa': '提交到 Ceisa',
  'lumen.exportEngine.pg6.sebelumnya': '上一步',
  'lumen.exportEngine.pg6.selanjutnya': '下一步',
  'lumen.exportEngine.pg6.konfirmasi': '确认{type}',
  'lumen.exportEngine.pg6.transferWarning':
    '您即将进行转移 (NPE)。文件将作为最终版本提交至 CEISA，获得 NPE 后无法再修改。',
  'lumen.exportEngine.pg6.revisiWarning': '您即将修订文件。之前已提交的数据将在 CEISA 中更新。',
  'lumen.exportEngine.pg6.yaLanjutkan': '是，继续',
  'lumen.exportEngine.pg6.submissionProgress': '提交进度',
  'lumen.exportEngine.pg6.submittingToCeisa': '正在提交到 CEISA...',
  'lumen.exportEngine.pg6.submissionFailed': '提交失败',
  'lumen.exportEngine.pg6.close': '关闭',
  'lumen.exportEngine.pk1.originLoadingPortRequired': '必须选择原装货港',
  'lumen.exportEngine.pk1.exportLoadingPortRequired': '必须选择出口装货港',
  'lumen.exportEngine.pk1.destinationPortRequired': '必须选择目的港',
  'lumen.exportEngine.pk1.exportDestinationCountryRequired': '必须选择出口目的国',
  'lumen.exportEngine.pk1.estimatedExportDateRequired': '必须填写预计出口日期',
  'lumen.exportEngine.pk1.inspectionLocationRequired': '必须填写检验地点',
  'lumen.exportEngine.pk1.inspectionOfficeRequired': '必须选择检验办公室',
  'lumen.exportEngine.pk1.inspectionDateRequired': '必须填写检验日期',
  'lumen.exportEngine.pk1.wajibDiisi': '必填',
  'lumen.exportEngine.pk2.seri': '序号',
  'lumen.exportEngine.pk2.namaSarkut': '运输工具名称',
  'lumen.exportEngine.pk2.nomorPengangkut': '航次号',
  'lumen.exportEngine.pk2.caraPengangkutan': '运输方式',
  'lumen.exportEngine.pk2.bendera': '船旗',
  'lumen.exportEngine.pk2.aksi': '操作',
  'lumen.exportEngine.pk2.edit': '编辑',
  'lumen.exportEngine.pk2.delete': '删除',
  'lumen.exportEngine.pk2.saranaAngkut': '运输工具',
  'lumen.exportEngine.pk2.tambah': '添加',
  'lumen.exportEngine.pk2.pelabuhanMuatAsal': '原装货港',
  'lumen.exportEngine.pk2.pilihPelabuhanMuatAsal': '选择原装货港',
  'lumen.exportEngine.pk2.pelabuhanMuatEkspor': '出口装货港',
  'lumen.exportEngine.pk2.pilihPelabuhanMuatEkspor': '选择出口装货港',
  'lumen.exportEngine.pk2.tempatPenimbunan': '存放地点',
  'lumen.exportEngine.pk2.pilihTempatPenimbunan': '选择存放地点',
  'lumen.exportEngine.pk2.pilihKantorMuatDulu': '请先选择原装货海关办事处',
  'lumen.exportEngine.pk2.tanggalPerkiraanEkspor': '预计出口日期',
  'lumen.exportEngine.pk2.jenisPengangkutan': '运输类型',
  'lumen.exportEngine.pk2.pilihJenisPengangkutan': '选择运输类型',
  'lumen.exportEngine.pk2.pelabuhanTujuan': '目的港',
  'lumen.exportEngine.pk2.pilihPelabuhanTujuan': '选择目的港',
  'lumen.exportEngine.pk2.negaraTujuanEkspor': '出口目的国',
  'lumen.exportEngine.pk2.pilihNegaraTujuanEkspor': '选择出口目的国',
  'lumen.exportEngine.pk2.pemeriksaan': '检查',
  'lumen.exportEngine.pk2.lokasiPemeriksaan': '检查地点',
  'lumen.exportEngine.pk2.pilihLokasiPemeriksaan': '选择检查地点',
  'lumen.exportEngine.pk2.kantorPabeanPemeriksaan': '检查海关办事处',
  'lumen.exportEngine.pk2.pilihKantorPabeanPemeriksaan': '选择检查海关办事处',
  'lumen.exportEngine.pk2.tanggalPeriksa': '检查日期',
  'lumen.exportEngine.pk3.tambahPetiKemas': '添加集装箱',
  'lumen.exportEngine.pk3.seri': '序号',
  'lumen.exportEngine.pk3.nomor': '编号',
  'lumen.exportEngine.pk3.ukuran': '尺寸',
  'lumen.exportEngine.pk3.jenis': '种类',
  'lumen.exportEngine.pk3.tipe': '类型',
  'lumen.exportEngine.pk3.tambahKemasan': '添加包装',
  'lumen.exportEngine.pk3.jumlah': '数量',
  'lumen.exportEngine.pk3.merek': '品牌',
  'lumen.exportEngine.pk3.namaRequired': '运输工具名称为必填项',
  'lumen.exportEngine.pk3.caraRequired': '运输方式为必填项',
  'lumen.exportEngine.pk3.voyRequired': '航次/航班/车牌号为必填项',
  'lumen.exportEngine.pk3.benderaRequired': '船旗为必填项',
  'lumen.exportEngine.pk3.masukkanNamaDulu': '请先输入运输工具名称',
  'lumen.exportEngine.pk3.hanyaLaut': '仅海运可搜索船旗',
  'lumen.exportEngine.pk3.kodeNegaraGagal': '已找到船旗“{flagName}”，但无法获取国家代码。请手动选择船旗。',
  'lumen.exportEngine.pk3.benderaTidakDitemukan': '未找到该船舶的船旗',
  'lumen.exportEngine.pk3.gagalCari': '查询船旗失败。请手动选择船旗。',
  'lumen.exportEngine.pk3.editSaranaAngkut': '编辑运输工具',
  'lumen.exportEngine.pk3.tambahSaranaAngkut': '添加运输工具',
  'lumen.exportEngine.pk3.namaSaranaAngkut': '运输工具名称',
  'lumen.exportEngine.pk3.namaPlaceholder': '输入运输工具名称',
  'lumen.exportEngine.pk3.cariBendera': '查找船旗',
  'lumen.exportEngine.pk3.caraPengangkutan': '运输方式',
  'lumen.exportEngine.pk3.caraPlaceholder': '选择运输方式',
  'lumen.exportEngine.pk3.voyLabel': '航次 / 航班 / 车牌号',
  'lumen.exportEngine.pk3.voyPlaceholder': '输入航次/航班/车牌号',
  'lumen.exportEngine.pk3.bendera': '船旗',
  'lumen.exportEngine.pk3.benderaPlaceholder': '选择船旗',
  'lumen.exportEngine.pk4.seri': '序号',
  'lumen.exportEngine.pk4.jumlah': '数量',
  'lumen.exportEngine.pk4.jenis': '种类',
  'lumen.exportEngine.pk4.merek': '品牌',
  'lumen.exportEngine.pk4.nomor': '编号',
  'lumen.exportEngine.pk4.ukuran': '尺寸',
  'lumen.exportEngine.pk4.tipe': '类型',
  'lumen.exportEngine.pk4.aksi': '操作',
  'lumen.exportEngine.pk4.edit': '编辑',
  'lumen.exportEngine.pk4.copy': '复制',
  'lumen.exportEngine.pk4.delete': '删除',
  'lumen.exportEngine.pk4.kemasan': '包装',
  'lumen.exportEngine.pk4.petiKemas': '集装箱',
  'lumen.exportEngine.pk4.tambahKemasan': '添加包装',
  'lumen.exportEngine.pk4.tambahPetiKemas': '添加集装箱',
  'lumen.exportEngine.pk4.konfirmasiHapus': '确认删除',
  'lumen.exportEngine.pk4.hapusKemasanBody': '您确定要删除此包装吗？',
  'lumen.exportEngine.pk4.hapusPetiKemasBody': '您确定要删除此集装箱吗？',
  'lumen.exportEngine.pk4.hapus': '删除',
  'lumen.exportEngine.pk5.transaksi': '交易',
  'lumen.exportEngine.pk5.valuta': '货币',
  'lumen.exportEngine.pk5.pilihValuta': '选择货币',
  'lumen.exportEngine.pk5.ndpbm': 'NDPBM',
  'lumen.exportEngine.pk5.caraPenyerahan': '交货方式',
  'lumen.exportEngine.pk5.pilihCaraPenyerahan': '选择交货方式',
  'lumen.exportEngine.pk5.nilaiEksporFob': '出口价值（FOB 贸易术语）',
  'lumen.exportEngine.pk5.freight': '运费',
  'lumen.exportEngine.pk5.nilaiAsuransi': '保险价值',
  'lumen.exportEngine.pk5.asuransi': '保险',
  'lumen.exportEngine.pk5.jenisAsuransi': '保险类型',
  'lumen.exportEngine.pk5.dalamNegeri': '国内',
  'lumen.exportEngine.pk5.luarNegeri': '国外',
  'lumen.exportEngine.pk5.ratesHint': 'DJBC 标准运费和保险价值；手动输入不会被覆盖，除非重新计算。',
  'lumen.exportEngine.pk5.hitungFreightAsuransi': '计算运费和保险',
  'lumen.exportEngine.pk5.beratKotor': '毛重（KGM）',
  'lumen.exportEngine.pk5.beratBersih': '净重（KGM）',
  'lumen.exportEngine.pk5.nilaiMaklon': '加工费价值',
  'lumen.exportEngine.pk5.nilaiBeaKeluar': '出口关税价值',
  'lumen.exportEngine.pk5.infoBeaKeluar': '出口关税信息',
  'lumen.exportEngine.pk5.infoBeaKeluarText':
    '出口关税价值根据出口货物 HS 编码适用的出口关税税率自动计算（最新财政部规定），以印尼盾填写。',
  'lumen.exportEngine.pk5.hitungBeaKeluar': '计算出口关税',
  'lumen.exportEngine.pk5.nilaiPph22': '出口第 22 条所得税价值',
  'lumen.exportEngine.pk5.infoPph22': '第 22 条所得税信息',
  'lumen.exportEngine.pk5.infoPph22Text':
    '出口需缴纳第 22 条所得税时勾选（如煤炭、金属矿产、棕榈油出口）。价值按出口价值 × 最新 PMK 规定的第 22 条税率计算，以印尼盾计。',
  'lumen.exportEngine.pk5.nilaiPungutanSawit': '棕榈油征收价值',
  'lumen.exportEngine.pk5.infoPungutanSawit': '棕榈油征收信息',
  'lumen.exportEngine.pk5.infoPungutanSawitText': 'BPDPKS 对 CPO/棕榈油产品征收的出口税。请按适用税率以印尼盾填写。',
  'lumen.exportEngine.pk5.previewUnavailable': '出口关税预览不可用',
  'lumen.exportEngine.pk5.responseUnavailable': '出口关税响应不可用',
  'lumen.exportEngine.pk5.persistFailedFallback': '保存失败',
  'lumen.exportEngine.pk5.calcFailedTitle': '计算失败',
  'lumen.exportEngine.pk5.calcFailedFallback': '计算出口关税失败',
  'lumen.exportEngine.pk5.warningTitle': '警告',
  'lumen.exportEngine.pk5.savedRefreshFailed': '出口关税已保存，但最新数据未能自动重新加载。',
  'lumen.exportEngine.pk5.successTitle': '成功',
  'lumen.exportEngine.pk5.savedAmount': '出口关税 {amount} 已保存',
  'lumen.exportEngine.pk5.persistFailedTitle': '保存失败',
  'lumen.exportEngine.pk6.bankDevisa': '外汇银行',
  'lumen.exportEngine.pk6.tambah': '添加',
  'lumen.exportEngine.pk6.seri': '序号',
  'lumen.exportEngine.pk6.kodeBank': '银行代码',
  'lumen.exportEngine.pk6.namaBank': '银行名称',
  'lumen.exportEngine.pk6.aksi': '操作',
  'lumen.exportEngine.pk6.delete': '删除',
  'lumen.exportEngine.pk6.konfirmasiHapus': '确认删除',
  'lumen.exportEngine.pk6.hapusBankBody': '您确定要删除此外汇银行吗？',
  'lumen.exportEngine.pk6.hapus': '删除',
  'lumen.exportEngine.pk6.previewBeaKeluar': '出口关税预览',
  'lumen.exportEngine.pk6.totalBeaKeluar': '出口关税合计',
  'lumen.exportEngine.pk6.totalSummary': '美元 {usd} · NDPBM {ndpbm} · 期间 {periode}',
  'lumen.exportEngine.pk6.peringatan': '警告',
  'lumen.exportEngine.pk6.warningWithSeri': '{code} · 序号 {seri}：{message}',
  'lumen.exportEngine.pk6.warningNoSeri': '{code}：{message}',
  'lumen.exportEngine.pk6.periksaDataPendukung': '请检查出口关税的支持数据。',
  'lumen.exportEngine.pk6.posTarif': '税则号列',
  'lumen.exportEngine.pk6.uraian': '描述',
  'lumen.exportEngine.pk6.netto': '净重',
  'lumen.exportEngine.pk6.hpe': 'HPE',
  'lumen.exportEngine.pk6.tarifBk': '关税税率',
  'lumen.exportEngine.pk6.bkUsd': '关税（美元）',
  'lumen.exportEngine.pk6.bkIdr': '关税（印尼盾）',
  'lumen.exportEngine.pk6.status': '状态',
  'lumen.exportEngine.pk6.tidakAdaBaris': '没有计算行。',
  'lumen.exportEngine.pk6.nettoMt': '{n} 吨',
  'lumen.exportEngine.pk6.nettoKg': '{n} 千克',
  'lumen.exportEngine.pk6.usdAmount': '美元 {amount}',
  'lumen.exportEngine.pk6.staleHpe': 'HPE 已过期',
  'lumen.exportEngine.pk6.hpeMonthUsed': '使用的 HPE 月份：{month}',
  'lumen.exportEngine.pk6.bracketInfo': '{kelompok} · HR {min}-{max}',
  'lumen.exportEngine.pk6.terapkan': '应用',
  'lumen.exportEngine.pk6.tambahBankDevisa': '添加外汇银行',
  'lumen.exportEngine.pk6.pilihBank': '选择银行',
  'lumen.exportEngine.br1.hsFetchFailed': '获取HS编码详情失败',
  'lumen.exportEngine.br1.hsFetchError': '获取HS编码详情时出错',
  'lumen.exportEngine.br1.excelDownloaded': 'Excel 下载成功',
  'lumen.exportEngine.br1.excelDownloadFailed': 'Excel 下载失败',
  'lumen.exportEngine.br1.uploadExcelTitle': '上传 Excel',
  'lumen.exportEngine.br1.uploadingExcel': '正在上传 Excel 文件并刷新货物数据...',
  'lumen.exportEngine.br1.processIdMissing': '未找到流程 ID',
  'lumen.exportEngine.br1.uploadFailed': '上传失败',
  'lumen.exportEngine.br1.uploadRefreshing': '上传成功，正在加载最新数据...',
  'lumen.exportEngine.br1.uploadDone': 'Excel 上传成功，货物数据已更新',
  'lumen.exportEngine.br1.uploadRefreshFailed': '上传成功，但无法自动刷新视图。请刷新页面。',
  'lumen.exportEngine.br1.uploadExcelFailed': 'Excel 上传失败',
  'lumen.exportEngine.br2.seri': '序号',
  'lumen.exportEngine.br2.hs': 'HS编码',
  'lumen.exportEngine.br2.lartas': '限制品',
  'lumen.exportEngine.br2.uraian': '货物描述',
  'lumen.exportEngine.br2.satuan': '单位',
  'lumen.exportEngine.br2.kemasan': '包装',
  'lumen.exportEngine.br2.fob': 'FOB',
  'lumen.exportEngine.br2.nw': '净重',
  'lumen.exportEngine.br2.aksi': '操作',
  'lumen.exportEngine.br2.yes': '是',
  'lumen.exportEngine.br2.no': '否',
  'lumen.exportEngine.br2.kg': '公斤',
  'lumen.exportEngine.br2.copy': '复制',
  'lumen.exportEngine.br2.delete': '删除',
  'lumen.exportEngine.br3.itemCopyNotFound': '未找到要复制的项目',
  'lumen.exportEngine.br3.itemDeleteNotFound': '未找到要删除的项目',
  'lumen.exportEngine.br3.bulkDeleted': '已删除 {count} 个商品',
  'lumen.exportEngine.br3.bulkDeleteFailed': '删除商品失败',
  'lumen.exportEngine.br3.itemUpdated': '项目更新成功',
  'lumen.exportEngine.br3.itemAdded': '项目添加成功',
  'lumen.exportEngine.br3.processIdMissing': '未找到流程 ID',
  'lumen.exportEngine.br3.smartSyncTitle': 'Smart Sync',
  'lumen.exportEngine.br3.smartSyncStep1': '第 1/3 步：正在保存当前数据...',
  'lumen.exportEngine.br3.smartSyncStep2': '第 2/3 步：正在与 CEISA 同步数据...',
  'lumen.exportEngine.br3.smartSyncStep3': '第 3/3 步：正在获取已同步数据...',
  'lumen.exportEngine.br3.smartSyncDone': 'Smart Sync 已完成！已同步 {count} 个项目。',
  'lumen.exportEngine.br3.smartSyncRetrieveFailed': '获取已同步数据失败',
  'lumen.exportEngine.br3.smartSyncFailed': 'Smart Sync 失败',
  'lumen.exportEngine.br4.downloading': '正在下载...',
  'lumen.exportEngine.br4.downloadExcel': '下载 Excel',
  'lumen.exportEngine.br4.uploading': '正在上传...',
  'lumen.exportEngine.br4.uploadExcel': '上传 Excel',
  'lumen.exportEngine.br4.hsCodeDetails': 'HS 编码详情',
  'lumen.exportEngine.br4.basicInfo': '基本信息',
  'lumen.exportEngine.br4.tariffRates': '关税税率',
  'lumen.exportEngine.br4.preferentialTariffs': '优惠关税 ({count})',
  'lumen.exportEngine.br4.code': '编码:',
  'lumen.exportEngine.br4.normalizedCode': '标准化编码:',
  'lumen.exportEngine.br4.idDescription': '印尼语描述:',
  'lumen.exportEngine.br4.enDescription': '英语描述:',
  'lumen.exportEngine.br4.inswYear': 'INSW 年份:',
  'lumen.exportEngine.br4.lartas': 'LARTAS:',
  'lumen.exportEngine.br4.yes': '是',
  'lumen.exportEngine.br4.no': '否',
  'lumen.exportEngine.br4.issueDate': '签发日期:',
  'lumen.exportEngine.br4.effective': '生效:',
  'lumen.exportEngine.br4.historicalRates': '历史税率:',
  'lumen.exportEngine.br4.loadingHsCode': '正在加载 HS 编码详情...',
  'lumen.exportEngine.br5.total': '总计：{count}',
  'lumen.exportEngine.br5.filtered': '已筛选：{count}',
  'lumen.exportEngine.br5.smartSync': 'Smart Sync',
  'lumen.exportEngine.br5.syncing': '正在同步...',
  'lumen.exportEngine.br5.tambahBarang': '添加货物',
  'lumen.exportEngine.br5.searchPlaceholder': '按品名或 HS 编码搜索...',
  'lumen.exportEngine.br5.clearSearch': '清除搜索',
  'lumen.exportEngine.br5.tableAria': '货物列表',
  'lumen.exportEngine.br6.nilaiEksporFob': '出口价值（FOB 价值）',
  'lumen.exportEngine.br6.infoNilaiEksporAria': '出口价值说明',
  'lumen.exportEngine.br6.nilaiEksporInfo':
    '填写发票上按 FOB 贸易术语列明的每件货物出口价值，币种按“币种”栏填写。如使用 FOB 以外的贸易术语，所填出口价值为 FOB 价值。委托加工（maklon）服务出口的，出口价值栏按以下规定填写：使用出口成品（加工后）的价值。如出口成品的价值未知，则使用经加工的货物或原材料的进口价值加上委托加工服务的价值。填写示例见 Perdirjen No. PER-22/BC/2024 附录 I 第 34 页。',
  'lumen.exportEngine.br6.nilaiEksporPerSatuan': '每单位货物出口价值',
  'lumen.exportEngine.br6.incoterm': '贸易术语',
  'lumen.exportEngine.br6.beratBersih': '净重（公斤）',
  'lumen.exportEngine.br6.mataUang': '币种',
  'lumen.exportEngine.br6.totalNilaiFob': 'FOB 总价值（{currency}）',
  'lumen.exportEngine.br6.totalQuantity': '总数量',
  'lumen.exportEngine.br6.informasiDasar': '基本信息',
  'lumen.exportEngine.br6.detailHarga': '详情与价格',
  'lumen.exportEngine.br6.dokumenFasilitasLartas': '优惠/限制文件',
  'lumen.exportEngine.br6.entitasBarang': '货物主体',
  'lumen.exportEngine.br6.tambahBarang': '添加货物',
  'lumen.exportEngine.br6.simpanPerubahan': '保存更改',
  'lumen.exportEngine.br6.gagalMenambahkanBarang': '添加货物失败',
  'lumen.exportEngine.br6.lengkapiFieldWajib': '请填写以下必填字段：{fields}',
  'lumen.exportEngine.br7.seri': '序号',
  'lumen.exportEngine.br7.jumlahSatuan': '单位数量',
  'lumen.exportEngine.br7.jumlahSatuanPlaceholder': '单位数量',
  'lumen.exportEngine.br7.kodeSatuan': '单位代码',
  'lumen.exportEngine.br7.kodeSatuanPlaceholder': '单位代码',
  'lumen.exportEngine.br7.jumlahKemasan': '包装数量',
  'lumen.exportEngine.br7.jumlahKemasanPlaceholder': '包装数量',
  'lumen.exportEngine.br7.kodeKemasan': '包装代码',
  'lumen.exportEngine.br7.hsCode': 'HS 编码',
  'lumen.exportEngine.br7.lartas': '限制进出口',
  'lumen.exportEngine.br7.nonLartas': '非限制进出口',
  'lumen.exportEngine.br7.uraian': '描述',
  'lumen.exportEngine.br7.uraianPlaceholder': '货物描述',
  'lumen.exportEngine.br7.sesuaiHs': '与 HS 一致',
  'lumen.exportEngine.br7.kode': '代码',
  'lumen.exportEngine.br7.kodeProdukPlaceholder': '产品代码',
  'lumen.exportEngine.br7.merk': '品牌',
  'lumen.exportEngine.br7.tipe': '型号',
  'lumen.exportEngine.br7.ukuran': '尺寸',
  'lumen.exportEngine.br7.kodeJenisEkspor': '出口类型代码',
  'lumen.exportEngine.br7.negaraAsal': '货物原产国',
  'lumen.exportEngine.br7.negaraAsalPlaceholder': '原产国',
  'lumen.exportEngine.br7.daerahAsal': '货物原产地区',
  'lumen.exportEngine.br7.daerahAsalPlaceholder': '原产地区',
  'lumen.exportEngine.br8.dokumenCount': '文件：{count}',
  'lumen.exportEngine.br8.pemilikCount': '所有者：{count}',
  'lumen.exportEngine.br8.pilihDokumen': '选择文件...',
  'lumen.exportEngine.br8.pilihPemilik': '选择货物所有者...',
  'lumen.exportEngine.br8.tambah': '添加',
  'lumen.exportEngine.br8.tidakAdaDokumen': '没有可用文件',
  'lumen.exportEngine.br8.tidakAdaPemilik': '没有可用所有者',
  'lumen.exportEngine.br8.seri': '序号',
  'lumen.exportEngine.br8.jenis': '种类',
  'lumen.exportEngine.br8.nomor': '编号',
  'lumen.exportEngine.br8.tanggal': '日期',
  'lumen.exportEngine.br8.fasilitas': '设施',
  'lumen.exportEngine.br8.izin': '许可',
  'lumen.exportEngine.br8.aksi': '操作',
  'lumen.exportEngine.br8.nama': '名称',
  'lumen.exportEngine.br8.identitas': '身份',
  'lumen.exportEngine.br8.alamat': '地址',
  'lumen.exportEngine.br8.hapus': '删除',
  'lumen.exportEngine.br8.belumAdaDokumenDiTab': '文件选项卡中还没有文件。请先添加文件。',
  'lumen.exportEngine.br8.belumAdaDokumenDipilih': '尚未选择文件。请从上方下拉列表中选择文件。',
  'lumen.exportEngine.br8.belumAdaPemilikDiTab': '实体选项卡中还没有所有者。请先添加所有者。',
  'lumen.exportEngine.br8.belumAdaPemilikDipilih': '尚未选择所有者。请从上方下拉列表中选择所有者。',
  'lumen.exportEngine.br8.infoPemilik': '所有者实体来自实体选项卡中的货物所有者列表',
  'lumen.exportEngine.he2.pelabuhanLabel': '出口装货港',
  'lumen.exportEngine.he2.pelabuhanPlaceholder': '选择出口装货港',
  'lumen.exportEngine.he2.kantorAsalLabel': '原装货海关',
  'lumen.exportEngine.he2.kantorAsalPlaceholder': '选择原装货海关',
  'lumen.exportEngine.he2.jenisEksporLabel': '出口类型',
  'lumen.exportEngine.he2.jenisEksporPlaceholder': '选择出口类型',
  'lumen.exportEngine.he2.kantorEksporLabel': '出口装货海关',
  'lumen.exportEngine.he2.kantorEksporPlaceholder': '选择出口装货海关',
  'lumen.exportEngine.he2.kategoriEksporLabel': '出口类别',
  'lumen.exportEngine.he2.kategoriEksporPlaceholder': '选择出口类别',
  'lumen.exportEngine.he2.caraDagangLabel': '贸易方式',
  'lumen.exportEngine.he2.caraDagangPlaceholder': '选择贸易方式',
  'lumen.exportEngine.he2.caraBayarLabel': '付款方式',
  'lumen.exportEngine.he2.caraBayarPlaceholder': '选择付款方式',
  'lumen.exportEngine.he2.ketBayar': '付款说明',
  'lumen.exportEngine.he2.komoditiLabel': '商品类别',
  'lumen.exportEngine.he2.komoditiPlaceholder': '选择商品类别',
  'lumen.exportEngine.he2.curahLabel': '散装',
  'lumen.exportEngine.he2.curahPlaceholder': '选择散装',
  'lumen.exportEngine.he2.barangKirimanLabel': '快件货物出口',
  'lumen.exportEngine.he2.barangKirimanPlaceholder': '选择快件货物出口',
  'lumen.exportEngine.he2.pkbTitle': '货物集拼通知 (PKB)',
  'lumen.exportEngine.he2.pkbSubtitle': '出口类型 4、5 或 6 — 请填写 PKB 文件，或保存并使用模板以加快重复填写。',
  'lumen.exportEngine.he2.manageTemplate': '管理模板',
  'lumen.exportEngine.he2.isiPkb': '填写 PKB',
  'lumen.exportEngine.he3.title': 'PKB',
  'lumen.exportEngine.he3.permintaanPemeriksaan': '检验申请',
  'lumen.exportEngine.he3.pelaksanaanStuffing': '装箱实施',
  'lumen.exportEngine.he3.tanggal': '日期',
  'lumen.exportEngine.he3.dateFormat': 'DD-MM-YYYY',
  'lumen.exportEngine.he3.alamat': '地址',
  'lumen.exportEngine.he3.telepon': '电话',
  'lumen.exportEngine.he3.contactPerson': '联系人',
  'lumen.exportEngine.he3.jenisBarang': '货物类型',
  'lumen.exportEngine.he3.pilihJenisBarang': '选择货物类型',
  'lumen.exportEngine.he3.tempatSimpan': '存放地点',
  'lumen.exportEngine.he3.pilihTempatSimpan': '选择存放地点',
  'lumen.exportEngine.he3.petiKemas': '集装箱',
  'lumen.exportEngine.he3.feet20': '20 英尺',
  'lumen.exportEngine.he3.feet40': '40 英尺',
  'lumen.exportEngine.he3.caraStuffing': '装箱方式',
  'lumen.exportEngine.he3.pilihCaraStuffing': '选择装箱方式',
  'lumen.exportEngine.he3.halPartOf': '部分归属',
  'lumen.exportEngine.he3.pilihHalPartOf': '选择部分归属',
  'lumen.exportEngine.he3.tempat': '地点',
  'lumen.exportEngine.he3.hapus': '清除',
  'lumen.exportEngine.he4.manageTitle': '管理 PKB 模板',
  'lumen.exportEngine.he4.ppjkNpwp': 'PPJK NPWP:',
  'lumen.exportEngine.he4.addTemplate': '添加模板',
  'lumen.exportEngine.he4.colTemplateName': '模板名称',
  'lumen.exportEngine.he4.colCaraStuffing': '装箱方式',
  'lumen.exportEngine.he4.colPeti': '20ft / 40ft',
  'lumen.exportEngine.he4.colTempatStuffing': '装箱地点',
  'lumen.exportEngine.he4.colStatus': '状态',
  'lumen.exportEngine.he4.colActions': '操作',
  'lumen.exportEngine.he4.noNpwp': 'PPJK NPWP 不可用。请先在实体中填写 PPJK 数据。',
  'lumen.exportEngine.he4.loading': '正在加载模板...',
  'lumen.exportEngine.he4.noTemplates': '未找到模板',
  'lumen.exportEngine.he4.inactive': '停用',
  'lumen.exportEngine.he4.active': '启用',
  'lumen.exportEngine.he4.applyTemplate': '使用此模板',
  'lumen.exportEngine.he4.edit': '编辑',
  'lumen.exportEngine.he4.delete': '删除',
  'lumen.exportEngine.he4.deleteTitle': '删除模板',
  'lumen.exportEngine.he4.deleteConfirmPrefix': '确定要删除',
  'lumen.exportEngine.he4.thisTemplate': '此模板',
  'lumen.exportEngine.he4.deleteConfirmSuffix': '？此操作无法撤销。',
  'lumen.exportEngine.he4.cancel': '取消',
  'lumen.exportEngine.he4.editTitle': '编辑 PKB 模板',
  'lumen.exportEngine.he4.addTitle': '添加 PKB 模板',
  'lumen.exportEngine.he4.templateName': '模板名称',
  'lumen.exportEngine.he4.templateNamePlaceholder': '例如 LCL Priok 默认',
  'lumen.exportEngine.he4.activeSwitch': '启用',
  'lumen.exportEngine.he4.metaNote':
    '。模板存储可重复使用的 PKB 值。申请日期和装箱日期按每笔交易填写，请在 PKB 表单中填写。',
  'lumen.exportEngine.he4.permintaanPemeriksaan': '检验申请',
  'lumen.exportEngine.he4.alamat': '地址',
  'lumen.exportEngine.he4.telepon': '电话',
  'lumen.exportEngine.he4.contactPerson': '联系人',
  'lumen.exportEngine.he4.jenisBarang': '货物类型',
  'lumen.exportEngine.he4.pilihJenisBarang': '选择货物类型',
  'lumen.exportEngine.he4.tempatSimpan': '存放地点',
  'lumen.exportEngine.he4.pilihTempatSimpan': '选择存放地点',
  'lumen.exportEngine.he4.petiKemas': '集装箱',
  'lumen.exportEngine.he4.feet20': '20 英尺',
  'lumen.exportEngine.he4.feet40': '40 英尺',
  'lumen.exportEngine.he4.caraStuffing': '装箱方式',
  'lumen.exportEngine.he4.pilihCaraStuffing': '选择装箱方式',
  'lumen.exportEngine.he4.halPartOf': '部分',
  'lumen.exportEngine.he4.pilihHalPartOf': '选择部分',
  'lumen.exportEngine.he4.pelaksanaanStuffing': '装箱实施',
  'lumen.exportEngine.he4.tempat': '地点',
  'lumen.exportEngine.he4.saving': '保存中...',
  'lumen.exportEngine.he4.tambah': '添加',
  'lumen.exportEngine.dk1.fileFallback': '文件',
  'lumen.exportEngine.dk1.downloadAria': '下载 {label}',
  'lumen.exportEngine.dk1.uploadBlockedTitle': '暂时无法上传',
  'lumen.exportEngine.dk1.uploadBlockedMessage': '上传文件前请先保存文档行。',
  'lumen.exportEngine.dk1.formatTitle': '不支持的格式',
  'lumen.exportEngine.dk1.formatMessage': '仅允许 PDF 或 Excel 文件（.xlsx/.xls/.csv）。',
  'lumen.exportEngine.dk1.noUrl': '响应中不包含新的文件 URL',
  'lumen.exportEngine.dk1.successTitle': '成功',
  'lumen.exportEngine.dk1.uploaded': '{name} 已上传',
  'lumen.exportEngine.dk1.uploadFailed': '文件上传失败',
  'lumen.exportEngine.dk1.failedTitle': '失败',
  'lumen.exportEngine.dk2.colSeri': '序号',
  'lumen.exportEngine.dk2.colJenis': '类型',
  'lumen.exportEngine.dk2.colEcooStatus': 'eCOO 状态',
  'lumen.exportEngine.dk2.colNomor': '编号',
  'lumen.exportEngine.dk2.colTanggal': '日期',
  'lumen.exportEngine.dk2.colFasilitas': '设施',
  'lumen.exportEngine.dk2.colIjin': '许可',
  'lumen.exportEngine.dk2.colFile': '文件',
  'lumen.exportEngine.dk2.colAttached': '已关联',
  'lumen.exportEngine.dk2.colAksi': '操作',
  'lumen.exportEngine.dk2.attachTitle': '将文件关联到货物',
  'lumen.exportEngine.dk2.edit': '编辑',
  'lumen.exportEngine.dk2.copy': '复制',
  'lumen.exportEngine.dk2.uploadAria': '上传或替换文件',
  'lumen.exportEngine.dk2.uploadReplace': '上传 / 替换文件',
  'lumen.exportEngine.dk2.uploadFile': '上传文件',
  'lumen.exportEngine.dk2.delete': '删除',
  'lumen.exportEngine.dk2.attachIntro': '请选择此文件需要关联的货物项目：',
  'lumen.exportEngine.dk2.selectAllAria': '选择全部货物',
  'lumen.exportEngine.dk2.selectRowAria': '选择货物 {n}',
  'lumen.exportEngine.dk2.seriBarang': '货物序号',
  'lumen.exportEngine.dk2.hsCode': 'HS 编码',
  'lumen.exportEngine.dk2.namaBarang': '货物名称',
  'lumen.exportEngine.dk2.unnamed': 'UNNAMED',
  'lumen.exportEngine.dk2.noBarang': '暂无货物项目，请先添加货物项目。',
  'lumen.exportEngine.dk2.deleteTitle': '确认删除',
  'lumen.exportEngine.dk2.deleteBody': '确定要删除此文件吗？',
  'lumen.exportEngine.dk2.hapus': '删除',
  'lumen.exportEngine.dk2.tambahDokumen': '添加文件',
  'lumen.exportEngine.dk2.tableAria': '文件',
  'lumen.exportEngine.dk3.tambahDokumen': '添加文件',
  'lumen.exportEngine.dk3.seriDokumen': '文件序号',
  'lumen.exportEngine.dk3.seriDokumenPlaceholder': '文件序号',
  'lumen.exportEngine.dk3.jenisDokumen': '文件类型',
  'lumen.exportEngine.dk3.jenisDokumenPlaceholder': '选择文件类型',
  'lumen.exportEngine.dk3.nomorDokumen': '文件编号',
  'lumen.exportEngine.dk3.nomorDokumenPlaceholder': '输入文件编号',
  'lumen.exportEngine.dk3.tanggalDokumen': '文件日期',
  'lumen.exportEngine.dk3.fasilitas': '设施',
  'lumen.exportEngine.dk3.fasilitasPlaceholder': '选择设施',
  'lumen.exportEngine.dk3.ijin': '许可',
  'lumen.exportEngine.dk3.ijinPlaceholder': '输入许可代码',
  'lumen.exportEngine.dk3.batal': '取消',
  'lumen.exportEngine.dk3.simpan': '保存',
  'lumen.exportEngine.dk3.notSetTitle': '尚未设置声明',
  'lumen.exportEngine.dk3.notSetMessage': '您的 PPJK 尚无声明。请在 主数据 → 声明 中填写，然后重新同步。',
  'lumen.exportEngine.dk3.successTitle': '成功',
  'lumen.exportEngine.dk3.syncSuccess': '声明数据同步成功',
  'lumen.exportEngine.dk3.syncFailed': '同步声明数据失败',
  'lumen.exportEngine.dk3.title': '声明',
  'lumen.exportEngine.dk3.syncing': '同步中...',
  'lumen.exportEngine.dk3.syncButton': '同步声明',
  'lumen.exportEngine.dk3.legalHeading': '本人特此声明：',
  'lumen.exportEngine.dk3.legal1': '本人对本文件所通报事项的真实性以及作为其依据的海关辅助文件的有效性负责；并且',
  'lumen.exportEngine.dk3.legal2':
    '如在货物备妥通知日期后最迟 1（一）天内本人未到场见证实物查验，则本人授权 TPS 经营者代为见证，风险和费用由本人承担。',
  'lumen.exportEngine.dk3.signerHeading': '签署人信息',
  'lumen.exportEngine.dk3.nama': '姓名',
  'lumen.exportEngine.dk3.tanggal': '日期',
  'lumen.exportEngine.dk3.tempat': '地点',
  'lumen.exportEngine.dk3.jabatan': '职务',
  'lumen.exportEngine.en1.npwpKosongTitle': 'NPWP 为空',
  'lumen.exportEngine.en1.npwpKosongMsg': '请先输入出口商的 NPWP。',
  'lumen.exportEngine.en1.npwpBelumLengkapTitle': 'NPWP 不完整',
  'lumen.exportEngine.en1.npwpBelumLengkapMsg': '所选身份类型的 NPWP 必须为 {count} 位数字。',
  'lumen.exportEngine.en1.ditarikDariLumen': '已从 Lumen 获取出口商数据。',
  'lumen.exportEngine.en1.ditarikDariProfil': '已从公司资料获取出口商数据。',
  'lumen.exportEngine.en1.tidakDitemukanTitle': '未找到',
  'lumen.exportEngine.en1.tidakDitemukanMsg': '此 NPWP 没有数据。',
  'lumen.exportEngine.en1.gagalTitle': '失败',
  'lumen.exportEngine.en1.gagalMsg': '无法获取 NPWP 数据，请重试。',
  'lumen.exportEngine.en1.nomorIdentitas': '身份号码',
  'lumen.exportEngine.en1.alamat': '地址',
  'lumen.exportEngine.en1.hapus': '删除',
  'lumen.exportEngine.en2.eksportir': '出口商',
  'lumen.exportEngine.en2.penerima': '收货人',
  'lumen.exportEngine.en2.pembeli': '买方',
  'lumen.exportEngine.en2.jenis': '类型',
  'lumen.exportEngine.en2.jenisPlaceholder': '选择身份号码类型',
  'lumen.exportEngine.en2.npwpEksportir': '出口商 NPWP',
  'lumen.exportEngine.en2.nomorIdentitasPlaceholder': '输入身份号码',
  'lumen.exportEngine.en2.tarikNpwp': '获取 NPWP 数据',
  'lumen.exportEngine.en2.status': '状态',
  'lumen.exportEngine.en2.namaEksportir': '出口商名称',
  'lumen.exportEngine.en2.namaEksportirPlaceholder': '输入出口商名称',
  'lumen.exportEngine.en2.alamatEksportir': '出口商地址',
  'lumen.exportEngine.en2.alamatEksportirPlaceholder': '出口商地址',
  'lumen.exportEngine.en2.namaPenerima': '收货人名称',
  'lumen.exportEngine.en2.namaPenerimaPlaceholder': '输入收货人名称',
  'lumen.exportEngine.en2.alamatPenerima': '收货人地址',
  'lumen.exportEngine.en2.alamatPenerimaPlaceholder': '收货人地址',
  'lumen.exportEngine.en2.negaraPenerima': '收货人国家',
  'lumen.exportEngine.en2.negaraPenerimaPlaceholder': '选择收货人国家',
  'lumen.exportEngine.en2.salinPenerima': '复制收货人',
  'lumen.exportEngine.en2.namaPembeli': '买方名称',
  'lumen.exportEngine.en2.namaPembeliPlaceholder': '输入买方名称',
  'lumen.exportEngine.en2.alamatPembeli': '买方地址',
  'lumen.exportEngine.en2.alamatPembeliPlaceholder': '买方地址',
  'lumen.exportEngine.en2.negaraPembeli': '买方国家',
  'lumen.exportEngine.en2.negaraPembeliPlaceholder': '选择买方国家',
  'lumen.exportEngine.en3.ppjk': 'PPJK',
  'lumen.exportEngine.en3.jenisPlaceholder': '类型',
  'lumen.exportEngine.en3.nomorIdentitasPpjk': 'PPJK 身份号码',
  'lumen.exportEngine.en3.nomorIdentitasPpjkPlaceholder': 'PPJK 身份号码将自动填写',
  'lumen.exportEngine.en3.namaPpjk': 'PPJK 名称',
  'lumen.exportEngine.en3.namaPpjkPlaceholder': 'PPJK 名称将自动填写',
  'lumen.exportEngine.en3.alamatPpjk': 'PPJK 地址',
  'lumen.exportEngine.en3.alamatPpjkPlaceholder': 'PPJK 地址将自动填写',
  'lumen.exportEngine.en3.konsolidasi': '负责拼箱的一方',
  'lumen.exportEngine.en3.manageWarehouse': '管理仓库',
  'lumen.exportEngine.en3.lokasiKonsolidasi': '拼箱地点',
  'lumen.exportEngine.en3.lokasiBelumTersedia': 'PPJK 身份号码尚不可用。请稍候或刷新页面。',
  'lumen.exportEngine.en3.lokasiPlaceholder': '从列表中选择仓库...',
  'lumen.exportEngine.en3.kategori': '类别',
  'lumen.exportEngine.en3.kategoriPlaceholder': '选择类别代码',
  'lumen.exportEngine.en3.nomorIdentitasPlaceholder': '输入身份号码',
  'lumen.exportEngine.en3.nitku': 'NITKU',
  'lumen.exportEngine.en3.nitkuPlaceholder': '输入 NITKU',
  'lumen.exportEngine.en3.namaPlaceholder': '输入名称',
  'lumen.exportEngine.en3.alamatKonsolidasi': '拼箱地址',
  'lumen.exportEngine.en3.alamatKonsolidasiPlaceholder': '输入拼箱地址',
  'lumen.exportEngine.en3.total': '总计：{n}',
  'lumen.exportEngine.en3.salinEksportir': '复制出口商',
  'lumen.exportEngine.en3.pemilikBarang': '货物所有人',
  'lumen.exportEngine.en4.npwpDigitAlert': '所选身份类型的 NPWP 必须为 {expectedLength} 位数字',
  'lumen.exportEngine.en4.requiredAlert': '请填写所有必填字段',
  'lumen.exportEngine.en4.title': '添加货物所有人 - 出口商',
  'lumen.exportEngine.en4.jenisIdentitas': '身份类型',
  'lumen.exportEngine.en4.jenisIdentitasPlaceholder': '选择身份类型',
  'lumen.exportEngine.en4.nomorIdentitas': '身份号码',
  'lumen.exportEngine.en4.nomorIdentitasPlaceholder': '输入身份号码',
  'lumen.exportEngine.en4.syncCompanyProfile': '同步公司资料',
  'lumen.exportEngine.en4.namaPemilik': '所有人名称',
  'lumen.exportEngine.en4.namaPemilikPlaceholder': '输入所有人名称',
  'lumen.exportEngine.en4.alamatPemilik': '所有人地址',
  'lumen.exportEngine.en4.alamatPemilikPlaceholder': '输入所有人地址',
  'lumen.exportEngine.en4.entitasBarang': '货物实体',
  'lumen.exportEngine.en4.entitasBarangHint': '选择该所有人拥有的货物',
  'lumen.exportEngine.en4.tambah': '添加',
  'lumen.exportEngine.en4.seriBarang': '货物序号',
  'lumen.exportEngine.en4.hsCode': 'HS 编码',
  'lumen.exportEngine.en4.uraian': '描述',
  'lumen.exportEngine.en4.aksi': '操作',
  'lumen.exportEngine.en4.emptyTitle': '尚未选择货物',
  'lumen.exportEngine.en4.emptyHint': '点击“添加”按钮选择货物',
  'lumen.exportEngine.en4.tambahEntitasBarang': '添加货物实体',
  'lumen.exportEngine.en4.pilih': '选择',
  'lumen.exportEngine.en5.manageTitle': '管理集运仓库',
  'lumen.exportEngine.en5.ppjkNpwpCaption': 'PPJK NPWP：{npwp}',
  'lumen.exportEngine.en5.addWarehouse': '添加仓库',
  'lumen.exportEngine.en5.location': '地点',
  'lumen.exportEngine.en5.warehouseName': '仓库名称',
  'lumen.exportEngine.en5.nitku': 'NITKU',
  'lumen.exportEngine.en5.loading': '正在加载仓库...',
  'lumen.exportEngine.en5.empty': '未找到仓库',
  'lumen.exportEngine.en5.delete': '删除',
  'lumen.exportEngine.en5.deleteTitle': '删除仓库',
  'lumen.exportEngine.en5.deleteBodyBefore': '确定要删除',
  'lumen.exportEngine.en5.deleteBodyAfter': '？此操作无法撤销。',
  'lumen.exportEngine.en5.addTitle': '添加新仓库',
  'lumen.exportEngine.en5.editTitle': '编辑仓库',
  'lumen.exportEngine.en5.consoleLocation': '集运地点',
  'lumen.exportEngine.en5.consoleLocationPlaceholder': '输入地点',
  'lumen.exportEngine.en5.category': '类别',
  'lumen.exportEngine.en5.categoryPlaceholder': '选择类别',
  'lumen.exportEngine.en5.identityType': '身份类型',
  'lumen.exportEngine.en5.identityTypePlaceholder': '选择身份类型',
  'lumen.exportEngine.en5.identityNumber': '身份号码',
  'lumen.exportEngine.en5.identityNumberPlaceholder': '输入身份号码',
  'lumen.exportEngine.en5.nitkuPlaceholder': '输入 NITKU',
  'lumen.exportEngine.en5.warehouseNamePlaceholder': '输入仓库名称',
  'lumen.exportEngine.en5.warehouseAddress': '仓库地址',
  'lumen.exportEngine.en5.warehouseAddressPlaceholder': '输入仓库地址',
  'lumen.exportEngine.en5.updateWarehouse': '更新仓库',
  'lumen.exportEngine.en5.saveWarehouse': '保存仓库',
  'lumen.exportEngine.pt1.tabHeader': '标题',
  'lumen.exportEngine.pt1.tabEntitas': '实体',
  'lumen.exportEngine.pt1.tabDokumen': '文件',
  'lumen.exportEngine.pt1.tabPengangkut': '运输',
  'lumen.exportEngine.pt1.tabKemasan': '包装和集装箱',
  'lumen.exportEngine.pt1.tabTransaksi': '交易',
  'lumen.exportEngine.pt1.tabBarang': '货物',
  'lumen.exportEngine.pt1.tabPernyataan': '声明',
  'lumen.exportEngine.pt1.entityEksportir': '出口商',
  'lumen.exportEngine.pt1.entityPenerima': '收货人',
  'lumen.exportEngine.pt1.entityPembeli': '买方',
  'lumen.exportEngine.pt1.entityPpjk': 'PPJK',
  'lumen.exportEngine.pt1.entityKonsolidasi': '拼箱',
  'lumen.exportEngine.pt1.labelJenisIdentitas': '身份类型',
  'lumen.exportEngine.pt1.labelNpwp': 'NPWP',
  'lumen.exportEngine.pt1.labelNama': '名称',
  'lumen.exportEngine.pt1.labelAlamat': '地址',
  'lumen.exportEngine.pt1.labelStatus': '状态',
  'lumen.exportEngine.pt1.labelNegara': '国家',
  'lumen.exportEngine.pt1.fieldRequired': '{label}为必填项',
  'lumen.exportEngine.pt1.exportirName': '出口商名称为必填项',
  'lumen.exportEngine.pt1.exportirAddress': '出口商地址为必填项',
  'lumen.exportEngine.pt1.exportirIdentityType': '出口商身份类型为必填项',
  'lumen.exportEngine.pt1.exportirStatus': '出口商状态为必填项',
  'lumen.exportEngine.pt1.recipientName': '收货人名称为必填项',
  'lumen.exportEngine.pt1.recipientAddress': '收货人地址为必填项',
  'lumen.exportEngine.pt1.recipientCountry': '收货人国家为必填项',
  'lumen.exportEngine.pt1.buyerName': '买方名称为必填项',
  'lumen.exportEngine.pt1.buyerAddress': '买方地址为必填项',
  'lumen.exportEngine.pt1.buyerCountry': '买方国家为必填项',
  'lumen.exportEngine.pt1.ppjkName': 'PPJK名称为必填项',
  'lumen.exportEngine.pt1.ppjkAddress': 'PPJK地址为必填项',
  'lumen.exportEngine.pt1.ppjkIdentityType': 'PPJK身份类型为必填项',
  'lumen.exportEngine.pt1.ppjkIdentityNumber': 'PPJK NPWP为必填项',
  'lumen.exportEngine.pt1.entityHeadingOne': '{name}（{count} 个字段）',
  'lumen.exportEngine.pt1.entityHeadingMany': '{name}（{count} 个字段）',
  'lumen.exportEngine.pt1.kolomBelumLengkap': '有字段尚未填写完整',
  'lumen.exportEngine.pt1.hide': '隐藏',
  'lumen.exportEngine.pt1.show': '显示',
  'lumen.exportEngine.pt1.go': '前往',
  'lumen.exportEngine.pt1.view': '查看',
  'lumen.exportEngine.pt2.statusSelesai': '已完成',
  'lumen.exportEngine.pt2.statusTerkirim': '已提交',
  'lumen.exportEngine.pt2.statusDraft': '草稿',
  'lumen.exportEngine.pt2.npwpUnavailable': 'PPJK NPWP 不可用',
  'lumen.exportEngine.pt2.ajuCreated': 'AJU 号码创建成功',
  'lumen.exportEngine.pt2.ajuCreateFailed': '创建 AJU 号码失败',
  'lumen.exportEngine.pt2.ajuCopied': 'AJU 号码已复制到剪贴板',
  'lumen.exportEngine.pt2.ajuCopyFailed': '复制 AJU 号码失败',
  'lumen.exportEngine.pt2.ajuEmpty': 'AJU 号码不能为空',
  'lumen.exportEngine.pt2.ajuMinLength': 'AJU 号码至少需要 20 个字符',
  'lumen.exportEngine.pt2.title': '📋 AJU 号码 - 出口申报',
  'lumen.exportEngine.pt2.loading': '加载中...',
  'lumen.exportEngine.pt2.nomorAju': 'AJU 号码',
  'lumen.exportEngine.pt2.copyAria': '复制到剪贴板',
  'lumen.exportEngine.pt2.nomorAjuTerbaru': '最新 AJU 号码',
  'lumen.exportEngine.pt2.save': '保存',
  'lumen.exportEngine.pt2.areaHeader': '表头',
  'lumen.exportEngine.pt2.areaEntitas': '实体',
  'lumen.exportEngine.pt2.areaPengangkut': '运输工具',
  'lumen.exportEngine.pt2.areaTransaksi': '交易',
  'lumen.exportEngine.pt2.areaKemasan': '包装和集装箱',
  'lumen.exportEngine.pt2.rangeEmpty': '0 / 0',
  'lumen.exportEngine.pt2.range': '{from}-{to} / {total}',
  'lumen.exportEngine.pt2.appliedTitle': '已应用出口商数据',
  'lumen.exportEngine.pt2.appliedAreas': '已更新的标签页：{areas}。',
  'lumen.exportEngine.pt2.draftUpdated': '草稿已更新。',
  'lumen.exportEngine.pt2.applyFailed': '应用出口商数据失败',
  'lumen.exportEngine.pt2.failedTitle': '失败',
  'lumen.exportEngine.pt2.dataEksportir': '出口商数据',
  'lumen.exportEngine.pt2.dataEksportirHint': '从数据库选取，自动填写表头、实体和运输工具。',
  'lumen.exportEngine.pt2.pilihDariDatabase': '从数据库选择',
  'lumen.exportEngine.pt2.pilihEksportir': '选择出口商',
  'lumen.exportEngine.pt2.pilihPerusahaan': '选择用于此文件的出口商公司。',
  'lumen.exportEngine.pt2.searchPlaceholder': '按名称、NPWP、收货人或买方搜索',
  'lumen.exportEngine.pt2.showing': '显示 {range}',
  'lumen.exportEngine.pt2.loadFailed': '加载出口商列表失败。请刷新页面重试。',
  'lumen.exportEngine.pt2.noResults': '未找到出口商',
  'lumen.exportEngine.pt2.sebelumnya': '上一页',
  'lumen.exportEngine.pt2.selanjutnya': '下一页',
  'lumen.exportEngine.pt2.halaman': '第',
  'lumen.exportEngine.pt2.dari': '页，共',
  'lumen.exportEngine.pt2.dataBerikutAkan': '以下数据将被',
  'lumen.exportEngine.pt2.ditimpa': '覆盖',
  'lumen.exportEngine.pt2.overwriteNote1':
    '在表头中仅覆盖出口商的固定数据（出口类型和类别、贸易条款、付款方式、优惠设施、海关办公室、装货港）。AJU 号码、集装箱数量和装箱数据保持不变。标签页',
  'lumen.exportEngine.pt2.dan': '和',
  'lumen.exportEngine.pt2.overwriteNote2': '仅填充仍为空的部分 — 从文件中提取的数据不会丢失。',
  'lumen.exportEngine.pt2.terapkan': '应用',
  'lumen.exportEngine.pt2.pilihKartu': '请选择上方的一张出口商卡片以继续。',
  'lumen.exportEngine.fx1.fieldWajibDiisi': '此字段必填',
  'lumen.exportEngine.fx2.labelWithCurrency': '{label} - {currency}',
  // lumen.bc23Engine (revamp PR 8b)
  'lumen.bc23Engine.br1.titleError': '错误',
  'lumen.bc23Engine.br1.titleSuccess': '成功',
  'lumen.bc23Engine.br1.gagalHapusDokumen': '删除文件失败',
  'lumen.bc23Engine.br1.noItemsSelected': '未选择任何项目',
  'lumen.bc23Engine.br1.updatedOne': '已成功更新 {count} 个项目',
  'lumen.bc23Engine.br1.updatedMany': '已成功更新 {count} 个项目',
  'lumen.bc23Engine.br1.bulkEditFailed': '批量编辑失败',
  'lumen.bc23Engine.br1.fetchHsFailed': '获取 HS 编码详情失败',
  'lumen.bc23Engine.br1.fetchHsError': '获取 HS 编码详情时出错',
  'lumen.bc23Engine.br2.colJSatuan': '单位数量',
  'lumen.bc23Engine.br2.colTotalDokumen': '文件总数',
  'lumen.bc23Engine.br2.selectAllAria': '选择所有项目',
  'lumen.bc23Engine.br2.selectRowAria': '选择项目',
  'lumen.bc23Engine.br2.lihatDokumenAria': '查看文件',
  'lumen.bc23Engine.br4.noItemsToSync': '没有可同步的项目',
  'lumen.bc23Engine.br4.processIdMissing': '流程 ID 不可用，请重新加载页面。',
  'lumen.bc23Engine.br4.tariffsUpdated': '已更新 {count} 个项目的关税',
  'lumen.bc23Engine.br4.titleInfo': '提示',
  'lumen.bc23Engine.br4.noTariffYet': '暂无关税数据，提交时将计算关税。',
  'lumen.bc23Engine.br4.saveBeforeSyncFailed': '同步前保存商品数据失败',
  'lumen.bc23Engine.br4.refreshTariffFailed': '刷新关税数据失败，如有需要请重新加载页面。',
  'lumen.bc23Engine.br4.syncFailed': '同步关税和 LARTAS 数据失败',
  'lumen.bc23Engine.br5.itemUpdatedApplied': '商品已更新，更改已应用到 {count} 个HS编码相同或为空的商品',
  'lumen.bc23Engine.br5.itemUpdatedNoMatch': '商品已更新。没有其他商品的HS编码相同或为空，未应用更改。',
  'lumen.bc23Engine.br5.saveChangesFailed': '无法将更改保存到服务器，请重试。',
  'lumen.bc23Engine.br5.itemAdded': '商品添加成功',
  'lumen.bc23Engine.br5.saveNewItemFailed': '无法将新商品保存到服务器，请重试。',
  'lumen.bc23Engine.br6.hapusBarang': '删除商品',
  'lumen.bc23Engine.br6.tindakanTidakDapatDibatalkan': '此操作无法撤销',
  'lumen.bc23Engine.br6.yakinHapusBarang': '确定要删除以下商品吗？',
  'lumen.bc23Engine.br6.seriColon': '序号：',
  'lumen.bc23Engine.br6.uraianColon': '描述：',
  'lumen.bc23Engine.br6.hsCodeColon': 'HS 编码：',
  'lumen.bc23Engine.br6.hapus': '删除',
  'lumen.bc23Engine.br6.dokumenTerlampir': '附件文档',
  'lumen.bc23Engine.br6.seriInfoLine': '序号 {seri}：{uraian}',
  'lumen.bc23Engine.br6.dokumenFallback': '文档 {kode}',
  'lumen.bc23Engine.br6.colSeri': '序号',
  'lumen.bc23Engine.br6.colJenisDokumen': '文档类型',
  'lumen.bc23Engine.br6.colKode': '代码',
  'lumen.bc23Engine.br6.colNomorDokumen': '文档编号',
  'lumen.bc23Engine.br6.colTanggal': '日期',
  'lumen.bc23Engine.br6.colKodeFasilitas': '设施代码',
  'lumen.bc23Engine.br6.colNamaFasilitas': '设施名称',
  'lumen.bc23Engine.br6.colKodeIjin': '许可代码',
  'lumen.bc23Engine.br6.colAction': '操作',
  'lumen.bc23Engine.br6.hapusDokumenAria': '删除文档',
  'lumen.bc23Engine.br6.tidakAdaDokumen': '此商品没有附件文档',
  'lumen.bc23Engine.br6.tambahBarang': '添加商品',
  'lumen.bc23Engine.br6.editBarang': '编辑商品',
  'lumen.bc23Engine.br7.syncing': '同步中...',
  'lumen.bc23Engine.br7.syncLartasTarif': '同步 Lartas 和关税',
  'lumen.bc23Engine.br7.clearSearch': '清除搜索',
  'lumen.bc23Engine.br7.tableLabel': '货物列表',
  'lumen.bc23Engine.dk1.successTitle': '成功',
  'lumen.bc23Engine.dk1.errorTitle': '错误',
  'lumen.bc23Engine.dk1.documentAdded': '文档添加成功',
  'lumen.bc23Engine.dk1.documentUpdated': '文档更新成功',
  'lumen.bc23Engine.dk1.saveNewFailed': '保存新文档失败',
  'lumen.bc23Engine.dk1.saveEditedFailed': '保存已编辑的文档失败',
  'lumen.bc23Engine.dk2.successTitle': '成功',
  'lumen.bc23Engine.dk2.errorTitle': '错误',
  'lumen.bc23Engine.dk2.orderAlreadyCorrect': '文档顺序已正确',
  'lumen.bc23Engine.dk2.orderUpdated': '文档顺序更新成功',
  'lumen.bc23Engine.dk2.orderSaveFailed': '保存文档顺序失败',
  'lumen.bc23Engine.dk2.documentCopied': '文档复制成功',
  'lumen.bc23Engine.dk2.copyFailed': '保存复制的文档失败',
  'lumen.bc23Engine.dk2.documentDeleted': '文档删除成功',
  'lumen.bc23Engine.dk2.deleteFailed': '删除文档后保存更改失败',
  'lumen.bc23Engine.dk2.colSeri': '序号',
  'lumen.bc23Engine.dk2.colJenis': '类型',
  'lumen.bc23Engine.dk2.colEcooStatus': 'eCOO 状态',
  'lumen.bc23Engine.dk2.colNomor': '编号',
  'lumen.bc23Engine.dk2.colTanggal': '日期',
  'lumen.bc23Engine.dk2.colFasilitas': '优惠',
  'lumen.bc23Engine.dk2.colKodeIjin': '许可代码',
  'lumen.bc23Engine.dk2.colAttached': '已关联',
  'lumen.bc23Engine.dk2.colAksi': '操作',
  'lumen.bc23Engine.dk2.actionAttachToBarang': '关联到商品',
  'lumen.bc23Engine.dk2.actionEdit': '编辑',
  'lumen.bc23Engine.dk2.actionCopy': '复制',
  'lumen.bc23Engine.dk2.actionDelete': '删除',
  'lumen.bc23Engine.dk3.attachTitle': '将文件关联到商品',
  'lumen.bc23Engine.dk3.attachIntro': '选择此文件要关联到哪些商品：',
  'lumen.bc23Engine.dk3.selectAllAria': '选择全部商品',
  'lumen.bc23Engine.dk3.selectRowAria': '选择商品 {seri}',
  'lumen.bc23Engine.dk3.colSeriBarang': '商品序号',
  'lumen.bc23Engine.dk3.colHsCode': 'HS 编码',
  'lumen.bc23Engine.dk3.colNamaBarang': '商品名称',
  'lumen.bc23Engine.dk3.unnamed': '未命名',
  'lumen.bc23Engine.dk3.noBarang': '没有可用的商品。请先添加商品。',
  'lumen.bc23Engine.dk3.urutkanOtomatis': '自动排序',
  'lumen.bc23Engine.dk3.tambahDokumen': '添加文件',
  'lumen.bc23Engine.dk3.tableAria': '文件',
  'lumen.bc23Engine.eb2.simpanPerubahan': '保存更改',
  'lumen.bc23Engine.eb3.nonLartas': '非LARTAS',
  'lumen.bc23Engine.eb5.kodeJenisBm': 'BM 类型代码',
  'lumen.bc23Engine.eb5.tarifBm': 'BM 税率 (%)',
  'lumen.bc23Engine.eb5.tarifBmPlaceholder': '输入小数，如 2.5',
  'lumen.bc23Engine.eb5.jenisTarifBm': 'BM 税率类型',
  'lumen.bc23Engine.eb5.fasilitasTarifBm': 'BM 税率优惠',
  'lumen.bc23Engine.eb5.tarifPpn': '增值税税率 (%)',
  'lumen.bc23Engine.eb5.tarifPpnPlaceholder': '输入小数，如 11.5',
  'lumen.bc23Engine.eb5.fasilitasPpn': '增值税优惠',
  'lumen.bc23Engine.eb5.tarifPph': '所得税税率 (%)',
  'lumen.bc23Engine.eb5.tarifPphPlaceholder': '输入小数，如 2.5',
  'lumen.bc23Engine.eb5.fasilitasPph': '所得税优惠',
  'lumen.bc23Engine.eb5.bmt': 'BMT',
  'lumen.bc23Engine.eb5.bmad': 'BMAD',
  'lumen.bc23Engine.eb5.bmtp': 'BMTP',
  'lumen.bc23Engine.eb5.bmi': 'BMI',
  'lumen.bc23Engine.eb5.sementara': '临时',
  'lumen.bc23Engine.eb5.select': '选择',
  'lumen.bc23Engine.eb5.tarifAria': '税率',
  'lumen.bc23Engine.eb5.cukai': '消费税',
  'lumen.bc23Engine.eb5.komoditi': '商品',
  'lumen.bc23Engine.eb5.komoditiOption': '3 - 烟草制品',
  'lumen.bc23Engine.eb5.bosarTarif': '税率基数',
  'lumen.bc23Engine.eb5.jumlah': '数量',
  'lumen.bc23Engine.eb5.nilaiCukai': '消费税金额',
  'lumen.bc23Engine.eb5.hjeRp': '零售价 (Rp)',
  'lumen.bc23Engine.eb5.satuanKemasan': '包装单位',
  'lumen.bc23Engine.eb5.isiPerKemasan': '每包数量',
  'lumen.bc23Engine.eb5.jumlahPitaCukai': '税票数量',
  'lumen.bc23Engine.eb5.saldoAwal': '期初余额',
  'lumen.bc23Engine.eb5.saldoAkhir': '期末余额',
  'lumen.bc23Engine.he1.fieldJenis': '类型',
  'lumen.bc23Engine.he1.fieldNpwp': '{title} NPWP',
  'lumen.bc23Engine.he1.fieldNama': '{title}名称',
  'lumen.bc23Engine.he1.fieldNegara': '{title}国家',
  'lumen.bc23Engine.he1.fieldAlamat': '{title}地址',
  'lumen.bc23Engine.he1.fieldAfiliasi': '关联关系',
  'lumen.bc23Engine.he1.nitku': 'NITKU',
  'lumen.bc23Engine.he1.optAfl': 'AFL - 关联公司',
  'lumen.bc23Engine.he1.optCtr': 'CTR - 财务/法律控制',
  'lumen.bc23Engine.he1.optFam': 'FAM - 家庭成员',
  'lumen.bc23Engine.he1.optTah': 'TAH - 无关联',
  'lumen.bc23Engine.he2.titleImportir': '进口商/保税经营者',
  'lumen.bc23Engine.he2.fieldJenis': '类型',
  'lumen.bc23Engine.he2.fieldNpwpImportir': '进口商NPWP',
  'lumen.bc23Engine.he2.fieldNamaImportir': '进口商名称',
  'lumen.bc23Engine.he2.fieldStatus': '状态',
  'lumen.bc23Engine.he2.fieldApiNib': 'API/NIB',
  'lumen.bc23Engine.he2.fieldNib': 'NIB',
  'lumen.bc23Engine.he2.fieldAlamatImportir': '进口商地址',
  'lumen.bc23Engine.he2.fieldNomorIzinTpb': 'TPB许可证号',
  'lumen.bc23Engine.he2.fieldTanggalSkepTpb': 'TPB批准日期',
  'lumen.bc23Engine.he2.searchByNpwp': '按NPWP搜索进口商数据',
  'lumen.bc23Engine.he2.searchByName': '按名称搜索进口商数据',
  'lumen.bc23Engine.he3.pemasok': '供应商',
  'lumen.bc23Engine.he3.pemilikBarang': '货主',
  'lumen.bc23Engine.he3.ppjk': 'PPJK',
  'lumen.bc23Engine.he4.pelabuhanBongkar': '卸货港',
  'lumen.bc23Engine.he4.pilihPelabuhanBongkar': '选择卸货港',
  'lumen.bc23Engine.he4.tujuan': '目的',
  'lumen.bc23Engine.he4.pilihTujuan': '选择目的',
  'lumen.bc23Engine.he4.kantorPabeanBongkar': '卸货海关办公室',
  'lumen.bc23Engine.he4.pilihKantorPabeanBongkar': '选择卸货海关办公室',
  'lumen.bc23Engine.he4.kantorPabeanPengawas': '监管海关办公室',
  'lumen.bc23Engine.he4.pilihKantorPabeanPengawas': '选择监管海关办公室',
  'lumen.bc23Engine.he4.colPungutan': '税费',
  'lumen.bc23Engine.he4.colDibayar': '已支付',
  'lumen.bc23Engine.he4.colDitanggungPemerintah': '政府承担',
  'lumen.bc23Engine.he4.colDitunda': '延期',
  'lumen.bc23Engine.he4.colTidakDipungut': '不征收',
  'lumen.bc23Engine.he4.colDibebaskan': '免税',
  'lumen.bc23Engine.he4.colSudahDilunasi': '已结清',
  'lumen.bc23Engine.he4.title': '税费',
  'lumen.bc23Engine.he4.emptyTitle': '暂无数据',
  'lumen.bc23Engine.he4.emptyDescription': '目前没有可显示的记录。',
  'lumen.bc23Engine.pg5.downloadExcel': '下载 Excel',
  'lumen.bc23Engine.pg5.uploadExcel': '上传 Excel',
  'lumen.bc23Engine.pg5.updateDraftCeisa': '更新 CEISA 草稿',
  'lumen.bc23Engine.pg5.submitDraftCeisa': '提交 CEISA 草稿',
  'lumen.bc23Engine.pg5.idHeaderNotFound': '未找到头部 ID',
  'lumen.bc23Engine.pg5.draftPibDownloaded': 'PIB 草稿下载成功',
  'lumen.bc23Engine.pg5.draftPibDownloadFailed': 'PIB 草稿下载失败',
  'lumen.bc23Engine.pg7.securityTitle': '安全与隐私',
  'lumen.bc23Engine.pg7.securityBody': '您的数据已加密，归您所有',
  'lumen.bc23Engine.pg7.editItems': '编辑 {count} 个项目',
  'lumen.bc23Engine.pk1.vesselNameRequired': '请先输入船名',
  'lumen.bc23Engine.pk1.flagFound': '已找到船旗:{flag}',
  'lumen.bc23Engine.pk1.warningTitle': '警告',
  'lumen.bc23Engine.pk1.flagNotFound': '未找到该船舶的船旗信息',
  'lumen.bc23Engine.pk1.flagFetchFailed': '获取船旗信息失败',
  'lumen.bc23Engine.pk1.docNotFoundTitle': '未找到文件',
  'lumen.bc23Engine.pk1.docNotFoundMsg': '未找到提单(705)文件,请先添加提单文件。',
  'lumen.bc23Engine.pk1.docIncompleteTitle': '文件不完整',
  'lumen.bc23Engine.pk1.docIncompleteMsg': '提单文件必须同时有编号和日期。',
  'lumen.bc23Engine.pk1.manifestSuccessMsg': '已成功获取 BC 1.1 舱单数据',
  'lumen.bc23Engine.pk1.apiErrorTitle': 'API 错误',
  'lumen.bc23Engine.pk1.manifestRetrieveFailed': '获取舱单数据失败',
  'lumen.bc23Engine.pk1.manifestCallFailed': '调用 BC 1.1 舱单 API 失败,请重试。',
  'lumen.bc23Engine.pk1.tpsRequired': '必须选择堆存场所(TPS)',
  'lumen.bc23Engine.pk2.manifestBc11': 'BC 1.1 舱单',
  'lumen.bc23Engine.pk2.loadingData': '正在加载数据...',
  'lumen.bc23Engine.pk2.flagNameFromApi': '接口返回的船旗名称:',
  'lumen.bc23Engine.pk2.portOfLoadingFromApi': '接口返回的装货港:',
  'lumen.bc23Engine.pk2.useThisValue': '使用此值',
  'lumen.bc23Engine.pk3.seri': '序号',
  'lumen.bc23Engine.pk3.jumlah': '数量',
  'lumen.bc23Engine.pk3.jenis': '类型',
  'lumen.bc23Engine.pk3.merek': '品牌',
  'lumen.bc23Engine.pk3.aksi': '操作',
  'lumen.bc23Engine.pk3.edit': '编辑',
  'lumen.bc23Engine.pk3.copy': '复制',
  'lumen.bc23Engine.pk3.delete': '删除',
  'lumen.bc23Engine.pk4.seri': '序号',
  'lumen.bc23Engine.pk4.nomor': '编号',
  'lumen.bc23Engine.pk4.ukuran': '尺寸',
  'lumen.bc23Engine.pk4.jenis': '类型',
  'lumen.bc23Engine.pk4.tipe': '种类',
  'lumen.bc23Engine.pk4.aksi': '操作',
  'lumen.bc23Engine.pk4.edit': '编辑',
  'lumen.bc23Engine.pk4.copy': '复制',
  'lumen.bc23Engine.pk4.delete': '删除',
  'lumen.bc23Engine.pk4.kemasan': '包装',
  'lumen.bc23Engine.pk4.petiKemas': '集装箱',
  'lumen.bc23Engine.pk4.tambahKemasan': '添加包装',
  'lumen.bc23Engine.pk4.tambahPetiKemas': '添加集装箱',
  'lumen.bc23Engine.pk6.warningTitle': '警告',
  'lumen.bc23Engine.pk6.ndpbmRetrieveFailed': '无法获取 NDPBM 值，请手动输入。',
  'lumen.bc23Engine.pk6.errorTitle': '错误',
  'lumen.bc23Engine.pk6.ndpbmFetchFailed': '获取 NDPBM 时出错',
  'lumen.bc23Engine.pk7.harga': '价格',
  'lumen.bc23Engine.pk7.warningPastikanValuta': '请确认币种正确',
  'lumen.bc23Engine.pk7.valuta': '币种',
  'lumen.bc23Engine.pk7.pilihValuta': '选择币种',
  'lumen.bc23Engine.pk7.ndpbm': 'NDPBM',
  'lumen.bc23Engine.pk7.jenisTransaksi': '交易类型',
  'lumen.bc23Engine.pk7.pilihJenisTransaksi': '选择交易类型',
  'lumen.bc23Engine.pk7.incoterm': '国际贸易术语',
  'lumen.bc23Engine.pk7.pilihIncoterm': '选择国际贸易术语',
  'lumen.bc23Engine.pk7.hargaBarang': '货物价格',
  'lumen.bc23Engine.pk7.nilaiPabeanRupiah': '以印尼盾计的海关价值',
  'lumen.bc23Engine.pk7.informasiKomponenBiaya': '费用组成信息',
  'lumen.bc23Engine.pk7.hargaLainnya': '其他价格',
  'lumen.bc23Engine.pk7.biayaPenambahanCurrency': '附加费用 - {currency}',
  'lumen.bc23Engine.pk7.biayaPengurangCurrency': '扣减费用 - {currency}',
  'lumen.bc23Engine.pk7.freightCurrency': '运费 - {currency}',
  'lumen.bc23Engine.pk7.asuransi': '保险',
  'lumen.bc23Engine.pk7.nilaiAsuransiCurrency': '保险价值 - {currency}',
  'lumen.bc23Engine.pk7.voluntaryDeclaration': '自愿申报',
  'lumen.bc23Engine.pk7.berat': '重量',
  'lumen.bc23Engine.pk7.beratKotor': '毛重 (KGM)',
  'lumen.bc23Engine.pk7.beratBersih': '净重 (KGM)',
  'lumen.bc23Engine.pk7.keteranganPajak': '税务信息',
  'lumen.bc23Engine.pk7.jasaKenaPajak': '应税服务',
  'lumen.bc23Engine.pk7.jasaPembelianBkp': '1 - 购买应税货物',
  'lumen.bc23Engine.pk7.jasaPenerimaBkp': '2 - 应税货物服务接收方',
  'lumen.bc23Engine.pk9.assistTip':
    '当进口时已能确定该组成部分的价值且尚未包含在发票价格中时，填写“固定值”栏。当进口时尚无法确定该组成部分的价值时，填写“估计值 (VD)”栏，可使用 VD 机制在每个货物明细/货物序号中填写。',
  'lumen.bc23Engine.pk9.royaltiTip':
    '特许权使用费是为版权、专利等支付的款项，而许可证费是为使用某项技术或品牌的权利支付的款项。当进口时已能确定该组成部分的价值且尚未包含在发票价格中时，填写“固定值”栏。当进口时尚无法确定该组成部分的价值时，填写“估计值 (VD)”栏，可使用 VD 机制在每个货物明细/货物序号中填写。',
  'lumen.bc23Engine.pk9.proceedsTip':
    '收益是指转售、处置或使用货物所得中必须支付给卖方的部分。当进口时已能确定该组成部分的价值且尚未包含在发票价格中时，填写“固定值”栏。当进口时尚无法确定该组成部分的价值时，填写“估计值 (VD)”栏，可使用 VD 机制在每个货物明细/货物序号中填写。',
  'lumen.bc23Engine.pk9.transportTip':
    '填写运输/货运费用，以及尚未包含在运输费用中的装货、卸货和搬运费用。当进口时已能确定该组成部分的价值且尚未包含在发票价格中时，填写“固定值”栏。当进口时尚无法确定该组成部分的价值时，填写“估计值 (VD)”栏，可使用 VD 机制在每个货物明细/货物序号中填写。',
  'lumen.bc23Engine.pk9.asuransiTip':
    '选择保险类型：国内或国外。然后在右侧栏中填写保险价值。当进口时已能确定该组成部分的价值且尚未包含在发票价格中时，填写“固定值”栏。当进口时尚无法确定该组成部分的价值时，填写“估计值 (VD)”栏，可使用 VD 机制在每个货物明细/货物序号中填写。',
  'lumen.bc23Engine.pt1.tabHeader': '表头',
  'lumen.bc23Engine.pt1.tabEntitas': '实体',
  'lumen.bc23Engine.pt1.tabDokumen': '单据',
  'lumen.bc23Engine.pt1.tabPengangkut': '运输',
  'lumen.bc23Engine.pt1.tabKemasan': '包装与集装箱',
  'lumen.bc23Engine.pt1.tabTransaksi': '交易',
  'lumen.bc23Engine.pt1.tabBarang': '货物',
  'lumen.bc23Engine.pt1.tabPungutan': '税费',
  'lumen.bc23Engine.pt1.tabPernyataan': '声明',
  'lumen.bc23Engine.pt1.errorsBadge': '{count} 个错误',
  'lumen.bc23Engine.pt1.botAssistAria': '机器人协助',
  'lumen.bc23Engine.pt3.showPdf': '显示 PDF',
  'lumen.bc23Engine.pt3.iframeTitle': 'PDF 查看器 - {name}',
  // lumen.account (revamp PR 9a)
  'lumen.account.reviewer.loading': '加载中...',
  'lumen.account.reviewer.loadFailed': '加载请求失败。',
  'lumen.account.reviewer.statTotal': '请求总数',
  'lumen.account.reviewer.statPending': '待审核',
  'lumen.account.reviewer.statApproved': '已批准',
  'lumen.account.reviewer.statNeedRevision': '需要修改',
  'lumen.account.reviewer.statusWaiting': '待审核',
  'lumen.account.reviewer.statusApproved': '已批准',
  'lumen.account.reviewer.statusNeedRevision': '需要修改',
  'lumen.account.reviewer.statusRejected': '已拒绝',
  'lumen.account.reviewer.statusInvalidated': '已作废',
  'lumen.account.reviewer.statusScheduled': '已排期',
  'lumen.account.reviewer.colAju': 'AJU 编号',
  'lumen.account.reviewer.colVersion': '版本',
  'lumen.account.reviewer.colRequestedBy': '申请人',
  'lumen.account.reviewer.colRequestedAt': '申请时间',
  'lumen.account.reviewer.review': '审核',
  'lumen.account.reviewer.dashboardTitle': '审核员仪表板',
  'lumen.account.reviewer.dashboardDescription': '审核并批准 AJU 文件请求',
  'lumen.account.reviewer.allRequests': '所有请求',
  'lumen.account.reviewer.noRequests': '未找到审批请求。',
  'lumen.account.reviewer.colDescription': '描述',
  'lumen.account.reviewer.colEmailCount': '邮箱数量',
  'lumen.account.reviewer.viewGroup': '查看分组',
  'lumen.account.reviewer.editGroup': '编辑分组',
  'lumen.account.reviewer.editEmail': '编辑邮箱',
  'lumen.account.reviewer.toggleStatus': '切换邮箱状态',
  'lumen.account.reviewer.active': '启用',
  'lumen.account.reviewer.inactive': '停用',
  'lumen.account.reviewer.emailGroupsTitle': '邮件分组',
  'lumen.account.reviewer.emailGroupsDescription': '管理用于发送 AJU 草稿审批的邮件分组。',
  'lumen.account.reviewer.addGroup': '添加分组',
  'lumen.account.reviewer.editGroupTitle': '编辑分组',
  'lumen.account.reviewer.groupNamePlaceholder': '分组名称',
  'lumen.account.reviewer.groupDescriptionPlaceholder': '分组描述',
  'lumen.account.reviewer.cancel': '取消',
  'lumen.account.reviewer.update': '更新',
  'lumen.account.reviewer.save': '保存',
  'lumen.account.reviewer.groupDetail': '分组详情',
  'lumen.account.reviewer.editEmailTitle': '编辑邮箱',
  'lumen.account.reviewer.addEmail': '添加邮箱',
  'lumen.account.reviewer.recipientPlaceholder': '收件人姓名',
  'lumen.account.reviewer.emailPlaceholder': 'email@example.com',
  'lumen.account.reviewer.toolPencil': '铅笔',
  'lumen.account.reviewer.toolRectangle': '矩形',
  'lumen.account.reviewer.toolCircle': '圆形',
  'lumen.account.reviewer.toolArrow': '箭头',
  'lumen.account.reviewer.toolText': '文字',
  'lumen.account.reviewer.stopTool': '停止{tool}',
  'lumen.account.reviewer.undo': '撤销上一笔',
  'lumen.account.reviewer.clear': '清除所有批注',
  'lumen.account.reviewer.zoomOut': '缩小',
  'lumen.account.reviewer.zoomIn': '放大',
  'lumen.account.reviewer.notFound': '未找到请求。',
  'lumen.account.reviewer.backToDashboard': '返回仪表板',
  'lumen.account.reviewer.noAju': '无 AJU 编号',
  'lumen.account.reviewer.requestMeta': '版本 {version} · 申请人 {name}',
  'lumen.account.reviewer.pdfFailed': 'PDF 加载失败',
  'lumen.account.reviewer.pdfLoading': '正在加载文档...',
  'lumen.account.reviewer.reviewResult': '审核结果',
  'lumen.account.reviewer.reviewActions': '审核操作',
  'lumen.account.reviewer.notes': '备注',
  'lumen.account.reviewer.checklist': '修改清单',
  'lumen.account.reviewer.reviewedOn': '审核于 {date}',
  'lumen.account.reviewer.itemPlaceholder': '条目 {n}',
  'lumen.account.reviewer.removeItem': '删除条目',
  'lumen.account.reviewer.addItem': '添加条目',
  'lumen.account.reviewer.notesPlaceholder': '添加备注（可选）',
  'lumen.account.reviewer.approve': '批准',
  'lumen.account.reviewer.needRevision': '需要修改',
  'lumen.account.reviewer.textPlaceholder': '在此输入...',
  'lumen.account.support.allPriorities': '所有优先级',
  'lumen.account.support.allStatuses': '所有状态',
  'lumen.account.support.attachmentsHint': '每个文件最大 10MB。支持的格式：图片、PDF、文档、文本文件',
  'lumen.account.support.attachmentsLabel': '附件（可选）',
  'lumen.account.support.attachmentsPrompt': '上传截图、日志或其他文件',
  'lumen.account.support.autoCloseNote': '此窗口将在几秒后自动关闭',
  'lumen.account.support.buttonLabel': '需要帮助？创建支持工单',
  'lumen.account.support.cancel': '取消',
  'lumen.account.support.categoryAccount': '账户问题',
  'lumen.account.support.categoryBilling': '账单问题',
  'lumen.account.support.categoryBug': '缺陷报告',
  'lumen.account.support.categoryColon': '类别：',
  'lumen.account.support.categoryFallback': '一般',
  'lumen.account.support.categoryFeature': '功能请求',
  'lumen.account.support.categoryGeneral': '一般支持',
  'lumen.account.support.categoryLabel': '类别',
  'lumen.account.support.categoryPickPlaceholder': '选择类别',
  'lumen.account.support.categoryTechnical': '技术问题',
  'lumen.account.support.centerTitle': '支持中心',
  'lumen.account.support.clearFiles': '清除附件',
  'lumen.account.support.close': '关闭',
  'lumen.account.support.createFirst': '创建您的第一个工单',
  'lumen.account.support.descriptionLabel': '描述',
  'lumen.account.support.descriptionPlaceholder': '请详细描述您遇到的问题...',
  'lumen.account.support.descriptionRequired': '描述为必填项',
  'lumen.account.support.detailHeading': '工单详情：',
  'lumen.account.support.emptyTitle': '未找到支持工单',
  'lumen.account.support.filterHigh': '高',
  'lumen.account.support.filterLow': '低',
  'lumen.account.support.filterMedium': '中',
  'lumen.account.support.filterUrgent': '紧急',
  'lumen.account.support.helpBody':
    '请在下方描述您的问题，我们的支持团队将为您提供帮助。请尽可能提供详细信息，以便我们快速解决您的请求。',
  'lumen.account.support.helpTitle': '需要帮助？',
  'lumen.account.support.invalidDate': '日期无效',
  'lumen.account.support.loading': '加载中...',
  'lumen.account.support.na': '不适用',
  'lumen.account.support.noTitle': '无标题',
  'lumen.account.support.priorityColon': '优先级：',
  'lumen.account.support.priorityHigh': '高',
  'lumen.account.support.priorityLabel': '优先级',
  'lumen.account.support.priorityLow': '低',
  'lumen.account.support.priorityMedium': '中',
  'lumen.account.support.priorityPickPlaceholder': '选择优先级',
  'lumen.account.support.priorityPlaceholder': '按优先级筛选',
  'lumen.account.support.priorityUrgent': '紧急',
  'lumen.account.support.searchPlaceholder': '搜索工单...',
  'lumen.account.support.statusClosed': '已关闭',
  'lumen.account.support.statusColon': '状态：',
  'lumen.account.support.statusInProgress': '处理中',
  'lumen.account.support.statusOpen': '待处理',
  'lumen.account.support.statusPlaceholder': '按状态筛选',
  'lumen.account.support.statusResolved': '已解决',
  'lumen.account.support.statusUnknown': '未知',
  'lumen.account.support.submit': '创建工单',
  'lumen.account.support.submitting': '创建中...',
  'lumen.account.support.successDialogTitle': '支持工单已创建',
  'lumen.account.support.successFollowUp': '我们的支持团队将审核您的请求并尽快回复。',
  'lumen.account.support.successIntro': '您的支持工单已创建，工单号为：',
  'lumen.account.support.successTitle': '工单创建成功！',
  'lumen.account.support.tabCreate': '新建',
  'lumen.account.support.tabHistory': '我的工单',
  'lumen.account.support.titleLabel': '标题',
  'lumen.account.support.titlePlaceholder': '简要描述您的问题',
  'lumen.account.support.titleRequired': '标题为必填项',
  'lumen.account.support.viewTicket': '查看工单',
  'lumen.account.support.assigned': '已分配给：{name}',
  'lumen.account.support.attachFile': '附加文件',
  'lumen.account.support.attachmentCount': '📎 {n}',
  'lumen.account.support.avatarOther': 'U',
  'lumen.account.support.avatarYou': 'You',
  'lumen.account.support.bytes': '字节',
  'lumen.account.support.commentsCount': '评论（{n}）',
  'lumen.account.support.copyUrl': '复制网址',
  'lumen.account.support.detailFailed': '无法加载工单详情',
  'lumen.account.support.detailTitle': '工单详情',
  'lumen.account.support.downloadFailed': '下载失败：{message}',
  'lumen.account.support.downloadFallback': '无法下载附件',
  'lumen.account.support.downloadFile': '下载附件',
  'lumen.account.support.downloaded': '{fileName} 下载成功！',
  'lumen.account.support.downloading': '正在下载 {fileName}...',
  'lumen.account.support.hideInternal': '隐藏内部评论',
  'lumen.account.support.internalBadge': '内部',
  'lumen.account.support.messagePlaceholder': '输入您的消息...',
  'lumen.account.support.noComments': '暂无评论',
  'lumen.account.support.pageUrlRow': '📄 {url}',
  'lumen.account.support.pickedFiles': '附件（{n}）',
  'lumen.account.support.removeFile': '移除文件',
  'lumen.account.support.sendComment': '发送评论',
  'lumen.account.support.showInternal': '显示内部评论',
  'lumen.account.support.startConversation': '在下方开始对话',
  'lumen.account.support.toastError': '错误',
  'lumen.account.support.toastInfo': '提示',
  'lumen.account.support.toastSuccess': '成功',
  'lumen.account.support.unknownUser': '未知用户',
  'lumen.account.support.urlCopied': '页面网址已复制到剪贴板！',
  'lumen.account.support.urlCopyFailed': '无法复制网址',
  'lumen.account.support.zeroBytes': '0 字节',
  'lumen.account.credit.backToCredit': '返回积分页面',
  'lumen.account.credit.backToTopup': '返回充值页面',
  'lumen.account.credit.balanceEmpty': '没有余额数据',
  'lumen.account.credit.balanceError': '余额加载失败',
  'lumen.account.credit.balanceTitle': '您的余额',
  'lumen.account.credit.bankLabel': '选择银行',
  'lumen.account.credit.calculating': '正在计算费用…',
  'lumen.account.credit.cardOpen': '打开支付页面',
  'lumen.account.credit.cardRedirecting': '正在跳转到支付页面...',
  'lumen.account.credit.cardUnavailable': '支付链接不可用',
  'lumen.account.credit.cardUnavailableBody': '未找到支付链接。请联系客服或重试。',
  'lumen.account.credit.checkFailed': '检查支付状态失败。请重试。',
  'lumen.account.credit.checkStatus': '检查支付状态',
  'lumen.account.credit.copied': '已复制到剪贴板',
  'lumen.account.credit.copy': '复制',
  'lumen.account.credit.credit': '积分',
  'lumen.account.credit.creditsCount': '{n} 积分',
  'lumen.account.credit.creditsLabel': '积分数量',
  'lumen.account.credit.creditsPlaceholder': '输入积分数量',
  'lumen.account.credit.description': '购买用于 CEISA 和 NVOCC 申报的积分',
  'lumen.account.credit.errorTitle': '错误',
  'lumen.account.credit.failedToast': '请重试',
  'lumen.account.credit.feeLabel': '支付服务费',
  'lumen.account.credit.formTitle': '积分充值',
  'lumen.account.credit.invalidUrl': '支付链接无效',
  'lumen.account.credit.loadErrorToast': '支付详情加载失败',
  'lumen.account.credit.loadingDetails': '正在加载支付详情...',
  'lumen.account.credit.loadingProducts': '正在加载产品...',
  'lumen.account.credit.methodLabel': '支付方式',
  'lumen.account.credit.methodQris': 'QRIS',
  'lumen.account.credit.methodVa': '虚拟账户',
  'lumen.account.credit.missingParams': '支付参数不完整',
  'lumen.account.credit.missingParamsBody': '支付页面需要类型和参考号参数。请返回充值页面。',
  'lumen.account.credit.noProducts': '没有可用的积分产品',
  'lumen.account.credit.noReference': '未找到支付参考号',
  'lumen.account.credit.notFound': '未找到支付数据',
  'lumen.account.credit.notFoundBody': '未找到此参考号的支付数据。请返回充值页面。',
  'lumen.account.credit.notFoundToast': '未找到支付数据',
  'lumen.account.credit.paidToast': '积分已添加到您的账户',
  'lumen.account.credit.paymentTitle': '支付',
  'lumen.account.credit.priceLabel': '每积分价格：',
  'lumen.account.credit.productLabel': '选择产品',
  'lumen.account.credit.productOption': '{name} - {price}/积分',
  'lumen.account.credit.productPlaceholder': '选择积分套餐',
  'lumen.account.credit.qrisBody': '请用您的电子钱包应用扫描下方二维码：',
  'lumen.account.credit.qrisTitle': '扫描 QRIS',
  'lumen.account.credit.resolveError': '积分账户加载失败。使用默认账户。',
  'lumen.account.credit.statusFailed': '支付失败',
  'lumen.account.credit.statusLabel': '支付状态：',
  'lumen.account.credit.statusPaid': '支付成功',
  'lumen.account.credit.statusPending': '等待支付',
  'lumen.account.credit.submit': '继续支付',
  'lumen.account.credit.subtotal': '小计：',
  'lumen.account.credit.successTitle': '成功',
  'lumen.account.credit.tabSubscription': '订阅',
  'lumen.account.credit.tabTopup': '手动充值',
  'lumen.account.credit.title': '积分充值',
  'lumen.account.credit.topupFailed': '创建充值失败。请重试。',
  'lumen.account.credit.total': '应付总额：',
  'lumen.account.credit.totalCredit': '积分总数',
  'lumen.account.credit.vaInstruction': '请转账到下方的虚拟账户号码：',
  'lumen.account.credit.vaNote': '转账后，支付将在 1-5 分钟内自动处理。',
  'lumen.account.credit.warning': '警告',
  'lumen.account.subscription.virtualAccount': '虚拟账户',
  'lumen.account.subscription.qrisAlt': 'QRIS',
  'lumen.account.subscription.paymentSuccess': '支付成功',
  'lumen.account.subscription.paymentThanks': '谢谢！您的订阅账单已支付。',
  'lumen.account.subscription.amountPaid': '已付金额',
  'lumen.account.subscription.period': '周期',
  'lumen.account.subscription.invoiceNotFound': '未找到账单详情。',
  'lumen.account.subscription.creditsAdded': '已添加的积分',
  'lumen.account.subscription.creditsCount': '{n} 积分',
  'lumen.account.subscription.noCredits': '此套餐没有积分额度',
  'lumen.account.subscription.viewSubscription': '查看订阅',
  'lumen.account.subscription.startFiling': '开始申报',
  'lumen.account.support.userUnknown': '未知用户',
  'lumen.account.support.priorityFallback': '中',
};

// English is a partial dictionary on purpose: only the fixed UI chrome
// (language switcher, sidebar menus/badges/theme names, notification bell) is
// translated. Every other key falls back to Indonesian through `t()`.
//
// The draft audit drawer is a deliberate exception: it is a new user-facing
// surface, so `docpabean.audit.*` is filled in here in full rather than being
// left to fall back.
const en: TranslationDict = {
  // ---- App update ----
  'appUpdate.title': 'A new version is available',
  'appUpdate.message': 'Lumen has been updated. Reload the page to use the latest version.',
  'appUpdate.reload': 'Reload Now',

  // ---- Settings (personal + company) ----
  'settings.title': 'Settings',
  'settings.subtitle': 'Tailor Lumen to the way you work.',
  'settings.sectionPersonal': 'My Preferences',
  'settings.sectionCompany': 'Company Settings',
  'settings.docDetection': 'Automatic Document Type Detection',
  'settings.docDetectionDesc':
    'The system reads every uploaded document and fills in its type for you. Turn this off if you would rather pick the document type yourself.',
  'settings.docDetectionNote':
    'Applies to the PIB upload step. Guessing from the filename keeps working even with detection off.',
  'settings.docDetectionLockedNote':
    'This setting is locked by your company administrator. Contact them if you need it changed.',
  'settings.lockedByCompany': 'Locked by company',
  'settings.professionalMode': 'Professional Mode',
  'settings.professionalModeDesc': 'Hides Stamp Duty, Mini Games, and Trivia Game from the processing flow.',
  'settings.professionalModeNote': 'Switching reloads the page so the interface picks up your latest preference.',
  'settings.companyDocDetection': 'Company-wide detection default',
  'settings.companyDocDetectionDesc': 'Where detection starts for members who have never set it themselves.',
  'settings.companyLock': 'Lock this choice',
  'settings.companyLockDesc':
    'Members cannot change detection while it is locked. Their own choice is kept and takes effect again once you unlock it.',
  'settings.companyNote': 'Only company administrators see this section.',
  'settings.saveFailed': 'Could not save',
  'settings.saveFailedMsg': 'The company setting was not saved. Please try again.',
  // Language switcher
  'language.switcher': 'Language',
  'language.indonesia': 'Bahasa Indonesia',
  'language.english': 'English',
  'language.chinese': '中文',

  // Sidebar menus
  'menu.mgmtDashboard': 'Management Dashboard',
  'menu.manifest': 'Manifest',
  'menu.dashboard': 'Dashboard',
  'menu.buatAju': 'Create Declaration',
  'menu.draft': 'Draft',
  'menu.docManifes': 'Manifest Documents',
  'menu.theGuardian': 'The Guardian',
  'menu.radar': 'Radar',
  'menu.kepabeanan': 'Customs',
  'menu.docPabean': 'Customs Documents',
  'menu.monitoringBlokir': 'Block Monitoring',
  'menu.respon': 'Responses',
  'menu.databaseBarang': 'Goods Database',
  'menu.ppftz': 'PPFTZ',
  'menu.kuotaImporEkspor': 'Import / Export Quota',
  'menu.shipmentQuota': 'Shipment Quota',
  'menu.hargaReferensi': 'Reference Prices',
  'menu.cukai': 'Excise',
  'menu.tutorial': 'Tutorial',
  'menu.suratJalan': 'Delivery Note',
  'menu.dokumenCk': 'CK Documents',
  'menu.billOfMaterial': 'Bill of Material',
  'menu.inventori': 'Inventory',
  'menu.riskSelfCheck': 'Risk Self-Check',
  'menu.customerApproval': 'Customer Approval',
  'menu.approvalRequests': 'Approval Requests',
  'menu.emailGroups': 'Email Groups',
  'menu.reviewers': 'Reviewers',
  'menu.rolesPermissions': 'Roles & Permissions',
  'menu.creditTopup': 'Credit Top-up',
  'menu.langganan': 'Subscription',
  'menu.berita': 'News',
  'menu.antaraNews': 'Antara News',
  'menu.cnnIndonesia': 'CNN Indonesia',
  'menu.cnbcIndonesia': 'CNBC Indonesia',
  'menu.republikaNews': 'Republika News',
  'menu.kumparanNews': 'Kumparan News',
  'menu.voaNews': 'VOA News',
  'menu.layananLainnya': 'Other Services',
  'menu.stampDuty': 'Stamp Duty',
  'menu.miniGames': 'Mini Games',
  'menu.fileCompress': 'Compress Files',
  'menu.splitPdf': 'Split PDF',
  'menu.pengaturan': 'Settings',
  'menu.master': 'Master Data',
  'menu.ceisaUser': 'CEISA Users',
  'menu.user': 'Users',
  'menu.seaCarriers': 'Sea Carriers',
  'menu.email': 'Email',
  'menu.customerEmailForwarding': 'Customer Email Forwarding',
  'menu.statement': 'Statement',
  'menu.manifestReminder': 'Manifest Reminder',
  'menu.revokeAccess': 'Revoke Access',
  'menu.exportBank': 'Export Bank',
  'menu.riwayatPembaruan': 'Update History',

  // Sidebar badges
  'badge.new': 'New',
  'badge.bod': 'BOD',
  'badge.mulai': 'Start',
  'badge.aiReady': 'AI Ready',

  // Sidebar footer / controls
  'sidebar.manageAccount': 'Manage account',
  'sidebar.impersonate': 'Impersonate User',
  'sidebar.impersonating': 'Impersonating',
  'sidebar.changeTheme': 'Change Theme',
  'sidebar.theme': 'Theme',
  'theme.apex': 'APEX',
  'theme.apexNight': 'APEX Night',
  'theme.horizon': 'Horizon',
  'theme.horizonNight': 'Horizon Night',
  'theme.horizonDawn': 'Horizon Dawn',
  'theme.horizonDusk': 'Horizon Dusk',
  'theme.horizonMist': 'Horizon Mist',
  'sidebar.logout': 'Log out',
  'sidebar.loggingOut': 'Logging out...',
  'sidebar.collapse': 'Collapse sidebar',
  'sidebar.expand': 'Expand sidebar',
  'sidebar.quickSearch': 'Quick search...',
  'sidebar.noMatches': 'No matches',

  // Notification bell
  'notifications.bell.title': 'Notifications',
  'notifications.bell.aria': 'Email response notifications',
  'notifications.bell.markAllRead': 'Mark all as read',
  'notifications.bell.empty': 'No email responses yet',
  'notifications.bell.emptyHint': 'Incoming CEISA responses will appear here',
  'notifications.bell.loading': 'Loading notifications...',
  'notifications.bell.error': 'Failed to load notifications',
  'notifications.bell.retry': 'Try again',
  'notifications.bell.unreadCount': 'unread',
  'notifications.bell.new': 'New',
  'notifications.bell.ajuNumber': 'AJU Number',
  'notifications.bell.filterAll': 'All',
  'notifications.bell.filterUnread': 'Unread',
  'notifications.bell.emptyUnread': 'All caught up',
  'notifications.bell.emptyUnreadHint': 'No responses waiting to be opened',
  'notifications.bell.urgent': 'Urgent',
  'notifications.bell.download': 'Download',
  'notifications.bell.downloading': 'Downloading',
  'notifications.bell.downloaded': 'downloaded successfully',
  'notifications.bell.downloadFailed': 'Download failed',
  'notifications.bell.sinceLastResponse': 'since last response',
  'notifications.bell.lastResponseAt': 'Last response',
  // Entity history check — see the Indonesian block for the wording rules.
  'entitycheck.cocok': 'Matches',
  'entitycheck.perluDiperiksa': 'Please check',
  'entitycheck.tidakDicek': 'Not checked',
  'entitycheck.dariAkun': 'From your account',
  'entitycheck.samaDenganDokumen': 'Same as document',
  'entitycheck.bedaDariDokumen': 'Differs from document',
  'entitycheck.cocokDariNama': 'matched by name',
  'entitycheck.dokumen': 'Document',
  'entitycheck.dokumenSebelumnya': 'Previous document',
  'entitycheck.pakaiIni': 'Use this',
  'entitycheck.biarkanSaja': 'Keep mine',
  'entitycheck.belumAda': 'Not here yet',
  'entitycheck.tambahkan': 'Add',
  'entitasform.pilihDariRiwayat': 'Pick from document history',
  'entitasform.syncPerluDiperiksa': 'Differs from the last filing — pull the data from Lumen',
  'entitasform.dataConsigneeSumber': 'Consignee Data',
  'entitasform.bukaDiConsignee': 'Open in Consignee Data',
  'entitasform.bukaConsignee': 'Open Consignee Data',
  'entitasform.riwayatDokumenCount': 'Document history ({count})',
  'entitasform.diperbaruiTanggal': 'Updated {date}',
  'entitasform.belumAdaDiConsignee':
    'This importer is not in Master › Consignee Data yet. Once the document is accepted by CEISA, the importer is saved there automatically as the primary source.',
  'entitasform.belumAdaDiConsigneeSingkat':
    'Not in Consignee Data yet. Saved automatically once the document is accepted by CEISA.',
  'entitasform.dataMasterTidakBisaDitandai': 'Consignee Data is managed from the Master menu, not marked wrong here.',
  'entitasform.riwayatTidakDapatDimuat': 'Document history could not be loaded',
  'entitasform.dibukaDiTabBaru': 'Opens in a new tab: Master › Consignee Data',
  'entitasform.dataConsigneeSeksi': 'CONSIGNEE DATA',
  'entitasform.consigneeTerpakai': 'Consignee data applied to Importir.',
  'entitasform.simpanKeConsignee': 'Save to Consignee Data',
  'entitasform.simpanKeConsigneeHint': 'Save this importer so it fills in automatically on the next document.',
  'entitasform.tersimpanKeConsignee': 'Saved to Consignee Data',
  'entitasform.tersimpanKeConsigneeMsg': 'This importer will now fill in from its NPWP.',
  'entitasform.consigneeSudahAda': 'This NPWP is already in Consignee Data.',
  'entitasform.gagalSimpanConsignee': 'Could not save to Consignee Data.',

  // ---- Master: Data Consignee ----
  'menu.dataConsignee': 'Consignee Data',
  'consignee.title': 'Consignee Data',
  'consignee.subtitle': 'The importers you file for. Enter once, reuse across your documents.',
  'consignee.privacyTitle': 'Only for your PPJK',
  'consignee.tabOwn': 'My PPJK',
  'consignee.tabGlobal': 'All PPJKs',
  'consignee.colPpjk': 'PPJK',
  'consignee.globalNoticeTitle': 'Internal view, read-only',
  'consignee.globalNotice':
    'Consignees of every PPJK, visible to super admins only. To add or change a consignee, work as the PPJK that owns it.',
  'consignee.globalSearchPlaceholder': 'Search consignee, NPWP or PPJK',
  'consignee.privacyBody':
    'This list is stored for {company} (NPWP {npwp}) only. It is not shared with other PPJKs, not used to train anything, and only used to fill your documents.',
  'consignee.yourPpjk': 'your PPJK',
  'consignee.noPpjkTitle': 'No PPJK NPWP yet',
  'consignee.noPpjkMsg': 'Your account is not linked to a PPJK. Contact your administrator.',
  'consignee.loadFailedTitle': 'Could not load',
  'consignee.loadFailedMsg': 'The consignee list could not be loaded. Try again shortly.',
  'consignee.searchPlaceholder': 'Search name or NPWP',
  'consignee.total': '{n} consignees',
  'consignee.template': 'Template',
  'consignee.exportCurrent': 'Download current data',
  'consignee.uploadExcel': 'Upload Excel',
  'consignee.uploadIntro':
    'Download the template, fill it in Excel, then upload it. You will see what changes before anything is saved.',
  'consignee.add': 'Add',
  'consignee.addTitle': 'Add Consignee',
  'consignee.editTitle': 'Edit Consignee',
  'consignee.emptyTitle': 'No consignees yet',
  'consignee.emptyHint': 'Add them one by one, or upload all at once from Excel.',
  'consignee.colNama': 'Consignee Name',
  'consignee.colNpwp': 'NPWP',
  'consignee.colAlamat': 'Address',
  'consignee.colNib': 'NIB',
  'consignee.colJenisApi': 'API Type',
  'consignee.colStatus': 'Status',
  'consignee.colSumber': 'Source',
  'consignee.colDiperbarui': 'Updated',
  'consignee.colAksi': 'Actions',
  'consignee.sourceExcel': 'Excel',
  'consignee.sourceManual': 'Manual',
  'consignee.sourceCeisa': 'CEISA',
  'consignee.edit': 'Edit',
  'consignee.delete': 'Delete',
  'consignee.cancel': 'Cancel',
  'consignee.save': 'Save',
  'consignee.create': 'Add',
  'consignee.unknown': 'Unknown',
  'consignee.npwpHint': '15 or 16 digits. Dots and dashes are fine, they are cleaned up automatically.',
  'consignee.npwpStoredAs': 'Will be stored as {npwp}',
  'consignee.npwpInvalid': 'NPWP must be 15 or 16 digits',
  'consignee.nibInvalid': 'NIB must be 13 digits',
  'consignee.formInvalidTitle': 'Check the form',
  'consignee.formInvalidMsg': 'Name and NPWP are required and must be valid.',
  'consignee.savedTitle': 'Saved',
  'consignee.createdMsg': 'Consignee added.',
  'consignee.updatedMsg': 'Consignee updated.',
  'consignee.existsMsg': 'This NPWP is already in your list. Edit the existing row instead of adding a new one.',
  'consignee.saveFailedTitle': 'Could not save',
  'consignee.saveFailedMsg': 'The consignee was not saved. Try again.',
  'consignee.deleteTitle': 'Delete Consignee',
  'consignee.deleteConfirm': 'Remove {nama} from your list? It will no longer appear on new documents.',
  'consignee.deletedTitle': 'Deleted',
  'consignee.deletedMsg': 'Consignee removed from the list.',
  'consignee.deleteFailedMsg': 'The consignee was not deleted. Try again.',
  'consignee.downloadFailedTitle': 'Could not download',
  'consignee.downloadFailedMsg': 'The file could not be downloaded. Try again shortly.',
  'consigneeImport.dropTitle': 'Drop the Excel file here',
  'consigneeImport.dropHint': 'One .xlsx file, up to 5,000 rows',
  'consigneeImport.chooseFile': 'Choose file',
  'consigneeImport.onlyXlsx': 'Use a single Excel (.xlsx) file made from the template.',
  'consigneeImport.reading': 'Reading {file}',
  'consigneeImport.previewFailed': 'The file could not be read',
  'consigneeImport.previewStale': 'Consignee data changed, the preview may be out of date',
  'consigneeImport.reloadPreview': 'Reload preview',
  'consigneeImport.chooseOther': 'Choose another file',
  'consigneeImport.rowsSeen': '{n} rows',
  'consigneeImport.rowLabel': 'Row {n}',
  'consigneeImport.actionNew': 'new',
  'consigneeImport.actionUpdated': 'updated',
  'consigneeImport.actionUnchanged': 'unchanged',
  'consigneeImport.actionRejected': 'skipped',
  'consigneeImport.neverDeletes':
    'An upload never deletes. Rows missing from the file are left alone; blank cells never overwrite an existing value.',
  'consigneeImport.importN': 'Import {n} rows',
  'consigneeImport.importedTitle': 'Import finished',
  'consigneeImport.importedMsg': '{new} new, {updated} updated.',
  'consigneeImport.resultLine': '{new} new, {updated} updated, {unchanged} unchanged.',
  'consigneeImport.rejectedTitle': 'Skipped rows',
  'consigneeImport.failedTitle': 'Import failed',
  'consigneeImport.failedMsg': 'Nothing was saved. Try again.',
  'consigneeImport.uploadAnother': 'Upload another file',
  'menu.dataEksportir': 'Exporter Data',
  'eksportir.title': 'Exporter Data',
  'eksportir.subtitle': 'The exporters you file for. Enter once, reuse across your PEB documents.',
  'eksportir.privacyTitle': 'Only for your PPJK',
  'eksportir.tabOwn': 'My PPJK',
  'eksportir.tabGlobal': 'All PPJKs',
  'eksportir.colPpjk': 'PPJK',
  'eksportir.globalNoticeTitle': 'Internal view, read-only',
  'eksportir.globalNotice':
    'Exporters of every PPJK, visible to super admins only. To add or change an exporter, work as the PPJK that owns it.',
  'eksportir.globalSearchPlaceholder': 'Search exporter, identity number or PPJK',
  'eksportir.privacyBody':
    'This list is stored for {company} (NPWP {npwp}) only. It is not shared with other PPJKs, not used to train anything, and only used to fill your documents.',
  'eksportir.yourPpjk': 'your PPJK',
  'eksportir.noPpjkTitle': 'No PPJK NPWP yet',
  'eksportir.noPpjkMsg': 'Your account is not linked to a PPJK. Contact your administrator.',
  'eksportir.loadFailedTitle': 'Could not load',
  'eksportir.loadFailedMsg': 'The exporter list could not be loaded. Try again shortly.',
  'eksportir.searchPlaceholder': 'Search name or identity number',
  'eksportir.total': '{n} exporters',
  'eksportir.template': 'Template',
  'eksportir.exportCurrent': 'Download current data',
  'eksportir.uploadExcel': 'Upload Excel',
  'eksportir.uploadIntro':
    'Download the template, fill it in Excel, then upload it. You will see what changes before anything is saved.',
  'eksportir.add': 'Add',
  'eksportir.addTitle': 'Add Exporter',
  'eksportir.editTitle': 'Edit Exporter',
  'eksportir.emptyTitle': 'No exporters yet',
  'eksportir.emptyHint': 'Add them one by one, or upload all at once from Excel.',
  'eksportir.colNama': 'Exporter Name',
  'eksportir.colIdentitas': 'Identity',
  'eksportir.colJenisIdentitas': 'Identity Type',
  'eksportir.colNomorIdentitas': 'Identity Number',
  'eksportir.colAlamat': 'Address',
  'eksportir.colStatus': 'Status',
  'eksportir.colSumber': 'Source',
  'eksportir.colDiperbarui': 'Updated',
  'eksportir.colAksi': 'Actions',
  'eksportir.sourceExcel': 'Excel',
  'eksportir.sourceManual': 'Manual',
  'eksportir.sourceCeisa': 'CEISA',
  'eksportir.edit': 'Edit',
  'eksportir.delete': 'Delete',
  'eksportir.cancel': 'Cancel',
  'eksportir.save': 'Save',
  'eksportir.create': 'Add',
  'eksportir.unknown': 'Unknown',
  'eksportir.namaPlaceholder': 'PT. EXAMPLE',
  'eksportir.npwpHint': '15 or 16 digits. Dots and dashes are fine, they are cleaned up automatically.',
  'eksportir.identitasHint': 'Digits only. Anything else is removed automatically.',
  'eksportir.identitasStoredAs': 'Will be stored as {nomor}',
  'eksportir.npwpInvalid': 'NPWP must be 15 or 16 digits',
  'eksportir.ktpInvalid': 'KTP must be 16 digits',
  'eksportir.identitasEmpty': 'The identity number must contain digits',
  'eksportir.identitasTooLong': 'The identity number can have at most 50 digits',
  'eksportir.formInvalidTitle': 'Check the form',
  'eksportir.formInvalidMsg': 'Name and identity number are required and must be valid.',
  'eksportir.savedTitle': 'Saved',
  'eksportir.createdMsg': 'Exporter added.',
  'eksportir.updatedMsg': 'Exporter updated.',
  'eksportir.existsMsg': 'This identity is already in your list. Edit the existing row instead of adding a new one.',
  'eksportir.saveFailedTitle': 'Could not save',
  'eksportir.saveFailedMsg': 'The exporter was not saved. Try again.',
  'eksportir.deleteTitle': 'Delete Exporter',
  'eksportir.deleteConfirm': 'Remove {nama} from your list? It will no longer appear on new documents.',
  'eksportir.deletedTitle': 'Deleted',
  'eksportir.deletedMsg': 'Exporter removed from the list.',
  'eksportir.deleteFailedMsg': 'The exporter was not deleted. Try again.',
  'eksportir.downloadFailedTitle': 'Could not download',
  'eksportir.downloadFailedMsg': 'The file could not be downloaded. Try again shortly.',
  'eksportir.jenis.2': 'PASSPORT',
  'eksportir.jenis.3': 'KTP',
  'eksportir.jenis.4': 'OTHER',
  'eksportir.jenis.5': 'NPWP 15 DIGITS',
  'eksportir.jenis.6': 'NPWP 16 DIGITS',
  'eksportir.jenis.npwp': 'NPWP',
  'eksportir.status.1': 'COOPERATIVE',
  'eksportir.status.2': 'PMDN (OIL & GAS)',
  'eksportir.status.3': 'PMDN (NON OIL & GAS)',
  'eksportir.status.4': 'PMA (OIL & GAS)',
  'eksportir.status.5': 'PMA (NON OIL & GAS)',
  'eksportir.status.6': 'BUMN',
  'eksportir.status.7': 'BUMD',
  'eksportir.status.8': 'PRIVATE',
  'eksportir.status.9': 'JOINT VENTURE',
  'eksportir.status.10': 'OTHER',
  'eksportirImport.dropTitle': 'Drop the Excel file here',
  'eksportirImport.dropHint': 'One .xlsx file, up to 5,000 rows',
  'eksportirImport.chooseFile': 'Choose file',
  'eksportirImport.onlyXlsx': 'Use a single Excel (.xlsx) file made from the template.',
  'eksportirImport.reading': 'Reading {file}',
  'eksportirImport.previewFailed': 'The file could not be read',
  'eksportirImport.previewStale': 'Exporter data changed, the preview may be out of date',
  'eksportirImport.reloadPreview': 'Reload preview',
  'eksportirImport.chooseOther': 'Choose another file',
  'eksportirImport.rowsSeen': '{n} rows',
  'eksportirImport.rowLabel': 'Row {n}',
  'eksportirImport.actionNew': 'new',
  'eksportirImport.actionUpdated': 'updated',
  'eksportirImport.actionUnchanged': 'unchanged',
  'eksportirImport.actionRejected': 'skipped',
  'eksportirImport.neverDeletes':
    'An upload never deletes. Rows missing from the file are left alone; blank cells never overwrite an existing value.',
  'eksportirImport.importN': 'Import {n} rows',
  'eksportirImport.importedTitle': 'Import finished',
  'eksportirImport.importedMsg': '{new} new, {updated} updated.',
  'eksportirImport.resultLine': '{new} new, {updated} updated, {unchanged} unchanged.',
  'eksportirImport.rejectedTitle': 'Skipped rows',
  'eksportirImport.failedTitle': 'Import failed',
  'eksportirImport.failedMsg': 'Nothing was saved. Try again.',
  'eksportirImport.uploadAnother': 'Upload another file',
  'eksportirCard.dataEksportir': 'Exporter Data',
  'eksportirCard.dibukaDiTabBaru': 'Opens in a new tab: Master › Exporter Data',
  'eksportirCard.belumAda':
    'Not in Exporter Data yet. Saved automatically once the document is sent to CEISA successfully.',
  'eksportirCard.buka': 'Open Exporter Data',
  'eksportirCard.simpan': 'Save to Exporter Data',
  'eksportirCard.simpanHint': 'Save this exporter so it fills in automatically on the next documents.',
  'eksportirCard.tersimpan': 'Saved to Exporter Data',
  'eksportirCard.tersimpanMsg': 'This exporter will now fill in automatically from its identity number.',
  'eksportirCard.sudahAda': 'This identity is already in Exporter Data.',
  'eksportirCard.gagalSimpan': 'Could not save to Exporter Data.',
  'eksportirCard.diterapkanTitle': 'Applied',
  'eksportirCard.diterapkanMsg': 'Exporter Data applied to the Exporter card.',
  'statement.updatedBy': 'Updated by {email} on {date}',
  'statement.utama': 'Primary',
  'pernyataanform.notifyNoStatementTitle': 'No Pernyataan set up',
  'pernyataanform.notifyNoStatementMessage':
    'Your PPJK has no Pernyataan yet. Fill it in under Master → Pernyataan, then sync again.',
  'statement.tabOwn': 'My PPJK',
  'statement.tabGlobal': 'All PPJKs',
  'statement.staleSessionTitle': "Your account's PPJK has changed",
  'statement.staleSessionMsg':
    'This browser still holds your old PPJK ({stored}). Your account is now linked to {current}, which is what this tab shows and what your drafts use. Log out and back in so the rest of the app follows.',
  'statement.jadikanUtama': 'Make primary',
  'statement.jadikanUtamaBerhasil': '{name} is now the primary statement for new drafts.',
  'statement.jadikanUtamaGagal': 'Could not make it primary',
  'statement.nonaktifkanUtamaJudul': 'Deactivate the primary statement?',
  'statement.nonaktifkanUtamaPesan':
    'The earliest other active statement becomes primary for new drafts automatically.',
  'statement.nonaktifkanUtamaTanpaPengganti':
    'There is no other active statement. New drafts will not get a statement filled in automatically.',
  'statement.nonaktifkan': 'Deactivate',
  'statement.batal': 'Cancel',
  'statement.konflikJudul': 'A colleague just updated this statement',
  'statement.konflikDiperbaruiOleh': 'Updated by {email} on {date}',
  'statement.konflikDiperbaruiPada': 'Updated on {date}',
  'statement.kolomTempat': 'Place',
  'statement.kolomNama': 'Name',
  'statement.kolomJabatan': 'Position',
  'statement.konflikMuatUlang': 'Reload',
  'statement.konflikTimpa': 'Overwrite',
  'statement.konflikGagalMemuat': 'The latest values could not be loaded.',
  'statement.konflikMuatUlangDaftar': 'Reload list',
  'pernyataanform.pilihPernyataan': 'Choose statement',
  'pernyataanform.pilihPernyataanPlaceholder': 'Choose from Master › Statement',
  'pernyataanform.diubahManual': 'Current values were edited manually',
  'settings.sectionTampilan': 'Appearance',
  'settings.theme': 'Theme',
  'settings.themeDesc': 'App colours. Applies to your account only.',
  'settings.language': 'Language',
  'settings.languageDesc': 'Language of menus and app text.',
  'settings.textSize': 'Text size',
  'settings.textSizeDesc': 'Enlarge text and buttons across the app.',
  'settings.textSizeNormal': 'Normal',
  'settings.textSizeLarge': 'Large',
  'settings.textSizeLarger': 'Larger',
  'settings.textSizePreview':
    'Example: Nomor Aju 000020-001234-20260915-000041, Importer PT. CEMANI TOKA, Status SPPB.',
  'settings.textSizeNote': 'Changes apply immediately. Some dense tables feel tighter at the largest size.',

  // ---- Dok Pabean declaration PDF preview (table action) ----
  // New user-facing surface, so it is filled in here rather than falling back.
  'docpabean.export': 'Export',
  'docpabean.import': 'Import',
  'docpabean.tooltipPreviewPdf': 'Preview PDF',
  'docpabean.tooltipPreviewPdfNoAju': 'No AJU number yet',
  'docpabean.pdfPreview.title': '{doc} Preview',
  'docpabean.pdfPreview.kindFinal': 'Final (NOPEN)',
  'docpabean.pdfPreview.kindDraft': 'CEISA Draft',
  'docpabean.pdfPreview.fallbackTitle': 'Final document not available yet',
  'docpabean.pdfPreview.fallbackBody':
    'This document already has an NPE/SPPB, but the final form could not be fetched from CEISA. Showing the CEISA draft instead.',
  'docpabean.pdfPreview.loading': 'Fetching the document from CEISA…',
  'docpabean.pdfPreview.loadingHint':
    'If the document has not been generated before, CEISA needs time to prepare it — up to about a minute when CEISA is slow.',
  'docpabean.pdfPreview.docGeneric': 'Document',
  'docpabean.pdfPreview.refreshDraft': 'Refresh Draft',
  'docpabean.pdfPreview.download': 'Download',
  'docpabean.pdfPreview.openNewTab': 'Open in New Tab',
  'docpabean.pdfPreview.errorTitle': 'The document cannot be shown',
  'docpabean.pdfPreview.errorGeneric': 'Failed to fetch the document. Please try again.',
  'docpabean.pdfPreview.errorBilling': 'Subscription unpaid / insufficient credit — the preview cannot be opened.',
  'docpabean.pdfPreview.retry': 'Try Again',

  // ---- Draft change history (the "Audit Logs" drawer on the edit page) ----
  'docpabean.audit.title': 'Change History',
  'docpabean.audit.refresh': 'Reload',
  'docpabean.audit.count': '{n} changes',
  'docpabean.audit.loadMore': 'Load more ({n} left)',
  'docpabean.audit.unavailable': 'History is not available for this draft yet.',
  'docpabean.audit.subtitle.batch': 'Batch {uuid}',
  'docpabean.audit.subtitle.none': 'Draft not saved yet',
  'docpabean.audit.systemActor': 'System',
  'docpabean.audit.rowCount': '{n} rows',
  'docpabean.audit.empty': '(empty)',
  'docpabean.audit.yes': 'Yes',
  'docpabean.audit.no': 'No',
  'docpabean.audit.addedEntity': 'Added: {entity}',
  'docpabean.audit.removedEntity': 'Removed: {entity}',
  'docpabean.audit.showMoreFields': 'Show {n} more',
  'docpabean.audit.hideMoreFields': 'Hide',
  'docpabean.audit.showMoreValue': 'more',
  'docpabean.audit.showLessValue': 'less',
  'docpabean.audit.filter.tab.all': 'All',
  'docpabean.audit.filteredEmpty': 'No changes on this tab.',
  'docpabean.audit.empty.title': 'No history yet',
  'docpabean.audit.empty.body': 'Changes to this draft will appear here.',
  'docpabean.audit.error.title': 'Could not load the history',
  'docpabean.audit.error.body': 'The history could not be loaded. Please try again shortly.',
  'docpabean.audit.error.retry': 'Try again',
  'docpabean.audit.notFound.title': 'History not found',
  'docpabean.audit.notFound.body': 'This draft is not available for your account.',
  'docpabean.audit.forbidden.title': 'Account is not linked to a PPJK',
  'docpabean.audit.forbidden.body': 'Your account is not linked to a PPJK, so draft history cannot be shown.',
  'docpabean.audit.day.today': 'Today',
  'docpabean.audit.day.yesterday': 'Yesterday',
  'docpabean.audit.day.unknown': 'Unknown date',
  'docpabean.audit.time.justNow': 'Just now',
  'docpabean.audit.time.minutesAgo': '{n} minutes ago',
  'docpabean.audit.time.hoursAgo': '{n} hours ago',
  'docpabean.audit.time.daysAgo': '{n} days ago',
  'docpabean.audit.time.monthsAgo': '{n} months ago',
  'docpabean.audit.time.yearsAgo': '{n} years ago',
  'docpabean.audit.time.unknown': 'Unknown time',
  // AI extraction shows as three milestones only: no counts, no field names, no
  // values.
  'docpabean.audit.milestone.extractionStarted': 'AI extraction started by {name}',
  'docpabean.audit.milestone.extractionStartedAnon': 'AI extraction started',
  'docpabean.audit.milestone.extractionCompleted': 'AI extraction finished',
  'docpabean.audit.milestone.extractionFailed': 'AI extraction failed',
  'docpabean.audit.milestone.submitDraft': '{name} submitted the draft',
  'docpabean.audit.milestone.submitFinal': '{name} submitted the final document',
  'docpabean.audit.milestone.draftDeleted': '{name} deleted the draft',
  'docpabean.audit.milestone.documentFileUploaded': '{name} uploaded the file {file}',
  'docpabean.audit.milestone.documentFileUploadedAnon': 'File {file} was uploaded',
  'docpabean.audit.import.full': 'Excel · Full',
  'docpabean.audit.import.barangOnly': 'Excel · Barang Only',
  'docpabean.audit.import.allTabs': 'All tabs',
  'docpabean.audit.import.otherTab': 'No tab',
  'docpabean.audit.import.added': '{n} added',
  'docpabean.audit.import.changed': '{n} changed',
  'docpabean.audit.import.removed': '{n} removed',
  'docpabean.audit.import.fields': '{n} fields',
  'docpabean.audit.import.noChanges': 'No changes',
  'docpabean.audit.import.goodsReplaced': 'Goods list replaced with the sheet contents',
  'docpabean.audit.import.showPerTab': 'Show changes by tab',
  'docpabean.audit.import.hidePerTab': 'Hide changes by tab',
  'docpabean.audit.import.truncated': 'Showing the first 300 rows',
  'docpabean.audit.action.UPDATE': 'Changed',
  'docpabean.audit.action.CREATE': 'Added',
  'docpabean.audit.action.DELETE': 'Removed',
  'docpabean.audit.action.HISTORICAL_SYNC': 'Copied from history',
  'docpabean.audit.action.AI_APPLIED': 'AI filled in',
  'docpabean.audit.action.EXTRACTION_REQUESTED': 'Extraction started',
  'docpabean.audit.action.EXTRACTION_COMPLETED': 'Extraction finished',
  'docpabean.audit.action.EXTRACTION_FAILED': 'Extraction failed',
  'docpabean.audit.action.SUBMIT_DRAFT': 'Draft submitted',
  'docpabean.audit.action.SUBMIT_FINAL': 'Final document submitted',
  'docpabean.audit.action.DRAFT_DELETED': 'Draft deleted',
  'docpabean.audit.action.BULK_SUMMARY': 'Bulk change',
  'docpabean.audit.action.EXCEL_IMPORT': 'Excel upload',
  'docpabean.audit.entity.header': 'Header',
  'docpabean.audit.entity.entity': 'Entity',
  'docpabean.audit.entity.document': 'Document',
  'docpabean.audit.entity.carrier': 'Carrier',
  'docpabean.audit.entity.peti_kemas': 'Container',
  'docpabean.audit.entity.kemasan': 'Packaging',
  'docpabean.audit.entity.transaksi': 'Transaction',
  'docpabean.audit.entity.barang': 'Goods',
  'docpabean.audit.entity.statement': 'Statement',
  'docpabean.audit.entity.process': 'Process',
  'docpabean.audit.entity.barang_vd': 'Transaction type',
  'docpabean.audit.field.barang_vd.kodeJenisVd': 'Transaction type',
  'docpabean.audit.field.barang_vd.nilaiBarangVd': 'VD value',
  // A customs term, not UI copy: the CEISA form prints these words, so they are
  // the same in every language block rather than translated out of the document.
  'docpabean.audit.value.kondisiBarang1': 'Barang Baru',
  'docpabean.audit.value.kondisiBarang2': 'Bukan Barang Baru',
  'docpabean.audit.value.jenisApi01': 'API U',
  'docpabean.audit.value.jenisApi02': 'API P',
  'docpabean.audit.tab.header': 'Header',
  'docpabean.audit.tab.entitas': 'Entity',
  'docpabean.audit.tab.dokumen': 'Document',
  'docpabean.audit.tab.pengangkut': 'Carrier',
  'docpabean.audit.tab.kemasan': 'Packaging & Containers',
  'docpabean.audit.tab.transaksi': 'Transaction',
  'docpabean.audit.tab.barang': 'Goods',
  'docpabean.audit.tab.pungutan': 'Levies',
  'docpabean.audit.tab.pernyataan': 'Statement',

  // ---- Lumen UI components (src/components/lumen: button and accessibility labels) ----
  // ---- Lumen shell: top bar ----
  'lumen.topbar.openMenu': 'Open navigation menu',
  'lumen.topbar.switchToLight': 'Switch to light mode',
  'lumen.topbar.switchToDark': 'Switch to dark mode',
  'lumen.topbar.account': 'Account',
  'lumen.topbar.impersonateDescription': 'Search for a user and sign in as them. The page reloads afterwards.',
  'lumen.close': 'Close',
  'lumen.pagination.label': 'Pagination',
  'lumen.pagination.previous': 'Previous',
  'lumen.pagination.next': 'Next',
  'lumen.pagination.previousPage': 'Go to previous page',
  'lumen.pagination.nextPage': 'Go to next page',
  'lumen.pagination.morePages': 'More pages',

  // ---- Lumen table system (src/components/data-table) ----
  // The first six replace the old SharedDataTable / mantine-datatable copy.
  'lumen.table.pageSize': 'Records per page',
  'lumen.table.range': '{from} - {to} / {total}',
  'lumen.table.loading': 'Loading data...',
  'lumen.table.noRecords': 'No records',
  'lumen.table.emptyTitle': 'No data available',
  'lumen.table.emptyDescription': 'There are no records to display at the moment.',
  'lumen.table.pageLink': 'Page {n}',
  'lumen.table.selected': '{n} selected',
  'lumen.table.clearSelection': 'Clear selection',
  'lumen.table.selectAll': 'Select all rows on this page',
  'lumen.table.selectRow': 'Select row',
  'lumen.table.selectRowNamed': 'Select {name}',
  'lumen.table.search': 'Search',
  'lumen.table.columns': 'Columns',
  'lumen.table.resetColumns': 'Reset columns',
  'lumen.table.filter': 'Filters',
  'lumen.table.hideFilter': 'Hide filters',
  'lumen.table.resetFilters': 'Reset',
  'lumen.table.activeFilters': 'Active filters',
  'lumen.table.removeFilter': 'Remove filter {label}',
  'lumen.table.clearFilters': 'Clear all filters',

  // ---- Lumen common copy (shared parts cleanup) ----
  // Words more than one list page uses. Each value is the value of the page key it replaces, in this
  // language (those were the old pages' literals, verbatim in every language): `cancel` / `save` are the
  // master pages' "Cancel" / "Save", `batal` / `simpan` the approval pages' "Batal" / "Simpan".
  'lumen.common.actions': 'Actions',
  'lumen.common.active': 'Active',
  'lumen.common.inactive': 'Inactive',
  'lumen.common.status': 'Status',
  'lumen.common.edit': 'Edit',
  'lumen.common.deactivate': 'Deactivate',
  'lumen.common.viewDetails': 'View Details',
  'lumen.common.create': 'Create',
  'lumen.common.save': 'Save',
  'lumen.common.cancel': 'Cancel',
  'lumen.common.simpan': 'Simpan',
  'lumen.common.batal': 'Batal',
  'lumen.common.update': 'Update',
  'lumen.common.success': 'Success',
  'lumen.common.error': 'Error',
  'lumen.common.requiredFields': 'Please fill in all required fields',
  'lumen.common.total': 'Total: {n} records',
  'lumen.common.name': 'Name',
  'lumen.common.email': 'Email',
  'lumen.common.emailPlaceholder': 'email@example.com',
  'lumen.common.username': 'Username',
  'lumen.common.password': 'Password',
  'lumen.common.editEmail': 'Edit Email',
  'lumen.common.motType': 'MOT Type',
  'lumen.common.ppjk': 'PPJK: {n}',
  'lumen.common.ppjkNpwp': 'PPJK NPWP',
  'lumen.common.ppjkRequiredTitle': 'PPJK NPWP Required',
  'lumen.common.ppjkRequiredBody': 'No PPJK NPWP found for your account. Please contact your administrator.',

  // ---- Lumen chart parts (dashboards PR 5) ----
  // Labels the chart parts in src/components/charts add, translated (like lumen.table.*).
  'lumen.chart.updating': 'Updating…',

  // ---- Lumen /dashboard (dashboards PR 5) ----
  // The old page's literal text, verbatim in every language (copy unchanged). {error}, {n}, {v} and {pct} are
  // filled with formatTemplate.
  'lumen.dashboard.title': 'Operational Dashboard',
  'lumen.dashboard.subtitle': 'Overview aktivitas, performa, dan tren operasional',
  'lumen.dashboard.selectPpjk': 'Select PPJK',
  'lumen.dashboard.ppjkNotFound': 'PPJK tidak ditemukan',
  'lumen.dashboard.pickStartDate': 'Pick start date',
  'lumen.dashboard.pickEndDate': 'Pick end date',
  'lumen.dashboard.loading': 'Loading dashboard...',
  'lumen.dashboard.error': 'Error: {error}',
  'lumen.dashboard.graphView': 'Graph View',
  'lumen.dashboard.userStats': 'User Stats',
  'lumen.dashboard.loadingCharts': 'Loading charts...',
  'lumen.dashboard.loadingStats': 'Loading stats...',
  'lumen.dashboard.usageTrend': 'Usage Trend',
  'lumen.dashboard.usageTrendDescription': 'Daily AJU submissions over time',
  'lumen.dashboard.loadingGraph': 'Loading graph data...',
  'lumen.dashboard.noGraphData': 'No graph data available for the selected date range.',
  'lumen.dashboard.ajuCount': '{n} AJU',
  'lumen.dashboard.totalAju': 'Total AJU',
  'lumen.dashboard.dailyAverage': 'Daily Average',
  'lumen.dashboard.peakDay': 'Peak Day',
  'lumen.dashboard.loadingUserStats': 'Loading user stats...',
  'lumen.dashboard.noUserStats': 'No user statistics available for the selected date range.',
  'lumen.dashboard.totalUsers': 'Total Users',
  'lumen.dashboard.avgPerUser': 'Avg per User',
  'lumen.dashboard.topPerformance': 'Top Performance',
  'lumen.dashboard.userPerformance': 'User Performance',
  'lumen.dashboard.topN': 'Top {n}',
  'lumen.dashboard.distribution': 'Distribution',
  'lumen.dashboard.others': 'Others',
  'lumen.dashboard.ajuShare': '{v} AJU ({pct}%)',
  'lumen.dashboard.topPerformers': 'Top Performers',
  'lumen.dashboard.rank': '#{n}',

  // ---- Lumen master/email ----
  // The old page's literal English, verbatim in every language (copy unchanged).
  'lumen.masterEmail.searchPlaceholder': 'Search by email...',
  'lumen.masterEmail.add': 'Add Email',
  'lumen.masterEmail.emailType': 'Email Type',
  'lumen.masterEmail.branch': 'Branch',
  'lumen.masterEmail.emailPlaceholder': 'user@example.com',
  'lumen.masterEmail.updated': 'Email updated successfully',
  'lumen.masterEmail.updateFailed': 'Failed to update email',
  'lumen.masterEmail.created': 'Email created successfully',
  'lumen.masterEmail.createFailed': 'Failed to create email',
  'lumen.masterEmail.emailRequired': 'Please fill in the email field',
  'lumen.masterEmail.deactivated': 'Email deactivated successfully',
  'lumen.masterEmail.deactivateFailed': 'Failed to deactivate email',

  // ---- Lumen auth ----
  // Sign-in, MFA dialogs and the reviewer sign-in (src/app/(auth), src/components/auth-frame, mfa-dialogs).
  // Most values are the old pages' literal copy, moved verbatim and identical in every language (copy
  // unchanged); translating them is a copy change. New labels: showPassword, hidePassword, loginFailed,
  // otpLabel, setup.steps, setup.qrLabel.
  'lumen.auth.showPassword': 'Show password',
  'lumen.auth.hidePassword': 'Hide password',
  'lumen.auth.loginFailed': 'Login failed',
  'lumen.auth.otpLabel': '6-digit verification code',
  'lumen.auth.cubeLogoAlt': 'CUBEforall by CCN',
  'lumen.auth.version': 'Version 1.0.0 (build 484)',
  'lumen.auth.copyright': '© 2022 - 2026. All rights reserved.',
  'lumen.auth.toast.loginSuccessful': 'Login Successful',
  'lumen.auth.toast.cubeSignedIn': 'Signed in with your CUBEforall account',
  'lumen.auth.toast.cubeError': 'CUBE SSO Error',
  'lumen.auth.toast.mfaSetup': 'MFA Setup',
  'lumen.auth.toast.mfaSetupPending': 'Please complete your pending MFA setup or contact support',
  'lumen.auth.toast.error': 'Error',
  'lumen.auth.toast.mfaSetupFailed': 'Failed to setup MFA. Please try logging in again.',
  'lumen.auth.toast.mfaStatusFailed': 'Failed to check MFA status. Redirecting to app.',
  'lumen.auth.toast.success': 'Success!',
  'lumen.auth.toast.mfaActivated': 'MFA successfully activated',
  'lumen.auth.toast.mfaNotActive': 'MFA not active yet, please try again',
  'lumen.auth.toast.setupCodeIncorrect': 'Verification code is incorrect, please try again',
  'lumen.auth.toast.mfaVerified': 'MFA verification successful',
  'lumen.auth.toast.mfaCodeInvalid': 'Invalid verification code. Please try again.',
  'lumen.auth.toast.deviceAdded': 'Device Added Successfully',
  'lumen.auth.toast.deviceAddedMessage':
    'The new device has been added and verified. Your team member can now use it to login.',
  'lumen.auth.verify.title': 'Two-Factor Authentication',
  'lumen.auth.verify.description': 'Please enter the 6-digit verification code from your authenticator app',
  'lumen.auth.verify.verifying': 'Verifying code...',
  'lumen.auth.verify.help':
    'Open your authenticator app (e.g., Google Authenticator, Authy) to view your verification code',
  'lumen.auth.verify.back': 'Kembali ke Login',
  'lumen.auth.setup.title': 'Setup Autentikasi Multi-Faktor (MFA)',
  'lumen.auth.setup.steps': 'MFA setup steps',
  'lumen.auth.setup.step1': 'Scan QR Code',
  'lumen.auth.setup.step1Desc': 'Gunakan Google Authenticator',
  'lumen.auth.setup.step2': 'Backup Codes',
  'lumen.auth.setup.step2Desc': 'Simpan kode darurat',
  'lumen.auth.setup.step3': 'Verifikasi',
  'lumen.auth.setup.step3Desc': 'Masukkan 6 digit kode',
  'lumen.auth.setup.scanHint': 'Buka aplikasi {app} di smartphone Anda dan scan QR code di bawah ini.',
  'lumen.auth.setup.qrLabel': 'MFA QR code',
  'lumen.auth.setup.manualEntry': 'Atau masukkan kode manual',
  'lumen.auth.setup.copy': 'Salin kode',
  'lumen.auth.setup.copied': 'Tersalin!',
  'lumen.auth.setup.toBackup': 'Lanjut ke Backup Codes',
  'lumen.auth.setup.important': 'PENTING:',
  'lumen.auth.setup.backupWarning':
    'Simpan kode backup ini di tempat yang aman. Anda akan membutuhkannya jika kehilangan akses ke perangkat autentikasi.',
  'lumen.auth.setup.yourCodes': 'Kode Backup Anda:',
  'lumen.auth.setup.download': 'Download Backup Codes',
  'lumen.auth.setup.downloaded': 'Backup Codes Telah Didownload',
  'lumen.auth.setup.back': 'Kembali',
  'lumen.auth.setup.toVerify': 'Lanjut ke Verifikasi',
  'lumen.auth.setup.verifyHint': 'Masukkan 6 digit kode yang muncul di aplikasi Google Authenticator Anda.',
  'lumen.auth.setup.verifySubmit': 'Verifikasi & Aktifkan MFA',
  'lumen.auth.addDevice.title': 'Tambahkan Device Baru',
  'lumen.auth.addDevice.description': 'Add a new device for team members to access this account',
  'lumen.auth.addDevice.hint':
    'After adding the device, the team member will scan the QR code with their authenticator app',
  'lumen.auth.addDevice.deviceName': 'Device Name',
  'lumen.auth.addDevice.deviceNamePlaceholder': "e.g., Friend's iPhone",
  'lumen.auth.addDevice.userName': 'User Name',
  'lumen.auth.addDevice.userNamePlaceholder': 'e.g., Jane Smith',
  'lumen.auth.addDevice.generate': 'Generate QR Code',
  'lumen.auth.addDevice.cancel': 'Cancel',
  'lumen.auth.reviewer.title': 'Reviewer Portal',
  'lumen.auth.reviewer.subtitle': 'Login to review and approve AJU documents',
  'lumen.auth.reviewer.email': 'Email address',
  'lumen.auth.reviewer.emailPlaceholder': 'reviewer@company.com',
  'lumen.auth.reviewer.password': 'Password',
  'lumen.auth.reviewer.passwordPlaceholder': 'Your password',
  'lumen.auth.reviewer.signIn': 'Sign in',
  'lumen.auth.reviewer.footer': 'Lumen Reviewer Portal',
  'lumen.auth.reviewer.caption': 'Review and approve customs documents securely',
  'lumen.breadcrumb.label': 'Breadcrumb',
  'lumen.breadcrumb.more': 'More',
  // ---- Lumen P4 pages: customer approval (4 pages), riwayat-pembaruan, stamp-duty ----
  // The old pages' literal text, verbatim in every language (copy unchanged). Generic words are lumen.common.*
  // (Active, Name, Actions, …); words two of these pages share live under the first one.
  // customer-approval (Status, Actions are lumen.common.*)
  'lumen.customerApproval.title': 'Approval Requests',
  'lumen.customerApproval.description': 'Kelola dan pantau permintaan approval dari customer',
  'lumen.customerApproval.refresh': 'Refresh',
  'lumen.customerApproval.statTotal': 'Total Requests',
  'lumen.customerApproval.statWaiting': 'Waiting',
  'lumen.customerApproval.statusApproved': 'Approved',
  'lumen.customerApproval.statusRejected': 'Rejected',
  'lumen.customerApproval.statusWaiting': 'Waiting for Review',
  'lumen.customerApproval.statusNeedRevision': 'Need Revision',
  'lumen.customerApproval.statusInvalidated': 'Invalidated',
  'lumen.customerApproval.statusScheduled': 'Scheduled',
  'lumen.customerApproval.searchPlaceholder': 'Search by AJU no., requester...',
  'lumen.customerApproval.count': '{n} requests',
  'lumen.customerApproval.colAju': 'AJU No.',
  'lumen.customerApproval.colVersion': 'Ver',
  'lumen.customerApproval.notes': 'Notes',
  'lumen.customerApproval.colRequested': 'Requested',
  'lumen.customerApproval.colReviewed': 'Reviewed',
  'lumen.customerApproval.scheduledAt': 'Dijadwalkan: {date}',
  'lumen.customerApproval.justNow': 'just now',
  'lumen.customerApproval.minutesAgo': '{m}m ago',
  'lumen.customerApproval.hoursMinutesAgo': '{h}h {m}m ago',
  'lumen.customerApproval.hoursAgo': '{h}h ago',
  'lumen.customerApproval.daysHoursAgo': '{d}d {h}h ago',
  'lumen.customerApproval.daysAgo': '{d}d ago',
  'lumen.customerApproval.resendEmail': 'Resend Email',
  'lumen.customerApproval.cancelScheduled': 'Cancel Scheduled',
  'lumen.customerApproval.empty': 'No approval requests found',
  'lumen.customerApproval.detailsTitle': 'Approval Request Details',
  'lumen.customerApproval.requestInfo': 'Request Information',
  'lumen.customerApproval.requestedBy': 'Requested by:',
  'lumen.customerApproval.requestedOn': 'Requested: {date}',
  'lumen.customerApproval.reviewedOn': 'Reviewed: {date}',
  'lumen.customerApproval.revisionChecklist': 'Revision Checklist',
  'lumen.customerApproval.completed': '{checked}/{total} completed',
  'lumen.customerApproval.recipients': 'Recipients ({n})',
  'lumen.customerApproval.sent': 'Sent',
  'lumen.customerApproval.failed': 'Failed',
  'lumen.customerApproval.pending': 'Pending',
  'lumen.customerApproval.close': 'Close',
  'lumen.customerApproval.editDraft': 'Edit Draft',
  // customer-approval/reviewers (Batal, Simpan, Update and the email placeholder are lumen.common.*)
  'lumen.approvalReviewers.title': 'Reviewer Accounts',
  'lumen.approvalReviewers.description': 'Kelola akun reviewer untuk approval AJU draft.',
  'lumen.approvalReviewers.add': 'Tambah Reviewer',
  'lumen.approvalReviewers.editTitle': 'Edit Reviewer',
  'lumen.approvalReviewers.namePlaceholder': 'Full name',
  'lumen.approvalReviewers.passwordOptional': 'Password (optional)',
  'lumen.approvalReviewers.passwordPlaceholder': 'Min. 6 characters',
  'lumen.approvalReviewers.passwordKeepPlaceholder': 'Leave empty to keep current',
  // customer-approval/email-groups (Edit Email is lumen.common.editEmail)
  'lumen.approvalEmailGroups.title': 'Email Groups',
  'lumen.approvalEmailGroups.description': 'Kelola grup email untuk pengiriman approval AJU draft.',
  'lumen.approvalEmailGroups.addGroup': 'Tambah Group',
  'lumen.approvalEmailGroups.editGroup': 'Edit Group',
  'lumen.approvalEmailGroups.importir': 'Importir',
  'lumen.approvalEmailGroups.loading': 'Loading...',
  'lumen.approvalEmailGroups.filterPlaceholder': 'Pilih importir untuk filter grup',
  'lumen.approvalEmailGroups.importirPlaceholder': 'Pilih importir',
  'lumen.approvalEmailGroups.colDescription': 'Description',
  'lumen.approvalEmailGroups.emailCount': 'Jumlah Email',
  'lumen.approvalEmailGroups.addEmailRow': 'Tambah email',
  'lumen.approvalEmailGroups.groupNamePlaceholder': 'Group name',
  'lumen.approvalEmailGroups.groupDescriptionPlaceholder': 'Group description',
  'lumen.approvalEmailGroups.groupDetail': 'Group Detail',
  'lumen.approvalEmailGroups.addEmail': 'Tambah Email',
  'lumen.approvalEmailGroups.recipientNamePlaceholder': 'Recipient name',
  // customer-approval/roles, role-form-modal, user-assignment-drawer
  'lumen.customRoles.title': 'Roles & Permissions',
  'lumen.customRoles.description':
    'Buat role khusus, pilih menu yang boleh diakses beserta levelnya, lalu tugaskan user.',
  'lumen.customRoles.add': 'Tambah Role',
  'lumen.customRoles.fallback':
    'Akun Anda masih memakai role lama. Semua akses tetap berjalan seperti sebelumnya sampai admin menugaskan custom role.',
  'lumen.customRoles.showInactive': 'Tampilkan role nonaktif',
  'lumen.customRoles.colName': 'Nama Role',
  'lumen.customRoles.colCode': 'Kode',
  'lumen.customRoles.colDescription': 'Deskripsi',
  'lumen.customRoles.colUser': 'User',
  'lumen.customRoles.colMenus': 'Akses Menu',
  'lumen.customRoles.system': 'System',
  'lumen.customRoles.systemHint': 'Role bawaan sistem hasil migrasi role lama. Tidak dapat diubah.',
  'lumen.customRoles.menusNone': 'Tidak ada',
  'lumen.customRoles.menusFull': '{n} menu · penuh',
  'lumen.customRoles.menusRead': '{n} menu · lihat saja',
  'lumen.customRoles.menusMixed': '{n} menu · {full} penuh',
  'lumen.customRoles.editLocked': 'Role sistem tidak dapat diubah',
  'lumen.customRoles.duplicate': 'Duplikat',
  'lumen.customRoles.assignUser': 'Assign user',
  'lumen.customRoles.deactivate': 'Nonaktifkan',
  'lumen.customRoles.deleteLocked': 'Role sistem tidak dapat dihapus',
  'lumen.customRoles.deactivateTitle': 'Nonaktifkan Role',
  'lumen.customRoles.deactivateConfirm':
    'Role {name} akan dinonaktifkan. User yang masih aktif harus dipindahkan terlebih dahulu.',
  'lumen.customRoles.editTitle': 'Edit Role',
  'lumen.customRoles.duplicateTitle': 'Duplikat Role',
  'lumen.customRoles.tabGeneral': 'Informasi Umum',
  'lumen.customRoles.namePlaceholder': 'mis. Document Approver',
  'lumen.customRoles.codeLabel': 'Kode Role',
  'lumen.customRoles.codeHint': 'Format slug, dipakai di kode program. Dibuat otomatis dari nama.',
  'lumen.customRoles.codePlaceholder': 'document_approver',
  'lumen.customRoles.descriptionPlaceholder': 'Menjelaskan tanggung jawab role ini',
  'lumen.customRoles.active': 'Role aktif',
  'lumen.customRoles.menusEmpty': 'Katalog menu belum tersedia.',
  'lumen.customRoles.menusHint':
    'Menu yang dipilih menentukan halaman {and} data yang bisa diakses user dengan role ini. Menu yang tidak dipilih tidak akan tampil di sidebar dan datanya juga tidak bisa dibuka.',
  'lumen.customRoles.menusHintAnd': 'dan',
  'lumen.customRoles.levelRead': 'Lihat saja',
  'lumen.customRoles.levelFull': 'Penuh',
  'lumen.customRoles.levelReadHint':
    'User bisa membuka dan mengunduh, tidak bisa membuat, mengubah, mengirim, atau menghapus.',
  'lumen.customRoles.levelFullHint': 'User bisa melakukan semua aksi di menu ini.',
  'lumen.customRoles.assignTitle': 'Assign User — {name}',
  'lumen.customRoles.assignTitlePlain': 'Assign User',
  'lumen.customRoles.subjectReviewer': 'Reviewer',
  'lumen.customRoles.searchPlaceholder': 'Cari nama atau email',
  'lumen.customRoles.moving': '{n} user akan dipindahkan dari role lain ke role ini.',
  'lumen.customRoles.noUser': 'Tidak ada user yang cocok.',
  'lumen.customRoles.noReviewer': 'Tidak ada reviewer yang cocok.',
  'lumen.customRoles.inactive': 'Nonaktif',
  'lumen.customRoles.selected': '{n} dipilih',

  // ---- Lumen /management-dashboard (dashboards PR 5) ----
  // The old page's literal text, verbatim in every language (copy unchanged). {n}, {name}, {pct}, {rate},
  // {currency}, {at} and {filename} are filled with formatTemplate. dateRange is new (the preset select's
  // accessible name), translated. The toasts' "Error" title is lumen.common.error.
  'lumen.managementDashboard.title': 'Executive Dashboard',
  'lumen.managementDashboard.subtitle': 'Real-time business intelligence',
  'lumen.managementDashboard.rangeThisMonth': 'This Month',
  'lumen.managementDashboard.rangeLastMonth': 'Last Month',
  'lumen.managementDashboard.rangeLast3Months': 'Last 3 Months',
  'lumen.managementDashboard.rangeThisQuarter': 'This Quarter',
  'lumen.managementDashboard.rangeLastQuarter': 'Last Quarter',
  'lumen.managementDashboard.rangeThisYear': 'This Year',
  'lumen.managementDashboard.rangeLastYear': 'Last Year',
  'lumen.managementDashboard.rangeLast7Days': 'Last 7 Days',
  'lumen.managementDashboard.rangeLast30Days': 'Last 30 Days',
  'lumen.managementDashboard.rangeLast90Days': 'Last 90 Days',
  'lumen.managementDashboard.refresh': 'Refresh',
  'lumen.managementDashboard.downloadReport': 'Download Report',
  'lumen.managementDashboard.downloading': 'Downloading...',
  'lumen.managementDashboard.loading': 'Loading Executive Dashboard...',
  'lumen.managementDashboard.loadFailed': 'Failed to load dashboard',
  'lumen.managementDashboard.retry': 'Retry',
  'lumen.managementDashboard.totalProcesses': 'Total Processes',
  'lumen.managementDashboard.successfulCount': '{n} successful',
  'lumen.managementDashboard.nilaiPabean': 'Nilai Pabean',
  'lumen.managementDashboard.totalCustomsValue': 'Total customs value',
  'lumen.managementDashboard.activePpjks': 'Active PPJKs',
  'lumen.managementDashboard.processingAgents': 'Processing agents',
  'lumen.managementDashboard.monthlyTrends': 'Monthly Trends',
  'lumen.managementDashboard.monthlyTrendsDescription': 'Process volume over time',
  'lumen.managementDashboard.timeSeries': 'Time Series',
  'lumen.managementDashboard.noTrendData': 'No trend data available',
  'lumen.managementDashboard.unknown': 'Unknown',
  'lumen.managementDashboard.notAvailable': 'N/A',
  'lumen.managementDashboard.shipmentDistribution': 'Shipment Distribution',
  'lumen.managementDashboard.byShipmentType': 'By shipment type',
  'lumen.managementDashboard.distribution': 'Distribution',
  'lumen.managementDashboard.noShipmentData': 'No shipment data available',
  'lumen.managementDashboard.slicePercent': '{name}: {pct}%',
  'lumen.managementDashboard.ppjkPerformance': 'PPJK Performance',
  'lumen.managementDashboard.agentMetrics': 'Agent metrics',
  'lumen.managementDashboard.performance': 'Performance',
  'lumen.managementDashboard.successRate': '{rate}% Success',
  'lumen.managementDashboard.processes': 'Processes',
  'lumen.managementDashboard.successful': 'Successful',
  'lumen.managementDashboard.noPpjkData': 'No PPJK data available',
  'lumen.managementDashboard.currencyBreakdown': 'Currency Breakdown',
  'lumen.managementDashboard.transactionCurrencies': 'Transaction currencies',
  'lumen.managementDashboard.finance': 'Finance',
  'lumen.managementDashboard.transactions': 'Transactions',
  'lumen.managementDashboard.currencyLeads': '{currency} leads with {n} transactions',
  'lumen.managementDashboard.currencyUnavailable': 'Currency performance information unavailable',
  'lumen.managementDashboard.totalTransactions': 'Total transactions: {n}',
  'lumen.managementDashboard.noCurrencyData': 'No currency data available',
  'lumen.managementDashboard.topImportOrigins': 'Top Import Origins',
  'lumen.managementDashboard.byTotalProcesses': 'By total processes',
  'lumen.managementDashboard.imports': 'Imports',
  'lumen.managementDashboard.topExportDestinations': 'Top Export Destinations',
  'lumen.managementDashboard.exports': 'Exports',
  'lumen.managementDashboard.topImportHsCodes': 'Top Import HS Codes',
  'lumen.managementDashboard.byFrequency': 'By frequency',
  'lumen.managementDashboard.import': 'Import',
  'lumen.managementDashboard.frequency': 'Frequency',
  'lumen.managementDashboard.noImportHsData': 'No import HS code data available',
  'lumen.managementDashboard.topExportHsCodes': 'Top Export HS Codes',
  'lumen.managementDashboard.export': 'Export',
  'lumen.managementDashboard.noExportHsData': 'No export HS code data available',
  'lumen.managementDashboard.topImporters': 'Top Importers',
  'lumen.managementDashboard.topImportersDescription': 'Importer performance by total processes and goods',
  'lumen.managementDashboard.importAnalysis': 'Import Analysis',
  'lumen.managementDashboard.totalGoods': 'Total Goods',
  'lumen.managementDashboard.topExporters': 'Top Exporters',
  'lumen.managementDashboard.topExportersDescription': 'Exporter performance by total processes and goods',
  'lumen.managementDashboard.exportAnalysis': 'Export Analysis',
  'lumen.managementDashboard.financialSummary': 'Financial Summary',
  'lumen.managementDashboard.financialSummaryDescription': 'Value breakdown and exchange rates',
  'lumen.managementDashboard.hargaBarang': 'Harga Barang',
  'lumen.managementDashboard.totalFreight': 'Total Freight',
  'lumen.managementDashboard.biayaPenambah': 'Biaya Penambah',
  'lumen.managementDashboard.avgExchangeRate': 'Avg Exchange Rate',
  'lumen.managementDashboard.avgHargaPerProcess': 'Avg Harga per Process',
  'lumen.managementDashboard.avgPabeanPerProcess': 'Avg Nilai Pabean per Process',
  'lumen.managementDashboard.currencyDetails': 'Currency Details',
  'lumen.managementDashboard.currencyDetailsDescription': 'Exchange rates and transaction volumes',
  'lumen.managementDashboard.details': 'Details',
  'lumen.managementDashboard.currency': 'Currency',
  'lumen.managementDashboard.avgRate': 'Avg Rate',
  'lumen.managementDashboard.minRate': 'Min Rate',
  'lumen.managementDashboard.maxRate': 'Max Rate',
  'lumen.managementDashboard.generatedAt': 'Generated: {at}',
  'lumen.managementDashboard.version': 'Lumen Executive Dashboard v2.0',
  'lumen.managementDashboard.downloadSuccessTitle': 'Berhasil',
  'lumen.managementDashboard.downloadSuccess': 'Report {filename} terunduh.',
  'lumen.managementDashboard.downloadFailed': 'Gagal mengunduh report.',
  'lumen.managementDashboard.dateRange': 'Date range',
  // stamp-duty (Active is lumen.common.active)
  'lumen.stampDuty.title': 'Stamp Duty Generator',
  'lumen.stampDuty.description': 'Upload your PDF document to add official stamp duty marks',
  'lumen.stampDuty.uploadDocument': 'Upload Document',
  'lumen.stampDuty.dropHere': 'Drop your PDF file here',
  'lumen.stampDuty.orBrowse': 'or click to browse from your computer',
  'lumen.stampDuty.pdfOnly': 'PDF files only',
  'lumen.stampDuty.maxSize': 'Max 10MB',
  'lumen.stampDuty.supportedFormat': 'Supported Format',
  'lumen.stampDuty.pdfDocuments': 'PDF Documents',
  'lumen.stampDuty.processing': 'Processing',
  'lumen.stampDuty.automaticStamping': 'Automatic Stamping',
  'lumen.stampDuty.documentPreview': 'Document Preview',
  'lumen.stampDuty.sizeKb': '{n} KB',
  'lumen.stampDuty.uploadNew': 'Upload New File',
  'lumen.command.title': 'Command palette',
  'lumen.command.description': 'Search for a command to run…',
  'lumen.toast.region': 'Notifications',

  // ---- Lumen respon (Kepabeanan › Respon) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.respon.searchPlaceholder': 'Cari berdasarkan nomor pengajuan, nama perusahaan, atau nama respon...',
  'lumen.respon.total': 'Total: {n} AJU',
  'lumen.respon.nomorAju': 'Nomor Pengajuan',
  'lumen.respon.namaPerusahaan': 'Nama Perusahaan',
  'lumen.respon.namaRespon': 'Nama Respon',
  'lumen.respon.count': '{n} respon',
  'lumen.respon.range': '{from} - {to} / {total} AJU',
  'lumen.respon.download': 'Download {label}',
  'lumen.respon.error': 'Error',
  'lumen.respon.success': 'Success',
  'lumen.respon.fetchFailed': 'Failed to fetch response data',
  'lumen.respon.fetchDataFailed': 'Failed to fetch data',
  'lumen.respon.fetchingTitle': 'Mengambil {label} dari CEISA…',
  'lumen.respon.fetchingBody': 'Dokumen belum ada di arsip; CEISA bisa memakan waktu hingga 30 detik.',
  'lumen.respon.downloaded': '{label} berhasil diunduh',
  'lumen.respon.downloadFailed': 'Gagal mengunduh {label}',

  // ---- Lumen database-barang (Kepabeanan › Database Barang) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.databaseBarang.searchPlaceholder': 'Cari kode barang, uraian, HS code...',
  'lumen.databaseBarang.ajuNo': 'Aju No',
  'lumen.databaseBarang.companyName': 'Company Name',
  'lumen.databaseBarang.total': 'Total: {n} records',
  'lumen.databaseBarang.downloadExcel': 'Download Excel',
  'lumen.databaseBarang.kodeNegaraAsal': 'Kode Negara Asal',
  'lumen.databaseBarang.merk': 'Merk',
  'lumen.databaseBarang.uraian': 'Uraian',
  'lumen.databaseBarang.hsCode': 'HS Code',
  'lumen.databaseBarang.kodeBarang': 'Kode Barang',
  'lumen.databaseBarang.uom': 'UOM',
  'lumen.databaseBarang.unitPrice': 'Unit Price',
  'lumen.databaseBarang.currency': 'Currency',
  'lumen.databaseBarang.range': '{from} - {to} / {total}',
  'lumen.databaseBarang.error': 'Error',
  'lumen.databaseBarang.success': 'Success',
  'lumen.databaseBarang.fetchDataFailed': 'Failed to fetch data',
  'lumen.databaseBarang.fetchFailed': 'Failed to fetch database barang data',
  'lumen.databaseBarang.downloaded': 'Database barang downloaded',
  'lumen.databaseBarang.downloadFailed': 'Failed to download database barang',

  // ---- Lumen manifest-dashboard (Manifest › Dashboard) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.manifestDashboard.title': 'Manifest Dashboard',
  'lumen.manifestDashboard.subtitle': 'Real-time overview of your manifest operations',
  'lumen.manifestDashboard.startDate': 'Start date',
  'lumen.manifestDashboard.endDate': 'End date',
  'lumen.manifestDashboard.downloadReport': 'Download Excel Report',
  'lumen.manifestDashboard.downloading': 'Downloading...',
  'lumen.manifestDashboard.loading': 'Loading dashboard...',
  'lumen.manifestDashboard.noData': 'No data available',
  'lumen.manifestDashboard.totalManifests': 'Total Manifests',
  'lumen.manifestDashboard.totalHouseBls': 'Total House BLs',
  'lumen.manifestDashboard.critical': 'Critical',
  'lumen.manifestDashboard.pending': 'Pending',
  'lumen.manifestDashboard.submittedToday': 'Submitted Today',
  'lumen.manifestDashboard.attentionRequired': 'Attention Required',
  'lumen.manifestDashboard.needAttention': '{pct}% of manifests need attention',
  'lumen.manifestDashboard.criticalCount': '{n} Critical',
  'lumen.manifestDashboard.mediumCount': '{n} Medium',
  'lumen.manifestDashboard.normalCount': '{n} Normal',
  'lumen.manifestDashboard.statusDistribution': 'Status Distribution',
  'lumen.manifestDashboard.draft': 'Draft',
  'lumen.manifestDashboard.sent': 'Sent',
  'lumen.manifestDashboard.ready': 'Ready',
  'lumen.manifestDashboard.deleted': 'Deleted',
  'lumen.manifestDashboard.sharePct': '({pct}%)',
  'lumen.manifestDashboard.companyPerformance': 'Company Performance',
  'lumen.manifestDashboard.submitted': 'Submitted',
  'lumen.manifestDashboard.manifestCount': '{n} manifests',
  'lumen.manifestDashboard.criticalManifests': 'Critical Manifests',
  'lumen.manifestDashboard.noCriticalManifests': 'No critical manifests',
  'lumen.manifestDashboard.daysUntil': '{n}d',
  'lumen.manifestDashboard.upcomingEvents': 'Upcoming Events',
  'lumen.manifestDashboard.noUpcomingEvents': 'No upcoming events',
  'lumen.manifestDashboard.typeInwardSea': 'Inward Laut',
  'lumen.manifestDashboard.typeInwardAir': 'Inward Udara',
  'lumen.manifestDashboard.typeOutwardSea': 'Outward Laut',
  'lumen.manifestDashboard.typeOutwardAir': 'Outward Udara',
  'lumen.manifestDashboard.toastSuccess': 'Berhasil',
  'lumen.manifestDashboard.reportDownloaded': 'Report {filename} terunduh.',
  'lumen.manifestDashboard.downloadFailed': 'Gagal mengunduh report.',
  'lumen.manifestDashboard.demoModeTitle': 'Demo Mode',
  'lumen.manifestDashboard.demoModeBody': 'Backend endpoint not available. Showing demo data.',
  'lumen.manifestDashboard.fetchFailed': 'Failed to fetch dashboard data: {message}',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 S): the submit dialog (ModalSubmit) and the incomplete-manifest
  // report (IncompleteManifestModal), their toasts. The old text verbatim in every language; {label}, {bl}, {name},
  // {address}, {message} and {n} are filled with formatTemplate. Nomor AJU and Cek Lengkap (with its three toasts) are
  // the shell block's; Batal, Simpan, Success and Error are lumen.common.*.
  'lumen.manifestEngine.submit.title': 'Manifest',
  'lumen.manifestEngine.submit.ajuPlaceholder': 'Masukkan Nomor AJU',
  'lumen.manifestEngine.submit.refresh': 'Refresh Nomor AJU',
  'lumen.manifestEngine.submit.ajuUpdated': 'Nomor AJU berhasil diperbarui',
  'lumen.manifestEngine.submit.ajuLoadFailed': 'Gagal memuat nomor AJU terbaru',
  'lumen.manifestEngine.submit.ajuEmpty': 'Nomor AJU tidak boleh kosong',
  'lumen.manifestEngine.submit.belumTitle': 'Belum Lengkap',
  'lumen.manifestEngine.submit.belumFallback': 'Data belum lengkap',
  'lumen.manifestEngine.submit.noProcessId': 'Manifest ID tidak ditemukan',
  'lumen.manifestEngine.submit.referenceLabel': 'Reference ID',
  'lumen.manifestEngine.submit.referenceRequiredTitle': '{label} wajib diisi',
  'lumen.manifestEngine.submit.referenceRequiredBody': 'Isi {label} di tab Header sebelum manifest dikirim',
  'lumen.manifestEngine.submit.noBlTitle': 'Manifest belum memiliki {bl}',
  'lumen.manifestEngine.submit.noBlBody': 'Tambahkan minimal satu {bl} sebelum submit ke CEISA',
  'lumen.manifestEngine.submit.companyMissing': 'Data perusahaan tidak tersedia. Name: {name}, Address: {address}',
  'lumen.manifestEngine.submit.companyEmpty': 'empty',
  'lumen.manifestEngine.submit.submitted': 'Manifest berhasil disubmit ke CEISA',
  'lumen.manifestEngine.submit.submitFailed': 'Gagal submit manifest',
  'lumen.manifestEngine.submit.submitFailedWith': 'Gagal submit manifest: {message}',
  'lumen.manifestEngine.submit.tutup': 'Tutup',
  'lumen.manifestEngine.submit.ok': 'OK',
  'lumen.manifestEngine.submit.incompleteTitle': 'Data Belum Lengkap',
  'lumen.manifestEngine.submit.incompleteBody':
    'Manifest belum bisa didorong ke CEISA. Lengkapi {n} kolom wajib berikut terlebih dahulu.',

  // ---- Lumen manifest/draft (revamp PR 6a, unit F6) ----
  // The old page's literal text, verbatim in every language (copy unchanged). Status, Actions, Edit, Error,
  // Success and Cancel are lumen.common.*.
  'lumen.manifestDraft.title': 'Draft Manifest',
  'lumen.manifestDraft.subtitle': 'Kelola draft manifest yang belum disubmit',
  'lumen.manifestDraft.searchPlaceholder': 'Cari berdasarkan nama perusahaan...',
  'lumen.manifestDraft.search': 'Search',
  'lumen.manifestDraft.deleteSelected': 'Delete ({n})',
  'lumen.manifestDraft.colType': 'Type',
  'lumen.manifestDraft.colCompany': 'Nama Perusahaan',
  'lumen.manifestDraft.colVessel': 'Sarana Pengangkut',
  'lumen.manifestDraft.colVoyage': 'Voyage',
  'lumen.manifestDraft.colDeparture': 'Tgl Berangkat',
  'lumen.manifestDraft.colArrival': 'Tgl Tiba',
  'lumen.manifestDraft.modeLaut': 'Laut',
  'lumen.manifestDraft.modeUdara': 'Udara',
  'lumen.manifestDraft.modeDarat': 'Darat',
  'lumen.manifestDraft.imo': ' | IMO: {imo}',
  'lumen.manifestDraft.view': 'View',
  'lumen.manifestDraft.demoCannotView': 'Demo users cannot view',
  'lumen.manifestDraft.demoCannotEdit': 'Demo users cannot edit',
  'lumen.manifestDraft.fetchFailed': 'Failed to fetch drafts: {message}',
  'lumen.manifestDraft.noSelectionTitle': 'No Selection',
  'lumen.manifestDraft.noSelectionBody': 'Please select at least one record to delete',
  'lumen.manifestDraft.deleted': 'Successfully deleted {n} record(s)',
  'lumen.manifestDraft.deleteFailed': 'Failed to delete records: {message}',
  'lumen.manifestDraft.confirmTitle': 'Confirm Delete',
  'lumen.manifestDraft.confirmBody': 'Are you sure you want to delete {n} record(s)? This action cannot be undone.',
  'lumen.manifestDraft.delete': 'Delete',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 B1): the BL list (table, toolbar, bulk edit, sync, print chrome,
  // NOA) and the PEB / BL susulan upload. The old text verbatim in every language (copy unchanged); {n}, {message}, {ok},
  // {fail}, {mapped}, {direction}, {doc}, {checked}, {total}, {label} and {name} are filled with formatTemplate. New labels the
  // new parts need (bl.selectAllRows, bl.reorderHint, susulan.removeFile) are Indonesian like the page. The print documents
  // and the CEISA code labels stay as constants (i1 §11 settled 2).
  'lumen.manifestEngine.bl.titleBl': 'Data BL',
  'lumen.manifestEngine.bl.titleAwb': 'Data AWB',
  'lumen.manifestEngine.bl.bulkEdit': 'Bulk Edit ({n} dipilih)',
  'lumen.manifestEngine.bl.uploadNoa': 'Upload NOA',
  'lumen.manifestEngine.bl.susulanOutBl': 'Upload PEB / BL Susulan',
  'lumen.manifestEngine.bl.susulanOutAwb': 'Upload PEB / AWB Susulan',
  'lumen.manifestEngine.bl.susulanInBl': 'Upload BL Susulan',
  'lumen.manifestEngine.bl.susulanInAwb': 'Upload AWB Susulan',
  'lumen.manifestEngine.bl.printAllBl': 'Cetak Semua BL',
  'lumen.manifestEngine.bl.printAllAwb': 'Cetak Semua AWB',
  'lumen.manifestEngine.bl.syncMasterBl': 'Sync with Master BL',
  'lumen.manifestEngine.bl.syncMasterAwb': 'Sync with Master AWB',
  'lumen.manifestEngine.bl.syncAllPorts': 'Sync All Ports',
  'lumen.manifestEngine.bl.addBl': 'Tambah Data BL',
  'lumen.manifestEngine.bl.addAwb': 'Tambah Data AWB',
  'lumen.manifestEngine.bl.colNo': 'No',
  'lumen.manifestEngine.bl.colNoPos': 'No Pos',
  'lumen.manifestEngine.bl.colPorts': 'Kode Pelabuhan',
  'lumen.manifestEngine.bl.portAsal': 'Asal:',
  'lumen.manifestEngine.bl.portBongkar': 'Bongkar:',
  'lumen.manifestEngine.bl.portTransit': 'Transit:',
  'lumen.manifestEngine.bl.portAkhir': 'Akhir:',
  'lumen.manifestEngine.bl.colMasterBl': 'Master BL',
  'lumen.manifestEngine.bl.colMasterAwb': 'Master AWB',
  'lumen.manifestEngine.bl.colHostBl': 'Host BL',
  'lumen.manifestEngine.bl.colHostAwb': 'Host AWB',
  'lumen.manifestEngine.bl.colPeb': 'No. PEB / PPKEK',
  'lumen.manifestEngine.bl.colShipper': 'Shipper',
  'lumen.manifestEngine.bl.colConsignee': 'Consignee',
  'lumen.manifestEngine.bl.colFileName': 'File Name',
  'lumen.manifestEngine.bl.colActions': 'Aksi',
  'lumen.manifestEngine.bl.actionEdit': 'Edit',
  'lumen.manifestEngine.bl.actionCopy': 'Copy',
  'lumen.manifestEngine.bl.actionPrint': 'Print',
  'lumen.manifestEngine.bl.actionDelete': 'Delete',
  'lumen.manifestEngine.bl.selectAllRows': 'Pilih semua baris',
  'lumen.manifestEngine.bl.reorderHint': 'Seret untuk mengubah urutan',
  'lumen.manifestEngine.bl.copyUnsaved': 'Tidak dapat menyalin BL yang belum disimpan',
  'lumen.manifestEngine.bl.copyingTitle': 'Copying...',
  'lumen.manifestEngine.bl.copying': 'Menyalin BL...',
  'lumen.manifestEngine.bl.copied': 'BL berhasil disalin',
  'lumen.manifestEngine.bl.copyFailed': 'Gagal menyalin BL',
  'lumen.manifestEngine.bl.copyFailedWith': 'Gagal menyalin BL: {message}',
  'lumen.manifestEngine.bl.deleted': 'BL berhasil dihapus',
  'lumen.manifestEngine.bl.deletingTitle': 'Deleting...',
  'lumen.manifestEngine.bl.deleting': 'Menghapus BL...',
  'lumen.manifestEngine.bl.deleteFailed': 'Gagal menghapus BL',
  'lumen.manifestEngine.bl.deleteFailedWith': 'Gagal menghapus BL: {message}',
  'lumen.manifestEngine.bl.processingTitle': 'Processing...',
  'lumen.manifestEngine.bl.partialTitle': 'Partial Success',
  'lumen.manifestEngine.bl.partial': 'Berhasil: {ok} BL, Gagal: {fail} BL',
  'lumen.manifestEngine.bl.infoTitle': 'Info',
  'lumen.manifestEngine.bl.noBls': 'Tidak ada BL untuk disinkronkan',
  'lumen.manifestEngine.bl.noMasterData': 'Tidak ada data Master BL atau Vessel untuk disinkronkan',
  'lumen.manifestEngine.bl.syncingMaster': 'Menyinkronkan {n} BL dengan Master BL...',
  'lumen.manifestEngine.bl.syncedMaster': 'Berhasil menyinkronkan {n} BL dengan Master BL',
  'lumen.manifestEngine.bl.syncFailed': 'Sinkronisasi gagal',
  'lumen.manifestEngine.bl.noPortData': 'Tidak ada data pelabuhan untuk disinkronkan',
  'lumen.manifestEngine.bl.lookingUpPorts': 'Mencari kode pelabuhan untuk {n} pelabuhan...',
  'lumen.manifestEngine.bl.portsAllCorrect': 'Semua pelabuhan sudah menggunakan kode yang benar',
  'lumen.manifestEngine.bl.updatingPorts': 'Memperbarui {n} BL dengan kode pelabuhan...',
  'lumen.manifestEngine.bl.portsMapped': '{mapped} pelabuhan berhasil dimapping, {ok} BL diperbarui',
  'lumen.manifestEngine.bl.portsFailedWith': 'Sinkronisasi pelabuhan gagal: {message}',
  'lumen.manifestEngine.bl.noneSelected': 'Tidak ada BL yang dipilih',
  'lumen.manifestEngine.bl.bulkUpdating': 'Memperbarui {n} BL...',
  'lumen.manifestEngine.bl.bulkUpdated': 'Berhasil memperbarui {n} BL',
  'lumen.manifestEngine.bl.bulkFailed': 'Bulk edit gagal',
  'lumen.manifestEngine.bl.reordering': 'Menyimpan urutan BL...',
  'lumen.manifestEngine.bl.reordered': 'Urutan BL berhasil diubah dan disimpan',
  'lumen.manifestEngine.bl.reorderFailed': 'Gagal menyimpan urutan BL',
  'lumen.manifestEngine.bl.bulkTitle': 'Bulk Edit BL',
  'lumen.manifestEngine.bl.bulkIntro': 'Isi field yang ingin diupdate. Field yang kosong tidak akan diubah.',
  'lumen.manifestEngine.bl.bulkMasterBlPlaceholder': 'Master BL (opsional)',
  'lumen.manifestEngine.bl.bulkDate': 'Tanggal Master BL',
  'lumen.manifestEngine.bl.bulkDatePlaceholder': 'Tanggal Master BL (opsional)',
  'lumen.manifestEngine.bl.bulkVessel': 'Vessel Name',
  'lumen.manifestEngine.bl.bulkVesselPlaceholder': 'Vessel Name (opsional)',
  'lumen.manifestEngine.bl.pelabuhanAsal': 'Pelabuhan Asal',
  'lumen.manifestEngine.bl.pelabuhanBongkar': 'Pelabuhan Bongkar',
  'lumen.manifestEngine.bl.pelabuhanTransit': 'Pelabuhan Transit',
  'lumen.manifestEngine.bl.pelabuhanAkhir': 'Pelabuhan Akhir',
  'lumen.manifestEngine.bl.pelabuhanAsalPlaceholder': 'Pilih Pelabuhan Asal (opsional)',
  'lumen.manifestEngine.bl.pelabuhanBongkarPlaceholder': 'Pilih Pelabuhan Bongkar (opsional)',
  'lumen.manifestEngine.bl.pelabuhanTransitPlaceholder': 'Pilih Pelabuhan Transit (opsional)',
  'lumen.manifestEngine.bl.pelabuhanAkhirPlaceholder': 'Pilih Pelabuhan Akhir (opsional)',
  'lumen.manifestEngine.bl.bulkApply': 'Terapkan ke {n} BL',
  'lumen.manifestEngine.bl.syncPortsText':
    'Proses ini akan mencari kode pelabuhan untuk semua nama pelabuhan di {n} BL, lalu memperbarui semua BL dengan kode pelabuhan yang ditemukan.',
  'lumen.manifestEngine.bl.syncPortsFound': '{n} pelabuhan unik ditemukan:',
  'lumen.manifestEngine.bl.lanjutkan': 'Lanjutkan',
  'lumen.manifestEngine.bl.printTitle': 'Print Preview - {direction} Manifest BC 1.1',
  'lumen.manifestEngine.bl.printAllTitle': 'Print Preview - {direction} Manifest BC 1.1 ({n} {doc})',
  'lumen.manifestEngine.bl.tutup': 'Tutup',
  'lumen.manifestEngine.bl.printManifest': 'Print Manifest',
  'lumen.manifestEngine.bl.printAll': 'Print Semua Manifest ({n})',
  'lumen.manifestEngine.bl.showChecklist': 'Show Checklist',
  'lumen.manifestEngine.bl.hideChecklist': 'Hide Checklist',
  'lumen.manifestEngine.bl.checkedCount': '{checked}/{total} checked',
  'lumen.manifestEngine.bl.checkAll': 'Check All',
  'lumen.manifestEngine.bl.uncheckAll': 'Uncheck All',
  'lumen.manifestEngine.bl.noaBusy': 'Memproses NOA...',
  'lumen.manifestEngine.bl.noaBusyHint': 'Mohon tunggu, jangan tutup halaman.',
  'lumen.manifestEngine.bl.noaNoProcess': 'Manifest belum tersedia. Simpan header dulu sebelum upload NOA.',
  'lumen.manifestEngine.bl.noaNoBatch': 'Batch UUID tidak ditemukan.',
  'lumen.manifestEngine.bl.noaNoFileUrl': 'Upload response tidak mengandung file_url.',
  'lumen.manifestEngine.bl.noaDone': 'Ekstraksi NOA selesai. Memuat ulang data...',
  'lumen.manifestEngine.bl.noaFailed': 'Upload NOA gagal.',
  'lumen.manifestEngine.bl.noaNotFound': 'Manifest tidak ditemukan.',
  'lumen.manifestEngine.bl.noaNoContainer': 'NOA tidak punya container yang bisa dipakai, atau BL/PEB belum diupload.',
  'lumen.manifestEngine.susulan.descInAwb': 'Upload file AWB tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.descInBl': 'Upload file BL tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.descOutAwb': 'Upload file PEB atau AWB tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.descOutBl': 'Upload file PEB atau BL tambahan yang akan ditambahkan ke manifest ini.',
  'lumen.manifestEngine.susulan.dropInAwb': 'Drag & drop file AWB',
  'lumen.manifestEngine.susulan.dropInBl': 'Drag & drop file BL',
  'lumen.manifestEngine.susulan.dropOutAwb': 'Drag & drop file PEB / AWB',
  'lumen.manifestEngine.susulan.dropOutBl': 'Drag & drop file PEB / BL',
  'lumen.manifestEngine.susulan.dropActive': 'Drop file PDF disini',
  'lumen.manifestEngine.susulan.browseOr': 'atau',
  'lumen.manifestEngine.susulan.browseLink': 'klik untuk browse',
  'lumen.manifestEngine.susulan.pdfOnly': 'PDF Only',
  'lumen.manifestEngine.susulan.maxFiles': 'Maks. 20 file',
  'lumen.manifestEngine.susulan.docType': 'Tipe Dokumen',
  'lumen.manifestEngine.susulan.docTypeHint':
    'Pilih tipe dokumen yang akan diupload. File yang di-drop akan otomatis menggunakan tipe ini.',
  'lumen.manifestEngine.susulan.listTitle': 'File yang akan diupload ({n})',
  'lumen.manifestEngine.susulan.uploadFailed': 'Gagal mengupload',
  'lumen.manifestEngine.susulan.uploading': 'Uploading...',
  'lumen.manifestEngine.susulan.uploaded': 'Uploaded',
  'lumen.manifestEngine.susulan.removeFile': 'Hapus {name}',
  'lumen.manifestEngine.susulan.proceed': 'Proceed',
  'lumen.manifestEngine.susulan.processing': 'Processing...',
  'lumen.manifestEngine.susulan.badFormatTitle': 'Format tidak sesuai',
  'lumen.manifestEngine.susulan.badFormat': 'Hanya file PDF yang diperbolehkan',
  'lumen.manifestEngine.susulan.tooManyTitle': 'Terlalu banyak file',
  'lumen.manifestEngine.susulan.tooMany': 'Maksimal 20 file dapat diupload',
  'lumen.manifestEngine.susulan.addedTitle': 'File ditambahkan',
  'lumen.manifestEngine.susulan.added': '{n} file berhasil ditambahkan',
  'lumen.manifestEngine.susulan.noFilesTitle': 'Tidak ada file',
  'lumen.manifestEngine.susulan.noFiles': 'Silakan tambahkan file terlebih dahulu',
  'lumen.manifestEngine.susulan.noneUploaded': 'Tidak ada file yang berhasil diupload',
  'lumen.manifestEngine.susulan.done': 'Berhasil menambahkan {n} {label} susulan',
  'lumen.manifestEngine.susulan.failed': 'Gagal menambahkan dokumen susulan',
  'lumen.manifestEngine.susulan.failedWith': 'Gagal menambahkan dokumen susulan: {message}',

  // ---- Lumen harga-referensi (Kuota Impor / Ekspor › Harga Referensi) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.hargaReferensi.title': 'Harga Referensi',
  'lumen.hargaReferensi.description': 'Search and view preferential tariff reference prices by HS Code',
  'lumen.hargaReferensi.searchPlaceholder': 'Enter HS Code (min. 6 digits)...',
  'lumen.hargaReferensi.hsCode': 'HS Code',
  'lumen.hargaReferensi.period': 'Period',
  'lumen.hargaReferensi.month': 'Month',
  'lumen.hargaReferensi.year': 'Year',
  'lumen.hargaReferensi.referencePrice': 'Reference Price',
  'lumen.hargaReferensi.currency': 'Currency',
  'lumen.hargaReferensi.uom': 'UOM',
  'lumen.hargaReferensi.notAvailable': 'N/A',
  'lumen.hargaReferensi.noRecordsFor': 'No reference prices found for HS Code: {hsCode}',
  'lumen.hargaReferensi.noRecords': 'No reference prices available',
  'lumen.hargaReferensi.error': 'Error',
  'lumen.hargaReferensi.fetchFailed': 'Failed to fetch tariffs',

  // ---- Lumen shipment-quota (Kuota Impor / Ekspor › Kuota Pengiriman, + create) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.shipmentQuota.title': 'Shipment Quota Management',
  'lumen.shipmentQuota.create': 'Create Quota',
  'lumen.shipmentQuota.searchPlaceholder': 'Search by HS Code...',
  'lumen.shipmentQuota.empty': 'No shipment quotas yet',
  'lumen.shipmentQuota.createFirst': 'Create Your First Quota',
  'lumen.shipmentQuota.status': 'Status',
  'lumen.shipmentQuota.hsCode': 'HS Code',
  'lumen.shipmentQuota.shipmentType': 'Shipment Type',
  'lumen.shipmentQuota.totalQuota': 'Total Quota',
  'lumen.shipmentQuota.quotaLeft': 'Quota Left',
  'lumen.shipmentQuota.usage': 'Usage %',
  'lumen.shipmentQuota.expiredDate': 'Expired Date',
  'lumen.shipmentQuota.createdAt': 'Created At',
  'lumen.shipmentQuota.expired': 'Expired',
  'lumen.shipmentQuota.depleted': 'Depleted',
  'lumen.shipmentQuota.low': 'Low',
  'lumen.shipmentQuota.active': 'Active',
  'lumen.shipmentQuota.error': 'Error',
  'lumen.shipmentQuota.success': 'Success',
  'lumen.shipmentQuota.fetchFailed': 'Failed to fetch quotas',
  'lumen.shipmentQuota.createTitle': 'Create Shipment Quota',
  'lumen.shipmentQuota.createDescription': 'Fill in the details below to create a new shipment quota',
  'lumen.shipmentQuota.ppjkNpwp': 'PPJK NPWP',
  'lumen.shipmentQuota.ppjkLoading': 'Loading PPJK NPWP...',
  'lumen.shipmentQuota.ppjkPlaceholder': 'PPJK NPWP from your account',
  'lumen.shipmentQuota.hsPlaceholder': 'Search HS Code...',
  'lumen.shipmentQuota.lartas': 'LARTAS',
  'lumen.shipmentQuota.nonLartas': 'NON-LARTAS',
  'lumen.shipmentQuota.uom': 'Unit of Measure (UOM)',
  'lumen.shipmentQuota.uomPlaceholder': 'Select UOM...',
  'lumen.shipmentQuota.typePlaceholder': 'Select shipment type',
  'lumen.shipmentQuota.import': 'Import',
  'lumen.shipmentQuota.export': 'Export',
  'lumen.shipmentQuota.quota': 'Quota',
  'lumen.shipmentQuota.quotaPlaceholder': 'Enter quota amount',
  'lumen.shipmentQuota.expiredPlaceholder': 'Select expiration date and time',
  'lumen.shipmentQuota.cancel': 'Cancel',
  'lumen.shipmentQuota.required': 'Please fill in all required fields',
  'lumen.shipmentQuota.created': 'Shipment quota created successfully!',
  'lumen.shipmentQuota.createFailed': 'Failed to create shipment quota',
  // New labels for the Lumen date-time field (translated).
  'lumen.shipmentQuota.time': 'Time',
  'lumen.shipmentQuota.done': 'Done',

  // ---- Lumen ssm/data (SSM › Data, + SSMForm) ----
  // The old page's literal copy, verbatim in every language (copy unchanged).
  'lumen.ssmData.pageTitle': 'SSM Data Management',
  'lumen.ssmData.totalItems': 'Total Items',
  'lumen.ssmData.activeItems': 'Active Items',
  'lumen.ssmData.inactiveItems': 'Inactive Items',
  'lumen.ssmData.lastUpdated': 'Last Updated',
  'lumen.ssmData.today': 'Today',
  'lumen.ssmData.sectionTitle': 'SSM Data',
  'lumen.ssmData.sectionDescription': 'Manage system configuration and master data',
  'lumen.ssmData.refresh': 'Refresh',
  'lumen.ssmData.addNew': 'Add New Item',
  'lumen.ssmData.searchPlaceholder': 'Search by code, name, or description...',
  'lumen.ssmData.code': 'Code',
  'lumen.ssmData.name': 'Name',
  'lumen.ssmData.description': 'Description',
  'lumen.ssmData.status': 'Status',
  'lumen.ssmData.actions': 'Actions',
  'lumen.ssmData.active': 'Active',
  'lumen.ssmData.inactive': 'Inactive',
  'lumen.ssmData.viewDetails': 'View Details',
  'lumen.ssmData.edit': 'Edit',
  'lumen.ssmData.delete': 'Delete',
  'lumen.ssmData.noData': 'No data found',
  'lumen.ssmData.showing': 'Showing {n} of {total} items',
  'lumen.ssmData.step.pemberitahuan': 'Pemberitahuan',
  'lumen.ssmData.step.transportasi': 'Transportasi',
  'lumen.ssmData.step.dokumen': 'Dokumen',
  'lumen.ssmData.step.komoditi': 'Komoditi',
  'lumen.ssmData.step.layanan': 'Layanan',
  'lumen.ssmData.formMeta': 'No Pengajuan : | Jenis API : 02',
  'lumen.ssmData.formTitle': 'Data Pemberitahuan',
  'lumen.ssmData.tabUtama': 'Data Utama',
  'lumen.ssmData.tabEntitas': 'Data Entitas',
  'lumen.ssmData.tabPungutan': 'Data Pungutan',
  'lumen.ssmData.nomerPengajuan': 'Nomer Pengajuan',
  'lumen.ssmData.tanggalPengajuan': 'Tanggal Pengajuan',
  'lumen.ssmData.nomorPendaftaran': 'Nomor Pendaftaran',
  'lumen.ssmData.tanggalPendaftaran': 'Tanggal Pendaftaran',
  'lumen.ssmData.kantorPabean': 'Kantor Pabean',
  'lumen.ssmData.skepFasilitas': 'SKEP Fasilitas',
  'lumen.ssmData.jenisPib': 'Jenis PIB',
  'lumen.ssmData.jenisImpor': 'Jenis Impor',
  'lumen.ssmData.caraPembayaran': 'Cara Pembayaran',
  'lumen.ssmData.transaksi': 'Transaksi',
  'lumen.ssmData.kodePembayaran': 'Kode Pembayaran',
  'lumen.ssmData.previous': 'Sebelumnya',
  'lumen.ssmData.next': 'Selanjutnya',
  'lumen.ssmData.opt.kantorPabean.kpu_tanjung_priok': 'KPU TANJUNG PRIOK',
  'lumen.ssmData.opt.kantorPabean.kpu_soekarno_hatta': 'KPU SOEKARNO HATTA',
  'lumen.ssmData.opt.kantorPabean.kpu_juanda': 'KPU JUANDA',
  'lumen.ssmData.opt.skepFasilitas.asean_china_fta': 'PREFERENSI TARIF IMPORTASI ASEAN-CHINA FTA',
  'lumen.ssmData.opt.skepFasilitas.asean_korea_fta': 'PREFERENSI TARIF IMPORTASI ASEAN-KOREA FTA',
  'lumen.ssmData.opt.skepFasilitas.asean_india_fta': 'PREFERENSI TARIF IMPORTASI ASEAN-INDIA FTA',
  'lumen.ssmData.opt.jenisPib.biasa': 'Biasa',
  'lumen.ssmData.opt.jenisPib.khusus': 'Khusus',
  'lumen.ssmData.opt.jenisPib.sementara': 'Sementara',
  'lumen.ssmData.opt.jenisImpor.untuk_dipakai': 'UNTUK DIPAKAI',
  'lumen.ssmData.opt.jenisImpor.sementara': 'SEMENTARA',
  'lumen.ssmData.opt.jenisImpor.angkutan': 'ANGKUTAN',
  'lumen.ssmData.opt.caraPembayaran.biasa_tunai': 'BIASA/TUNAI',
  'lumen.ssmData.opt.caraPembayaran.kredit': 'KREDIT',
  'lumen.ssmData.opt.caraPembayaran.transfer': 'TRANSFER',
  'lumen.ssmData.opt.transaksi.perdagangan': 'Transaksi Perdagangan Atau Cara Pemi',
  'lumen.ssmData.opt.transaksi.non_perdagangan': 'Non Perdagangan',

  'lumen.shell.menu': 'Menu',
  'lumen.shell.menuDescription': 'Main app navigation',
  // ---- Lumen shell: sidebar ----
  'lumen.sidebar.navLabel': 'Main menu',
  'lumen.sidebar.locked': 'Module not active',
  // ---- Lumen shell: reviewer area and feature lock ----
  // The old screens showed this copy as literals, one language for everyone; kept verbatim (copy decision).
  'lumen.reviewer.dashboard': 'Dashboard',
  'lumen.reviewer.role': 'Reviewer',
  'lumen.reviewer.logout': 'Logout',
  // ---- Lumen master B (revamp PR 4): customer-email-forwarding, sea-carriers, revoke-access, consignee ----
  // The old pages' literal copy is kept verbatim in every language; labels new components need are translated.
  'lumen.customerEmailForwarding.title': 'CEISA Customer Email Forwarding',
  'lumen.customerEmailForwarding.description': 'Kelola mapping importir dan penerima email forwarding CEISA.',
  'lumen.customerEmailForwarding.addMapping': 'Tambah Mapping',
  'lumen.customerEmailForwarding.editMappingTitle': 'Edit Mapping',
  'lumen.customerEmailForwarding.failed': 'Gagal',
  'lumen.customerEmailForwarding.importirLoadFailed': 'Daftar importir tidak dapat dimuat.',
  'lumen.customerEmailForwarding.loadFailedTitle': 'Data tidak dapat dimuat',
  'lumen.customerEmailForwarding.tenantImportirLoadFailed': 'Daftar importir tenant tidak dapat dimuat.',
  'lumen.customerEmailForwarding.filterImportir': 'Filter importir',
  'lumen.customerEmailForwarding.loadingImportir': 'Memuat importir...',
  'lumen.customerEmailForwarding.importirPlaceholder': 'Cari nama atau NPWP importir',
  'lumen.customerEmailForwarding.searchMapping': 'Cari mapping',
  'lumen.customerEmailForwarding.searchPlaceholder': 'Nama atau NPWP importir',
  'lumen.customerEmailForwarding.importir': 'Importir',
  'lumen.customerEmailForwarding.recipients': 'Penerima',
  'lumen.customerEmailForwarding.status': 'Status',
  'lumen.customerEmailForwarding.active': 'Aktif',
  'lumen.customerEmailForwarding.inactive': 'Nonaktif',
  'lumen.customerEmailForwarding.actions': 'Aksi',
  'lumen.customerEmailForwarding.manageRecipients': 'Kelola penerima',
  'lumen.customerEmailForwarding.editMapping': 'Edit mapping',
  'lumen.customerEmailForwarding.deactivateMapping': 'Nonaktifkan mapping',
  'lumen.customerEmailForwarding.activateMapping': 'Aktifkan mapping',
  'lumen.customerEmailForwarding.importirRequired': 'Importir wajib dipilih.',
  'lumen.customerEmailForwarding.importirUnavailable': 'Importir tidak tersedia untuk tenant ini.',
  'lumen.customerEmailForwarding.cancel': 'Batal',
  'lumen.customerEmailForwarding.save': 'Simpan',
  'lumen.customerEmailForwarding.recipientsTitle': 'Penerima Email',
  'lumen.customerEmailForwarding.showInactive': 'Tampilkan penerima nonaktif',
  'lumen.customerEmailForwarding.inactiveLoadFailed': 'Penerima nonaktif tidak dapat dimuat.',
  'lumen.customerEmailForwarding.name': 'Nama',
  'lumen.customerEmailForwarding.email': 'Email',
  'lumen.customerEmailForwarding.emailPlaceholder': 'nama@perusahaan.com',
  'lumen.customerEmailForwarding.editRecipient': 'Edit Penerima',
  'lumen.customerEmailForwarding.addRecipient': 'Tambah Penerima',
  'lumen.customerEmailForwarding.nameRequired': 'Nama penerima wajib diisi.',
  'lumen.customerEmailForwarding.emailInvalid': 'Masukkan alamat email yang valid.',
  'lumen.customerEmailForwarding.activateRecipient': 'Activate recipient',
  'lumen.customerEmailForwarding.deactivateRecipient': 'Deactivate recipient',
  'lumen.customerEmailForwarding.noImportir': 'No importir found',
  'lumen.customerEmailForwarding.clearImportir': 'Clear importir filter',
  'lumen.seaCarriers.title': 'Sea Carriers',
  'lumen.seaCarriers.description': 'Upload a CSV or TXT file containing sea carrier data.',
  'lumen.seaCarriers.dropTitle': 'Click or drag & drop to upload',
  'lumen.seaCarriers.accepted': 'Accepted formats: .csv, .txt',
  'lumen.seaCarriers.size': '{n} KB',
  'lumen.seaCarriers.submit': 'Submit',
  'lumen.seaCarriers.invalidTitle': 'Invalid file type',
  'lumen.seaCarriers.invalidMsg': 'Only .csv or .txt files are accepted.',
  'lumen.seaCarriers.successTitle': 'Upload successful',
  'lumen.seaCarriers.successMsg': 'Sea carriers file has been uploaded successfully.',
  'lumen.seaCarriers.failedTitle': 'Upload failed',
  'lumen.seaCarriers.failedMsg': 'An error occurred while uploading the file.',
  'lumen.seaCarriers.removeFile': 'Remove file',
  'lumen.revokeAccess.title': 'Revoke Access by PPJK NPWP',
  'lumen.revokeAccess.description':
    "Block or unblock a PPJK's CEISA access. Blocking revokes all active tokens immediately.",
  'lumen.revokeAccess.warning': 'This action affects all app users tied to the given PPJK NPWP. Use with care.',
  'lumen.revokeAccess.npwp': 'PPJK NPWP',
  'lumen.revokeAccess.placeholder': 'e.g. 0029326105001000',
  'lumen.revokeAccess.unblock': 'Unblock',
  'lumen.revokeAccess.block': 'Block / Revoke Access',
  'lumen.revokeAccess.validationTitle': 'Validation Error',
  'lumen.revokeAccess.npwpRequired': 'PPJK NPWP is required',
  'lumen.revokeAccess.success': 'Success',
  'lumen.revokeAccess.blocked': 'PPJK blocked successfully',
  'lumen.revokeAccess.unblocked': 'PPJK unblocked successfully',
  'lumen.revokeAccess.error': 'Error',
  'lumen.revokeAccess.requestFailed': 'Request failed',
  'lumen.revokeAccess.resultNpwp': 'NPWP:',
  'lumen.revokeAccess.resultState': 'State:',
  'lumen.revokeAccess.stateBlocked': 'BLOCKED',
  'lumen.revokeAccess.stateUnblocked': 'UNBLOCKED',
  'lumen.revokeAccess.appUsersAffected': 'App Users Affected:',
  'lumen.revokeAccess.ceisaUsersHit': 'CEISA Users Hit:',
  'lumen.revokeAccess.ceisaAccountsHit': 'CEISA Accounts Hit:',
  'lumen.revokeAccess.tokensRevoked': 'Tokens Revoked:',
  'lumen.revokeAccess.appUserIds': 'App User IDs:',

  // ---- Lumen manifest/guardian/radar (revamp PR 5, unit R) ----
  // The old page's literal text, verbatim in every language (copy unchanged). New, the same in every language:
  // dotLabel (each radar dot's accessible name, only placeholders and separators) and the table view's title and
  // column headers (tableTitle, col*), in English like the detail card's labels. The rail toggle is lumen.table.*.
  'lumen.manifestRadar.title': 'Orbital Radar',
  'lumen.manifestRadar.ppjk': 'PPJK {npwp}',
  'lumen.manifestRadar.ppjkAll': 'all',
  'lumen.manifestRadar.refresh': 'Refresh',
  'lumen.manifestRadar.windowHours': 'Window (h)',
  'lumen.manifestRadar.pastHours': 'Past (h)',
  'lumen.manifestRadar.critHours': 'Critical ≤ (h)',
  'lumen.manifestRadar.warnHours': 'Warning ≤ (h)',
  'lumen.manifestRadar.direction': 'Direction',
  'lumen.manifestRadar.both': 'Both',
  'lumen.manifestRadar.inward': 'Inward',
  'lumen.manifestRadar.outward': 'Outward',
  'lumen.manifestRadar.status': 'Status (CSV)',
  'lumen.manifestRadar.statusPlaceholder': 'DRAFT,SENT',
  'lumen.manifestRadar.apply': 'Apply',
  'lumen.manifestRadar.counts': 'Counts',
  'lumen.manifestRadar.critical': 'Critical',
  'lumen.manifestRadar.warning': 'Warning',
  'lumen.manifestRadar.normal': 'Normal',
  'lumen.manifestRadar.overdue': 'Overdue',
  'lumen.manifestRadar.done': 'Done',
  'lumen.manifestRadar.active': 'Active',
  'lumen.manifestRadar.loading': 'Memuat radar...',
  'lumen.manifestRadar.toastError': 'Gagal',
  'lumen.manifestRadar.loadFailed': 'Gagal memuat timeline radar',
  'lumen.manifestRadar.eyebrow': 'Manifest · Orbital Radar',
  'lumen.manifestRadar.headline': '{critical} critical · {warning} warning',
  'lumen.manifestRadar.tRange': 'T-RANGE: {h}h',
  'lumen.manifestRadar.scan': 'SCAN: {time} WIB',
  'lumen.manifestRadar.ringHours': '{h}h',
  'lumen.manifestRadar.axisInward': '↑ INWARD · ETA',
  'lumen.manifestRadar.axisOutward': '↓ OUTWARD · ETD',
  'lumen.manifestRadar.sevCritical': 'CRITICAL',
  'lumen.manifestRadar.sevWarning': 'WARNING',
  'lumen.manifestRadar.sevNormal': 'NORMAL',
  'lumen.manifestRadar.legendInward': '▲ INWARD',
  'lumen.manifestRadar.legendOutward': '▼ OUTWARD',
  'lumen.manifestRadar.manifestId': 'Manifest #{id}',
  'lumen.manifestRadar.bl': 'BL · {bl}',
  'lumen.manifestRadar.eta': 'ETA',
  'lumen.manifestRadar.etd': 'ETD',
  'lumen.manifestRadar.detailStatus': 'Status',
  'lumen.manifestRadar.dotLabel': '{severity} · {countdown} · {aju} · {direction}',
  'lumen.manifestRadar.tableTitle': 'Manifests',
  'lumen.manifestRadar.colAjuBl': 'AJU / BL',
  'lumen.manifestRadar.colSeverity': 'Severity',
  'lumen.manifestRadar.colCountdown': 'Countdown',
  'lumen.manifestRadar.colVesselVoyage': 'Vessel / Voyage',
  'lumen.manifestRadar.colRoute': 'Route',
  'lumen.manifestRadar.colEvent': 'ETA/ETD',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 C): the Container section (table, Host BL filter, the
  // Tambah / Edit / Attach dialogs, their toasts). The old text verbatim in every language (copy unchanged, mixed English
  // and Indonesian as before); {filtered}, {total}, {plural}, {size}, {n}, {ok}, {fail}, {host} and {message} are filled
  // with formatTemplate. The code lists (Ukuran, Jenis, Type) stay as constants (i1 §11 settled 2). Error, Success and
  // Cancel reuse lumen.common.*.
  'lumen.manifestEngine.container.title': 'All Containers from BLs',
  'lumen.manifestEngine.container.showing': 'Showing: {filtered} of {total} container{plural}',
  'lumen.manifestEngine.container.add': 'Tambah Container',
  'lumen.manifestEngine.container.filterPlaceholder': 'Filter by Host BL',
  'lumen.manifestEngine.container.allHostBls': 'All Host BLs',
  'lumen.manifestEngine.container.noResults': 'No results found.',
  'lumen.manifestEngine.container.clearFilter': 'Clear selection',
  'lumen.manifestEngine.container.colNoPos': 'No Pos',
  'lumen.manifestEngine.container.colMasterBl': 'Master BL',
  'lumen.manifestEngine.container.colHostBl': 'Host BL',
  'lumen.manifestEngine.container.colNomor': 'Nomor Container',
  'lumen.manifestEngine.container.colUkuran': 'Ukuran',
  'lumen.manifestEngine.container.colJenis': 'Jenis',
  'lumen.manifestEngine.container.colType': 'Type',
  'lumen.manifestEngine.container.colAksi': 'Aksi',
  'lumen.manifestEngine.container.feet': '{size} FEET',
  'lumen.manifestEngine.container.edit': 'Edit Container',
  'lumen.manifestEngine.container.attach': 'Attach to BL',
  'lumen.manifestEngine.container.delete': 'Delete Container',
  'lumen.manifestEngine.container.info': 'Info',
  'lumen.manifestEngine.container.deletingTitle': 'Deleting...',
  'lumen.manifestEngine.container.partialTitle': 'Partial Success',
  'lumen.manifestEngine.container.idNotFound': 'Container ID not found',
  'lumen.manifestEngine.container.deleting': 'Menghapus container...',
  'lumen.manifestEngine.container.deleted': 'Container berhasil dihapus',
  'lumen.manifestEngine.container.deleteFailed': 'Failed to delete container',
  'lumen.manifestEngine.container.deleteFailedWith': 'Failed to delete container: {message}',
  'lumen.manifestEngine.container.numberRequired': 'Container number is required',
  'lumen.manifestEngine.container.pickBl': 'Please select at least 1 BL to attach this container',
  'lumen.manifestEngine.container.pickSize': 'Please select Ukuran Container',
  'lumen.manifestEngine.container.added': 'Container added successfully to {n} BL(s)',
  'lumen.manifestEngine.container.addFailed': 'Failed to add container',
  'lumen.manifestEngine.container.addFailedWith': 'Failed to add container: {message}',
  'lumen.manifestEngine.container.noEditing': 'No container selected for editing',
  'lumen.manifestEngine.container.numberEmpty': 'Container number cannot be empty',
  'lumen.manifestEngine.container.noChanges': 'No changes made to container',
  'lumen.manifestEngine.container.blNotFound': 'BL not found',
  'lumen.manifestEngine.container.notInBl': 'Container not found in BL',
  'lumen.manifestEngine.container.updated': 'Container number updated successfully',
  'lumen.manifestEngine.container.updateFailed': 'Failed to update container',
  'lumen.manifestEngine.container.updateFailedWith': 'Failed to update container: {message}',
  'lumen.manifestEngine.container.noSelected': 'No container selected',
  'lumen.manifestEngine.container.noChangesToSave': 'No changes to save',
  'lumen.manifestEngine.container.attached': 'Container attached/detached successfully ({n} BL(s) updated)',
  'lumen.manifestEngine.container.partial': 'Success: {ok} BL(s), Failed: {fail} BL(s)',
  'lumen.manifestEngine.container.attachFailedWith': 'Failed to attach container: {message}',
  'lumen.manifestEngine.container.attachTitle': 'Attach Container to BLs',
  'lumen.manifestEngine.container.containerInfo': 'Container Information',
  'lumen.manifestEngine.container.infoNomor': 'Nomor:',
  'lumen.manifestEngine.container.infoUkuran': 'Ukuran:',
  'lumen.manifestEngine.container.infoJenis': 'Jenis:',
  'lumen.manifestEngine.container.infoType': 'Type:',
  'lumen.manifestEngine.container.pickAttach': 'Select BLs to attach this container (can select multiple):',
  'lumen.manifestEngine.container.pickAddBefore': 'Select BLs to attach this container',
  'lumen.manifestEngine.container.pickAddAfter': '(must select at least 1):',
  'lumen.manifestEngine.container.selectAll': 'Pilih Semua',
  'lumen.manifestEngine.container.hostBlLine': 'Host BL: {host}',
  'lumen.manifestEngine.container.saveAttach': 'Save ({n} BL{plural} selected)',
  'lumen.manifestEngine.container.editTitle': 'Edit Container',
  'lumen.manifestEngine.container.blInfo': 'BL Information',
  'lumen.manifestEngine.container.hostBl': 'Host BL:',
  'lumen.manifestEngine.container.saveChanges': 'Save Changes',
  'lumen.manifestEngine.container.addTitle': 'Tambah Container',
  'lumen.manifestEngine.container.addSubmit': 'Add Container ({n} BL{plural} selected)',
  'lumen.manifestEngine.container.nomorContainer': 'Nomor Container',
  'lumen.manifestEngine.container.ukuranContainer': 'Ukuran Container',
  'lumen.manifestEngine.container.jenisContainer': 'Jenis Container',
  'lumen.manifestEngine.container.typeContainer': 'Type Container',
  'lumen.manifestEngine.container.nomorSegel': 'Nomor Segel',
  'lumen.manifestEngine.container.nomorPolisi': 'Nomor Polisi',
  'lumen.manifestEngine.container.driver': 'Driver',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 C): the Barang section (table, Combine / Slice views,
  // Edit Barang, its toasts). The old text verbatim in every language; {filtered}, {total} and {message} are filled with
  // formatTemplate. The filter's texts and the Info title are the Container block's.
  'lumen.manifestEngine.barang.title': 'All Barang from BLs',
  'lumen.manifestEngine.barang.combine': 'Combine Goods',
  'lumen.manifestEngine.barang.uncombine': 'Uncombine Goods',
  'lumen.manifestEngine.barang.slice': 'Slice HS Codes (4 Digits)',
  'lumen.manifestEngine.barang.unslice': 'Unslice HS Codes',
  'lumen.manifestEngine.barang.showing': 'Showing: {filtered} of {total} barang',
  'lumen.manifestEngine.barang.colNoPos': 'No Pos',
  'lumen.manifestEngine.barang.colNoPeb': 'No. PEB',
  'lumen.manifestEngine.barang.colNoAwb': 'No. AWB',
  'lumen.manifestEngine.barang.colMasterAwb': 'Master AWB',
  'lumen.manifestEngine.barang.colHostAwb': 'Host AWB',
  'lumen.manifestEngine.barang.colNoBl': 'No. BL',
  'lumen.manifestEngine.barang.colMasterBl': 'Master BL',
  'lumen.manifestEngine.barang.colHostBl': 'Host BL',
  'lumen.manifestEngine.barang.colKodeHs': 'Kode HS',
  'lumen.manifestEngine.barang.colUraianHs': 'Uraian HS',
  'lumen.manifestEngine.barang.colAksi': 'Aksi',
  'lumen.manifestEngine.barang.edit': 'Edit Barang',
  'lumen.manifestEngine.barang.editTitle': 'Edit Barang',
  'lumen.manifestEngine.barang.barangInfo': 'Barang Information',
  'lumen.manifestEngine.barang.blLine': 'BL:',
  'lumen.manifestEngine.barang.kodeHs': 'Kode HS',
  'lumen.manifestEngine.barang.kodeHsPlaceholder': 'Enter Kode HS',
  'lumen.manifestEngine.barang.previous': 'Previous:',
  'lumen.manifestEngine.barang.uraianHs': 'Uraian HS',
  'lumen.manifestEngine.barang.uraianHsPlaceholder': 'Enter Uraian HS',
  'lumen.manifestEngine.barang.saveChanges': 'Save Changes',
  'lumen.manifestEngine.barang.noBarang': 'No barang selected for editing',
  'lumen.manifestEngine.barang.kodeEmpty': 'Kode HS cannot be empty',
  'lumen.manifestEngine.barang.uraianEmpty': 'Uraian HS cannot be empty',
  'lumen.manifestEngine.barang.noChanges': 'No changes made to barang',
  'lumen.manifestEngine.barang.blNotFound': 'BL not found',
  'lumen.manifestEngine.barang.notInBl': 'Barang not found in BL',
  'lumen.manifestEngine.barang.updated': 'Barang updated successfully',
  'lumen.manifestEngine.barang.updateFailed': 'Failed to update barang',
  'lumen.manifestEngine.barang.updateFailedWith': 'Failed to update barang: {message}',

  // ---- Lumen manifest/product + manifest/product/upload (revamp PR 6a, unit P) ----
  // Both pages' literal text, verbatim in every language (copy unchanged). Toast titles "Error" are lumen.common.error;
  // the upload kit keeps its upload.* keys and the Excel hook its own toasts.
  'lumen.manifestProduct.pill': 'Kelola Manifest dengan Mudah dan Cepat',
  'lumen.manifestProduct.titleCategory': 'Pilih Jalur Manifest',
  'lumen.manifestProduct.titleDirection': 'Pilih Arah Manifest',
  'lumen.manifestProduct.subtitleCategory': 'Mulai proses manifest dengan memilih jalur pengiriman terlebih dahulu',
  'lumen.manifestProduct.subtitleDirection': 'Tentukan arah manifest untuk melanjutkan proses',
  'lumen.manifestProduct.pickedLabel': 'Jalur terpilih:',
  'lumen.manifestProduct.udara': 'Udara',
  'lumen.manifestProduct.laut': 'Laut',
  'lumen.manifestProduct.changeCategory': 'Ganti Jalur',
  'lumen.manifestProduct.categoryUdaraTitle': 'Manifest - Udara',
  'lumen.manifestProduct.categoryUdaraDesc': 'Pilih jalur udara untuk proses manifest',
  'lumen.manifestProduct.categoryLautTitle': 'Manifest - Laut',
  'lumen.manifestProduct.categoryLautDesc': 'Pilih jalur laut untuk proses manifest',
  'lumen.manifestProduct.pickCategory': 'Pilih Jalur',
  'lumen.manifestProduct.pick': 'Pilih',
  'lumen.manifestProduct.start': 'Mulai',
  'lumen.manifestProduct.inwardUdaraTitle': 'Inward Manifest - Udara',
  'lumen.manifestProduct.inwardUdaraDesc': 'Manifest untuk barang masuk melalui jalur udara',
  'lumen.manifestProduct.outwardUdaraTitle': 'Outward Manifest - Udara',
  'lumen.manifestProduct.outwardUdaraDesc': 'Manifest untuk barang keluar melalui jalur udara',
  'lumen.manifestProduct.inwardLautTitle': 'Inward Manifest - Laut',
  'lumen.manifestProduct.inwardLautDesc': 'Manifest untuk barang masuk melalui jalur laut',
  'lumen.manifestProduct.outwardLautTitle': 'Outward Manifest - Laut',
  'lumen.manifestProduct.outwardLautDesc': 'Manifest untuk barang keluar melalui jalur laut',
  'lumen.manifestProduct.popular': 'Popular',
  'lumen.manifestProduct.methodTitle': 'Pilih Metode Input',
  'lumen.manifestProduct.methodBody': 'Pilih metode yang ingin Anda gunakan untuk mengisi {title}',
  'lumen.manifestProduct.aiTitle': 'AI Assistant',
  'lumen.manifestProduct.aiDesc': 'Biarkan AI membantu mengisi form dengan cepat dan akurat',
  'lumen.manifestProduct.manualTitle': 'Manual Input',
  'lumen.manifestProduct.manualDesc': 'Isi form secara manual dengan kontrol penuh',
  'lumen.manifestProduct.back': 'Kembali',
  'lumen.manifestProduct.uploadTitle': 'Upload Dokumen Manifest {direction} {mode}',
  'lumen.manifestProduct.uploadTitleMode': '- {mode}',
  'lumen.manifestProduct.inward': 'Inward',
  'lumen.manifestProduct.outward': 'Outward',
  'lumen.manifestProduct.tabPdf': 'Upload PDF',
  'lumen.manifestProduct.tabExcel': 'Upload Excel',
  'lumen.manifestProduct.docsReady': '{n} dokumen siap diupload',
  'lumen.manifestProduct.docsGrouped': '{n} dokumen telah dikelompokkan',
  'lumen.manifestProduct.succeeded': '{n} berhasil',
  'lumen.manifestProduct.failed': '{n} gagal',
  'lumen.manifestProduct.reset': 'Reset',
  'lumen.manifestProduct.uploading': 'Uploading... {p}%',
  'lumen.manifestProduct.processing': 'Processing...',
  'lumen.manifestProduct.toReview': 'Lanjut ke Review',
  'lumen.manifestProduct.uploadN': 'Upload {n} Dokumen',
  'lumen.manifestProduct.process': 'Process',
  'lumen.manifestProduct.grouping': 'Mengelompokkan dokumen berdasarkan jenis...',
  'lumen.manifestProduct.fileFailed': 'Gagal mengupload file. Silakan coba lagi.',
  'lumen.manifestProduct.noFileTitle': 'Tidak ada file',
  'lumen.manifestProduct.noFileBody': 'Silakan tambahkan file terlebih dahulu',
  'lumen.manifestProduct.noTypeTitle': 'Jenis dokumen belum dipilih',
  'lumen.manifestProduct.noTypeBody': '{n} file belum memiliki jenis dokumen',
  'lumen.manifestProduct.extractFailed': 'Gagal memulai ekstraksi manifest',
  'lumen.manifestProduct.uploadDoneTitle': 'Upload Selesai',
  'lumen.manifestProduct.uploadDoneBody': '{s} dari {t} dokumen berhasil diupload.',
  'lumen.manifestProduct.uploadError': 'Terjadi kesalahan saat mengupload dokumen: {message}',
  'lumen.manifestProduct.noBatch': 'Batch UUID tidak ditemukan. Silakan upload dokumen terlebih dahulu.',
  'lumen.manifestProduct.excelTitle': 'Upload Draft Manifest via Excel',
  'lumen.manifestProduct.excelSubtitle':
    'Upload 1 file Excel (.xls atau .xlsx) untuk membuat draft manifest secara langsung.',
  'lumen.manifestProduct.excelDrop': 'Tarik & lepas file Excel di sini',
  'lumen.manifestProduct.excelHint': 'Maksimal 1 file dengan format .xls atau .xlsx',
  'lumen.manifestProduct.excelPick': 'Pilih File Excel',
  'lumen.manifestProduct.excelRemove': 'Hapus File',
  'lumen.manifestProduct.excelRejected': 'Gunakan 1 file Excel (.xls atau .xlsx) untuk melanjutkan upload.',
  'lumen.manifestProduct.excelNoFile': 'Silakan pilih 1 file Excel terlebih dahulu.',
  'lumen.manifestProduct.excelUploading': 'Mengunggah file...',
  'lumen.manifestProduct.excelProcessing': 'Memproses manifest...',
  'lumen.manifestProduct.excelReady': '1 file Excel siap diproses',
  'lumen.manifestProduct.excelNone': 'Belum ada file Excel yang dipilih',
  'lumen.manifestProduct.excelNote': 'File Excel akan diproses dengan flow terpisah dari upload PDF.',
  'lumen.manifestProduct.excelContinue': 'Lanjutkan Upload Excel',
  'lumen.manifestProduct.excelBatchMissing': 'Batch UUID tidak ditemukan dari response upload.',
  'lumen.manifestProduct.excelUrlMissing': 'URL file hasil upload tidak ditemukan.',
  'lumen.manifestProduct.excelFailed': 'Upload Excel gagal diproses.',
  'lumen.manifestProduct.extractTitle': 'Mengekstraksi Manifest',
  'lumen.manifestProduct.extractDoneTitle': 'Ekstraksi Selesai!',
  'lumen.manifestProduct.extractBody': 'AI sedang membaca dan mengekstrak data dari dokumen Anda',
  'lumen.manifestProduct.extractDoneBody': 'Semua dokumen berhasil diekstraksi',
  'lumen.manifestProduct.startedAt': 'Mulai',
  'lumen.manifestProduct.duration': 'Durasi',
  'lumen.manifestProduct.statDone': 'Selesai',
  'lumen.manifestProduct.statRunning': 'Proses',
  'lumen.manifestProduct.statFailed': 'Gagal',
  'lumen.manifestProduct.statTotal': 'Total',
  'lumen.manifestProduct.viewResults': 'Lihat Hasil Ekstraksi',

  // ---- Lumen manifest form engine (revamp PR 6b): the page shell and the Header pilot (wave 1 F) ----
  // The old page's literal text, verbatim in every language (copy unchanged); {message}, {status}, {when}, {label},
  // {list} and {imo} are filled with formatTemplate, and **…** marks the bold words of a dialog line. New labels the
  // new parts need (sections, sectionDone/Todo, summary*, completeness, security, header.time/timeDone) are Indonesian
  // like the page. Wave 2 adds its own blocks (masterBl, bl, blEditor, container, barang, submit, susulan).
  'lumen.manifestEngine.shell.back': 'Back',
  'lumen.manifestEngine.shell.inward': 'Inward',
  'lumen.manifestEngine.shell.outward': 'Outward',
  'lumen.manifestEngine.shell.air': 'Air',
  'lumen.manifestEngine.shell.sea': 'Sea',
  'lumen.manifestEngine.shell.lihatDiCeisa': 'Lihat di Ceisa',
  'lumen.manifestEngine.shell.hapusAju': 'Hapus Aju Di Ceisa',
  'lumen.manifestEngine.shell.cekLengkap': 'Cek Lengkap',
  'lumen.manifestEngine.shell.submitDraft': 'Submit Draft',
  'lumen.manifestEngine.shell.prosesPenerimaan': 'Proses Penerimaan',
  'lumen.manifestEngine.shell.header': 'Header',
  'lumen.manifestEngine.shell.masterBl': 'Master BL',
  'lumen.manifestEngine.shell.masterAwb': 'Master AWB',
  'lumen.manifestEngine.shell.bl': 'BL',
  'lumen.manifestEngine.shell.awb': 'AWB',
  'lumen.manifestEngine.shell.container': 'Container',
  'lumen.manifestEngine.shell.barang': 'Barang',
  'lumen.manifestEngine.shell.previous': 'Sebelumnya',
  'lumen.manifestEngine.shell.next': 'Selanjutnya',
  'lumen.manifestEngine.shell.secureTitle': 'Secure & Private',
  'lumen.manifestEngine.shell.secureBody': 'Protected by enterprise-grade security',
  'lumen.manifestEngine.shell.ownershipTitle': 'Data Ownership',
  'lumen.manifestEngine.shell.ownershipBody': 'Your data belongs to you, always',
  'lumen.manifestEngine.shell.bankTitle': 'Bank-Level Security',
  'lumen.manifestEngine.shell.bankBody': 'Military-grade protection for your business',
  'lumen.manifestEngine.shell.loading': 'Loading document data',
  'lumen.manifestEngine.shell.loadingBody': 'This may take a moment as we process your document.',
  'lumen.manifestEngine.shell.savingTitle': 'Saving...',
  'lumen.manifestEngine.shell.savingHeader': 'Menyimpan header data...',
  'lumen.manifestEngine.shell.headerSaved': 'Header data berhasil disimpan',
  'lumen.manifestEngine.shell.headerSaveFailed': 'Gagal menyimpan header data. Silakan coba lagi.',
  'lumen.manifestEngine.shell.loadFailed': 'Gagal memuat data manifest',
  'lumen.manifestEngine.shell.loadFailedWith': 'Gagal memuat data manifest: {message}',
  'lumen.manifestEngine.shell.ajuNotFound': 'Nomor AJU tidak ditemukan',
  'lumen.manifestEngine.shell.prosesOk': 'Proses kirim berhasil',
  'lumen.manifestEngine.shell.prosesFailed': 'Proses kirim gagal',
  'lumen.manifestEngine.shell.prosesError': 'Gagal proses kirim: {message}',
  'lumen.manifestEngine.shell.cekOk': 'Cek lengkap berhasil',
  'lumen.manifestEngine.shell.cekFailed': 'Cek lengkap gagal',
  'lumen.manifestEngine.shell.cekError': 'Gagal cek lengkap: {message}',
  'lumen.manifestEngine.shell.berhasil': 'Berhasil',
  'lumen.manifestEngine.shell.hapusOk': 'AJU berhasil dihapus dari CEISA. Memuat ulang data...',
  'lumen.manifestEngine.shell.hapusFailed': 'Gagal hapus AJU di CEISA',
  'lumen.manifestEngine.shell.hapusError': 'Gagal hapus AJU: {message}',
  'lumen.manifestEngine.shell.lengkapTitle': 'Data Lengkap!',
  'lumen.manifestEngine.shell.lengkapBody': 'Semua data manifest telah lengkap dan siap diproses',
  'lumen.manifestEngine.shell.lengkapStatus': 'Status: {status}',
  'lumen.manifestEngine.shell.mengerti': 'Mengerti',
  'lumen.manifestEngine.shell.hapusTitle': 'Konfirmasi Hapus AJU',
  'lumen.manifestEngine.shell.hapusBody':
    'Apakah Anda yakin ingin **menghapus AJU** ini dari CEISA? Tindakan ini tidak dapat dibatalkan.',
  'lumen.manifestEngine.shell.nomorAju': 'Nomor AJU',
  'lumen.manifestEngine.shell.yaHapus': 'Ya, Hapus',
  'lumen.manifestEngine.shell.prosesTitle': 'Konfirmasi Proses Penerimaan',
  'lumen.manifestEngine.shell.prosesBody':
    'Apakah Anda yakin ingin **mengirim (proses penerimaan)** manifest ini ke CEISA?',
  'lumen.manifestEngine.shell.yaProses': 'Ya, Proses Penerimaan',
  'lumen.manifestEngine.shell.sections': 'Bagian manifest',
  'lumen.manifestEngine.shell.sectionDone': 'lengkap',
  'lumen.manifestEngine.shell.sectionTodo': 'belum lengkap',
  'lumen.manifestEngine.shell.summary': 'Ringkasan',
  'lumen.manifestEngine.shell.summaryDirection': 'Arah',
  'lumen.manifestEngine.shell.summaryKantor': 'Kantor',
  'lumen.manifestEngine.shell.completeness': 'Kelengkapan',
  'lumen.manifestEngine.shell.security': 'Keamanan',
  'lumen.manifestEngine.shell.reminderLoading': 'Reminder...',
  'lumen.manifestEngine.shell.reminderOff': 'Reminder belum aktif',
  'lumen.manifestEngine.shell.reminderArmed': 'Reminder armed · {when}',
  'lumen.manifestEngine.shell.reminderCancelLabel': 'Cancel reminder',
  'lumen.manifestEngine.shell.reminderCancelTitle': 'Batalkan Reminder?',
  'lumen.manifestEngine.shell.reminderCancelBody':
    'Reminder yang sedang aktif akan dibatalkan. Tindakan ini tidak otomatis menghapus rule — rule tetap berjalan untuk manifest lain.',
  'lumen.manifestEngine.shell.reminderClose': 'Tutup',
  'lumen.manifestEngine.shell.reminderConfirm': 'Ya, Batalkan',
  'lumen.manifestEngine.shell.reminderCancelled': 'Reminder dibatalkan.',
  'lumen.manifestEngine.shell.reminderCancelFailed': 'Gagal membatalkan reminder',
  'lumen.manifestEngine.shell.reminderLoadFailed': 'Gagal memuat reminder',
  'lumen.manifestEngine.shell.gagal': 'Gagal',
  'lumen.manifestEngine.header.kantor': 'Pilih kantor pabean',
  'lumen.manifestEngine.header.required': 'Field ini wajib diisi',
  'lumen.manifestEngine.header.vessel': 'Nama Sarana Pengangkut',
  'lumen.manifestEngine.header.imo': 'Nomor IMO / Registrasi',
  'lumen.manifestEngine.header.updateImo': 'Update Nomor IMO',
  'lumen.manifestEngine.header.new': 'New',
  'lumen.manifestEngine.header.voyage': 'Nomor Voyage',
  'lumen.manifestEngine.header.tanggalBerangkat': 'Tanggal Berangkat',
  'lumen.manifestEngine.header.tanggalTiba': 'Tanggal Tiba',
  'lumen.manifestEngine.header.reference': 'Reference ID',
  'lumen.manifestEngine.header.referenceOptional': '{label} (opsional)',
  'lumen.manifestEngine.header.referenceRequired': '{label} wajib diisi',
  'lumen.manifestEngine.header.referenceHintSource': 'Pilih dari daftar job perusahaan Anda, atau ketik manual',
  'lumen.manifestEngine.header.referenceHintFree': 'ID internal dari sistem Anda, mis. nomor PO/Job',
  'lumen.manifestEngine.header.referenceUnavailable':
    'Daftar job sedang tidak tersedia — silakan ketik nomornya manual.',
  'lumen.manifestEngine.header.duplicateWithAju': 'Reference ID ini sudah dipakai di AJU {list}',
  'lumen.manifestEngine.header.duplicateOther': 'Reference ID ini sudah dipakai di manifest lain',
  'lumen.manifestEngine.header.reusedTitle': 'Reference ID sudah dipakai',
  'lumen.manifestEngine.header.reusedWithAju': 'Reference ID ini juga dipakai di AJU {list}. Data tetap tersimpan.',
  'lumen.manifestEngine.header.reusedOther': 'Reference ID ini juga dipakai di manifest lain. Data tetap tersimpan.',
  'lumen.manifestEngine.header.imoNeedVessel': 'Masukkan nama sarana pengangkut terlebih dahulu',
  'lumen.manifestEngine.header.imoFound': 'Nomor IMO {imo} berhasil ditemukan',
  'lumen.manifestEngine.header.imoNotFoundTitle': 'Tidak ditemukan',
  'lumen.manifestEngine.header.imoNotFound': 'Nomor IMO tidak ditemukan untuk kapal ini',
  'lumen.manifestEngine.header.imoFailed': 'Gagal mencari nomor IMO',
  'lumen.manifestEngine.header.saveFailed': 'Gagal menyimpan header data',
  'lumen.manifestEngine.header.lookupLoading': 'Loading...',
  'lumen.manifestEngine.header.lookupEmpty': 'Tidak dapat menemukan',
  'lumen.manifestEngine.header.lookupFailed': 'Error when get {label}',
  'lumen.manifestEngine.header.time': 'Jam',
  'lumen.manifestEngine.header.timeDone': 'OK',
  // ---- end Lumen manifest/guardian/radar ----

  'lumen.consignee.namaPlaceholder': 'PT. CONTOH',
  // ---- end Lumen master B ----
  'lumen.featureLock.title': 'Fitur Belum Aktif',
  'lumen.featureLock.moduleInactive': 'Modul {module} belum aktif untuk perusahaan Anda.',
  'lumen.featureLock.thisModuleInactive': 'Modul ini belum aktif untuk perusahaan Anda.',
  'lumen.featureLock.contactAdmin': 'Silakan hubungi Admin Lumen untuk mengaktifkan fitur ini dan membahas pembayaran.',
  'lumen.featureLock.contactSales': 'Hubungi Customer Service',
  'lumen.featureLock.understood': 'Mengerti',
  // ---- Lumen master pages (P1): user, ceisa-user, export-bank, manifest-reminder, statement ----
  // The old pages' literal English, verbatim in every language (copy unchanged). Generic words are
  // lumen.common.* (Active, Cancel, Save, …); words two of these pages share live under the first one.
  // master/user
  'lumen.masterUser.searchPlaceholder': 'Search by name, email, ceisa user...',
  'lumen.masterUser.add': 'Add User',
  'lumen.masterUser.editTitle': 'Edit User',
  'lumen.masterUser.ceisaUser': 'Ceisa User',
  'lumen.masterUser.ceisaUserPlaceholder': 'Cari Ceisa User...',
  'lumen.masterUser.updated': 'User updated successfully',
  'lumen.masterUser.updateFailed': 'Failed to update user',
  'lumen.masterUser.created': 'User created successfully',
  'lumen.masterUser.createFailed': 'Failed to create user',
  // master/ceisa-user (also uses lumen.masterUser.add, updated, created and their failures)
  'lumen.masterCeisaUser.searchPlaceholder': 'Search by username, name, NPWP, company code...',
  'lumen.masterCeisaUser.editTitle': 'Edit Ceisa User',
  'lumen.masterCeisaUser.addTitle': 'Add Ceisa User',
  'lumen.masterCeisaUser.npwp': 'NPWP',
  'lumen.masterCeisaUser.npwpHint': 'Minimum 12 digits',
  'lumen.masterCeisaUser.companyCode': 'Company Code',
  'lumen.masterCeisaUser.address': 'Address',
  'lumen.masterCeisaUser.apiKey': 'API Key',
  'lumen.masterCeisaUser.apiKeyHint': 'CEISA beacukai-api-key',
  'lumen.masterCeisaUser.apiKeyEditHint': 'CEISA beacukai-api-key. Leave empty to clear.',
  'lumen.masterCeisaUser.applicationId': 'Application ID',
  'lumen.masterCeisaUser.lastSixDigitPrefix': 'Last Six Digit Prefix',
  'lumen.masterCeisaUser.npwpTooShort': 'NPWP must be at least 12 characters',
  'lumen.masterCeisaUser.deactivateTitle': 'Deactivate User',
  'lumen.masterCeisaUser.warning': 'Warning',
  'lumen.masterCeisaUser.deactivateConfirm':
    'Are you sure you want to deactivate user {username}? This action will set the user status to inactive.',
  'lumen.masterCeisaUser.deactivated': 'User deactivated successfully',
  'lumen.masterCeisaUser.deactivateFailed': 'Failed to deactivate user',
  // master/export-bank (the old page's own heading and line; Name is lumen.common.name)
  'lumen.masterExportBank.title': 'Export Bank',
  'lumen.masterExportBank.description': 'Manage the bank devisa catalogue used in export transaction forms.',
  'lumen.masterExportBank.searchPlaceholder': 'Search by code or name...',
  'lumen.masterExportBank.add': 'Add Export Bank',
  'lumen.masterExportBank.editTitle': 'Edit Export Bank',
  'lumen.masterExportBank.deleteTitle': 'Delete Export Bank',
  'lumen.masterExportBank.code': 'Code',
  'lumen.masterExportBank.codePlaceholder': 'e.g. BNI',
  'lumen.masterExportBank.namePlaceholder': 'Bank Name',
  'lumen.masterExportBank.activate': 'Activate',
  'lumen.masterExportBank.delete': 'Delete',
  'lumen.masterExportBank.required': 'Code and Name are required',
  'lumen.masterExportBank.created': 'Export bank created successfully',
  'lumen.masterExportBank.createFailed': 'Failed to create export bank',
  'lumen.masterExportBank.updated': 'Export bank updated successfully',
  'lumen.masterExportBank.updateFailed': 'Failed to update export bank',
  'lumen.masterExportBank.deactivated': 'Export bank deactivated',
  'lumen.masterExportBank.activated': 'Export bank activated',
  'lumen.masterExportBank.deleted': 'Export bank deleted successfully',
  'lumen.masterExportBank.deleteFailed': 'Failed to delete export bank',
  'lumen.masterExportBank.deleteConfirm':
    'Are you sure you want to delete bank {code} - {name}? This action cannot be undone.',
  // master/manifest-reminder (PPJK NPWP, MOT Type and the PPJK-required alert are lumen.common.*)
  'lumen.masterManifestReminder.searchPlaceholder': 'Search by email, direction, MOT...',
  'lumen.masterManifestReminder.add': 'Add Reminder',
  'lumen.masterManifestReminder.addTitle': 'Add Manifest Reminder',
  'lumen.masterManifestReminder.editTitle': 'Edit Manifest Reminder',
  'lumen.masterManifestReminder.direction': 'Direction',
  'lumen.masterManifestReminder.mot': 'MOT',
  'lumen.masterManifestReminder.refDate': 'Ref Date',
  'lumen.masterManifestReminder.offset': 'Offset',
  'lumen.masterManifestReminder.emails': 'Emails',
  'lumen.masterManifestReminder.referenceDate': 'Reference Date',
  'lumen.masterManifestReminder.offsetUnit': 'Offset Unit',
  'lumen.masterManifestReminder.offsetValue': 'Offset Value',
  'lumen.masterManifestReminder.emailsHint': 'Comma-separated email addresses',
  'lumen.masterManifestReminder.emailsPlaceholder': 'user@example.com,admin@example.com',
  'lumen.masterManifestReminder.emailsRequired': 'Please fill in the emails field',
  'lumen.masterManifestReminder.updated': 'Reminder config updated successfully',
  'lumen.masterManifestReminder.updateFailed': 'Failed to update reminder config',
  'lumen.masterManifestReminder.created': 'Reminder config created successfully',
  'lumen.masterManifestReminder.createFailed': 'Failed to create reminder config',
  'lumen.masterManifestReminder.deactivated': 'Reminder config deactivated successfully',
  'lumen.masterManifestReminder.deactivateFailed': 'Failed to deactivate reminder config',
  // ---- Lumen manifest/guardian (revamp PR 5, unit G) ----
  // The old page's literal text, verbatim in every language (copy unchanged). Active, Inactive, Edit, Create, Save,
  // Batal and PPJK NPWP are lumen.common.*.
  'lumen.manifestGuardian.title': 'The Guardian',
  'lumen.manifestGuardian.subtitle': 'Manifest reminder rules untuk PPJK {npwp}',
  'lumen.manifestGuardian.none': '—',
  'lumen.manifestGuardian.createRule': 'Create Rule',
  'lumen.manifestGuardian.colNo': '#',
  'lumen.manifestGuardian.manifestType': 'Manifest Type',
  'lumen.manifestGuardian.offset': 'Offset',
  'lumen.manifestGuardian.snooze': 'Snooze',
  'lumen.manifestGuardian.maxFires': 'Max Fires',
  'lumen.manifestGuardian.recipients': 'Recipients',
  'lumen.manifestGuardian.actions': 'Aksi',
  'lumen.manifestGuardian.offsetBefore': '{offset} sebelum',
  'lumen.manifestGuardian.snoozeEvery': 'setiap {snooze}',
  'lumen.manifestGuardian.unlimited': 'Unlimited',
  'lumen.manifestGuardian.delete': 'Delete',
  'lumen.manifestGuardian.loading': 'Memuat...',
  'lumen.manifestGuardian.noPpjk': 'PPJK NPWP tidak tersedia. Pastikan login.',
  'lumen.manifestGuardian.empty': 'Belum ada rule. Klik "Create Rule" untuk menambahkan.',
  'lumen.manifestGuardian.typeInwardAir': 'Inward Air',
  'lumen.manifestGuardian.typeInwardOcean': 'Inward Ocean',
  'lumen.manifestGuardian.typeOutwardAir': 'Outward Air',
  'lumen.manifestGuardian.typeOutwardOcean': 'Outward Ocean',
  'lumen.manifestGuardian.createTitle': 'Create Reminder Rule',
  'lumen.manifestGuardian.editTitle': 'Edit Reminder Rule',
  'lumen.manifestGuardian.typeLocked': 'Manifest type tidak bisa diubah — buat rule baru jika ingin tipe lain.',
  'lumen.manifestGuardian.offsetLabel': 'Offset (menit sebelum ETA/ETD)',
  'lumen.manifestGuardian.snoozeLabel': 'Snooze (menit)',
  'lumen.manifestGuardian.maxFireLabel': 'Max Fire Count (0 = unlimited)',
  'lumen.manifestGuardian.recipientsLabel': 'Recipients (comma-separated)',
  'lumen.manifestGuardian.recipientsPlaceholder': 'ops@dextercargo.com,manager@dextercargo.com',
  'lumen.manifestGuardian.deleteTitle': 'Hapus Rule?',
  'lumen.manifestGuardian.deleteBody':
    'Rule akan dihapus permanen. Reminder yang sedang berjalan untuk rule ini juga dibatalkan oleh backend pada fire berikutnya.',
  'lumen.manifestGuardian.deleteConfirm': 'Hapus',
  'lumen.manifestGuardian.toastSuccess': 'Berhasil',
  'lumen.manifestGuardian.toastError': 'Gagal',
  'lumen.manifestGuardian.toastWarning': 'Perhatian',
  'lumen.manifestGuardian.noPpjkWarning': 'PPJK NPWP belum tersedia. Pastikan login dengan PPJK terkait.',
  'lumen.manifestGuardian.recipientsRequired': 'Recipients wajib diisi.',
  'lumen.manifestGuardian.emailInvalid': 'Email tidak valid: {email}',
  'lumen.manifestGuardian.offsetPositive': 'Offset Minutes harus > 0.',
  'lumen.manifestGuardian.snoozePositive': 'Snooze Minutes harus > 0.',
  'lumen.manifestGuardian.maxFireNegative': 'Max Fire Count tidak boleh negatif (0 = unlimited).',
  'lumen.manifestGuardian.created': 'Rule berhasil dibuat.',
  'lumen.manifestGuardian.updated': 'Rule berhasil diperbarui.',
  'lumen.manifestGuardian.deleted': 'Rule berhasil dihapus.',
  'lumen.manifestGuardian.loadFailed': 'Gagal memuat daftar rule',
  'lumen.manifestGuardian.saveFailed': 'Gagal menyimpan rule',
  'lumen.manifestGuardian.deleteFailed': 'Gagal menghapus rule',

  // ---- Lumen manifest form engine (revamp PR 6b, wave 2 M): the Master BL / AWB section ----
  // The old section's literal text, verbatim in every language (copy unchanged); {count}, {failed} and {message} are
  // filled with formatTemplate. Kelompok Pos option labels stay constants in master-bl.logic.ts (CEISA code names).
  'lumen.manifestEngine.masterBl.titleBl': 'Data Master BL',
  'lumen.manifestEngine.masterBl.titleAwb': 'Data Master AWB',
  'lumen.manifestEngine.masterBl.uploadBl': 'Upload Master BL',
  'lumen.manifestEngine.masterBl.uploadAwb': 'Upload Master AWB',
  'lumen.manifestEngine.masterBl.addBl': 'Tambah Master BL',
  'lumen.manifestEngine.masterBl.addAwb': 'Tambah Master AWB',
  'lumen.manifestEngine.masterBl.editBl': 'Edit Master BL',
  'lumen.manifestEngine.masterBl.editAwb': 'Edit Master AWB',
  'lumen.manifestEngine.masterBl.colKelompok': 'Kel. Pos',
  'lumen.manifestEngine.masterBl.colNomor': 'No Master',
  'lumen.manifestEngine.masterBl.colTanggal': 'Tgl. Master',
  'lumen.manifestEngine.masterBl.colJumlah': 'Jml Pos',
  'lumen.manifestEngine.masterBl.colAksi': 'Aksi',
  'lumen.manifestEngine.masterBl.attach': 'Attach to BL',
  'lumen.manifestEngine.masterBl.copy': 'Copy',
  'lumen.manifestEngine.masterBl.delete': 'Delete',
  'lumen.manifestEngine.masterBl.kelompokPos': 'Kelompok Pos',
  'lumen.manifestEngine.masterBl.nomorMaster': 'Nomor Master',
  'lumen.manifestEngine.masterBl.tanggalMaster': 'Tanggal Master',
  'lumen.manifestEngine.masterBl.required': 'Field ini wajib diisi',
  'lumen.manifestEngine.masterBl.noResults': 'No results found.',
  'lumen.manifestEngine.masterBl.matchedBl': '{count} Host BL ditemukan dengan nomor Master BL ini',
  'lumen.manifestEngine.masterBl.matchedAwb': '{count} Host AWB ditemukan dengan nomor Master AWB ini',
  'lumen.manifestEngine.masterBl.validationTitle': 'Validation Error',
  'lumen.manifestEngine.masterBl.validationBody': 'Silakan lengkapi semua field yang wajib diisi',
  'lumen.manifestEngine.masterBl.processingBl': 'Memproses Master BL...',
  'lumen.manifestEngine.masterBl.processingAwb': 'Memproses Master AWB...',
  'lumen.manifestEngine.masterBl.processingHint': 'Mohon tunggu, jangan tutup halaman.',
  'lumen.manifestEngine.masterBl.needHeader': 'Manifest belum tersedia. Simpan header dulu sebelum upload Master BL.',
  'lumen.manifestEngine.masterBl.noBatch': 'Batch UUID tidak ditemukan.',
  'lumen.manifestEngine.masterBl.badUpload': 'Upload response tidak mengandung file_url / file_id.',
  'lumen.manifestEngine.masterBl.extracted': 'Ekstraksi Master BL selesai. Memuat ulang data...',
  'lumen.manifestEngine.masterBl.uploadFailed': 'Gagal upload Master BL.',
  'lumen.manifestEngine.masterBl.blsUpdated': '{count} BL berhasil diperbarui',
  'lumen.manifestEngine.masterBl.warningTitle': 'Warning',
  'lumen.manifestEngine.masterBl.blsFailed': '{failed} dari {count} BL gagal diperbarui',
  'lumen.manifestEngine.masterBl.noProcess': 'Lumen Process ID tidak ditemukan',
  'lumen.manifestEngine.masterBl.duplicateTitle': 'Duplikat',
  'lumen.manifestEngine.masterBl.duplicateBody': 'Master BL dengan nomor ini sudah ada',
  'lumen.manifestEngine.masterBl.saving': 'Menyimpan Master BL...',
  'lumen.manifestEngine.masterBl.added': 'Master BL berhasil ditambahkan',
  'lumen.manifestEngine.masterBl.updated': 'Master BL berhasil diperbarui',
  'lumen.manifestEngine.masterBl.saveFailed': 'Gagal menyimpan Master BL',
  'lumen.manifestEngine.masterBl.saveFailedWith': 'Gagal menyimpan Master BL: {message}',
  'lumen.manifestEngine.masterBl.copyUnsaved': 'Tidak dapat menyalin Master BL yang belum disimpan',
  'lumen.manifestEngine.masterBl.copyingTitle': 'Copying...',
  'lumen.manifestEngine.masterBl.copying': 'Menyalin Master BL...',
  'lumen.manifestEngine.masterBl.copied': 'Master BL berhasil disalin',
  'lumen.manifestEngine.masterBl.copyFailed': 'Gagal menyalin Master BL',
  'lumen.manifestEngine.masterBl.copyFailedWith': 'Gagal menyalin Master BL: {message}',
  'lumen.manifestEngine.masterBl.deletingTitle': 'Deleting...',
  'lumen.manifestEngine.masterBl.deleting': 'Menghapus Master BL...',
  'lumen.manifestEngine.masterBl.deleted': 'Master BL berhasil dihapus',
  'lumen.manifestEngine.masterBl.deleteFailed': 'Gagal menghapus Master BL',
  'lumen.manifestEngine.masterBl.deleteFailedWith': 'Gagal menghapus Master BL: {message}',
  'lumen.manifestEngine.masterBl.applyNone': 'Silakan pilih minimal satu BL untuk menerapkan data Master BL.',
  'lumen.manifestEngine.masterBl.masterNotFound': 'Master BL tidak ditemukan',
  'lumen.manifestEngine.masterBl.applied': 'Master BL data diterapkan ke {count} BL dan diperbarui di latar belakang.',
  'lumen.manifestEngine.masterBl.applyTitleBl': 'Terapkan Master BL ke BL',
  'lumen.manifestEngine.masterBl.applyTitleAwb': 'Terapkan Master AWB ke AWB',
  'lumen.manifestEngine.masterBl.applyIntroBl': 'Data Master BL berikut akan diterapkan ke BL:',
  'lumen.manifestEngine.masterBl.applyIntroAwb': 'Data Master AWB berikut akan diterapkan ke AWB:',
  'lumen.manifestEngine.masterBl.applyKelompok': 'Kelompok Pos:',
  'lumen.manifestEngine.masterBl.applyNomor': 'Nomor Master:',
  'lumen.manifestEngine.masterBl.applyTanggal': 'Tanggal Master:',
  'lumen.manifestEngine.masterBl.pickBls': 'Pilih BL yang akan diterapkan:',
  'lumen.manifestEngine.masterBl.selectAll': 'Pilih Semua',
  'lumen.manifestEngine.masterBl.noBls': 'Tidak ada BL yang tersedia. Silakan buat BL terlebih dahulu di tab BL.',
  'lumen.manifestEngine.masterBl.houseBl': 'House BL:',
  'lumen.manifestEngine.masterBl.selected': '{count} BL dipilih',
  'lumen.manifestEngine.masterBl.lanjutkan': 'Lanjutkan',

  // /manifest/doc-pabean "Doc Manifes" (revamp PR 6a, unit D): the page, its dialogs, Cargo Tracking and
  // the upload dialog. Copied word for word, the same text in id, zh and en. The ID/JA column labels stay in
  // the page's own dictionary (doc-manifes-dict.ts).
  'lumen.manifestDocPabean.loadFailed': 'Gagal memuat data Manifest Doc Pabean.',
  'lumen.manifestDocPabean.retry': 'Coba lagi',
  'lumen.manifestDocPabean.langId': 'ID',
  'lumen.manifestDocPabean.langJa': 'JA',
  'lumen.manifestDocPabean.actDownload': 'Download',
  'lumen.manifestDocPabean.actView': 'View',
  'lumen.manifestDocPabean.actCopy': 'Copy',
  'lumen.manifestDocPabean.actUpload': 'Upload Dokumen',
  'lumen.manifestDocPabean.actRekon': 'Update ke REKON',
  'lumen.manifestDocPabean.actDelete': 'Delete',
  'lumen.manifestDocPabean.demoCannotCopy': 'Demo users cannot copy',
  'lumen.manifestDocPabean.demoCannotEdit': 'Demo users cannot edit',
  'lumen.manifestDocPabean.demoCannotUpload': 'Demo users cannot upload',
  'lumen.manifestDocPabean.demoCannotRekon': 'Demo users cannot update to REKON',
  'lumen.manifestDocPabean.demoCannotDelete': 'Demo users cannot delete',
  'lumen.manifestDocPabean.imo': ' | IMO: {imo}',
  'lumen.manifestDocPabean.copied': 'Manifest berhasil disalin',
  'lumen.manifestDocPabean.copyFailed': 'Gagal menyalin manifest',
  'lumen.manifestDocPabean.copyFailedWith': 'Gagal menyalin manifest: {message}',
  'lumen.manifestDocPabean.deleted': 'Manifest berhasil dihapus',
  'lumen.manifestDocPabean.deleteFailed': 'Gagal menghapus manifest',
  'lumen.manifestDocPabean.deleteFailedWith': 'Gagal menghapus manifest: {message}',
  'lumen.manifestDocPabean.rekonDone': 'Status berhasil diubah ke REKON',
  'lumen.manifestDocPabean.rekonFailed': 'Gagal mengubah status',
  'lumen.manifestDocPabean.rekonFailedWith': 'Gagal mengubah status: {message}',
  'lumen.manifestDocPabean.statusFailed': 'Gagal mengambil data status manifest',
  'lumen.manifestDocPabean.statusFailedWith': 'Gagal mengambil data status: {message}',
  'lumen.manifestDocPabean.pdfFailedWith': 'Gagal mengunduh PDF: {message}',
  'lumen.manifestDocPabean.deleteTitle': 'Konfirmasi Hapus',
  'lumen.manifestDocPabean.deleteBody': 'Apakah Anda yakin ingin menghapus manifest ini?',
  'lumen.manifestDocPabean.detailCompany': 'Nama Perusahaan',
  'lumen.manifestDocPabean.detailVoyage': 'Voyage',
  'lumen.manifestDocPabean.detailAju': 'Nomor AJU',
  'lumen.manifestDocPabean.detailVessel': 'Vessel',
  'lumen.manifestDocPabean.delete': 'Hapus',
  'lumen.manifestDocPabean.rekonTitle': 'Konfirmasi Update Status',
  'lumen.manifestDocPabean.rekonBody': 'Apakah Anda yakin ingin mengubah status manifest ini ke {status}?',
  'lumen.manifestDocPabean.downloadTitle': 'Download Dokumen',
  'lumen.manifestDocPabean.responCount': 'Respon ({n})',
  'lumen.manifestDocPabean.responRekon': 'Rekon',
  'lumen.manifestDocPabean.responPenerimaan': 'Penerimaan',
  'lumen.manifestDocPabean.responPerbaikan': 'Perbaikan',
  'lumen.manifestDocPabean.close': 'Tutup',
  'lumen.manifestDocPabean.trackingTitle': 'Cargo Tracking',
  'lumen.manifestDocPabean.trackingLoading': 'Loading cargo tracking...',
  'lumen.manifestDocPabean.trackingEmpty': 'No cargo tracking data available',
  'lumen.manifestDocPabean.trackingFailed': 'Failed to fetch cargo tracking data',
  'lumen.manifestDocPabean.trackingContainers': 'Container',
  'lumen.manifestDocPabean.trackingContainer': 'Container {n}',
  'lumen.manifestDocPabean.trackingEta': 'ETA {date}',
  'lumen.manifestDocPabean.trackingEvents': 'Events',
  'lumen.manifestDocPabean.trackingActual': 'Actual',
  'lumen.manifestDocPabean.trackingEstimated': 'Estimated',
  'lumen.manifestDocPabean.uploadType': 'Tipe Dokumen',
  'lumen.manifestDocPabean.typeRevisi': 'Revisi',
  'lumen.manifestDocPabean.typePenerimaan': 'Penerimaan',
  'lumen.manifestDocPabean.typeSync': 'Sync',
  'lumen.manifestDocPabean.hintRevisi': '* Revisi: Hanya 1 file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.hintSync': '* Sync: Hanya 1 file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.hintPenerimaan': '* Penerimaan: Bisa multiple files (PDF atau Excel)',
  'lumen.manifestDocPabean.labelExcel': 'Upload File Excel (1 file)',
  'lumen.manifestDocPabean.labelMulti': 'Upload File (PDF atau Excel, bisa multiple)',
  'lumen.manifestDocPabean.labelAny': 'Upload File (PDF atau Excel)',
  'lumen.manifestDocPabean.placeholderExcel': 'Pilih 1 file Excel...',
  'lumen.manifestDocPabean.placeholderMulti': 'Pilih file (bisa lebih dari satu)...',
  'lumen.manifestDocPabean.fileLine': '{i}. {name} ({size} KB)',
  'lumen.manifestDocPabean.fileTotal': 'Total: {n} file(s)',
  'lumen.manifestDocPabean.upload': 'Upload',
  'lumen.manifestDocPabean.errNoType': 'Pilih tipe dokumen terlebih dahulu',
  'lumen.manifestDocPabean.errNoFile': 'Pilih file terlebih dahulu',
  'lumen.manifestDocPabean.errRevisiOne': 'Revisi hanya bisa upload 1 file Excel',
  'lumen.manifestDocPabean.errRevisiExcel': 'Revisi hanya menerima file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.errSyncOne': 'Sync hanya bisa upload 1 file Excel',
  'lumen.manifestDocPabean.errSyncExcel': 'Sync hanya menerima file Excel (.xlsx atau .xls)',
  'lumen.manifestDocPabean.errNotPdfExcel': 'File {name} bukan PDF atau Excel',
  'lumen.manifestDocPabean.uploadedAll': '{n} file berhasil diupload',
  'lumen.manifestDocPabean.partialTitle': 'Partial Success',
  'lumen.manifestDocPabean.uploadedPartial': '{ok} file berhasil, {fail} file gagal',
  'lumen.manifestDocPabean.uploadedNone': 'Semua file gagal diupload',
  'lumen.manifestDocPabean.uploadFailedWith': 'Gagal upload file: {message}',
  'lumen.draft.colShipmentType': 'Shipment Type',
  'lumen.draft.colCustomer': 'Customer Name',
  'lumen.draft.colImportir': 'Importer Name',
  'lumen.draft.colLatestUpdate': 'Latest Update',
  'lumen.draft.colMot': 'MOT',
  'lumen.draft.colKantor': 'Customs Office',
  'lumen.draft.colActions': 'Actions',
  'lumen.draft.edit': 'Edit',
  'lumen.draft.selected': '{n} item(s) selected',
  'lumen.draft.deleteSelected': 'Delete Selected',
  'lumen.draft.filterShipment': 'Shipment Type',
  'lumen.draft.filterCustomer': 'Customer Name',
  'lumen.draft.filterImportir': 'Importer Name',
  'lumen.draft.filterMot': 'Transport Mode',
  'lumen.docPabean.logoNoWebsite': 'No website yet',
  'lumen.docPabean.logoWrong': 'This logo is wrong',
  'lumen.docPabean.logoMissing': 'This company has a logo',
  'lumen.docPabean.logoWebsitePlaceholder': 'Correct website, e.g. mahle.com',
  'lumen.docPabean.logoSendWebsite': 'Send website',
  'lumen.docPabean.logoReviewNote': 'Reports are reviewed before they are applied.',
  'lumen.docPabean.logoOf': 'Logo {name}',
  'lumen.docPabean.uploadTitle': 'Upload Files',
  'lumen.docPabean.uploadRefresh': 'Refresh',
  'lumen.docPabean.uploadColSeri': 'No.',
  'lumen.docPabean.uploadColJenis': 'Type',
  'lumen.docPabean.uploadColNo': 'Document No.',
  'lumen.docPabean.uploadColFile': 'File',
  'lumen.docPabean.uploadColAksi': 'Actions',
  'lumen.docPabean.uploadLoading': 'Loading documents...',
  'lumen.docPabean.uploadEmpty': 'This batch has no documents yet.',
  'lumen.docPabean.uploadNoFile': 'No file yet',
  'lumen.docPabean.uploadReplace': 'Replace file',
  'lumen.docPabean.uploadUpload': 'Upload file',
  'lumen.docPabean.uploadClose': 'Close',
  'lumen.docPabean.uploadDone': '{name} uploaded',
  'lumen.docPabean.uploadFailed': 'Upload failed',
  'lumen.docPabean.uploadListFailed': 'Could not load the document list',
  'lumen.docPabean.uploadBadFormatTitle': 'Unsupported format',
  'lumen.docPabean.uploadBadFormat': 'Only PDF or Excel files (.xlsx/.xls/.csv) are allowed.',
  'lumen.docPabean.blokirLoadFailed': 'Could not load Monitoring Blokir.',
  'lumen.uploadKit.loadingText': 'Memuat...',
  'lumen.uploadKit.emptyText': 'Tidak ditemukan',
  'lumen.uploadKit.loadErrorText': 'Gagal memuat',
  'lumen.docReview.loading': 'Loading...',
  'lumen.docReview.errorTitle': 'Error',
  'lumen.docReview.title': 'Review Dokumen',
  'lumen.docReview.noDocsFound': 'No Documents Found',
  'lumen.docReview.noDocsDesc': 'No documents were found for this batch. Please go back and try again.',
  'lumen.docReview.goBack': 'Go Back',
  'lumen.docReview.back': 'Back',
  'lumen.docReview.documents': 'Dokumen',
  'lumen.docReview.pages': 'halaman',
  'lumen.docReview.selectedPages': 'Halaman terpilih:',
  'lumen.docReview.noSelection': 'Belum ada halaman terpilih',
  'lumen.docReview.loadingPdfPreview': 'Loading PDF preview...',
  'lumen.docReview.openInNewTab': 'Buka di tab baru',
  'lumen.docReview.openPdfInNewTab': 'Open PDF in new tab',
  'lumen.docReview.documentSelection': 'Document Selection',
  'lumen.docReview.documentsByCategory': 'Documents by Category',
  'lumen.docReview.excelUnavailable': 'Excel - Preview unavailable',
  'lumen.docReview.includedInSubmission': 'Included in submission',
  'lumen.docReview.pagesAllSelected': 'pages selected',
  'lumen.docReview.extractedBy': 'Extracted by',
  'lumen.docReview.processing': 'Processing...',
  'lumen.docReview.preparingDocs': 'Preparing your documents...',
  'lumen.docReview.fetchingDocs': 'Fetching document data...',
  'lumen.docReview.waitProcessing': 'Please wait while we process your request. This may take a few moments.',
  'lumen.docReview.donNavigateAway': 'Please do not close this page or navigate away.',
  'lumen.docReview.dataLossWarning': 'Closing this page may result in data loss',
  'lumen.docReview.successTitle': 'Berhasil',
  'lumen.docReview.selectionSaved': 'Pilihan halaman berhasil disimpan',
  'lumen.docReview.submitError': 'Failed to submit selection. Please try again.',
  'lumen.docReview.fetchError': 'Failed to fetch files. Please try again.',
  'lumen.docReview.viewerError': 'Gagal memuat pratinjau PDF. Coba unduh file atau refresh halaman.',
  'lumen.docReview.noPdfPreview': 'No PDF documents available for preview',
  'lumen.docReview.processingModalTitle': 'Processing Documents',
  'lumen.docReview.processingCompleteTitle': 'Processing Complete',
  'lumen.docReview.processingSuccessDesc': 'Your documents have been processed successfully!',
  'lumen.docReview.submitSelection': 'Submit Selection',
  'lumen.docReview.documentPlaceholder': 'Dokumen {id}',
  'lumen.docReview.allExcelNote':
    'All uploaded files are Excel documents. They will be included in the submission but cannot be previewed here.',
  'lumen.docReview.categoryHeading': '{category} ({count})',

  // PR 7b B6a: the export upload wizard
  'lumen.exportWizard.title': 'Upload Dokumen Ekspor',
  'lumen.exportWizard.subtitle': 'BC 3.0 · Alur 3 langkah',
  'lumen.exportWizard.oldMode': 'Mode Lama (PDF / Excel)',
  'lumen.exportWizard.oldModeTitle': 'Pakai Mode Lama: Upload PDF / Excel langsung tanpa wizard',
  'lumen.exportWizard.step1': 'Pelabuhan Muat',
  'lumen.exportWizard.step1Desc': 'Pilih kode pelabuhan',
  'lumen.exportWizard.step2': 'Eksportir',
  'lumen.exportWizard.step2Desc': 'Pilih perusahaan eksportir',
  'lumen.exportWizard.step3': 'Dokumen',
  'lumen.exportWizard.step3Desc': 'Upload file PDF',
  'lumen.exportWizard.back': 'Kembali',
  'lumen.exportWizard.next': 'Lanjutkan',
  'lumen.exportWizard.upload': 'Upload Dokumen',
  'lumen.exportWizard.uploading': 'Mengunggah...',
  'lumen.exportWizard.scaffolding': 'Menyiapkan draft...',
  'lumen.exportWizard.readingDocs': 'Membaca dokumen %s/%s...',
  'lumen.exportWizard.uploadDisabled': 'Tombol aktif setelah semua dokumen selesai dibaca',
  'lumen.exportWizard.portLabel': 'Pelabuhan Muat',
  'lumen.exportWizard.portPlaceholder': 'Cari pelabuhan (kode atau nama)',
  'lumen.exportWizard.portTitle': 'Kode Pelabuhan Muat',
  'lumen.exportWizard.portDesc':
    'Pilih pelabuhan tempat barang akan dimuat untuk ekspor. Anda dapat mencari berdasarkan kode atau nama pelabuhan.',
  'lumen.exportWizard.whyImportant': 'Mengapa ini penting?',
  'lumen.exportWizard.whyDesc':
    'Kode pelabuhan muat akan digunakan untuk mengisi data header PEB secara otomatis pada langkah berikutnya.',
  'lumen.exportWizard.required': 'Field ini wajib diisi',
  'lumen.exportWizard.exporterTitle': 'Pilih Eksportir',
  'lumen.exportWizard.exporterDesc': 'Pilih perusahaan eksportir yang akan digunakan untuk dokumen ini.',
  'lumen.exportWizard.exporterPlaceholder': 'Cari nama, NPWP, penerima, atau pembeli',
  'lumen.exportWizard.results': 'Menampilkan %s-%s dari %s',
  'lumen.exportWizard.noData': 'Tidak ada data',
  'lumen.exportWizard.or': 'ATAU',
  'lumen.exportWizard.excelUpload': 'Upload File Excel CEISA',
  'lumen.exportWizard.excelUploadDesc': 'Klik atau seret file Excel (.xlsx, .xls) ke area ini',
  'lumen.exportWizard.change': 'Ubah',
  'lumen.exportWizard.loading': 'Loading...',
  'lumen.exportWizard.step1PelabuhanMuat': 'Pelabuhan Muat',
  'lumen.exportWizard.step1PelabuhanMuatDesc': 'Pilih kode pelabuhan',
  'lumen.exportWizard.excelFormatError': 'Format tidak didukung',
  'lumen.exportWizard.excelFormatErrorDesc': 'Hanya file Excel (.xls, .xlsx) yang diterima.',
  'lumen.exportWizard.excelSearchPlaceholder': 'Cari nama, NPWP, penerima, atau pembeli',
  'lumen.exportWizard.resultsCount': 'Menampilkan {from}-{to} dari {total}',
  'lumen.exportWizard.failedLoad': 'Gagal memuat data',
  'lumen.exportWizard.retry': 'Coba Lagi',
  'lumen.exportWizard.emptyState': 'Tidak ada eksportir ditemukan',
  'lumen.exportWizard.emptyStateDesc': 'Coba ubah kata kunci pencarian atau periksa kembali data Anda.',
  'lumen.exportWizard.previous': 'Sebelumnya',
  'lumen.exportWizard.paginationNext': 'Selanjutnya',
  'lumen.exportWizard.uploadExcelDatabase': 'Upload Excel Database',
  'lumen.exportWizard.uploadExcelDatabaseDesc': 'Upload file Excel CEISA untuk memproses data ekspor secara langsung.',
  'lumen.exportWizard.emptyStateClick': 'Klik untuk pilih file Excel CEISA',
  'lumen.exportWizard.emptyStateFormat': 'Format: .xls, .xlsx',
  'lumen.exportWizard.uploadingProcessing': 'Mengupload dan memproses...',
  'lumen.exportWizard.uploadingProcessingDesc': 'Mohon tunggu, sedang memproses file Excel CEISA',
  'lumen.exportWizard.step3Title': 'Upload Dokumen',
  'lumen.exportWizard.step3Subtitle': 'Unggah file PDF untuk masing-masing jenis dokumen yang diperlukan.',
  'lumen.exportWizard.selectUnspecified': 'Belum dipilih',
  'lumen.exportWizard.summaryTitle': 'Ringkasan Upload',
  'lumen.exportWizard.summaryDesc':
    'Periksa jenis dokumen untuk setiap file sebelum upload. Ubah di daftar di atas jika ada yang salah.',
  'lumen.exportWizard.noInvoiceTitle': 'Belum ada file Invoice',
  'lumen.exportWizard.noInvoiceBefore': 'Salah satu file harus bertipe ',
  'lumen.exportWizard.noInvoiceStrong': 'Invoice (I)',
  'lumen.exportWizard.noInvoiceAfter':
    ' atau format Excel CEISA. Tanpa Invoice, Python tidak akan mengekstrak data barang dan tab Barang akan kosong. Ubah jenis dokumen salah satu file di daftar di atas.',
  'lumen.exportWizard.dupTypeTitle': 'Duplikat jenis dokumen',
  'lumen.exportWizard.dupTypeBefore': 'Beberapa file memiliki jenis dokumen yang sama: ',
  'lumen.exportWizard.dupTypeStrong':
    ', Pastikan ini memang disengaja — biasanya setiap jenis dokumen hanya diunggah satu kali.',
  'lumen.exportWizard.dataFilledTitle': 'Data eksportir & pelabuhan sudah terisi',
  'lumen.exportWizard.dataFilledDesc':
    'Setelah upload selesai, halaman review hanya akan meminta Anda memverifikasi halaman-halaman yang berisi data barang. Informasi eksportir dan pelabuhan akan otomatis terisi dari pilihan Anda di langkah sebelumnya.',
  'lumen.exportWizard.uploadSuccessTitle': 'Upload Berhasil',
  'lumen.exportWizard.uploadSuccessMsg': 'File Excel CEISA berhasil diupload dan diproses.',
  'lumen.exportWizard.uploadFailedTitle': 'Upload gagal',
  'lumen.exportWizard.scaffoldFailedTitle': 'Gagal scaffold',
  'lumen.exportWizard.uploadDoneTitle': 'Berhasil',
  'lumen.exportWizard.uploadDoneMsg': 'Dokumen berhasil diunggah. Mengarahkan ke halaman review.',
  'lumen.exportWizard.confirmDiscard':
    'Berkas sudah terunggah ke draft ini. Kembali akan membuang progres upload. Lanjutkan?',
  'lumen.exportWizard.stepBadge': 'Langkah {step} dari {total}',
  'lumen.exportWizard.stepPageInfo': 'Halaman {page} dari {totalPages}',

  // PR 6b B2: the BL editor (Sheet, sections, inner HS / Container / Dokumen lists). Old text verbatim,
  // the same in id, zh and en; sections, selectAll and selectRow are new labels for the new parts.
  'lumen.manifestEngine.blEditor.titleAddBl': 'Tambah Data BL',
  'lumen.manifestEngine.blEditor.titleAddAwb': 'Tambah Data AWB',
  'lumen.manifestEngine.blEditor.titleEditBl': 'Edit Data BL',
  'lumen.manifestEngine.blEditor.titleEditAwb': 'Edit Data AWB',
  'lumen.manifestEngine.blEditor.sections': 'Bagian BL',
  'lumen.manifestEngine.blEditor.batal': 'Batal',
  'lumen.manifestEngine.blEditor.simpan': 'Simpan',
  'lumen.manifestEngine.blEditor.required': 'Field ini wajib diisi',
  'lumen.manifestEngine.blEditor.successTitle': 'Success',
  'lumen.manifestEngine.blEditor.errorTitle': 'Error',
  'lumen.manifestEngine.blEditor.warningTitle': 'Warning',
  'lumen.manifestEngine.blEditor.validationTitle': 'Validation Error',
  'lumen.manifestEngine.blEditor.validationMessage': 'Please fill in all required fields',
  'lumen.manifestEngine.blEditor.updated': 'BL data has been updated successfully',
  'lumen.manifestEngine.blEditor.added': 'BL data has been added successfully',
  'lumen.manifestEngine.blEditor.saveFailed': 'Failed to save BL: {message}',
  'lumen.manifestEngine.blEditor.noResults': 'No results found.',
  'lumen.manifestEngine.blEditor.lookupLoading': 'Loading...',
  'lumen.manifestEngine.blEditor.lookupEmpty': 'Tidak dapat menemukan',
  'lumen.manifestEngine.blEditor.lookupFailed': 'Error when get {label}',
  'lumen.manifestEngine.blEditor.kelompokPosTitle': 'Kelompok Pos & Nomor Pos',
  'lumen.manifestEngine.blEditor.kelompokPos': 'Kelompok Pos',
  'lumen.manifestEngine.blEditor.nomorPos': 'Nomor Pos',
  'lumen.manifestEngine.blEditor.masterHostBl': 'Master BL & Host BL',
  'lumen.manifestEngine.blEditor.masterHostAwb': 'Master AWB & Host AWB',
  'lumen.manifestEngine.blEditor.masterBl': 'Master BL',
  'lumen.manifestEngine.blEditor.masterAwb': 'Master AWB',
  'lumen.manifestEngine.blEditor.tanggalMasterBl': 'Tanggal Master BL',
  'lumen.manifestEngine.blEditor.tanggalMasterAwb': 'Tanggal Master AWB',
  'lumen.manifestEngine.blEditor.hostBl': 'Host BL',
  'lumen.manifestEngine.blEditor.hostAwb': 'Host AWB',
  'lumen.manifestEngine.blEditor.tanggalHostBl': 'Tanggal Host BL',
  'lumen.manifestEngine.blEditor.tanggalHostAwb': 'Tanggal Host AWB',
  'lumen.manifestEngine.blEditor.flagBl': 'Flag BL',
  'lumen.manifestEngine.blEditor.konsolidasi': 'Konsolidasi',
  'lumen.manifestEngine.blEditor.parsial': 'Parsial',
  'lumen.manifestEngine.blEditor.partOf': 'Part Of',
  'lumen.manifestEngine.blEditor.pelabuhan': 'Pelabuhan',
  'lumen.manifestEngine.blEditor.pelabuhanAsal': 'Pelabuhan Asal',
  'lumen.manifestEngine.blEditor.pelabuhanBongkar': 'Pelabuhan Bongkar',
  'lumen.manifestEngine.blEditor.pelabuhanTransit': 'Pelabuhan Transit',
  'lumen.manifestEngine.blEditor.pelabuhanAkhir': 'Pelabuhan Akhir',
  'lumen.manifestEngine.blEditor.pilihPelabuhanAsal': 'Pilih Pelabuhan Asal',
  'lumen.manifestEngine.blEditor.pilihPelabuhanBongkar': 'Pilih Pelabuhan Bongkar',
  'lumen.manifestEngine.blEditor.pilihPelabuhanTransit': 'Pilih Pelabuhan Transit',
  'lumen.manifestEngine.blEditor.pilihPelabuhanAkhir': 'Pilih Pelabuhan Akhir',
  'lumen.manifestEngine.blEditor.motherVessel': 'Mother Vessel',
  'lumen.manifestEngine.blEditor.vesselName': 'Vessel Name',
  'lumen.manifestEngine.blEditor.copyFromHeader': 'Copy dari Header',
  'lumen.manifestEngine.blEditor.vesselCopied': 'Mother vessel copied from header',
  'lumen.manifestEngine.blEditor.vesselMissing': 'Header vessel or voyage data not found',
  'lumen.manifestEngine.blEditor.kemasan': 'Kemasan',
  'lumen.manifestEngine.blEditor.berat': 'Berat',
  'lumen.manifestEngine.blEditor.dimensi': 'Dimensi',
  'lumen.manifestEngine.blEditor.unitKg': 'kg',
  'lumen.manifestEngine.blEditor.unitM3': 'm3',
  'lumen.manifestEngine.blEditor.numberPlaceholder': '0',
  'lumen.manifestEngine.blEditor.marking': 'Marking',
  'lumen.manifestEngine.blEditor.markingPlaceholder': 'marking',
  'lumen.manifestEngine.blEditor.jenisKemasan': 'Jenis Kemasan',
  'lumen.manifestEngine.blEditor.pilihJenisKemasan': 'Pilih Jenis Kemasan',
  'lumen.manifestEngine.blEditor.totalKemasan': 'Total Kemasan',
  'lumen.manifestEngine.blEditor.jumlahKemasanTerangkut': 'Jumlah Kemasan Terangkut',
  'lumen.manifestEngine.blEditor.shipper': 'Shipper',
  'lumen.manifestEngine.blEditor.jenisIdentitas': 'Jenis Identitas',
  'lumen.manifestEngine.blEditor.npwpShipper': 'NPWP Shipper / Pengirim',
  'lumen.manifestEngine.blEditor.namaShipper': 'Nama Shipper / Pengirim',
  'lumen.manifestEngine.blEditor.alamatShipper': 'Alamat Shipper / Pengirim',
  'lumen.manifestEngine.blEditor.consignee': 'Consignee',
  'lumen.manifestEngine.blEditor.normalizeNpwp': 'Normalize NPWP',
  'lumen.manifestEngine.blEditor.npwpNormalizedTitle': 'NPWP Normalized',
  'lumen.manifestEngine.blEditor.npwpNormalized': 'NPWP diubah dari "{raw}" menjadi "{normalized}"',
  'lumen.manifestEngine.blEditor.npwpCleanTitle': 'NPWP sudah bersih',
  'lumen.manifestEngine.blEditor.npwpClean': 'Tidak ada simbol yang perlu dihapus.',
  'lumen.manifestEngine.blEditor.npwpConsignee': 'NPWP Consignee / Penerima',
  'lumen.manifestEngine.blEditor.namaConsignee': 'Nama Consignee / Penerima',
  'lumen.manifestEngine.blEditor.alamatConsignee': 'Alamat Consignee / Penerima',
  'lumen.manifestEngine.blEditor.notify': 'Notify',
  'lumen.manifestEngine.blEditor.salinConsignee': 'Salin Data Consignee',
  'lumen.manifestEngine.blEditor.consigneeCopied': 'Data Consignee telah disalin ke Notify',
  'lumen.manifestEngine.blEditor.npwpNotify': 'NPWP Notify',
  'lumen.manifestEngine.blEditor.namaNotify': 'Nama Notify',
  'lumen.manifestEngine.blEditor.alamatNotify': 'Alamat Notify',
  'lumen.manifestEngine.blEditor.dataHsCount': 'Data HS ({n})',
  'lumen.manifestEngine.blEditor.dataHs': 'Data HS',
  'lumen.manifestEngine.blEditor.hapusSelected': 'Hapus ({n} dipilih)',
  'lumen.manifestEngine.blEditor.combine': 'Combine Goods',
  'lumen.manifestEngine.blEditor.uncombine': 'Uncombine Goods',
  'lumen.manifestEngine.blEditor.slice': 'Slice HS Codes (4 Digits)',
  'lumen.manifestEngine.blEditor.addHs': 'TAMBAH DATA HS BARU',
  'lumen.manifestEngine.blEditor.colHs': 'HS',
  'lumen.manifestEngine.blEditor.colUraian': 'Uraian',
  'lumen.manifestEngine.blEditor.colAksi': 'Aksi',
  'lumen.manifestEngine.blEditor.edit': 'Edit',
  'lumen.manifestEngine.blEditor.copy': 'Copy',
  'lumen.manifestEngine.blEditor.delete': 'Delete',
  'lumen.manifestEngine.blEditor.selectAll': 'Pilih semua',
  'lumen.manifestEngine.blEditor.selectRow': 'Pilih baris {n}',
  'lumen.manifestEngine.blEditor.noSelection': 'Tidak ada item yang dipilih',
  'lumen.manifestEngine.blEditor.deletedCount': '{n} item berhasil dihapus',
  'lumen.manifestEngine.blEditor.slicedTitle': 'HS Codes Sliced',
  'lumen.manifestEngine.blEditor.sliced': 'All HS codes longer than 4 digits have been trimmed to 4 digits.',
  'lumen.manifestEngine.blEditor.hsDialogAdd': 'Tambah Data HS',
  'lumen.manifestEngine.blEditor.hsDialogEdit': 'Edit Data HS',
  'lumen.manifestEngine.blEditor.kodeHs': 'Kode HS',
  'lumen.manifestEngine.blEditor.uraianHs': 'Uraian HS',
  'lumen.manifestEngine.blEditor.cancel': 'Cancel',
  'lumen.manifestEngine.blEditor.ok': 'OK',
  'lumen.manifestEngine.blEditor.dataContainerCount': 'Data Container ({n})',
  'lumen.manifestEngine.blEditor.dataContainer': 'Data Container',
  'lumen.manifestEngine.blEditor.addContainer': 'TAMBAH CONTAINER BARU',
  'lumen.manifestEngine.blEditor.nomorContainer': 'Nomor Container',
  'lumen.manifestEngine.blEditor.tipeContainer': 'Tipe Container',
  'lumen.manifestEngine.blEditor.ukuranContainer': 'Ukuran Container',
  'lumen.manifestEngine.blEditor.jenisContainer': 'Jenis Container',
  'lumen.manifestEngine.blEditor.nomorSegel': 'Nomor Segel',
  'lumen.manifestEngine.blEditor.isPartOf': 'Is Part Of',
  'lumen.manifestEngine.blEditor.yes': 'Yes',
  'lumen.manifestEngine.blEditor.containerDialogAdd': 'Tambah Peti Kemas',
  'lumen.manifestEngine.blEditor.containerDialogEdit': 'Edit Peti Kemas',
  'lumen.manifestEngine.blEditor.type': 'Type',
  'lumen.manifestEngine.blEditor.nomorPolisi': 'Nomor Polisi',
  'lumen.manifestEngine.blEditor.driver': 'Driver',
  'lumen.manifestEngine.blEditor.ukuranPlaceholder': 'Ukuran',
  'lumen.manifestEngine.blEditor.jenisPlaceholder': 'Jenis',
  'lumen.manifestEngine.blEditor.segelPlaceholder': 'Segel',
  'lumen.manifestEngine.blEditor.tipePlaceholder': 'Tipe',
  'lumen.manifestEngine.blEditor.platNomorPlaceholder': 'Plat Nomor',
  'lumen.manifestEngine.blEditor.dataDokumenCount': 'Data Dokumen ({n})',
  'lumen.manifestEngine.blEditor.dataDokumen': 'Data Dokumen',
  'lumen.manifestEngine.blEditor.addDokumen': 'TAMBAH DOKUMEN BARU',
  'lumen.manifestEngine.blEditor.jenisDokumen': 'Jenis Dokumen',
  'lumen.manifestEngine.blEditor.nomorDok': 'Nomor Dok',
  'lumen.manifestEngine.blEditor.tanggalDokumen': 'Tanggal Dokumen',
  'lumen.manifestEngine.blEditor.kodeKantor': 'Kode Kantor',
  'lumen.manifestEngine.blEditor.kodeDokumenAsal': 'Kode Dokumen Asal',
  'lumen.manifestEngine.blEditor.pilihKodeDokumen': 'Pilih Kode Dokumen',
  'lumen.manifestEngine.blEditor.nomorDokumenAsal': 'Nomor Dokumen Asal',
  'lumen.manifestEngine.blEditor.nomorDokumenPlaceholder': '000000',
  'lumen.manifestEngine.blEditor.tanggalPlaceholder': '2025-10-19',
  'lumen.manifestEngine.blEditor.pilihKodeKantor': 'Pilih Kode Kantor',
  // ---- end Lumen manifest/guardian ----
  // master/statement (the Utama, scope, conflict and confirm copy stays in statement.*)
  'lumen.masterStatement.searchPlaceholder': 'Search by name, place, position...',
  'lumen.masterStatement.add': 'Add Config',
  'lumen.masterStatement.addTitle': 'Add Statement Config',
  'lumen.masterStatement.editTitle': 'Edit Statement Config',
  'lumen.masterStatement.position': 'Position',
  'lumen.masterStatement.place': 'Place',
  'lumen.masterStatement.positionPlaceholder': 'e.g. Manager',
  'lumen.masterStatement.placePlaceholder': 'e.g. Jakarta',
  'lumen.masterStatement.updated': 'Statement config updated successfully',
  'lumen.masterStatement.updateFailed': 'Failed to update statement config',
  'lumen.masterStatement.created': 'Statement config created successfully',
  'lumen.masterStatement.createFailed': 'Failed to create statement config',
  'lumen.masterStatement.deactivated': 'Statement config deactivated successfully',
  'lumen.masterStatement.deactivateFailed': 'Failed to deactivate statement config',
  // lumen.pibEngine (revamp PR 7c)
  'lumen.pibEngine.lookup.loading': 'Loading...',
  'lumen.pibEngine.lookup.empty': 'Not found',
  'lumen.pibEngine.lookup.failed': 'Error when get {label}',
  'lumen.pibEngine.lookup.clear': 'Clear',
  'lumen.pibEngine.select.empty': 'No results found.',
  'lumen.pibEngine.select.clear': 'Clear selection',
  'lumen.pibEngine.s1.draftTitle': 'Draft PIB',
  'lumen.pibEngine.s1.draftSubtitulo': 'Local preview, not sent to CEISA',
  'lumen.pibEngine.s1.printPdf': 'Print / Save PDF',
  'lumen.pibEngine.s1.backToDraft': 'Return to Draft',
  'lumen.pibEngine.s1.loadingDraft': 'Preparing draft PIB...',
  'lumen.pibEngine.eb1.errorPickHsFirst': 'Pick an HS Code first',
  'lumen.pibEngine.eb1.hsSpekMarked': 'HS Code marked as Special Goods HS Code',
  'lumen.pibEngine.eb1.hsSpekUnmarked': 'HS Code removed from Special Goods HS Code',
  'lumen.pibEngine.eb1.hsSpekToggleFailed': 'Failed to change Goods Status',
  'lumen.pibEngine.eb1.processIdMissing': 'Process ID not available. Please reload the page.',
  'lumen.pibEngine.eb1.hsDetailsFetchFailed': 'Failed to fetch HS Code details',
  'lumen.pibEngine.eb1.hsDetailsFetchError': 'Error fetching HS Code details',
  'lumen.pibEngine.eb2.navInformasiDasar': 'Basic information',
  'lumen.pibEngine.eb2.navDokumenTransaksi': 'Documents & Transactions',
  'lumen.pibEngine.eb2.navSpesifikasiKhusus': 'Special specifications',
  'lumen.pibEngine.eb2.navPungutan': 'Charges/Tariffs',
  'lumen.pibEngine.eb2.sectionInformasiDasar': 'Basic information',
  'lumen.pibEngine.eb2.sectionDetailHarga': 'Details & Prices',
  'lumen.pibEngine.eb2.sectionPungutan': 'Charges/Tariffs',
  'lumen.pibEngine.eb2.sectionDokumen': 'Documents',
  'lumen.pibEngine.eb2.sectionJenisTransaksi': 'Transaction type',
  'lumen.pibEngine.eb2.sectionSpesifikasiKhusus': 'Special specifications',
  'lumen.pibEngine.eb2.tambahBiaya': 'Add charges',
  'lumen.pibEngine.eb2.btnBatal': 'Cancel',
  'lumen.pibEngine.eb2.btnMenyimpan': 'Saving...',
  'lumen.pibEngine.eb2.btnTambahBarang': 'Add goods',
  'lumen.pibEngine.eb2.btnSimpan': 'Save',
  'lumen.pibEngine.eb2.btnHsSpekKhusus': 'Special HS Code',
  'lumen.pibEngine.eb2.btnTandaiHsSpekKhusus': 'Mark HS as Special HS Code',
  'lumen.pibEngine.eb2.btnYaTerapkan': 'Yes, Apply',
  'lumen.pibEngine.eb2.modalKonfirmasiTitle': 'Apply to All Items Confirmation',
  'lumen.pibEngine.eb2.modalKonfirmasiDesc':
    'You will apply HS Code, Unit Code, Package Code, Country of Origin, and Tariffs (PPN, PPH, BM) from this item to ALL OTHER items in the list.',
  'lumen.pibEngine.eb2.modalKonfirmasiWarning':
    'This action will overwrite existing data on all items. Are you sure you want to continue?',
  'lumen.pibEngine.eb2.modalMenyimpan': 'Saving goods data...',
  'lumen.pibEngine.eb2.errorTitle': 'Error',
  'lumen.pibEngine.eb2.errHsCodeRequired': 'HS Code is required',
  'lumen.pibEngine.eb2.errUraianRequired': 'Goods description is required',
  'lumen.pibEngine.eb2.errSatuanRequired': 'Quantity must be filled and greater than 0',
  'lumen.pibEngine.eb2.errKodeSatuanRequired': 'Unit code is required',
  'lumen.pibEngine.ebfix.successTitle': 'Success',
  'lumen.pibEngine.s2.kolomBelumLengkap': 'Please complete the missing fields',
  'lumen.pibEngine.s2.hargaMismatch': 'Total price mismatch',
  'lumen.pibEngine.s2.hargaMismatchDetail':
    'Goods tab {totalBarang} {valuta} ({totalItems} items) vs Transaksi tab {hargaBarang} {valuta} — difference {selisih} {valuta}.',
  'lumen.pibEngine.s2.hargaMismatchHint':
    'Does not block submit. Check Goods Price in Transaksi tab or per-item value in Barang tab.',
  'lumen.pibEngine.s2.oneWarning': '1 WARNING',
  'lumen.pibEngine.s2.go': 'Go',
  'lumen.pibEngine.s2.view': 'View',
  'lumen.pibEngine.s2.hide': 'Hide',
  'lumen.pibEngine.s2.show': 'Show',
  'lumen.pibEngine.s2.fieldRequired': '{field} is required',
  'lumen.pibEngine.s2.nibRequired': 'NIB for Importer is required',
  'lumen.pibEngine.s2.namaRequired': 'Name of {entity} is required',
  'lumen.pibEngine.s2.alamatRequired': 'Address of {entity} is required',
  'lumen.pibEngine.s2.identitasRequired': 'ID type of {entity} is required',
  'lumen.pibEngine.s2.npwpRequired': 'NPWP of {entity} is required',
  'lumen.pibEngine.s2.statusRequired': 'Importer status is required',
  'lumen.pibEngine.s2.apiRequired': 'Importer API type is required',
  'lumen.pibEngine.s2.afiliasiRequired': 'Owner affiliation must be selected',
  'lumen.pibEngine.s2.ndpbmRequired': 'NDPBM is required and greater than 0',
  'lumen.pibEngine.s2.hargaBarangRequired': 'Goods Price is required and greater than 0',
  'lumen.pibEngine.s2.brutoRequired': 'Gross Weight is required and greater than 0',
  'lumen.pibEngine.s2.nettoRequired': 'Net weight must be greater than 0 — enter net weight per item on the Goods tab',
  'lumen.pibEngine.s2.loadingAju': 'Loading AJU…',
  'lumen.pibEngine.s2.refreshAju': 'Refresh AJU number',
  'lumen.pibEngine.s2.saveAju': 'Save AJU',
  'lumen.pibEngine.s2.cancel': 'Batal',
  'lumen.pibEngine.s2.editAju': 'Edit AJU number',
  'lumen.pibEngine.s2.submitDraft': 'Submit Draft',
  'lumen.pibEngine.s2.ajuPlaceholder': '000000-000000-00000000-000000',
  'lumen.pibEngine.s2.refreshAjuAria': 'Refresh AJU number',
  'lumen.pibEngine.s2.cancelEditAria': 'Cancel AJU edit',
  'lumen.pibEngine.s3.ajuModalTitle': 'AJU Number - Import Declaration',
  'lumen.pibEngine.s3.nomorAjuDihasilkan': 'Generated AJU Number',
  'lumen.pibEngine.s3.berhasilDisalin': 'AJU number copied to clipboard!',
  'lumen.pibEngine.s3.nomorAjuTerbaru': 'Recent AJU Numbers',
  'lumen.pibEngine.s3.statusSelesai': 'Done',
  'lumen.pibEngine.s3.statusTerkirim': 'Sent',
  'lumen.pibEngine.s3.statusDraft': 'Draft',
  'lumen.pibEngine.s3.batal': 'Cancel',
  'lumen.pibEngine.s3.simpan': 'Save',
  'lumen.pibEngine.s3.kirimApproval': 'Send Approval',
  'lumen.pibEngine.s3.pilihEmailGroup': 'Select an email group to send the approval request to the reviewer.',
  'lumen.pibEngine.s3.buatGroupBaru': 'Create New Group',
  'lumen.pibEngine.s3.namaGroup': 'Group Name',
  'lumen.pibEngine.s3.namaGroupPlaceholder': 'Group name',
  'lumen.pibEngine.s3.deskripsiOpsional': 'Description (optional)',
  'lumen.pibEngine.s3.deskripsiGroupPlaceholder': 'Group description',
  'lumen.pibEngine.s3.pilihEmailGroupPlaceholder': 'Select email group',
  'lumen.pibEngine.s3.loading': 'Loading...',
  'lumen.pibEngine.s3.kirimSekarang': 'Send Now',
  'lumen.pibEngine.s3.jadwalkan': 'Schedule',
  'lumen.pibEngine.s3.pilihTanggalWaktu': 'Select date and time',
  'lumen.pibEngine.s3.waktuPengiriman': 'Delivery Time',
  'lumen.pibEngine.s3.selesai': 'Done',
  'lumen.pibEngine.s3.emailAkanDikirim': 'Emails to be sent',
  'lumen.pibEngine.s3.tidakAdaEmailAktif': 'No active emails in this group.',
  'lumen.pibEngine.s3.nama': 'Name',
  'lumen.pibEngine.s3.email': 'E-mail',
  'lumen.pibEngine.s3.tambah': 'Add',
  'lumen.pibEngine.s3.tambahEmail': 'Add Email',
  'lumen.pibEngine.s3.jadwalkanApproval': 'Schedule Approval',
  'lumen.pibEngine.s3.kirimApprovalBtn': 'Send Approval',
  'lumen.pibEngine.s14.basicInfoTitle': 'Basic Info',
  'lumen.pibEngine.s14.seriLabel': 'Series',
  'lumen.pibEngine.s14.seriPlaceholder': 'Series',
  'lumen.pibEngine.s14.satuanLabel': 'Unit',
  'lumen.pibEngine.s14.satuanPlaceholder': 'Unit',
  'lumen.pibEngine.s14.kodeSatuanLabel': 'Unit Code',
  'lumen.pibEngine.s14.kodeSatuanPlaceholder': 'Unit code',
  'lumen.pibEngine.s14.kemasanLabel': 'Package',
  'lumen.pibEngine.s14.kemasanPlaceholder': 'Package',
  'lumen.pibEngine.s14.kodeKemasanLabel': 'Package Code',
  'lumen.pibEngine.s14.kodeKemasanPlaceholder': 'Package Code',
  'lumen.pibEngine.s14.hsCodeLabel': 'HS Code',
  'lumen.pibEngine.s14.hsCodePlaceholder': 'HS Code',
  'lumen.pibEngine.s14.hsCodeAria': 'HS Code',
  'lumen.pibEngine.s14.viewHsCodeDetails': 'View HS Code Details',
  'lumen.pibEngine.s14.lartasBadge': 'LARTAS',
  'lumen.pibEngine.s14.pernyataanLartasLabel': 'LARTAS Declaration',
  'lumen.pibEngine.s14.ya': 'Yes',
  'lumen.pibEngine.s14.tidak': 'No',
  'lumen.pibEngine.s14.uraianLabel': 'Description',
  'lumen.pibEngine.s14.sesuaiHs': 'Match HS',
  'lumen.pibEngine.s14.uraianPlaceholder': 'Goods description',
  'lumen.pibEngine.s14.tanpaMerek': 'NO BRAND',
  'lumen.pibEngine.s14.merekLabel': 'Brand',
  'lumen.pibEngine.s14.merekPlaceholder': 'Brand',
  'lumen.pibEngine.s14.tanpaTipe': 'NO TYPE',
  'lumen.pibEngine.s14.tipeLabel': 'Type',
  'lumen.pibEngine.s14.tipePlaceholder': 'Type',
  'lumen.pibEngine.s14.ukuranLabel': 'Size',
  'lumen.pibEngine.s14.ukuranPlaceholder': '0.00',
  'lumen.pibEngine.s14.spesifikasiLainLabel': 'Other Specifications',
  'lumen.pibEngine.s14.spesifikasiLainPlaceholder': 'Other Specifications',
  'lumen.pibEngine.s14.kodeBarangLabel': 'Goods Code',
  'lumen.pibEngine.s14.kodeBarangPlaceholder': 'Goods Code',
  'lumen.pibEngine.s14.beratBersihLabel': 'Net Weight (kg)',
  'lumen.pibEngine.s14.nettoPlaceholder': '0.00',
  'lumen.pibEngine.s14.kondisiBaru': 'NEW GOODS',
  'lumen.pibEngine.s14.kondisiBukanBaru': 'NOT NEW GOODS',
  'lumen.pibEngine.s14.kondisiBarangLabel': 'Item Condition',
  'lumen.pibEngine.s14.kondisiBarangPlaceholder': 'Item Condition',
  'lumen.pibEngine.s14.volumeLabel': 'Volume (m³)',
  'lumen.pibEngine.s14.volumePlaceholder': '0.0000',
  'lumen.pibEngine.s14.negaraAsalLabel': 'Country of Origin',
  'lumen.pibEngine.s14.negaraAsalPlaceholder': 'Country of Origin',
  'lumen.pibEngine.s15.docCount': 'Document',
  'lumen.pibEngine.s15.tambah': 'Add',
  'lumen.pibEngine.s15.seri': 'Seri',
  'lumen.pibEngine.s15.jenis': 'Type',
  'lumen.pibEngine.s15.nomor': 'Number',
  'lumen.pibEngine.s15.tanggal': 'Date',
  'lumen.pibEngine.s15.fasilitas': 'Facility',
  'lumen.pibEngine.s15.izin': 'Permit',
  'lumen.pibEngine.s15.aksi': 'Action',
  'lumen.pibEngine.s15.edit': 'Edit',
  'lumen.pibEngine.s15.editAria': 'Edit',
  'lumen.pibEngine.s15.delete': 'Delete',
  'lumen.pibEngine.s15.deleteAria': 'Delete',
  'lumen.pibEngine.s15.emptyState': 'No documents yet. Click "Tambah" to add one.',
  'lumen.pibEngine.s15.attachModalTitle': 'Attach Documents to Item',
  'lumen.pibEngine.s15.attachDescription': 'Select which documents to attach to this item:',
  'lumen.pibEngine.s15.noDocsAvailable': 'No documents available. Add documents first in the Documents tab.',
  'lumen.pibEngine.s15.failSaveDocTitle': 'Failed to save item documents',
  'lumen.pibEngine.s15.failSaveDocMessage': 'Document changes not saved. Please try again.',
  'lumen.pibEngine.s8.syncDariJarvis': 'Sync from Lumen',
  'lumen.pibEngine.s8.syncPerluDiperiksa': 'Differs from last filing — get data from Lumen',
  'lumen.pibEngine.s8.pilihDataDariLumen': 'Pick Data from Lumen',
  'lumen.pibEngine.s8.dataTandaDiSalahkan': 'Data marked wrong',
  'lumen.pibEngine.s8.dataTidakAkanDitampilkan': 'This data will no longer appear in future searches.',
  'lumen.pibEngine.s8.gagalMenandaiData': 'Failed to mark data',
  'lumen.pibEngine.s8.terjadiKesalahan': 'An error occurred while updating data.',
  'lumen.pibEngine.s8.tandaiDataSalah': 'Mark Data as Wrong',
  'lumen.pibEngine.s8.yaTandaiSalah': 'Yes, Mark Wrong',
  'lumen.pibEngine.s8.tidak': 'No',
  'lumen.pibEngine.s8.batal': 'Cancel',
  'lumen.pibEngine.s8.apply': 'Apply',
  'lumen.pibEngine.s8.tidakAdaDataUntukDipilih': 'No data to select.',
  'lumen.pibEngine.s8.bukaConsignee': 'Open Consignee Data',
  'lumen.pibEngine.s8.riwayatDokumenCount': 'Document history ({count})',
  'lumen.pibEngine.s8.diperbaruiTanggal': 'Updated {date}',
  'lumen.pibEngine.s8.bukaDiConsignee': 'Open in Consignee Data',
  'lumen.pibEngine.s8.riwayatTidakDapatDimuat': 'Document history could not be loaded',
  'lumen.pibEngine.s8.tandaiSebagaiSalah':
    'Mark “{name}” as wrong data? This data will be hidden from future searches.',
  'lumen.pibEngine.s8.dataMasterTidakBisaDitandai':
    'Consignee data is managed in the Master menu, not marked wrong here.',
  'lumen.pibEngine.s16.amountCif': 'Amount (CIF)',
  'lumen.pibEngine.s16.typeHere': 'Type here…',
  'lumen.pibEngine.s16.fob': 'FOB',
  'lumen.pibEngine.s16.hargaSatuan': 'Unit Price',
  'lumen.pibEngine.s16.biayaTambahanDiskon': 'Additional Cost - Discount',
  'lumen.pibEngine.s16.freight': 'Freight',
  'lumen.pibEngine.s16.biayaAsuransi': 'Insurance Cost',
  'lumen.pibEngine.s16.cifRupiah': 'CIF - Rupiah (Calculated)',
  'lumen.pibEngine.s16.freeOfChargeItem': 'Free of Charge Item',
  'lumen.pibEngine.s16.metodePenentuanNilai': 'Customs Value Determination Method',
  'lumen.pibEngine.s16.pilihMetode': 'Select Method',
  'lumen.pibEngine.s16.alasan': 'Reason',
  'lumen.pibEngine.s16.pilihAlasan': 'Select Reason',
  'lumen.pibEngine.s16.statementPerbedaanHarga': 'Price Difference Statement',
  'lumen.pibEngine.s16.ada': 'Yes',
  'lumen.pibEngine.s16.tidakAda': 'No',
  'lumen.pibEngine.s16.transaksiCount': 'Transactions: {count}',
  'lumen.pibEngine.s16.tambah': 'Add',
  'lumen.pibEngine.s16.aksi': 'Action',
  'lumen.pibEngine.s16.jenisTransaksi': 'Transaction Type',
  'lumen.pibEngine.s16.nilaiVD': 'Voluntary Declaration Value',
  'lumen.pibEngine.s16.belumAdaTransaksi': 'No transaction type added',
  'lumen.pibEngine.s16.tambahJenisTransaksi': 'Add Transaction Type',
  'lumen.pibEngine.s16.ubahJenisTransaksi': 'Edit Transaction Type',
  'lumen.pibEngine.s16.jenisNilai': 'Transaction Type',
  'lumen.pibEngine.s16.pilihJenisNilai': 'Select Transaction Type',
  'lumen.pibEngine.s16.voluntaryDeclaration': 'Voluntary Declaration',
  'lumen.pibEngine.s16.wajibDiisi': 'Mandatory for this transaction type',
  'lumen.pibEngine.s16.opsional': 'Optional for this transaction type',
  'lumen.pibEngine.s16.batal': 'Cancel',
  'lumen.pibEngine.s16.simpan': 'Save',
  'lumen.pibEngine.s16.errorPilihJenisTransaksi': 'A transaction type must be selected',
  'lumen.pibEngine.s16.errorVoluntaryDeclaration': 'Voluntary Declaration is required for this transaction type',
  'lumen.pibEngine.s16.errorDuplicate': 'Transaction type already exists in the list',
  'lumen.pibEngine.s16.edit': 'Edit',
  'lumen.pibEngine.s16.hapus': 'Delete',
  'lumen.pibEngine.s16.editAriaLabel': 'Edit transaction type',
  'lumen.pibEngine.s16.hapusAriaLabel': 'Delete transaction type',
  'lumen.pibEngine.s4.titleTransfer': 'Transfer summary to CEISA',
  'lumen.pibEngine.s4.titleSubmit': 'Submit draft summary',
  'lumen.pibEngine.s4.hargaMismatchTitle': 'Total price mismatch',
  'lumen.pibEngine.s4.barangTab': 'Barang tab ({n} series)',
  'lumen.pibEngine.s4.transaksiTab': 'Transaction tab',
  'lumen.pibEngine.s4.selisih': 'Difference',
  'lumen.pibEngine.s4.hargaMismatchMessage':
    'Check the Barang Price in the Transaction tab and the per-item value in the Barang tab first.',
  'lumen.pibEngine.s4.hargaAck': 'I have checked the difference and still want to submit',
  'lumen.pibEngine.s4.duplicateTitle': 'Items attached to two similar documents',
  'lumen.pibEngine.s4.duplicateMessage':
    'An item can only carry one document per code. CEISA will reject this submission. Open the Document tab, then remove the items below from one of their documents.',
  'lumen.pibEngine.s4.duplicateAck': 'I have checked and still want to submit',
  'lumen.pibEngine.s4.kantorPelTitle': 'Office & Port',
  'lumen.pibEngine.s4.kantor': 'Office',
  'lumen.pibEngine.s4.pelTujuan': 'Destination Port',
  'lumen.pibEngine.s4.importirTitle': 'Importer',
  'lumen.pibEngine.s4.nama': 'Name',
  'lumen.pibEngine.s4.npwp': 'NPWP',
  'lumen.pibEngine.s4.apiNib': 'API / NIB',
  'lumen.pibEngine.s4.alamat': 'Address',
  'lumen.pibEngine.s4.pengirimTitle': 'Sender',
  'lumen.pibEngine.s4.penjualTitle': 'Seller',
  'lumen.pibEngine.s4.negara': 'Country',
  'lumen.pibEngine.s4.pengangkutTitle': 'Carrier',
  'lumen.pibEngine.s4.sarana': 'Vehicle/Vessel',
  'lumen.pibEngine.s4.voyFlight': 'Voyage/Flight',
  'lumen.pibEngine.s4.bendera': 'Flag',
  'lumen.pibEngine.s4.pelMuat': 'Loading Port',
  'lumen.pibEngine.s4.kemasanLabel': 'Packaging',
  'lumen.pibEngine.s4.kontainerLabel': 'Container',
  'lumen.pibEngine.s4.dokumenLabel': 'Document',
  'lumen.pibEngine.s4.barangLabel': 'Item',
  'lumen.pibEngine.s4.unit': 'unit',
  'lumen.pibEngine.s4.dokumenUnit': 'document',
  'lumen.pibEngine.s4.seri': 'series',
  'lumen.pibEngine.s4.transaksiTitle': 'Transaction',
  'lumen.pibEngine.s4.jenisTransaksi': 'Transaction Type',
  'lumen.pibEngine.s4.incoterm': 'Incoterm',
  'lumen.pibEngine.s4.totalCif': 'Total CIF',
  'lumen.pibEngine.s4.valuta': 'Currency',
  'lumen.pibEngine.s4.ndpbm': 'NDPBM',
  'lumen.pibEngine.s4.beratKotor': 'Gross Weight',
  'lumen.pibEngine.s4.beratBersih': 'Net Weight',
  'lumen.pibEngine.s4.lartasTitle': 'Restriction & Prohibition',
  'lumen.pibEngine.s4.lartasY': 'Yes (Y)',
  'lumen.pibEngine.s4.lartasT': 'No (T)',
  'lumen.pibEngine.s4.lartasN': 'None (N)',
  'lumen.pibEngine.s4.loadingBarang': 'Loading item data…',
  'lumen.pibEngine.s4.back': 'Back',
  'lumen.pibEngine.s4.transferConfirm': 'Yes, Transfer to CEISA',
  'lumen.pibEngine.s4.submitConfirm': 'Submit to CEISA',
  'lumen.pibEngine.s4.tooltipDuplicate': 'Fix items attached to two similar documents first',
  'lumen.pibEngine.s4.tooltipHarga': 'Check the price difference confirmation above first',
  'lumen.pibEngine.s4.editAria': 'Edit {n} item(s)',
  'lumen.pibEngine.s5.errorWorker': 'PDF worker communication failed. Please refresh the page and try again.',
  'lumen.pibEngine.s5.errorNetwork': 'Unable to load PDF due to network restrictions. Please contact support.',
  'lumen.pibEngine.s5.errorLoad': 'Failed to load PDF. Please try again later.',
  'lumen.pibEngine.s5.labelInvoice': 'Invoice',
  'lumen.pibEngine.s5.labelPackingList': 'Packing List',
  'lumen.pibEngine.s5.labelBillOfLading': 'Bill of Lading',
  'lumen.pibEngine.s5.labelAirWaybill': 'Air Waybill',
  'lumen.pibEngine.s5.labelCertOrigin': 'Certificate of Origin',
  'lumen.pibEngine.s5.labelImportCert': 'Import Certificate',
  'lumen.pibEngine.s5.excelPreviewNotAvailable': 'Excel File Preview Not Available',
  'lumen.pibEngine.s5.excelCannotDisplay': 'Excel files (.xlsx, .xls, .csv) cannot be displayed in the PDF viewer.',
  'lumen.pibEngine.s5.downloadExcel': 'Download Excel File',
  'lumen.pibEngine.s5.fallingBackIframe': 'Falling back to iframe viewer...',
  'lumen.pibEngine.s5.loadingPdf': 'Loading PDF...',
  'lumen.pibEngine.s5.loadingPage': 'Loading page {page}...',
  'lumen.pibEngine.s5.pageIndicator': 'Page {page} of {total}',
  'lumen.pibEngine.s5.zoomOutAria': 'Zoom out',
  'lumen.pibEngine.s5.zoomOutTitle': 'Zoom Out (Ctrl + -)',
  'lumen.pibEngine.s5.zoomInAria': 'Zoom in',
  'lumen.pibEngine.s5.zoomInTitle': 'Zoom In (Ctrl + +)',
  'lumen.pibEngine.s5.resetZoomAria': 'Reset zoom',
  'lumen.pibEngine.s5.resetZoomTitle': 'Reset Zoom (Ctrl + 0)',
  'lumen.pibEngine.s5.zoomLevelTitle': 'Zoom level (Ctrl +/- to zoom, Ctrl 0 to reset)',
  'lumen.pibEngine.s5.prevPdfAria': 'Previous PDF',
  'lumen.pibEngine.s5.prevPdfTitle': 'Previous PDF',
  'lumen.pibEngine.s5.nextPdfAria': 'Next PDF',
  'lumen.pibEngine.s5.nextPdfTitle': 'Next PDF',
  'lumen.pibEngine.s5.downloadPdfAria': 'Download PDF',
  'lumen.pibEngine.s5.downloadPdfTitle': 'Download PDF',
  'lumen.pibEngine.s5.hidePdfAria': 'Hide PDF',
  'lumen.pibEngine.s5.hidePdfTitle': 'Hide PDF',
  'lumen.pibEngine.s17.beaMasuk': 'Additions (Import Duty)',
  'lumen.pibEngine.s17.ppn': 'VAT',
  'lumen.pibEngine.s17.pph': 'INCOME TAX',
  'lumen.pibEngine.s17.kodeJenis': 'Type Code',
  'lumen.pibEngine.s17.tarif': 'Rate (%)',
  'lumen.pibEngine.s17.tarifPlaceholder': 'Rate',
  'lumen.pibEngine.s17.ppnPlaceholder': 'Rate',
  'lumen.pibEngine.s17.pphPlaceholder': 'Rate',
  'lumen.pibEngine.s17.jenisTarif': 'Rate Type',
  'lumen.pibEngine.s17.fasilitas': 'Facility',
  'lumen.pibEngine.s17.pilih': 'Select',
  'lumen.pibEngine.s17.advalorum': 'Ad Valorem',
  'lumen.pibEngine.s17.spesifik': 'Specific',
  'lumen.pibEngine.s17.tambahBiaya': 'Add Charge',
  'lumen.pibEngine.s17.biayaTambahan': 'Additional Charge',
  'lumen.pibEngine.s17.hapus': 'Delete',
  'lumen.pibEngine.s17.kategoriSpesifikasi': 'Specification Category',
  'lumen.pibEngine.s17.otomotif': 'Automotive',
  'lumen.pibEngine.s17.others': 'Other',
  'lumen.pibEngine.s17.cbuLabel': 'CBU',
  'lumen.pibEngine.s17.pilihCbu': 'Select CBU',
  'lumen.pibEngine.s17.noncbu': 'NON CBU',
  'lumen.pibEngine.s17.cbu': 'CBU',
  'lumen.pibEngine.s17.jenisKendaraan': 'VEHICLE TYPE',
  'lumen.pibEngine.s17.jenisKendaraanPlaceholder': 'Vehicle Type',
  'lumen.pibEngine.s17.merk': 'MARK',
  'lumen.pibEngine.s17.merkPlaceholder': 'Brand',
  'lumen.pibEngine.s17.tipe': 'MODEL',
  'lumen.pibEngine.s17.tipePlaceholder': 'Model',
  'lumen.pibEngine.s17.tahunPembuatan': 'MANUFACTURING YEAR',
  'lumen.pibEngine.s17.tahunPembuatanPlaceholder': 'Manufacturing Year',
  'lumen.pibEngine.s17.nomorRangka': 'CHASSIS NUMBER',
  'lumen.pibEngine.s17.nomorRangkaPlaceholder': 'Chassis Number',
  'lumen.pibEngine.s17.nomorMesin': 'ENGINE NUMBER',
  'lumen.pibEngine.s17.nomorMesinPlaceholder': 'Engine Number',
  'lumen.pibEngine.s17.silinder': 'Cylinder',
  'lumen.pibEngine.s17.silinderPlaceholder': 'Cylinder',
  'lumen.pibEngine.s17.daya': 'Power',
  'lumen.pibEngine.s17.dayaPlaceholder': 'Power',
  'lumen.pibEngine.s17.modelLabel': 'MODEL',
  'lumen.pibEngine.s17.modelPlaceholder': 'Model',
  'lumen.pibEngine.s17.nomorCasiLabel': 'NOMOR CASI',
  'lumen.pibEngine.s17.nomorCasiPlaceholder': 'NOMOR CASI Empty',
  'lumen.pibEngine.s17.mutuLabel': 'QUALITY',
  'lumen.pibEngine.s17.pilihMutu': 'Select Quality',
  'lumen.pibEngine.s17.mutuPangan': 'FOOD GRADE',
  'lumen.pibEngine.s17.mutuFarmasi': 'PHARMACEUTICAL GRADE',
  'lumen.pibEngine.s17.mutuPakanTernak': 'ANIMAL FEED GRADE',
  'lumen.pibEngine.s17.mutuLainnya': 'OTHER GRADE',
  'lumen.pibEngine.s9.verified': 'Verified',
  'lumen.pibEngine.s9.check': 'Check',
  'lumen.pibEngine.s9.review': 'Review',
  'lumen.pibEngine.s9.clickReviewSource': 'Click to review against source',
  'lumen.pibEngine.s9.autoVerified': 'Auto-verified from source',
  'lumen.pibEngine.s9.needsManualReview': 'Needs manual review',
  'lumen.pibEngine.s9.suggestVerify': 'Suggest verifying this value',
  'lumen.pibEngine.s6.kalibrasiTitle': 'Kalibrasi Draft PIB (Internal)',
  'lumen.pibEngine.s6.checklistTitle': 'Checklist: Draft PDF vs Final PDF',
  'lumen.pibEngine.s6.loadingData': 'Fetching comparison data for {nomorAju}...',
  'lumen.pibEngine.s6.failedTitle': 'Failed to fetch data',
  'lumen.pibEngine.s6.nomorAjuLabel': 'Nomor Aju',
  'lumen.pibEngine.s6.statusLabel': 'Status:',
  'lumen.pibEngine.s6.printSave': 'Print / Save as PDF',
  'lumen.pibEngine.s6.totalFields': 'Total Fields',
  'lumen.pibEngine.s6.matches': 'Matches',
  'lumen.pibEngine.s6.mismatches': 'Mismatches',
  'lumen.pibEngine.s6.missingInDraft': 'Missing in Draft',
  'lumen.pibEngine.s6.missingInFinal': 'Missing in Final',
  'lumen.pibEngine.s6.goodsAdded': 'Goods Added',
  'lumen.pibEngine.s6.goodsRemoved': 'Goods Removed',
  'lumen.pibEngine.s6.goodsModified': 'Goods Modified',
  'lumen.pibEngine.s6.goodsUnchanged': 'Goods Unchanged',
  'lumen.pibEngine.s6.draftPdf': 'DRAFT PDF',
  'lumen.pibEngine.s6.finalPdf': 'FINAL PDF',
  'lumen.pibEngine.s6.pages': 'pages',
  'lumen.pibEngine.s6.localTab': 'Lokal vs CEISA',
  'lumen.pibEngine.s6.headerTab': 'Header Fields',
  'lumen.pibEngine.s6.goodsTab': 'Goods',
  'lumen.pibEngine.s6.localAlert':
    'Internal calibration: local PIB draft values (from form) are compared with the PIB draft issued by CEISA for this AJU. Mismatches indicate that the template or local value mapping needs to be aligned.',
  'lumen.pibEngine.s6.emptyInLocal': 'Kosong di Lokal',
  'lumen.pibEngine.s6.emptyInCeisa': 'Kosong di CEISA',
  'lumen.pibEngine.s6.field': 'Field',
  'lumen.pibEngine.s6.draftLokal': 'Draft Lokal',
  'lumen.pibEngine.s6.draftCeisa': 'Draft CEISA',
  'lumen.pibEngine.s6.status': 'Status',
  'lumen.pibEngine.s6.draftValue': 'Draft Value',
  'lumen.pibEngine.s6.finalValue': 'Final Value',
  'lumen.pibEngine.s6.noHeader': 'Tidak ada data header',
  'lumen.pibEngine.s6.noGoods': 'Tidak ada data barang.',
  'lumen.pibEngine.s6.addedText': 'Added: ',
  'lumen.pibEngine.s6.removedText': 'Removed: ',
  'lumen.pibEngine.s6.modifiedText': 'Modified: ',
  'lumen.pibEngine.s6.unchangedText': 'Unchanged: ',
  'lumen.pibEngine.s6.barang': 'barang',
  'lumen.pibEngine.s6.comparisonFailed': 'Comparison failed',
  'lumen.pibEngine.s6.unknownError': 'Unknown error',
  'lumen.pibEngine.p2.loadingValidation': 'Loading and validating form data',
  'lumen.pibEngine.p3.initErrorTitle': 'Error',
  'lumen.pibEngine.p3.initErrorMessage': 'Failed to initialize form',
  'lumen.pibEngine.p3.npwpErrorTitle': 'Entity validation failed',
  'lumen.pibEngine.p3.npwpErrorMessage': 'NPWP PPJK is invalid. Please fill in the NPWP PPJK first.',
  'lumen.pibEngine.p3.processIdNotFoundTitle': 'Error',
  'lumen.pibEngine.p3.processIdNotFoundMessage': 'Process ID not found',
  'lumen.pibEngine.p3.downloadSuccessTitle': 'Success',
  'lumen.pibEngine.p3.downloadSuccessMessage': 'Download success!',
  'lumen.pibEngine.p3.downloadFailedTitle': 'Error',
  'lumen.pibEngine.p3.downloadFailedMessage': 'Download failed!',
  'lumen.pibEngine.p3.downloadBarangSuccessTitle': 'Success',
  'lumen.pibEngine.p3.downloadBarangSuccessMessage': 'Barang Excel download successful!',
  'lumen.pibEngine.p3.downloadBarangFailedTitle': 'Error',
  'lumen.pibEngine.p3.downloadBarangFailedMessage': 'Barang Excel download failed!',
  'lumen.pibEngine.p3.uploadBarangSuccessTitle': 'Success',
  'lumen.pibEngine.p3.uploadBarangSuccessMessage': 'Barang Excel upload successful! Refreshing...',
  'lumen.pibEngine.p3.uploadBarangFailedTitle': 'Error',
  'lumen.pibEngine.p3.uploadBarangFailedMessage': 'Barang Excel upload failed!',
  'lumen.pibEngine.p3.uploadSuccessTitle': 'Success',
  'lumen.pibEngine.p3.uploadSuccessMessage': 'Upload successful! Refreshing form data...',
  'lumen.pibEngine.p3.uploadFailedTitle': 'Error',
  'lumen.pibEngine.p3.uploadFailedMessage': 'Upload failed!',
  'lumen.pibEngine.p3.ajuCancelledMsg': '❌ AJU cancelled by cancel button',
  'lumen.pibEngine.p4.noAjuTitle': 'Error',
  'lumen.pibEngine.p4.noAjuMessage': 'Nomor AJU is not yet available. Please submit the DRAFT to CEISA first.',
  'lumen.pibEngine.p4.noProcessIdTitle': 'Error',
  'lumen.pibEngine.p4.noProcessIdMessage': 'Process ID is not available to calculate excise',
  'lumen.pibEngine.p4.noDataPungutanTitle': 'Info',
  'lumen.pibEngine.p4.noDataPungutanMessage': 'No excise data',
  'lumen.pibEngine.p4.gagalTitle': 'Gagal',
  'lumen.pibEngine.p4.syncDoneTitle': 'Success',
  'lumen.pibEngine.p4.syncDefaultMessage': 'HS tariff synchronization complete',
  'lumen.pibEngine.p4.canNotTransferTitle': 'Belum bisa Transfer',
  'lumen.pibEngine.p4.validationFailedTitle': 'Validasi Failed',
  'lumen.pibEngine.p4.validationFailedMessage': 'There are {n} error messages. Fix them before transferring.',
  'lumen.pibEngine.p4.transferSuccessTitle': 'Transfer Successful',
  'lumen.pibEngine.p4.transferSuccessMessage': 'Document successfully transferred to CEISA',
  'lumen.pibEngine.p4.transferFailedTitle': 'Transfer Failed',
  'lumen.pibEngine.p4.noDataStatusTitle': 'Info',
  'lumen.pibEngine.p4.noDataStatusMessage': 'No status data',
  'lumen.pibEngine.p4.noFormDataTitle': 'Error',
  'lumen.pibEngine.p4.noFormDataMessage': 'Form data is not available',
  'lumen.pibEngine.p4.gateSuccessTitle': 'Berhasil',
  'lumen.pibEngine.p4.successMessage': 'Berhasil',
  'lumen.pibEngine.p4.gagalGeneratePungutanMessage': 'Failed to generate excise',
  'lumen.pibEngine.p4.gagalSinkronisasiHsMessage': 'Failed to sync HS tariff',
  'lumen.pibEngine.p4.gagalMengambilStatusMessage': 'Failed to fetch status',
  'lumen.pibEngine.p4.gagalCetakFormulirMessage': 'Failed to print form',
  'lumen.pibEngine.p4.gagalShort': 'Gagal',
  'lumen.pibEngine.p5.gateAjuTitle': 'Error',
  'lumen.pibEngine.p5.gateAjuMsg': 'AJU number not available',
  'lumen.pibEngine.p5.nomorPolisiMsg': 'License plate number is required',
  'lumen.pibEngine.p5.gateKontainerMsg': 'Container number is required',
  'lumen.pibEngine.p5.gateSuccessTitle': 'Success',
  'lumen.pibEngine.p5.gateSuccessMsg': 'Success',
  'lumen.pibEngine.p5.gateFailTitle': 'Failed',
  'lumen.pibEngine.p5.gateFailMsg': 'Failed',
  'lumen.pibEngine.p5.submitBlockedTitle': 'Cannot submit yet',
  'lumen.pibEngine.p5.validationTitle': 'Validation error',
  'lumen.pibEngine.p5.validationMsg': 'Net weight must not exceed gross weight',
  'lumen.pibEngine.p5.entitySaveFailTitle': 'Failed to save Entity',
  'lumen.pibEngine.p5.entitySaveFailMsg': 'Sync result data not saved. CEISA submission cancelled.',
  'lumen.pibEngine.p5.draftSuccessTitle': 'Success',
  'lumen.pibEngine.p5.draftSuccessMsg': 'Draft successfully updated in CEISA',
  'lumen.pibEngine.p5.draftFailTitle': 'Error',
  'lumen.pibEngine.p5.draftFailMsg': 'Failed to update draft to CEISA',
  'lumen.pibEngine.p5.loadingTitle': 'Loading document data',
  'lumen.pibEngine.p5.loadingDesc': 'This may take a moment as we process your document.',
  'lumen.pibEngine.p6.loadingTitle': 'Loading document data',
  'lumen.pibEngine.p6.loadingSub': 'This may take a moment as we process your document.',
  'lumen.pibEngine.p6.back': 'Back',
  'lumen.pibEngine.p6.auditLogs': 'Audit Logs',
  'lumen.pibEngine.p6.excelFull': 'Excel (Full)',
  'lumen.pibEngine.p6.downloadExcelFull': 'Download Excel (Full)',
  'lumen.pibEngine.p6.uploadExcelFull': 'Upload Excel (Full)',
  'lumen.pibEngine.p6.excelBarang': 'Excel (Barang Only)',
  'lumen.pibEngine.p6.downloadExcelBarang': 'Download Excel (Barang Only)',
  'lumen.pibEngine.p6.uploadExcelBarang': 'Upload Excel (Barang Only)',
  'lumen.pibEngine.p6.historical': 'Historical',
  'lumen.pibEngine.p6.syncHistorical': 'Sync with Historical Data',
  'lumen.pibEngine.p6.draftPib': 'Draft PIB',
  'lumen.pibEngine.p6.aksi': 'Actions',
  'lumen.pibEngine.p6.generatePungutan': 'Generate Pungutan',
  'lumen.pibEngine.p6.validasi': 'Validate',
  'lumen.pibEngine.p6.approval': 'Approval',
  'lumen.pibEngine.p6.kirimApproval': 'Send for approval',
  'lumen.pibEngine.p6.cetak': 'Print',
  'lumen.pibEngine.p6.cetakFormulirDraft': 'Print CEISA draft form',
  'lumen.pibEngine.p6.draftPibPreview': 'Draft PIB (local preview)',
  'lumen.pibEngine.p6.internal': 'Internal',
  'lumen.pibEngine.p6.kalibrasi': 'Calibrate Draft PIB (internal)',
  'lumen.pibEngine.p6.ceisaPortal': 'CEISA Portal',
  'lumen.pibEngine.p6.lihatCeisa': 'View in CEISA',
  'lumen.pibEngine.p6.submit': 'Submit',
  'lumen.pibEngine.p6.transferBilling': 'Transfer (Billing)',
  'lumen.pibEngine.p6.revisi': 'Revise',
  'lumen.pibEngine.p6.revisionChecklist': 'Revision Checklist',
  'lumen.pibEngine.p6.completed': 'completed',
  'lumen.pibEngine.p6.selesaikanChecklist': 'Complete every checklist item before submitting',
  'lumen.pibEngine.p6.sebelumnya': 'Previous',
  'lumen.pibEngine.p6.lihatPdf': 'View PDF',
  'lumen.pibEngine.p6.tutupPdf': 'Close PDF',
  'lumen.pibEngine.p6.editItem': 'Edit Item',
  'lumen.pibEngine.p6.selanjutnya': 'Next',
  'lumen.pibEngine.p6.perhatianProporsional': 'Attention: proportional charges detected',
  'lumen.pibEngine.p6.lumenMendeteksi': 'Lumen detected',
  'lumen.pibEngine.p6.biayaPenambah': 'additional charges',
  'lumen.pibEngine.p6.biayaPengurang': 'deductions',
  'lumen.pibEngine.p6.harapLakukan': 'Please do the following in CEISA first:',
  'lumen.pibEngine.p6.setelahDua': 'Once both steps are done, you can run',
  'lumen.pibEngine.p6.melewatiLumen': 'in Lumen.',
  'lumen.pibEngine.p6.sayaMengerti': 'I understand',
  'lumen.pibEngine.p6b.freight': 'Freight',
  'lumen.pibEngine.p6b.atau': 'or',
  'lumen.pibEngine.p6b.asuransi': 'Insurance',
  'lumen.pibEngine.p6b.padaDokumenIni': 'on this document.',
  'lumen.pibEngine.p6b.klik': 'Click',
  'lumen.pibEngine.p6b.hitungProporsionalAsuransi': 'Hitung Proporsional Asuransi dan Freight',
  'lumen.pibEngine.p6b.hitungProporsionalBiaya': 'Hitung Proporsional Biaya Penambah dan Pengurang',
  'lumen.pibEngine.p6b.dan': 'and',
  'lumen.pibEngine.p6b.generatePungutan': 'Generate Pungutan',
  'lumen.pibEngine.p6b.cetakDraftPib': 'Cetak Draft PIB',
  'lumen.pibEngine.p7.kemasanGateIn': 'Kemasan Gate In',
  'lumen.pibEngine.p7.kemasanGateOut': 'Kemasan Gate Out',
  'lumen.pibEngine.p7.kontainerGateIn': 'Container Gate In',
  'lumen.pibEngine.p7.nomorPolisiLabel': 'Nomor Polisi',
  'lumen.pibEngine.p7.nomorPolisiPlaceholder': 'Example: B 1234 ABC',
  'lumen.pibEngine.p7.nomorSegelLabel': 'Seal Number',
  'lumen.pibEngine.p7.nomorSegelPlaceholder': 'Seal number',
  'lumen.pibEngine.p7.nomorKontainerLabel': 'Container Number *',
  'lumen.pibEngine.p7.nomorKontainerPlaceholder': 'Example: ABCU1234567',
  'lumen.pibEngine.p7.waktuGateLabel': 'Gate Time *',
  'lumen.pibEngine.p7.kirim': 'Send',
  'lumen.pibEngine.p7.konfirmasiTitle': 'Confirmation',
  'lumen.pibEngine.p7.transferBilling': 'Transfer (Billing)',
  'lumen.pibEngine.p7.revisi': 'Revision',
  'lumen.pibEngine.p7.transferWarning':
    'You will perform a Transfer (Billing). The document will be finally submitted to CEISA to obtain billing. Ensure all data is correct.',
  'lumen.pibEngine.p7.revisiWarning':
    'You will revise the document. Previously submitted data will be updated in CEISA.',
  'lumen.pibEngine.p7.batal': 'Cancel',
  'lumen.pibEngine.p7.lanjutkan': 'Yes, Continue',
  'lumen.pibEngine.p7.konfirmasiTransfer': 'Transfer Confirmation',
  'lumen.pibEngine.p7.konfirmasiTransferDesc':
    'The document will be finally sent to CEISA. Make sure all data is correct before continuing.',
  'lumen.pibEngine.p7.yaTransfer': 'Yes, Transfer to CEISA',
  'lumen.pibEngine.p7.dokumenBelumLengkap': 'Required Documents Not Yet Complete',
  'lumen.pibEngine.p7.submitKombinasi': 'Submit to CEISA requires at minimum the combination:',
  'lumen.pibEngine.p7.invoiceBl': 'INVOICE + BL (or AWB)',
  'lumen.pibEngine.p7.belumTersedia': 'Not yet available',
  'lumen.pibEngine.p7.tambahkanDokumen': 'Add the missing documents on the Documents tab, then try submitting again.',
  'lumen.pibEngine.p7.mengerti': 'Understood',
  'lumen.pibEngine.p7.dokumenBermasalah': 'Problematic Documents',
  'lumen.pibEngine.p7.submitDedup':
    'Submit cancelled because the document list will be deduped by the backend (based on type + document number). Fix it first on the Documents tab.',
  'lumen.pibEngine.p7.barisKosong': 'Empty rows (Serial)',
  'lumen.pibEngine.p7.lengkapiJenisNomor': 'Complete the Document Type and Number, or delete the row.',
  'lumen.pibEngine.p7.duplikat': 'Duplicate (Type · Number)',
  'lumen.pibEngine.p7.hapusBarisKembar': 'Delete the duplicate row or change one of its numbers.',
  'lumen.pibEngine.p7.statusCEISA': 'CEISA Status',
  'lumen.pibEngine.p7.kode': 'Code',
  'lumen.pibEngine.p7.waktu': 'Time',
  'lumen.pibEngine.p7.nomorDaftar': 'Registration No.',
  'lumen.pibEngine.p7.responCEISA': 'CEISA Response',
  'lumen.pibEngine.p7.pesan': 'Message(s)',
  'lumen.pibEngine.p7.tutup': 'Close',
  'lumen.pibEngine.p7.hasilPungutan': 'Pungutan Generation Result',
  'lumen.pibEngine.p7.totalPungutan': 'Total Pungutan',
  'lumen.pibEngine.p7.submittingCEISA': 'Submitting to CEISA',
  'lumen.pibEngine.p7.processingDocument': 'Processing your document...',
  'lumen.pibEngine.p7.progress': 'Progress',
  'lumen.pibEngine.p7.submissionComplete': 'Submission Complete',
  'lumen.pibEngine.p7.submittedSuccessfully': 'Document submitted to CEISA successfully',
  'lumen.pibEngine.p7.submissionFailed': 'Submission Failed',
  'lumen.pibEngine.p7.close': 'Close',
  'lumen.pibEngine.s10.lihatDatabase': 'See database',
  'lumen.pibEngine.s10.loadingItems': 'Memuat...',
  'lumen.pibEngine.s10.searchPlaceholder': 'Search by description, HS code, brand... (press Enter to search)',
  'lumen.pibEngine.s10.originLabel': 'Origin: {name} ({code})',
  'lumen.pibEngine.s10.ajuLabel': 'Aju: {ajuNo}',
  'lumen.pibEngine.tr1.successTitle': 'Success',
  'lumen.pibEngine.s21.welcome': "Hi! I'm your AI assistant 👋",
  'lumen.pibEngine.s21.welcomeHint': 'Select a context above and ask me anything!',
  'lumen.pibEngine.s21.placeholder': 'Type a message...',
  'lumen.pibEngine.s21.thinking': 'AI is thinking...',
  'lumen.pibEngine.s21.pChecking': '🔍 Checking all tabs... Please wait a moment...',
  'lumen.pibEngine.s21.pVerified': 'Full Verification of All Tabs',
  'lumen.pibEngine.s21.pStatus': 'Check Status vs PDF',
  'lumen.pibEngine.s21.pResult': 'Result: 9/9 tabs verified ✅',
  'lumen.pibEngine.s21.pMatch': 'All data matches the PDF',
  'lumen.pibEngine.s21.aiAssistant': 'AI Assistant',
  'lumen.pibEngine.s21.online': 'Online',
  'lumen.pibEngine.s21.error': "Sorry, I'm having trouble responding right now. Please try again later.",
  'lumen.pibEngine.s21.contextLabel': '📍 {label}',
  'lumen.pibEngine.s11.tambahKemasan': 'Add packaging',
  'lumen.pibEngine.s11.tambahPetiKemas': 'Add container',
  'lumen.pibEngine.s11.seri': 'Serial',
  'lumen.pibEngine.s11.jumlah': 'Quantity',
  'lumen.pibEngine.s11.jenis': 'Type',
  'lumen.pibEngine.s11.merek': 'Brand',
  'lumen.pibEngine.s11.merk': 'Brand',
  'lumen.pibEngine.s11.nomor': 'Number',
  'lumen.pibEngine.s11.ukuran': 'Size',
  'lumen.pibEngine.s11.tipe': 'Type',
  'lumen.pibEngine.kb1.modalTitle': 'Informasi Komponen Biaya',
  'lumen.pibEngine.kb1.keterangan': 'Description',
  'lumen.pibEngine.kb1.nilaiPasti': 'Fixed Value',
  'lumen.pibEngine.kb1.nilaiPerkiraan': 'Estimated Value (VD)',
  'lumen.pibEngine.kb1.hanyaSebenarnya': 'The actual or should-be price',
  'lumen.pibEngine.kb1.hargaInvoice': '1. Price stated in the Invoice',
  'lumen.pibEngine.kb1.pembayaranTdkLangsung':
    '2. Indirect payment (e.g. reduction of buyer/importer receivables, credit notes, etc.)',
  'lumen.pibEngine.kb1.jumlahHarga': 'A. Total of the actual or should-be price (1+2)',
  'lumen.pibEngine.kb1.biayaPengurang': 'B. Deduction costs (discount) {highlight} in the invoice',
  'lumen.pibEngine.kb1.jumlahA_DikurangiB': 'C. Total A minus B',
  'lumen.pibEngine.kb1.penambahBelumTermasuk': 'Additional costs {highlight} in the invoice price',
  'lumen.pibEngine.kb1.komisiPenjualan': '1. Sales commission and intermediary services',
  'lumen.pibEngine.kb1.biayaPengemasan': '2. Packaging costs',
  'lumen.pibEngine.kb1.biayaPengepakan': '3. Packing costs',
  'lumen.pibEngine.kb1.nilaiBantuan': '4. Assistance value',
  'lumen.pibEngine.kb1.assistDesc':
    '"Assistance value is the value of goods and services provided directly or indirectly by the buyer free or at reduced cost, for use in the production or sale of imported goods."',
  'lumen.pibEngine.kb1.royalti': '5. Royalties and license fees',
  'lumen.pibEngine.kb1.royaltiDesc':
    'Royalties are payments for copyrights, patents and similar rights, while licenses are payments for the right to use a technology or brand.',
  'lumen.pibEngine.kb1.proceeds': '6. Proceeds',
  'lumen.pibEngine.kb1.proceedsDesc':
    'Proceeds are the share of proceeds from the resale, release or use of imported goods that must be deposited to the seller.',
  'lumen.pibEngine.kb1.biayaTransport': '7. Transportation / Freight costs',
  'lumen.pibEngine.kb1.transportDesc':
    'Transportation / freight costs are the costs of transporting goods from the loading port to the discharge port not yet included in the invoice price.',
  'lumen.pibEngine.kb1.biayaPemuatan':
    '8. Loading, unloading and handling costs not yet included in transportation costs',
  'lumen.pibEngine.kb1.asuransi': '9. Insurance',
  'lumen.pibEngine.kb1.asuransiDesc':
    'Select the insurance type (Domestic or Foreign), then fill in the insurance value not yet included in the invoice price.',
  'lumen.pibEngine.kb1.garansi': '10. Warranty',
  'lumen.pibEngine.kb1.jumlahPenambah': 'D. Total Additional Costs (sum 1 to 10)',
  'lumen.pibEngine.kb1.jumlahC_DitambahD': 'E. Total C plus D',
  'lumen.pibEngine.kb1.tidakPerluDitambahkan': 'Costs that need not be added but are {highlight} in the invoice price',
  'lumen.pibEngine.kb1.kegiatanPembeli':
    '1. Costs incurred from activities conducted by the Buyer for their own interests',
  'lumen.pibEngine.kb1.pengimporan': '2. Costs incurred after importation of goods',
  'lumen.pibEngine.kb1.pajakInternal': '3. Internal tax costs in the exporting country',
  'lumen.pibEngine.kb1.bunga': '4. Interest',
  'lumen.pibEngine.kb1.deviden': '5. Dividends',
  'lumen.pibEngine.kb1.jumlahTidakDitambahkan': 'F. Total Costs Not Added (sum 1 to 5)',
  'lumen.pibEngine.kb1.jumlahE_DikurangiF': 'G. Total E minus F',
  'lumen.pibEngine.kb1.hapus': 'Delete',
  'lumen.pibEngine.kb1.simpan': 'Save',
  'lumen.pibEngine.kb1.menyimpan': 'Saving...',
  'lumen.pibEngine.kb1.apakahYakin': 'Are you sure?',
  'lumen.pibEngine.kb1.andAkanMenghapusAnda': 'You are about to delete this data!',
  'lumen.pibEngine.kb1.tidak': 'No',
  'lumen.pibEngine.kb1.ya': 'Yes',
  'lumen.pibEngine.kb1.error': 'Error',
  'lumen.pibEngine.kb1.lumenProcessIdNotFound': 'Lumen Process ID not found',
  'lumen.pibEngine.kb1.saveSuccess': 'Cost components saved successfully',
  'lumen.pibEngine.kb1.successTitle': 'Success',
  'lumen.pibEngine.kb1.saveError': 'Failed to save cost components',
  'lumen.pibEngine.kb1.deleteSuccess': 'Cost data successfully deleted',
  'lumen.pibEngine.kb1.deleteError': 'Failed to delete cost components',
  'lumen.pibEngine.kb1.notApplicable': 'N/A',
  'lumen.pibEngine.kb1.tidakTermasuk': 'not included',
  'lumen.pibEngine.kb1.belumTermasuk': 'not yet included',
  'lumen.pibEngine.kb1.sudahTermasuk': 'already included',
  'lumen.pibEngine.kb2.incoterm': 'Incoterm',
  'lumen.pibEngine.kb2.dalamNegeri': 'DOMESTIC',
  'lumen.pibEngine.kb2.luarNegeri': 'OVERSEAS',
  'lumen.pibEngine.sh1.successTitle': 'Success',
  'lumen.pibEngine.sh1.syncSuccess': 'Data synced. {matched} of {total} items matched.',
  'lumen.pibEngine.sh1.syncFailed': 'Failed to sync historical data',
  'lumen.pibEngine.sh1.sourcesFailed': 'Failed to load historical data sources',
  'lumen.pibEngine.sh1.previewFailed': 'Failed to load data preview',
  'lumen.pibEngine.sh1.forceApplied': 'Series {seri} applied from the closest candidate.',
  'lumen.pibEngine.sh1.forceApplyUnavailable': 'The force-apply feature is not available on the backend yet.',
  'lumen.pibEngine.sh1.forceApplyFailed': 'Failed to apply the candidate.',
  'lumen.pibEngine.sh1.labelSaved': 'Label "{label}" saved',
  'lumen.pibEngine.sh1.labelRemoved': 'Label removed',
  'lumen.pibEngine.sh1.labelSaveFailed': 'Failed to save label',
  'lumen.pibEngine.sh1.stepSources': 'Select Historical Data Source',
  'lumen.pibEngine.sh1.stepPreview': 'Historical Data Preview',
  'lumen.pibEngine.sh1.stepResult': 'Sync Result',
  'lumen.pibEngine.sh1.processIdLine': 'Process ID: {id} — {name}',
  'lumen.pibEngine.sh1.matchedSummary': '{matched} of {total} items matched',
  'lumen.pibEngine.sh2.aboutTitle': 'About this feature',
  'lumen.pibEngine.sh2.aboutBodyExport':
    'Pulls data from earlier export documents with the same exporter NPWP to complete the document being created.',
  'lumen.pibEngine.sh2.aboutBodyImport':
    'Pulls data from earlier import documents with the same importer NPWP to complete the document being created.',
  'lumen.pibEngine.sh2.updatedTitle': 'What is updated',
  'lumen.pibEngine.sh2.updatedBody':
    'Entities, Goods (HS, description, unit, packaging, country of origin), Packaging, Transaction',
  'lumen.pibEngine.sh2.unchangedTitle': 'What stays the same',
  'lumen.pibEngine.sh2.unchangedBody': 'Quantity, weight, price, freight, insurance, and other quantity data',
  'lumen.pibEngine.sh2.loadingSources': 'Loading data sources...',
  'lumen.pibEngine.sh2.loadFailed': 'Failed to load',
  'lumen.pibEngine.sh2.retry': 'Try again',
  'lumen.pibEngine.sh2.noHistory': 'No historical data was found for this importer.',
  'lumen.pibEngine.sh2.summaryExport': '{sources} sources from {groups} buyers — pick one to see a preview',
  'lumen.pibEngine.sh2.summaryImport': '{sources} sources from {groups} shippers — pick one to see a preview',
  'lumen.pibEngine.sh2.buyer': 'Buyer',
  'lumen.pibEngine.sh2.shipper': 'Shipper',
  'lumen.pibEngine.sh2.barangCount': '{count} items',
  'lumen.pibEngine.sh2.uniqueUraian': '{count} unique descriptions',
  'lumen.pibEngine.sh2.npwpLine': 'NPWP: {npwp}',
  'lumen.pibEngine.sh2.labelPlaceholder': 'Type a label...',
  'lumen.pibEngine.sh2.addLabel': 'Add label',
  'lumen.pibEngine.sh2.editLabel': 'Edit label',
  'lumen.pibEngine.sh2.mergedSources': '{count} sources merged',
  'lumen.pibEngine.sh2.previewButton': 'View Preview',
  'lumen.pibEngine.sh2.loadingPreview': 'Loading data preview...',
  'lumen.pibEngine.sh2.back': 'Back',
  'lumen.pibEngine.sh2.applySync': 'Apply Sync',
  'lumen.pibEngine.sh2.exporter': 'Exporter',
  'lumen.pibEngine.sh2.importer': 'Importer',
  'lumen.pibEngine.sh2.recipient': 'Recipient',
  'lumen.pibEngine.sh2.sender': 'Sender',
  'lumen.pibEngine.sh2.carrier': 'Carrier',
  'lumen.pibEngine.sh2.name': 'Name',
  'lumen.pibEngine.sh2.npwp': 'NPWP',
  'lumen.pibEngine.sh2.address': 'Address',
  'lumen.pibEngine.sh2.country': 'Country',
  'lumen.pibEngine.sh2.vessel': 'Vessel',
  'lumen.pibEngine.sh2.voyage': 'Voy/Flight',
  'lumen.pibEngine.sh2.flag': 'Flag',
  'lumen.pibEngine.sh2.loadPort': 'Port of Loading',
  'lumen.pibEngine.sh2.statDocuments': 'Documents',
  'lumen.pibEngine.sh2.statDocumentsUnit': 'documents',
  'lumen.pibEngine.sh2.statGoods': 'Goods',
  'lumen.pibEngine.sh2.statGoodsUnit': 'series',
  'lumen.pibEngine.sh2.statTransaction': 'Transaction',
  'lumen.pibEngine.sh2.barangTitle': 'Goods ({count} items)',
  'lumen.pibEngine.sh2.barangTitleLimited': 'Goods (Max. 10 of {count} items)',
  'lumen.pibEngine.sh2.colSeri': 'Series',
  'lumen.pibEngine.sh2.colHsCode': 'HS Code',
  'lumen.pibEngine.sh2.colUraian': 'Description',
  'lumen.pibEngine.sh2.colCountry': 'Country',
  'lumen.pibEngine.sh2.moreItems': '... and {count} more items',
  'lumen.pibEngine.sh2.syncedBanner': 'Synced {matched} of {total} items',
  'lumen.pibEngine.sh2.fromSource': 'From {name}',
  'lumen.pibEngine.sh2.ajuInfo': '(Aju {aju})',
  'lumen.pibEngine.sh2.ajuInfoMore': '(Aju {aju}, +{count} more)',
  'lumen.pibEngine.sh2.tabMatched': 'Matched',
  'lumen.pibEngine.sh2.tabNotMerged': 'Not Merged',
  'lumen.pibEngine.sh2.noneMatched': 'No items were merged.',
  'lumen.pibEngine.sh2.allMerged': 'All items were merged.',
  'lumen.pibEngine.sh2.sourceAju': 'Source Aju',
  'lumen.pibEngine.sh2.sourceSeri': 'Source Series',
  'lumen.pibEngine.sh2.sourceUraian': 'Source Description',
  'lumen.pibEngine.sh2.matchTier': 'Match Tier',
  'lumen.pibEngine.sh2.colUraianCurrent': 'Description (current)',
  'lumen.pibEngine.sh2.colScore': 'Score',
  'lumen.pibEngine.sh2.colReason': 'Reason',
  'lumen.pibEngine.sh2.colClosest': 'Closest Candidate',
  'lumen.pibEngine.sh2.colAction': 'Action',
  'lumen.pibEngine.sh2.candidateLine': 'Aju {aju} · Series {seri}',
  'lumen.pibEngine.sh2.useCandidate': 'Use this candidate',
  'lumen.pibEngine.sh2.editManually': 'Edit manually',
  'lumen.pibEngine.sh2.closeModalTitle': 'Close the modal',
  'lumen.pibEngine.sh2.editManuallyHint': 'Edit goods series {seri} manually from the main table.',
  'lumen.pibEngine.sh2.pickDifferent': 'Pick different source',
  'lumen.pibEngine.sh2.close': 'Close',
  'lumen.pibEngine.ji1.statusOk': 'read off a document',
  'lumen.pibEngine.ji1.statusMasterOk': 'resolved from master data',
  'lumen.pibEngine.ji1.statusDefault': 'template constant',
  'lumen.pibEngine.ji1.statusShape': "outside the control's options",
  'lumen.pibEngine.ji1.statusMaster': 'waiting on master data',
  'lumen.pibEngine.ji1.statusCalc': 'CEISA calculates it',
  'lumen.pibEngine.ji1.statusUser': 'a person only',
  'lumen.pibEngine.ji1.copied': 'Copied',
  'lumen.pibEngine.ji1.copy': 'Copy',
  'lumen.pibEngine.ji1.sectionJsonAria': 'Section JSON',
  'lumen.pibEngine.ji1.saveToGroundTruth': 'Save to ground truth',
  'lumen.pibEngine.ji1.cancel': 'Cancel',
  'lumen.pibEngine.ji1.emptySectionHint': 'Leave it empty to record that the document has no such section.',
  'lumen.pibEngine.ji1.reviewedBy': 'Reviewed by {who}',
  'lumen.pibEngine.ji1.someone': 'someone',
  'lumen.pibEngine.ji1.reviewedAt': 'Reviewed {when}',
  'lumen.pibEngine.ji1.notYetReviewed': 'Not yet reviewed',
  'lumen.pibEngine.ji1.outputFromForm': 'Output from the form (synced {count}×, last {when})',
  'lumen.pibEngine.ji1.outputDrafted': 'Output as the pipeline drafted it',
  'lumen.pibEngine.ji1.sectionsEditedOne': '{count} section edited',
  'lumen.pibEngine.ji1.sectionsEditedMany': '{count} sections edited',
  'lumen.pibEngine.ji1.noSectionsEdited': 'no sections edited',
  'lumen.pibEngine.ji1.rerunSinceSeeded': 're-run since seeded',
  'lumen.pibEngine.ji1.rerunSinceSeededTip':
    "The batch was run through the pipeline again after this review started. The pipeline's row is the new run; this ground truth still holds what was reviewed.",
  'lumen.pibEngine.ji1.resyncFromForm': 'Resync from form',
  'lumen.pibEngine.ji1.resyncTip':
    "Read the form's rows back into the reviewed output now. Every save on the form already does this.",
  'lumen.pibEngine.ji1.withdrawReview': 'Withdraw review',
  'lumen.pibEngine.ji1.markAsReviewed': 'Mark as reviewed',
  'lumen.pibEngine.ji1.groundTruthIntroBefore':
    'The nine tab payloads as reviewed -- the same shape the pipeline writes to',
  'lumen.pibEngine.ji1.groundTruthIntroAfter':
    ', joined. The sections half is on the Documents view, where each one can be edited.',
  'lumen.pibEngine.ji1.rowsCount': '{count} rows',
  'lumen.pibEngine.ji1.keysCount': '{count} keys',
  'lumen.pibEngine.ji1.empty': 'empty',
  'lumen.pibEngine.ji1.sectionEdits': 'Section edits',
  'lumen.pibEngine.ji1.recordedCount': '{count} recorded',
  'lumen.pibEngine.ji1.moreCharacters': '… {count} more characters',
  'lumen.pibEngine.ji1.noSections':
    'This run stored no sections. Runs from before the inspector existed did not keep them — re-run the batch to see them.',
  'lumen.pibEngine.ji1.noSectionList': 'no section list',
  'lumen.pibEngine.ji1.sharedFile': 'shared file',
  'lumen.pibEngine.ji1.sharedFileTip':
    "Another document wrote to the same file; these sections may be the other document's.",
  'lumen.pibEngine.ji1.fileOverwritten': 'file overwritten',
  'lumen.pibEngine.ji1.fileOverwrittenTip':
    'The extraction file on this pod disagrees with what the tabs were actually fed, so another run of a document with this name overwrote it. Sections marked “another run’s file” below are not this run’s; everything a tab was given still is.',
  'lumen.pibEngine.ji1.requiredEmpty': '{count} required empty',
  'lumen.pibEngine.ji1.sectionsFound': '{found}/{total} sections',
  'lumen.pibEngine.ji1.readBackFailed':
    'The extraction file could not be read back for this document, so only the sections a tab was actually fed are shown. The rest are empty here, not in the run.',
  'lumen.pibEngine.ji1.edited': 'edited',
  'lumen.pibEngine.ji1.reviewedEditBy': "Reviewed edit by {who} {when}. The pipeline's own answer is shown below it.",
  'lumen.pibEngine.ji1.offSchema': 'off-schema',
  'lumen.pibEngine.ji1.offSchemaTip': "The model answered with a section this document type's schema does not name.",
  'lumen.pibEngine.ji1.required': 'required',
  'lumen.pibEngine.ji1.multiRegion': 'multi-region',
  'lumen.pibEngine.ji1.anotherRunsFile': 'another run’s file',
  'lumen.pibEngine.ji1.anotherRunsFileTip':
    "Read back off the pod's extraction file, which another run has since overwritten. No tab was given this section, so the run itself kept no other copy.",
  'lumen.pibEngine.ji1.sentToATab': 'sent to a tab',
  'lumen.pibEngine.ji1.sentToATabTip': 'This is the copy a tab was actually fed.',
  'lumen.pibEngine.ji1.editAgain': 'Edit again',
  'lumen.pibEngine.ji1.editForGroundTruth': 'Edit for ground truth',
  'lumen.pibEngine.ji1.resetToPipelines': 'Reset to the pipeline’s',
  'lumen.pibEngine.ji1.reviewerRecordedNone': 'The reviewer recorded no such section on this document.',
  'lumen.pibEngine.ji1.nothingExtracted': 'Nothing was extracted under this heading.',
  'lumen.pibEngine.ji1.pipelinesOwnAnswer': 'The pipeline’s own answer',
  'lumen.pibEngine.ji1.whatTheReaderSaw': 'What the reader saw',
  'lumen.pibEngine.ji1.charactersCount': '{count} characters',
  'lumen.pibEngine.ji1.pagesCount': '{count} pages',
  'lumen.pibEngine.ji1.truncated': 'truncated',
  'lumen.pibEngine.ji1.noPerFieldView':
    'No per-field view for this tab. It is stored by the PIB overlay, which this run did not keep.',
  'lumen.pibEngine.ji1.value': 'Value',
  'lumen.pibEngine.ji1.ruleThePromptStates': 'The rule the prompt states',
  'lumen.pibEngine.ji1.whereItComesFrom': 'Where it comes from',
  'lumen.pibEngine.ji1.sentToTheModel': 'sent to the model',
  'lumen.pibEngine.ji1.notInTheSlice': 'not in the slice',
  'lumen.pibEngine.ji1.neverGivenSection':
    'No document of this type carried this section, so the tab was never given it.',
  'lumen.pibEngine.ji1.nothingSpeaksToInput':
    "Nothing in the documents speaks to this input — it is a constant, a calculation, or a person's to fill.",
  'lumen.pibEngine.ji2.noTabCalls':
    'This run stored no tab calls. Runs from before the inspector existed did not keep them.',
  'lumen.pibEngine.ji2.tabsAria': 'Tab calls',
  'lumen.pibEngine.ji2.nothingStoredTab': 'Nothing was stored for this tab.',
  'lumen.pibEngine.ji2.askedModel': 'asked the model',
  'lumen.pibEngine.ji2.assembledRules': 'assembled from rules',
  'lumen.pibEngine.ji2.callOne': '{count} call',
  'lumen.pibEngine.ji2.callMany': '{count} calls',
  'lumen.pibEngine.ji2.documentOne': '{count} document',
  'lumen.pibEngine.ji2.documentMany': '{count} documents',
  'lumen.pibEngine.ji2.sharePct': '{pct}% of the extractions',
  'lumen.pibEngine.ji2.shareTip': 'How much of everything extracted this tab was actually sent',
  'lumen.pibEngine.ji2.promptNotVerified': 'prompt not verified',
  'lumen.pibEngine.ji2.promptNotVerifiedTip':
    "The prompts are rebuilt from the stored slice and did not match the number of calls the run recorded. The slice and the answer are still the run's own.",
  'lumen.pibEngine.ji2.inputTitle': 'Input — the slice this tab was fed',
  'lumen.pibEngine.ji2.inputSubtitle': '{shown} of {total} characters',
  'lumen.pibEngine.ji2.sectionsCount': '{count} sections',
  'lumen.pibEngine.ji2.notSentToTab': 'Not sent to this tab: {list}',
  'lumen.pibEngine.ji2.heldBackDoc':
    'Held back as redundant: {list} — the map does give this tab these, and a primary in this pile already answers the same field.',
  'lumen.pibEngine.ji2.noDocMapped': 'No document was mapped to this tab, so no call went out.',
  'lumen.pibEngine.ji2.notGivenAtAll': 'Not given to this tab at all: {list}',
  'lumen.pibEngine.ji2.heldBackAbsent':
    'Held back as redundant: {list} — everything the map gives this tab of these is a table a primary in this pile already answers.',
  'lumen.pibEngine.ji2.promptTitle': 'Prompt — exactly what the model was sent',
  'lumen.pibEngine.ji2.systemInstruction': 'System instruction',
  'lumen.pibEngine.ji2.callOfTotal': 'Call {n} of {total}',
  'lumen.pibEngine.ji2.promptWord': 'Prompt',
  'lumen.pibEngine.ji2.noPromptKept':
    'No prompt was kept for this tab — either no call went out, or the capture shed them to stay inside its size cap.',
  'lumen.pibEngine.ji2.outputTitle': 'Output — what the model answered',
  'lumen.pibEngine.ji2.emptyWord': 'empty',
  'lumen.pibEngine.ji2.payloadTitle': 'Payload — what went onto the form',
  'lumen.pibEngine.ji2.payloadSubtitle': 'after the rules and the master-data lookups',
  'lumen.pibEngine.ji2.fieldsTitle': 'Fields — one row per input on this tab',
  'lumen.pibEngine.ji2.pendingTitle': 'Pending — what this tab could not answer',
  'lumen.pibEngine.ji2.choicesTitle': 'Choices — where the documents printed more than one right answer',
  'lumen.pibEngine.ji2.noModelCalls':
    'This run kept no model calls. Runs from before the ledger was stored with the draft did not keep them — re-run the batch to see them.',
  'lumen.pibEngine.ji2.hostTip': "The server that answered — OpenRouter's provider, or google",
  'lumen.pibEngine.ji2.slowestRetried': 'slowest {stage}: {seconds} · {attempts} attempts',
  'lumen.pibEngine.ji2.slowestBadge': 'slowest {stage}: {seconds}',
  'lumen.pibEngine.ji2.slowestTip':
    'Slowest {stage} call: {subject}, {seconds} on {host}, {attempts}, {tokens} answer tokens',
  'lumen.pibEngine.ji2.attemptOne': '{count} attempt',
  'lumen.pibEngine.ji2.attemptMany': '{count} attempts',
  'lumen.pibEngine.ji2.inOrder': 'In order',
  'lumen.pibEngine.ji2.slowestFirst': 'Slowest first',
  'lumen.pibEngine.ji2.callsNote':
    'Seconds include the waits between attempts. More than one attempt means the call was refused first — a rate limit or a full provider — and a slow call with one attempt was a slow host or a long answer.',
  'lumen.pibEngine.ji2.colStage': 'Stage',
  'lumen.pibEngine.ji2.colSubject': 'Subject',
  'lumen.pibEngine.ji2.colModel': 'Model',
  'lumen.pibEngine.ji2.colHost': 'Host',
  'lumen.pibEngine.ji2.colSeconds': 'Seconds',
  'lumen.pibEngine.ji2.colAttempts': 'Attempts',
  'lumen.pibEngine.ji2.colIn': 'In',
  'lumen.pibEngine.ji2.colOut': 'Out',
  'lumen.pibEngine.ji2.colCost': 'Cost',
  'lumen.pibEngine.ji2.colFinish': 'Finish',
  'lumen.pibEngine.ji2.rowCandidateMissed': 'row {seri} ({code}): {reason}',
  'lumen.pibEngine.ji2.rowCandidateTaken': 'row {seri} ({code}) is on line {line}',
  'lumen.pibEngine.ji2.notShippedDetail': 'no goods row prints anything close to this code',
  'lumen.pibEngine.ji2.noCodeDetail': 'the line prints no article code to check the goods rows against',
  'lumen.pibEngine.ji2.pendingDash': 'pending —',
  'lumen.pibEngine.ji2.noAttachRecord':
    "This run kept no attach record. Either nothing it read attaches to goods lines — no certificate, permit or surveyor's report — or it ran before the record was stored, and re-running the batch will show it.",
  'lumen.pibEngine.ji2.filterPlaceholder': 'Filter by seri barang, code or naming',
  'lumen.pibEngine.ji2.allLines': 'All lines',
  'lumen.pibEngine.ji2.unmatchedOnly': 'Unmatched lines only',
  'lumen.pibEngine.ji2.likelyMissedOnly': 'Likely missed only',
  'lumen.pibEngine.ji2.attachNote':
    "Each goods line a document printed, beside the barang rows it was attached to and the test that settled it. The article code goes first across the whole document; then an equal amount, the naming, the line number. A line with no row stayed pending, and says whether it rightly did: correct when no goods row prints a close code, or when the rows that do are on lines of their own; likely missed when a row with a close code — a leading zero, a code inside a longer one, a code the document cut off — was left free. Replayed from the run's own documents, not read again.",
  'lumen.pibEngine.ji2.replayMismatch':
    'Replaying the join did not make exactly the links this run stored, so a reason below may not be the one that decided it.',
  'lumen.pibEngine.ji2.dokumenSerials': ' · Dokumen #{list}',
  'lumen.pibEngine.ji2.rowsLines': '{rows} rows · {lines} lines',
  'lumen.pibEngine.ji2.unmatchedCount': '{count} unmatched',
  'lumen.pibEngine.ji2.likelyMissedCount': '{count} likely missed',
  'lumen.pibEngine.ji2.attachedNothing': 'Attached nothing: {reason}',
  'lumen.pibEngine.ji2.colLine': 'Line',
  'lumen.pibEngine.ji2.colCode': 'Code',
  'lumen.pibEngine.ji2.colNaming': "Document's naming",
  'lumen.pibEngine.ji2.colQty': 'Qty',
  'lumen.pibEngine.ji2.colSeri': 'Seri',
  'lumen.pibEngine.ji2.colBarang': 'Barang',
  'lumen.pibEngine.ji2.colSettledBy': 'Settled by',
  'lumen.pibEngine.ji2.colWhatHeld': 'What held',
  'lumen.pibEngine.ji2.noLineMatches': 'No line matches this filter.',
  'lumen.pibEngine.ji2.panelTitle': 'Lumen 2.0 — what the pipeline read',
  'lumen.pibEngine.ji2.documentsCount': '{count} documents',
  'lumen.pibEngine.ji2.fetching': 'Fetching what the run read — this is the size of the extractions.',
  'lumen.pibEngine.ji2.fetchFailed':
    'The draft could not be fetched. It may have been run before the inspector existed, or the service may be unreachable.',
  'lumen.pibEngine.ji2.viewsAria': 'Inspector views',
  'lumen.pibEngine.ji2.viewDocuments': 'Documents ({count})',
  'lumen.pibEngine.ji2.viewTabs': 'Tabs ({count})',
  'lumen.pibEngine.ji2.viewCalls': 'Model calls ({count})',
  'lumen.pibEngine.ji2.viewAttach': 'Attach ({count})',
  'lumen.pibEngine.ji2.viewTruth': 'Ground truth',
  'lumen.pibEngine.mtb.seriIzinTitle': 'Series permit',
  'lumen.pibEngine.mtb.seriIzinSubtitle': 'Item number within one permit document',
  'lumen.pibEngine.mtb.dokumenIzin': 'Permit document',
  'lumen.pibEngine.mtb.noDocumentPlaceholder': 'No documents in this draft',
  'lumen.pibEngine.mtb.documentPlaceholder': 'Pick a permit document...',
  'lumen.pibEngine.mtb.documentHint':
    'Permit series attaches to item & document pairs, so a destination document must be selected. Items not yet linked to this document will be automatically attached.',
  'lumen.pibEngine.mtb.fillMethod': 'Filling method',
  'lumen.pibEngine.mtb.serialList': 'List of Item Series & Permit Series',
  'lumen.pibEngine.mtb.serialHintA': 'One pair per row —',
  'lumen.pibEngine.mtb.serialHintCode': 'item series : permit series',
  'lumen.pibEngine.mtb.serialHintB':
    '. Can be pasted directly from Excel; separators: comma, colon, equals, space, or tab.',
  'lumen.pibEngine.mtb.startFrom': 'Start from',
  'lumen.pibEngine.mtb.serialValue': 'Permit series value',
  'lumen.pibEngine.mtb.startHint': 'Number increments one by one following the item series order.',
  'lumen.pibEngine.mtb.sameValueHint': 'The same number applies to all item series in this row.',
  'lumen.pibEngine.mtb.previewLabel': 'Numbering preview',
  'lumen.pibEngine.mtb.barang': 'items',
  'lumen.pibEngine.mtb.notYet': 'not yet',
  'lumen.pibEngine.mtb.pasteHint': 'Paste the list of item series and permit series pairs above.',
  'lumen.pibEngine.mtb.fillHint': 'Enter Item Series and a start number to see the numbering result.',
  'lumen.pibEngine.mtb.others': 'other(s)',
  'lumen.pibEngine.mtb.outsideRange':
    'item series outside this row\'s "Item Series" range — still applied, but skip if unintentional.',
  'lumen.pibEngine.hcc.title': 'HS Code Tariff Data',
  'lumen.pibEngine.hcc.hsCodes': 'HS Codes',
  'lumen.pibEngine.hcc.items': 'Items',
  'lumen.pibEngine.hcc.loading': 'Loading tariff data...',
  'lumen.pibEngine.hcc.noData': 'No data to display',
  'lumen.pibEngine.hcc.group': 'Group',
  'lumen.pibEngine.hcc.hsCode': 'HS Code',
  'lumen.pibEngine.hcc.dokumen': 'Document',
  'lumen.pibEngine.hcc.ppn': 'PPN (%)',
  'lumen.pibEngine.hcc.pph': 'PPH (%)',
  'lumen.pibEngine.hcc.bm': 'BM (%)',
  'lumen.pibEngine.hcc.count': 'Count',
  'lumen.pibEngine.hcc.seriBarang': 'Seri Barang',
  'lumen.pibEngine.hcc.lartas': 'Lartas',
  'lumen.pibEngine.hcc.sync': 'Sync',
  'lumen.pibEngine.s19.modul': 'Module: {modul}',
  'lumen.pibEngine.s19.na': 'N/A',
  'lumen.pibEngine.s19.wajibLaporDheSda': 'DHE-SDA reporting required',
  'lumen.pibEngine.s19.tidak': 'No',
  'lumen.pibEngine.s19.note': 'NOTE',
  'lumen.pibEngine.s12.selectDocumentError': 'Please select a document',
  'lumen.pibEngine.s12.dokumenFasilitasLartas': 'Facility / Restriction Documents',
  'lumen.pibEngine.s12.dokumen': 'Document',
  'lumen.pibEngine.s12.pilihDokumen': 'Select document',
  'lumen.pibEngine.s12.izin': 'Permit',
  'lumen.pibEngine.s12.masukkanIzin': 'Enter permit',
  'lumen.pibEngine.s12.dokumenLampiran': 'Attached Document',
  'lumen.pibEngine.s12.modalIsOpen': 'Modal is open: {open}',
  'lumen.pibEngine.s12.seri': 'Serial',
  'lumen.pibEngine.s12.jenisDokumen': 'Document Type',
  'lumen.pibEngine.s12.pilihJenisDokumen': 'Select document type',
  'lumen.pibEngine.s12.nomor': 'Number',
  'lumen.pibEngine.s12.tanggal': 'Date',
  'lumen.pibEngine.s12.pilihTanggal': 'Select date',
  'lumen.pibEngine.s12.kodeIjin': 'Permit Code',
  'lumen.pibEngine.s12.pilihKodeIjin': 'Select permit code',
  'lumen.pibEngine.s12.tidakDitemukan': 'Not found',
  'lumen.pibEngine.s12.fasilitasDokumen': 'Document Facility',
  'lumen.pibEngine.s12.pilihFasilitasDokumen': 'Select document facility',
  'lumen.pibEngine.s12.statusDokumen': 'Document Status',
  'lumen.pibEngine.s12.cancel': 'Cancel',
  'lumen.pibEngine.rv1.draftPibTitle': 'Draft PIB',
  'lumen.pibEngine.rv2.syncInfoTitle': 'Info',
  'lumen.pibEngine.rv2.revisionProgressAria': 'Progress revision checklist',
  'lumen.pibEngine.mtd.row': 'Row',
  'lumen.pibEngine.mtd.removeRow': 'Remove row',
  'lumen.pibEngine.mtd.identityTitle': 'Item identity',
  'lumen.pibEngine.mtd.identitySubtitle': 'Target rows and HS classification',
  'lumen.pibEngine.mtd.seriBarang': 'Item series',
  'lumen.pibEngine.mtd.seriBarangHint': 'Row numbers to update. Use commas or dashes — example',
  'lumen.pibEngine.mtd.hsCode': 'HS Code',
  'lumen.pibEngine.mtd.hsCodeHint': 'Harmonized System classification code of the item.',
  'lumen.pibEngine.mtd.hsCodePlaceholder': 'Select HS Code…',
  'lumen.pibEngine.mtd.uraian': 'Description',
  'lumen.pibEngine.mtd.uraianHint': 'Full item description as in the documents (invoice / packing list).',
  'lumen.pibEngine.mtd.uraianPlaceholder': 'e.g. Smartphone with 6.7-inch screen, 256GB',
  'lumen.pibEngine.mtd.kodeBarang': 'Item code',
  'lumen.pibEngine.mtd.kodeBarangPlaceholder': 'SKU / internal code (optional)',
  'lumen.pibEngine.mtd.merkTitle': 'Brand & specification',
  'lumen.pibEngine.mtd.merkSubtitle': 'Mark "none" if the item has no brand / type',
  'lumen.pibEngine.mtd.merek': 'Brand',
  'lumen.pibEngine.mtd.noBrand': 'No brand',
  'lumen.pibEngine.mtd.brandPlaceholder': 'Brand name',
  'lumen.pibEngine.mtd.noBrandFlag': 'NO BRAND',
  'lumen.pibEngine.mtd.tipe': 'Type',
  'lumen.pibEngine.mtd.noType': 'No type',
  'lumen.pibEngine.mtd.typePlaceholder': 'Type name',
  'lumen.pibEngine.mtd.noTypeFlag': 'NO TYPE',
  'lumen.pibEngine.mtd.ukuran': 'Size',
  'lumen.pibEngine.mtd.ukuranHint': 'Size / dimensions if relevant.',
  'lumen.pibEngine.mtd.ukuranPlaceholder': 'e.g. XL / 42',
  'lumen.pibEngine.mtd.originTitle': 'Origin, unit & packaging',
  'lumen.pibEngine.mtd.originSubtitle': 'Logistics data and item weight',
  'lumen.pibEngine.mtd.negaraAsal': 'Country of origin',
  'lumen.pibEngine.mtd.negaraAsalHint': 'Country where the item was produced.',
  'lumen.pibEngine.mtd.countryPlaceholder': 'Select country…',
  'lumen.pibEngine.mtd.kodeSatuan': 'Unit code',
  'lumen.pibEngine.mtd.kodeSatuanHint': 'Quantity unit of the item.',
  'lumen.pibEngine.mtd.unitPlaceholder': 'Select unit…',
  'lumen.pibEngine.mtd.kodeKemasan': 'Packaging code',
  'lumen.pibEngine.mtd.kodeKemasanHint': 'Type of shipping package.',
  'lumen.pibEngine.mtd.packagingPlaceholder': 'Select packaging…',
  'lumen.pibEngine.mtd.nettLabel': 'Net weight (KGM)',
  'lumen.pibEngine.mtd.nettHint': 'Net weight per unit in kilograms.',
  'lumen.pibEngine.mtd.taxTitle': 'Taxes & facilities',
  'lumen.pibEngine.mtd.taxSubtitle': 'Item tariffs and customs facilities',
  'lumen.pibEngine.mtd.fasBM': 'BM facility',
  'lumen.pibEngine.mtd.taxNameBM': 'Import duty',
  'lumen.pibEngine.mtd.fasPPN': 'PPN facility',
  'lumen.pibEngine.mtd.taxNamePPN': 'Value-added tax',
  'lumen.pibEngine.mtd.fasPPh': 'PPh facility',
  'lumen.pibEngine.mtd.taxNamePPh': 'Income tax',
  'lumen.pibEngine.mtd.facilityPlaceholder': 'Select facility...',
  'lumen.pibEngine.mtd.pastedList': 'pasted list',
  'lumen.pibEngine.mtd.notSet': 'not set yet',
  'lumen.pibEngine.mtd.noHsSelected': 'No HS Code selected',
  'lumen.pibEngine.mtd.noDescription': 'No item description yet.',
  'lumen.pibEngine.mtd.none': 'None',
  'lumen.pibEngine.mtd.dialogEyebrow': 'Imported item details',
  'lumen.pibEngine.mtd.dialogTitle': 'Set item brand, type, size & HS',
  'lumen.pibEngine.mtd.dialogIntro':
    'Fill in only the fields you want to update — fields left empty will not change the data of the selected rows.',
  'lumen.pibEngine.mtd.close': 'Close',
  'lumen.pibEngine.mtd.summaryTitle': 'Row summary',
  'lumen.pibEngine.mtd.summaryIntro': 'Live preview of the data to be saved.',
  'lumen.pibEngine.mtd.requiredFields': 'Required fields',
  'lumen.pibEngine.mtd.appliedToSeri': 'Applied to series:',
  'lumen.pibEngine.mtd.summaryNegara': 'Country of origin',
  'lumen.pibEngine.mtd.summarySatuan': 'Unit',
  'lumen.pibEngine.mtd.summaryKemasan': 'Packaging',
  'lumen.pibEngine.mtd.summaryNett': 'Net weight',
  'lumen.pibEngine.mtd.summaryTax': 'Tax',
  'lumen.pibEngine.mtd.summarySeriIzin': 'Permit series',
  'lumen.pibEngine.mtd.numbered': 'items numbered',
  'lumen.pibEngine.mtd.noPermitDoc': 'No permit document selected — permit series unchanged.',
  'lumen.pibEngine.mtd.footerA': 'Changes are applied to series',
  'lumen.pibEngine.mtd.footerB': 'Permit series written to',
  'lumen.pibEngine.mtd.footerC': 'for',
  'lumen.pibEngine.mtd.footerD': 'items.',
  'lumen.pibEngine.mtd.cancel': 'Cancel',
  'lumen.pibEngine.mtd.addRow': 'Add row',
  'lumen.pibEngine.mtd.apply': 'Apply',
  'lumen.pibEngine.rv5.rowN': 'Row {n}',
  'lumen.pibEngine.rv5.numberedN': '{n} items numbered',
  'lumen.pibEngine.rv5.statusMatch': 'Match',
  'lumen.pibEngine.rv5.statusMismatch': 'Mismatch',
  'lumen.pibEngine.rv5.mandatory': 'mandatory',
  'lumen.pibEngine.rv5.fetchError': 'Failed to fetch comparison data',
  'lumen.pibEngine.rv5.dupSeri': 'Seri',
  'lumen.pibEngine.rv5.dupDokumen': 'document',
  'lumen.pibEngine.rv5.dupSeriDok': 'series',
  'lumen.pibEngine.rv5.jenisN': '{n} types',
  'lumen.pibEngine.rv5.kgN': '{n} kg',
  // lumen.otherDocs (revamp PR 8a)
  'lumen.otherDocs.ck1.statusDraft': 'Draft',
  'lumen.otherDocs.ck1.statusFinal': 'Final',
  'lumen.otherDocs.ck1.statusCkGenerated': 'CK created',
  'lumen.otherDocs.ck1.statusCancelled': 'Cancelled',
  'lumen.otherDocs.ck1.statusGenerated': 'CK draft',
  'lumen.otherDocs.ck1.statusSubmitted': 'Sent',
  'lumen.otherDocs.ck1.statusAccepted': 'Accepted',
  'lumen.otherDocs.ck1.statusRejected': 'Rejected',
  'lumen.otherDocs.ck1.statusError': 'Failed',
  'lumen.otherDocs.ck1.docCk1Desc': 'Excise band order',
  'lumen.otherDocs.ck1.docCk4Desc': 'Excise goods production report',
  'lumen.otherDocs.ck1.docCk5Desc': 'Excise goods transfer',
  'lumen.otherDocs.ck1.itemBahanBaku': 'Raw material',
  'lumen.otherDocs.ck1.itemBarangJadi': 'Finished goods',
  'lumen.otherDocs.ck1.itemPitaCukai': 'Excise band',
  'lumen.otherDocs.ck1.addItem': 'Add item',
  'lumen.otherDocs.ck1.allStatus': 'All statuses',
  'lumen.otherDocs.ck1.caraKredit': 'Credit',
  'lumen.otherDocs.ck1.caraTunai': 'Cash',
  'lumen.otherDocs.ck1.cellRows': '{n} rows',
  'lumen.otherDocs.ck1.colAksi': 'Actions',
  'lumen.otherDocs.ck1.colAngkutan': 'Transport',
  'lumen.otherDocs.ck1.colBarang': 'Goods',
  'lumen.otherDocs.ck1.colPengirimPenerima': 'Sender → Receiver',
  'lumen.otherDocs.ck1.colStatus': 'Status',
  'lumen.otherDocs.ck1.colSuratJalan': 'Delivery note',
  'lumen.otherDocs.ck1.createButton': 'Create delivery note',
  'lumen.otherDocs.ck1.delBodyAfter': '? CK documents already created are not deleted.',
  'lumen.otherDocs.ck1.delBodyBefore': 'Are you sure you want to delete',
  'lumen.otherDocs.ck1.deleteItemAria': 'Delete item #{n}',
  'lumen.otherDocs.ck1.delTitle': 'Delete delivery note',
  'lumen.otherDocs.ck1.emptyDesc': 'Create your first delivery note, then issue CK-1 / CK-4 / CK-5 from it.',
  'lumen.otherDocs.ck1.emptyTitle': 'No delivery notes yet',
  'lumen.otherDocs.ck1.existingDocs': 'DOCUMENTS ALREADY CREATED FROM THIS DELIVERY NOTE',
  'lumen.otherDocs.ck1.fAlamatPenerima': 'Receiver address',
  'lumen.otherDocs.ck1.fAlamatPengirim': 'Sender address',
  'lumen.otherDocs.ck1.fHje': 'HJE / package',
  'lumen.otherDocs.ck1.fIsiPerKemasan': 'Content per package',
  'lumen.otherDocs.ck1.fJenisBkc': 'Excise goods type',
  'lumen.otherDocs.ck1.fJenisKemasan': 'Package type',
  'lumen.otherDocs.ck1.fJenisKemasanPlaceholder': 'Pack / Carton',
  'lumen.otherDocs.ck1.fJumlah': 'Quantity',
  'lumen.otherDocs.ck1.fJumlahKemasan': 'Number of packages',
  'lumen.otherDocs.ck1.fKadarAlkohol': 'Alcohol content %',
  'lumen.otherDocs.ck1.fKeterangan': 'Notes',
  'lumen.otherDocs.ck1.fKodeBarang': 'Item code',
  'lumen.otherDocs.ck1.fKodeKantorAsal': 'Origin office code (KPPBC)',
  'lumen.otherDocs.ck1.fKodeKantorTujuan': 'Destination office code',
  'lumen.otherDocs.ck1.fMerk': 'Brand',
  'lumen.otherDocs.ck1.fModa': 'Mode',
  'lumen.otherDocs.ck1.fNamaPenerima': 'Receiver name',
  'lumen.otherDocs.ck1.fNamaPengangkut': 'Carrier name',
  'lumen.otherDocs.ck1.fNamaPengirim': 'Sender name',
  'lumen.otherDocs.ck1.fNomorPolisi': 'Plate number',
  'lumen.otherDocs.ck1.fNomorSuratJalan': 'Delivery note number',
  'lumen.otherDocs.ck1.fNppbkcPenerima': 'Receiver NPPBKC',
  'lumen.otherDocs.ck1.fNppbkcPengirim': 'Sender NPPBKC',
  'lumen.otherDocs.ck1.fNpwpPenerima': 'Receiver NPWP',
  'lumen.otherDocs.ck1.fNpwpPengirim': 'Sender NPWP',
  'lumen.otherDocs.ck1.formTitleCreate': 'Create delivery note',
  'lumen.otherDocs.ck1.formTitleEdit': 'Edit delivery note — {nomor}',
  'lumen.otherDocs.ck1.fPengemudi': 'Driver',
  'lumen.otherDocs.ck1.fPerkiraanTiba': 'Estimated arrival',
  'lumen.otherDocs.ck1.fromSuratJalan': 'From the delivery note',
  'lumen.otherDocs.ck1.fSatuan': 'Unit',
  'lumen.otherDocs.ck1.fStatus': 'Status',
  'lumen.otherDocs.ck1.fTanggal': 'Date',
  'lumen.otherDocs.ck1.fTarifCukai': 'Excise rate / unit',
  'lumen.otherDocs.ck1.fTglBerangkat': 'Departure date',
  'lumen.otherDocs.ck1.fUraianBarang': 'Item description',
  'lumen.otherDocs.ck1.gCaraBayar': 'Payment method',
  'lumen.otherDocs.ck1.genAlertBody':
    'Sender, receiver, transport and {n} item details will be filled in automatically from this delivery note. The draft can still be edited before it is sent to Customs.',
  'lumen.otherDocs.ck1.genSubmit': 'Create {docType} draft',
  'lumen.otherDocs.ck1.genTitle': 'Create {docType} from {nomor}',
  'lumen.otherDocs.ck1.gKodeKantor': 'Office code (KPPBC)',
  'lumen.otherDocs.ck1.gNppbkc': 'NPPBKC',
  'lumen.otherDocs.ck1.gPeriodeAkhir': 'Production period end',
  'lumen.otherDocs.ck1.gPeriodeAwal': 'Production period start',
  'lumen.otherDocs.ck1.gStatusPelunasan': 'Excise payment status',
  'lumen.otherDocs.ck1.gTujuanPengiriman': 'Shipping purpose',
  'lumen.otherDocs.ck1.itemHeader': 'ITEM #{n}',
  'lumen.otherDocs.ck1.menuCk1': 'CK-1 · Excise band order',
  'lumen.otherDocs.ck1.menuCk4': 'CK-4 · Production report',
  'lumen.otherDocs.ck1.menuCk5': 'CK-5 · Excise goods transfer',
  'lumen.otherDocs.ck1.menuCkLabel': 'Create a document from the delivery note',
  'lumen.otherDocs.ck1.menuDelete': 'Delete',
  'lumen.otherDocs.ck1.menuEdit': 'Edit',
  'lumen.otherDocs.ck1.pilih': 'Select',
  'lumen.otherDocs.ck1.rowMenu': 'More actions',
  'lumen.otherDocs.ck1.saveCreate': 'Save delivery note',
  'lumen.otherDocs.ck1.saveEdit': 'Save changes',
  'lumen.otherDocs.ck1.searchPlaceholder': 'Search number, sender, receiver, plate...',
  'lumen.otherDocs.ck1.secBarang': 'Excise goods',
  'lumen.otherDocs.ck1.secPenerima': 'Receiver',
  'lumen.otherDocs.ck1.secPengangkutan': 'Transport',
  'lumen.otherDocs.ck1.secPengirim': 'Sender (Factory / Warehouse)',
  'lumen.otherDocs.ck1.sjCreatedMsg': 'Delivery note created.',
  'lumen.otherDocs.ck1.sjDeletedMsg': 'Delivery note deleted.',
  'lumen.otherDocs.ck1.sjDeletedTitle': 'Deleted',
  'lumen.otherDocs.ck1.sjDeleteFailedTitle': 'Delete failed',
  'lumen.otherDocs.ck1.sjGeneratedMsg': '{desc} draft was created from {nomor}.',
  'lumen.otherDocs.ck1.sjGeneratedTitle': '{docType} created',
  'lumen.otherDocs.ck1.sjGenerateFailedTitle': 'Failed to create CK',
  'lumen.otherDocs.ck1.sjIncompleteMsg': 'Delivery note number, sender NPWP and name, and receiver name are required.',
  'lumen.otherDocs.ck1.sjIncompleteTitle': 'Incomplete data',
  'lumen.otherDocs.ck1.sjNoItemsMsg': 'At least one item with a description and quantity is required.',
  'lumen.otherDocs.ck1.sjNoItemsTitle': 'No items',
  'lumen.otherDocs.ck1.sjPostStockFailedTitle': 'Failed to post stock',
  'lumen.otherDocs.ck1.sjSavedTitle': 'Saved',
  'lumen.otherDocs.ck1.sjSaveFailedTitle': 'Failed to save',
  'lumen.otherDocs.ck1.sjSkippedInfo': '({n} rows skipped — not linked to a stock item yet)',
  'lumen.otherDocs.ck1.sjStockPostedMsg': '{n} stock movements recorded for {nomor}{skipped}.',
  'lumen.otherDocs.ck1.sjStockPostedTitle': 'Stock out posted',
  'lumen.otherDocs.ck1.sjUpdatedMsg': 'Delivery note updated.',
  'lumen.otherDocs.ck1.statGenerated': 'CK created',
  'lumen.otherDocs.ck1.statTotal': 'Total delivery notes',
  'lumen.otherDocs.ck1.subtitle': 'Excise source document — from your delivery note you can create CK-1, CK-4 and CK-5',
  'lumen.otherDocs.ck1.tipCreateCk': 'Create CK document',
  'lumen.otherDocs.ck1.tipPostStock': 'Post stock out',
  'lumen.otherDocs.ck1.title': 'Delivery notes',
  'lumen.otherDocs.ck3.title': 'Bill of Material',
  'lumen.otherDocs.ck3.subtitle': 'Production recipe per excise product — used by CK-4 to calculate raw material usage',
  'lumen.otherDocs.ck3.createBom': 'Create BOM',
  'lumen.otherDocs.ck3.searchPlaceholder': 'Search product code, name, brand...',
  'lumen.otherDocs.ck3.colProduk': 'Product',
  'lumen.otherDocs.ck3.colJenisBkc': 'Excise type',
  'lumen.otherDocs.ck3.colOutput': 'Output per batch',
  'lumen.otherDocs.ck3.colKomposisi': 'Ingredients',
  'lumen.otherDocs.ck3.colItemHasil': 'Output stock item',
  'lumen.otherDocs.ck3.colAksi': 'Actions',
  'lumen.otherDocs.ck3.merkPrefix': 'Brand ',
  'lumen.otherDocs.ck3.notLinked': 'Not linked',
  'lumen.otherDocs.ck3.notLinkedHint': 'Link a finished-goods item so CK-4 production stock posting can run',
  'lumen.otherDocs.ck3.edit': 'Edit',
  'lumen.otherDocs.ck3.hapus': 'Delete',
  'lumen.otherDocs.ck3.emptyTitle': 'No BOM yet',
  'lumen.otherDocs.ck3.emptyBody': 'Define a production recipe so CK-4 can calculate raw material usage automatically.',
  'lumen.otherDocs.ck3.createTitle': 'Create Bill of Material',
  'lumen.otherDocs.ck3.editTitlePrefix': 'Edit BOM — ',
  'lumen.otherDocs.ck3.kodeProduk': 'Product code',
  'lumen.otherDocs.ck3.namaProduk': 'Product name',
  'lumen.otherDocs.ck3.merk': 'Brand',
  'lumen.otherDocs.ck3.jenisBkc': 'Excise type',
  'lumen.otherDocs.ck3.jumlahOutput': 'Output quantity per batch',
  'lumen.otherDocs.ck3.satuanOutput': 'Output unit',
  'lumen.otherDocs.ck3.outputItem': 'Finished goods stock item (production output)',
  'lumen.otherDocs.ck3.outputItemHint': 'Required to post production stock from CK-4: finished goods go into this item',
  'lumen.otherDocs.ck3.outputItemPlaceholder': 'Select finished goods item',
  'lumen.otherDocs.ck3.outputItemNone': 'No BARANG_JADI items in inventory yet',
  'lumen.otherDocs.ck3.clearSelection': 'Clear selection',
  'lumen.otherDocs.ck3.compositionHeading': 'Raw material composition (per {n} {satuan})',
  'lumen.otherDocs.ck3.kodeBahan': 'Material code',
  'lumen.otherDocs.ck3.namaBahan': 'Material name',
  'lumen.otherDocs.ck3.jumlah': 'Quantity',
  'lumen.otherDocs.ck3.satuan': 'Unit',
  'lumen.otherDocs.ck3.itemStok': 'Stock item',
  'lumen.otherDocs.ck3.itemStokPlaceholder': 'Link raw material',
  'lumen.otherDocs.ck3.deleteRowAria': 'Delete ingredient row',
  'lumen.otherDocs.ck3.addIngredient': 'Add ingredient',
  'lumen.otherDocs.ck3.keterangan': 'Notes',
  'lumen.otherDocs.ck3.saveChanges': 'Save changes',
  'lumen.otherDocs.ck3.saveBom': 'Save BOM',
  'lumen.otherDocs.ck3.deleteTitle': 'Delete BOM',
  'lumen.otherDocs.ck3.deleteConfirmPre': 'Are you sure you want to delete BOM ',
  'lumen.otherDocs.ck3.deleteConfirmPost': '?',
  'lumen.otherDocs.ck3.incompleteTitle': 'Incomplete data',
  'lumen.otherDocs.ck3.incompleteMessage': 'Product code, product name and output quantity are required.',
  'lumen.otherDocs.ck3.emptyCompositionTitle': 'Empty composition',
  'lumen.otherDocs.ck3.emptyCompositionMessage': 'At least one ingredient with a name and quantity must be filled in.',
  'lumen.otherDocs.ck3.savedTitle': 'Saved',
  'lumen.otherDocs.ck3.updated': 'BOM updated.',
  'lumen.otherDocs.ck3.created': 'BOM created.',
  'lumen.otherDocs.ck3.saveFailed': 'Failed to save',
  'lumen.otherDocs.ck3.deletedTitle': 'Deleted',
  'lumen.otherDocs.ck3.deleted': 'BOM deleted.',
  'lumen.otherDocs.ck3.deleteFailed': 'Failed to delete',
  'lumen.otherDocs.ck3.pageTitle': 'Risk Self-Check',
  'lumen.otherDocs.ck3.pageSubtitle':
    "Company-side excise risk indicators — a mirror of Customs' SPT-BKC oversight, so findings are visible before an audit",
  'lumen.otherDocs.ck3.periodeAwal': 'Period start',
  'lumen.otherDocs.ck3.periodeAkhir': 'Period end',
  'lumen.otherDocs.ck3.until': 'to',
  'lumen.otherDocs.ck3.recalculate': 'Recalculate',
  'lumen.otherDocs.ck3.calculating': 'Calculating risk indicators...',
  'lumen.otherDocs.ck3.loadFailed': 'Failed to load self-check',
  'lumen.otherDocs.ck3.riskScore': 'Risk score 0 – 1',
  'lumen.otherDocs.ck3.scoreHint': 'The score is calculated from the same indicators Customs monitors (SPT-BKC)',
  'lumen.otherDocs.ck3.bucketSangatRendah': 'Very low',
  'lumen.otherDocs.ck3.bucketRendah': 'Low',
  'lumen.otherDocs.ck3.bucketSedang': 'Medium',
  'lumen.otherDocs.ck3.bucketTinggi': 'High',
  'lumen.otherDocs.ck3.bucketSangatTinggi': 'Very high',
  'lumen.otherDocs.ck3.statusOk': 'Safe',
  'lumen.otherDocs.ck3.statusWarning': 'Attention',
  'lumen.otherDocs.ck3.statusCritical': 'Critical',
  'lumen.otherDocs.ck3.weight': 'weight {n}%',
  'lumen.otherDocs.ck3.periodSummary': 'Period summary',
  'lumen.otherDocs.ck3.periodRange': '{awal} to {akhir}',
  'lumen.otherDocs.ck3.criticalIndicators': 'Critical indicators',
  'lumen.otherDocs.ck3.needAttention': 'Needs attention',
  'lumen.otherDocs.ck3.safe': 'Safe',
  'lumen.otherDocs.ck3.calculatedOn': 'Calculated {date} from your CK-1, CK-4, CK-5, BOM and stock card data.',
  'lumen.otherDocs.ck2.actCreate': 'Created',
  'lumen.otherDocs.ck2.actEdit': 'Edited',
  'lumen.otherDocs.ck2.actSubmit': 'Sent',
  'lumen.otherDocs.ck2.actStatusPull': 'Pull Status',
  'lumen.otherDocs.ck2.actDelete': 'Deleted',
  'lumen.otherDocs.ck2.allStatus': 'All statuses',
  'lumen.otherDocs.ck2.angkutFmt': '{moda} · {nopol}',
  'lumen.otherDocs.ck2.arrowFmt': '{asal} → {tujuan}',
  'lumen.otherDocs.ck2.btnHistory': 'History',
  'lumen.otherDocs.ck2.btnPull': 'Pull Status',
  'lumen.otherDocs.ck2.btnSend': 'Send to Customs',
  'lumen.otherDocs.ck2.byUser': '· by User #{id}',
  'lumen.otherDocs.ck2.colAksi': 'Actions',
  'lumen.otherDocs.ck2.colDikirim': 'Sent',
  'lumen.otherDocs.ck2.colDokumen': 'Document',
  'lumen.otherDocs.ck2.colNomorAju': 'Submission No.',
  'lumen.otherDocs.ck2.colNppbkc': 'NPPBKC / Office',
  'lumen.otherDocs.ck2.colStatus': 'Status',
  'lumen.otherDocs.ck2.copyAria': 'Copy submission number',
  'lumen.otherDocs.ck2.delAju': '({nomorAju})',
  'lumen.otherDocs.ck2.delBodyBefore': 'Are you sure you want to delete the draft',
  'lumen.otherDocs.ck2.delBodyEnd': '?',
  'lumen.otherDocs.ck2.delConfirm': 'Delete',
  'lumen.otherDocs.ck2.delTitle': 'Delete Document',
  'lumen.otherDocs.ck2.emptyDesc': 'Open the Delivery Note menu and choose "Create CK document" on a delivery note.',
  'lumen.otherDocs.ck2.emptyTitle': 'No excise documents yet',
  'lumen.otherDocs.ck2.historyDesc':
    'Audit trail of every document status change (who, when, from → to). Cannot be changed.',
  'lumen.otherDocs.ck2.historyEmpty': 'No history for this document yet.',
  'lumen.otherDocs.ck2.historyTitle': '{docType} History',
  'lumen.otherDocs.ck2.historyTitleFallback': 'History',
  'lumen.otherDocs.ck2.kirimSekarang': 'Send Now',
  'lumen.otherDocs.ck2.lblAngkutan': 'Transport',
  'lumen.otherDocs.ck2.lblBerangkatTiba': 'Departure / Arrival',
  'lumen.otherDocs.ck2.lblCaraBayar': 'Payment Method',
  'lumen.otherDocs.ck2.lblDikirim': 'Sent',
  'lumen.otherDocs.ck2.lblIdHeader': 'Header ID',
  'lumen.otherDocs.ck2.lblJenisBkc': 'BKC Type',
  'lumen.otherDocs.ck2.lblKantor': 'Office Code',
  'lumen.otherDocs.ck2.lblKantorAsalTujuan': 'Origin → Destination Office',
  'lumen.otherDocs.ck2.lblKodeDok': 'H2H Document Code',
  'lumen.otherDocs.ck2.lblMode': 'Send Mode',
  'lumen.otherDocs.ck2.lblNomorAju': 'Submission No.',
  'lumen.otherDocs.ck2.lblNomorPemesanan': 'Order Number',
  'lumen.otherDocs.ck2.lblNppbkc': 'NPPBKC',
  'lumen.otherDocs.ck2.lblNpwp': 'Applicant NPWP',
  'lumen.otherDocs.ck2.lblPenerima': 'Receiver',
  'lumen.otherDocs.ck2.lblPengirim': 'Sender',
  'lumen.otherDocs.ck2.lblPengusaha': 'Entrepreneur',
  'lumen.otherDocs.ck2.lblPeriode': 'Period',
  'lumen.otherDocs.ck2.lblPerusahaan': 'Company',
  'lumen.otherDocs.ck2.lblStatusPelunasan': 'Payment Status',
  'lumen.otherDocs.ck2.lblSuratJalan': 'Delivery Note',
  'lumen.otherDocs.ck2.lblTanggal': 'Date',
  'lumen.otherDocs.ck2.lblTotalKemasan': 'Total Packages',
  'lumen.otherDocs.ck2.lblTujuanKirim': 'Shipping Purpose',
  'lumen.otherDocs.ck2.loading': 'Loading...',
  'lumen.otherDocs.ck2.modeDraft': 'Draft in CEISA',
  'lumen.otherDocs.ck2.modeFinal': 'Final',
  'lumen.otherDocs.ck2.noAju': 'None yet — created on send',
  'lumen.otherDocs.ck2.noAjuYet': 'Created on send',
  'lumen.otherDocs.ck2.optAccepted': 'Accepted',
  'lumen.otherDocs.ck2.optDraftCk': 'CK Draft',
  'lumen.otherDocs.ck2.optError': 'Failed',
  'lumen.otherDocs.ck2.optRejected': 'Rejected',
  'lumen.otherDocs.ck2.optSubmitted': 'Sent',
  'lumen.otherDocs.ck2.partyFmt': '{nama} ({nppbkc})',
  'lumen.otherDocs.ck2.periodeRange': '{awal} to {akhir}',
  'lumen.otherDocs.ck2.postSkipped': '({n} rows skipped — check BOM links & stock items)',
  'lumen.otherDocs.ck2.respon': 'Customs response: {msg}',
  'lumen.otherDocs.ck2.searchPlaceholder': 'Search submission no., NPPBKC, NPWP...',
  'lumen.otherDocs.ck2.slashFmt': '{berangkat} / {tiba}',
  'lumen.otherDocs.ck2.statDraft': 'Draft',
  'lumen.otherDocs.ck2.statProblem': 'Rejected / Failed',
  'lumen.otherDocs.ck2.statSubmitted': 'Sent',
  'lumen.otherDocs.ck2.statTotal': 'Total Documents',
  'lumen.otherDocs.ck2.submitBody':
    'The document will be sent through the CEISA H2H gateway. The submission number is created automatically if none exists.',
  'lumen.otherDocs.ck2.submitTitle': 'Send {docType} to Customs',
  'lumen.otherDocs.ck2.subtitle':
    'Manage and send CK-1 (excise bands), CK-4 (production) and CK-5 (BKC movement) to Customs',
  'lumen.otherDocs.ck2.switchFinal': 'Send as final (isFinal) — without this the document is saved as a draft in CEISA',
  'lumen.otherDocs.ck2.tabAll': 'All',
  'lumen.otherDocs.ck2.tabCk1': 'CK-1 · Excise Bands',
  'lumen.otherDocs.ck2.tabCk4': 'CK-4 · Production',
  'lumen.otherDocs.ck2.tabCk5': 'CK-5 · Movement',
  'lumen.otherDocs.ck2.thHje': 'HJE',
  'lumen.otherDocs.ck2.thIsiKemasan': 'Content/Package',
  'lumen.otherDocs.ck2.thJenisBkc': 'BKC Type',
  'lumen.otherDocs.ck2.thJmlKemasan': 'Package Qty',
  'lumen.otherDocs.ck2.thJmlProduksi': 'Production Qty',
  'lumen.otherDocs.ck2.thJumlah': 'Quantity',
  'lumen.otherDocs.ck2.thKemasan': 'Package',
  'lumen.otherDocs.ck2.thKeping': 'Pieces',
  'lumen.otherDocs.ck2.thLembar': 'Sheets',
  'lumen.otherDocs.ck2.thMerk': 'Brand',
  'lumen.otherDocs.ck2.thNilaiCukai': 'Excise Value',
  'lumen.otherDocs.ck2.thPpn': 'VAT',
  'lumen.otherDocs.ck2.thSeriPita': 'Band Series',
  'lumen.otherDocs.ck2.thTarif': 'Rate',
  'lumen.otherDocs.ck2.thTglProduksi': 'Production Date',
  'lumen.otherDocs.ck2.thUraian': 'Description',
  'lumen.otherDocs.ck2.tipDelete': 'Delete draft',
  'lumen.otherDocs.ck2.tipDetail': 'View details',
  'lumen.otherDocs.ck2.tipHistory': 'Change history',
  'lumen.otherDocs.ck2.tipPostStock': 'Post production stock (finished goods in, raw materials out)',
  'lumen.otherDocs.ck2.tipPullStatus': 'Pull status from Customs',
  'lumen.otherDocs.ck2.tipSend': 'Send to Customs',
  'lumen.otherDocs.ck2.title': 'Excise Documents',
  'lumen.otherDocs.ck2.toastDeleted': 'Deleted',
  'lumen.otherDocs.ck2.toastDeletedMsg': 'Document deleted.',
  'lumen.otherDocs.ck2.toastDeleteFail': 'Failed to delete',
  'lumen.otherDocs.ck2.toastLoadDocFail': 'Failed to load document',
  'lumen.otherDocs.ck2.toastLoadHistoryFail': 'Failed to load history',
  'lumen.otherDocs.ck2.toastPosted': 'Production stock posted',
  'lumen.otherDocs.ck2.toastPostedMsg': '{n} movements (finished goods in + raw materials out){skipped}.',
  'lumen.otherDocs.ck2.toastPostFail': 'Failed to post stock',
  'lumen.otherDocs.ck2.toastSent': 'Sent',
  'lumen.otherDocs.ck2.toastSentMsg': '{docType} sent to Customs. Submission No.: {nomorAju}',
  'lumen.otherDocs.ck2.toastStatusDone': 'Status updated',
  'lumen.otherDocs.ck2.toastStatusDoneMsg': 'Status of {docType} ({nomorAju}) pulled from Customs.',
  'lumen.otherDocs.ck2.toastStatusFail': 'Failed to pull status',
  'lumen.otherDocs.ck2.toastSubmitFail': 'Sending failed',
  'lumen.otherDocs.ck2.totBatang': 'Total Sticks',
  'lumen.otherDocs.ck2.totBayar': 'Total Payable',
  'lumen.otherDocs.ck2.totCukai': 'Total Excise',
  'lumen.otherDocs.ck2.totGram': 'Total Grams',
  'lumen.otherDocs.ck2.totLiter': 'Total Liters',
  'lumen.otherDocs.ck2.totNilaiCukai': 'Total Excise Value',
  'lumen.otherDocs.ck2.totPpn': 'Total VAT (9.9%)',
  'lumen.otherDocs.ck4.alertStokAwalPost':
    'after the item is created — not entered directly — so the stock card stays consistent.',
  'lumen.otherDocs.ck4.alertStokAwalPre': 'Opening stock is booked with the',
  'lumen.otherDocs.ck4.alertStokKeluar': 'Stock out is rejected automatically if it exceeds the available balance.',
  'lumen.otherDocs.ck4.allTypes': 'All types',
  'lumen.otherDocs.ck4.btnBukukan': 'Post',
  'lumen.otherDocs.ck4.btnBukukanPenyesuaian': 'Post Adjustment',
  'lumen.otherDocs.ck4.btnHapus': 'Delete',
  'lumen.otherDocs.ck4.btnItemBaru': 'New Item',
  'lumen.otherDocs.ck4.btnSimpanItem': 'Save Item',
  'lumen.otherDocs.ck4.btnSimpanPerubahan': 'Save Changes',
  'lumen.otherDocs.ck4.btnStockOpname': 'Stock Opname',
  'lumen.otherDocs.ck4.btnStokKeluar': 'Stock Out',
  'lumen.otherDocs.ck4.btnStokMasuk': 'Stock In',
  'lumen.otherDocs.ck4.btnStokMenipis': 'Low Stock',
  'lumen.otherDocs.ck4.btnTambahBaris': 'Add Row',
  'lumen.otherDocs.ck4.colAksi': 'Actions',
  'lumen.otherDocs.ck4.colArah': 'Direction',
  'lumen.otherDocs.ck4.colItem': 'Item',
  'lumen.otherDocs.ck4.colJenisMutasi': 'Movement Type',
  'lumen.otherDocs.ck4.colJumlah': 'Quantity',
  'lumen.otherDocs.ck4.colLokasi': 'Location',
  'lumen.otherDocs.ck4.colMinStok': 'Min. Stock',
  'lumen.otherDocs.ck4.colReferensi': 'Reference',
  'lumen.otherDocs.ck4.colSaldoAkhir': 'Ending Balance',
  'lumen.otherDocs.ck4.colStokSaatIni': 'Current Stock',
  'lumen.otherDocs.ck4.colTanggal': 'Date',
  'lumen.otherDocs.ck4.colTipe': 'Type',
  'lumen.otherDocs.ck4.delBodyPost': '? Its movement history is kept.',
  'lumen.otherDocs.ck4.delBodyPre': 'Are you sure you want to delete item',
  'lumen.otherDocs.ck4.deleteRowAria': 'Delete row',
  'lumen.otherDocs.ck4.dirKeluar': 'Out',
  'lumen.otherDocs.ck4.dirMasuk': 'In',
  'lumen.otherDocs.ck4.emptyItemsDesc': 'Create a raw material / finished goods item, then post your first stock in.',
  'lumen.otherDocs.ck4.emptyItemsTitle': 'No inventory items yet',
  'lumen.otherDocs.ck4.emptyMovementsTitle': 'No stock movements yet',
  'lumen.otherDocs.ck4.hintPerluPengadaan': 'Needs procurement',
  'lumen.otherDocs.ck4.hintSemuaAman': 'All safe',
  'lumen.otherDocs.ck4.hintStokTercatat': 'Recorded stock now:',
  'lumen.otherDocs.ck4.itemOptionFmt': '{kode} — {nama} (stock: {qty} {satuan})',
  'lumen.otherDocs.ck4.lblBarisItem': 'Item Rows',
  'lumen.otherDocs.ck4.lblHasilHitung': 'Physical Count Result',
  'lumen.otherDocs.ck4.lblItem': 'Item',
  'lumen.otherDocs.ck4.lblJenisMutasi': 'Movement Type',
  'lumen.otherDocs.ck4.lblJumlah': 'Quantity',
  'lumen.otherDocs.ck4.lblKeterangan': 'Notes',
  'lumen.otherDocs.ck4.lblKodeItem': 'Item Code',
  'lumen.otherDocs.ck4.lblLokasi': 'Warehouse Location',
  'lumen.otherDocs.ck4.lblMerk': 'Brand (finished goods)',
  'lumen.otherDocs.ck4.lblNamaItem': 'Item Name',
  'lumen.otherDocs.ck4.lblReferensi': 'Reference (PO no. / document)',
  'lumen.otherDocs.ck4.lblSatuan': 'Unit',
  'lumen.otherDocs.ck4.lblStokMinimum': 'Minimum Stock (alert)',
  'lumen.otherDocs.ck4.lblTanggal': 'Date',
  'lumen.otherDocs.ck4.lblTipeItem': 'Item Type',
  'lumen.otherDocs.ck4.merkFmt': 'Brand {merk}',
  'lumen.otherDocs.ck4.mvHasilProduksi': 'Production Output',
  'lumen.otherDocs.ck4.mvOpnameMinus': 'Opname (−)',
  'lumen.otherDocs.ck4.mvOpnamePlus': 'Opname (+)',
  'lumen.otherDocs.ck4.mvPemakaianProduksi': 'Production Usage',
  'lumen.otherDocs.ck4.mvPenerimaan': 'Receipt',
  'lumen.otherDocs.ck4.mvPengiriman': 'Delivery',
  'lumen.otherDocs.ck4.mvReturMasuk': 'Return In',
  'lumen.otherDocs.ck4.optHasilProduksi': 'Production output',
  'lumen.otherDocs.ck4.optPemakaianProduksi': 'Production usage',
  'lumen.otherDocs.ck4.optPenerimaan': 'Receipt (purchase)',
  'lumen.otherDocs.ck4.optPengiriman': 'Delivery',
  'lumen.otherDocs.ck4.optReturMasuk': 'Return in',
  'lumen.otherDocs.ck4.phAlasan': 'Reason for adjustment',
  'lumen.otherDocs.ck4.phPilihItem': 'Select item',
  'lumen.otherDocs.ck4.satuanPlaceholder': 'Kg / Stick / Liter / Sheet',
  'lumen.otherDocs.ck4.searchPlaceholder': 'Search code, name, brand...',
  'lumen.otherDocs.ck4.statKeluarHariIni': 'Stock Out Today',
  'lumen.otherDocs.ck4.statMasukHariIni': 'Stock In Today',
  'lumen.otherDocs.ck4.statSaldoSaatIni': 'Current Balance',
  'lumen.otherDocs.ck4.statStokMenipis': 'Low Stock',
  'lumen.otherDocs.ck4.statTotalItem': 'Total Items',
  'lumen.otherDocs.ck4.statTotalKeluar': 'Total Out',
  'lumen.otherDocs.ck4.statTotalMasuk': 'Total In',
  'lumen.otherDocs.ck4.subtitle':
    'Stock cards for raw materials, finished goods and excise bands — movements are recorded automatically from delivery notes & CK-4',
  'lumen.otherDocs.ck4.tabItemStok': 'Items & Stock',
  'lumen.otherDocs.ck4.tabRiwayat': 'Movement History',
  'lumen.otherDocs.ck4.tAdjustFailed': 'Adjustment failed',
  'lumen.otherDocs.ck4.tAdjustPosted': 'Adjustment posted',
  'lumen.otherDocs.ck4.tCardFailed': 'Failed to load stock card',
  'lumen.otherDocs.ck4.tDeletedTitle': 'Deleted',
  'lumen.otherDocs.ck4.tDeleteFailed': 'Failed to delete',
  'lumen.otherDocs.ck4.tEmptyLinesMsg': 'Select an item and fill in a quantity for at least one row.',
  'lumen.otherDocs.ck4.tEmptyLinesTitle': 'Empty rows',
  'lumen.otherDocs.ck4.thJenis': 'Type',
  'lumen.otherDocs.ck4.thKeluar': 'Out',
  'lumen.otherDocs.ck4.thMasuk': 'In',
  'lumen.otherDocs.ck4.thSaldo': 'Balance',
  'lumen.otherDocs.ck4.tIncompleteMsg': 'Item code, name and unit are required.',
  'lumen.otherDocs.ck4.tIncompleteTitle': 'Incomplete data',
  'lumen.otherDocs.ck4.tipEdit': 'Edit',
  'lumen.otherDocs.ck4.tipHapus': 'Delete',
  'lumen.otherDocs.ck4.tipKartuStok': 'Stock card',
  'lumen.otherDocs.ck4.tipLowStock': 'Below minimum stock ({min})',
  'lumen.otherDocs.ck4.tipStokKeluar': 'Stock out',
  'lumen.otherDocs.ck4.tipStokMasuk': 'Stock in',
  'lumen.otherDocs.ck4.tItemCreated': 'Item created.',
  'lumen.otherDocs.ck4.tItemDeleted': 'Item deleted.',
  'lumen.otherDocs.ck4.tItemUpdated': 'Item updated.',
  'lumen.otherDocs.ck4.title': 'BKC Inventory',
  'lumen.otherDocs.ck4.titleBukukanKeluar': 'Post Stock Out',
  'lumen.otherDocs.ck4.titleBukukanMasuk': 'Post Stock In',
  'lumen.otherDocs.ck4.titleEditItem': 'Edit Item — {kode}',
  'lumen.otherDocs.ck4.titleHapusItem': 'Delete Item',
  'lumen.otherDocs.ck4.titleKartuStok': 'Stock Card — {kode} ({nama})',
  'lumen.otherDocs.ck4.titleMemuatKartu': 'Loading stock card...',
  'lumen.otherDocs.ck4.titleNewItem': 'New Inventory Item',
  'lumen.otherDocs.ck4.titleOpname': 'Stock Opname (Adjustment)',
  'lumen.otherDocs.ck4.tNewBalance': 'New balance: {saldo}.',
  'lumen.otherDocs.ck4.tPickItemMsg': 'An item must be selected.',
  'lumen.otherDocs.ck4.tPickItemTitle': 'Select item',
  'lumen.otherDocs.ck4.tPostedCount': '{n} movements recorded.',
  'lumen.otherDocs.ck4.tPostedIn': 'Stock in posted',
  'lumen.otherDocs.ck4.tPostedOut': 'Stock out posted',
  'lumen.otherDocs.ck4.tPostFailed': 'Failed to post',
  'lumen.otherDocs.ck4.tSavedTitle': 'Saved',
  'lumen.otherDocs.ck4.tSaveFailed': 'Failed to save',
  'lumen.otherDocs.ck4.typeBahanBaku': 'Raw material',
  'lumen.otherDocs.ck4.typeBarangJadi': 'Finished goods (BKC)',
  'lumen.otherDocs.ck4.typePitaCukai': 'Excise band',
  'lumen.otherDocs.rp1.home': 'Home',
  'lumen.otherDocs.rp1.report': 'Report',
  'lumen.otherDocs.rp1.title20': 'BC 2.0 Report',
  'lumen.otherDocs.rp1.title30': 'BC 3.0 Report',
  'lumen.otherDocs.rp1.title57': 'BC 5.7 Report',
  'lumen.otherDocs.rp1.filterByNpwp': 'Filter by NPWP Customer',
  'lumen.otherDocs.rp1.npwpCustomer': 'NPWP Customer',
  'lumen.otherDocs.rp1.npwpCustomerPlaceholder': 'Enter NPWP Customer',
  'lumen.otherDocs.rp1.npwp': 'NPWP',
  'lumen.otherDocs.rp1.npwpPlaceholder': 'Enter NPWP',
  'lumen.otherDocs.rp1.startDate': 'Start Date',
  'lumen.otherDocs.rp1.startDatePlaceholder': 'Select start date',
  'lumen.otherDocs.rp1.endDate': 'End Date',
  'lumen.otherDocs.rp1.endDatePlaceholder': 'Select end date',
  'lumen.otherDocs.rp1.generateReport': 'Generate Report',
  'lumen.otherDocs.rp1.errorTitle': 'Error',
  'lumen.otherDocs.rp1.successTitle': 'Success',
  'lumen.otherDocs.rp1.generateFailed': 'Failed to generate report',
  'lumen.otherDocs.rp1.generated': 'Report generated successfully',
  'lumen.otherDocs.rp1.connectFailed': 'Failed to connect to server',
  'lumen.otherDocs.pz1.processIdMissing': 'The processId parameter was not found. Create the FTZ document manually.',
  'lumen.otherDocs.pz1.buatManual': 'Create Manually',
  'lumen.otherDocs.pz1.errorTitle': 'Failed to create the PPFTZ draft',
  'lumen.otherDocs.pz1.cobaLagi': 'Try again',
  'lumen.otherDocs.pz1.keDaftar': 'Go to PPFTZ list',
  'lumen.otherDocs.pz1.menyusunTitle': 'Building the PPFTZ draft from the extraction…',
  'lumen.otherDocs.pz1.menyusunBody': 'Invoice / Packing List / B/L data is being mapped to FTZ document 511',
  'lumen.otherDocs.pz1.createFailed': 'Failed to create the PPFTZ draft from the extraction',
  'lumen.otherDocs.pz1.terhapus': 'Deleted',
  'lumen.otherDocs.pz1.draftDihapus': 'PPFTZ draft deleted successfully',
  'lumen.otherDocs.pz1.gagalMenghapus': 'Failed to delete',
  'lumen.otherDocs.pz1.gagalMenghapusDraft': 'Failed to delete the PPFTZ draft',
  'lumen.otherDocs.pz1.colNomorAju': 'AJU number',
  'lumen.otherDocs.pz1.colFamily': 'Family',
  'lumen.otherDocs.pz1.colKodeDokumen': 'Document code',
  'lumen.otherDocs.pz1.colArah': 'Direction',
  'lumen.otherDocs.pz1.colStatus': 'Status',
  'lumen.otherDocs.pz1.colKodeKantor': 'Office code',
  'lumen.otherDocs.pz1.colDiperbarui': 'Updated',
  'lumen.otherDocs.pz1.colAksi': 'Actions',
  'lumen.otherDocs.pz1.buka': 'Open',
  'lumen.otherDocs.pz1.hapusDraft': 'Delete draft',
  'lumen.otherDocs.pz1.hapus': 'Delete',
  'lumen.otherDocs.pz1.title': 'PPFTZ / FTZ Documents',
  'lumen.otherDocs.pz1.subtitle': 'Drafts and Host-to-Host submission of CEISA FTZ documents (511–531)',
  'lumen.otherDocs.pz1.buatDokumen': 'Create FTZ Document',
  'lumen.otherDocs.pz1.phFamily': 'Family',
  'lumen.otherDocs.pz1.phKodeDokumen': 'Document code',
  'lumen.otherDocs.pz1.phStatus': 'Status',
  'lumen.otherDocs.pz1.loadFailed': 'Failed to load the PPFTZ document list',
  'lumen.otherDocs.pz1.belumAda': 'No PPFTZ documents yet',
  'lumen.otherDocs.pz1.confirmHapus': 'Delete PPFTZ draft {nomor}?',
  'lumen.otherDocs.pz2.tidakAdaPilihan': 'No options',
  'lumen.otherDocs.pz2.nomorAjuInvalid':
    'The AJU number must be empty or exactly {length} digits (currently {count} characters)',
  'lumen.otherDocs.pz2.kodeKantorWajib': 'Office code is required',
  'lumen.otherDocs.pz2.validasiGagal': 'Validation failed',
  'lumen.otherDocs.pz2.periksaHeader': 'Check the highlighted header fields again',
  'lumen.otherDocs.pz2.tersimpan': 'Saved',
  'lumen.otherDocs.pz2.headerTersimpan': 'Header saved successfully',
  'lumen.otherDocs.pz2.header': 'Header',
  'lumen.otherDocs.pz2.simpanHeader': 'Save Header',
  'lumen.otherDocs.pz2.belumDisimpan': 'There are unsaved header changes.',
  'lumen.otherDocs.pz2.pilihKantorDulu':
    'Select or enter the office code first so the AJU number suggestion is accurate',
  'lumen.otherDocs.pz2.gagalSarankan':
    "Failed to suggest an AJU number. Make sure the tenant's CEISA account is linked, or enter the AJU number manually.",
  'lumen.otherDocs.pz2.familyTidakCocok': 'Family and document code do not match',
  'lumen.otherDocs.pz2.familyTidakCocokDesc':
    'Family {family} does not match document code {kodeDokumen}. Go back to the Document step and choose again.',
  'lumen.otherDocs.pz2.ajuTidakValid': 'Invalid AJU number',
  'lumen.otherDocs.pz2.ajuTidakValidDesc':
    'The AJU number must be empty (the server will suggest one) or exactly {length} digits (currently {count} characters)',
  'lumen.otherDocs.pz2.draftDibuat': 'Draft created',
  'lumen.otherDocs.pz2.draftDibuatDesc': 'PPFTZ draft {nomorAju} created successfully',
  'lumen.otherDocs.pz2.gagalMembuatDraft': 'Failed to create draft',
  'lumen.otherDocs.pz2.gagalMembuatDraftFallback': 'Failed to create the PPFTZ draft',
  'lumen.otherDocs.pz2.gagalMemuatKatalog': 'Failed to load the PPFTZ document catalog',
  'lumen.otherDocs.pz2.cobaLagi': 'Try again',
  'lumen.otherDocs.pz2.stepFamily': 'Family',
  'lumen.otherDocs.pz2.stepFamilyHint': 'Zone type',
  'lumen.otherDocs.pz2.stepDokumen': 'Document',
  'lumen.otherDocs.pz2.stepDokumenHint': 'Document code',
  'lumen.otherDocs.pz2.stepKantor': 'Office',
  'lumen.otherDocs.pz2.stepKantorHint': 'Customs office code',
  'lumen.otherDocs.pz2.stepNomorAju': 'AJU Number',
  'lumen.otherDocs.pz2.stepNomorAjuHint': 'Confirm & create',
  'lumen.otherDocs.pz2.pilihJenisKawasan': 'Choose the zone type',
  'lumen.otherDocs.pz2.familyMenentukan': 'Each family determines the available document types.',
  'lumen.otherDocs.pz2.countDokumen': '{count} Documents',
  'lumen.otherDocs.pz2.pilihKodeDokumen': 'Choose the document code',
  'lumen.otherDocs.pz2.kodeMenentukan': 'The code determines the direction and type of customs activity.',
  'lumen.otherDocs.pz2.tidakAdaDokumen': 'There are no documents for this family.',
  'lumen.otherDocs.pz2.pilihKantorPabean': 'Choose the customs office',
  'lumen.otherDocs.pz2.kantorPemrosesan': 'The office that processes the document according to the activity location.',
  'lumen.otherDocs.pz2.daftarKantorKosong':
    'The reference office list is not available — enter the office code manually below.',
  'lumen.otherDocs.pz2.kodeKantorLain': 'Other office code',
  'lumen.otherDocs.pz2.masukkanManual': 'Enter the customs office code manually',
  'lumen.otherDocs.pz2.kodeKantor': 'Office Code',
  'lumen.otherDocs.pz2.kodeKantorPlaceholder': 'e.g. 020400',
  'lumen.otherDocs.pz2.ringkasan': 'Summary',
  'lumen.otherDocs.pz2.ajuHint':
    '{length} digits from the server (positions 7–12 = CEISA company code). You may change or clear it — the backend will suggest one at submit if empty.',
  'lumen.otherDocs.pz2.saranGagal': 'AJU number suggestion failed',
  'lumen.otherDocs.pz2.ajuDiperbarui': 'AJU number updated',
  'lumen.otherDocs.pz2.saranDimuat': 'The server suggestion was loaded',
  'lumen.otherDocs.pz2.cobaSaranLagi': 'Retry suggestion',
  'lumen.otherDocs.pz2.ajuEksternalPlaceholder': 'Enter an external AJU number, or leave it empty',
  'lumen.otherDocs.pz2.draftDapatDiedit': 'The draft can be edited before it is sent to the CEISA system.',
  'lumen.otherDocs.pz2.buatDokumenFtz': 'Create FTZ Document',
  'lumen.otherDocs.pz2.ikutiLangkah': 'Follow 4 steps to create a free-zone customs document.',
  'lumen.otherDocs.pz2.kembaliKeDaftar': 'Back to list',
  'lumen.otherDocs.pz2.langkahDari': 'Step {step} of 4',
  'lumen.otherDocs.pz2.kembali': 'Back',
  'lumen.otherDocs.pz2.buatDraft': 'Create Draft',
  'lumen.otherDocs.pz2.sarankanAju': 'Suggest AJU',
  'lumen.otherDocs.pz2.lanjut': 'Next',
  'lumen.otherDocs.pz3.gagalMemuatPayload': 'Failed to load the CEISA payload',
  'lumen.otherDocs.pz3.previewPayloadCeisa': 'CEISA Payload Preview',
  'lumen.otherDocs.pz3.memuat': 'Loading...',
  'lumen.otherDocs.pz3.gagalMemuatRiwayat': 'Failed to load the status history',
  'lumen.otherDocs.pz3.riwayatStatus': 'Status History',
  'lumen.otherDocs.pz3.belumAdaRiwayat': 'No history yet',
  'lumen.otherDocs.pz3.waktu': 'Time',
  'lumen.otherDocs.pz3.aksi': 'Action',
  'lumen.otherDocs.pz3.status': 'Status',
  'lumen.otherDocs.pz3.keterangan': 'Notes',
  'lumen.otherDocs.pz3.selengkapnya': 'Show more',
  'lumen.otherDocs.pz3.sembunyikan': 'Hide',
  'lumen.otherDocs.pz3.wajibDiisi': '{label} is required',
  'lumen.otherDocs.pz3.harusArrayJson': '{label} must be a valid JSON array',
  'lumen.otherDocs.pz3.tersimpan': 'Saved',
  'lumen.otherDocs.pz3.dataBerhasilDisimpan': '{label} data saved successfully',
  'lumen.otherDocs.pz3.tambahLabel': 'Add {label}',
  'lumen.otherDocs.pz3.simpanLabel': 'Save {label}',
  'lumen.otherDocs.pz3.ubahLabel': 'Edit {label}',
  'lumen.otherDocs.pz3.adaPerubahan': 'There are unsaved {label} changes.',
  'lumen.otherDocs.pz3.belumAdaData': 'No {label} data yet',
  'lumen.otherDocs.pz3.tambah': 'Add',
  'lumen.otherDocs.pz3.ubahBaris': 'Edit row',
  'lumen.otherDocs.pz3.hapusBaris': 'Delete row',
  'lumen.otherDocs.pz3.tidakAdaYangDiisi': 'Nothing to fill',
  'lumen.otherDocs.pz3.semuaBarangSudahTarif': 'All items already have a BM tariff',
  'lumen.otherDocs.pz3.tarifTidakDitemukan': 'Tariff not found',
  'lumen.otherDocs.pz3.tarifHsTidakDitemukan': 'HS tariff not found for item series {seri}',
  'lumen.otherDocs.pz3.tarifBmTerisi': 'BM tariff filled',
  'lumen.otherDocs.pz3.barangDiisiTarifBm': '{filled} items filled with a BM tariff from the HS master',
  'lumen.otherDocs.pz3.seriTidakDitemukan': '; series {seri} not found',
  'lumen.otherDocs.pz3.gagalMengisiTarif': 'Failed to fill tariffs',
  'lumen.otherDocs.pz3.gagalMengambilTarif': 'Failed to fetch tariffs from the HS master',
  'lumen.otherDocs.pz3.nilaiPabean': 'Customs Value',
  'lumen.otherDocs.pz3.totalBm': 'Total BM',
  'lumen.otherDocs.pz3.nilaiImpor': 'Import Value',
  'lumen.otherDocs.pz3.estimasiPpn': 'Estimated VAT {rate}%',
  'lumen.otherDocs.pz3.estimasiPph': 'Estimated income tax {rate}%',
  'lumen.otherDocs.pz3.pungutan': 'Levies',
  'lumen.otherDocs.pz3.isiTarifBm': 'Fill BM Tariffs from HS Master',
  'lumen.otherDocs.pz3.dokumen513Wajib':
    'Document 513 must declare a BM tariff per item. Item series {seri} has no tariff yet.',
  'lumen.otherDocs.pz3.seri': 'Series',
  'lumen.otherDocs.pz3.posTarif': 'Tariff Heading',
  'lumen.otherDocs.pz3.uraian': 'Description',
  'lumen.otherDocs.pz3.bm': 'BM',
  'lumen.otherDocs.pz3.statusTarif': 'Tariff Status',
  'lumen.otherDocs.pz3.belumAdaBarang': 'No items yet',
  'lumen.otherDocs.pz3.ada': 'Yes',
  'lumen.otherDocs.pz3.belum': 'Not yet',
  'lumen.otherDocs.pz3.ppnPphEstimasi':
    'VAT and income tax are estimates ({ppn}% and {pph}% for API importers) and are billed after CEISA accepts the document. The BM payment value can be adjusted per item in the Barang tab.',
  'lumen.otherDocs.pz3.tarifBmBarangTarif': 'BM tariff (barangTarif)',
  'lumen.otherDocs.pz3.nilaiPabeanLabel': 'Customs value: {nilai}',
  'lumen.otherDocs.pz3.belumAdaTarif':
    'No tariffs yet. For document 513 (outbound to TLDDP), every item must have a BM tariff.',
  'lumen.otherDocs.pz3.jenisTarif': 'Tariff Type',
  'lumen.otherDocs.pz3.tarif': 'Tariff',
  'lumen.otherDocs.pz3.tarifFasilitas': 'Facility Tariff',
  'lumen.otherDocs.pz3.kodeFasilitas': 'Facility Code',
  'lumen.otherDocs.pz3.jumlahSatuan': 'Unit Quantity',
  'lumen.otherDocs.pz3.satuan': 'Unit',
  'lumen.otherDocs.pz3.nilaiBayarBm': 'Payment Value (BM)',
  'lumen.otherDocs.pz3.hapusTarif': 'Delete tariff',
  'lumen.otherDocs.pz3.gagalMenyimpanHeader': 'Failed to save the header',
  'lumen.otherDocs.pz3.gagalMenyimpanHeaderPpftz': 'Failed to save the PPFTZ header',
  'lumen.otherDocs.pz3.gagalMenyimpanSection': 'Failed to save {section}',
  'lumen.otherDocs.pz3.gagalMenyimpanDataSection': 'Failed to save {section} data',
  'lumen.otherDocs.pz3.cekCeisaStatus': 'CEISA check: {status}',
  'lumen.otherDocs.pz3.lihatPanelPesan': 'See the message panel for details',
  'lumen.otherDocs.pz3.gagalCekDokumen': 'Failed to check the document with CEISA',
  'lumen.otherDocs.pz3.skemaCeisaTidakValid': 'Invalid CEISA schema',
  'lumen.otherDocs.pz3.cekCeisaGagal': 'CEISA check failed',
  'lumen.otherDocs.pz3.kirimCeisaStatus': 'CEISA submit: {status}',
  'lumen.otherDocs.pz3.idHeaderValue': 'idHeader: {idHeader}',
  'lumen.otherDocs.pz3.dokumenDikirim': 'Document sent to CEISA',
  'lumen.otherDocs.pz3.draftTerkirim': 'CEISA draft sent. The draft form can be printed after the status is refreshed',
  'lumen.otherDocs.pz3.kirimCeisaGagal': 'CEISA submit failed',
  'lumen.otherDocs.pz3.gagalMengirimDokumen': 'Failed to send the document to CEISA',
  'lumen.otherDocs.pz3.gagalMemuatFormulir': 'Failed to load the {type} form',
  'lumen.otherDocs.pz3.formulirBelumTersedia': 'The form is not yet available in CEISA for this document',
  'lumen.otherDocs.pz3.statusCeisa': 'CEISA Status',
  'lumen.otherDocs.pz3.nomorAjuStatus': '{nomorAju}: {status}',
  'lumen.otherDocs.pz3.idHeaderParen': '(idHeader {idHeader})',
  'lumen.otherDocs.pz3.gagalMemuatStatus': 'Failed to load the status',
  'lumen.otherDocs.pz3.gagalMemuatStatusCeisa': 'Failed to load the status from CEISA',
  'lumen.otherDocs.pz3.gagalMemuatDokumen': 'Failed to load the PPFTZ document',
  'lumen.otherDocs.pz3.cobaLagi': 'Try again',
  'lumen.otherDocs.pz3.kembaliKeDaftar': 'Back to list',
  'lumen.otherDocs.pz3.draftId': 'Draft #{id}',
  'lumen.otherDocs.pz3.dokumenFtz': 'FTZ Document',
  'lumen.otherDocs.pz3.idHeaderBullet': '• idHeader: {idHeader}',
  'lumen.otherDocs.pz3.cekCeisa': 'Check CEISA',
  'lumen.otherDocs.pz3.kirim': 'Submit',
  'lumen.otherDocs.pz3.refreshStatus': 'Refresh Status',
  'lumen.otherDocs.pz3.cetakDraft': 'Print Draft',
  'lumen.otherDocs.pz3.cetakFormulir': 'Print Form',
  'lumen.otherDocs.pz3.previewPayload': 'Preview Payload',
  'lumen.otherDocs.pz3.history': 'History',
  'lumen.otherDocs.pz3.dokumenBerstatus': 'The document has status {status} and can no longer be changed.',
  'lumen.otherDocs.pz3.pesanCeisaTerakhir': 'Latest CEISA message',
  'lumen.otherDocs.pz3.header': 'Header',
  'lumen.otherDocs.pz3.perubahanBelumDisimpan': 'Unsaved changes',
  'lumen.otherDocs.pz3.adaPerubahanTab':
    'There are unsaved changes on this tab. Switching tabs will discard them. Continue?',
  'lumen.otherDocs.pz3.lanjutkan': 'Continue',
  'lumen.otherDocs.pz3.kirimKeCeisa': 'Submit to CEISA',
  'lumen.otherDocs.pz3.cekTerakhirBerstatus':
    'The last check had status {status}. Fix the document first, or submit if you are sure.',
  'lumen.otherDocs.pz3.dokumen513WajibKirim':
    'Document 513 must declare a BM tariff per item. Item series {seri} has no tariff yet. Complete it in the Pungutan or Barang tab before submitting.',
  'lumen.otherDocs.pz3.pengajuanFinal': 'Final filing',
  'lumen.otherDocs.pz3.nonaktifkanDraft': 'Turn off to send as a CEISA draft first',
  'lumen.otherDocs.pz3.revisiAtasAju': 'Revision of an already submitted filing',
  'lumen.otherDocs.pz3.centangHanyaKoreksi': 'Check only to correct a previously submitted document',
  'lumen.otherDocs.pz3.setiapPengiriman':
    'Each submission uses 1 CEISA submission credit. The credit is refunded automatically if CEISA rejects it.',
  'lumen.otherDocs.pz3.kirimSekarang': 'Submit Now',
  'lumen.otherDocs.pz3.kirimFinal': 'Submit Final',
  'lumen.otherDocs.pz3.kirimDraft': 'Submit Draft',
  'lumen.otherDocs.ck5.title': 'Excise Module Guide',
  'lumen.otherDocs.ck5.subtitle':
    'From delivery note to Customs reporting — understand each menu in a few minutes. First time here? Follow along from top to bottom.',
  'lumen.otherDocs.ck5.learnProgress': 'Learning progress',
  'lumen.otherDocs.ck5.railCount': '{current}/{total} sections',
  'lumen.otherDocs.ck5.secAlur': 'Full flow',
  'lumen.otherDocs.ck5.secInventori': 'Inventory',
  'lumen.otherDocs.ck5.secBom': 'Bill of Material',
  'lumen.otherDocs.ck5.secSuratJalan': 'Delivery Note',
  'lumen.otherDocs.ck5.secDokumen': 'CK Documents',
  'lumen.otherDocs.ck5.secStok': 'Stock Posting',
  'lumen.otherDocs.ck5.secRisk': 'Risk Self-Check',
  'lumen.otherDocs.ck5.secMulai': 'Start here',
  'lumen.otherDocs.ck5.flowInventori': 'Inventory',
  'lumen.otherDocs.ck5.flowBom': 'BOM',
  'lumen.otherDocs.ck5.flowStokMasuk': 'Stock In',
  'lumen.otherDocs.ck5.flowSuratJalan': 'Delivery Note',
  'lumen.otherDocs.ck5.flowDokumenCk': 'CK Documents',
  'lumen.otherDocs.ck5.flowSubmit': 'Submit',
  'lumen.otherDocs.ck5.flowPostingStok': 'Stock Posting',
  'lumen.otherDocs.ck5.flowRiskCheck': 'Risk Check',
  'lumen.otherDocs.ck5.flowTitle': 'Full flow: one journey, eight steps',
  'lumen.otherDocs.ck5.scrollHint': 'Scroll to begin',
  'lumen.otherDocs.ck5.menuLabel': 'Menu {n}',
  'lumen.otherDocs.ck5.whenToUse': 'When to use it',
  'lumen.otherDocs.ck5.stepsHeading': 'Steps',
  'lumen.otherDocs.ck5.tipLabel': 'Tip:',
  'lumen.otherDocs.ck5.openMenu': 'Open {name}',
  'lumen.otherDocs.ck5.s1Title': 'Register Inventory items',
  'lumen.otherDocs.ck5.s1Desc':
    'Create items for raw materials, finished goods (excise goods), and excise bands. These become the stock cards that every feature reads automatically.',
  'lumen.otherDocs.ck5.s2Title': 'Build the BOM (production recipe)',
  'lumen.otherDocs.ck5.s2Desc':
    'Create a recipe per product: which raw materials a finished good needs and how much. Link outputs and components to inventory.',
  'lumen.otherDocs.ck5.s3Title': 'Record raw material stock in',
  'lumen.otherDocs.ck5.s3Desc':
    'Record raw material receipts as stock in so the warehouse has the right opening balance.',
  'lumen.otherDocs.ck5.s4Title': 'Create a Delivery Note',
  'lumen.otherDocs.ck5.s4Desc':
    'Fill in the sender, recipient, transport, and goods list. This is the source document for every CK document.',
  'lumen.otherDocs.ck5.s5Title': 'Generate CK documents',
  'lumen.otherDocs.ck5.s5Desc':
    'From the delivery note, issue CK-5 (mutation), CK-4 (production), or CK-1 (band order).',
  'lumen.otherDocs.ck5.s6Title': 'Edit, then Submit to Customs',
  'lumen.otherDocs.ck5.s6Desc':
    'Review and complete the document, send it host-to-host, and track the status until ACCEPTED.',
  'lumen.otherDocs.ck5.s7Title': 'Post stock',
  'lumen.otherDocs.ck5.s7Desc':
    'A final delivery note issues finished goods; CK-4 adds production and deducts raw materials per the BOM.',
  'lumen.otherDocs.ck5.s8Title': 'Monitor Risk Self-Check',
  'lumen.otherDocs.ck5.s8Desc': 'Review the 7 indicators and fix red flags before Customs finds them.',
  'lumen.otherDocs.ck5.mInvTitle': 'Inventory — stock cards',
  'lumen.otherDocs.ck5.mInvApa':
    'Your stock cards in three types: raw materials (yellow), finished goods/excise goods (green), and excise bands (purple). Here you record stock in, stock out, and stock opname — plus low-stock alerts.',
  'lumen.otherDocs.ck5.mInvKapan':
    'The very first step, before the BOM and delivery notes. Record stock in whenever you receive raw materials/bands, and run an opname when adjusting the physical balance.',
  'lumen.otherDocs.ck5.mInvL1': 'Click "Tambah Item", choose the type (BAHAN_BAKU / BARANG_JADI / PITA_CUKAI).',
  'lumen.otherDocs.ck5.mInvL2': 'Fill in the name, unit, and minimum stock threshold to trigger alerts.',
  'lumen.otherDocs.ck5.mInvL3': 'Record "Stok Masuk" when you receive raw materials or excise bands.',
  'lumen.otherDocs.ck5.mInvL4': 'Let delivery notes and CK-4 post mutations automatically.',
  'lumen.otherDocs.ck5.mInvL5': 'Run "Stock Opname" when the system balance differs from the physical count.',
  'lumen.otherDocs.ck5.mInvTip':
    'Every item not linked to a document breaks automatic reconciliation. Synchronised stock cards are the foundation of a healthy risk score.',
  'lumen.otherDocs.ck5.mBomTitle': 'Bill of Material — production recipe',
  'lumen.otherDocs.ck5.mBomApa':
    'Your production recipe: for each product/brand, the BOM lists which raw materials and in what quantities. Because it is linked to inventory, CK-4 can "explode" this recipe to automatically deduct raw material stock according to the production quantity.',
  'lumen.otherDocs.ck5.mBomKapan':
    'Once at the start for each product, updated when the composition changes. It must exist before CK-4 can calculate material usage automatically.',
  'lumen.otherDocs.ck5.mBomL1': 'Click "Buat BOM", choose the finished-goods product/brand as the output.',
  'lumen.otherDocs.ck5.mBomL2': 'Link the output to an inventory item of type BARANG_JADI.',
  'lumen.otherDocs.ck5.mBomL3': 'Add the raw material components + usage quantity per unit.',
  'lumen.otherDocs.ck5.mBomL4': 'Link each component to a BAHAN_BAKU inventory item.',
  'lumen.otherDocs.ck5.mBomL5': 'Save — CK-4 now uses it for automatic material consumption.',
  'lumen.otherDocs.ck5.mBomTip':
    'BOM quantity accuracy matters: if it is off, the "Pemakaian Bahan vs BOM" indicator in Risk Self-Check shows a large variance that reads as material leakage.',
  'lumen.otherDocs.ck5.mSjTitle': 'Delivery Note — source document',
  'lumen.otherDocs.ck5.mSjApa':
    'Your internal shipping document and the STARTING POINT of the whole module. Record the sender, recipient, transport, and list of excise goods. Its data later flows automatically into CK documents.',
  'lumen.otherDocs.ck5.mSjKapan':
    'Whenever goods are about to move or be reported — always the first step of a transaction.',
  'lumen.otherDocs.ck5.mSjL1': 'Click "Buat Surat Jalan", fill in the sender and recipient along with their NPPBKC.',
  'lumen.otherDocs.ck5.mSjL2': 'Complete the transport: mode of transport and licence plate number.',
  'lumen.otherDocs.ck5.mSjL3': 'Add goods: excise type (EA/MMEA/HT), brand, packaging, quantity, unit.',
  'lumen.otherDocs.ck5.mSjL4': 'Link each item to an inventory item so stock posting is automatic.',
  'lumen.otherDocs.ck5.mSjL5': 'Save as DRAFT or mark FINAL, then click "Generate" to create the CK.',
  'lumen.otherDocs.ck5.mSjTip':
    'Link every goods line to an inventory item from the start. Unlinked lines lower the "Kesiapan Data" score and stop stock posting from being automatic.',
  'lumen.otherDocs.ck5.mDokTitle': 'CK Documents — CK-1, CK-4, CK-5',
  'lumen.otherDocs.ck5.mDokApa':
    'Manage the three official excise documents issued from the delivery note, sent to Customs host-to-host, and then tracked by status. CK-1 = excise band order (purple). CK-4 = completed production report (orange). CK-5 = excise goods mutation notification (cyan).',
  'lumen.otherDocs.ck5.mDokKapan':
    'CK-5 when moving excise goods between locations. CK-4 when reporting production output. CK-1 when ordering excise bands.',
  'lumen.otherDocs.ck5.mDokL1': 'From the delivery note, choose "Generate" and select the type (CK-1/CK-4/CK-5).',
  'lumen.otherDocs.ck5.mDokL2': 'Sender, recipient, and goods data are copied automatically — double-check them.',
  'lumen.otherDocs.ck5.mDokL3': 'Complete the specific fields: HJE and rate (CK-1), settlement status (CK-5), etc.',
  'lumen.otherDocs.ck5.mDokL4': 'Save as GENERATED, then "Submit ke Bea Cukai".',
  'lumen.otherDocs.ck5.mDokL5': 'Track the status: SUBMITTED → ACCEPTED or REJECTED.',
  'lumen.otherDocs.ck5.mDokL6': 'If REJECTED, fix it according to the rejection notes and submit again.',
  'lumen.otherDocs.ck5.mDokTip':
    'Before submitting, make sure the HJE and excise rate are correct. For CK-1: one sheet holds a number of pieces per series (I:120, II:56, III:150), and VAT on HT bands is 9.9%.',
  'lumen.otherDocs.ck5.mRiskTitle': 'Risk Self-Check — compliance dashboard',
  'lumen.otherDocs.ck5.mRiskApa':
    "A dashboard that mimics DJBC's SPT-BKC risk indicators. The system calculates a 0–1 risk score from your own data, grouped into 5 categories and broken down into 7 explainable indicators. The goal: you see the red flags first, before Customs does.",
  'lumen.otherDocs.ck5.mRiskKapan':
    'Routinely — especially before periodic reporting and after many production/mutation/band-order transactions.',
  'lumen.otherDocs.ck5.mRiskL1': 'Open Risk Self-Check and choose the evaluation period.',
  'lumen.otherDocs.ck5.mRiskL2': 'Note the overall risk score and its category.',
  'lumen.otherDocs.ck5.mRiskL3': 'Review each indicator and open the details of WARNING/CRITICAL rows.',
  'lumen.otherDocs.ck5.mRiskL4': 'Read the recommendations on problem indicators.',
  'lumen.otherDocs.ck5.mRiskL5': 'Fix the root cause in the related menu, then reload.',
  'lumen.otherDocs.ck5.mRiskTip':
    'A high score is not a verdict but an early warning. Prioritise CRITICAL indicators, starting with "Kesiapan Data": many other problems improve once all inventory links are complete.',
  'lumen.otherDocs.ck5.chipBahanBaku': 'Raw Material',
  'lumen.otherDocs.ck5.chipBarangJadi': 'Finished Goods',
  'lumen.otherDocs.ck5.chipPitaCukai': 'Excise Band',
  'lumen.otherDocs.ck5.invName1': 'Shredded Tobacco',
  'lumen.otherDocs.ck5.invQty1': '450 kg',
  'lumen.otherDocs.ck5.invName2': 'SKM Brand A',
  'lumen.otherDocs.ck5.invQty2': '12,000 sticks',
  'lumen.otherDocs.ck5.invName3': 'Series II Band',
  'lumen.otherDocs.ck5.invQty3': '80 sheets',
  'lumen.otherDocs.ck5.lowStockWarn': '⚠ 1 item below minimum stock',
  'lumen.otherDocs.ck5.bomMockTitle': 'SKM Brand A · per 1,000 sticks',
  'lumen.otherDocs.ck5.bomIng1': 'Shredded tobacco',
  'lumen.otherDocs.ck5.bomQty1': '0.9 kg',
  'lumen.otherDocs.ck5.bomIng2': 'Cloves',
  'lumen.otherDocs.ck5.bomQty2': '0.3 kg',
  'lumen.otherDocs.ck5.bomIng3': 'Cigarette paper',
  'lumen.otherDocs.ck5.bomQty3': '1,000 sheets',
  'lumen.otherDocs.ck5.bomMockNote': 'CK-4 deducts material stock automatically',
  'lumen.otherDocs.ck5.docDesc1': 'Excise Band Order',
  'lumen.otherDocs.ck5.docDesc2': 'Production Report',
  'lumen.otherDocs.ck5.docDesc3': 'Excise Goods Mutation',
  'lumen.otherDocs.ck5.statusCycle': 'Cycle status:',
  'lumen.otherDocs.ck5.statusDraft': 'CK Draft',
  'lumen.otherDocs.ck5.statusSent': 'Sent',
  'lumen.otherDocs.ck5.statusAccepted': 'Accepted',
  'lumen.otherDocs.ck5.fanTitle': '1 Delivery Note',
  'lumen.otherDocs.ck5.fanSub': 'SJ/2026/00123 · 3 items',
  'lumen.otherDocs.ck5.fanPita': 'Excise band',
  'lumen.otherDocs.ck5.fanProduksi': 'Production',
  'lumen.otherDocs.ck5.fanMutasi': 'Mutation',
  'lumen.otherDocs.ck5.fanNote': 'Data is copied automatically — you just complete it',
  'lumen.otherDocs.ck5.riskSliderHint': 'Slide to get a feel for the 0–1 risk scale',
  'lumen.otherDocs.ck5.riskSliderAria': 'Risk score',
  'lumen.otherDocs.ck5.katSangatRendah': 'Very Low',
  'lumen.otherDocs.ck5.katRendah': 'Low',
  'lumen.otherDocs.ck5.katSedang': 'Medium',
  'lumen.otherDocs.ck5.katTinggi': 'High',
  'lumen.otherDocs.ck5.katSangatTinggi': 'Very High',
  'lumen.otherDocs.ck5.postingBadge': 'Automatic',
  'lumen.otherDocs.ck5.postingTitle': 'Stock Posting — documents ↔ stock cards always in sync',
  'lumen.otherDocs.ck5.postingSj': 'Final Delivery Note',
  'lumen.otherDocs.ck5.postingSjBody':
    'Issues <b>finished goods</b> from the warehouse (stock out) according to the goods shipped.',
  'lumen.otherDocs.ck5.postingCk4': 'CK-4 processed',
  'lumen.otherDocs.ck5.postingCk4Body':
    'Adds the <b>finished goods</b> produced & deducts <b>raw materials</b> per the BOM (the BOM is exploded).',
  'lumen.otherDocs.ck5.postingNote':
    'You still record <b>raw material/band stock in</b> and <b>stock opname</b> manually. The rest runs by itself.',
  'lumen.otherDocs.ck5.startHere': 'Start here',
  'lumen.otherDocs.ck5.reset': 'Reset',
  'lumen.otherDocs.ck5.checklistHint': 'Tick each step as you work through it — saved in this browser.',
  'lumen.otherDocs.ck5.allDone': 'Done! You now understand the whole Excise module flow. 🎉',
  'lumen.otherDocs.ck5.openMenuTip': 'Open menu',
  'lumen.otherDocs.ck5.glossaryTitle': 'Key terms',
  'lumen.otherDocs.ck5.glossarySearch': 'Search terms…',
  'lumen.otherDocs.ck5.glossaryEmpty': 'No matching terms.',
  'lumen.otherDocs.ck5.gBkcTerm': 'BKC',
  'lumen.otherDocs.ck5.gBkcDef':
    'Excise Goods (Barang Kena Cukai). Three kinds: EA (Ethyl Alcohol), MMEA (Alcoholic Beverages), and HT (Tobacco Products).',
  'lumen.otherDocs.ck5.gNppbkcTerm': 'NPPBKC',
  'lumen.otherDocs.ck5.gNppbkcDef':
    'Excise Goods Entrepreneur Registration Number — the official licence/identity of an excise goods entrepreneur issued by Customs.',
  'lumen.otherDocs.ck5.gCk1Term': 'CK-1',
  'lumen.otherDocs.ck5.gCk1Def':
    'Excise band order document (the band pieces attached to excise goods). Shown in purple.',
  'lumen.otherDocs.ck5.gCk4Term': 'CK-4',
  'lumen.otherDocs.ck5.gCk4Def':
    'Report that production of excise goods is complete. Adds finished goods stock & deducts raw materials per the BOM. Shown in orange.',
  'lumen.otherDocs.ck5.gCk5Term': 'CK-5',
  'lumen.otherDocs.ck5.gCk5Def':
    'Notification of excise goods mutation (movement) between locations, holding the settlement status. Shown in cyan.',
  'lumen.otherDocs.ck5.gPitaTerm': 'Excise Band',
  'lumen.otherDocs.ck5.gPitaDef':
    'Proof of excise settlement in the form of a band on the packaging of excise goods. Ordered via CK-1; pieces per sheet differ by series (I:120, II:56, III:150).',
  'lumen.otherDocs.ck5.gHjeTerm': 'HJE',
  'lumen.otherDocs.ck5.gHjeDef': 'Retail selling price per package — the basis for calculating excise.',
  'lumen.otherDocs.ck5.gTarifTerm': 'Excise Rate',
  'lumen.otherDocs.ck5.gTarifDef':
    'The excise amount per unit (stick/gram/litre), multiplied by quantity to calculate the excise value.',
  'lumen.otherDocs.ck5.gStokTerm': 'Stock Card',
  'lumen.otherDocs.ck5.gStokDef':
    'Record of inventory movements per item: stock in, out, and adjustments. The mandatory inventory book for excise goods entrepreneurs.',
  'lumen.otherDocs.ck5.gMutasiTerm': 'Mutation',
  'lumen.otherDocs.ck5.gMutasiDef':
    'Movement of excise goods or a change in stock balance. Reported in documents via CK-5.',
  'lumen.otherDocs.ck5.gPelunasanTerm': 'Settlement',
  'lumen.otherDocs.ck5.gPelunasanDef':
    'Excise payment status: Not Yet Settled, Settled, Not Collected, or Exempted. Attached to CK-5.',
  'lumen.otherDocs.ck5.gBomTerm': 'BOM',
  'lumen.otherDocs.ck5.gBomDef':
    'Bill of Material — production recipe: raw materials and quantities to make one finished good. Linked to inventory.',
  'lumen.otherDocs.ck5.gOpnameTerm': 'Stock Opname',
  'lumen.otherDocs.ck5.gOpnameDef':
    'Adjusting the stock balance to match the warehouse physical count — producing an increase/decrease mutation.',
  'lumen.otherDocs.ck5.gH2hTerm': 'Host-to-Host',
  'lumen.otherDocs.ck5.gH2hDef':
    'Sending documents directly from your system to Customs without re-entry; response status is pulled automatically.',
  'lumen.otherDocs.ck5.faqTitle': 'Frequently asked questions',
  'lumen.otherDocs.ck5.faq1Q': "I'm completely new. Where should I start?",
  'lumen.otherDocs.ck5.faq1A':
    'Follow the "Mulai dari sini" order: Inventory → BOM → stock in → Delivery Note → generate CK → submit → stock posting → Risk Self-Check. This order keeps the automation running smoothly.',
  'lumen.otherDocs.ck5.faq2Q': 'What is the difference between CK-1, CK-4, and CK-5?',
  'lumen.otherDocs.ck5.faq2A':
    'CK-1 orders excise bands (purple). CK-4 reports completed production (orange). CK-5 notifies excise goods mutation along with settlement (cyan). All three are issued from the delivery note and then submitted to Customs.',
  'lumen.otherDocs.ck5.faq3Q': 'Why is the Delivery Note created first?',
  'lumen.otherDocs.ck5.faq3A':
    'The Delivery Note is the source document. Sender, recipient, transport, and goods data are entered once, then copied automatically when generating the CK — saving time and staying consistent.',
  'lumen.otherDocs.ck5.faq4Q': 'Does stock change by itself?',
  'lumen.otherDocs.ck5.faq4A':
    'Mostly automatic: a final delivery note issues finished goods, CK-4 adds production & deducts raw materials per the BOM. You still record raw material/band stock in and stock opname manually.',
  'lumen.otherDocs.ck5.faq5Q': 'My risk score is high, what does it mean?',
  'lumen.otherDocs.ck5.faq5A':
    'An early warning, not a sanction. Review CRITICAL indicators first and read their recommendations. Usually start with "Kesiapan Data" (complete the inventory links), settle CK-5, and make sure CK-4/delivery notes are posted.',
  'lumen.otherDocs.fxp.dateRangeMax3Months': 'Date range cannot exceed 3 months',
  'lumen.otherDocs.fxp.submitSentenceFinal':
    'Document <b>{title}</b> ({kode}) will be sent to CEISA as a final filing.',
  'lumen.otherDocs.fxp.submitSentenceDraft':
    'Document <b>{title}</b> ({kode}) will be sent to CEISA as a draft (can be printed and viewed in the CEISA portal).',
  // lumen.exportEngine (revamp PR 8c)
  'lumen.exportEngine.g1.scaffoldPill': 'Auto-filled',
  'lumen.exportEngine.g1.scaffoldPillTooltip':
    'This value was filled in automatically from the exporter / port you chose at upload.',
  'lumen.exportEngine.g1.cardRecommendedTooltip':
    'Goods similar to this draft — {matchCount} of {matchTotal} tariff lines match',
  'lumen.exportEngine.g1.cardSelectedAria': 'Selected',
  'lumen.exportEngine.g1.cardNpwpNik': 'NPWP/NIK:',
  'lumen.exportEngine.g1.cardNoAddress': 'Address not available',
  'lumen.exportEngine.g1.cardPenerima': 'Consignee:',
  'lumen.exportEngine.g1.cardPembeli': 'Buyer:',
  'lumen.exportEngine.g1.cardPelMuat': 'Export loading port:',
  'lumen.exportEngine.pg1.secureTitle': 'Secure & Private',
  'lumen.exportEngine.pg1.secureMessage': 'Protected by enterprise-grade security',
  'lumen.exportEngine.pg1.ownershipTitle': 'Data Ownership',
  'lumen.exportEngine.pg1.ownershipMessage': 'Your data belongs to you, always',
  'lumen.exportEngine.pg1.bankTitle': 'Bank-Level Security',
  'lumen.exportEngine.pg1.bankMessage': 'Military-grade protection for your business',
  'lumen.exportEngine.pg2.loading': 'Loading...',
  'lumen.exportEngine.pg4.saveFailedTitle': 'Save failed',
  'lumen.exportEngine.pg4.saveBarangFailed': 'Failed to save goods data',
  'lumen.exportEngine.pg4.saveTabFailed': 'Failed to save tab {tab}',
  'lumen.exportEngine.pg4.ajuMissing': 'AJU number is not available yet',
  'lumen.exportEngine.pg4.failedTitle': 'Failed',
  'lumen.exportEngine.pg4.printFormFailed': 'Failed to print the form',
  'lumen.exportEngine.pg4.ppjkNpwpMissing': 'PPJK NPWP not found. Make sure the PPJK data is filled in correctly.',
  'lumen.exportEngine.pg5.formDataMissing': 'Form data not available. Please fill out the form first.',
  'lumen.exportEngine.pg5.submitSuccess': 'Export document was submitted to CEISA successfully.',
  'lumen.exportEngine.pg5.submitFailed': 'Failed to submit export document',
  'lumen.exportEngine.pg6.loadingPage': 'Loading page',
  'lumen.exportEngine.pg6.back': 'Back',
  'lumen.exportEngine.pg6.auditLogs': 'Audit Logs',
  'lumen.exportEngine.pg6.lihatDiCeisa': 'View in Ceisa',
  'lumen.exportEngine.pg6.syncHistoricalData': 'Sync with Historical Data',
  'lumen.exportEngine.pg6.aksi': 'Actions',
  'lumen.exportEngine.pg6.cetak': 'Print',
  'lumen.exportEngine.pg6.loadingEllipsis': 'Loading...',
  'lumen.exportEngine.pg6.cetakDraftPeb': 'Print PEB draft',
  'lumen.exportEngine.pg6.submit': 'Submit',
  'lumen.exportEngine.pg6.transferNpe': 'Transfer (NPE)',
  'lumen.exportEngine.pg6.revisi': 'Revision',
  'lumen.exportEngine.pg6.submitKeCeisa': 'Submit to Ceisa',
  'lumen.exportEngine.pg6.sebelumnya': 'Previous',
  'lumen.exportEngine.pg6.selanjutnya': 'Next',
  'lumen.exportEngine.pg6.konfirmasi': 'Confirm {type}',
  'lumen.exportEngine.pg6.transferWarning':
    'You are about to perform a Transfer (NPE). The document will be submitted to CEISA as final and cannot be changed again once the NPE is issued.',
  'lumen.exportEngine.pg6.revisiWarning':
    'You are about to revise the document. Data that was submitted earlier will be updated in CEISA.',
  'lumen.exportEngine.pg6.yaLanjutkan': 'Yes, Continue',
  'lumen.exportEngine.pg6.submissionProgress': 'Submission progress',
  'lumen.exportEngine.pg6.submittingToCeisa': 'Submitting to CEISA...',
  'lumen.exportEngine.pg6.submissionFailed': 'Submission Failed',
  'lumen.exportEngine.pg6.close': 'Close',
  'lumen.exportEngine.pk1.originLoadingPortRequired': 'Origin loading port must be selected',
  'lumen.exportEngine.pk1.exportLoadingPortRequired': 'Export loading port must be selected',
  'lumen.exportEngine.pk1.destinationPortRequired': 'Destination port must be selected',
  'lumen.exportEngine.pk1.exportDestinationCountryRequired': 'Export destination country must be selected',
  'lumen.exportEngine.pk1.estimatedExportDateRequired': 'Estimated export date is required',
  'lumen.exportEngine.pk1.inspectionLocationRequired': 'Inspection location is required',
  'lumen.exportEngine.pk1.inspectionOfficeRequired': 'Inspection office must be selected',
  'lumen.exportEngine.pk1.inspectionDateRequired': 'Inspection date is required',
  'lumen.exportEngine.pk1.wajibDiisi': 'Required',
  'lumen.exportEngine.pk2.seri': 'No.',
  'lumen.exportEngine.pk2.namaSarkut': 'Carrier name',
  'lumen.exportEngine.pk2.nomorPengangkut': 'Voyage number',
  'lumen.exportEngine.pk2.caraPengangkutan': 'Mode of transport',
  'lumen.exportEngine.pk2.bendera': 'Flag',
  'lumen.exportEngine.pk2.aksi': 'Actions',
  'lumen.exportEngine.pk2.edit': 'Edit',
  'lumen.exportEngine.pk2.delete': 'Delete',
  'lumen.exportEngine.pk2.saranaAngkut': 'Transport facilities',
  'lumen.exportEngine.pk2.tambah': 'Add',
  'lumen.exportEngine.pk2.pelabuhanMuatAsal': 'Origin loading port',
  'lumen.exportEngine.pk2.pilihPelabuhanMuatAsal': 'Select origin loading port',
  'lumen.exportEngine.pk2.pelabuhanMuatEkspor': 'Export loading port',
  'lumen.exportEngine.pk2.pilihPelabuhanMuatEkspor': 'Select export loading port',
  'lumen.exportEngine.pk2.tempatPenimbunan': 'Storage location',
  'lumen.exportEngine.pk2.pilihTempatPenimbunan': 'Select storage location',
  'lumen.exportEngine.pk2.pilihKantorMuatDulu': 'Please select the origin loading customs office first',
  'lumen.exportEngine.pk2.tanggalPerkiraanEkspor': 'Estimated export date',
  'lumen.exportEngine.pk2.jenisPengangkutan': 'Transport type',
  'lumen.exportEngine.pk2.pilihJenisPengangkutan': 'Select transport type',
  'lumen.exportEngine.pk2.pelabuhanTujuan': 'Destination port',
  'lumen.exportEngine.pk2.pilihPelabuhanTujuan': 'Select destination port',
  'lumen.exportEngine.pk2.negaraTujuanEkspor': 'Export destination country',
  'lumen.exportEngine.pk2.pilihNegaraTujuanEkspor': 'Select export destination country',
  'lumen.exportEngine.pk2.pemeriksaan': 'Inspection',
  'lumen.exportEngine.pk2.lokasiPemeriksaan': 'Inspection location',
  'lumen.exportEngine.pk2.pilihLokasiPemeriksaan': 'Select inspection location',
  'lumen.exportEngine.pk2.kantorPabeanPemeriksaan': 'Inspection customs office',
  'lumen.exportEngine.pk2.pilihKantorPabeanPemeriksaan': 'Select inspection customs office',
  'lumen.exportEngine.pk2.tanggalPeriksa': 'Inspection date',
  'lumen.exportEngine.pk3.tambahPetiKemas': 'Add container',
  'lumen.exportEngine.pk3.seri': 'No.',
  'lumen.exportEngine.pk3.nomor': 'Number',
  'lumen.exportEngine.pk3.ukuran': 'Size',
  'lumen.exportEngine.pk3.jenis': 'Type',
  'lumen.exportEngine.pk3.tipe': 'Kind',
  'lumen.exportEngine.pk3.tambahKemasan': 'Add packaging',
  'lumen.exportEngine.pk3.jumlah': 'Quantity',
  'lumen.exportEngine.pk3.merek': 'Brand',
  'lumen.exportEngine.pk3.namaRequired': 'Carrier name is required',
  'lumen.exportEngine.pk3.caraRequired': 'Mode of transport is required',
  'lumen.exportEngine.pk3.voyRequired': 'Voyage/flight/plate number is required',
  'lumen.exportEngine.pk3.benderaRequired': 'Flag is required',
  'lumen.exportEngine.pk3.masukkanNamaDulu': 'Enter the carrier name first',
  'lumen.exportEngine.pk3.hanyaLaut': 'Flag search is only available for sea transport',
  'lumen.exportEngine.pk3.kodeNegaraGagal':
    'Flag "{flagName}" was found, but the country code could not be retrieved. Please choose the flag manually.',
  'lumen.exportEngine.pk3.benderaTidakDitemukan': 'No flag found for this vessel',
  'lumen.exportEngine.pk3.gagalCari': 'Failed to look up the vessel flag. Please choose the flag manually.',
  'lumen.exportEngine.pk3.editSaranaAngkut': 'Edit transport facility',
  'lumen.exportEngine.pk3.tambahSaranaAngkut': 'Add transport facility',
  'lumen.exportEngine.pk3.namaSaranaAngkut': 'Carrier name',
  'lumen.exportEngine.pk3.namaPlaceholder': 'Enter the carrier name',
  'lumen.exportEngine.pk3.cariBendera': 'Find flag',
  'lumen.exportEngine.pk3.caraPengangkutan': 'Mode of transport',
  'lumen.exportEngine.pk3.caraPlaceholder': 'Select mode of transport',
  'lumen.exportEngine.pk3.voyLabel': 'Voyage / flight / plate number',
  'lumen.exportEngine.pk3.voyPlaceholder': 'Enter the voyage/flight/plate number',
  'lumen.exportEngine.pk3.bendera': 'Flag',
  'lumen.exportEngine.pk3.benderaPlaceholder': 'Select flag',
  'lumen.exportEngine.pk4.seri': 'No.',
  'lumen.exportEngine.pk4.jumlah': 'Quantity',
  'lumen.exportEngine.pk4.jenis': 'Type',
  'lumen.exportEngine.pk4.merek': 'Brand',
  'lumen.exportEngine.pk4.nomor': 'Number',
  'lumen.exportEngine.pk4.ukuran': 'Size',
  'lumen.exportEngine.pk4.tipe': 'Type',
  'lumen.exportEngine.pk4.aksi': 'Actions',
  'lumen.exportEngine.pk4.edit': 'Edit',
  'lumen.exportEngine.pk4.copy': 'Copy',
  'lumen.exportEngine.pk4.delete': 'Delete',
  'lumen.exportEngine.pk4.kemasan': 'Packaging',
  'lumen.exportEngine.pk4.petiKemas': 'Containers',
  'lumen.exportEngine.pk4.tambahKemasan': 'Add packaging',
  'lumen.exportEngine.pk4.tambahPetiKemas': 'Add container',
  'lumen.exportEngine.pk4.konfirmasiHapus': 'Confirm delete',
  'lumen.exportEngine.pk4.hapusKemasanBody': 'Are you sure you want to delete this packaging?',
  'lumen.exportEngine.pk4.hapusPetiKemasBody': 'Are you sure you want to delete this container?',
  'lumen.exportEngine.pk4.hapus': 'Delete',
  'lumen.exportEngine.pk5.transaksi': 'Transaction',
  'lumen.exportEngine.pk5.valuta': 'Currency',
  'lumen.exportEngine.pk5.pilihValuta': 'Select currency',
  'lumen.exportEngine.pk5.ndpbm': 'NDPBM',
  'lumen.exportEngine.pk5.caraPenyerahan': 'Delivery terms',
  'lumen.exportEngine.pk5.pilihCaraPenyerahan': 'Select delivery terms',
  'lumen.exportEngine.pk5.nilaiEksporFob': 'Export value (Incoterm FOB)',
  'lumen.exportEngine.pk5.freight': 'Freight',
  'lumen.exportEngine.pk5.nilaiAsuransi': 'Insurance value',
  'lumen.exportEngine.pk5.asuransi': 'Insurance',
  'lumen.exportEngine.pk5.jenisAsuransi': 'Insurance type',
  'lumen.exportEngine.pk5.dalamNegeri': 'DOMESTIC',
  'lumen.exportEngine.pk5.luarNegeri': 'FOREIGN',
  'lumen.exportEngine.pk5.ratesHint':
    'Standard DJBC freight and insurance value; manual entries are not overwritten unless recalculated.',
  'lumen.exportEngine.pk5.hitungFreightAsuransi': 'Calculate freight & insurance',
  'lumen.exportEngine.pk5.beratKotor': 'Gross weight (KGM)',
  'lumen.exportEngine.pk5.beratBersih': 'Net weight (KGM)',
  'lumen.exportEngine.pk5.nilaiMaklon': 'Toll manufacturing value',
  'lumen.exportEngine.pk5.nilaiBeaKeluar': 'Export duty value',
  'lumen.exportEngine.pk5.infoBeaKeluar': 'Export duty info',
  'lumen.exportEngine.pk5.infoBeaKeluarText':
    'The export duty value is calculated automatically from the export duty rate that applies to the HS code of the exported goods (latest Ministry of Finance regulation). Entered in Rupiah.',
  'lumen.exportEngine.pk5.hitungBeaKeluar': 'Calculate export duty',
  'lumen.exportEngine.pk5.nilaiPph22': 'Export Article 22 income tax value',
  'lumen.exportEngine.pk5.infoPph22': 'Article 22 income tax info',
  'lumen.exportEngine.pk5.infoPph22Text':
    'Tick if the export is subject to Article 22 income tax (e.g. coal, metal minerals, palm oil exports). The value is calculated from the export value × the Article 22 rate under the latest PMK, in Rupiah.',
  'lumen.exportEngine.pk5.nilaiPungutanSawit': 'Palm oil levy value',
  'lumen.exportEngine.pk5.infoPungutanSawit': 'Palm oil levy info',
  'lumen.exportEngine.pk5.infoPungutanSawitText':
    'Export levy on CPO/palm oil products charged by BPDPKS. Enter the value in Rupiah at the applicable rate.',
  'lumen.exportEngine.pk5.previewUnavailable': 'Export duty preview is not available',
  'lumen.exportEngine.pk5.responseUnavailable': 'Export duty response is not available',
  'lumen.exportEngine.pk5.persistFailedFallback': 'Persist failed',
  'lumen.exportEngine.pk5.calcFailedTitle': 'Calculation failed',
  'lumen.exportEngine.pk5.calcFailedFallback': 'Failed to calculate export duty',
  'lumen.exportEngine.pk5.warningTitle': 'Warning',
  'lumen.exportEngine.pk5.savedRefreshFailed':
    'Export duty was saved, but the latest data could not be reloaded automatically.',
  'lumen.exportEngine.pk5.successTitle': 'Success',
  'lumen.exportEngine.pk5.savedAmount': 'Export duty {amount} saved',
  'lumen.exportEngine.pk5.persistFailedTitle': 'Persist Failed',
  'lumen.exportEngine.pk6.bankDevisa': 'Foreign exchange bank',
  'lumen.exportEngine.pk6.tambah': 'Add',
  'lumen.exportEngine.pk6.seri': 'No.',
  'lumen.exportEngine.pk6.kodeBank': 'Bank code',
  'lumen.exportEngine.pk6.namaBank': 'Bank name',
  'lumen.exportEngine.pk6.aksi': 'Actions',
  'lumen.exportEngine.pk6.delete': 'Delete',
  'lumen.exportEngine.pk6.konfirmasiHapus': 'Confirm delete',
  'lumen.exportEngine.pk6.hapusBankBody': 'Are you sure you want to delete this foreign exchange bank?',
  'lumen.exportEngine.pk6.hapus': 'Delete',
  'lumen.exportEngine.pk6.previewBeaKeluar': 'Export duty preview',
  'lumen.exportEngine.pk6.totalBeaKeluar': 'Total export duty',
  'lumen.exportEngine.pk6.totalSummary': 'USD {usd} · NDPBM {ndpbm} · Period {periode}',
  'lumen.exportEngine.pk6.peringatan': 'Warning',
  'lumen.exportEngine.pk6.warningWithSeri': '{code} · Item {seri}: {message}',
  'lumen.exportEngine.pk6.warningNoSeri': '{code}: {message}',
  'lumen.exportEngine.pk6.periksaDataPendukung': 'Check the supporting export duty data.',
  'lumen.exportEngine.pk6.posTarif': 'Tariff heading',
  'lumen.exportEngine.pk6.uraian': 'Description',
  'lumen.exportEngine.pk6.netto': 'Net',
  'lumen.exportEngine.pk6.hpe': 'HPE',
  'lumen.exportEngine.pk6.tarifBk': 'Duty rate',
  'lumen.exportEngine.pk6.bkUsd': 'Duty USD',
  'lumen.exportEngine.pk6.bkIdr': 'Duty IDR',
  'lumen.exportEngine.pk6.status': 'Status',
  'lumen.exportEngine.pk6.tidakAdaBaris': 'No calculation rows.',
  'lumen.exportEngine.pk6.nettoMt': '{n} MT',
  'lumen.exportEngine.pk6.nettoKg': '{n} KG',
  'lumen.exportEngine.pk6.usdAmount': 'USD {amount}',
  'lumen.exportEngine.pk6.staleHpe': 'Stale HPE',
  'lumen.exportEngine.pk6.hpeMonthUsed': 'HPE month used: {month}',
  'lumen.exportEngine.pk6.bracketInfo': '{kelompok} · HR {min}-{max}',
  'lumen.exportEngine.pk6.terapkan': 'Apply',
  'lumen.exportEngine.pk6.tambahBankDevisa': 'Add foreign exchange bank',
  'lumen.exportEngine.pk6.pilihBank': 'Select bank',
  'lumen.exportEngine.br1.hsFetchFailed': 'Failed to fetch HS code details',
  'lumen.exportEngine.br1.hsFetchError': 'Error fetching HS code details',
  'lumen.exportEngine.br1.excelDownloaded': 'Excel downloaded successfully',
  'lumen.exportEngine.br1.excelDownloadFailed': 'Failed to download Excel',
  'lumen.exportEngine.br1.uploadExcelTitle': 'Upload Excel',
  'lumen.exportEngine.br1.uploadingExcel': 'Uploading the Excel file and refreshing the goods data...',
  'lumen.exportEngine.br1.processIdMissing': 'Process ID not found',
  'lumen.exportEngine.br1.uploadFailed': 'Upload failed',
  'lumen.exportEngine.br1.uploadRefreshing': 'Upload succeeded, loading the latest data...',
  'lumen.exportEngine.br1.uploadDone': 'Excel upload succeeded and the goods data is updated',
  'lumen.exportEngine.br1.uploadRefreshFailed':
    'Upload succeeded, but the view could not be refreshed automatically. Please reload the page.',
  'lumen.exportEngine.br1.uploadExcelFailed': 'Failed to upload Excel',
  'lumen.exportEngine.br2.seri': 'Seri',
  'lumen.exportEngine.br2.hs': 'HS',
  'lumen.exportEngine.br2.lartas': 'Restrictions',
  'lumen.exportEngine.br2.uraian': 'Description',
  'lumen.exportEngine.br2.satuan': 'Unit',
  'lumen.exportEngine.br2.kemasan': 'Packaging',
  'lumen.exportEngine.br2.fob': 'FOB',
  'lumen.exportEngine.br2.nw': 'NW',
  'lumen.exportEngine.br2.aksi': 'Actions',
  'lumen.exportEngine.br2.yes': 'Yes',
  'lumen.exportEngine.br2.no': 'No',
  'lumen.exportEngine.br2.kg': 'kg',
  'lumen.exportEngine.br2.copy': 'Copy',
  'lumen.exportEngine.br2.delete': 'Delete',
  'lumen.exportEngine.br3.itemCopyNotFound': 'Item not found to copy',
  'lumen.exportEngine.br3.itemDeleteNotFound': 'Item not found to delete',
  'lumen.exportEngine.br3.bulkDeleted': '{count} items deleted',
  'lumen.exportEngine.br3.bulkDeleteFailed': 'Failed to delete items',
  'lumen.exportEngine.br3.itemUpdated': 'Item updated successfully',
  'lumen.exportEngine.br3.itemAdded': 'Item added successfully',
  'lumen.exportEngine.br3.processIdMissing': 'Process ID not found',
  'lumen.exportEngine.br3.smartSyncTitle': 'Smart Sync',
  'lumen.exportEngine.br3.smartSyncStep1': 'Step 1/3: Saving current data...',
  'lumen.exportEngine.br3.smartSyncStep2': 'Step 2/3: Syncing data with CEISA...',
  'lumen.exportEngine.br3.smartSyncStep3': 'Step 3/3: Retrieving synced data...',
  'lumen.exportEngine.br3.smartSyncDone': 'Smart Sync completed! Synced {count} items.',
  'lumen.exportEngine.br3.smartSyncRetrieveFailed': 'Failed to retrieve synced data',
  'lumen.exportEngine.br3.smartSyncFailed': 'Smart Sync failed',
  'lumen.exportEngine.br4.downloading': 'Downloading...',
  'lumen.exportEngine.br4.downloadExcel': 'Download Excel',
  'lumen.exportEngine.br4.uploading': 'Uploading...',
  'lumen.exportEngine.br4.uploadExcel': 'Upload Excel',
  'lumen.exportEngine.br4.hsCodeDetails': 'HS Code Details',
  'lumen.exportEngine.br4.basicInfo': 'Basic Info',
  'lumen.exportEngine.br4.tariffRates': 'Tariff Rates',
  'lumen.exportEngine.br4.preferentialTariffs': 'Preferential Tariffs ({count})',
  'lumen.exportEngine.br4.code': 'Code:',
  'lumen.exportEngine.br4.normalizedCode': 'Normalized Code:',
  'lumen.exportEngine.br4.idDescription': 'ID Description:',
  'lumen.exportEngine.br4.enDescription': 'EN Description:',
  'lumen.exportEngine.br4.inswYear': 'INSW Year:',
  'lumen.exportEngine.br4.lartas': 'LARTAS:',
  'lumen.exportEngine.br4.yes': 'YES',
  'lumen.exportEngine.br4.no': 'NO',
  'lumen.exportEngine.br4.issueDate': 'Issue Date:',
  'lumen.exportEngine.br4.effective': 'Effective:',
  'lumen.exportEngine.br4.historicalRates': 'Historical Rates:',
  'lumen.exportEngine.br4.loadingHsCode': 'Loading HS code details...',
  'lumen.exportEngine.br5.total': 'Total: {count}',
  'lumen.exportEngine.br5.filtered': 'Filtered: {count}',
  'lumen.exportEngine.br5.smartSync': 'Smart Sync',
  'lumen.exportEngine.br5.syncing': 'Syncing...',
  'lumen.exportEngine.br5.tambahBarang': 'Add goods',
  'lumen.exportEngine.br5.searchPlaceholder': 'Search by description or HS code...',
  'lumen.exportEngine.br5.clearSearch': 'Clear search',
  'lumen.exportEngine.br5.tableAria': 'Goods list',
  'lumen.exportEngine.br6.nilaiEksporFob': 'Export Value (FOB Value)',
  'lumen.exportEngine.br6.infoNilaiEksporAria': 'Export Value info',
  'lumen.exportEngine.br6.nilaiEksporInfo':
    'Enter the export value per item shown on the invoice under the FOB Incoterm, in the currency given in the Currency field. If an Incoterm other than FOB is used, the export value entered is the FOB value. For contract processing (maklon) service exports, fill in the Export Value field as follows: use the value of the finished goods exported (after processing). If the value of the finished goods exported is unknown, use the import value of the goods or raw materials processed plus the value of the maklon service. For an example, see page 34 of Appendix I to Director General Regulation No. PER-22/BC/2024.',
  'lumen.exportEngine.br6.nilaiEksporPerSatuan': 'Export value per unit of goods',
  'lumen.exportEngine.br6.incoterm': 'Incoterm',
  'lumen.exportEngine.br6.beratBersih': 'Net Weight (kg)',
  'lumen.exportEngine.br6.mataUang': 'Currency',
  'lumen.exportEngine.br6.totalNilaiFob': 'Total FOB Value ({currency})',
  'lumen.exportEngine.br6.totalQuantity': 'Total Quantity',
  'lumen.exportEngine.br6.informasiDasar': 'Basic Information',
  'lumen.exportEngine.br6.detailHarga': 'Details & Price',
  'lumen.exportEngine.br6.dokumenFasilitasLartas': 'Facility/Restriction Documents',
  'lumen.exportEngine.br6.entitasBarang': 'Goods Entities',
  'lumen.exportEngine.br6.tambahBarang': 'Add Item',
  'lumen.exportEngine.br6.simpanPerubahan': 'Save Changes',
  'lumen.exportEngine.br6.gagalMenambahkanBarang': 'Failed to Add Item',
  'lumen.exportEngine.br6.lengkapiFieldWajib': 'Please complete the following required fields: {fields}',
  'lumen.exportEngine.br7.seri': 'Serial',
  'lumen.exportEngine.br7.jumlahSatuan': 'Unit Quantity',
  'lumen.exportEngine.br7.jumlahSatuanPlaceholder': 'Unit quantity',
  'lumen.exportEngine.br7.kodeSatuan': 'Unit Code',
  'lumen.exportEngine.br7.kodeSatuanPlaceholder': 'Unit code',
  'lumen.exportEngine.br7.jumlahKemasan': 'Package Quantity',
  'lumen.exportEngine.br7.jumlahKemasanPlaceholder': 'Package quantity',
  'lumen.exportEngine.br7.kodeKemasan': 'Package Code',
  'lumen.exportEngine.br7.hsCode': 'HS Code',
  'lumen.exportEngine.br7.lartas': 'LARTAS',
  'lumen.exportEngine.br7.nonLartas': 'NON-LARTAS',
  'lumen.exportEngine.br7.uraian': 'Description',
  'lumen.exportEngine.br7.uraianPlaceholder': 'Goods description',
  'lumen.exportEngine.br7.sesuaiHs': 'Match HS',
  'lumen.exportEngine.br7.kode': 'Code',
  'lumen.exportEngine.br7.kodeProdukPlaceholder': 'Product code',
  'lumen.exportEngine.br7.merk': 'Brand',
  'lumen.exportEngine.br7.tipe': 'Type',
  'lumen.exportEngine.br7.ukuran': 'Size',
  'lumen.exportEngine.br7.kodeJenisEkspor': 'Export Type Code',
  'lumen.exportEngine.br7.negaraAsal': 'Country of Origin',
  'lumen.exportEngine.br7.negaraAsalPlaceholder': 'Country of origin',
  'lumen.exportEngine.br7.daerahAsal': 'Area of Origin',
  'lumen.exportEngine.br7.daerahAsalPlaceholder': 'Area of origin',
  'lumen.exportEngine.br8.dokumenCount': 'Documents: {count}',
  'lumen.exportEngine.br8.pemilikCount': 'Owners: {count}',
  'lumen.exportEngine.br8.pilihDokumen': 'Select a document...',
  'lumen.exportEngine.br8.pilihPemilik': 'Select goods owner...',
  'lumen.exportEngine.br8.tambah': 'Add',
  'lumen.exportEngine.br8.tidakAdaDokumen': 'No documents available',
  'lumen.exportEngine.br8.tidakAdaPemilik': 'No owners available',
  'lumen.exportEngine.br8.seri': 'No.',
  'lumen.exportEngine.br8.jenis': 'Type',
  'lumen.exportEngine.br8.nomor': 'Number',
  'lumen.exportEngine.br8.tanggal': 'Date',
  'lumen.exportEngine.br8.fasilitas': 'Facility',
  'lumen.exportEngine.br8.izin': 'Permit',
  'lumen.exportEngine.br8.aksi': 'Actions',
  'lumen.exportEngine.br8.nama': 'Name',
  'lumen.exportEngine.br8.identitas': 'Identity',
  'lumen.exportEngine.br8.alamat': 'Address',
  'lumen.exportEngine.br8.hapus': 'Delete',
  'lumen.exportEngine.br8.belumAdaDokumenDiTab': 'No documents in the Documents tab yet. Add a document first.',
  'lumen.exportEngine.br8.belumAdaDokumenDipilih': 'No document selected yet. Pick a document from the dropdown above.',
  'lumen.exportEngine.br8.belumAdaPemilikDiTab': 'No owners in the Entities tab yet. Add an owner first.',
  'lumen.exportEngine.br8.belumAdaPemilikDipilih': 'No owner selected yet. Pick an owner from the dropdown above.',
  'lumen.exportEngine.br8.infoPemilik': 'Owner entities come from the Goods Owner list in the Entities tab',
  'lumen.exportEngine.he2.pelabuhanLabel': 'Export Loading Port',
  'lumen.exportEngine.he2.pelabuhanPlaceholder': 'Select Export Loading Port',
  'lumen.exportEngine.he2.kantorAsalLabel': 'Origin Loading Customs Office',
  'lumen.exportEngine.he2.kantorAsalPlaceholder': 'Select Origin Loading Customs Office',
  'lumen.exportEngine.he2.jenisEksporLabel': 'Export Type',
  'lumen.exportEngine.he2.jenisEksporPlaceholder': 'Select Export Type',
  'lumen.exportEngine.he2.kantorEksporLabel': 'Export Loading Customs Office',
  'lumen.exportEngine.he2.kantorEksporPlaceholder': 'Select Export Loading Customs Office',
  'lumen.exportEngine.he2.kategoriEksporLabel': 'Export Category',
  'lumen.exportEngine.he2.kategoriEksporPlaceholder': 'Select Export Category',
  'lumen.exportEngine.he2.caraDagangLabel': 'Trade Method',
  'lumen.exportEngine.he2.caraDagangPlaceholder': 'Select Trade Method',
  'lumen.exportEngine.he2.caraBayarLabel': 'Payment Method',
  'lumen.exportEngine.he2.caraBayarPlaceholder': 'Select Payment Method',
  'lumen.exportEngine.he2.ketBayar': 'Payment Details',
  'lumen.exportEngine.he2.komoditiLabel': 'Commodity',
  'lumen.exportEngine.he2.komoditiPlaceholder': 'Select Commodity',
  'lumen.exportEngine.he2.curahLabel': 'Bulk',
  'lumen.exportEngine.he2.curahPlaceholder': 'Select Bulk',
  'lumen.exportEngine.he2.barangKirimanLabel': 'Consignment Goods Export',
  'lumen.exportEngine.he2.barangKirimanPlaceholder': 'Select Consignment Goods Export',
  'lumen.exportEngine.he2.pkbTitle': 'Goods Consolidation Notification (PKB)',
  'lumen.exportEngine.he2.pkbSubtitle':
    'Export type 4, 5 or 6 — complete the PKB document, or save & use a template to speed up repeated entry.',
  'lumen.exportEngine.he2.manageTemplate': 'Manage Template',
  'lumen.exportEngine.he2.isiPkb': 'Fill in PKB',
  'lumen.exportEngine.he3.title': 'PKB',
  'lumen.exportEngine.he3.permintaanPemeriksaan': 'Inspection request',
  'lumen.exportEngine.he3.pelaksanaanStuffing': 'Stuffing implementation',
  'lumen.exportEngine.he3.tanggal': 'Date',
  'lumen.exportEngine.he3.dateFormat': 'DD-MM-YYYY',
  'lumen.exportEngine.he3.alamat': 'Address',
  'lumen.exportEngine.he3.telepon': 'Phone',
  'lumen.exportEngine.he3.contactPerson': 'Contact Person',
  'lumen.exportEngine.he3.jenisBarang': 'Type of goods',
  'lumen.exportEngine.he3.pilihJenisBarang': 'Select type of goods',
  'lumen.exportEngine.he3.tempatSimpan': 'Storage location',
  'lumen.exportEngine.he3.pilihTempatSimpan': 'Select storage location',
  'lumen.exportEngine.he3.petiKemas': 'Containers',
  'lumen.exportEngine.he3.feet20': '20 Feet',
  'lumen.exportEngine.he3.feet40': '40 Feet',
  'lumen.exportEngine.he3.caraStuffing': 'Stuffing method',
  'lumen.exportEngine.he3.pilihCaraStuffing': 'Select stuffing method',
  'lumen.exportEngine.he3.halPartOf': 'Part of',
  'lumen.exportEngine.he3.pilihHalPartOf': 'Select part of',
  'lumen.exportEngine.he3.tempat': 'Place',
  'lumen.exportEngine.he3.hapus': 'Clear',
  'lumen.exportEngine.he4.manageTitle': 'Manage PKB Templates',
  'lumen.exportEngine.he4.ppjkNpwp': 'PPJK NPWP:',
  'lumen.exportEngine.he4.addTemplate': 'Add Template',
  'lumen.exportEngine.he4.colTemplateName': 'Template Name',
  'lumen.exportEngine.he4.colCaraStuffing': 'Stuffing method',
  'lumen.exportEngine.he4.colPeti': '20ft / 40ft',
  'lumen.exportEngine.he4.colTempatStuffing': 'Stuffing location',
  'lumen.exportEngine.he4.colStatus': 'Status',
  'lumen.exportEngine.he4.colActions': 'Actions',
  'lumen.exportEngine.he4.noNpwp': 'PPJK NPWP is not available. Fill in the PPJK data in Entity first.',
  'lumen.exportEngine.he4.loading': 'Loading templates...',
  'lumen.exportEngine.he4.noTemplates': 'No templates found',
  'lumen.exportEngine.he4.inactive': 'Inactive',
  'lumen.exportEngine.he4.active': 'Active',
  'lumen.exportEngine.he4.applyTemplate': 'Use this template',
  'lumen.exportEngine.he4.edit': 'Edit',
  'lumen.exportEngine.he4.delete': 'Delete',
  'lumen.exportEngine.he4.deleteTitle': 'Delete Template',
  'lumen.exportEngine.he4.deleteConfirmPrefix': 'Are you sure you want to delete',
  'lumen.exportEngine.he4.thisTemplate': 'this template',
  'lumen.exportEngine.he4.deleteConfirmSuffix': '? This action cannot be undone.',
  'lumen.exportEngine.he4.cancel': 'Cancel',
  'lumen.exportEngine.he4.editTitle': 'Edit PKB Template',
  'lumen.exportEngine.he4.addTitle': 'Add PKB Template',
  'lumen.exportEngine.he4.templateName': 'Template Name',
  'lumen.exportEngine.he4.templateNamePlaceholder': 'e.g. LCL Priok default',
  'lumen.exportEngine.he4.activeSwitch': 'Active',
  'lumen.exportEngine.he4.metaNote':
    '. Templates store reusable PKB values. Request date & stuffing date are per-transaction — fill them on the PKB form.',
  'lumen.exportEngine.he4.permintaanPemeriksaan': 'Inspection request',
  'lumen.exportEngine.he4.alamat': 'Address',
  'lumen.exportEngine.he4.telepon': 'Phone',
  'lumen.exportEngine.he4.contactPerson': 'Contact Person',
  'lumen.exportEngine.he4.jenisBarang': 'Type of goods',
  'lumen.exportEngine.he4.pilihJenisBarang': 'Select type of goods',
  'lumen.exportEngine.he4.tempatSimpan': 'Storage location',
  'lumen.exportEngine.he4.pilihTempatSimpan': 'Select storage location',
  'lumen.exportEngine.he4.petiKemas': 'Containers',
  'lumen.exportEngine.he4.feet20': '20 Feet',
  'lumen.exportEngine.he4.feet40': '40 Feet',
  'lumen.exportEngine.he4.caraStuffing': 'Stuffing method',
  'lumen.exportEngine.he4.pilihCaraStuffing': 'Select stuffing method',
  'lumen.exportEngine.he4.halPartOf': 'Part of',
  'lumen.exportEngine.he4.pilihHalPartOf': 'Select part of',
  'lumen.exportEngine.he4.pelaksanaanStuffing': 'Stuffing implementation',
  'lumen.exportEngine.he4.tempat': 'Location',
  'lumen.exportEngine.he4.saving': 'Saving...',
  'lumen.exportEngine.he4.tambah': 'Add',
  'lumen.exportEngine.dk1.fileFallback': 'File',
  'lumen.exportEngine.dk1.downloadAria': 'Download {label}',
  'lumen.exportEngine.dk1.uploadBlockedTitle': 'Cannot upload yet',
  'lumen.exportEngine.dk1.uploadBlockedMessage': 'Save the document row first before uploading a file.',
  'lumen.exportEngine.dk1.formatTitle': 'Unsupported format',
  'lumen.exportEngine.dk1.formatMessage': 'Only PDF or Excel files (.xlsx/.xls/.csv) are allowed.',
  'lumen.exportEngine.dk1.noUrl': 'The response does not contain the new file URL',
  'lumen.exportEngine.dk1.successTitle': 'Success',
  'lumen.exportEngine.dk1.uploaded': '{name} uploaded',
  'lumen.exportEngine.dk1.uploadFailed': 'Failed to upload file',
  'lumen.exportEngine.dk1.failedTitle': 'Failed',
  'lumen.exportEngine.dk2.colSeri': 'Seri',
  'lumen.exportEngine.dk2.colJenis': 'Type',
  'lumen.exportEngine.dk2.colEcooStatus': 'eCOO Status',
  'lumen.exportEngine.dk2.colNomor': 'Number',
  'lumen.exportEngine.dk2.colTanggal': 'Date',
  'lumen.exportEngine.dk2.colFasilitas': 'Facility',
  'lumen.exportEngine.dk2.colIjin': 'Permit',
  'lumen.exportEngine.dk2.colFile': 'File',
  'lumen.exportEngine.dk2.colAttached': 'Attached',
  'lumen.exportEngine.dk2.colAksi': 'Actions',
  'lumen.exportEngine.dk2.attachTitle': 'Attach Document to Goods',
  'lumen.exportEngine.dk2.edit': 'Edit',
  'lumen.exportEngine.dk2.copy': 'Copy',
  'lumen.exportEngine.dk2.uploadAria': 'Upload or replace file',
  'lumen.exportEngine.dk2.uploadReplace': 'Upload / Replace File',
  'lumen.exportEngine.dk2.uploadFile': 'Upload File',
  'lumen.exportEngine.dk2.delete': 'Delete',
  'lumen.exportEngine.dk2.attachIntro': 'Choose which goods items this document must be attached to:',
  'lumen.exportEngine.dk2.selectAllAria': 'Select all goods',
  'lumen.exportEngine.dk2.selectRowAria': 'Select goods item {n}',
  'lumen.exportEngine.dk2.seriBarang': 'Goods Serial',
  'lumen.exportEngine.dk2.hsCode': 'HS Code',
  'lumen.exportEngine.dk2.namaBarang': 'Goods Name',
  'lumen.exportEngine.dk2.unnamed': 'UNNAMED',
  'lumen.exportEngine.dk2.noBarang': 'No goods items yet. Please add goods items first.',
  'lumen.exportEngine.dk2.deleteTitle': 'Confirm Delete',
  'lumen.exportEngine.dk2.deleteBody': 'Are you sure you want to delete this document?',
  'lumen.exportEngine.dk2.hapus': 'Delete',
  'lumen.exportEngine.dk2.tambahDokumen': 'Add document',
  'lumen.exportEngine.dk2.tableAria': 'Document',
  'lumen.exportEngine.dk3.tambahDokumen': 'Add Document',
  'lumen.exportEngine.dk3.seriDokumen': 'Document Serial',
  'lumen.exportEngine.dk3.seriDokumenPlaceholder': 'Document serial',
  'lumen.exportEngine.dk3.jenisDokumen': 'Document Type',
  'lumen.exportEngine.dk3.jenisDokumenPlaceholder': 'Select document type',
  'lumen.exportEngine.dk3.nomorDokumen': 'Document Number',
  'lumen.exportEngine.dk3.nomorDokumenPlaceholder': 'Enter document number',
  'lumen.exportEngine.dk3.tanggalDokumen': 'Document Date',
  'lumen.exportEngine.dk3.fasilitas': 'Facility',
  'lumen.exportEngine.dk3.fasilitasPlaceholder': 'Select facility',
  'lumen.exportEngine.dk3.ijin': 'Permit',
  'lumen.exportEngine.dk3.ijinPlaceholder': 'Enter permit code',
  'lumen.exportEngine.dk3.batal': 'Cancel',
  'lumen.exportEngine.dk3.simpan': 'Save',
  'lumen.exportEngine.dk3.notSetTitle': 'Statement not set',
  'lumen.exportEngine.dk3.notSetMessage':
    'Your PPJK has no Statement yet. Fill it in Master → Statement, then sync again.',
  'lumen.exportEngine.dk3.successTitle': 'Success',
  'lumen.exportEngine.dk3.syncSuccess': 'Statement data synced successfully',
  'lumen.exportEngine.dk3.syncFailed': 'Failed to sync statement data',
  'lumen.exportEngine.dk3.title': 'Statement',
  'lumen.exportEngine.dk3.syncing': 'Syncing...',
  'lumen.exportEngine.dk3.syncButton': 'Sync Statement',
  'lumen.exportEngine.dk3.legalHeading': 'I hereby declare:',
  'lumen.exportEngine.dk3.legal1':
    'I am responsible for the truthfulness of the matters notified in this document and the validity of the supporting customs documents on which it is based; and',
  'lumen.exportEngine.dk3.legal2':
    'If, no later than 1 (one) day after the date of the notice that the goods are ready, I do not attend to witness the physical inspection, I authorize the TPS operator to witness it, with the risk and costs being my responsibility.',
  'lumen.exportEngine.dk3.signerHeading': 'Signer Information',
  'lumen.exportEngine.dk3.nama': 'Name',
  'lumen.exportEngine.dk3.tanggal': 'Date',
  'lumen.exportEngine.dk3.tempat': 'Place',
  'lumen.exportEngine.dk3.jabatan': 'Position',
  'lumen.exportEngine.en1.npwpKosongTitle': 'Empty NPWP',
  'lumen.exportEngine.en1.npwpKosongMsg': "Enter the exporter's NPWP first.",
  'lumen.exportEngine.en1.npwpBelumLengkapTitle': 'NPWP incomplete',
  'lumen.exportEngine.en1.npwpBelumLengkapMsg': 'NPWP must be {count} digits for the selected identity type.',
  'lumen.exportEngine.en1.ditarikDariLumen': 'Exporter data was pulled from Lumen.',
  'lumen.exportEngine.en1.ditarikDariProfil': 'Exporter data was pulled from the company profile.',
  'lumen.exportEngine.en1.tidakDitemukanTitle': 'Not found',
  'lumen.exportEngine.en1.tidakDitemukanMsg': 'No data for this NPWP.',
  'lumen.exportEngine.en1.gagalTitle': 'Failed',
  'lumen.exportEngine.en1.gagalMsg': 'Could not pull the NPWP data. Try again.',
  'lumen.exportEngine.en1.nomorIdentitas': 'Identity number',
  'lumen.exportEngine.en1.alamat': 'Address',
  'lumen.exportEngine.en1.hapus': 'Delete',
  'lumen.exportEngine.en2.eksportir': 'Exporter',
  'lumen.exportEngine.en2.penerima': 'Consignee',
  'lumen.exportEngine.en2.pembeli': 'Buyer',
  'lumen.exportEngine.en2.jenis': 'Type',
  'lumen.exportEngine.en2.jenisPlaceholder': 'Select identity number type',
  'lumen.exportEngine.en2.npwpEksportir': 'Exporter NPWP',
  'lumen.exportEngine.en2.nomorIdentitasPlaceholder': 'Enter identity number',
  'lumen.exportEngine.en2.tarikNpwp': 'Pull NPWP data',
  'lumen.exportEngine.en2.status': 'Status',
  'lumen.exportEngine.en2.namaEksportir': 'Exporter name',
  'lumen.exportEngine.en2.namaEksportirPlaceholder': 'Enter exporter name',
  'lumen.exportEngine.en2.alamatEksportir': 'Exporter address',
  'lumen.exportEngine.en2.alamatEksportirPlaceholder': 'Exporter address',
  'lumen.exportEngine.en2.namaPenerima': 'Consignee name',
  'lumen.exportEngine.en2.namaPenerimaPlaceholder': 'Enter consignee name',
  'lumen.exportEngine.en2.alamatPenerima': 'Consignee address',
  'lumen.exportEngine.en2.alamatPenerimaPlaceholder': 'Consignee address',
  'lumen.exportEngine.en2.negaraPenerima': 'Consignee country',
  'lumen.exportEngine.en2.negaraPenerimaPlaceholder': 'Select consignee country',
  'lumen.exportEngine.en2.salinPenerima': 'Copy consignee',
  'lumen.exportEngine.en2.namaPembeli': 'Buyer name',
  'lumen.exportEngine.en2.namaPembeliPlaceholder': 'Enter buyer name',
  'lumen.exportEngine.en2.alamatPembeli': 'Buyer address',
  'lumen.exportEngine.en2.alamatPembeliPlaceholder': 'Buyer address',
  'lumen.exportEngine.en2.negaraPembeli': 'Buyer country',
  'lumen.exportEngine.en2.negaraPembeliPlaceholder': 'Select buyer country',
  'lumen.exportEngine.en3.ppjk': 'PPJK',
  'lumen.exportEngine.en3.jenisPlaceholder': 'Type',
  'lumen.exportEngine.en3.nomorIdentitasPpjk': 'PPJK identity number',
  'lumen.exportEngine.en3.nomorIdentitasPpjkPlaceholder': 'The PPJK identity number is filled in automatically',
  'lumen.exportEngine.en3.namaPpjk': 'PPJK name',
  'lumen.exportEngine.en3.namaPpjkPlaceholder': 'The PPJK name is filled in automatically',
  'lumen.exportEngine.en3.alamatPpjk': 'PPJK address',
  'lumen.exportEngine.en3.alamatPpjkPlaceholder': 'The PPJK address is filled in automatically',
  'lumen.exportEngine.en3.konsolidasi': 'Consolidating party',
  'lumen.exportEngine.en3.manageWarehouse': 'Manage Warehouse',
  'lumen.exportEngine.en3.lokasiKonsolidasi': 'Consolidation location',
  'lumen.exportEngine.en3.lokasiBelumTersedia':
    'The PPJK identity number is not available yet. Please wait or refresh the page.',
  'lumen.exportEngine.en3.lokasiPlaceholder': 'Choose a warehouse from the list...',
  'lumen.exportEngine.en3.kategori': 'Category',
  'lumen.exportEngine.en3.kategoriPlaceholder': 'Choose a category code',
  'lumen.exportEngine.en3.nomorIdentitasPlaceholder': 'Enter the identity number',
  'lumen.exportEngine.en3.nitku': 'NITKU',
  'lumen.exportEngine.en3.nitkuPlaceholder': 'Enter the NITKU',
  'lumen.exportEngine.en3.namaPlaceholder': 'Enter the name',
  'lumen.exportEngine.en3.alamatKonsolidasi': 'Consolidation address',
  'lumen.exportEngine.en3.alamatKonsolidasiPlaceholder': 'Enter the consolidation address',
  'lumen.exportEngine.en3.total': 'Total: {n}',
  'lumen.exportEngine.en3.salinEksportir': 'Copy exporter',
  'lumen.exportEngine.en3.pemilikBarang': 'Goods owners',
  'lumen.exportEngine.en4.npwpDigitAlert': 'NPWP must be {expectedLength} digits for the selected identity type',
  'lumen.exportEngine.en4.requiredAlert': 'Please complete all required fields',
  'lumen.exportEngine.en4.title': 'Add Goods Owner - Exporter',
  'lumen.exportEngine.en4.jenisIdentitas': 'Identity Type',
  'lumen.exportEngine.en4.jenisIdentitasPlaceholder': 'Select identity type',
  'lumen.exportEngine.en4.nomorIdentitas': 'Identity Number',
  'lumen.exportEngine.en4.nomorIdentitasPlaceholder': 'Enter identity number',
  'lumen.exportEngine.en4.syncCompanyProfile': 'Sync Company Profile',
  'lumen.exportEngine.en4.namaPemilik': 'Owner Name',
  'lumen.exportEngine.en4.namaPemilikPlaceholder': 'Enter owner name',
  'lumen.exportEngine.en4.alamatPemilik': 'Owner Address',
  'lumen.exportEngine.en4.alamatPemilikPlaceholder': 'Enter owner address',
  'lumen.exportEngine.en4.entitasBarang': 'Goods Entity',
  'lumen.exportEngine.en4.entitasBarangHint': 'Select the goods owned by this owner',
  'lumen.exportEngine.en4.tambah': 'Add',
  'lumen.exportEngine.en4.seriBarang': 'Goods Serial',
  'lumen.exportEngine.en4.hsCode': 'HS Code',
  'lumen.exportEngine.en4.uraian': 'Description',
  'lumen.exportEngine.en4.aksi': 'Actions',
  'lumen.exportEngine.en4.emptyTitle': 'No goods selected yet',
  'lumen.exportEngine.en4.emptyHint': 'Click the Add button to select goods',
  'lumen.exportEngine.en4.tambahEntitasBarang': 'Add Goods Entity',
  'lumen.exportEngine.en4.pilih': 'Select',
  'lumen.exportEngine.en5.manageTitle': 'Manage Consolidation Warehouses',
  'lumen.exportEngine.en5.ppjkNpwpCaption': 'PPJK NPWP: {npwp}',
  'lumen.exportEngine.en5.addWarehouse': 'Add Warehouse',
  'lumen.exportEngine.en5.location': 'Location',
  'lumen.exportEngine.en5.warehouseName': 'Warehouse Name',
  'lumen.exportEngine.en5.nitku': 'NITKU',
  'lumen.exportEngine.en5.loading': 'Loading warehouses...',
  'lumen.exportEngine.en5.empty': 'No warehouses found',
  'lumen.exportEngine.en5.delete': 'Delete',
  'lumen.exportEngine.en5.deleteTitle': 'Delete Warehouse',
  'lumen.exportEngine.en5.deleteBodyBefore': 'Are you sure you want to delete',
  'lumen.exportEngine.en5.deleteBodyAfter': '? This action cannot be undone.',
  'lumen.exportEngine.en5.addTitle': 'Add New Warehouse',
  'lumen.exportEngine.en5.editTitle': 'Edit Warehouse',
  'lumen.exportEngine.en5.consoleLocation': 'Console Location',
  'lumen.exportEngine.en5.consoleLocationPlaceholder': 'Enter location',
  'lumen.exportEngine.en5.category': 'Category',
  'lumen.exportEngine.en5.categoryPlaceholder': 'Select category',
  'lumen.exportEngine.en5.identityType': 'Identity Type',
  'lumen.exportEngine.en5.identityTypePlaceholder': 'Select identity type',
  'lumen.exportEngine.en5.identityNumber': 'Identity Number',
  'lumen.exportEngine.en5.identityNumberPlaceholder': 'Enter identity number',
  'lumen.exportEngine.en5.nitkuPlaceholder': 'Enter NITKU',
  'lumen.exportEngine.en5.warehouseNamePlaceholder': 'Enter warehouse name',
  'lumen.exportEngine.en5.warehouseAddress': 'Warehouse Address',
  'lumen.exportEngine.en5.warehouseAddressPlaceholder': 'Enter warehouse address',
  'lumen.exportEngine.en5.updateWarehouse': 'Update Warehouse',
  'lumen.exportEngine.en5.saveWarehouse': 'Save Warehouse',
  'lumen.exportEngine.pt1.tabHeader': 'Header',
  'lumen.exportEngine.pt1.tabEntitas': 'Entities',
  'lumen.exportEngine.pt1.tabDokumen': 'Documents',
  'lumen.exportEngine.pt1.tabPengangkut': 'Transport',
  'lumen.exportEngine.pt1.tabKemasan': 'Packaging & Containers',
  'lumen.exportEngine.pt1.tabTransaksi': 'Transaction',
  'lumen.exportEngine.pt1.tabBarang': 'Goods',
  'lumen.exportEngine.pt1.tabPernyataan': 'Declaration',
  'lumen.exportEngine.pt1.entityEksportir': 'Exporter',
  'lumen.exportEngine.pt1.entityPenerima': 'Consignee',
  'lumen.exportEngine.pt1.entityPembeli': 'Buyer',
  'lumen.exportEngine.pt1.entityPpjk': 'PPJK',
  'lumen.exportEngine.pt1.entityKonsolidasi': 'Consolidation',
  'lumen.exportEngine.pt1.labelJenisIdentitas': 'Identity type',
  'lumen.exportEngine.pt1.labelNpwp': 'NPWP',
  'lumen.exportEngine.pt1.labelNama': 'Name',
  'lumen.exportEngine.pt1.labelAlamat': 'Address',
  'lumen.exportEngine.pt1.labelStatus': 'Status',
  'lumen.exportEngine.pt1.labelNegara': 'Country',
  'lumen.exportEngine.pt1.fieldRequired': '{label} is required',
  'lumen.exportEngine.pt1.exportirName': 'Exporter name is required',
  'lumen.exportEngine.pt1.exportirAddress': 'Exporter address is required',
  'lumen.exportEngine.pt1.exportirIdentityType': 'Exporter identity type is required',
  'lumen.exportEngine.pt1.exportirStatus': 'Exporter status is required',
  'lumen.exportEngine.pt1.recipientName': 'Consignee name is required',
  'lumen.exportEngine.pt1.recipientAddress': 'Consignee address is required',
  'lumen.exportEngine.pt1.recipientCountry': 'Consignee country is required',
  'lumen.exportEngine.pt1.buyerName': 'Buyer name is required',
  'lumen.exportEngine.pt1.buyerAddress': 'Buyer address is required',
  'lumen.exportEngine.pt1.buyerCountry': 'Buyer country is required',
  'lumen.exportEngine.pt1.ppjkName': 'PPJK name is required',
  'lumen.exportEngine.pt1.ppjkAddress': 'PPJK address is required',
  'lumen.exportEngine.pt1.ppjkIdentityType': 'PPJK identity type is required',
  'lumen.exportEngine.pt1.ppjkIdentityNumber': 'PPJK NPWP is required',
  'lumen.exportEngine.pt1.entityHeadingOne': '{name} ({count} field)',
  'lumen.exportEngine.pt1.entityHeadingMany': '{name} ({count} fields)',
  'lumen.exportEngine.pt1.kolomBelumLengkap': 'Some fields are incomplete',
  'lumen.exportEngine.pt1.hide': 'Hide',
  'lumen.exportEngine.pt1.show': 'Show',
  'lumen.exportEngine.pt1.go': 'Go',
  'lumen.exportEngine.pt1.view': 'View',
  'lumen.exportEngine.pt2.statusSelesai': 'Completed',
  'lumen.exportEngine.pt2.statusTerkirim': 'Submitted',
  'lumen.exportEngine.pt2.statusDraft': 'Draft',
  'lumen.exportEngine.pt2.npwpUnavailable': 'PPJK NPWP is not available',
  'lumen.exportEngine.pt2.ajuCreated': 'AJU number created successfully',
  'lumen.exportEngine.pt2.ajuCreateFailed': 'Failed to create AJU number',
  'lumen.exportEngine.pt2.ajuCopied': 'AJU number copied to clipboard',
  'lumen.exportEngine.pt2.ajuCopyFailed': 'Failed to copy AJU number',
  'lumen.exportEngine.pt2.ajuEmpty': 'AJU number must not be empty',
  'lumen.exportEngine.pt2.ajuMinLength': 'AJU number must have at least 20 characters',
  'lumen.exportEngine.pt2.title': '📋 AJU Number - Export Declaration',
  'lumen.exportEngine.pt2.loading': 'Loading...',
  'lumen.exportEngine.pt2.nomorAju': 'AJU number',
  'lumen.exportEngine.pt2.copyAria': 'Copy to clipboard',
  'lumen.exportEngine.pt2.nomorAjuTerbaru': 'Latest AJU numbers',
  'lumen.exportEngine.pt2.save': 'Save',
  'lumen.exportEngine.pt2.areaHeader': 'Header',
  'lumen.exportEngine.pt2.areaEntitas': 'Entities',
  'lumen.exportEngine.pt2.areaPengangkut': 'Carrier',
  'lumen.exportEngine.pt2.areaTransaksi': 'Transaction',
  'lumen.exportEngine.pt2.areaKemasan': 'Packaging & Containers',
  'lumen.exportEngine.pt2.rangeEmpty': '0 of 0',
  'lumen.exportEngine.pt2.range': '{from}-{to} of {total}',
  'lumen.exportEngine.pt2.appliedTitle': 'Exporter data applied',
  'lumen.exportEngine.pt2.appliedAreas': 'Updated tabs: {areas}.',
  'lumen.exportEngine.pt2.draftUpdated': 'Draft updated.',
  'lumen.exportEngine.pt2.applyFailed': 'Failed to apply exporter data',
  'lumen.exportEngine.pt2.failedTitle': 'Failed',
  'lumen.exportEngine.pt2.dataEksportir': 'Exporter Data',
  'lumen.exportEngine.pt2.dataEksportirHint':
    'Pick from the database to fill Header, Entities and Carrier automatically.',
  'lumen.exportEngine.pt2.pilihDariDatabase': 'Pick from Database',
  'lumen.exportEngine.pt2.pilihEksportir': 'Select Exporter',
  'lumen.exportEngine.pt2.pilihPerusahaan': 'Select the exporter company to use for this document.',
  'lumen.exportEngine.pt2.searchPlaceholder': 'Search name, NPWP, consignee or buyer',
  'lumen.exportEngine.pt2.showing': 'Showing {range}',
  'lumen.exportEngine.pt2.loadFailed': 'Failed to load the exporter list. Try reloading the page.',
  'lumen.exportEngine.pt2.noResults': 'No exporters found',
  'lumen.exportEngine.pt2.sebelumnya': 'Previous',
  'lumen.exportEngine.pt2.selanjutnya': 'Next',
  'lumen.exportEngine.pt2.halaman': 'Page',
  'lumen.exportEngine.pt2.dari': 'of',
  'lumen.exportEngine.pt2.dataBerikutAkan': 'The following data will be',
  'lumen.exportEngine.pt2.ditimpa': 'overwritten',
  'lumen.exportEngine.pt2.overwriteNote1':
    "On Header only the exporter's fixed data is overwritten (export type & category, trade terms, payment method, facility, customs office, loading port). AJU number, container count and stuffing data stay. The tabs",
  'lumen.exportEngine.pt2.dan': 'and',
  'lumen.exportEngine.pt2.overwriteNote2':
    'are only filled where still empty — data extracted from documents will not be lost.',
  'lumen.exportEngine.pt2.terapkan': 'Apply',
  'lumen.exportEngine.pt2.pilihKartu': 'Select one of the exporter cards above to continue.',
  'lumen.exportEngine.fx1.fieldWajibDiisi': 'This field is required',
  'lumen.exportEngine.fx2.labelWithCurrency': '{label} - {currency}',
  // lumen.bc23Engine (revamp PR 8b)
  'lumen.bc23Engine.br1.titleError': 'Error',
  'lumen.bc23Engine.br1.titleSuccess': 'Success',
  'lumen.bc23Engine.br1.gagalHapusDokumen': 'Failed to delete the document',
  'lumen.bc23Engine.br1.noItemsSelected': 'No items selected',
  'lumen.bc23Engine.br1.updatedOne': 'Successfully updated {count} item',
  'lumen.bc23Engine.br1.updatedMany': 'Successfully updated {count} items',
  'lumen.bc23Engine.br1.bulkEditFailed': 'Bulk edit failed',
  'lumen.bc23Engine.br1.fetchHsFailed': 'Failed to fetch HS code details',
  'lumen.bc23Engine.br1.fetchHsError': 'Error fetching HS code details',
  'lumen.bc23Engine.br2.colJSatuan': 'Unit qty',
  'lumen.bc23Engine.br2.colTotalDokumen': 'Total documents',
  'lumen.bc23Engine.br2.selectAllAria': 'Select all items',
  'lumen.bc23Engine.br2.selectRowAria': 'Select item',
  'lumen.bc23Engine.br2.lihatDokumenAria': 'View documents',
  'lumen.bc23Engine.br4.noItemsToSync': 'No items to sync',
  'lumen.bc23Engine.br4.processIdMissing': 'Process ID is not available. Please reload the page.',
  'lumen.bc23Engine.br4.tariffsUpdated': 'Tariffs updated for {count} items',
  'lumen.bc23Engine.br4.titleInfo': 'Info',
  'lumen.bc23Engine.br4.noTariffYet': 'No tariff data available yet. Tariffs will be calculated on submit.',
  'lumen.bc23Engine.br4.saveBeforeSyncFailed': 'Failed to save barang data before sync',
  'lumen.bc23Engine.br4.refreshTariffFailed': 'Failed to refresh tariff data. Please reload page if needed.',
  'lumen.bc23Engine.br4.syncFailed': 'Failed to sync tariff and LARTAS data',
  'lumen.bc23Engine.br5.itemUpdatedApplied':
    'Item updated and changes applied to {count} items with same HS code or empty HS code',
  'lumen.bc23Engine.br5.itemUpdatedNoMatch':
    'Item updated. No other items had matching or empty HS codes to apply changes to.',
  'lumen.bc23Engine.br5.saveChangesFailed': 'Failed to save changes to server. Please try again.',
  'lumen.bc23Engine.br5.itemAdded': 'Item added successfully',
  'lumen.bc23Engine.br5.saveNewItemFailed': 'Failed to save new item to server. Please try again.',
  'lumen.bc23Engine.br6.hapusBarang': 'Delete item',
  'lumen.bc23Engine.br6.tindakanTidakDapatDibatalkan': 'This action cannot be undone',
  'lumen.bc23Engine.br6.yakinHapusBarang': 'Are you sure you want to delete this item?',
  'lumen.bc23Engine.br6.seriColon': 'Serial:',
  'lumen.bc23Engine.br6.uraianColon': 'Description:',
  'lumen.bc23Engine.br6.hsCodeColon': 'HS Code:',
  'lumen.bc23Engine.br6.hapus': 'Delete',
  'lumen.bc23Engine.br6.dokumenTerlampir': 'Attached documents',
  'lumen.bc23Engine.br6.seriInfoLine': 'Serial {seri}: {uraian}',
  'lumen.bc23Engine.br6.dokumenFallback': 'Document {kode}',
  'lumen.bc23Engine.br6.colSeri': 'Serial',
  'lumen.bc23Engine.br6.colJenisDokumen': 'Document type',
  'lumen.bc23Engine.br6.colKode': 'Code',
  'lumen.bc23Engine.br6.colNomorDokumen': 'Document number',
  'lumen.bc23Engine.br6.colTanggal': 'Date',
  'lumen.bc23Engine.br6.colKodeFasilitas': 'Facility code',
  'lumen.bc23Engine.br6.colNamaFasilitas': 'Facility name',
  'lumen.bc23Engine.br6.colKodeIjin': 'Permit code',
  'lumen.bc23Engine.br6.colAction': 'Action',
  'lumen.bc23Engine.br6.hapusDokumenAria': 'Delete document',
  'lumen.bc23Engine.br6.tidakAdaDokumen': 'No documents attached to this item',
  'lumen.bc23Engine.br6.tambahBarang': 'Add item',
  'lumen.bc23Engine.br6.editBarang': 'Edit item',
  'lumen.bc23Engine.br7.syncing': 'Syncing...',
  'lumen.bc23Engine.br7.syncLartasTarif': 'Sync Lartas & Tariff',
  'lumen.bc23Engine.br7.clearSearch': 'Clear search',
  'lumen.bc23Engine.br7.tableLabel': 'Goods list',
  'lumen.bc23Engine.dk1.successTitle': 'Success',
  'lumen.bc23Engine.dk1.errorTitle': 'Error',
  'lumen.bc23Engine.dk1.documentAdded': 'Document added successfully',
  'lumen.bc23Engine.dk1.documentUpdated': 'Document updated successfully',
  'lumen.bc23Engine.dk1.saveNewFailed': 'Failed to save new document',
  'lumen.bc23Engine.dk1.saveEditedFailed': 'Failed to save edited document',
  'lumen.bc23Engine.dk2.successTitle': 'Success',
  'lumen.bc23Engine.dk2.errorTitle': 'Error',
  'lumen.bc23Engine.dk2.orderAlreadyCorrect': 'Document order is already correct',
  'lumen.bc23Engine.dk2.orderUpdated': 'Document order updated successfully',
  'lumen.bc23Engine.dk2.orderSaveFailed': 'Failed to save document order',
  'lumen.bc23Engine.dk2.documentCopied': 'Document copied successfully',
  'lumen.bc23Engine.dk2.copyFailed': 'Failed to save copied document',
  'lumen.bc23Engine.dk2.documentDeleted': 'Document deleted successfully',
  'lumen.bc23Engine.dk2.deleteFailed': 'Failed to save changes after deleting document',
  'lumen.bc23Engine.dk2.colSeri': 'Seri',
  'lumen.bc23Engine.dk2.colJenis': 'Jenis',
  'lumen.bc23Engine.dk2.colEcooStatus': 'eCOO Status',
  'lumen.bc23Engine.dk2.colNomor': 'Nomor',
  'lumen.bc23Engine.dk2.colTanggal': 'Tanggal',
  'lumen.bc23Engine.dk2.colFasilitas': 'Fasilitas',
  'lumen.bc23Engine.dk2.colKodeIjin': 'Kode Ijin',
  'lumen.bc23Engine.dk2.colAttached': 'Attached',
  'lumen.bc23Engine.dk2.colAksi': 'Aksi',
  'lumen.bc23Engine.dk2.actionAttachToBarang': 'Attach to Barang',
  'lumen.bc23Engine.dk2.actionEdit': 'Edit',
  'lumen.bc23Engine.dk2.actionCopy': 'Copy',
  'lumen.bc23Engine.dk2.actionDelete': 'Delete',
  'lumen.bc23Engine.dk3.attachTitle': 'Attach Document to Barang',
  'lumen.bc23Engine.dk3.attachIntro': 'Select which barang items this document should be attached to:',
  'lumen.bc23Engine.dk3.selectAllAria': 'Select all barang',
  'lumen.bc23Engine.dk3.selectRowAria': 'Select barang {seri}',
  'lumen.bc23Engine.dk3.colSeriBarang': 'Seri Barang',
  'lumen.bc23Engine.dk3.colHsCode': 'HS Code',
  'lumen.bc23Engine.dk3.colNamaBarang': 'Nama Barang',
  'lumen.bc23Engine.dk3.unnamed': 'UNNAMED',
  'lumen.bc23Engine.dk3.noBarang': 'No barang items available. Please add barang items first.',
  'lumen.bc23Engine.dk3.urutkanOtomatis': 'Urutkan Otomatis',
  'lumen.bc23Engine.dk3.tambahDokumen': 'Tambah dokumen',
  'lumen.bc23Engine.dk3.tableAria': 'Dokumen',
  'lumen.bc23Engine.eb2.simpanPerubahan': 'Save changes',
  'lumen.bc23Engine.eb3.nonLartas': 'NON-LARTAS',
  'lumen.bc23Engine.eb5.kodeJenisBm': 'BM type code',
  'lumen.bc23Engine.eb5.tarifBm': 'BM rate (%)',
  'lumen.bc23Engine.eb5.tarifBmPlaceholder': 'Type decimal like 2.5',
  'lumen.bc23Engine.eb5.jenisTarifBm': 'BM rate type',
  'lumen.bc23Engine.eb5.fasilitasTarifBm': 'BM rate facility',
  'lumen.bc23Engine.eb5.tarifPpn': 'VAT rate (%)',
  'lumen.bc23Engine.eb5.tarifPpnPlaceholder': 'Type decimal like 11.5',
  'lumen.bc23Engine.eb5.fasilitasPpn': 'VAT facility',
  'lumen.bc23Engine.eb5.tarifPph': 'Income tax rate (%)',
  'lumen.bc23Engine.eb5.tarifPphPlaceholder': 'Type decimal like 2.5',
  'lumen.bc23Engine.eb5.fasilitasPph': 'Income tax facility',
  'lumen.bc23Engine.eb5.bmt': 'BMT',
  'lumen.bc23Engine.eb5.bmad': 'BMAD',
  'lumen.bc23Engine.eb5.bmtp': 'BMTP',
  'lumen.bc23Engine.eb5.bmi': 'BMI',
  'lumen.bc23Engine.eb5.sementara': 'Provisional',
  'lumen.bc23Engine.eb5.select': 'Select',
  'lumen.bc23Engine.eb5.tarifAria': 'Rate',
  'lumen.bc23Engine.eb5.cukai': 'Excise',
  'lumen.bc23Engine.eb5.komoditi': 'Commodity',
  'lumen.bc23Engine.eb5.komoditiOption': '3 - HASIL TEMBAKAU',
  'lumen.bc23Engine.eb5.bosarTarif': 'Rate base',
  'lumen.bc23Engine.eb5.jumlah': 'Quantity',
  'lumen.bc23Engine.eb5.nilaiCukai': 'Excise value',
  'lumen.bc23Engine.eb5.hjeRp': 'Retail price (Rp)',
  'lumen.bc23Engine.eb5.satuanKemasan': 'Packaging unit',
  'lumen.bc23Engine.eb5.isiPerKemasan': 'Contents per package',
  'lumen.bc23Engine.eb5.jumlahPitaCukai': 'Excise band count',
  'lumen.bc23Engine.eb5.saldoAwal': 'Opening balance',
  'lumen.bc23Engine.eb5.saldoAkhir': 'Closing balance',
  'lumen.bc23Engine.he1.fieldJenis': 'Type',
  'lumen.bc23Engine.he1.fieldNpwp': '{title} NPWP',
  'lumen.bc23Engine.he1.fieldNama': '{title} name',
  'lumen.bc23Engine.he1.fieldNegara': '{title} country',
  'lumen.bc23Engine.he1.fieldAlamat': '{title} address',
  'lumen.bc23Engine.he1.fieldAfiliasi': 'Affiliation',
  'lumen.bc23Engine.he1.nitku': 'NITKU',
  'lumen.bc23Engine.he1.optAfl': 'AFL - Affiliated Company',
  'lumen.bc23Engine.he1.optCtr': 'CTR - Financial/legally controlled',
  'lumen.bc23Engine.he1.optFam': 'FAM - Family member',
  'lumen.bc23Engine.he1.optTah': 'TAH - Not related',
  'lumen.bc23Engine.he2.titleImportir': 'Importer/TPB operator',
  'lumen.bc23Engine.he2.fieldJenis': 'Type',
  'lumen.bc23Engine.he2.fieldNpwpImportir': 'Importer NPWP',
  'lumen.bc23Engine.he2.fieldNamaImportir': 'Importer name',
  'lumen.bc23Engine.he2.fieldStatus': 'Status',
  'lumen.bc23Engine.he2.fieldApiNib': 'API/NIB',
  'lumen.bc23Engine.he2.fieldNib': 'NIB',
  'lumen.bc23Engine.he2.fieldAlamatImportir': 'Importer address',
  'lumen.bc23Engine.he2.fieldNomorIzinTpb': 'TPB permit number',
  'lumen.bc23Engine.he2.fieldTanggalSkepTpb': 'TPB decree date',
  'lumen.bc23Engine.he2.searchByNpwp': 'Search importer data by NPWP',
  'lumen.bc23Engine.he2.searchByName': 'Search importer data by name',
  'lumen.bc23Engine.he3.pemasok': 'Supplier',
  'lumen.bc23Engine.he3.pemilikBarang': 'Goods owner',
  'lumen.bc23Engine.he3.ppjk': 'PPJK',
  'lumen.bc23Engine.he4.pelabuhanBongkar': 'Unloading Port',
  'lumen.bc23Engine.he4.pilihPelabuhanBongkar': 'Select unloading port',
  'lumen.bc23Engine.he4.tujuan': 'Purpose',
  'lumen.bc23Engine.he4.pilihTujuan': 'Select purpose',
  'lumen.bc23Engine.he4.kantorPabeanBongkar': 'Unloading Customs Office',
  'lumen.bc23Engine.he4.pilihKantorPabeanBongkar': 'Select unloading customs office',
  'lumen.bc23Engine.he4.kantorPabeanPengawas': 'Supervising Customs Office',
  'lumen.bc23Engine.he4.pilihKantorPabeanPengawas': 'Select supervising customs office',
  'lumen.bc23Engine.he4.colPungutan': 'Levy',
  'lumen.bc23Engine.he4.colDibayar': 'Paid',
  'lumen.bc23Engine.he4.colDitanggungPemerintah': 'Borne by Government',
  'lumen.bc23Engine.he4.colDitunda': 'Deferred',
  'lumen.bc23Engine.he4.colTidakDipungut': 'Not Collected',
  'lumen.bc23Engine.he4.colDibebaskan': 'Exempted',
  'lumen.bc23Engine.he4.colSudahDilunasi': 'Settled',
  'lumen.bc23Engine.he4.title': 'Levies',
  'lumen.bc23Engine.he4.emptyTitle': 'No data available',
  'lumen.bc23Engine.he4.emptyDescription': 'There are no records to display at the moment.',
  'lumen.bc23Engine.pg5.downloadExcel': 'Download Excel',
  'lumen.bc23Engine.pg5.uploadExcel': 'Upload Excel',
  'lumen.bc23Engine.pg5.updateDraftCeisa': 'Update DRAFT to CEISA',
  'lumen.bc23Engine.pg5.submitDraftCeisa': 'Submit DRAFT to CEISA',
  'lumen.bc23Engine.pg5.idHeaderNotFound': 'Header ID not found',
  'lumen.bc23Engine.pg5.draftPibDownloaded': 'Draft PIB downloaded successfully',
  'lumen.bc23Engine.pg5.draftPibDownloadFailed': 'Failed to download Draft PIB',
  'lumen.bc23Engine.pg7.securityTitle': 'Secure & Private',
  'lumen.bc23Engine.pg7.securityBody': 'Your data is encrypted & belongs to you',
  'lumen.bc23Engine.pg7.editItems': 'Edit {count} items',
  'lumen.bc23Engine.pk1.vesselNameRequired': 'Please enter a vessel name first',
  'lumen.bc23Engine.pk1.flagFound': 'Flag found: {flag}',
  'lumen.bc23Engine.pk1.warningTitle': 'Warning',
  'lumen.bc23Engine.pk1.flagNotFound': 'No flag information found for this vessel',
  'lumen.bc23Engine.pk1.flagFetchFailed': 'Failed to fetch vessel flag information',
  'lumen.bc23Engine.pk1.docNotFoundTitle': 'Document Not Found',
  'lumen.bc23Engine.pk1.docNotFoundMsg': 'No B/L (705) document found. Please add a B/L document first.',
  'lumen.bc23Engine.pk1.docIncompleteTitle': 'Incomplete Document',
  'lumen.bc23Engine.pk1.docIncompleteMsg': 'B/L document must have both number and date.',
  'lumen.bc23Engine.pk1.manifestSuccessMsg': 'Manifest BC 1.1 data retrieved successfully',
  'lumen.bc23Engine.pk1.apiErrorTitle': 'API Error',
  'lumen.bc23Engine.pk1.manifestRetrieveFailed': 'Failed to retrieve manifest data',
  'lumen.bc23Engine.pk1.manifestCallFailed': 'Failed to call Manifest BC 1.1 API. Please try again.',
  'lumen.bc23Engine.pk1.tpsRequired': 'A storage location (TPS) must be selected',
  'lumen.bc23Engine.pk2.manifestBc11': 'Manifest BC 1.1',
  'lumen.bc23Engine.pk2.loadingData': 'Loading data...',
  'lumen.bc23Engine.pk2.flagNameFromApi': 'Flag name from API:',
  'lumen.bc23Engine.pk2.portOfLoadingFromApi': 'Port of loading from API:',
  'lumen.bc23Engine.pk2.useThisValue': 'Use this value',
  'lumen.bc23Engine.pk3.seri': 'Serial',
  'lumen.bc23Engine.pk3.jumlah': 'Quantity',
  'lumen.bc23Engine.pk3.jenis': 'Type',
  'lumen.bc23Engine.pk3.merek': 'Brand',
  'lumen.bc23Engine.pk3.aksi': 'Actions',
  'lumen.bc23Engine.pk3.edit': 'Edit',
  'lumen.bc23Engine.pk3.copy': 'Copy',
  'lumen.bc23Engine.pk3.delete': 'Delete',
  'lumen.bc23Engine.pk4.seri': 'Serial',
  'lumen.bc23Engine.pk4.nomor': 'Number',
  'lumen.bc23Engine.pk4.ukuran': 'Size',
  'lumen.bc23Engine.pk4.jenis': 'Type',
  'lumen.bc23Engine.pk4.tipe': 'Kind',
  'lumen.bc23Engine.pk4.aksi': 'Actions',
  'lumen.bc23Engine.pk4.edit': 'Edit',
  'lumen.bc23Engine.pk4.copy': 'Copy',
  'lumen.bc23Engine.pk4.delete': 'Delete',
  'lumen.bc23Engine.pk4.kemasan': 'Packages',
  'lumen.bc23Engine.pk4.petiKemas': 'Containers',
  'lumen.bc23Engine.pk4.tambahKemasan': 'Add package',
  'lumen.bc23Engine.pk4.tambahPetiKemas': 'Add container',
  'lumen.bc23Engine.pk6.warningTitle': 'Warning',
  'lumen.bc23Engine.pk6.ndpbmRetrieveFailed': 'Could not retrieve the NDPBM value. Please enter it manually.',
  'lumen.bc23Engine.pk6.errorTitle': 'Error',
  'lumen.bc23Engine.pk6.ndpbmFetchFailed': 'Error when fetching NDPBM',
  'lumen.bc23Engine.pk7.harga': 'Price',
  'lumen.bc23Engine.pk7.warningPastikanValuta': 'Please make sure the currency is correct',
  'lumen.bc23Engine.pk7.valuta': 'Currency',
  'lumen.bc23Engine.pk7.pilihValuta': 'Select Currency',
  'lumen.bc23Engine.pk7.ndpbm': 'NDPBM',
  'lumen.bc23Engine.pk7.jenisTransaksi': 'Transaction Type',
  'lumen.bc23Engine.pk7.pilihJenisTransaksi': 'Select Transaction Type',
  'lumen.bc23Engine.pk7.incoterm': 'Incoterm',
  'lumen.bc23Engine.pk7.pilihIncoterm': 'Select Incoterm',
  'lumen.bc23Engine.pk7.hargaBarang': 'Goods Price',
  'lumen.bc23Engine.pk7.nilaiPabeanRupiah': 'Customs Value in Rupiah',
  'lumen.bc23Engine.pk7.informasiKomponenBiaya': 'Cost Component Information',
  'lumen.bc23Engine.pk7.hargaLainnya': 'Other Prices',
  'lumen.bc23Engine.pk7.biayaPenambahanCurrency': 'Additional cost - {currency}',
  'lumen.bc23Engine.pk7.biayaPengurangCurrency': 'Deduction cost - {currency}',
  'lumen.bc23Engine.pk7.freightCurrency': 'Freight - {currency}',
  'lumen.bc23Engine.pk7.asuransi': 'Insurance',
  'lumen.bc23Engine.pk7.nilaiAsuransiCurrency': 'Insurance value - {currency}',
  'lumen.bc23Engine.pk7.voluntaryDeclaration': 'Voluntary declaration',
  'lumen.bc23Engine.pk7.berat': 'Weight',
  'lumen.bc23Engine.pk7.beratKotor': 'Gross Weight (KGM)',
  'lumen.bc23Engine.pk7.beratBersih': 'Net Weight (KGM)',
  'lumen.bc23Engine.pk7.keteranganPajak': 'Tax Information',
  'lumen.bc23Engine.pk7.jasaKenaPajak': 'Taxable Services',
  'lumen.bc23Engine.pk7.jasaPembelianBkp': '1 - PURCHASE OF TAXABLE GOODS',
  'lumen.bc23Engine.pk7.jasaPenerimaBkp': '2 - RECIPIENT OF TAXABLE GOODS SERVICES',
  'lumen.bc23Engine.pk9.assistTip':
    "Fill in the 'fixed value' column when the component's value is already known at the time of import and is not yet included in the invoice price. Fill in the 'Estimated Value (VD)' column when the component's value cannot yet be known with certainty at the time of import; this can be done on each goods detail / goods series using the VD mechanism.",
  'lumen.bc23Engine.pk9.royaltiTip':
    "Royalties are payments for copyrights, patents and the like, while licences are payments for the right to use a technology or brand. Fill in the 'fixed value' column when the component's value is already known at the time of import and is not yet included in the invoice price. Fill in the 'Estimated Value (VD)' column when the component's value cannot yet be known with certainty at the time of import; this can be done on each goods detail / goods series using the VD mechanism.",
  'lumen.bc23Engine.pk9.proceedsTip':
    "Proceeds are the part of the proceeds from the resale, disposal or use of the goods that must be paid to the seller. Fill in the 'fixed value' column when the component's value is already known at the time of import and is not yet included in the invoice price. Fill in the 'Estimated Value (VD)' column when the component's value cannot yet be known with certainty at the time of import; this can be done on each goods detail / goods series using the VD mechanism.",
  'lumen.bc23Engine.pk9.transportTip':
    "Enter the transportation / freight cost and the loading, unloading and handling costs not yet included in the transportation cost. Fill in the 'fixed value' column when the component's value is already known at the time of import and is not yet included in the invoice price. Fill in the 'Estimated Value (VD)' column when the component's value cannot yet be known with certainty at the time of import; this can be done on each goods detail / goods series using the VD mechanism.",
  'lumen.bc23Engine.pk9.asuransiTip':
    "Select the insurance type, domestic or foreign. Then enter the insurance value in the column to the right. Fill in the 'fixed value' column when the component's value is already known at the time of import and is not yet included in the invoice price. Fill in the 'Estimated Value (VD)' column when the component's value cannot yet be known with certainty at the time of import; this can be done on each goods detail / goods series using the VD mechanism.",
  'lumen.bc23Engine.pt1.tabHeader': 'Header',
  'lumen.bc23Engine.pt1.tabEntitas': 'Entities',
  'lumen.bc23Engine.pt1.tabDokumen': 'Documents',
  'lumen.bc23Engine.pt1.tabPengangkut': 'Carrier',
  'lumen.bc23Engine.pt1.tabKemasan': 'Packaging & Containers',
  'lumen.bc23Engine.pt1.tabTransaksi': 'Transaction',
  'lumen.bc23Engine.pt1.tabBarang': 'Goods',
  'lumen.bc23Engine.pt1.tabPungutan': 'Levies',
  'lumen.bc23Engine.pt1.tabPernyataan': 'Declaration',
  'lumen.bc23Engine.pt1.errorsBadge': '{count} ERRORS',
  'lumen.bc23Engine.pt1.botAssistAria': 'Bot assist',
  'lumen.bc23Engine.pt3.showPdf': 'Show PDF',
  'lumen.bc23Engine.pt3.iframeTitle': 'PDF Viewer - {name}',
  // lumen.account (revamp PR 9a)
  'lumen.account.reviewer.loading': 'Loading...',
  'lumen.account.reviewer.loadFailed': 'Failed to load requests.',
  'lumen.account.reviewer.statTotal': 'Total Requests',
  'lumen.account.reviewer.statPending': 'Pending Review',
  'lumen.account.reviewer.statApproved': 'Approved',
  'lumen.account.reviewer.statNeedRevision': 'Need Revision',
  'lumen.account.reviewer.statusWaiting': 'Pending Review',
  'lumen.account.reviewer.statusApproved': 'Approved',
  'lumen.account.reviewer.statusNeedRevision': 'Need Revision',
  'lumen.account.reviewer.statusRejected': 'Rejected',
  'lumen.account.reviewer.statusInvalidated': 'Invalidated',
  'lumen.account.reviewer.statusScheduled': 'Scheduled',
  'lumen.account.reviewer.colAju': 'AJU Number',
  'lumen.account.reviewer.colVersion': 'Version',
  'lumen.account.reviewer.colRequestedBy': 'Requested By',
  'lumen.account.reviewer.colRequestedAt': 'Requested At',
  'lumen.account.reviewer.review': 'Review',
  'lumen.account.reviewer.dashboardTitle': 'Reviewer Dashboard',
  'lumen.account.reviewer.dashboardDescription': 'Review and approve AJU document requests',
  'lumen.account.reviewer.allRequests': 'All Requests',
  'lumen.account.reviewer.noRequests': 'No approval requests found.',
  'lumen.account.reviewer.colDescription': 'Description',
  'lumen.account.reviewer.colEmailCount': 'Number of emails',
  'lumen.account.reviewer.viewGroup': 'View group',
  'lumen.account.reviewer.editGroup': 'Edit group',
  'lumen.account.reviewer.editEmail': 'Edit email',
  'lumen.account.reviewer.toggleStatus': 'Toggle email status',
  'lumen.account.reviewer.active': 'Active',
  'lumen.account.reviewer.inactive': 'Inactive',
  'lumen.account.reviewer.emailGroupsTitle': 'Email Groups',
  'lumen.account.reviewer.emailGroupsDescription': 'Manage email groups for sending AJU draft approvals.',
  'lumen.account.reviewer.addGroup': 'Add Group',
  'lumen.account.reviewer.editGroupTitle': 'Edit Group',
  'lumen.account.reviewer.groupNamePlaceholder': 'Group name',
  'lumen.account.reviewer.groupDescriptionPlaceholder': 'Group description',
  'lumen.account.reviewer.cancel': 'Cancel',
  'lumen.account.reviewer.update': 'Update',
  'lumen.account.reviewer.save': 'Save',
  'lumen.account.reviewer.groupDetail': 'Group Detail',
  'lumen.account.reviewer.editEmailTitle': 'Edit Email',
  'lumen.account.reviewer.addEmail': 'Add Email',
  'lumen.account.reviewer.recipientPlaceholder': 'Recipient name',
  'lumen.account.reviewer.emailPlaceholder': 'email@example.com',
  'lumen.account.reviewer.toolPencil': 'Pencil',
  'lumen.account.reviewer.toolRectangle': 'Rectangle',
  'lumen.account.reviewer.toolCircle': 'Circle',
  'lumen.account.reviewer.toolArrow': 'Arrow',
  'lumen.account.reviewer.toolText': 'Text',
  'lumen.account.reviewer.stopTool': 'Stop {tool}',
  'lumen.account.reviewer.undo': 'Undo last stroke',
  'lumen.account.reviewer.clear': 'Clear all annotations',
  'lumen.account.reviewer.zoomOut': 'Zoom out',
  'lumen.account.reviewer.zoomIn': 'Zoom in',
  'lumen.account.reviewer.notFound': 'Request not found.',
  'lumen.account.reviewer.backToDashboard': 'Back to Dashboard',
  'lumen.account.reviewer.noAju': 'No AJU Number',
  'lumen.account.reviewer.requestMeta': 'Version {version} · Requested by {name}',
  'lumen.account.reviewer.pdfFailed': 'Failed to load PDF',
  'lumen.account.reviewer.pdfLoading': 'Loading document...',
  'lumen.account.reviewer.reviewResult': 'Review Result',
  'lumen.account.reviewer.reviewActions': 'Review Actions',
  'lumen.account.reviewer.notes': 'Notes',
  'lumen.account.reviewer.checklist': 'Revision Checklist',
  'lumen.account.reviewer.reviewedOn': 'Reviewed on {date}',
  'lumen.account.reviewer.itemPlaceholder': 'Item {n}',
  'lumen.account.reviewer.removeItem': 'Remove item',
  'lumen.account.reviewer.addItem': 'Add item',
  'lumen.account.reviewer.notesPlaceholder': 'Add notes (optional)',
  'lumen.account.reviewer.approve': 'Approve',
  'lumen.account.reviewer.needRevision': 'Need Revision',
  'lumen.account.reviewer.textPlaceholder': 'Type here...',
  'lumen.account.support.allPriorities': 'All Priorities',
  'lumen.account.support.allStatuses': 'All Statuses',
  'lumen.account.support.attachmentsHint':
    'Maximum 10MB per file. Supported formats: images, PDF, documents, text files',
  'lumen.account.support.attachmentsLabel': 'Attachments (Optional)',
  'lumen.account.support.attachmentsPrompt': 'Upload a screenshot, log or other file',
  'lumen.account.support.autoCloseNote': 'This window will close automatically in a few seconds',
  'lumen.account.support.buttonLabel': 'Need help? Create a support ticket',
  'lumen.account.support.cancel': 'Cancel',
  'lumen.account.support.categoryAccount': 'Account issue',
  'lumen.account.support.categoryBilling': 'Billing issue',
  'lumen.account.support.categoryBug': 'Bug report',
  'lumen.account.support.categoryColon': 'Category:',
  'lumen.account.support.categoryFallback': 'General',
  'lumen.account.support.categoryFeature': 'Feature request',
  'lumen.account.support.categoryGeneral': 'General support',
  'lumen.account.support.categoryLabel': 'Category',
  'lumen.account.support.categoryPickPlaceholder': 'Select a category',
  'lumen.account.support.categoryTechnical': 'Technical issue',
  'lumen.account.support.centerTitle': 'Support Center',
  'lumen.account.support.clearFiles': 'Clear attachments',
  'lumen.account.support.close': 'Close',
  'lumen.account.support.createFirst': 'Create your first ticket',
  'lumen.account.support.descriptionLabel': 'Description',
  'lumen.account.support.descriptionPlaceholder': 'Please give detailed information about your issue...',
  'lumen.account.support.descriptionRequired': 'Description is required',
  'lumen.account.support.detailHeading': 'Ticket details:',
  'lumen.account.support.emptyTitle': 'No support tickets found',
  'lumen.account.support.filterHigh': 'High',
  'lumen.account.support.filterLow': 'Low',
  'lumen.account.support.filterMedium': 'Medium',
  'lumen.account.support.filterUrgent': 'Urgent',
  'lumen.account.support.helpBody':
    'Describe your issue below and our support team will help. Include as much detail as possible so we can resolve your request quickly.',
  'lumen.account.support.helpTitle': 'Need help?',
  'lumen.account.support.invalidDate': 'Invalid date',
  'lumen.account.support.loading': 'Loading...',
  'lumen.account.support.na': 'N/A',
  'lumen.account.support.noTitle': 'No title',
  'lumen.account.support.priorityColon': 'Priority:',
  'lumen.account.support.priorityHigh': 'High',
  'lumen.account.support.priorityLabel': 'Priority',
  'lumen.account.support.priorityLow': 'Low',
  'lumen.account.support.priorityMedium': 'Medium',
  'lumen.account.support.priorityPickPlaceholder': 'Select a priority',
  'lumen.account.support.priorityPlaceholder': 'Filter by priority',
  'lumen.account.support.priorityUrgent': 'Urgent',
  'lumen.account.support.searchPlaceholder': 'Search tickets...',
  'lumen.account.support.statusClosed': 'Closed',
  'lumen.account.support.statusColon': 'Status:',
  'lumen.account.support.statusInProgress': 'In Progress',
  'lumen.account.support.statusOpen': 'Open',
  'lumen.account.support.statusPlaceholder': 'Filter by status',
  'lumen.account.support.statusResolved': 'Resolved',
  'lumen.account.support.statusUnknown': 'Unknown',
  'lumen.account.support.submit': 'Create Ticket',
  'lumen.account.support.submitting': 'Creating...',
  'lumen.account.support.successDialogTitle': 'Support ticket created',
  'lumen.account.support.successFollowUp': 'Our support team will review your request and respond shortly.',
  'lumen.account.support.successIntro': 'Your support ticket has been created and given the ticket number:',
  'lumen.account.support.successTitle': 'Ticket created!',
  'lumen.account.support.tabCreate': 'New',
  'lumen.account.support.tabHistory': 'My Tickets',
  'lumen.account.support.titleLabel': 'Title',
  'lumen.account.support.titlePlaceholder': 'A short description of your issue',
  'lumen.account.support.titleRequired': 'Title is required',
  'lumen.account.support.viewTicket': 'View ticket',
  'lumen.account.support.assigned': 'Assigned: {name}',
  'lumen.account.support.attachFile': 'Attach file',
  'lumen.account.support.attachmentCount': '📎 {n}',
  'lumen.account.support.avatarOther': 'U',
  'lumen.account.support.avatarYou': 'You',
  'lumen.account.support.bytes': 'Bytes',
  'lumen.account.support.commentsCount': 'Comments ({n})',
  'lumen.account.support.copyUrl': 'Copy URL',
  'lumen.account.support.detailFailed': 'Failed to load ticket details',
  'lumen.account.support.detailTitle': 'Ticket Details',
  'lumen.account.support.downloadFailed': 'Download failed: {message}',
  'lumen.account.support.downloadFallback': 'Failed to download attachment',
  'lumen.account.support.downloadFile': 'Download attachment',
  'lumen.account.support.downloaded': '{fileName} downloaded successfully!',
  'lumen.account.support.downloading': 'Downloading {fileName}...',
  'lumen.account.support.hideInternal': 'Hide internal comments',
  'lumen.account.support.internalBadge': 'Internal',
  'lumen.account.support.messagePlaceholder': 'Type your message...',
  'lumen.account.support.noComments': 'No comments yet',
  'lumen.account.support.pageUrlRow': '📄 {url}',
  'lumen.account.support.pickedFiles': 'Attachments ({n})',
  'lumen.account.support.removeFile': 'Remove file',
  'lumen.account.support.sendComment': 'Send comment',
  'lumen.account.support.showInternal': 'Show internal comments',
  'lumen.account.support.startConversation': 'Start the conversation below',
  'lumen.account.support.toastError': 'Error',
  'lumen.account.support.toastInfo': 'Info',
  'lumen.account.support.toastSuccess': 'Success',
  'lumen.account.support.unknownUser': 'Unknown User',
  'lumen.account.support.urlCopied': 'Page URL copied to clipboard!',
  'lumen.account.support.urlCopyFailed': 'Failed to copy URL',
  'lumen.account.support.zeroBytes': '0 Bytes',
  'lumen.account.credit.backToCredit': 'Back to the credit page',
  'lumen.account.credit.backToTopup': 'Back to the top-up page',
  'lumen.account.credit.balanceEmpty': 'No balance data',
  'lumen.account.credit.balanceError': 'Failed to load the balance',
  'lumen.account.credit.balanceTitle': 'Your balance',
  'lumen.account.credit.bankLabel': 'Choose a bank',
  'lumen.account.credit.calculating': 'Calculating the fee…',
  'lumen.account.credit.cardOpen': 'Open the payment page',
  'lumen.account.credit.cardRedirecting': 'Redirecting to the payment page...',
  'lumen.account.credit.cardUnavailable': 'Payment URL not available',
  'lumen.account.credit.cardUnavailableBody': 'The payment link was not found. Please contact support or try again.',
  'lumen.account.credit.checkFailed': 'Failed to check the payment status. Please try again.',
  'lumen.account.credit.checkStatus': 'Check payment status',
  'lumen.account.credit.copied': 'Copied to the clipboard',
  'lumen.account.credit.copy': 'Copy',
  'lumen.account.credit.credit': 'Credit',
  'lumen.account.credit.creditsCount': '{n} credits',
  'lumen.account.credit.creditsLabel': 'Number of credits',
  'lumen.account.credit.creditsPlaceholder': 'Enter the number of credits',
  'lumen.account.credit.description': 'Buy credits for CEISA and NVOCC submissions',
  'lumen.account.credit.errorTitle': 'Error',
  'lumen.account.credit.failedToast': 'Please try again',
  'lumen.account.credit.feeLabel': 'Payment service fee',
  'lumen.account.credit.formTitle': 'Top up credits',
  'lumen.account.credit.invalidUrl': 'The payment URL is not valid',
  'lumen.account.credit.loadErrorToast': 'Failed to load the payment details',
  'lumen.account.credit.loadingDetails': 'Loading the payment details...',
  'lumen.account.credit.loadingProducts': 'Loading products...',
  'lumen.account.credit.methodLabel': 'Payment method',
  'lumen.account.credit.methodQris': 'QRIS',
  'lumen.account.credit.methodVa': 'Virtual Account',
  'lumen.account.credit.missingParams': 'Payment parameters are incomplete',
  'lumen.account.credit.missingParamsBody':
    'The payment page needs a type and a reference. Please go back to the top-up page.',
  'lumen.account.credit.noProducts': 'No credit products available',
  'lumen.account.credit.noReference': 'The payment reference was not found',
  'lumen.account.credit.notFound': 'Payment data not found',
  'lumen.account.credit.notFoundBody':
    'No payment data was found for this reference. Please go back to the top-up page.',
  'lumen.account.credit.notFoundToast': 'Payment data not found',
  'lumen.account.credit.paidToast': 'The credits have been added to your account',
  'lumen.account.credit.paymentTitle': 'Payment',
  'lumen.account.credit.priceLabel': 'Price per credit:',
  'lumen.account.credit.productLabel': 'Choose a product',
  'lumen.account.credit.productOption': '{name} - {price}/credit',
  'lumen.account.credit.productPlaceholder': 'Choose a credit package',
  'lumen.account.credit.qrisBody': 'Scan the QR code below with your e-wallet app:',
  'lumen.account.credit.qrisTitle': 'Scan QRIS',
  'lumen.account.credit.resolveError': 'Failed to load the credit account. Using the default account.',
  'lumen.account.credit.statusFailed': 'Payment failed',
  'lumen.account.credit.statusLabel': 'Payment status:',
  'lumen.account.credit.statusPaid': 'Payment successful',
  'lumen.account.credit.statusPending': 'Waiting for payment',
  'lumen.account.credit.submit': 'Continue to payment',
  'lumen.account.credit.subtotal': 'Subtotal:',
  'lumen.account.credit.successTitle': 'Success',
  'lumen.account.credit.tabSubscription': 'Subscription',
  'lumen.account.credit.tabTopup': 'Manual top-up',
  'lumen.account.credit.title': 'Top up credits',
  'lumen.account.credit.topupFailed': 'Failed to create the top-up. Please try again.',
  'lumen.account.credit.total': 'Total payment:',
  'lumen.account.credit.totalCredit': 'Total credits',
  'lumen.account.credit.vaInstruction': 'Transfer to the Virtual Account number below:',
  'lumen.account.credit.vaNote': 'After the transfer, the payment is processed automatically within 1-5 minutes.',
  'lumen.account.credit.warning': 'Warning',
  'lumen.account.subscription.virtualAccount': 'Virtual Account',
  'lumen.account.subscription.qrisAlt': 'QRIS',
  'lumen.account.subscription.paymentSuccess': 'Payment successful',
  'lumen.account.subscription.paymentThanks': 'Thank you! Your subscription invoice has been paid.',
  'lumen.account.subscription.amountPaid': 'Amount paid',
  'lumen.account.subscription.period': 'Period',
  'lumen.account.subscription.invoiceNotFound': 'Invoice details not found.',
  'lumen.account.subscription.creditsAdded': 'Credits added',
  'lumen.account.subscription.creditsCount': '{n} credits',
  'lumen.account.subscription.noCredits': 'No credit quota on this plan',
  'lumen.account.subscription.viewSubscription': 'View subscription',
  'lumen.account.subscription.startFiling': 'Start a filing',
  'lumen.account.support.userUnknown': 'Unknown',
  'lumen.account.support.priorityFallback': 'Medium',
};

export const TRANSLATIONS: Record<LanguageCode, TranslationDict> = { id, en, zh };

export const DEFAULT_LANGUAGE: LanguageCode = 'id';
